import { format, longFormatters } from 'date-fns/format';
import * as React52 from 'react';
import React52__default, { createContext, forwardRef, useContext, useRef, useMemo, useImperativeHandle, useState, useCallback, Children, useEffect, useReducer, isValidElement, cloneElement, useLayoutEffect } from 'react';
import { styled as styled$1, Button, Autocomplete, TextField, ToggleButtonGroup, toggleButtonGroupClasses, Alert, AlertTitle, Box, Snackbar, useTheme as useTheme$1, Paper, ToggleButton, InputAdornment, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, IconButton, TableSortLabel, ClickAwayListener, Collapse, CircularProgress, FormControlLabel, Switch, Dialog, ListItemText, Skeleton, Select, MenuItem } from '@mui/material';
import { DragHandle, Delete, Add, Info, Troubleshoot, FilterAltOutlined, FilterAltOffOutlined, KeyboardArrowUp, KeyboardArrowDown, AppRegistration, ContentCopy } from '@mui/icons-material';
import Link from 'next/link';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { grey as grey$1 } from '@mui/material/colors';
import { styled, alpha, useTheme, ThemeProvider, useThemeProps } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import Box4 from '@mui/material/Box';
import Typography4 from '@mui/material/Typography';
import IconButton4 from '@mui/material/IconButton';
import { createSvgIcon } from '@mui/material/utils';
import ButtonBase from '@mui/material/ButtonBase';
import MuiTextField from '@mui/material/TextField';
import InputAdornment$1 from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import ReactDOM, { createPortal } from 'react-dom';
import Fade from '@mui/material/Fade';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grow from '@mui/material/Grow';
import MuiPaper from '@mui/material/Paper';
import MuiPopper from '@mui/material/Popper';
import BaseFocusTrap from '@mui/material/Unstable_TrapFocus';
import Button$1 from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Chip from '@mui/material/Chip';
import DialogContent from '@mui/material/DialogContent';
import MuiDialog, { dialogClasses } from '@mui/material/Dialog';
import { addDays } from 'date-fns/addDays';
import { addSeconds } from 'date-fns/addSeconds';
import { addMinutes } from 'date-fns/addMinutes';
import { addHours } from 'date-fns/addHours';
import { addWeeks } from 'date-fns/addWeeks';
import { addMonths } from 'date-fns/addMonths';
import { addYears } from 'date-fns/addYears';
import { endOfDay } from 'date-fns/endOfDay';
import { endOfWeek } from 'date-fns/endOfWeek';
import { endOfYear } from 'date-fns/endOfYear';
import { getDate } from 'date-fns/getDate';
import { getDaysInMonth } from 'date-fns/getDaysInMonth';
import { getHours } from 'date-fns/getHours';
import { getMinutes } from 'date-fns/getMinutes';
import { getMonth } from 'date-fns/getMonth';
import { getSeconds } from 'date-fns/getSeconds';
import { getMilliseconds } from 'date-fns/getMilliseconds';
import { getWeek } from 'date-fns/getWeek';
import { getYear } from 'date-fns/getYear';
import { isAfter } from 'date-fns/isAfter';
import { isBefore } from 'date-fns/isBefore';
import { isEqual } from 'date-fns/isEqual';
import { isSameDay } from 'date-fns/isSameDay';
import { isSameYear } from 'date-fns/isSameYear';
import { isSameMonth } from 'date-fns/isSameMonth';
import { isSameHour } from 'date-fns/isSameHour';
import { isValid } from 'date-fns/isValid';
import { parse } from 'date-fns/parse';
import { setDate } from 'date-fns/setDate';
import { setHours } from 'date-fns/setHours';
import { setMinutes } from 'date-fns/setMinutes';
import { setMonth } from 'date-fns/setMonth';
import { setSeconds } from 'date-fns/setSeconds';
import { setMilliseconds } from 'date-fns/setMilliseconds';
import { setYear } from 'date-fns/setYear';
import { startOfDay } from 'date-fns/startOfDay';
import { startOfMonth } from 'date-fns/startOfMonth';
import { endOfMonth } from 'date-fns/endOfMonth';
import { startOfWeek } from 'date-fns/startOfWeek';
import { startOfYear } from 'date-fns/startOfYear';
import { isWithinInterval } from 'date-fns/isWithinInterval';
import { enUS } from 'date-fns/locale/en-US';
import CloseIcon from '@mui/icons-material/Close';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { yupResolver } from '@hookform/resolvers/yup';
import Grid from '@mui/material/Unstable_Grid2';
import { Controller, useFieldArray, useWatch, useForm } from 'react-hook-form';
import { parseISO } from 'date-fns/parseISO';
import { KeyboardCode, defaultDropAnimationSideEffects, useSensors, useSensor, MouseSensor, TouchSensor, KeyboardSensor, closestCenter, pointerWithin, rectIntersection, getFirstCollision, DndContext, MeasuringStrategy, DragOverlay, closestCorners } from '@dnd-kit/core';
import { useSortable, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import * as yup from 'yup';
import { notFound } from 'next/navigation';
import { NextResponse } from 'next/server';

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    var b = "function" === typeof Symbol && Symbol.for;
    var c = b ? Symbol.for("react.element") : 60103;
    var d = b ? Symbol.for("react.portal") : 60106;
    var e = b ? Symbol.for("react.fragment") : 60107;
    var f = b ? Symbol.for("react.strict_mode") : 60108;
    var g = b ? Symbol.for("react.profiler") : 60114;
    var h = b ? Symbol.for("react.provider") : 60109;
    var k = b ? Symbol.for("react.context") : 60110;
    var l = b ? Symbol.for("react.async_mode") : 60111;
    var m = b ? Symbol.for("react.concurrent_mode") : 60111;
    var n = b ? Symbol.for("react.forward_ref") : 60112;
    var p = b ? Symbol.for("react.suspense") : 60113;
    var q = b ? Symbol.for("react.suspense_list") : 60120;
    var r3 = b ? Symbol.for("react.memo") : 60115;
    var t = b ? Symbol.for("react.lazy") : 60116;
    var v = b ? Symbol.for("react.block") : 60121;
    var w = b ? Symbol.for("react.fundamental") : 60117;
    var x = b ? Symbol.for("react.responder") : 60118;
    var y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
      if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case t:
                  case r3:
                  case h:
                    return a;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a) {
      return z(a) === m;
    }
    exports.AsyncMode = l;
    exports.ConcurrentMode = m;
    exports.ContextConsumer = k;
    exports.ContextProvider = h;
    exports.Element = c;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = t;
    exports.Memo = r3;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;
    exports.isAsyncMode = function(a) {
      return A(a) || z(a) === l;
    };
    exports.isConcurrentMode = A;
    exports.isContextConsumer = function(a) {
      return z(a) === k;
    };
    exports.isContextProvider = function(a) {
      return z(a) === h;
    };
    exports.isElement = function(a) {
      return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    exports.isForwardRef = function(a) {
      return z(a) === n;
    };
    exports.isFragment = function(a) {
      return z(a) === e;
    };
    exports.isLazy = function(a) {
      return z(a) === t;
    };
    exports.isMemo = function(a) {
      return z(a) === r3;
    };
    exports.isPortal = function(a) {
      return z(a) === d;
    };
    exports.isProfiler = function(a) {
      return z(a) === g;
    };
    exports.isStrictMode = function(a) {
      return z(a) === f;
    };
    exports.isSuspense = function(a) {
      return z(a) === p;
    };
    exports.isValidElementType = function(a) {
      return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r3 || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    exports.typeOf = z;
  }
});

// ../../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.development.js"(exports) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object2) {
          if (typeof object2 === "object" && object2 !== null) {
            var $$typeof = object2.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object2.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment14 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object2) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object2) {
          return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object2) {
          return typeOf(object2) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object2) {
          return typeOf(object2) === REACT_PROVIDER_TYPE;
        }
        function isElement(object2) {
          return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object2) {
          return typeOf(object2) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object2) {
          return typeOf(object2) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object2) {
          return typeOf(object2) === REACT_LAZY_TYPE;
        }
        function isMemo(object2) {
          return typeOf(object2) === REACT_MEMO_TYPE;
        }
        function isPortal(object2) {
          return typeOf(object2) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object2) {
          return typeOf(object2) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object2) {
          return typeOf(object2) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object2) {
          return typeOf(object2) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment14;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js"(exports, module) {
    if (process.env.NODE_ENV === "production") {
      module.exports = require_react_is_production_min();
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/.pnpm/object-assign@4.1.1/node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/.pnpm/object-assign@4.1.1/node_modules/object-assign/index.js"(exports, module) {
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/has.js"(exports, module) {
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/checkPropTypes.js"(exports, module) {
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values3, location, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values3, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement2, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data2) {
        this.message = message;
        this.data = data2 && typeof data2 === "object" ? data2 : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement2(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement2(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function() {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js"(exports, module) {
    if (process.env.NODE_ENV !== "production") {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../generic-types/src/admin-api.ts
var VersionedTable = /* @__PURE__ */ ((VersionedTable2) => {
  VersionedTable2["BalticPremiumsHirePremium"] = "BalticPremiumsHirePremium";
  VersionedTable2["BalticPremiumsHistory"] = "BalticPremiumsHistory";
  VersionedTable2["BalticPremiumsIcePremium"] = "BalticPremiumsIcePremium";
  VersionedTable2["BunkerForward"] = "BunkerForward";
  VersionedTable2["BunkerRegionMapping"] = "BunkerRegionMapping";
  VersionedTable2["BunkerSpot"] = "BunkerSpot";
  VersionedTable2["CanalPilotCostArea"] = "CanalPilotCostArea";
  VersionedTable2["CargoInsurance"] = "CargoInsurance";
  VersionedTable2["CoasterFFA"] = "CoasterFFA";
  VersionedTable2["ComBallast"] = "ComBallast";
  VersionedTable2["CurrencyRate"] = "CurrencyRate";
  VersionedTable2["EmissionPeriod"] = "EmissionPeriod";
  VersionedTable2["EmissionPrice"] = "EmissionPrice";
  VersionedTable2["ExtraPortDay"] = "ExtraPortDay";
  VersionedTable2["FFA"] = "FFA";
  VersionedTable2["HMVesselValue"] = "HMVesselValue";
  VersionedTable2["HMCostArea"] = "HMCostArea";
  VersionedTable2["OpeBallastArea"] = "OpeBallastArea";
  VersionedTable2["PiracyArea"] = "PiracyArea";
  VersionedTable2["PortCost"] = "PortCost";
  VersionedTable2["Seamargin"] = "Seamargin";
  VersionedTable2["VesselCharacteristics"] = "VesselCharacteristics";
  VersionedTable2["EmissionArea"] = "EmissionArea";
  VersionedTable2["CanalCostDiscount"] = "CanalCostDiscount";
  VersionedTable2["CanalDefinitionCharacteristics"] = "CanalDefinitionCharacteristics";
  VersionedTable2["CanalDefinitionOtherOption"] = "CanalDefinitionOtherOption";
  VersionedTable2["Despatch"] = "Despatch";
  VersionedTable2["CommodityCharacteristics"] = "CommodityCharacteristics";
  VersionedTable2["PortSizeRestriction"] = "PortSizeRestriction";
  return VersionedTable2;
})(VersionedTable || {});
var EDITOR_DISABLED_TABLES = [
  "CanalDefinitionOtherOption" /* CanalDefinitionOtherOption */
];
var isTableVersioned = (table) => {
  return Object.values(VersionedTable).includes(table);
};
var getVersionColumn = (table) => {
  if (isTableVersioned(table)) {
    return table + "VersionId";
  }
  throw new Error(`Table ${table} is not versioned - no version col`);
};
var getVersionTable = (table, error = true) => {
  if (isTableVersioned(table)) {
    return table;
  }
  if (error) {
    throw new Error(`Table ${table} is not versioned - no versioned table`);
  }
  return table;
};
var REVERSE_VERSION_TABLE = Object.fromEntries(
  Object.keys(VersionedTable).map((vt) => [
    getVersionTable(vt),
    VersionedTable[vt]
  ])
);
var getReverseVersionTable = (table) => {
  return REVERSE_VERSION_TABLE[table] ?? table;
};
var VERSION_COLUMNS = Object.values(VersionedTable).map(
  (vt) => getVersionColumn(vt)
);

// ../generic-types/src/historical-calc-api.ts
var numericFields = [
  "quantity",
  "tolerance",
  "hireOverride",
  "sfoOverride",
  "mgoOverride",
  "loadPortDA",
  "loadPortDraft",
  "dischargePortDA",
  "dischargePortDraft"
];

// ../generic-types/src/api.ts
var QueueType = /* @__PURE__ */ ((QueueType2) => {
  QueueType2["Save"] = "save";
  QueueType2["Calculate"] = "calculate";
  QueueType2["CFROptimizer"] = "cfr-optimizer";
  return QueueType2;
})(QueueType || {});

// ../generic-types/src/results.ts
var SectionPassageType = /* @__PURE__ */ ((SectionPassageType2) => {
  SectionPassageType2["Canal"] = "canal";
  SectionPassageType2["PiracyArea"] = "piracy_area";
  SectionPassageType2["HM_Area"] = "hm_area";
  SectionPassageType2["IceArea"] = "ice_area";
  SectionPassageType2["RoutePoint"] = "route_point";
  return SectionPassageType2;
})(SectionPassageType || {});
var SubActivityType = /* @__PURE__ */ ((SubActivityType2) => {
  SubActivityType2["Port"] = "port";
  SubActivityType2["VesselHire"] = "vessel-hire";
  SubActivityType2["Sailing"] = "sailing";
  SubActivityType2["Ballast"] = "ballast";
  SubActivityType2["BallastBonus"] = "ballast-bonus";
  SubActivityType2["Cleaning"] = "cleaning";
  SubActivityType2["EU_ETS"] = "eu-ets";
  SubActivityType2["TotalCost"] = "total-cost";
  SubActivityType2["DespatchCompensation"] = "despatch-compensation";
  return SubActivityType2;
})(SubActivityType || {});
var StageType = /* @__PURE__ */ ((StageType2) => {
  StageType2["Ballast"] = "Ballast";
  StageType2["Port"] = "Port";
  StageType2["Sailing"] = "Sailing";
  StageType2["Generic"] = "Generic";
  return StageType2;
})(StageType || {});
var isSubActivityDataType = (value) => {
  return value && value.subActivityType;
};
var isBallastStage = (stage) => {
  return stage.stageType === "Ballast" /* Ballast */;
};
var isPortStage = (stage) => {
  return stage.stageType === "Port" /* Port */;
};
var isSailingStage = (stage) => {
  return stage.stageType === "Sailing" /* Sailing */;
};
var SizeRestrictionResultStatus = /* @__PURE__ */ ((SizeRestrictionResultStatus2) => {
  SizeRestrictionResultStatus2["OK"] = "ok";
  SizeRestrictionResultStatus2["Error"] = "error";
  SizeRestrictionResultStatus2["Critical"] = "critical";
  return SizeRestrictionResultStatus2;
})(SizeRestrictionResultStatus || {});
var ResultStructureVersionIdEnum = /* @__PURE__ */ ((ResultStructureVersionIdEnum2) => {
  ResultStructureVersionIdEnum2[ResultStructureVersionIdEnum2["Version1"] = 1] = "Version1";
  ResultStructureVersionIdEnum2[ResultStructureVersionIdEnum2["Version2"] = 2] = "Version2";
  ResultStructureVersionIdEnum2[ResultStructureVersionIdEnum2["Version3"] = 3] = "Version3";
  return ResultStructureVersionIdEnum2;
})(ResultStructureVersionIdEnum || {});
var LogLevelValuesEnum = /* @__PURE__ */ ((LogLevelValuesEnum2) => {
  LogLevelValuesEnum2[LogLevelValuesEnum2["error"] = 0] = "error";
  LogLevelValuesEnum2[LogLevelValuesEnum2["log"] = 1] = "log";
  LogLevelValuesEnum2[LogLevelValuesEnum2["warn"] = 2] = "warn";
  LogLevelValuesEnum2[LogLevelValuesEnum2["info"] = 3] = "info";
  LogLevelValuesEnum2[LogLevelValuesEnum2["debug"] = 4] = "debug";
  return LogLevelValuesEnum2;
})(LogLevelValuesEnum || {});
var getLogLevelValue = (level) => {
  return LogLevelValuesEnum[level];
};
var VoyageNoPlansReason = /* @__PURE__ */ ((VoyageNoPlansReason2) => {
  VoyageNoPlansReason2["Unknown"] = "unknown";
  VoyageNoPlansReason2["NoFFA"] = "no-ffa";
  VoyageNoPlansReason2["NoSFOPrice"] = "no-sfo-price";
  VoyageNoPlansReason2["NoMGOPrice"] = "no-mgo-price";
  VoyageNoPlansReason2["CoasterNoDeepsea"] = "coaster-no-deepsea";
  VoyageNoPlansReason2["CanalDWTLimits"] = "canal-dwt-limit";
  VoyageNoPlansReason2["StowageCBFTLimits"] = "stowage-cbft-limits";
  VoyageNoPlansReason2["StowageDraftLimits"] = "stowage-draft-limits";
  VoyageNoPlansReason2["CanalDraftLimits"] = "canal-draft-limits";
  return VoyageNoPlansReason2;
})(VoyageNoPlansReason || {});
var PortOperationEnum = /* @__PURE__ */ ((PortOperationEnum2) => {
  PortOperationEnum2["loadPort"] = "Load Port";
  PortOperationEnum2["dischargePort"] = "Discharge Port";
  return PortOperationEnum2;
})(PortOperationEnum || {});

// ../generic-types/src/public-in.ts
var ExternalAPIOperationType = /* @__PURE__ */ ((ExternalAPIOperationType2) => {
  ExternalAPIOperationType2["discharge"] = "discharge";
  ExternalAPIOperationType2["load"] = "load";
  return ExternalAPIOperationType2;
})(ExternalAPIOperationType || {});

// ../generic-types/src/db-schema-types/enums.ts
var FFAProductCode = {
  COASTER: "COASTER",
  S10TC: "S10TC",
  P4TC: "P4TC",
  P5TC: "P5TC",
  C5TC: "C5TC",
  HS7TC: "HS7TC",
  ROTT_3_5_PRC: "ROTT_3_5_PRC",
  ROTT_VLSFO: "ROTT_VLSFO",
  SING_380: "SING_380",
  SING_VLSFO: "SING_VLSFO",
  ICE_GASOIL: "ICE_GASOIL",
  SING_10PPM: "SING_10PPM"
};
var ExchangeEmission = {
  EU_EMISSIONS: "EU_EMISSIONS"
};
var WaterTypeT = {
  SW: "SW",
  FW: "FW",
  BW: "BW"
};
var PortSource = {
  MANUAL: "MANUAL",
  SEAMETRIX: "SEAMETRIX",
  NOT_IN_SEAMETRIX: "NOT_IN_SEAMETRIX",
  INCORRECT_IN_SEAMETRIX: "INCORRECT_IN_SEAMETRIX",
  MARINE_TRAFFIC: "MARINE_TRAFFIC"
};
var AreaUsage = {
  EUETS: "EUETS",
  SECA: "SECA",
  Piracy: "Piracy",
  OpeBallast: "OpeBallast",
  HM: "HM",
  Canal: "Canal",
  Ice: "Ice",
  LSMGOinPort: "LSMGOinPort",
  TradeRegion: "TradeRegion",
  CarbonCredits: "CarbonCredits",
  Lakes: "Lakes",
  RoutePoint: "RoutePoint"
};
var CalculationContext = {
  Spot: "Spot",
  Historical: "Historical"
};
var MatrixPortCostFallbackFilter = {
  Verified: "Verified",
  EstimatedAveragePort: "EstimatedAveragePort",
  EstimatedAverageCommodityPort: "EstimatedAverageCommodityPort",
  EstimatedAverageVesselPort: "EstimatedAverageVesselPort",
  EstimatedAverageVesselCommodityCountry: "EstimatedAverageVesselCommodityCountry",
  EstimatedAverageVesselCountry: "EstimatedAverageVesselCountry",
  EstimatedAverageVesselCommodityGlobal: "EstimatedAverageVesselCommodityGlobal",
  EstimatedAverageVesselGlobal: "EstimatedAverageVesselGlobal",
  EstimatedAverageCommodityGlobal: "EstimatedAverageCommodityGlobal"
};
var RegionContext = {
  DeepSea: "DeepSea",
  ShortSeaATL: "ShortSeaATL"
};
var SeaMatrixSetting = {
  GreatCircleInterval: "GreatCircleInterval",
  SECAAvoidance: "SECAAvoidance",
  ASLCompliance: "ASLCompliance"
};
var OperationType = {
  D: "D",
  L: "L"
};
var DepthUnit = {
  M: "M",
  FT: "FT"
};
var PortSizeRestrictionOperationType = {
  Any: "Any",
  D: "D",
  L: "L"
};
var VesselSpeedType = {
  FullSpeedPercentage: "FullSpeedPercentage",
  SlowSteamingPercentage: "SlowSteamingPercentage"
};
var CanalFuelType = {
  LSMGO: "LSMGO",
  VLSFO: "VLSFO"
};
var CanalDirection = {
  Any: "Any",
  North: "North",
  South: "South"
};
var CanalLadenBallast = {
  Any: "Any",
  Laden: "Laden",
  Ballast: "Ballast"
};
var DistancePassingDirection = {
  North: "North",
  South: "South",
  Unknown: "Unknown"
};
var FunctionLinkKey = {
  A: "A",
  B: "B",
  C: "C",
  D: "D"
};
var FFAContractDirection = {
  N: "N",
  U: "U"
};
var FuelGrade = {
  IFO380: "IFO380",
  IFO180: "IFO180",
  VLSFO: "VLSFO",
  ULSFO: "ULSFO",
  MGO: "MGO",
  HSFO: "HSFO"
};
var CurrencyOption = {
  EUR: "EUR",
  USD: "USD"
};
var Permission = {
  UploadPremiums: "UploadPremiums",
  ManageVersions: "ManageVersions",
  ViewCalculationHistory: "ViewCalculationHistory",
  QueueInformation: "QueueInformation",
  DebugCalculation: "DebugCalculation"
};
var JobType = {
  Manual: "Manual",
  PreCalculate: "PreCalculate",
  User: "User"
};
var BatchJobType = {
  Historical: "Historical",
  Optimizer: "Optimizer"
};

// ../generic-types/src/default-values.ts
var TOLERANCE_DEFAULT_VALUE = 10;
var DEFAULT_DB_VERSION = "latest-version";
var VALID_TO_DEFAULT_VALUE = "2200-01-01 12:00:00";

// ../generic-types/src/inputs.ts
var CalculatorMode = /* @__PURE__ */ ((CalculatorMode2) => {
  CalculatorMode2[CalculatorMode2["simple"] = 0] = "simple";
  CalculatorMode2[CalculatorMode2["advanced"] = 1] = "advanced";
  CalculatorMode2[CalculatorMode2["multi"] = 2] = "multi";
  return CalculatorMode2;
})(CalculatorMode || {});
var getCalculatorMode = (value) => {
  switch (value) {
    default:
    case "simple":
    case `${0 /* simple */}`:
    case 0 /* simple */:
      return 0 /* simple */;
    case "advanced":
    case `${1 /* advanced */}`:
    case 1 /* advanced */:
      return 1 /* advanced */;
    case "multi":
    case `${2 /* multi */}`:
    case 2 /* multi */:
      return 2 /* multi */;
  }
};

// ../generic-types/src/bool-parser.ts
var TrueValues = /* @__PURE__ */ new Set([
  "True",
  "TRUE",
  "true",
  "1",
  1,
  "yes",
  "Yes",
  "YES",
  "t",
  "T"
]);
var FalseValues = /* @__PURE__ */ new Set([
  "False",
  "FALSE",
  "false",
  "0",
  0,
  "no",
  "No",
  "NO",
  "",
  "-",
  "N/A",
  "f",
  "F"
]);
var knownBoolFormats = /* @__PURE__ */ new Set([...TrueValues, ...FalseValues, 1, 0]);
var parseBool = (value) => {
  if (typeof value === "undefined" || value === null) {
    return value;
  }
  if (typeof value === "boolean") {
    return value;
  }
  if (!knownBoolFormats.has(value)) {
    throw new Error(`Invalid boolean value: '${value}', type: ${typeof value}`);
  }
  return TrueValues.has(value);
};
var formatMaturity = (ts) => {
  const dateKey = format(ts, "MMM.yyyy");
  return dateKey;
};

// ../generic-types/src/cron-status.types.ts
var CronStatus = /* @__PURE__ */ ((CronStatus2) => {
  CronStatus2["ok"] = "ok";
  CronStatus2["warning"] = "warning";
  CronStatus2["error"] = "error";
  return CronStatus2;
})(CronStatus || {});
var getAPIRoutes = (basePath, allowDBVersions = false, allowDebugPlan = false) => ({
  commodities: `${basePath}/web-api/widget/commodities`,
  ports: `${basePath}/web-api/widget/ports`,
  terms: `${basePath}/web-api/widget/terms`,
  vessels: `${basePath}/web-api/widget/vessels`,
  calculate: `${basePath}/web-api/widget/calculate`,
  optimize: `${basePath}/web-api/widget/optimize`,
  calculateHistorical: `${basePath}/web-api/widget/calc-historical`,
  batchCalculationDetails: `${basePath}/web-api/widget/batch-calculation-details`,
  batchCalculationFilterOptions: `${basePath}/web-api/widget/batch-calculation-filter-options`,
  batchCalculationGraphData: `${basePath}/web-api/widget/batch-calculation-graph-data`,
  batchCalculationResultPlans: `${basePath}/web-api/widget/batch-calculation-result-plans`,
  batchCalculationCSV: `${basePath}/web-api/widget/batch-calculation-csv-data`,
  optimizerLogs: `${basePath}/web-api/widget/optimizer-logs`,
  copyOutput: `${basePath}/web-api/widget/copying-output`,
  ...allowDBVersions && {
    dbVersions: `${basePath}/web-api/widget/db-versions`
  },
  ...allowDebugPlan && {
    debugPlan: `${basePath}/web-api/widget/calculations`
  },
  calculationDetails: `${basePath}/web-api/widget/calculation-details`
});
var CalcContext = createContext(null);

// ../calculator-ui/src/utils/numbers.ts
var formatNumberWithCommas = (number2, round2 = null) => {
  let res = "";
  if (number2 < 1e3 && round2 === null || round2 === false) {
    res = (Math.round(number2 * 100) / 100).toFixed(2);
    if (number2 >= 1e3) {
      res = Math.floor(number2).toLocaleString("en-US") + "." + res.split(".")[1];
    }
  } else {
    res = Math.round(number2).toLocaleString("en-US");
  }
  if (res === "-0") {
    res = "0";
  }
  return res;
};
var formatNumbersWithCommas = (obj, round2 = null) => {
  if (typeof obj === "number") {
    return formatNumberWithCommas(obj, round2);
  } else if (Array.isArray(obj)) {
    return obj.map(
      (item) => formatNumbersWithCommas(item, round2)
    );
  } else if (typeof obj === "object" && obj !== null) {
    const formattedObj = {};
    for (const key in obj) {
      formattedObj[key] = formatNumbersWithCommas(obj[key], round2);
    }
    return formattedObj;
  }
  return obj;
};

// ../calculator-ui/src/constants/index.ts
var DRAWER_WIDTH = 240;
var black = "#000000de";
var black1 = "#000009";
var black2 = "#121212";
var white = "#ffffff";
var light = "#F1ECE4";
var lightGreen = "#E2F6B9";
var grey = "#ccc";
var darkGrey = "#9f9c97";
var dark1 = "#242323";
var dark2 = "#1E1E1E";
var dark3 = "#2d2d2c";
var dark35 = "#222222";
var dark37 = "#2b2b2b";
var dark4 = "#252525";
var dark5 = "#1d1d1d";
var dark6 = "#333333";
var dark7 = "#3d3d3d";
var text60 = "#a0a0a0";
var text87 = "#E0E0E0";
var errorRed = "#d32f2f";
var dragHandleLightTheme = `rgba(0, 0, 0, 0.24)`;
var darkBorder = `rgba(255, 255, 255, 0.12)`;
var lightBorder = `rgba(0, 0, 0, 0.12)`;
var lightBlue = "#1976d2";
var secondaryDarkGreen = "#0C7247";
var secondaryBrightGreen = "#1FCA6A";
var secondaryLightGreen = "#CFF55C";
var secondarySand = "#E3D09E";
var secondaryWarmSand = "#D7BF5C";
var secondaryYellow = "#FFE72D";
var secondaryOrange = "#FEB429";
var secondaryPeachOrange = "#FD6A3D";
var additionalRed = "#E74311";
var secondaryPink = "#F5B3B1";
var secondaryDarkPink = "#FE6F98";
var secondaryPurple = "#C695C7";
var secondaryLavender = "#D2AFFF";
var secondaryDarkPurple = "#624BAD";
var secondaryDarkBlue = "#2C92DD";
var secondaryBlue = "#ACCBE7";
var SizeRestrictionWarning = ({
  sizeRestriction,
  portLabel,
  verticalAlign = "sub"
}) => {
  if (!sizeRestriction) {
    return null;
  }
  if (!sizeRestriction.status || sizeRestriction.status === "ok" /* OK */) {
    return null;
  }
  if (sizeRestriction.status === "error" /* Error */ || sizeRestriction.status === "critical" /* Critical */) {
    const tooltip = sizeRestriction.reason ?? `Size restriction ${sizeRestriction.status}`;
    return /* @__PURE__ */ jsx(Tooltip, { title: portLabel ? `${portLabel}: ${tooltip}` : tooltip, arrow: true, children: /* @__PURE__ */ jsx(
      Info,
      {
        color: sizeRestriction.status === "error" /* Error */ ? "warning" : "error",
        fontSize: "small",
        sx: {
          verticalAlign,
          marginLeft: "3px"
        }
      }
    ) });
  }
  return null;
};
var SizeRestrictionItineraryWarning = ({
  voyage
}) => {
  const { portInfos, sizeRestrictions } = voyage;
  const criticalWarning = sizeRestrictions.find(
    (restriction) => restriction.status === "critical" /* Critical */
  );
  if (criticalWarning) {
    const portLabel = portInfos[criticalWarning.portCallIndex].DisplayName;
    return /* @__PURE__ */ jsx(
      SizeRestrictionWarning,
      {
        sizeRestriction: criticalWarning,
        portLabel,
        verticalAlign: "bottom"
      }
    );
  }
  const errorWarning = sizeRestrictions.find(
    (restriction) => restriction.status === "error" /* Error */
  );
  if (errorWarning) {
    const portLabel = portInfos[errorWarning.portCallIndex].DisplayName;
    return /* @__PURE__ */ jsx(
      SizeRestrictionWarning,
      {
        sizeRestriction: errorWarning,
        portLabel,
        verticalAlign: "bottom"
      }
    );
  }
};
var voyageValuesTableHeaders = [
  "FFA",
  "Premium",
  "Size Premium",
  "Ice Premium",
  "Ballast Bonus %",
  "Hire",
  "Ballast Bonus",
  "Bunker (VLSFO cost)",
  "Bunker (LSMGO cost)",
  "EU ETS unit price in mts",
  "Cargo Intake",
  "Freight Rate"
];
var costsMatrixTableHeaders = [
  "Stage",
  "Name",
  "Activity",
  "Cost in days",
  "Bunker VLSFO in mts",
  "Bunker LSMGO in mts",
  "EU ETS carbon in mts",
  "Cost in $",
  "Draft",
  "Sea/Port Margin %",
  "Verified/Estimated",
  "Sum in $"
];
var costsMatrixTableHeadersOptimizer = [
  "Stage",
  "Name",
  "Activity",
  "Quantity (MT)",
  "CFR Price",
  "Cost in days",
  "Bunker VLSFO in mts",
  "Bunker LSMGO in mts",
  "EU ETS carbon in mts",
  "Cost in $",
  "Draft",
  "Sea/Port Margin %",
  "Verified/Estimated",
  "Sum in $"
];
var getPremiumDebugParams = (duration, premiumTooltip) => {
  if (!premiumTooltip) {
    return "";
  }
  const {
    durationAdjustmentDurationDifference,
    durationAdjustmentCalculatedVsTripPremium,
    durationAdjustmentDailyPremiumAdjustment
  } = premiumTooltip;
  if (durationAdjustmentDurationDifference === void 0 || durationAdjustmentCalculatedVsTripPremium === void 0 || durationAdjustmentDailyPremiumAdjustment === void 0) {
    return "";
  }
  const fields = [
    `diff=${durationAdjustmentDurationDifference}`,
    `vs=${durationAdjustmentCalculatedVsTripPremium}`,
    `adj=${durationAdjustmentDailyPremiumAdjustment}`,
    `duration=${duration}`
  ];
  return `?${fields.join("&")}`;
};
var formatPremiumTooltipText = ({
  premium,
  destination,
  pricingMethodology,
  curveLink,
  curveLinkPreBallastDays,
  postBallastDays,
  postBallastCanalTransit,
  preBallastCanalTransit,
  preBallastDays,
  tripDurationAPS_DOP,
  loadRegion,
  lumpSum,
  shipSize,
  PremiumInput,
  durationAdjustmentDurationDifference,
  durationAdjustmentCalculatedVsTripPremium,
  durationAdjustmentDailyPremiumAdjustment
}) => {
  const durationDiffLabel = durationAdjustmentDurationDifference ? formatNumberWithCommas(durationAdjustmentDurationDifference) : "-";
  const vsLabel = durationAdjustmentCalculatedVsTripPremium ? formatNumberWithCommas(durationAdjustmentCalculatedVsTripPremium) : "-";
  const durationAdjustmentLabel = durationAdjustmentDailyPremiumAdjustment ? formatNumberWithCommas(durationAdjustmentDailyPremiumAdjustment) : "-";
  return `Region: ${loadRegion}-${destination}
    Trip duration in the sheet: ${tripDurationAPS_DOP}
    Premium: ${premium}
    Pre-ballast days: ${preBallastDays}
    Pre-ballast canal: ${preBallastCanalTransit}
    Post-ballast days: ${postBallastDays}
    Post-ballast canal: ${postBallastCanalTransit}
    Pricing methodology: ${pricingMethodology}
    Curve link: ${curveLink}
    Curve pre-ballast days: ${curveLinkPreBallastDays}
    lumpSum: ${typeof lumpSum === "number" ? formatNumberWithCommas(lumpSum) : "-"}
    Vessel size: ${shipSize}
    Premium Input: ${typeof PremiumInput === "number" ? formatNumberWithCommas(PremiumInput) : "-"}
    Duration difference: ${durationDiffLabel}
    Calculated vs trip premium: ${vsLabel}
    Daily premium adjustment: ${durationAdjustmentLabel}
  `;
};
var formatCarbonTooltipText = (data2) => {
  return `Total CO2 emitted: ${data2.totalCO2Emitted}
    CO2 emitted within EU ETS: ${data2.cO2EmittedWithinEUETS}
    Applicable CO2 emitted within EU ETS: ${data2.applicableCO2EmittedWithinEUETS}
    Other CO2 emitted: ${data2.otherCO2Emitted}
  `;
};
var valueSuffixConstructor = (value, suffix) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    value,
    /* @__PURE__ */ jsx("span", { "aria-hidden": true, children: ` ${suffix}` })
  ] });
};
var getRowXs = (index, isSummary = false) => ({
  "&:last-child :is(td, th)": { border: 0 },
  td: { fontWeight: isSummary ? "bold" : void 0 }
});
var mutedStyle = {
  color: "secondary.main",
  fontStyle: "italic"
};
var PortCallCFRCellsRenderer = ({
  data: data2,
  stage,
  subactivity
}) => {
  const fallback = /* @__PURE__ */ jsx(TableCell, { colSpan: 2 });
  if (stage.stageType !== "Port" || subactivity.subActivityType !== "port" /* Port */ || !subactivity.operationKey) {
    return fallback;
  }
  const portCall = data2?.portInfos?.[stage.portCallIndex];
  if (!portCall) {
    return fallback;
  }
  const operation = portCall.operations.find(
    (op) => `${op.operation}+${op.commodity}` === subactivity.operationKey
  );
  if (!operation) {
    return fallback;
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(TableCell, { children: formatNumberWithCommas(operation.amount) }),
    /* @__PURE__ */ jsx(TableCell, { align: "right", children: formatNumberWithCommas(operation.cfrPrice ?? 0) })
  ] });
};
var DebugTable = ({
  data: initialData,
  databaseVersion,
  maturityDate,
  isCFROptimizer
}) => {
  const data2 = formatNumbersWithCommas(initialData);
  const { totalCost } = data2;
  const maturity = formatMaturity(maturityDate);
  const premiumRoute = initialData.hire.premiumTooltip ? `${initialData.hire.premiumTooltip.loadRegion}-${initialData.hire.premiumTooltip.destination}` : "";
  const debugParams = getPremiumDebugParams(
    initialData.totalCost.costInDays,
    initialData.hire.premiumTooltip
  );
  const premiumDebugUrl = `/premiums/debug/${databaseVersion ?? "latest"}/${maturity}/${initialData.hire.premiumTooltip?.shipSize}/${premiumRoute}${debugParams}`;
  const costMatrixHeaders = isCFROptimizer ? costsMatrixTableHeadersOptimizer : costsMatrixTableHeaders;
  const profitLoss = initialData.profitLoss?.perMT ?? 0;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    initialData.profitLoss !== void 0 ? /* @__PURE__ */ jsx(
      Box,
      {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        py: 3,
        children: /* @__PURE__ */ jsxs(Box, { borderRadius: 2, bgcolor: dark7, p: 2, children: [
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "subtitle1",
              lineHeight: 0.9,
              paddingBottom: 0.5,
              children: "Result"
            }
          ),
          /* @__PURE__ */ jsxs(
            Typography,
            {
              variant: "h5",
              sx: {
                color: `${profitLoss >= 0 ? secondaryBrightGreen : additionalRed} !important`
              },
              children: [
                profitLoss >= 0 ? "+" : "-",
                formatNumberWithCommas(profitLoss),
                " $/mt"
              ]
            }
          )
        ] })
      }
    ) : null,
    /* @__PURE__ */ jsx(TableContainer, { sx: { mb: 4 }, component: Paper, children: /* @__PURE__ */ jsxs(Table, { children: [
      /* @__PURE__ */ jsx(TableHead, { children: /* @__PURE__ */ jsx(TableRow, { children: voyageValuesTableHeaders.map((item, index) => /* @__PURE__ */ jsx(TableCell, { align: index !== 0 ? "right" : void 0, children: item }, item)) }) }),
      /* @__PURE__ */ jsx(TableBody, { children: /* @__PURE__ */ jsxs(TableRow, { sx: { "&:last-child :is(td, th)": { border: 0 } }, children: [
        /* @__PURE__ */ jsx(TableCell, { children: data2.hire.ffa }),
        /* @__PURE__ */ jsxs(TableCell, { align: "right", children: [
          data2.hire.premium,
          /* @__PURE__ */ jsx(
            Tooltip,
            {
              title: initialData.hire.premiumTooltip ? /* @__PURE__ */ jsx("span", { style: { whiteSpace: "pre-line" }, children: formatPremiumTooltipText(
                initialData.hire.premiumTooltip
              ) }) : "No applicable hire premium found",
              arrow: true,
              children: /* @__PURE__ */ jsx(
                Info,
                {
                  color: "disabled",
                  fontSize: "small",
                  sx: {
                    verticalAlign: "sub",
                    marginLeft: "3px"
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(Link, { href: premiumDebugUrl, passHref: true, prefetch: false, children: /* @__PURE__ */ jsx(
            IconButton,
            {
              sx: {
                color: grey,
                padding: 0,
                verticalAlign: "sub",
                marginLeft: "3px"
              },
              size: "small",
              "aria-label": "Debug premium",
              title: "Debug premium",
              children: /* @__PURE__ */ jsx(Troubleshoot, { fontSize: "small" })
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.hire.sizePremiumPct, "%") }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.hire.icePremium, "%") }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.ballastBonusPct, "%") }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.hire.value, "$") }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.ballastBonus, "$") }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.bunkerVlsfoCost, "$/MT") }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.bunkerLsmgoCost, "$/MT") }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.etsPrice ?? 0, "MTS") }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.cargoIntake, "MTS") }),
        /* @__PURE__ */ jsx(TableCell, { align: "right", children: valueSuffixConstructor(data2.freightRate, "$/MT") })
      ] }) })
    ] }) }),
    /* @__PURE__ */ jsx(TableContainer, { component: Paper, children: /* @__PURE__ */ jsxs(Table, { children: [
      /* @__PURE__ */ jsx(TableHead, { children: /* @__PURE__ */ jsx(TableRow, { children: costMatrixHeaders.map((row, index) => /* @__PURE__ */ jsx(TableCell, { align: index > 3 ? "right" : void 0, children: row }, row)) }) }),
      /* @__PURE__ */ jsxs(TableBody, { children: [
        initialData.stages.map((stage, stageIndex) => {
          const rowSpan = stage.subactivities.length + 1;
          return /* @__PURE__ */ jsxs(React52.Fragment, { children: [
            /* @__PURE__ */ jsxs(TableRow, { sx: getRowXs(), children: [
              /* @__PURE__ */ jsx(TableCell, { rowSpan, children: stage.stage }),
              /* @__PURE__ */ jsxs(
                TableCell,
                {
                  rowSpan,
                  style: { whiteSpace: "pre-line" },
                  children: [
                    stage.name,
                    isPortStage(stage) ? /* @__PURE__ */ jsx(
                      SizeRestrictionWarning,
                      {
                        sizeRestriction: initialData.sizeRestrictions.find(
                          (sR) => sR.portCallIndex === stage.portCallIndex
                        )
                      }
                    ) : null
                  ]
                }
              )
            ] }),
            stage.subactivities.map((subactivity) => /* @__PURE__ */ jsxs(
              TableRow,
              {
                sx: getRowXs(stageIndex, subactivity.isSummary),
                children: [
                  /* @__PURE__ */ jsxs(TableCell, { children: [
                    subactivity.subactivity,
                    stage.distance && subactivity.subactivity.includes("->") ? /* @__PURE__ */ jsxs(
                      Box,
                      {
                        className: "text-sm mt-2 font-light text-frGrey-400 leading-none grid grid-cols-2 grid-cols-[40%,30%]",
                        sx: {
                          display: "grid",
                          gridTemplateColumns: "40% 30%",
                          fontSize: "0.875rem",
                          color: darkGrey
                        },
                        children: [
                          /* @__PURE__ */ jsx(Box, { whiteSpace: "nowrap", children: "Distance non-seca:" }),
                          /* @__PURE__ */ jsx(Box, { textAlign: "right", children: valueSuffixConstructor(
                            formatNumberWithCommas(
                              stage.distance.nonSeca,
                              true
                            ),
                            "nm"
                          ) }),
                          /* @__PURE__ */ jsx("span", { children: "Distance seca:" }),
                          /* @__PURE__ */ jsx(Box, { textAlign: "right", children: valueSuffixConstructor(
                            formatNumberWithCommas(
                              stage.distance.seca,
                              true
                            ),
                            "nm"
                          ) })
                        ]
                      }
                    ) : null
                  ] }),
                  isCFROptimizer ? /* @__PURE__ */ jsx(
                    PortCallCFRCellsRenderer,
                    {
                      stage,
                      subactivity,
                      data: initialData
                    }
                  ) : null,
                  subactivity.subActivityType === "route_point" /* RoutePoint */ ? /* @__PURE__ */ jsx(TableCell, { colSpan: 9 }) : /* @__PURE__ */ jsxs(Fragment, { children: [
                    /* @__PURE__ */ jsx(
                      TableCell,
                      {
                        align: "right",
                        sx: subactivity.daysExcludedInSum ? mutedStyle : void 0,
                        children: formatNumberWithCommas(subactivity.costInDays)
                      }
                    ),
                    /* @__PURE__ */ jsx(TableCell, { align: "right", children: formatNumberWithCommas(
                      subactivity.bunkersInMts.vlsfo
                    ) }),
                    /* @__PURE__ */ jsx(TableCell, { align: "right", children: formatNumberWithCommas(
                      subactivity.bunkersInMts.lsmgo
                    ) }),
                    /* @__PURE__ */ jsx(TableCell, { align: "right", children: formatNumberWithCommas(
                      subactivity.euEtsCarbonInMts
                    ) }),
                    /* @__PURE__ */ jsx(TableCell, { align: "right", children: subactivity.costInDollars !== void 0 ? formatNumberWithCommas(
                      subactivity.costInDollars
                    ) : "" }),
                    /* @__PURE__ */ jsx(TableCell, { align: "right", children: subactivity.draft !== void 0 ? formatNumberWithCommas(subactivity.draft) : "" }),
                    /* @__PURE__ */ jsx(TableCell, { align: "right", children: subactivity.margin !== void 0 ? formatNumberWithCommas(subactivity.margin) : "" }),
                    /* @__PURE__ */ jsxs(TableCell, { align: "right", children: [
                      typeof subactivity.verifiedEstimated === "string" ? subactivity.verifiedEstimated : subactivity.verifiedEstimated.label,
                      typeof subactivity.verifiedEstimated === "object" && /* @__PURE__ */ jsx(
                        Tooltip,
                        {
                          title: subactivity.verifiedEstimated.tooltip,
                          arrow: true,
                          children: /* @__PURE__ */ jsx(
                            Info,
                            {
                              color: "disabled",
                              fontSize: "small",
                              sx: {
                                verticalAlign: "sub",
                                marginLeft: "3px"
                              }
                            }
                          )
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsx(TableCell, { align: "right", children: formatNumberWithCommas(subactivity.sumInDollars) })
                  ] })
                ]
              },
              subactivity.subactivity
            ))
          ] }, stage.stage);
        }),
        /* @__PURE__ */ jsxs(TableRow, { sx: getRowXs(), children: [
          /* @__PURE__ */ jsx(TableCell, { colSpan: 2 }),
          /* @__PURE__ */ jsx(TableCell, { children: "Total" }),
          isCFROptimizer ? /* @__PURE__ */ jsx(TableCell, { colSpan: 2 }) : null,
          /* @__PURE__ */ jsx(TableCell, { align: "right", children: totalCost.costInDays }),
          /* @__PURE__ */ jsx(TableCell, { align: "right", children: totalCost.bunkersInMts.vlsfo }),
          /* @__PURE__ */ jsx(TableCell, { align: "right", children: totalCost.bunkersInMts.lsmgo }),
          /* @__PURE__ */ jsxs(TableCell, { align: "right", children: [
            totalCost.euEtsCarbonInMts,
            /* @__PURE__ */ jsx(
              Tooltip,
              {
                title: /* @__PURE__ */ jsx("span", { style: { whiteSpace: "pre-line" }, children: formatCarbonTooltipText(data2) }),
                arrow: true,
                children: /* @__PURE__ */ jsx(
                  Info,
                  {
                    color: "disabled",
                    fontSize: "small",
                    sx: {
                      verticalAlign: "sub",
                      marginLeft: "3px"
                    }
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ jsx(TableCell, { align: "right", children: totalCost.costInDollars ? totalCost.costInDollars : "" }),
          /* @__PURE__ */ jsx(TableCell, { align: "right", children: totalCost.draft }),
          /* @__PURE__ */ jsx(TableCell, { align: "right", children: totalCost.margin }),
          /* @__PURE__ */ jsx(TableCell, { align: "right", colSpan: 2, children: totalCost.sumInDollars })
        ] })
      ] })
    ] }) })
  ] });
};
var DebugTable_default = DebugTable;

// ../calculator-ui/src/utils/dropdownOptions.ts
var generateDropdownOptions = (renderOptions) => {
  const options = renderOptions.map((option) => {
    return typeof option !== "object" ? option : option.value;
  });
  const getOptionLabel = (option) => {
    const matchOption = renderOptions.find(
      (o) => typeof o !== "object" ? o === option : o.value === option
    ) || option.toString();
    return typeof matchOption === "object" ? matchOption?.label : `${matchOption}`;
  };
  return { options, getOptionLabel };
};
function TableHeaderCell({
  id,
  label,
  order,
  onSort,
  isSortActive,
  disableFilter,
  filterOptions,
  filterValue,
  onFilter,
  isFilterActive,
  tableCellProps,
  description,
  sortEnabled = true
}) {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const ctx = useContext(CalcContext);
  const { options, getOptionLabel } = generateDropdownOptions(filterOptions);
  return /* @__PURE__ */ jsxs(
    TableCell,
    {
      ...tableCellProps,
      sx: {
        ...tableCellProps?.sx
      },
      children: [
        sortEnabled ? /* @__PURE__ */ jsx(
          Tooltip,
          {
            title: description ? `${description} - Click to sort` : "Sort",
            placement: "top",
            children: /* @__PURE__ */ jsx(
              TableSortLabel,
              {
                active: isSortActive,
                direction: order,
                onClick: () => onSort(id),
                children: label
              }
            )
          }
        ) : label,
        disableFilter ? null : /* @__PURE__ */ jsx(Tooltip, { title: "Filter", placement: "top", children: /* @__PURE__ */ jsx(
          IconButton,
          {
            onClick: () => {
              setIsFilterOpen((open) => !open);
            },
            color: isFilterActive ? "primary" : "default",
            size: "small",
            edge: "end",
            children: /* @__PURE__ */ jsx(FilterAltOutlined, { fontSize: "small" })
          }
        ) }),
        isFilterOpen && /* @__PURE__ */ jsx(
          ClickAwayListener,
          {
            onClickAway: () => setIsFilterOpen(false),
            touchEvent: false,
            children: /* @__PURE__ */ jsx(
              Autocomplete,
              {
                options,
                getOptionLabel,
                value: typeof filterValue === "object" && filterValue !== null ? filterValue.value : filterValue,
                onChange: (_, newValue) => {
                  const value = typeof newValue === "object" && newValue ? newValue.value : newValue;
                  onFilter(id, value);
                  if (ctx && ctx.isMobileView) {
                    setIsFilterOpen(false);
                  }
                },
                size: "small",
                sx: {
                  position: "absolute",
                  width: "calc(100% - 20px)",
                  maxWidth: "215px",
                  right: tableCellProps?.align === "right" ? "15px" : void 0,
                  background: isDarkMode ? `${dark6} !important` : white
                },
                renderInput: (params) => /* @__PURE__ */ jsx(TextField, { ...params, variant: "outlined" })
              }
            )
          }
        )
      ]
    }
  );
}
var TableHeaderCell_default = TableHeaderCell;
var VesselSizeInfo = ({ vesselInfo }) => {
  const items = [
    ["FFA product code", vesselInfo?.ffaProductCode],
    ["DWT", vesselInfo?.DWT],
    ["Length overall", vesselInfo?.lengthOverAll],
    ["Beam", vesselInfo?.beam],
    ["Laden draft SW", vesselInfo?.ladenDraftSW],
    ["Tonnes per centimeter", vesselInfo?.tonnesPerCentimeter],
    ["Holds", vesselInfo?.holds],
    ["Gears", vesselInfo?.gears],
    ["Grain CFT", vesselInfo?.grainCft],
    ["Speed ballast full NM/hour", vesselInfo?.speedBallastFullNMHour],
    [
      "Consumption ballast full MT/day",
      vesselInfo?.consumptionBallastFullMTDay
    ],
    ["Speed laden full NM/hour", vesselInfo?.speedLadenFullNMhour],
    ["Consumption laden full MT/day", vesselInfo?.consumptionLadenFullMTDay],
    ["Speed ballast eco NM/hour", vesselInfo?.speedBallastEcoNMhour],
    ["Consumption ballast eco MT/day", vesselInfo?.consumptionBallastEcoMTDay],
    ["Speed laden eco NM/hour", vesselInfo?.speedLadenEcoNMhour],
    ["Consumption laden eco MT/day", vesselInfo?.consumptionLadenEcoMTDay],
    ["Port working MT/day", vesselInfo?.portWorkingMTDay],
    ["Port idle MT/day", vesselInfo?.portIdleMTDay]
  ];
  const toolTipBody = /* @__PURE__ */ jsx(Fragment, { children: items.map(([label, value]) => /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("span", { children: [
      label,
      ": "
    ] }),
    /* @__PURE__ */ jsx("span", { children: value ?? "N/A" })
  ] }, label)) });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("span", { children: "\xA0" }),
    /* @__PURE__ */ jsx(Tooltip, { title: toolTipBody, arrow: true, style: { cursor: "pointer" }, children: /* @__PURE__ */ jsxs("span", { children: [
      "(DWT: ",
      vesselInfo?.DWT ?? "N/A",
      ")"
    ] }) })
  ] });
};
var VesselSizeInfo_default = VesselSizeInfo;
var tableHeadCells = [
  { id: "shipSize", label: "Vessel Size" },
  { id: "routePoint", label: "Canal/Route Point" },
  { id: "price", label: "Freight Rate ($)" },
  { id: "cargoIntake", label: "Cargo Intake (MTS)" },
  { id: "isWithinTolerance", label: "Is Within Tolerance" }
];
var minimalInputHeadCells = tableHeadCells.slice().filter((item) => item.id !== "isWithinTolerance");
var filtersReducer = (state, action) => {
  switch (action.type) {
    case "SET_FILTER":
      const filters = Object.fromEntries(
        Object.entries({
          ...state.filters,
          [action.filterName]: action.filterValue
        }).filter(([_, v]) => v !== null)
        // Remove null values
      );
      return {
        ...state,
        filters
      };
    case "CLEAR_FILTERS":
      return {
        ...state,
        filters: {}
      };
    case "SET_ORDER_BY":
      const isAsc = state.orderBy === action.orderBy && state.order === "asc" /* Asc */;
      return {
        ...state,
        orderBy: action.orderBy,
        order: isAsc ? "desc" /* Desc */ : "asc" /* Asc */
      };
    default:
      throw new Error();
  }
};
var initialFiltersState = {
  order: "asc" /* Asc */,
  orderBy: "price",
  filters: { isWithinTolerance: true }
};
var noFiltersInitialState = {
  order: "asc" /* Asc */,
  orderBy: "price",
  filters: {}
};
var CalcTableOutput = ({
  data: data2,
  isAdvancedView,
  calculationId,
  vesselMap,
  apiRoutes,
  canDebugCalculation,
  setOutputPlans,
  renderMapButton,
  databaseVersion,
  isCFROptimizer,
  filterEnabled = true
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [filters, dispatch] = useReducer(
    filtersReducer,
    filterEnabled ? initialFiltersState : noFiltersInitialState
  );
  const [activeDebugId, setActiveDebugId] = useState(
    null
  );
  const activeColor = isDarkMode ? dark1 : grey$1[100];
  const filtersActive = Object.keys(filters.filters).length > 0;
  const handleSort = (property) => {
    dispatch({ type: "SET_ORDER_BY", orderBy: property });
  };
  const handleFilter = (id, value) => {
    dispatch({ type: "SET_FILTER", filterName: id, filterValue: value });
  };
  const handleResetFilters = () => dispatch({ type: "CLEAR_FILTERS" });
  const filterOptions = useMemo(() => {
    const results = data2.reduce(
      (acc, value) => {
        acc.shipSize.add(value.shipSize);
        acc.routePoint.add(value.routePoint);
        acc.price.add(value.price);
        acc.cargoIntake.add(value.debugData.cargoIntake);
        acc.isWithinTolerance.add(value.isWithinTolerance);
        return acc;
      },
      {
        shipSize: /* @__PURE__ */ new Set(),
        routePoint: /* @__PURE__ */ new Set(),
        price: /* @__PURE__ */ new Set(),
        cargoIntake: /* @__PURE__ */ new Set(),
        isWithinTolerance: /* @__PURE__ */ new Set()
      }
    );
    const transformedResults = {
      shipSize: [],
      routePoint: [],
      price: [],
      cargoIntake: [],
      isWithinTolerance: []
    };
    for (const key in results) {
      transformedResults[key] = [
        ...results[key]
      ].sort().map((value) => {
        if (typeof value === "number" || value === null) {
          return {
            label: value !== null ? formatNumberWithCommas(value) : "N/A",
            value
          };
        } else if (typeof value === "boolean") {
          return {
            label: value ? "Yes" : "No",
            value
          };
        }
        return value;
      });
    }
    return transformedResults;
  }, [data2]);
  const filteredSortedData = useMemo(() => {
    const orderBy = filters.orderBy;
    const isAsc = filters.order === "asc" /* Asc */;
    const shouldFilter = Object.keys(filters.filters).length > 0;
    const filteredData = shouldFilter ? data2.filter((item) => {
      for (const [key, value] of Object.entries(filters.filters)) {
        const theKey = key;
        if (theKey === "cargoIntake") {
          if (item.debugData[theKey] !== value) {
            return false;
          }
        } else if (item[theKey] !== value) {
          return false;
        }
      }
      return true;
    }) : data2;
    return filteredData.sort((a, b) => {
      if (orderBy === "cargoIntake") {
        return isAsc ? a.debugData[orderBy] - b.debugData[orderBy] : b.debugData[orderBy] - a.debugData[orderBy];
      }
      if (orderBy === "shipSize") {
        const aDWT = vesselMap[a[orderBy]].DWT;
        const bDWT = vesselMap[b[orderBy]].DWT;
        return isAsc ? aDWT - bDWT : bDWT - aDWT;
      }
      if (a[orderBy] < b[orderBy])
        return isAsc ? -1 : 1;
      if (a[orderBy] > b[orderBy])
        return isAsc ? 1 : -1;
      return 0;
    });
  }, [data2, filters, vesselMap]);
  useEffect(() => {
    if (setOutputPlans) {
      setOutputPlans(filteredSortedData);
    }
  }, [filteredSortedData, filtersActive]);
  const rightAlignedCellProps = {
    align: "right",
    sx: {
      paddingRight: "43px"
      // Add filter icon width 27px + 16px padding
    }
  };
  return /* @__PURE__ */ jsx(TableContainer, { component: Paper, children: /* @__PURE__ */ jsxs(Table, { stickyHeader: true, "data-calculation-id": calculationId, children: [
    /* @__PURE__ */ jsx(TableHead, { children: /* @__PURE__ */ jsxs(
      TableRow,
      {
        sx: {
          "& > th": {
            background: isDarkMode ? dark4 : void 0,
            borderBottom: isDarkMode ? `1px solid ${dark4}` : void 0
          }
        },
        children: [
          /* @__PURE__ */ jsx(TableCell, { width: 100, children: filtersActive && /* @__PURE__ */ jsx(Tooltip, { title: "Clear filters", placement: "top", children: /* @__PURE__ */ jsx(
            IconButton,
            {
              onClick: handleResetFilters,
              color: "error",
              size: "small",
              edge: "start",
              children: /* @__PURE__ */ jsx(FilterAltOffOutlined, { fontSize: "small" })
            }
          ) }) }),
          (isAdvancedView ? tableHeadCells : minimalInputHeadCells).map(
            ({ id, label }, index) => /* @__PURE__ */ jsx(
              TableHeaderCell_default,
              {
                id,
                label,
                isSortActive: filters.orderBy === id,
                isFilterActive: id in filters.filters,
                filterOptions: filterOptions[id],
                filterValue: filters.filters[id] ?? null,
                disableFilter: !filterEnabled,
                onSort: handleSort,
                onFilter: handleFilter,
                order: filters.order,
                tableCellProps: {
                  align: index !== 0 ? "right" : void 0
                }
              },
              id
            )
          ),
          isCFROptimizer ? /* @__PURE__ */ jsx(TableCell, { width: 100, children: "CFR Price" }) : null
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs(TableBody, { children: [
      filteredSortedData.length === 0 && /* @__PURE__ */ jsx(TableRow, { children: /* @__PURE__ */ jsxs(TableCell, { colSpan: isAdvancedView ? 7 : 5, align: "center", children: [
        "No matching results found.",
        " ",
        filtersActive ? "Please adjust your filters." : null
      ] }) }),
      filteredSortedData.map((item) => /* @__PURE__ */ jsxs(React52__default.Fragment, { children: [
        /* @__PURE__ */ jsxs(
          TableRow,
          {
            "data-result-id": item.id,
            onClick: () => setActiveDebugId(
              (currentValue) => currentValue === item.id ? null : item.id
            ),
            sx: {
              "& > td": {
                borderBottom: 0,
                background: item.id === activeDebugId ? isDarkMode ? dark3 : activeColor : isDarkMode ? dark5 : void 0,
                color: item.id === activeDebugId ? isDarkMode ? "primary.main" : black1 : isDarkMode ? "secondary.main" : black1
              }
            },
            children: [
              /* @__PURE__ */ jsx(TableCell, { children: /* @__PURE__ */ jsx(IconButton, { "aria-label": "expand row", size: "small", edge: "start", children: item.id === activeDebugId ? /* @__PURE__ */ jsx(KeyboardArrowUp, {}) : /* @__PURE__ */ jsx(KeyboardArrowDown, {}) }) }),
              /* @__PURE__ */ jsxs(TableCell, { children: [
                item.shipSize,
                /* @__PURE__ */ jsx(VesselSizeInfo_default, { vesselInfo: vesselMap[item.shipSize] }),
                /* @__PURE__ */ jsx(SizeRestrictionItineraryWarning, { voyage: item.debugData })
              ] }),
              /* @__PURE__ */ jsx(TableCell, { ...rightAlignedCellProps, children: item.routePoint }),
              /* @__PURE__ */ jsx(TableCell, { ...rightAlignedCellProps, children: item.price !== null ? formatNumberWithCommas(item.price) : "N/A" }),
              /* @__PURE__ */ jsx(TableCell, { ...rightAlignedCellProps, children: item.debugData.cargoIntake !== null ? formatNumberWithCommas(item.debugData.cargoIntake) : "N/A" }),
              isAdvancedView ? /* @__PURE__ */ jsxs(TableCell, { ...rightAlignedCellProps, children: [
                item.isWithinTolerance ? "Yes" : "No",
                !item.isWithinTolerance ? /* @__PURE__ */ jsx(Tooltip, { title: item.isWithinToleranceDetails, arrow: true, children: /* @__PURE__ */ jsx(
                  Info,
                  {
                    color: "disabled",
                    fontSize: "small",
                    sx: {
                      verticalAlign: "sub",
                      marginLeft: "3px"
                    }
                  }
                ) }) : null
              ] }) : null,
              isCFROptimizer ? /* @__PURE__ */ jsxs(TableCell, { width: 100, children: [
                item.cfrPriceType && item.cfrPriceType !== "distinct" ? /* @__PURE__ */ jsxs(Fragment, { children: [
                  item.cfrPriceType === "avg" ? "~" : "",
                  item.cfrPrice !== null && item.cfrPrice !== void 0 ? formatNumberWithCommas(item.cfrPrice) : "N/A"
                ] }) : null,
                item.cfrPriceType && item.cfrPriceType === "distinct" ? "Distinct" : ""
              ] }) : null
            ]
          }
        ),
        /* @__PURE__ */ jsx(TableRow, { sx: { "&:last-child > td": { border: 0 } }, children: /* @__PURE__ */ jsx(
          TableCell,
          {
            style: { paddingBottom: 0, paddingTop: 0 },
            colSpan: 6,
            sx: { bgcolor: activeColor },
            children: /* @__PURE__ */ jsx(
              Collapse,
              {
                in: item.id === activeDebugId,
                timeout: "auto",
                unmountOnExit: true,
                children: /* @__PURE__ */ jsxs(Box, { sx: { my: 2 }, children: [
                  /* @__PURE__ */ jsx(
                    DebugTable_default,
                    {
                      data: item.debugData,
                      databaseVersion: databaseVersion ?? "latest",
                      maturityDate: item.debugData.inputParams.baseDate,
                      isCFROptimizer
                    }
                  ),
                  /* @__PURE__ */ jsxs(
                    Box,
                    {
                      sx: {
                        display: "flex",
                        flex: 1,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between"
                      },
                      children: [
                        /* @__PURE__ */ jsx("div", { children: renderMapButton?.(calculationId, item.id) }),
                        /* @__PURE__ */ jsx("div", { children: canDebugCalculation && apiRoutes.debugPlan && /* @__PURE__ */ jsx(
                          DebugPanel_default,
                          {
                            apiRoute: apiRoutes.debugPlan,
                            calculationId,
                            planId: item.id
                          }
                        ) })
                      ]
                    }
                  )
                ] })
              }
            )
          }
        ) })
      ] }, item.id))
    ] })
  ] }) });
};
var CalcTableOutput_default = CalcTableOutput;
var IndeterminateProgress = ({
  innerMr = 1,
  ...props
}) => {
  return /* @__PURE__ */ jsx(Box4, { sx: { display: "flex", alignItems: "center" }, children: /* @__PURE__ */ jsx(Box4, { sx: { width: "100%", mr: innerMr }, children: /* @__PURE__ */ jsx(LinearProgress, { ...props }) }) });
};
var IndeterminateProgress_default = IndeterminateProgress;
var LinearProgressWithLabel = ({
  onCompleted,
  value,
  delay = 50,
  ...props
}) => {
  React52.useEffect(() => {
    if (!onCompleted)
      return;
    if (value < 100)
      return;
    const timeoutId = setTimeout(() => {
      onCompleted();
    }, delay);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [onCompleted, value, delay]);
  return /* @__PURE__ */ jsxs(Box4, { sx: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ jsx(Box4, { sx: { width: "100%", mr: 1 }, children: /* @__PURE__ */ jsx(LinearProgress, { variant: "determinate", value, ...props }) }),
    /* @__PURE__ */ jsx(Box4, { sx: { minWidth: 35 }, children: /* @__PURE__ */ jsx(Typography4, { variant: "body2", color: "text.secondary", children: `${Math.round(
      value
    )}%` }) })
  ] });
};
var LinearProgressWithLabel_default = LinearProgressWithLabel;

// ../../node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r3 in t)
        ({}).hasOwnProperty.call(t, r3) && (n[r3] = t[r3]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

// ../../node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r3, e) {
  if (null == r3)
    return {};
  var t = {};
  for (var n in r3)
    if ({}.hasOwnProperty.call(r3, n)) {
      if (e.indexOf(n) >= 0)
        continue;
      t[n] = r3[n];
    }
  return t;
}

// ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e)
    n += e;
  else if ("object" == typeof e)
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    } else
      for (f in e)
        e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++)
    (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_default = clsx;

// ../../node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/deepmerge/deepmerge.js
function isPlainObject(item) {
  if (typeof item !== "object" || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends2({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isPlainObject(source[key]) && // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/formatMuiErrorMessage/formatMuiErrorMessage.js
function formatMuiErrorMessage(code) {
  let url = "https://mui.com/production-error/?code=" + code;
  for (let i = 1; i < arguments.length; i += 1) {
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
}

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/refType/refType.js
var import_prop_types = __toESM(require_prop_types());
var refType = import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]);
var refType_default = refType;

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/capitalize/capitalize.js
function capitalize(string2) {
  if (typeof string2 !== "string") {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage(7));
  }
  return string2.charAt(0).toUpperCase() + string2.slice(1);
}

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/ownerDocument/ownerDocument.js
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/setRef/setRef.js
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
var useEnhancedEffect = typeof window !== "undefined" ? React52.useLayoutEffect : React52.useEffect;
var useEnhancedEffect_default = useEnhancedEffect;
var globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = React52.useState(idOverride);
  const id = idOverride || defaultId;
  React52.useEffect(() => {
    if (defaultId == null) {
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}
var maybeReactUseId = React52["useId".toString()];
function useId(idOverride) {
  if (maybeReactUseId !== void 0) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  return useGlobalId(idOverride);
}
function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = "value"
}) {
  const {
    current: isControlled
  } = React52.useRef(controlled !== void 0);
  const [valueState, setValue] = React52.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== "production") {
    React52.useEffect(() => {
      if (isControlled !== (controlled !== void 0)) {
        console.error([`MUI: A component is changing the ${isControlled ? "" : "un"}controlled ${state} state of ${name} to be ${isControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${name} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join("\n"));
      }
    }, [state, name, controlled]);
    const {
      current: defaultValue
    } = React52.useRef(defaultProp);
    React52.useEffect(() => {
      if (!isControlled && !Object.is(defaultValue, defaultProp)) {
        console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. To suppress this warning opt to use a controlled ${name}.`].join("\n"));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  const setValueIfUncontrolled = React52.useCallback((newValue) => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}
function useEventCallback(fn) {
  const ref = React52.useRef(fn);
  useEnhancedEffect_default(() => {
    ref.current = fn;
  });
  return React52.useRef((...args) => (
    // @ts-expect-error hide `this`
    (0, ref.current)(...args)
  )).current;
}
var useEventCallback_default = useEventCallback;
function useForkRef(...refs) {
  return React52.useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      return null;
    }
    return (instance) => {
      refs.forEach((ref) => {
        setRef(ref, instance);
      });
    };
  }, refs);
}

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/visuallyHidden/visuallyHidden.js
var visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
var visuallyHidden_default = visuallyHidden;

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/composeClasses/composeClasses.js
function composeClasses(slots, getUtilityClass, classes = void 0) {
  const output = {};
  Object.keys(slots).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot) => {
      output[slot] = slots[slot].reduce((acc, key) => {
        if (key) {
          const utilityClass = getUtilityClass(key);
          if (utilityClass !== "") {
            acc.push(utilityClass);
          }
          if (classes && classes[key]) {
            acc.push(classes[key]);
          }
        }
        return acc;
      }, []).join(" ");
    }
  );
  return output;
}

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/ClassNameGenerator/ClassNameGenerator.js
var defaultGenerator = (componentName) => componentName;
var createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
var ClassNameGenerator = createClassNameGenerator();
var ClassNameGenerator_default = ClassNameGenerator;

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/generateUtilityClass/generateUtilityClass.js
var globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator_default.generate(componentName)}-${slot}`;
}

// ../../node_modules/.pnpm/@mui+utils@5.15.20_@types+react@18.3.3_react@18.3.1/node_modules/@mui/utils/generateUtilityClasses/generateUtilityClasses.js
function generateUtilityClasses(componentName, slots, globalStatePrefix = "Mui") {
  const result = {};
  slots.forEach((slot) => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js
var import_prop_types2 = __toESM(require_prop_types());
var _excluded = ["localeText"];
var MuiPickersAdapterContext = /* @__PURE__ */ React52.createContext(null);
if (process.env.NODE_ENV !== "production") {
  MuiPickersAdapterContext.displayName = "MuiPickersAdapterContext";
}
var LocalizationProvider = function LocalizationProvider2(inProps) {
  const {
    localeText: inLocaleText
  } = inProps, otherInProps = _objectWithoutPropertiesLoose(inProps, _excluded);
  const {
    utils: parentUtils,
    localeText: parentLocaleText
  } = React52.useContext(MuiPickersAdapterContext) ?? {
    utils: void 0,
    localeText: void 0
  };
  const props = useThemeProps({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: otherInProps,
    name: "MuiLocalizationProvider"
  });
  const {
    children,
    dateAdapter: DateAdapter,
    dateFormats,
    dateLibInstance,
    adapterLocale,
    localeText: themeLocaleText
  } = props;
  const localeText = React52.useMemo(() => _extends({}, themeLocaleText, parentLocaleText, inLocaleText), [themeLocaleText, parentLocaleText, inLocaleText]);
  const utils = React52.useMemo(() => {
    if (!DateAdapter) {
      if (parentUtils) {
        return parentUtils;
      }
      return null;
    }
    const adapter = new DateAdapter({
      locale: adapterLocale,
      formats: dateFormats,
      instance: dateLibInstance
    });
    if (!adapter.isMUIAdapter) {
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    }
    return adapter;
  }, [DateAdapter, adapterLocale, dateFormats, dateLibInstance, parentUtils]);
  const defaultDates = React52.useMemo(() => {
    if (!utils) {
      return null;
    }
    return {
      minDate: utils.date("1900-01-01T00:00:00.000"),
      maxDate: utils.date("2099-12-31T00:00:00.000")
    };
  }, [utils]);
  const contextValue = React52.useMemo(() => {
    return {
      utils,
      defaultDates,
      localeText
    };
  }, [defaultDates, utils, localeText]);
  return /* @__PURE__ */ jsx(MuiPickersAdapterContext.Provider, {
    value: contextValue,
    children
  });
};
process.env.NODE_ENV !== "production" ? LocalizationProvider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: import_prop_types2.default.any,
  children: import_prop_types2.default.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: import_prop_types2.default.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: import_prop_types2.default.shape({
    dayOfMonth: import_prop_types2.default.string,
    dayOfMonthFull: import_prop_types2.default.string,
    fullDate: import_prop_types2.default.string,
    fullTime: import_prop_types2.default.string,
    fullTime12h: import_prop_types2.default.string,
    fullTime24h: import_prop_types2.default.string,
    hours12h: import_prop_types2.default.string,
    hours24h: import_prop_types2.default.string,
    keyboardDate: import_prop_types2.default.string,
    keyboardDateTime: import_prop_types2.default.string,
    keyboardDateTime12h: import_prop_types2.default.string,
    keyboardDateTime24h: import_prop_types2.default.string,
    meridiem: import_prop_types2.default.string,
    minutes: import_prop_types2.default.string,
    month: import_prop_types2.default.string,
    monthShort: import_prop_types2.default.string,
    normalDate: import_prop_types2.default.string,
    normalDateWithWeekday: import_prop_types2.default.string,
    seconds: import_prop_types2.default.string,
    shortDate: import_prop_types2.default.string,
    weekday: import_prop_types2.default.string,
    weekdayShort: import_prop_types2.default.string,
    year: import_prop_types2.default.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: import_prop_types2.default.any,
  /**
   * Locale for components texts
   */
  localeText: import_prop_types2.default.object
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/locales/utils/getPickersLocalization.js
var getPickersLocalization = (pickersTranslations) => {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: _extends({}, pickersTranslations)
        }
      }
    }
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/locales/enUS.js
var enUSPickers = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (view) => view === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (view, time, adapter) => `Select ${view}. ${time === null ? "No time selected" : `Selected time is ${adapter.format(time, "fullTime")}`}`,
  hoursClockNumberText: (hours) => `${hours} hours`,
  minutesClockNumberText: (minutes) => `${minutes} minutes`,
  secondsClockNumberText: (seconds) => `${seconds} seconds`,
  // Digital clock labels
  selectViewText: (view) => `Select ${view}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (weekNumber) => `Week ${weekNumber}`,
  calendarWeekNumberText: (weekNumber) => `${weekNumber}`,
  // Open picker labels
  openDatePickerDialogue: (value, utils) => value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (value, utils) => value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear value",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (params) => "Y".repeat(params.digitAmount),
  fieldMonthPlaceholder: (params) => params.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (params) => params.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
};
var DEFAULT_LOCALE = enUSPickers;
getPickersLocalization(enUSPickers);

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/useUtils.js
var useLocalizationContext = () => {
  const localization = React52.useContext(MuiPickersAdapterContext);
  if (localization === null) {
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join("\n"));
  }
  if (localization.utils === null) {
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join("\n"));
  }
  const localeText = React52.useMemo(() => _extends({}, DEFAULT_LOCALE, localization.localeText), [localization.localeText]);
  return React52.useMemo(() => _extends({}, localization, {
    localeText
  }), [localization, localeText]);
};
var useUtils = () => useLocalizationContext().utils;
var useDefaultDates = () => useLocalizationContext().defaultDates;
var useLocaleText = () => useLocalizationContext().localeText;
var useNow = (timezone) => {
  const utils = useUtils();
  const now = React52.useRef();
  if (now.current === void 0) {
    now.current = utils.date(void 0, timezone);
  }
  return now.current;
};

// ../../node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/RtlProvider/index.js
var import_prop_types3 = __toESM(require_prop_types());
var RtlContext = /* @__PURE__ */ React52.createContext();
process.env.NODE_ENV !== "production" ? {
  children: import_prop_types3.default.node,
  value: import_prop_types3.default.bool
} : void 0;
var useRtl = () => {
  const value = React52.useContext(RtlContext);
  return value != null ? value : false;
};

// ../../node_modules/.pnpm/@mui+base@5.0.0-beta.40_@types+react@18.3.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@mui/base/utils/isHostComponent.js
function isHostComponent(element) {
  return typeof element === "string";
}

// ../../node_modules/.pnpm/@mui+base@5.0.0-beta.40_@types+react@18.3.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@mui/base/utils/appendOwnerState.js
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === void 0 || isHostComponent(elementType)) {
    return otherProps;
  }
  return _extends2({}, otherProps, {
    ownerState: _extends2({}, otherProps.ownerState, ownerState)
  });
}

// ../../node_modules/.pnpm/@mui+base@5.0.0-beta.40_@types+react@18.3.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@mui/base/utils/extractEventHandlers.js
function extractEventHandlers(object2, excludeKeys = []) {
  if (object2 === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object2).filter((prop) => prop.match(/^on[A-Z]/) && typeof object2[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop) => {
    result[prop] = object2[prop];
  });
  return result;
}

// ../../node_modules/.pnpm/@mui+base@5.0.0-beta.40_@types+react@18.3.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@mui/base/utils/resolveComponentProps.js
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === "function") {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}

// ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
function r2(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e)
    n += e;
  else if ("object" == typeof e)
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (f = r2(e[t])) && (n && (n += " "), n += f);
    } else
      for (f in e)
        e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx2() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++)
    (e = arguments[f]) && (t = r2(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_default2 = clsx2;

// ../../node_modules/.pnpm/@mui+base@5.0.0-beta.40_@types+react@18.3.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@mui/base/utils/omitEventHandlers.js
function omitEventHandlers(object2) {
  if (object2 === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object2).filter((prop) => !(prop.match(/^on[A-Z]/) && typeof object2[prop] === "function")).forEach((prop) => {
    result[prop] = object2[prop];
  });
  return result;
}

// ../../node_modules/.pnpm/@mui+base@5.0.0-beta.40_@types+react@18.3.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@mui/base/utils/mergeSlotProps.js
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;
  if (!getSlotProps) {
    const joinedClasses2 = clsx_default2(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle2 = _extends2({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props2 = _extends2({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (joinedClasses2.length > 0) {
      props2.className = joinedClasses2;
    }
    if (Object.keys(mergedStyle2).length > 0) {
      props2.style = mergedStyle2;
    }
    return {
      props: props2,
      internalRef: void 0
    };
  }
  const eventHandlers = extractEventHandlers(_extends2({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers);
  const joinedClasses = clsx_default2(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  const mergedStyle = _extends2({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  const props = _extends2({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props,
    internalRef: internalSlotProps.ref
  };
}

// ../../node_modules/.pnpm/@mui+base@5.0.0-beta.40_@types+react@18.3.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@mui/base/utils/useSlotProps.js
var _excluded3 = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function useSlotProps(parameters) {
  var _parameters$additiona;
  const {
    elementType,
    externalSlotProps,
    ownerState,
    skipResolvingSlotProps = false
  } = parameters, rest = _objectWithoutPropertiesLoose2(parameters, _excluded3);
  const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps(_extends2({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  const props = appendOwnerState(elementType, _extends2({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}
var ArrowDropDownIcon = createSvgIcon(/* @__PURE__ */ jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
var ArrowLeftIcon = createSvgIcon(/* @__PURE__ */ jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft");
var ArrowRightIcon = createSvgIcon(/* @__PURE__ */ jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
var CalendarIcon = createSvgIcon(/* @__PURE__ */ jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
createSvgIcon(/* @__PURE__ */ jsxs(React52.Fragment, {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
createSvgIcon(/* @__PURE__ */ jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
createSvgIcon(/* @__PURE__ */ jsxs(React52.Fragment, {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
var ClearIcon = createSvgIcon(/* @__PURE__ */ jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/components/PickersArrowSwitcher/pickersArrowSwitcherClasses.js
function getPickersArrowSwitcherUtilityClass(slot) {
  return generateUtilityClass("MuiPickersArrowSwitcher", slot);
}
generateUtilityClasses("MuiPickersArrowSwitcher", ["root", "spacer", "button"]);
var _excluded4 = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel"];
var _excluded22 = ["ownerState"];
var _excluded32 = ["ownerState"];
var PickersArrowSwitcherRoot = styled("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  display: "flex"
});
var PickersArrowSwitcherSpacer = styled("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (props, styles) => styles.spacer
})(({
  theme
}) => ({
  width: theme.spacing(3)
}));
var PickersArrowSwitcherButton = styled(IconButton4, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (props, styles) => styles.button
})({
  variants: [{
    props: {
      hidden: true
    },
    style: {
      visibility: "hidden"
    }
  }]
});
var useUtilityClasses = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"]
  };
  return composeClasses(slots, getPickersArrowSwitcherUtilityClass, classes);
};
var PickersArrowSwitcher = /* @__PURE__ */ React52.forwardRef(function PickersArrowSwitcher2(inProps, ref) {
  const isRtl = useRtl();
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersArrowSwitcher"
  });
  const {
    children,
    className,
    slots,
    slotProps,
    isNextDisabled,
    isNextHidden,
    onGoToNext,
    nextLabel,
    isPreviousDisabled,
    isPreviousHidden,
    onGoToPrevious,
    previousLabel
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded4);
  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  const nextProps = {
    isDisabled: isNextDisabled,
    isHidden: isNextHidden,
    goTo: onGoToNext,
    label: nextLabel
  };
  const previousProps = {
    isDisabled: isPreviousDisabled,
    isHidden: isPreviousHidden,
    goTo: onGoToPrevious,
    label: previousLabel
  };
  const PreviousIconButton = slots?.previousIconButton ?? PickersArrowSwitcherButton;
  const previousIconButtonProps = useSlotProps({
    elementType: PreviousIconButton,
    externalSlotProps: slotProps?.previousIconButton,
    additionalProps: {
      size: "medium",
      title: previousProps.label,
      "aria-label": previousProps.label,
      disabled: previousProps.isDisabled,
      edge: "end",
      onClick: previousProps.goTo
    },
    ownerState: _extends({}, ownerState, {
      hidden: previousProps.isHidden
    }),
    className: classes.button
  });
  const NextIconButton = slots?.nextIconButton ?? PickersArrowSwitcherButton;
  const nextIconButtonProps = useSlotProps({
    elementType: NextIconButton,
    externalSlotProps: slotProps?.nextIconButton,
    additionalProps: {
      size: "medium",
      title: nextProps.label,
      "aria-label": nextProps.label,
      disabled: nextProps.isDisabled,
      edge: "start",
      onClick: nextProps.goTo
    },
    ownerState: _extends({}, ownerState, {
      hidden: nextProps.isHidden
    }),
    className: classes.button
  });
  const LeftArrowIcon = slots?.leftArrowIcon ?? ArrowLeftIcon;
  const _useSlotProps = useSlotProps({
    elementType: LeftArrowIcon,
    externalSlotProps: slotProps?.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), leftArrowIconProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded22);
  const RightArrowIcon = slots?.rightArrowIcon ?? ArrowRightIcon;
  const _useSlotProps2 = useSlotProps({
    elementType: RightArrowIcon,
    externalSlotProps: slotProps?.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), rightArrowIconProps = _objectWithoutPropertiesLoose(_useSlotProps2, _excluded32);
  return /* @__PURE__ */ jsxs(PickersArrowSwitcherRoot, _extends({
    ref,
    className: clsx_default(classes.root, className),
    ownerState
  }, other, {
    children: [/* @__PURE__ */ jsx(PreviousIconButton, _extends({}, previousIconButtonProps, {
      children: isRtl ? /* @__PURE__ */ jsx(RightArrowIcon, _extends({}, rightArrowIconProps)) : /* @__PURE__ */ jsx(LeftArrowIcon, _extends({}, leftArrowIconProps))
    })), children ? /* @__PURE__ */ jsx(Typography4, {
      variant: "subtitle1",
      component: "span",
      children
    }) : /* @__PURE__ */ jsx(PickersArrowSwitcherSpacer, {
      className: classes.spacer,
      ownerState
    }), /* @__PURE__ */ jsx(NextIconButton, _extends({}, nextIconButtonProps, {
      children: isRtl ? /* @__PURE__ */ jsx(LeftArrowIcon, _extends({}, leftArrowIconProps)) : /* @__PURE__ */ jsx(RightArrowIcon, _extends({}, rightArrowIconProps))
    }))]
  }));
});

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/views.js
var areViewsEqual = (views, expectedViews) => {
  if (views.length !== expectedViews.length) {
    return false;
  }
  return expectedViews.every((expectedView) => views.includes(expectedView));
};
var applyDefaultViewProps = ({
  openTo,
  defaultOpenTo,
  views,
  defaultViews
}) => {
  const viewsWithDefault = views ?? defaultViews;
  let openToWithDefault;
  if (openTo != null) {
    openToWithDefault = openTo;
  } else if (viewsWithDefault.includes(defaultOpenTo)) {
    openToWithDefault = defaultOpenTo;
  } else if (viewsWithDefault.length > 0) {
    openToWithDefault = viewsWithDefault[0];
  } else {
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  }
  return {
    views: viewsWithDefault,
    openTo: openToWithDefault
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/time-utils.js
var timeViews = ["hours", "minutes", "seconds"];
var isTimeView = (view) => timeViews.includes(view);
var getSecondsInDay = (date, utils) => {
  return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
var createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, utils) => (dateLeft, dateRight) => {
  if (disableIgnoringDatePartForTimeValidation) {
    return utils.isAfter(dateLeft, dateRight);
  }
  return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
};
var warnedOnceNotValidView = false;
function useViews({
  onChange,
  onViewChange,
  openTo,
  view: inView,
  views,
  autoFocus,
  focusedView: inFocusedView,
  onFocusedViewChange
}) {
  if (process.env.NODE_ENV !== "production") {
    if (!warnedOnceNotValidView) {
      if (inView != null && !views.includes(inView)) {
        console.warn(`MUI X: \`view="${inView}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
        warnedOnceNotValidView = true;
      }
      if (inView == null && openTo != null && !views.includes(openTo)) {
        console.warn(`MUI X: \`openTo="${openTo}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
        warnedOnceNotValidView = true;
      }
    }
  }
  const previousOpenTo = React52.useRef(openTo);
  const previousViews = React52.useRef(views);
  const defaultView = React52.useRef(views.includes(openTo) ? openTo : views[0]);
  const [view, setView] = useControlled({
    name: "useViews",
    state: "view",
    controlled: inView,
    default: defaultView.current
  });
  const defaultFocusedView = React52.useRef(autoFocus ? view : null);
  const [focusedView, setFocusedView] = useControlled({
    name: "useViews",
    state: "focusedView",
    controlled: inFocusedView,
    default: defaultFocusedView.current
  });
  React52.useEffect(() => {
    if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView2) => !views.includes(previousView2))) {
      setView(views.includes(openTo) ? openTo : views[0]);
      previousViews.current = views;
      previousOpenTo.current = openTo;
    }
  }, [openTo, setView, view, views]);
  const viewIndex = views.indexOf(view);
  const previousView = views[viewIndex - 1] ?? null;
  const nextView = views[viewIndex + 1] ?? null;
  const handleFocusedViewChange = useEventCallback_default((viewToFocus, hasFocus) => {
    if (hasFocus) {
      setFocusedView(viewToFocus);
    } else {
      setFocusedView(
        (prevFocusedView) => viewToFocus === prevFocusedView ? null : prevFocusedView
        // If false the blur is due to view switching
      );
    }
    onFocusedViewChange?.(viewToFocus, hasFocus);
  });
  const handleChangeView = useEventCallback_default((newView) => {
    handleFocusedViewChange(newView, true);
    if (newView === view) {
      return;
    }
    setView(newView);
    if (onViewChange) {
      onViewChange(newView);
    }
  });
  const goToNextView = useEventCallback_default(() => {
    if (nextView) {
      handleChangeView(nextView);
    }
  });
  const setValueAndGoToNextView = useEventCallback_default((value, currentViewSelectionState, selectedView) => {
    const isSelectionFinishedOnCurrentView = currentViewSelectionState === "finish";
    const hasMoreViews = selectedView ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      views.indexOf(selectedView) < views.length - 1
    ) : Boolean(nextView);
    const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? "partial" : currentViewSelectionState;
    onChange(value, globalSelectionState, selectedView);
    if (selectedView && selectedView !== view) {
      const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
      if (nextViewAfterSelected) {
        handleChangeView(nextViewAfterSelected);
      }
    } else if (isSelectionFinishedOnCurrentView) {
      goToNextView();
    }
  });
  return {
    view,
    setView: handleChangeView,
    focusedView,
    setFocusedView: handleFocusedViewChange,
    nextView,
    previousView,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: views.includes(openTo) ? openTo : views[0],
    goToNextView,
    setValueAndGoToNextView
  };
}
function useNextMonthDisabled(month, {
  disableFuture,
  maxDate,
  timezone
}) {
  const utils = useUtils();
  return React52.useMemo(() => {
    const now = utils.date(void 0, timezone);
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    return !utils.isAfter(lastEnabledMonth, month);
  }, [disableFuture, maxDate, month, utils, timezone]);
}
function usePreviousMonthDisabled(month, {
  disablePast,
  minDate,
  timezone
}) {
  const utils = useUtils();
  return React52.useMemo(() => {
    const now = utils.date(void 0, timezone);
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    return !utils.isBefore(firstEnabledMonth, month);
  }, [disablePast, minDate, month, utils, timezone]);
}

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/constants/dimensions.js
var DAY_SIZE = 36;
var DAY_MARGIN = 2;
var DIALOG_WIDTH = 320;
var MAX_CALENDAR_HEIGHT = 280;
var VIEW_HEIGHT = 336;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/components/PickerViewRoot/PickerViewRoot.js
var PickerViewRoot = styled("div")({
  overflow: "hidden",
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/date-utils.js
var mergeDateAndTime = (utils, dateParam, timeParam) => {
  let mergedDate = dateParam;
  mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
  mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
  mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
  return mergedDate;
};
var findClosestEnabledDate = ({
  date,
  disableFuture,
  disablePast,
  maxDate,
  minDate,
  isDateDisabled,
  utils,
  timezone
}) => {
  const today = mergeDateAndTime(utils, utils.date(void 0, timezone), date);
  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }
  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }
  let forward = date;
  let backward = date;
  if (utils.isBefore(date, minDate)) {
    forward = minDate;
    backward = null;
  }
  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = maxDate;
    }
    forward = null;
  }
  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }
    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }
    if (forward) {
      if (!isDateDisabled(forward)) {
        return forward;
      }
      forward = utils.addDays(forward, 1);
    }
    if (backward) {
      if (!isDateDisabled(backward)) {
        return backward;
      }
      backward = utils.addDays(backward, -1);
    }
  }
  return null;
};
var replaceInvalidDateByNull = (utils, value) => value == null || !utils.isValid(value) ? null : value;
var applyDefaultDate = (utils, value, defaultValue) => {
  if (value == null || !utils.isValid(value)) {
    return defaultValue;
  }
  return value;
};
var areDatesEqual = (utils, a, b) => {
  if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) {
    return true;
  }
  return utils.isEqual(a, b);
};
var getMonthsInYear = (utils, year) => {
  const firstMonth = utils.startOfYear(year);
  const months = [firstMonth];
  while (months.length < 12) {
    const prevMonth = months[months.length - 1];
    months.push(utils.addMonths(prevMonth, 1));
  }
  return months;
};
var getTodayDate = (utils, timezone, valueType) => valueType === "date" ? utils.startOfDay(utils.date(void 0, timezone)) : utils.date(void 0, timezone);
var dateViews = ["year", "month", "day"];
var isDatePickerView = (view) => dateViews.includes(view);
var resolveDateFormat = (utils, {
  format: format4,
  views
}, isInToolbar) => {
  if (format4 != null) {
    return format4;
  }
  const formats = utils.formats;
  if (areViewsEqual(views, ["year"])) {
    return formats.year;
  }
  if (areViewsEqual(views, ["month"])) {
    return formats.month;
  }
  if (areViewsEqual(views, ["day"])) {
    return formats.dayOfMonth;
  }
  if (areViewsEqual(views, ["month", "year"])) {
    return `${formats.month} ${formats.year}`;
  }
  if (areViewsEqual(views, ["day", "month"])) {
    return `${formats.month} ${formats.dayOfMonth}`;
  }
  if (isInToolbar) {
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
  }
  return formats.keyboardDate;
};
var getWeekdays = (utils, date) => {
  const start = utils.startOfWeek(date);
  return [0, 1, 2, 3, 4, 5, 6].map((diff) => utils.addDays(start, diff));
};
var useValueWithTimezone = ({
  timezone: timezoneProp,
  value: valueProp,
  defaultValue,
  onChange,
  valueManager
}) => {
  const utils = useUtils();
  const firstDefaultValue = React52.useRef(defaultValue);
  const inputValue = valueProp ?? firstDefaultValue.current ?? valueManager.emptyValue;
  const inputTimezone = React52.useMemo(() => valueManager.getTimezone(utils, inputValue), [utils, valueManager, inputValue]);
  const setInputTimezone = useEventCallback_default((newValue) => {
    if (inputTimezone == null) {
      return newValue;
    }
    return valueManager.setTimezone(utils, inputTimezone, newValue);
  });
  const timezoneToRender = timezoneProp ?? inputTimezone ?? "default";
  const valueWithTimezoneToRender = React52.useMemo(() => valueManager.setTimezone(utils, timezoneToRender, inputValue), [valueManager, utils, timezoneToRender, inputValue]);
  const handleValueChange = useEventCallback_default((newValue, ...otherParams) => {
    const newValueWithInputTimezone = setInputTimezone(newValue);
    onChange?.(newValueWithInputTimezone, ...otherParams);
  });
  return {
    value: valueWithTimezoneToRender,
    handleValueChange,
    timezone: timezoneToRender
  };
};
var useControlledValueWithTimezone = ({
  name,
  timezone: timezoneProp,
  value: valueProp,
  defaultValue,
  onChange: onChangeProp,
  valueManager
}) => {
  const [valueWithInputTimezone, setValue] = useControlled({
    name,
    state: "value",
    controlled: valueProp,
    default: defaultValue ?? valueManager.emptyValue
  });
  const onChange = useEventCallback_default((newValue, ...otherParams) => {
    setValue(newValue);
    onChangeProp?.(newValue, ...otherParams);
  });
  return useValueWithTimezone({
    timezone: timezoneProp,
    value: valueWithInputTimezone,
    defaultValue: void 0,
    onChange,
    valueManager
  });
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/getDefaultReferenceDate.js
var SECTION_TYPE_GRANULARITY = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
};
var getSectionTypeGranularity = (sections) => Math.max(...sections.map((section) => SECTION_TYPE_GRANULARITY[section.type] ?? 1));
var roundDate = (utils, granularity, date) => {
  if (granularity === SECTION_TYPE_GRANULARITY.year) {
    return utils.startOfYear(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.month) {
    return utils.startOfMonth(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.day) {
    return utils.startOfDay(date);
  }
  let roundedDate = date;
  if (granularity < SECTION_TYPE_GRANULARITY.minutes) {
    roundedDate = utils.setMinutes(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.seconds) {
    roundedDate = utils.setSeconds(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.milliseconds) {
    roundedDate = utils.setMilliseconds(roundedDate, 0);
  }
  return roundedDate;
};
var getDefaultReferenceDate = ({
  props,
  utils,
  granularity,
  timezone,
  getTodayDate: inGetTodayDate
}) => {
  let referenceDate = inGetTodayDate ? inGetTodayDate() : roundDate(utils, granularity, getTodayDate(utils, timezone));
  if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.minDate);
  }
  if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.maxDate);
  }
  const isAfter2 = createIsAfterIgnoreDatePart(props.disableIgnoringDatePartForTimeValidation ?? false, utils);
  if (props.minTime != null && isAfter2(props.minTime, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : mergeDateAndTime(utils, referenceDate, props.minTime));
  }
  if (props.maxTime != null && isAfter2(referenceDate, props.maxTime)) {
    referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : mergeDateAndTime(utils, referenceDate, props.maxTime));
  }
  return referenceDate;
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/useField/useField.utils.js
var getDateSectionConfigFromFormatToken = (utils, formatToken) => {
  const config = utils.formatTokenMap[formatToken];
  if (config == null) {
    throw new Error([`MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join("\n"));
  }
  if (typeof config === "string") {
    return {
      type: config,
      contentType: config === "meridiem" ? "letter" : "digit",
      maxLength: void 0
    };
  }
  return {
    type: config.sectionType,
    contentType: config.contentType,
    maxLength: config.maxLength
  };
};
var getDeltaFromKeyCode = (keyCode) => {
  switch (keyCode) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
};
var getDaysInWeekStr = (utils, timezone, format4) => {
  const elements = [];
  const now = utils.date(void 0, timezone);
  const startDate = utils.startOfWeek(now);
  const endDate = utils.endOfWeek(now);
  let current = startDate;
  while (utils.isBefore(current, endDate)) {
    elements.push(current);
    current = utils.addDays(current, 1);
  }
  return elements.map((weekDay) => utils.formatByString(weekDay, format4));
};
var getLetterEditingOptions = (utils, timezone, sectionType, format4) => {
  switch (sectionType) {
    case "month": {
      return getMonthsInYear(utils, utils.date(void 0, timezone)).map((month) => utils.formatByString(month, format4));
    }
    case "weekDay": {
      return getDaysInWeekStr(utils, timezone, format4);
    }
    case "meridiem": {
      const now = utils.date(void 0, timezone);
      return [utils.startOfDay(now), utils.endOfDay(now)].map((date) => utils.formatByString(date, format4));
    }
    default: {
      return [];
    }
  }
};
var FORMAT_SECONDS_NO_LEADING_ZEROS = "s";
var NON_LOCALIZED_DIGITS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
var getLocalizedDigits = (utils) => {
  const today = utils.date(void 0);
  const formattedZero = utils.formatByString(utils.setSeconds(today, 0), FORMAT_SECONDS_NO_LEADING_ZEROS);
  if (formattedZero === "0") {
    return NON_LOCALIZED_DIGITS;
  }
  return Array.from({
    length: 10
  }).map((_, index) => utils.formatByString(utils.setSeconds(today, index), FORMAT_SECONDS_NO_LEADING_ZEROS));
};
var removeLocalizedDigits = (valueStr, localizedDigits) => {
  if (localizedDigits[0] === "0") {
    return valueStr;
  }
  const digits = [];
  let currentFormattedDigit = "";
  for (let i = 0; i < valueStr.length; i += 1) {
    currentFormattedDigit += valueStr[i];
    const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
    if (matchingDigitIndex > -1) {
      digits.push(matchingDigitIndex.toString());
      currentFormattedDigit = "";
    }
  }
  return digits.join("");
};
var applyLocalizedDigits = (valueStr, localizedDigits) => {
  if (localizedDigits[0] === "0") {
    return valueStr;
  }
  return valueStr.split("").map((char) => localizedDigits[Number(char)]).join("");
};
var isStringNumber = (valueStr, localizedDigits) => {
  const nonLocalizedValueStr = removeLocalizedDigits(valueStr, localizedDigits);
  return !Number.isNaN(Number(nonLocalizedValueStr));
};
var cleanLeadingZeros = (valueStr, size) => {
  let cleanValueStr = valueStr;
  cleanValueStr = Number(cleanValueStr).toString();
  while (cleanValueStr.length < size) {
    cleanValueStr = `0${cleanValueStr}`;
  }
  return cleanValueStr;
};
var cleanDigitSectionValue = (utils, value, sectionBoundaries, localizedDigits, section) => {
  if (process.env.NODE_ENV !== "production") {
    if (section.type !== "day" && section.contentType === "digit-with-letter") {
      throw new Error([`MUI X: The token "${section.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join("\n"));
    }
  }
  if (section.type === "day" && section.contentType === "digit-with-letter") {
    const date = utils.setDate(sectionBoundaries.longestMonth, value);
    return utils.formatByString(date, section.format);
  }
  let valueStr = value.toString();
  if (section.hasLeadingZerosInInput) {
    valueStr = cleanLeadingZeros(valueStr, section.maxLength);
  }
  return applyLocalizedDigits(valueStr, localizedDigits);
};
var adjustSectionValue = (utils, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes) => {
  const delta = getDeltaFromKeyCode(keyCode);
  const isStart = keyCode === "Home";
  const isEnd = keyCode === "End";
  const shouldSetAbsolute = section.value === "" || isStart || isEnd;
  const adjustDigitSection = () => {
    const sectionBoundaries = sectionsValueBoundaries[section.type]({
      currentDate: activeDate,
      format: section.format,
      contentType: section.contentType
    });
    const getCleanValue = (value) => cleanDigitSectionValue(utils, value, sectionBoundaries, localizedDigits, section);
    const step = section.type === "minutes" && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
    const currentSectionValue = parseInt(removeLocalizedDigits(section.value, localizedDigits), 10);
    let newSectionValueNumber = currentSectionValue + delta * step;
    if (shouldSetAbsolute) {
      if (section.type === "year" && !isEnd && !isStart) {
        return utils.formatByString(utils.date(void 0, timezone), section.format);
      }
      if (delta > 0 || isStart) {
        newSectionValueNumber = sectionBoundaries.minimum;
      } else {
        newSectionValueNumber = sectionBoundaries.maximum;
      }
    }
    if (newSectionValueNumber % step !== 0) {
      if (delta < 0 || isStart) {
        newSectionValueNumber += step - (step + newSectionValueNumber) % step;
      }
      if (delta > 0 || isEnd) {
        newSectionValueNumber -= newSectionValueNumber % step;
      }
    }
    if (newSectionValueNumber > sectionBoundaries.maximum) {
      return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
    }
    if (newSectionValueNumber < sectionBoundaries.minimum) {
      return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
    }
    return getCleanValue(newSectionValueNumber);
  };
  const adjustLetterSection = () => {
    const options = getLetterEditingOptions(utils, timezone, section.type, section.format);
    if (options.length === 0) {
      return section.value;
    }
    if (shouldSetAbsolute) {
      if (delta > 0 || isStart) {
        return options[0];
      }
      return options[options.length - 1];
    }
    const currentOptionIndex = options.indexOf(section.value);
    const newOptionIndex = (currentOptionIndex + delta) % options.length;
    const clampedIndex = (newOptionIndex + options.length) % options.length;
    return options[clampedIndex];
  };
  if (section.contentType === "digit" || section.contentType === "digit-with-letter") {
    return adjustDigitSection();
  }
  return adjustLetterSection();
};
var getSectionVisibleValue = (section, target, localizedDigits) => {
  let value = section.value || section.placeholder;
  const hasLeadingZeros = target === "non-input" ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
  if (target === "non-input" && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) {
    value = Number(removeLocalizedDigits(value, localizedDigits)).toString();
  }
  const shouldAddInvisibleSpace = ["input-rtl", "input-ltr"].includes(target) && section.contentType === "digit" && !hasLeadingZeros && value.length === 1;
  if (shouldAddInvisibleSpace) {
    value = `${value}\u200E`;
  }
  if (target === "input-rtl") {
    value = `\u2068${value}\u2069`;
  }
  return value;
};
var changeSectionValueFormat = (utils, valueStr, currentFormat, newFormat) => {
  if (process.env.NODE_ENV !== "production") {
    if (getDateSectionConfigFromFormatToken(utils, currentFormat).type === "weekDay") {
      throw new Error("changeSectionValueFormat doesn't support week day formats");
    }
  }
  return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
var isFourDigitYearFormat = (utils, timezone, format4) => utils.formatByString(utils.date(void 0, timezone), format4).length === 4;
var doesSectionFormatHaveLeadingZeros = (utils, timezone, contentType, sectionType, format4) => {
  if (contentType !== "digit") {
    return false;
  }
  const now = utils.date(void 0, timezone);
  switch (sectionType) {
    case "year": {
      if (isFourDigitYearFormat(utils, timezone, format4)) {
        const formatted0001 = utils.formatByString(utils.setYear(now, 1), format4);
        return formatted0001 === "0001";
      }
      const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format4);
      return formatted2001 === "01";
    }
    case "month": {
      return utils.formatByString(utils.startOfYear(now), format4).length > 1;
    }
    case "day": {
      return utils.formatByString(utils.startOfMonth(now), format4).length > 1;
    }
    case "weekDay": {
      return utils.formatByString(utils.startOfWeek(now), format4).length > 1;
    }
    case "hours": {
      return utils.formatByString(utils.setHours(now, 1), format4).length > 1;
    }
    case "minutes": {
      return utils.formatByString(utils.setMinutes(now, 1), format4).length > 1;
    }
    case "seconds": {
      return utils.formatByString(utils.setSeconds(now, 1), format4).length > 1;
    }
    default: {
      throw new Error("Invalid section type");
    }
  }
};
var getDateFromDateSections = (utils, sections, localizedDigits) => {
  const shouldSkipWeekDays = sections.some((section) => section.type === "day");
  const sectionFormats = [];
  const sectionValues = [];
  for (let i = 0; i < sections.length; i += 1) {
    const section = sections[i];
    const shouldSkip = shouldSkipWeekDays && section.type === "weekDay";
    if (!shouldSkip) {
      sectionFormats.push(section.format);
      sectionValues.push(getSectionVisibleValue(section, "non-input", localizedDigits));
    }
  }
  const formatWithoutSeparator = sectionFormats.join(" ");
  const dateWithoutSeparatorStr = sectionValues.join(" ");
  return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
var createDateStrForV7HiddenInputFromSections = (sections) => sections.map((section) => {
  return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
}).join("");
var createDateStrForV6InputFromSections = (sections, localizedDigits, isRtl) => {
  const formattedSections = sections.map((section) => {
    const dateValue = getSectionVisibleValue(section, isRtl ? "input-rtl" : "input-ltr", localizedDigits);
    return `${section.startSeparator}${dateValue}${section.endSeparator}`;
  });
  const dateStr = formattedSections.join("");
  if (!isRtl) {
    return dateStr;
  }
  return `\u2066${dateStr}\u2069`;
};
var getSectionsBoundaries = (utils, localizedDigits, timezone) => {
  const today = utils.date(void 0, timezone);
  const endOfYear2 = utils.endOfYear(today);
  const endOfDay2 = utils.endOfDay(today);
  const {
    maxDaysInMonth,
    longestMonth
  } = getMonthsInYear(utils, today).reduce((acc, month) => {
    const daysInMonth = utils.getDaysInMonth(month);
    if (daysInMonth > acc.maxDaysInMonth) {
      return {
        maxDaysInMonth: daysInMonth,
        longestMonth: month
      };
    }
    return acc;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: format4
    }) => ({
      minimum: 0,
      maximum: isFourDigitYearFormat(utils, timezone, format4) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: utils.getMonth(endOfYear2) + 1
    }),
    day: ({
      currentDate
    }) => ({
      minimum: 1,
      maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
      longestMonth
    }),
    weekDay: ({
      format: format4,
      contentType
    }) => {
      if (contentType === "digit") {
        const daysInWeek = getDaysInWeekStr(utils, timezone, format4).map(Number);
        return {
          minimum: Math.min(...daysInWeek),
          maximum: Math.max(...daysInWeek)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: format4
    }) => {
      const lastHourInDay = utils.getHours(endOfDay2);
      const hasMeridiem = removeLocalizedDigits(utils.formatByString(utils.endOfDay(today), format4), localizedDigits) !== lastHourInDay.toString();
      if (hasMeridiem) {
        return {
          minimum: 1,
          maximum: Number(removeLocalizedDigits(utils.formatByString(utils.startOfDay(today), format4), localizedDigits))
        };
      }
      return {
        minimum: 0,
        maximum: lastHourInDay
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: utils.getMinutes(endOfDay2)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: utils.getSeconds(endOfDay2)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
var warnedOnceInvalidSection = false;
var validateSections = (sections, valueType) => {
  if (process.env.NODE_ENV !== "production") {
    if (!warnedOnceInvalidSection) {
      const supportedSections = ["empty"];
      if (["date", "date-time"].includes(valueType)) {
        supportedSections.push("weekDay", "day", "month", "year");
      }
      if (["time", "date-time"].includes(valueType)) {
        supportedSections.push("hours", "minutes", "seconds", "meridiem");
      }
      const invalidSection = sections.find((section) => !supportedSections.includes(section.type));
      if (invalidSection) {
        console.warn(`MUI X: The field component you are using is not compatible with the "${invalidSection.type}" date section.`, `The supported date sections are ["${supportedSections.join('", "')}"]\`.`);
        warnedOnceInvalidSection = true;
      }
    }
  }
};
var transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo) => {
  switch (section.type) {
    case "year": {
      return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
    }
    case "month": {
      return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
    }
    case "weekDay": {
      const formattedDaysInWeek = getDaysInWeekStr(utils, timezone, section.format);
      const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
      const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
      const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
      const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
      return utils.addDays(dateToTransferFrom, diff);
    }
    case "day": {
      return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
    }
    case "meridiem": {
      const isAM = utils.getHours(dateToTransferFrom) < 12;
      const mergedDateHours = utils.getHours(dateToTransferTo);
      if (isAM && mergedDateHours >= 12) {
        return utils.addHours(dateToTransferTo, -12);
      }
      if (!isAM && mergedDateHours < 12) {
        return utils.addHours(dateToTransferTo, 12);
      }
      return dateToTransferTo;
    }
    case "hours": {
      return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
    }
    case "minutes": {
      return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
    }
    case "seconds": {
      return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
    }
    default: {
      return dateToTransferTo;
    }
  }
};
var reliableSectionModificationOrder = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
};
var mergeDateIntoReferenceDate = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections) => (
  // cloning sections before sort to avoid mutating it
  [...sections].sort((a, b) => reliableSectionModificationOrder[a.type] - reliableSectionModificationOrder[b.type]).reduce((mergedDate, section) => {
    if (!shouldLimitToEditedSections || section.modified) {
      return transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
    }
    return mergedDate;
  }, referenceDate)
);
var isAndroid = () => navigator.userAgent.toLowerCase().indexOf("android") > -1;
var getSectionOrder = (sections, shouldApplyRTL) => {
  const neighbors = {};
  if (!shouldApplyRTL) {
    sections.forEach((_, index) => {
      const leftIndex = index === 0 ? null : index - 1;
      const rightIndex = index === sections.length - 1 ? null : index + 1;
      neighbors[index] = {
        leftIndex,
        rightIndex
      };
    });
    return {
      neighbors,
      startIndex: 0,
      endIndex: sections.length - 1
    };
  }
  const rtl2ltr = {};
  const ltr2rtl = {};
  let groupedSectionsStart = 0;
  let groupedSectionsEnd = 0;
  let RTLIndex = sections.length - 1;
  while (RTLIndex >= 0) {
    groupedSectionsEnd = sections.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (section, index) => index >= groupedSectionsStart && section.endSeparator?.includes(" ") && // Special case where the spaces were not there in the initial input
      section.endSeparator !== " / "
    );
    if (groupedSectionsEnd === -1) {
      groupedSectionsEnd = sections.length - 1;
    }
    for (let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1) {
      ltr2rtl[i] = RTLIndex;
      rtl2ltr[RTLIndex] = i;
      RTLIndex -= 1;
    }
    groupedSectionsStart = groupedSectionsEnd + 1;
  }
  sections.forEach((_, index) => {
    const rtlIndex = ltr2rtl[index];
    const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
    const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
    neighbors[index] = {
      leftIndex,
      rightIndex
    };
  });
  return {
    neighbors,
    startIndex: rtl2ltr[0],
    endIndex: rtl2ltr[sections.length - 1]
  };
};
var parseSelectedSections = (selectedSections, sections) => {
  if (selectedSections == null) {
    return null;
  }
  if (selectedSections === "all") {
    return "all";
  }
  if (typeof selectedSections === "string") {
    return sections.findIndex((section) => section.type === selectedSections);
  }
  return selectedSections;
};
var getSectionValueText = (section, utils) => {
  if (!section.value) {
    return void 0;
  }
  switch (section.type) {
    case "month": {
      if (section.contentType === "digit") {
        return utils.format(utils.setMonth(utils.date(), Number(section.value) - 1), "month");
      }
      const parsedDate = utils.parse(section.value, section.format);
      return parsedDate ? utils.format(parsedDate, "month") : void 0;
    }
    case "day":
      return section.contentType === "digit" ? utils.format(utils.setDate(utils.startOfYear(utils.date()), Number(section.value)), "dayOfMonthFull") : section.value;
    case "weekDay":
      return void 0;
    default:
      return void 0;
  }
};
var getSectionValueNow = (section, utils) => {
  if (!section.value) {
    return void 0;
  }
  switch (section.type) {
    case "weekDay": {
      if (section.contentType === "letter") {
        return void 0;
      }
      return Number(section.value);
    }
    case "meridiem": {
      const parsedDate = utils.parse(`01:00 ${section.value}`, `${utils.formats.hours12h}:${utils.formats.minutes} ${section.format}`);
      if (parsedDate) {
        return utils.getHours(parsedDate) >= 12 ? 1 : 0;
      }
      return void 0;
    }
    case "day":
      return section.contentType === "digit-with-letter" ? parseInt(section.value, 10) : Number(section.value);
    case "month": {
      if (section.contentType === "digit") {
        return Number(section.value);
      }
      const parsedDate = utils.parse(section.value, section.format);
      return parsedDate ? utils.getMonth(parsedDate) + 1 : void 0;
    }
    default:
      return section.contentType !== "letter" ? Number(section.value) : void 0;
  }
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/valueManagers.js
var _excluded5 = ["value", "referenceDate"];
var singleItemValueManager = {
  emptyValue: null,
  getTodayValue: getTodayDate,
  getInitialReferenceValue: (_ref) => {
    let {
      value,
      referenceDate
    } = _ref, params = _objectWithoutPropertiesLoose(_ref, _excluded5);
    if (value != null && params.utils.isValid(value)) {
      return value;
    }
    if (referenceDate != null) {
      return referenceDate;
    }
    return getDefaultReferenceDate(params);
  },
  cleanValue: replaceInvalidDateByNull,
  areValuesEqual: areDatesEqual,
  isSameError: (a, b) => a === b,
  hasError: (error) => error != null,
  defaultErrorState: null,
  getTimezone: (utils, value) => value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
  setTimezone: (utils, timezone, value) => value == null ? null : utils.setTimezone(value, timezone)
};
var singleItemFieldValueManager = {
  updateReferenceValue: (utils, value, prevReferenceValue) => value == null || !utils.isValid(value) ? prevReferenceValue : value,
  getSectionsFromValue: (utils, date, prevSections, getSectionsFromDate) => {
    const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
    if (shouldReUsePrevDateSections) {
      return prevSections;
    }
    return getSectionsFromDate(date);
  },
  getV7HiddenInputValueFromSections: createDateStrForV7HiddenInputFromSections,
  getV6InputValueFromSections: createDateStrForV6InputFromSections,
  getActiveDateManager: (utils, state) => ({
    date: state.value,
    referenceDate: state.referenceValue,
    getSections: (sections) => sections,
    getNewValuesFromNewActiveDate: (newActiveDate) => ({
      value: newActiveDate,
      referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
    })
  }),
  parseValueStr: (valueStr, referenceValue, parseDate) => parseDate(valueStr.trim(), referenceValue)
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersDay/PickersDay.js
var import_prop_types4 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersDay/pickersDayClasses.js
function getPickersDayUtilityClass(slot) {
  return generateUtilityClass("MuiPickersDay", slot);
}
var pickersDayClasses = generateUtilityClasses("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]);
var _excluded6 = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"];
var useUtilityClasses2 = (ownerState) => {
  const {
    selected,
    disableMargin,
    disableHighlightToday,
    today,
    disabled,
    outsideCurrentMonth,
    showDaysOutsideCurrentMonth,
    classes
  } = ownerState;
  const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
  const slots = {
    root: ["root", selected && !isHiddenDaySpacingFiller && "selected", disabled && "disabled", !disableMargin && "dayWithMargin", !disableHighlightToday && today && "today", outsideCurrentMonth && showDaysOutsideCurrentMonth && "dayOutsideMonth", isHiddenDaySpacingFiller && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  };
  return composeClasses(slots, getPickersDayUtilityClass, classes);
};
var styleArg = ({
  theme
}) => _extends({}, theme.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: theme.transitions.create("background-color", {
    duration: theme.transitions.duration.short
  }),
  color: (theme.vars || theme).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
    [`&.${pickersDayClasses.selected}`]: {
      willChange: "background-color",
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.disabled}:not(.${pickersDayClasses.selected})`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${pickersDayClasses.disabled}&.${pickersDayClasses.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: false
    },
    style: {
      margin: `0 ${DAY_MARGIN}px`
    }
  }, {
    props: {
      outsideCurrentMonth: true,
      showDaysOutsideCurrentMonth: true
    },
    style: {
      color: (theme.vars || theme).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: false,
      today: true
    },
    style: {
      [`&:not(.${pickersDayClasses.selected})`]: {
        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
      }
    }
  }]
});
var overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, !ownerState.disableMargin && styles.dayWithMargin, !ownerState.disableHighlightToday && ownerState.today && styles.today, !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth, ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller];
};
var PickersDayRoot = styled(ButtonBase, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver
})(styleArg);
var PickersDayFiller = styled("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver
})(({
  theme
}) => _extends({}, styleArg({
  theme
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
}));
var noop = () => {
};
var PickersDayRaw = /* @__PURE__ */ React52.forwardRef(function PickersDay(inProps, forwardedRef) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersDay"
  });
  const {
    autoFocus = false,
    className,
    day,
    disabled = false,
    disableHighlightToday = false,
    disableMargin = false,
    isAnimating,
    onClick,
    onDaySelect,
    onFocus = noop,
    onBlur = noop,
    onKeyDown = noop,
    onMouseDown = noop,
    onMouseEnter = noop,
    outsideCurrentMonth,
    selected = false,
    showDaysOutsideCurrentMonth = false,
    children,
    today: isToday = false
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded6);
  const ownerState = _extends({}, props, {
    autoFocus,
    disabled,
    disableHighlightToday,
    disableMargin,
    selected,
    showDaysOutsideCurrentMonth,
    today: isToday
  });
  const classes = useUtilityClasses2(ownerState);
  const utils = useUtils();
  const ref = React52.useRef(null);
  const handleRef = useForkRef(ref, forwardedRef);
  useEnhancedEffect_default(() => {
    if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) {
      ref.current.focus();
    }
  }, [autoFocus, disabled, isAnimating, outsideCurrentMonth]);
  const handleMouseDown = (event) => {
    onMouseDown(event);
    if (outsideCurrentMonth) {
      event.preventDefault();
    }
  };
  const handleClick = (event) => {
    if (!disabled) {
      onDaySelect(day);
    }
    if (outsideCurrentMonth) {
      event.currentTarget.focus();
    }
    if (onClick) {
      onClick(event);
    }
  };
  if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) {
    return /* @__PURE__ */ jsx(PickersDayFiller, {
      className: clsx_default(classes.root, classes.hiddenDaySpacingFiller, className),
      ownerState,
      role: other.role
    });
  }
  return /* @__PURE__ */ jsx(PickersDayRoot, _extends({
    className: clsx_default(classes.root, className),
    ref: handleRef,
    centerRipple: true,
    disabled,
    tabIndex: selected ? 0 : -1,
    onKeyDown: (event) => onKeyDown(event, day),
    onFocus: (event) => onFocus(event, day),
    onBlur: (event) => onBlur(event, day),
    onMouseEnter: (event) => onMouseEnter(event, day),
    onClick: handleClick,
    onMouseDown: handleMouseDown
  }, other, {
    ownerState,
    children: !children ? utils.format(day, "dayOfMonth") : children
  }));
});
process.env.NODE_ENV !== "production" ? PickersDayRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: import_prop_types4.default.oneOfType([import_prop_types4.default.func, import_prop_types4.default.shape({
    current: import_prop_types4.default.shape({
      focusVisible: import_prop_types4.default.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: import_prop_types4.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: import_prop_types4.default.object,
  className: import_prop_types4.default.string,
  component: import_prop_types4.default.elementType,
  /**
   * The date to show.
   */
  day: import_prop_types4.default.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: import_prop_types4.default.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: import_prop_types4.default.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: import_prop_types4.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: import_prop_types4.default.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: import_prop_types4.default.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: import_prop_types4.default.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: import_prop_types4.default.string,
  isAnimating: import_prop_types4.default.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: import_prop_types4.default.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: import_prop_types4.default.bool.isRequired,
  onBlur: import_prop_types4.default.func,
  onDaySelect: import_prop_types4.default.func.isRequired,
  onFocus: import_prop_types4.default.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: import_prop_types4.default.func,
  onKeyDown: import_prop_types4.default.func,
  onMouseEnter: import_prop_types4.default.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: import_prop_types4.default.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: import_prop_types4.default.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: import_prop_types4.default.bool,
  style: import_prop_types4.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types4.default.oneOfType([import_prop_types4.default.arrayOf(import_prop_types4.default.oneOfType([import_prop_types4.default.func, import_prop_types4.default.object, import_prop_types4.default.bool])), import_prop_types4.default.func, import_prop_types4.default.object]),
  /**
   * @default 0
   */
  tabIndex: import_prop_types4.default.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: import_prop_types4.default.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: import_prop_types4.default.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: import_prop_types4.default.oneOfType([import_prop_types4.default.func, import_prop_types4.default.shape({
    current: import_prop_types4.default.shape({
      pulsate: import_prop_types4.default.func.isRequired,
      start: import_prop_types4.default.func.isRequired,
      stop: import_prop_types4.default.func.isRequired
    })
  })])
} : void 0;
var PickersDay2 = /* @__PURE__ */ React52.memo(PickersDayRaw);

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DateField/DateField.js
var import_prop_types12 = __toESM(require_prop_types());
function useValidation(props, validate, isSameError, defaultErrorState) {
  const {
    value,
    onError
  } = props;
  const adapter = useLocalizationContext();
  const previousValidationErrorRef = React52.useRef(defaultErrorState);
  const validationError = validate({
    adapter,
    value,
    props
  });
  React52.useEffect(() => {
    if (onError && !isSameError(validationError, previousValidationErrorRef.current)) {
      onError(validationError, value);
    }
    previousValidationErrorRef.current = validationError;
  }, [isSameError, onError, previousValidationErrorRef, validationError, value]);
  return validationError;
}

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/useField/buildSectionsFromFormat.js
var expandFormat = ({
  utils,
  format: format4
}) => {
  let formatExpansionOverflow = 10;
  let prevFormat = format4;
  let nextFormat = utils.expandFormat(format4);
  while (nextFormat !== prevFormat) {
    prevFormat = nextFormat;
    nextFormat = utils.expandFormat(prevFormat);
    formatExpansionOverflow -= 1;
    if (formatExpansionOverflow < 0) {
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
    }
  }
  return nextFormat;
};
var getEscapedPartsFromFormat = ({
  utils,
  expandedFormat
}) => {
  const escapedParts = [];
  const {
    start: startChar,
    end: endChar
  } = utils.escapedCharacters;
  const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, "g");
  let match = null;
  while (match = regExp.exec(expandedFormat)) {
    escapedParts.push({
      start: match.index,
      end: regExp.lastIndex - 1
    });
  }
  return escapedParts;
};
var getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, sectionFormat) => {
  switch (sectionConfig.type) {
    case "year": {
      return localeText.fieldYearPlaceholder({
        digitAmount: utils.formatByString(utils.date(void 0, timezone), sectionFormat).length,
        format: sectionFormat
      });
    }
    case "month": {
      return localeText.fieldMonthPlaceholder({
        contentType: sectionConfig.contentType,
        format: sectionFormat
      });
    }
    case "day": {
      return localeText.fieldDayPlaceholder({
        format: sectionFormat
      });
    }
    case "weekDay": {
      return localeText.fieldWeekDayPlaceholder({
        contentType: sectionConfig.contentType,
        format: sectionFormat
      });
    }
    case "hours": {
      return localeText.fieldHoursPlaceholder({
        format: sectionFormat
      });
    }
    case "minutes": {
      return localeText.fieldMinutesPlaceholder({
        format: sectionFormat
      });
    }
    case "seconds": {
      return localeText.fieldSecondsPlaceholder({
        format: sectionFormat
      });
    }
    case "meridiem": {
      return localeText.fieldMeridiemPlaceholder({
        format: sectionFormat
      });
    }
    default: {
      return sectionFormat;
    }
  }
};
var createSection = ({
  utils,
  timezone,
  date,
  shouldRespectLeadingZeros,
  localeText,
  localizedDigits,
  now,
  token,
  startSeparator
}) => {
  if (token === "") {
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  }
  const sectionConfig = getDateSectionConfigFromFormatToken(utils, token);
  const hasLeadingZerosInFormat = doesSectionFormatHaveLeadingZeros(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
  const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === "digit";
  const isValidDate = date != null && utils.isValid(date);
  let sectionValue = isValidDate ? utils.formatByString(date, token) : "";
  let maxLength = null;
  if (hasLeadingZerosInInput) {
    if (hasLeadingZerosInFormat) {
      maxLength = sectionValue === "" ? utils.formatByString(now, token).length : sectionValue.length;
    } else {
      if (sectionConfig.maxLength == null) {
        throw new Error(`MUI X: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
      }
      maxLength = sectionConfig.maxLength;
      if (isValidDate) {
        sectionValue = applyLocalizedDigits(cleanLeadingZeros(removeLocalizedDigits(sectionValue, localizedDigits), maxLength), localizedDigits);
      }
    }
  }
  return _extends({}, sectionConfig, {
    format: token,
    maxLength,
    value: sectionValue,
    placeholder: getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
    hasLeadingZerosInFormat,
    hasLeadingZerosInInput,
    startSeparator,
    endSeparator: "",
    modified: false
  });
};
var buildSections = (params) => {
  const {
    utils,
    expandedFormat,
    escapedParts
  } = params;
  const now = utils.date(void 0);
  const sections = [];
  let startSeparator = "";
  const validTokens = Object.keys(utils.formatTokenMap).sort((a, b) => b.length - a.length);
  const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
  const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join("|")})*$`);
  const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join("|")})`);
  const getEscapedPartOfCurrentChar = (i2) => escapedParts.find((escapeIndex) => escapeIndex.start <= i2 && escapeIndex.end >= i2);
  let i = 0;
  while (i < expandedFormat.length) {
    const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
    const isEscapedChar = escapedPartOfCurrentChar != null;
    const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
    if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
      let word = firstWordInFormat;
      while (word.length > 0) {
        const firstWord = regExpFirstTokenInWord.exec(word)[1];
        word = word.slice(firstWord.length);
        sections.push(createSection(_extends({}, params, {
          now,
          token: firstWord,
          startSeparator
        })));
        startSeparator = "";
      }
      i += firstWordInFormat.length;
    } else {
      const char = expandedFormat[i];
      const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
      if (!isEscapeBoundary) {
        if (sections.length === 0) {
          startSeparator += char;
        } else {
          sections[sections.length - 1].endSeparator += char;
        }
      }
      i += 1;
    }
  }
  if (sections.length === 0 && startSeparator.length > 0) {
    sections.push({
      type: "empty",
      contentType: "letter",
      maxLength: null,
      format: "",
      value: "",
      placeholder: "",
      hasLeadingZerosInFormat: false,
      hasLeadingZerosInInput: false,
      startSeparator,
      endSeparator: "",
      modified: false
    });
  }
  return sections;
};
var postProcessSections = ({
  isRtl,
  formatDensity,
  sections
}) => {
  return sections.map((section) => {
    const cleanSeparator = (separator) => {
      let cleanedSeparator = separator;
      if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(" ")) {
        cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
      }
      if (formatDensity === "spacious" && ["/", ".", "-"].includes(cleanedSeparator)) {
        cleanedSeparator = ` ${cleanedSeparator} `;
      }
      return cleanedSeparator;
    };
    section.startSeparator = cleanSeparator(section.startSeparator);
    section.endSeparator = cleanSeparator(section.endSeparator);
    return section;
  });
};
var buildSectionsFromFormat = (params) => {
  let expandedFormat = expandFormat(params);
  if (params.isRtl && params.enableAccessibleFieldDOMStructure) {
    expandedFormat = expandedFormat.split(" ").reverse().join(" ");
  }
  const escapedParts = getEscapedPartsFromFormat(_extends({}, params, {
    expandedFormat
  }));
  const sections = buildSections(_extends({}, params, {
    expandedFormat,
    escapedParts
  }));
  return postProcessSections(_extends({}, params, {
    sections
  }));
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/useField/useFieldState.js
var useFieldState = (params) => {
  const utils = useUtils();
  const localeText = useLocaleText();
  const adapter = useLocalizationContext();
  const isRtl = useRtl();
  const {
    valueManager,
    fieldValueManager,
    valueType,
    validator,
    internalProps,
    internalProps: {
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      onChange,
      format: format4,
      formatDensity = "dense",
      selectedSections: selectedSectionsProp,
      onSelectedSectionsChange,
      shouldRespectLeadingZeros = false,
      timezone: timezoneProp,
      enableAccessibleFieldDOMStructure = false
    }
  } = params;
  const {
    timezone,
    value: valueFromTheOutside,
    handleValueChange
  } = useValueWithTimezone({
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange,
    valueManager
  });
  const localizedDigits = React52.useMemo(() => getLocalizedDigits(utils), [utils]);
  const sectionsValueBoundaries = React52.useMemo(() => getSectionsBoundaries(utils, localizedDigits, timezone), [utils, localizedDigits, timezone]);
  const getSectionsFromValue = React52.useCallback((value, fallbackSections = null) => fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, (date) => buildSectionsFromFormat({
    utils,
    timezone,
    localeText,
    localizedDigits,
    format: format4,
    date,
    formatDensity,
    shouldRespectLeadingZeros,
    enableAccessibleFieldDOMStructure,
    isRtl
  })), [fieldValueManager, format4, localeText, localizedDigits, isRtl, shouldRespectLeadingZeros, utils, formatDensity, timezone, enableAccessibleFieldDOMStructure]);
  const [state, setState] = React52.useState(() => {
    const sections = getSectionsFromValue(valueFromTheOutside);
    validateSections(sections, valueType);
    const stateWithoutReferenceDate = {
      sections,
      value: valueFromTheOutside,
      referenceValue: valueManager.emptyValue,
      tempValueStrAndroid: null
    };
    const granularity = getSectionTypeGranularity(sections);
    const referenceValue = valueManager.getInitialReferenceValue({
      referenceDate: referenceDateProp,
      value: valueFromTheOutside,
      utils,
      props: internalProps,
      granularity,
      timezone
    });
    return _extends({}, stateWithoutReferenceDate, {
      referenceValue
    });
  });
  const [selectedSections, innerSetSelectedSections] = useControlled({
    controlled: selectedSectionsProp,
    default: null,
    name: "useField",
    state: "selectedSections"
  });
  const setSelectedSections = (newSelectedSections) => {
    innerSetSelectedSections(newSelectedSections);
    onSelectedSectionsChange?.(newSelectedSections);
  };
  const parsedSelectedSections = React52.useMemo(() => parseSelectedSections(selectedSections, state.sections), [selectedSections, state.sections]);
  const activeSectionIndex = parsedSelectedSections === "all" ? 0 : parsedSelectedSections;
  const publishValue = ({
    value,
    referenceValue,
    sections
  }) => {
    setState((prevState) => _extends({}, prevState, {
      sections,
      value,
      referenceValue,
      tempValueStrAndroid: null
    }));
    if (valueManager.areValuesEqual(utils, state.value, value)) {
      return;
    }
    const context = {
      validationError: validator({
        adapter,
        value,
        props: _extends({}, internalProps, {
          value,
          timezone
        })
      })
    };
    handleValueChange(value, context);
  };
  const setSectionValue = (sectionIndex, newSectionValue) => {
    const newSections = [...state.sections];
    newSections[sectionIndex] = _extends({}, newSections[sectionIndex], {
      value: newSectionValue,
      modified: true
    });
    return newSections;
  };
  const clearValue = () => {
    publishValue({
      value: valueManager.emptyValue,
      referenceValue: state.referenceValue,
      sections: getSectionsFromValue(valueManager.emptyValue)
    });
  };
  const clearActiveSection = () => {
    if (activeSectionIndex == null) {
      return;
    }
    const activeSection = state.sections[activeSectionIndex];
    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
    const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section) => section.value !== "").length;
    const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === "" ? 0 : 1);
    const newSections = setSectionValue(activeSectionIndex, "");
    const newActiveDate = hasNoOtherNonEmptySections ? null : utils.getInvalidDate();
    const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
    publishValue(_extends({}, newValues, {
      sections: newSections
    }));
  };
  const updateValueFromValueStr = (valueStr) => {
    const parseDateStr = (dateStr, referenceDate) => {
      const date = utils.parse(dateStr, format4);
      if (date == null || !utils.isValid(date)) {
        return null;
      }
      const sections = buildSectionsFromFormat({
        utils,
        timezone,
        localeText,
        localizedDigits,
        format: format4,
        date,
        formatDensity,
        shouldRespectLeadingZeros,
        enableAccessibleFieldDOMStructure,
        isRtl
      });
      return mergeDateIntoReferenceDate(utils, timezone, date, sections, referenceDate, false);
    };
    const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
    const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
    publishValue({
      value: newValue,
      referenceValue: newReferenceValue,
      sections: getSectionsFromValue(newValue, state.sections)
    });
  };
  const updateSectionValue = ({
    activeSection,
    newSectionValue,
    shouldGoToNextSection
  }) => {
    if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) {
      setSelectedSections(activeSectionIndex + 1);
    }
    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
    const newSections = setSectionValue(activeSectionIndex, newSectionValue);
    const newActiveDateSections = activeDateManager.getSections(newSections);
    const newActiveDate = getDateFromDateSections(utils, newActiveDateSections, localizedDigits);
    let values3;
    let shouldPublish;
    if (newActiveDate != null && utils.isValid(newActiveDate)) {
      const mergedDate = mergeDateIntoReferenceDate(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
      values3 = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
      shouldPublish = true;
    } else {
      values3 = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
      shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
    }
    if (shouldPublish) {
      return publishValue(_extends({}, values3, {
        sections: newSections
      }));
    }
    return setState((prevState) => _extends({}, prevState, values3, {
      sections: newSections,
      tempValueStrAndroid: null
    }));
  };
  const setTempAndroidValueStr = (tempValueStrAndroid) => setState((prev) => _extends({}, prev, {
    tempValueStrAndroid
  }));
  React52.useEffect(() => {
    const sections = getSectionsFromValue(state.value);
    validateSections(sections, valueType);
    setState((prevState) => _extends({}, prevState, {
      sections
    }));
  }, [format4, utils.locale, isRtl]);
  React52.useEffect(() => {
    let shouldUpdate;
    if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) {
      shouldUpdate = true;
    } else {
      shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
    }
    if (shouldUpdate) {
      setState((prevState) => _extends({}, prevState, {
        value: valueFromTheOutside,
        referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
        sections: getSectionsFromValue(valueFromTheOutside)
      }));
    }
  }, [valueFromTheOutside]);
  return {
    state,
    activeSectionIndex,
    parsedSelectedSections,
    setSelectedSections,
    clearValue,
    clearActiveSection,
    updateSectionValue,
    updateValueFromValueStr,
    setTempAndroidValueStr,
    getSectionsFromValue,
    sectionsValueBoundaries,
    localizedDigits,
    timezone
  };
};
var QUERY_LIFE_DURATION_MS = 5e3;
var isQueryResponseWithoutValue = (response) => response.saveQuery != null;
var useFieldCharacterEditing = ({
  sections,
  updateSectionValue,
  sectionsValueBoundaries,
  localizedDigits,
  setTempAndroidValueStr,
  timezone
}) => {
  const utils = useUtils();
  const [query, setQuery] = React52.useState(null);
  const resetQuery = useEventCallback_default(() => setQuery(null));
  React52.useEffect(() => {
    if (query != null && sections[query.sectionIndex]?.type !== query.sectionType) {
      resetQuery();
    }
  }, [sections, query, resetQuery]);
  React52.useEffect(() => {
    if (query != null) {
      const timeout2 = setTimeout(() => resetQuery(), QUERY_LIFE_DURATION_MS);
      return () => {
        clearTimeout(timeout2);
      };
    }
    return () => {
    };
  }, [query, resetQuery]);
  const applyQuery = ({
    keyPressed,
    sectionIndex
  }, getFirstSectionValueMatchingWithQuery, isValidQueryValue) => {
    const cleanKeyPressed = keyPressed.toLowerCase();
    const activeSection = sections[sectionIndex];
    if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
      const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
      const queryResponse2 = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
      if (!isQueryResponseWithoutValue(queryResponse2)) {
        setQuery({
          sectionIndex,
          value: concatenatedQueryValue,
          sectionType: activeSection.type
        });
        return queryResponse2;
      }
    }
    const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
    if (isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
      resetQuery();
      return null;
    }
    setQuery({
      sectionIndex,
      value: cleanKeyPressed,
      sectionType: activeSection.type
    });
    if (isQueryResponseWithoutValue(queryResponse)) {
      return null;
    }
    return queryResponse;
  };
  const applyLetterEditing = (params) => {
    const findMatchingOptions = (format4, options, queryValue) => {
      const matchingValues = options.filter((option) => option.toLowerCase().startsWith(queryValue));
      if (matchingValues.length === 0) {
        return {
          saveQuery: false
        };
      }
      return {
        sectionValue: matchingValues[0],
        shouldGoToNextSection: matchingValues.length === 1
      };
    };
    const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue) => {
      const getOptions = (format4) => getLetterEditingOptions(utils, timezone, activeSection.type, format4);
      if (activeSection.contentType === "letter") {
        return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
      }
      if (fallbackFormat && formatFallbackValue != null && getDateSectionConfigFromFormatToken(utils, fallbackFormat).contentType === "letter") {
        const fallbackOptions = getOptions(fallbackFormat);
        const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
        if (isQueryResponseWithoutValue(response)) {
          return {
            saveQuery: false
          };
        }
        return _extends({}, response, {
          sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
        });
      }
      return {
        saveQuery: false
      };
    };
    const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection) => {
      switch (activeSection.type) {
        case "month": {
          const formatFallbackValue = (fallbackValue) => changeSectionValueFormat(utils, fallbackValue, utils.formats.month, activeSection.format);
          return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
        }
        case "weekDay": {
          const formatFallbackValue = (fallbackValue, fallbackOptions) => fallbackOptions.indexOf(fallbackValue).toString();
          return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
        }
        case "meridiem": {
          return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
        }
        default: {
          return {
            saveQuery: false
          };
        }
      }
    };
    return applyQuery(params, getFirstSectionValueMatchingWithQuery);
  };
  const applyNumericEditing = (params) => {
    const getNewSectionValue = (queryValue, section) => {
      const cleanQueryValue = removeLocalizedDigits(queryValue, localizedDigits);
      const queryValueNumber = Number(cleanQueryValue);
      const sectionBoundaries = sectionsValueBoundaries[section.type]({
        currentDate: null,
        format: section.format,
        contentType: section.contentType
      });
      if (queryValueNumber > sectionBoundaries.maximum) {
        return {
          saveQuery: false
        };
      }
      if (queryValueNumber < sectionBoundaries.minimum) {
        return {
          saveQuery: true
        };
      }
      const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
      const newSectionValue = cleanDigitSectionValue(utils, queryValueNumber, sectionBoundaries, localizedDigits, section);
      return {
        sectionValue: newSectionValue,
        shouldGoToNextSection
      };
    };
    const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection) => {
      if (activeSection.contentType === "digit" || activeSection.contentType === "digit-with-letter") {
        return getNewSectionValue(queryValue, activeSection);
      }
      if (activeSection.type === "month") {
        const hasLeadingZerosInFormat = doesSectionFormatHaveLeadingZeros(utils, timezone, "digit", "month", "MM");
        const response = getNewSectionValue(queryValue, {
          type: activeSection.type,
          format: "MM",
          hasLeadingZerosInFormat,
          hasLeadingZerosInInput: true,
          contentType: "digit",
          maxLength: 2
        });
        if (isQueryResponseWithoutValue(response)) {
          return response;
        }
        const formattedValue = changeSectionValueFormat(utils, response.sectionValue, "MM", activeSection.format);
        return _extends({}, response, {
          sectionValue: formattedValue
        });
      }
      if (activeSection.type === "weekDay") {
        const response = getNewSectionValue(queryValue, activeSection);
        if (isQueryResponseWithoutValue(response)) {
          return response;
        }
        const formattedValue = getDaysInWeekStr(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
        return _extends({}, response, {
          sectionValue: formattedValue
        });
      }
      return {
        saveQuery: false
      };
    };
    return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue) => isStringNumber(queryValue, localizedDigits));
  };
  const applyCharacterEditing = useEventCallback_default((params) => {
    const activeSection = sections[params.sectionIndex];
    const isNumericEditing = isStringNumber(params.keyPressed, localizedDigits);
    const response = isNumericEditing ? applyNumericEditing(_extends({}, params, {
      keyPressed: applyLocalizedDigits(params.keyPressed, localizedDigits)
    })) : applyLetterEditing(params);
    if (response == null) {
      setTempAndroidValueStr(null);
      return;
    }
    updateSectionValue({
      activeSection,
      newSectionValue: response.sectionValue,
      shouldGoToNextSection: response.shouldGoToNextSection
    });
  });
  return {
    applyCharacterEditing,
    resetCharacterQuery: resetQuery
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/utils.js
function arrayIncludes(array2, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every((item) => array2.indexOf(item) !== -1);
  }
  return array2.indexOf(itemOrItems) !== -1;
}
var onSpaceOrEnter = (innerFn, externalEvent) => (event) => {
  if (event.key === "Enter" || event.key === " ") {
    innerFn(event);
    event.preventDefault();
    event.stopPropagation();
  }
  if (externalEvent) {
    externalEvent(event);
  }
};
var getActiveElement = (root = document) => {
  const activeEl = root.activeElement;
  if (!activeEl) {
    return null;
  }
  if (activeEl.shadowRoot) {
    return getActiveElement(activeEl.shadowRoot);
  }
  return activeEl;
};
var DEFAULT_DESKTOP_MODE_MEDIA_QUERY = "@media (pointer: fine)";

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/useField/useFieldV7TextField.js
var useFieldV7TextField = (params) => {
  const {
    internalProps: {
      disabled,
      readOnly = false
    },
    forwardedProps: {
      sectionListRef: inSectionListRef,
      onBlur,
      onClick,
      onFocus,
      onInput,
      onPaste,
      focused: focusedProp,
      autoFocus = false
    },
    fieldValueManager,
    applyCharacterEditing,
    resetCharacterQuery,
    setSelectedSections,
    parsedSelectedSections,
    state,
    clearActiveSection,
    clearValue,
    updateSectionValue,
    updateValueFromValueStr,
    sectionOrder,
    areAllSectionsEmpty,
    sectionsValueBoundaries
  } = params;
  const sectionListRef = React52.useRef(null);
  const handleSectionListRef = useForkRef(inSectionListRef, sectionListRef);
  const localeText = useLocaleText();
  const utils = useUtils();
  const id = useId();
  const [focused, setFocused] = React52.useState(false);
  const interactions = React52.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!sectionListRef.current) {
        return;
      }
      const selection = document.getSelection();
      if (!selection) {
        return;
      }
      if (parsedSelectedSections == null) {
        if (selection.rangeCount > 0 && sectionListRef.current.getRoot().contains(selection.getRangeAt(0).startContainer)) {
          selection.removeAllRanges();
        }
        if (focused) {
          sectionListRef.current.getRoot().blur();
        }
        return;
      }
      if (!sectionListRef.current.getRoot().contains(getActiveElement(document))) {
        return;
      }
      const range = new window.Range();
      let target;
      if (parsedSelectedSections === "all") {
        target = sectionListRef.current.getRoot();
      } else {
        const section = state.sections[parsedSelectedSections];
        if (section.type === "empty") {
          target = sectionListRef.current.getSectionContainer(parsedSelectedSections);
        } else {
          target = sectionListRef.current.getSectionContent(parsedSelectedSections);
        }
      }
      range.selectNodeContents(target);
      target.focus();
      selection.removeAllRanges();
      selection.addRange(range);
    },
    getActiveSectionIndexFromDOM: () => {
      const activeElement = getActiveElement(document);
      if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) {
        return null;
      }
      return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
    },
    focusField: (newSelectedSections = 0) => {
      if (!sectionListRef.current) {
        return;
      }
      const newParsedSelectedSections = parseSelectedSections(newSelectedSections, state.sections);
      setFocused(true);
      sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
    },
    setSelectedSections: (newSelectedSections) => {
      if (!sectionListRef.current) {
        return;
      }
      const newParsedSelectedSections = parseSelectedSections(newSelectedSections, state.sections);
      const newActiveSectionIndex = newParsedSelectedSections === "all" ? 0 : newParsedSelectedSections;
      setFocused(newActiveSectionIndex !== null);
      setSelectedSections(newSelectedSections);
    },
    isFieldFocused: () => {
      const activeElement = getActiveElement(document);
      return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
    }
  }), [parsedSelectedSections, setSelectedSections, state.sections, focused]);
  const revertDOMSectionChange = useEventCallback_default((sectionIndex) => {
    if (!sectionListRef.current) {
      return;
    }
    const section = state.sections[sectionIndex];
    sectionListRef.current.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
    interactions.syncSelectionToDOM();
  });
  const handleContainerClick = useEventCallback_default((event, ...args) => {
    if (event.isDefaultPrevented() || !sectionListRef.current) {
      return;
    }
    setFocused(true);
    onClick?.(event, ...args);
    if (parsedSelectedSections === "all") {
      setTimeout(() => {
        const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
        if (cursorPosition === 0) {
          setSelectedSections(sectionOrder.startIndex);
          return;
        }
        let sectionIndex = 0;
        let cursorOnStartOfSection = 0;
        while (cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length) {
          const section = state.sections[sectionIndex];
          sectionIndex += 1;
          cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
        }
        setSelectedSections(sectionIndex - 1);
      });
    } else if (!focused) {
      setFocused(true);
      setSelectedSections(sectionOrder.startIndex);
    } else {
      const hasClickedOnASection = sectionListRef.current.getRoot().contains(event.target);
      if (!hasClickedOnASection) {
        setSelectedSections(sectionOrder.startIndex);
      }
    }
  });
  const handleContainerInput = useEventCallback_default((event) => {
    onInput?.(event);
    if (!sectionListRef.current || parsedSelectedSections !== "all") {
      return;
    }
    const target = event.target;
    const keyPressed = target.textContent ?? "";
    sectionListRef.current.getRoot().innerHTML = state.sections.map((section) => `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join("");
    interactions.syncSelectionToDOM();
    if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
      resetCharacterQuery();
      clearValue();
      setSelectedSections("all");
    } else if (keyPressed.length > 1) {
      updateValueFromValueStr(keyPressed);
    } else {
      applyCharacterEditing({
        keyPressed,
        sectionIndex: 0
      });
    }
  });
  const handleContainerPaste = useEventCallback_default((event) => {
    onPaste?.(event);
    if (readOnly || parsedSelectedSections !== "all") {
      event.preventDefault();
      return;
    }
    const pastedValue = event.clipboardData.getData("text");
    event.preventDefault();
    resetCharacterQuery();
    updateValueFromValueStr(pastedValue);
  });
  const handleContainerFocus = useEventCallback_default((...args) => {
    onFocus?.(...args);
    if (focused || !sectionListRef.current) {
      return;
    }
    setFocused(true);
    const isFocusInsideASection = sectionListRef.current.getSectionIndexFromDOMElement(getActiveElement(document)) != null;
    if (!isFocusInsideASection) {
      setSelectedSections(sectionOrder.startIndex);
    }
  });
  const handleContainerBlur = useEventCallback_default((...args) => {
    onBlur?.(...args);
    setTimeout(() => {
      if (!sectionListRef.current) {
        return;
      }
      const activeElement = getActiveElement(document);
      const shouldBlur = !sectionListRef.current.getRoot().contains(activeElement);
      if (shouldBlur) {
        setFocused(false);
        setSelectedSections(null);
      }
    });
  });
  const getInputContainerClickHandler = useEventCallback_default((sectionIndex) => (event) => {
    if (event.isDefaultPrevented() || readOnly) {
      return;
    }
    setSelectedSections(sectionIndex);
  });
  const handleInputContentMouseUp = useEventCallback_default((event) => {
    event.preventDefault();
  });
  const getInputContentFocusHandler = useEventCallback_default((sectionIndex) => () => {
    if (readOnly) {
      return;
    }
    setSelectedSections(sectionIndex);
  });
  const handleInputContentPaste = useEventCallback_default((event) => {
    event.preventDefault();
    if (readOnly || typeof parsedSelectedSections !== "number") {
      return;
    }
    const activeSection = state.sections[parsedSelectedSections];
    const pastedValue = event.clipboardData.getData("text");
    const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
    const digitsOnly = /^[0-9]+$/.test(pastedValue);
    const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
    const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
    if (isValidPastedValue) {
      resetCharacterQuery();
      updateSectionValue({
        activeSection,
        newSectionValue: pastedValue,
        shouldGoToNextSection: true
      });
    } else if (!lettersOnly && !digitsOnly) {
      resetCharacterQuery();
      updateValueFromValueStr(pastedValue);
    }
  });
  const handleInputContentDragOver = useEventCallback_default((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "none";
  });
  const handleInputContentInput = useEventCallback_default((event) => {
    if (!sectionListRef.current) {
      return;
    }
    const target = event.target;
    const keyPressed = target.textContent ?? "";
    const sectionIndex = sectionListRef.current.getSectionIndexFromDOMElement(target);
    const section = state.sections[sectionIndex];
    if (readOnly || !sectionListRef.current) {
      revertDOMSectionChange(sectionIndex);
      return;
    }
    if (keyPressed.length === 0) {
      if (section.value === "") {
        revertDOMSectionChange(sectionIndex);
        return;
      }
      const inputType = event.nativeEvent.inputType;
      if (inputType === "insertParagraph" || inputType === "insertLineBreak") {
        revertDOMSectionChange(sectionIndex);
        return;
      }
      resetCharacterQuery();
      clearActiveSection();
      return;
    }
    applyCharacterEditing({
      keyPressed,
      sectionIndex
    });
    revertDOMSectionChange(sectionIndex);
  });
  useEnhancedEffect_default(() => {
    if (!focused || !sectionListRef.current) {
      return;
    }
    if (parsedSelectedSections === "all") {
      sectionListRef.current.getRoot().focus();
    } else if (typeof parsedSelectedSections === "number") {
      const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
      if (domElement) {
        domElement.focus();
      }
    }
  }, [parsedSelectedSections, focused]);
  const sectionBoundaries = React52.useMemo(() => {
    return state.sections.reduce((acc, next) => {
      acc[next.type] = sectionsValueBoundaries[next.type]({
        currentDate: null,
        contentType: next.contentType,
        format: next.format
      });
      return acc;
    }, {});
  }, [sectionsValueBoundaries, state.sections]);
  const isContainerEditable = parsedSelectedSections === "all";
  const elements = React52.useMemo(() => {
    return state.sections.map((section, index) => {
      const isEditable = !isContainerEditable && !disabled && !readOnly;
      return {
        container: {
          "data-sectionindex": index,
          onClick: getInputContainerClickHandler(index)
        },
        content: {
          tabIndex: isContainerEditable || index > 0 ? -1 : 0,
          contentEditable: !isContainerEditable && !disabled && !readOnly,
          role: "spinbutton",
          id: `${id}-${section.type}`,
          "aria-labelledby": `${id}-${section.type}`,
          "aria-readonly": readOnly,
          "aria-valuenow": getSectionValueNow(section, utils),
          "aria-valuemin": sectionBoundaries[section.type].minimum,
          "aria-valuemax": sectionBoundaries[section.type].maximum,
          "aria-valuetext": section.value ? getSectionValueText(section, utils) : localeText.empty,
          "aria-label": localeText[section.type],
          "aria-disabled": disabled,
          spellCheck: isEditable ? false : void 0,
          autoCapitalize: isEditable ? "off" : void 0,
          autoCorrect: isEditable ? "off" : void 0,
          [parseInt(React52.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: isEditable ? "next" : void 0,
          children: section.value || section.placeholder,
          onInput: handleInputContentInput,
          onPaste: handleInputContentPaste,
          onFocus: getInputContentFocusHandler(index),
          onDragOver: handleInputContentDragOver,
          onMouseUp: handleInputContentMouseUp,
          inputMode: section.contentType === "letter" ? "text" : "numeric"
        },
        before: {
          children: section.startSeparator
        },
        after: {
          children: section.endSeparator
        }
      };
    });
  }, [state.sections, getInputContentFocusHandler, handleInputContentPaste, handleInputContentDragOver, handleInputContentInput, getInputContainerClickHandler, handleInputContentMouseUp, disabled, readOnly, isContainerEditable, localeText, utils, sectionBoundaries, id]);
  const handleValueStrChange = useEventCallback_default((event) => {
    updateValueFromValueStr(event.target.value);
  });
  const valueStr = React52.useMemo(() => areAllSectionsEmpty ? "" : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [areAllSectionsEmpty, state.sections, fieldValueManager]);
  React52.useEffect(() => {
    if (sectionListRef.current == null) {
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:", "", "<DatePicker slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join("\n"));
    }
    if (autoFocus && sectionListRef.current) {
      sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }
  }, []);
  return {
    interactions,
    returnedValue: {
      // Forwarded
      autoFocus,
      readOnly,
      focused: focusedProp ?? focused,
      sectionListRef: handleSectionListRef,
      onBlur: handleContainerBlur,
      onClick: handleContainerClick,
      onFocus: handleContainerFocus,
      onInput: handleContainerInput,
      onPaste: handleContainerPaste,
      // Additional
      enableAccessibleFieldDOMStructure: true,
      elements,
      // TODO v7: Try to set to undefined when there is a section selected.
      tabIndex: parsedSelectedSections === 0 ? -1 : 0,
      contentEditable: isContainerEditable,
      value: valueStr,
      onChange: handleValueStrChange,
      areAllSectionsEmpty
    }
  };
};
var cleanString = (dirtyString) => dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, "");
var addPositionPropertiesToSections = (sections, localizedDigits, isRtl) => {
  let position = 0;
  let positionInInput = isRtl ? 1 : 0;
  const newSections = [];
  for (let i = 0; i < sections.length; i += 1) {
    const section = sections[i];
    const renderedValue = getSectionVisibleValue(section, isRtl ? "input-rtl" : "input-ltr", localizedDigits);
    const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
    const sectionLength = cleanString(sectionStr).length;
    const sectionLengthInInput = sectionStr.length;
    const cleanedValue = cleanString(renderedValue);
    const startInInput = positionInInput + (cleanedValue === "" ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
    const endInInput = startInInput + cleanedValue.length;
    newSections.push(_extends({}, section, {
      start: position,
      end: position + sectionLength,
      startInInput,
      endInInput
    }));
    position += sectionLength;
    positionInInput += sectionLengthInInput;
  }
  return newSections;
};
var useFieldV6TextField = (params) => {
  const isRtl = useRtl();
  const focusTimeoutRef = React52.useRef();
  const {
    forwardedProps: {
      onFocus,
      onClick,
      onPaste,
      onBlur,
      inputRef: inputRefProp,
      placeholder: inPlaceholder
    },
    internalProps: {
      readOnly = false
    },
    parsedSelectedSections,
    activeSectionIndex,
    state,
    fieldValueManager,
    valueManager,
    applyCharacterEditing,
    resetCharacterQuery,
    updateSectionValue,
    updateValueFromValueStr,
    clearActiveSection,
    clearValue,
    setTempAndroidValueStr,
    setSelectedSections,
    getSectionsFromValue,
    areAllSectionsEmpty,
    localizedDigits
  } = params;
  const inputRef = React52.useRef(null);
  const handleRef = useForkRef(inputRefProp, inputRef);
  const sections = React52.useMemo(() => addPositionPropertiesToSections(state.sections, localizedDigits, isRtl), [state.sections, localizedDigits, isRtl]);
  const interactions = React52.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!inputRef.current) {
        return;
      }
      if (parsedSelectedSections == null) {
        if (inputRef.current.scrollLeft) {
          inputRef.current.scrollLeft = 0;
        }
        return;
      }
      if (inputRef.current !== getActiveElement(document)) {
        return;
      }
      const currentScrollTop = inputRef.current.scrollTop;
      if (parsedSelectedSections === "all") {
        inputRef.current.select();
      } else {
        const selectedSection = sections[parsedSelectedSections];
        const selectionStart = selectedSection.type === "empty" ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
        const selectionEnd = selectedSection.type === "empty" ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
        if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
          if (inputRef.current === getActiveElement(document)) {
            inputRef.current.setSelectionRange(selectionStart, selectionEnd);
          }
        }
      }
      inputRef.current.scrollTop = currentScrollTop;
    },
    getActiveSectionIndexFromDOM: () => {
      const browserStartIndex = inputRef.current.selectionStart ?? 0;
      const browserEndIndex = inputRef.current.selectionEnd ?? 0;
      const isInputReadOnly = !!inputRef.current?.readOnly;
      if (browserStartIndex === 0 && browserEndIndex === 0 || isInputReadOnly) {
        return null;
      }
      const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 : sections.findIndex((section) => section.startInInput - section.startSeparator.length > browserStartIndex);
      return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
    },
    focusField: (newSelectedSection = 0) => {
      inputRef.current?.focus();
      setSelectedSections(newSelectedSection);
    },
    setSelectedSections: (newSelectedSections) => setSelectedSections(newSelectedSections),
    isFieldFocused: () => inputRef.current === getActiveElement(document)
  }), [inputRef, parsedSelectedSections, sections, setSelectedSections]);
  const syncSelectionFromDOM = () => {
    if (readOnly) {
      setSelectedSections(null);
      return;
    }
    const browserStartIndex = inputRef.current.selectionStart ?? 0;
    let nextSectionIndex;
    if (browserStartIndex <= sections[0].startInInput) {
      nextSectionIndex = 1;
    } else if (browserStartIndex >= sections[sections.length - 1].endInInput) {
      nextSectionIndex = 1;
    } else {
      nextSectionIndex = sections.findIndex((section) => section.startInInput - section.startSeparator.length > browserStartIndex);
    }
    const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
    setSelectedSections(sectionIndex);
  };
  const handleInputFocus = useEventCallback_default((...args) => {
    onFocus?.(...args);
    const input = inputRef.current;
    clearTimeout(focusTimeoutRef.current);
    focusTimeoutRef.current = setTimeout(() => {
      if (!input || input !== inputRef.current) {
        return;
      }
      if (activeSectionIndex != null || readOnly) {
        return;
      }
      if (
        // avoid selecting all sections when focusing empty field without value
        input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length
      ) {
        setSelectedSections("all");
      } else {
        syncSelectionFromDOM();
      }
    });
  });
  const handleInputClick = useEventCallback_default((event, ...args) => {
    if (event.isDefaultPrevented()) {
      return;
    }
    onClick?.(event, ...args);
    syncSelectionFromDOM();
  });
  const handleInputPaste = useEventCallback_default((event) => {
    onPaste?.(event);
    event.preventDefault();
    if (readOnly) {
      return;
    }
    const pastedValue = event.clipboardData.getData("text");
    if (typeof parsedSelectedSections === "number") {
      const activeSection = state.sections[parsedSelectedSections];
      const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
      const digitsOnly = /^[0-9]+$/.test(pastedValue);
      const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
      const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
      if (isValidPastedValue) {
        resetCharacterQuery();
        updateSectionValue({
          activeSection,
          newSectionValue: pastedValue,
          shouldGoToNextSection: true
        });
        return;
      }
      if (lettersOnly || digitsOnly) {
        return;
      }
    }
    resetCharacterQuery();
    updateValueFromValueStr(pastedValue);
  });
  const handleContainerBlur = useEventCallback_default((...args) => {
    onBlur?.(...args);
    setSelectedSections(null);
  });
  const handleInputChange = useEventCallback_default((event) => {
    if (readOnly) {
      return;
    }
    const targetValue = event.target.value;
    if (targetValue === "") {
      resetCharacterQuery();
      clearValue();
      return;
    }
    const eventData = event.nativeEvent.data;
    const shouldUseEventData = eventData && eventData.length > 1;
    const valueStr2 = shouldUseEventData ? eventData : targetValue;
    const cleanValueStr = cleanString(valueStr2);
    if (activeSectionIndex == null || shouldUseEventData) {
      updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
      return;
    }
    let keyPressed;
    if (parsedSelectedSections === "all" && cleanValueStr.length === 1) {
      keyPressed = cleanValueStr;
    } else {
      const prevValueStr = cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
      let startOfDiffIndex = -1;
      let endOfDiffIndex = -1;
      for (let i = 0; i < prevValueStr.length; i += 1) {
        if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) {
          startOfDiffIndex = i;
        }
        if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) {
          endOfDiffIndex = i;
        }
      }
      const activeSection = sections[activeSectionIndex];
      const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
      if (hasDiffOutsideOfActiveSection) {
        return;
      }
      const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - cleanString(activeSection.endSeparator || "").length;
      keyPressed = cleanValueStr.slice(activeSection.start + cleanString(activeSection.startSeparator || "").length, activeSectionEndRelativeToNewValue);
    }
    if (keyPressed.length === 0) {
      if (isAndroid()) {
        setTempAndroidValueStr(valueStr2);
      } else {
        resetCharacterQuery();
        clearActiveSection();
      }
      return;
    }
    applyCharacterEditing({
      keyPressed,
      sectionIndex: activeSectionIndex
    });
  });
  const placeholder = React52.useMemo(() => {
    if (inPlaceholder !== void 0) {
      return inPlaceholder;
    }
    return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
  }, [inPlaceholder, fieldValueManager, getSectionsFromValue, valueManager.emptyValue, localizedDigits, isRtl]);
  const valueStr = React52.useMemo(() => state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [state.sections, fieldValueManager, state.tempValueStrAndroid, localizedDigits, isRtl]);
  React52.useEffect(() => {
    if (inputRef.current && inputRef.current === getActiveElement(document)) {
      setSelectedSections("all");
    }
    return () => {
      clearTimeout(focusTimeoutRef.current);
    };
  }, []);
  const inputMode = React52.useMemo(() => {
    if (activeSectionIndex == null) {
      return "text";
    }
    if (state.sections[activeSectionIndex].contentType === "letter") {
      return "text";
    }
    return "numeric";
  }, [activeSectionIndex, state.sections]);
  const inputHasFocus = inputRef.current && inputRef.current === getActiveElement(document);
  const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
  return {
    interactions,
    returnedValue: {
      // Forwarded
      readOnly,
      onBlur: handleContainerBlur,
      onClick: handleInputClick,
      onFocus: handleInputFocus,
      onPaste: handleInputPaste,
      inputRef: handleRef,
      // Additional
      enableAccessibleFieldDOMStructure: false,
      placeholder,
      inputMode,
      autoComplete: "off",
      value: shouldShowPlaceholder ? "" : valueStr,
      onChange: handleInputChange
    }
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/useField/useField.js
var useField = (params) => {
  const utils = useUtils();
  const {
    internalProps,
    internalProps: {
      unstableFieldRef,
      minutesStep,
      enableAccessibleFieldDOMStructure = false,
      disabled = false,
      readOnly = false
    },
    forwardedProps: {
      onKeyDown,
      error,
      clearable,
      onClear
    },
    fieldValueManager,
    valueManager,
    validator
  } = params;
  const isRtl = useRtl();
  const stateResponse = useFieldState(params);
  const {
    state,
    activeSectionIndex,
    parsedSelectedSections,
    setSelectedSections,
    clearValue,
    clearActiveSection,
    updateSectionValue,
    setTempAndroidValueStr,
    sectionsValueBoundaries,
    localizedDigits,
    timezone
  } = stateResponse;
  const characterEditingResponse = useFieldCharacterEditing({
    sections: state.sections,
    updateSectionValue,
    sectionsValueBoundaries,
    localizedDigits,
    setTempAndroidValueStr,
    timezone
  });
  const {
    resetCharacterQuery
  } = characterEditingResponse;
  const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
  const useFieldTextField = enableAccessibleFieldDOMStructure ? useFieldV7TextField : useFieldV6TextField;
  const sectionOrder = React52.useMemo(() => getSectionOrder(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [state.sections, isRtl, enableAccessibleFieldDOMStructure]);
  const {
    returnedValue,
    interactions
  } = useFieldTextField(_extends({}, params, stateResponse, characterEditingResponse, {
    areAllSectionsEmpty,
    sectionOrder
  }));
  const handleContainerKeyDown = useEventCallback_default((event) => {
    onKeyDown?.(event);
    switch (true) {
      case ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "a" && !event.shiftKey && !event.altKey): {
        event.preventDefault();
        setSelectedSections("all");
        break;
      }
      case event.key === "ArrowRight": {
        event.preventDefault();
        if (parsedSelectedSections == null) {
          setSelectedSections(sectionOrder.startIndex);
        } else if (parsedSelectedSections === "all") {
          setSelectedSections(sectionOrder.endIndex);
        } else {
          const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
          if (nextSectionIndex !== null) {
            setSelectedSections(nextSectionIndex);
          }
        }
        break;
      }
      case event.key === "ArrowLeft": {
        event.preventDefault();
        if (parsedSelectedSections == null) {
          setSelectedSections(sectionOrder.endIndex);
        } else if (parsedSelectedSections === "all") {
          setSelectedSections(sectionOrder.startIndex);
        } else {
          const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
          if (nextSectionIndex !== null) {
            setSelectedSections(nextSectionIndex);
          }
        }
        break;
      }
      case event.key === "Delete": {
        event.preventDefault();
        if (readOnly) {
          break;
        }
        if (parsedSelectedSections == null || parsedSelectedSections === "all") {
          clearValue();
        } else {
          clearActiveSection();
        }
        resetCharacterQuery();
        break;
      }
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(event.key): {
        event.preventDefault();
        if (readOnly || activeSectionIndex == null) {
          break;
        }
        const activeSection = state.sections[activeSectionIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSectionValue = adjustSectionValue(utils, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, activeDateManager.date, {
          minutesStep
        });
        updateSectionValue({
          activeSection,
          newSectionValue,
          shouldGoToNextSection: false
        });
        break;
      }
    }
  });
  useEnhancedEffect_default(() => {
    interactions.syncSelectionToDOM();
  });
  const validationError = useValidation(_extends({}, internalProps, {
    value: state.value,
    timezone
  }), validator, valueManager.isSameError, valueManager.defaultErrorState);
  const inputError = React52.useMemo(() => {
    if (error !== void 0) {
      return error;
    }
    return valueManager.hasError(validationError);
  }, [valueManager, validationError, error]);
  React52.useEffect(() => {
    if (!inputError && activeSectionIndex == null) {
      resetCharacterQuery();
    }
  }, [state.referenceValue, activeSectionIndex, inputError]);
  React52.useEffect(() => {
    if (state.tempValueStrAndroid != null && activeSectionIndex != null) {
      resetCharacterQuery();
      clearActiveSection();
    }
  }, [state.sections]);
  React52.useImperativeHandle(unstableFieldRef, () => ({
    getSections: () => state.sections,
    getActiveSectionIndex: interactions.getActiveSectionIndexFromDOM,
    setSelectedSections: interactions.setSelectedSections,
    focusField: interactions.focusField,
    isFieldFocused: interactions.isFieldFocused
  }));
  const handleClearValue = useEventCallback_default((event, ...args) => {
    event.preventDefault();
    onClear?.(event, ...args);
    clearValue();
    if (!interactions.isFieldFocused()) {
      interactions.focusField(0);
    } else {
      setSelectedSections(sectionOrder.startIndex);
    }
  });
  const commonForwardedProps = {
    onKeyDown: handleContainerKeyDown,
    onClear: handleClearValue,
    error: inputError,
    clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
  };
  const commonAdditionalProps = {
    disabled,
    readOnly
  };
  return _extends({}, params.forwardedProps, commonForwardedProps, commonAdditionalProps, returnedValue);
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/validation/validateDate.js
var validateDate = ({
  props,
  value,
  adapter
}) => {
  if (value === null) {
    return null;
  }
  const {
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    disablePast,
    disableFuture,
    timezone
  } = props;
  const now = adapter.utils.date(void 0, timezone);
  const minDate = applyDefaultDate(adapter.utils, props.minDate, adapter.defaultDates.minDate);
  const maxDate = applyDefaultDate(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
  switch (true) {
    case !adapter.utils.isValid(value):
      return "invalidDate";
    case Boolean(shouldDisableDate && shouldDisableDate(value)):
      return "shouldDisableDate";
    case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
      return "shouldDisableMonth";
    case Boolean(shouldDisableYear && shouldDisableYear(value)):
      return "shouldDisableYear";
    case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
      return "disableFuture";
    case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
      return "disablePast";
    case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
      return "minDate";
    case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
      return "maxDate";
    default:
      return null;
  }
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/validation/extractValidationProps.js
var DATE_VALIDATION_PROP_NAMES = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"];
var TIME_VALIDATION_PROP_NAMES = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"];
var DATE_TIME_VALIDATION_PROP_NAMES = ["minDateTime", "maxDateTime"];
var VALIDATION_PROP_NAMES = [...DATE_VALIDATION_PROP_NAMES, ...TIME_VALIDATION_PROP_NAMES, ...DATE_TIME_VALIDATION_PROP_NAMES];
var extractValidationProps = (props) => VALIDATION_PROP_NAMES.reduce((extractedProps, propName) => {
  if (props.hasOwnProperty(propName)) {
    extractedProps[propName] = props[propName];
  }
  return extractedProps;
}, {});

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/fields.js
var SHARED_FIELD_INTERNAL_PROP_NAMES = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator"];
var splitFieldInternalAndForwardedProps = (props, valueType) => {
  const forwardedProps = _extends({}, props);
  const internalProps = {};
  const extractProp = (propName) => {
    if (forwardedProps.hasOwnProperty(propName)) {
      internalProps[propName] = forwardedProps[propName];
      delete forwardedProps[propName];
    }
  };
  SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
  if (valueType === "date") {
    DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
  } else if (valueType === "time") {
    TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
  } else if (valueType === "date-time") {
    DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
    TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
    DATE_TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
  }
  return {
    forwardedProps,
    internalProps
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/defaultizedFieldProps.js
var useDefaultizedDateField = (props) => {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  return _extends({}, props, {
    disablePast: props.disablePast ?? false,
    disableFuture: props.disableFuture ?? false,
    format: props.format ?? utils.formats.keyboardDate,
    minDate: applyDefaultDate(utils, props.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, props.maxDate, defaultDates.maxDate)
  });
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DateField/useDateField.js
var useDateField = (inProps) => {
  const props = useDefaultizedDateField(inProps);
  const {
    forwardedProps,
    internalProps
  } = splitFieldInternalAndForwardedProps(props, "date");
  return useField({
    forwardedProps,
    internalProps,
    valueManager: singleItemValueManager,
    fieldValueManager: singleItemFieldValueManager,
    validator: validateDate,
    valueType: "date"
  });
};
var _excluded7 = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"];
var _excluded23 = ["ownerState"];
var useClearableField = (props) => {
  const localeText = useLocaleText();
  const {
    clearable,
    onClear,
    InputProps: InputProps2,
    sx,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded7);
  const IconButton11 = slots?.clearButton ?? IconButton4;
  const _useSlotProps = useSlotProps({
    elementType: IconButton11,
    externalSlotProps: slotProps?.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: localeText.fieldClearLabel
    }
  }), iconButtonProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded23);
  const EndClearIcon = slots?.clearIcon ?? ClearIcon;
  const endClearIconProps = useSlotProps({
    elementType: EndClearIcon,
    externalSlotProps: slotProps?.clearIcon,
    ownerState: {}
  });
  return _extends({}, other, {
    InputProps: _extends({}, InputProps2, {
      endAdornment: /* @__PURE__ */ jsxs(React52.Fragment, {
        children: [clearable && /* @__PURE__ */ jsx(InputAdornment$1, {
          position: "end",
          sx: {
            marginRight: InputProps2?.endAdornment ? -1 : -1.5
          },
          children: /* @__PURE__ */ jsx(IconButton11, _extends({}, iconButtonProps, {
            onClick: onClear,
            children: /* @__PURE__ */ jsx(EndClearIcon, _extends({
              fontSize: "small"
            }, endClearIconProps))
          }))
        }), InputProps2?.endAdornment]
      })
    }),
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(sx) ? sx : [sx]]
  });
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/PickersTextField.js
var import_prop_types11 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/pickersTextFieldClasses.js
function getPickersTextFieldUtilityClass(slot) {
  return generateUtilityClass("MuiPickersTextField", slot);
}
generateUtilityClasses("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/PickersOutlinedInput/PickersOutlinedInput.js
var import_prop_types7 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/PickersInputBase/PickersInputBase.js
var import_prop_types6 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/PickersInputBase/pickersInputBaseClasses.js
function getPickersInputBaseUtilityClass(slot) {
  return generateUtilityClass("MuiPickersInputBase", slot);
}
var pickersInputBaseClasses = generateUtilityClasses("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input"]);

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersSectionList/PickersSectionList.js
var import_prop_types5 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersSectionList/pickersSectionListClasses.js
function getPickersSectionListUtilityClass(slot) {
  return generateUtilityClass("MuiPickersSectionList", slot);
}
var pickersSectionListClasses = generateUtilityClasses("MuiPickersSectionList", ["root", "section", "sectionContent"]);
var _excluded8 = ["slots", "slotProps", "elements", "sectionListRef"];
var PickersSectionListRoot = styled("div", {
  name: "MuiPickersSectionList",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
});
var PickersSectionListSection = styled("span", {
  name: "MuiPickersSectionList",
  slot: "Section",
  overridesResolver: (props, styles) => styles.section
})({});
var PickersSectionListSectionSeparator = styled("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator",
  overridesResolver: (props, styles) => styles.sectionSeparator
})({
  whiteSpace: "pre"
});
var PickersSectionListSectionContent = styled("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent",
  overridesResolver: (props, styles) => styles.sectionContent
})({
  outline: "none"
});
var useUtilityClasses3 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    section: ["section"],
    sectionContent: ["sectionContent"]
  };
  return composeClasses(slots, getPickersSectionListUtilityClass, classes);
};
function PickersSection(props) {
  const {
    slots,
    slotProps,
    element,
    classes
  } = props;
  const Section = slots?.section ?? PickersSectionListSection;
  const sectionProps = useSlotProps({
    elementType: Section,
    externalSlotProps: slotProps?.section,
    externalForwardedProps: element.container,
    className: classes.section,
    ownerState: {}
  });
  const SectionContent = slots?.sectionContent ?? PickersSectionListSectionContent;
  const sectionContentProps = useSlotProps({
    elementType: SectionContent,
    externalSlotProps: slotProps?.sectionContent,
    externalForwardedProps: element.content,
    additionalProps: {
      suppressContentEditableWarning: true
    },
    className: classes.sectionContent,
    ownerState: {}
  });
  const SectionSeparator = slots?.sectionSeparator ?? PickersSectionListSectionSeparator;
  const sectionSeparatorBeforeProps = useSlotProps({
    elementType: SectionSeparator,
    externalSlotProps: slotProps?.sectionSeparator,
    externalForwardedProps: element.before,
    ownerState: {
      position: "before"
    }
  });
  const sectionSeparatorAfterProps = useSlotProps({
    elementType: SectionSeparator,
    externalSlotProps: slotProps?.sectionSeparator,
    externalForwardedProps: element.after,
    ownerState: {
      position: "after"
    }
  });
  return /* @__PURE__ */ jsxs(Section, _extends({}, sectionProps, {
    children: [/* @__PURE__ */ jsx(SectionSeparator, _extends({}, sectionSeparatorBeforeProps)), /* @__PURE__ */ jsx(SectionContent, _extends({}, sectionContentProps)), /* @__PURE__ */ jsx(SectionSeparator, _extends({}, sectionSeparatorAfterProps))]
  }));
}
var PickersSectionList = /* @__PURE__ */ React52.forwardRef(function PickersSectionList2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersSectionList"
  });
  const {
    slots,
    slotProps,
    elements,
    sectionListRef
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded8);
  const classes = useUtilityClasses3(props);
  const rootRef = React52.useRef(null);
  const handleRootRef = useForkRef(ref, rootRef);
  const getRoot = (methodName) => {
    if (!rootRef.current) {
      throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
    }
    return rootRef.current;
  };
  React52.useImperativeHandle(sectionListRef, () => ({
    getRoot() {
      return getRoot("getRoot");
    },
    getSectionContainer(index) {
      const root = getRoot("getSectionContainer");
      return root.querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${index}"]`);
    },
    getSectionContent(index) {
      const root = getRoot("getSectionContent");
      return root.querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${index}"] .${pickersSectionListClasses.sectionContent}`);
    },
    getSectionIndexFromDOMElement(element) {
      const root = getRoot("getSectionIndexFromDOMElement");
      if (element == null || !root.contains(element)) {
        return null;
      }
      let sectionContainer = null;
      if (element.classList.contains(pickersSectionListClasses.section)) {
        sectionContainer = element;
      } else if (element.classList.contains(pickersSectionListClasses.sectionContent)) {
        sectionContainer = element.parentElement;
      }
      if (sectionContainer == null) {
        return null;
      }
      return Number(sectionContainer.dataset.sectionindex);
    }
  }));
  const Root = slots?.root ?? PickersSectionListRoot;
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    additionalProps: {
      ref: handleRootRef,
      suppressContentEditableWarning: true
    },
    className: classes.root,
    ownerState: {}
  });
  return /* @__PURE__ */ jsx(Root, _extends({}, rootProps, {
    children: rootProps.contentEditable ? elements.map(({
      content,
      before,
      after
    }) => `${before.children}${content.children}${after.children}`).join("") : /* @__PURE__ */ jsx(React52.Fragment, {
      children: elements.map((element, elementIndex) => /* @__PURE__ */ jsx(PickersSection, {
        slots,
        slotProps,
        element,
        classes
      }, elementIndex))
    })
  }));
});
process.env.NODE_ENV !== "production" ? PickersSectionList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: import_prop_types5.default.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: import_prop_types5.default.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: import_prop_types5.default.arrayOf(import_prop_types5.default.shape({
    after: import_prop_types5.default.object.isRequired,
    before: import_prop_types5.default.object.isRequired,
    container: import_prop_types5.default.object.isRequired,
    content: import_prop_types5.default.object.isRequired
  })).isRequired,
  sectionListRef: import_prop_types5.default.oneOfType([import_prop_types5.default.func, import_prop_types5.default.shape({
    current: import_prop_types5.default.shape({
      getRoot: import_prop_types5.default.func.isRequired,
      getSectionContainer: import_prop_types5.default.func.isRequired,
      getSectionContent: import_prop_types5.default.func.isRequired,
      getSectionIndexFromDOMElement: import_prop_types5.default.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: import_prop_types5.default.object,
  /**
   * Overridable component slots.
   */
  slots: import_prop_types5.default.object
} : void 0;
var _excluded9 = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef"];
var round = (value) => Math.round(value * 1e5) / 1e5;
var PickersInputBaseRoot = styled("div", {
  name: "MuiPickersInputBase",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => _extends({}, theme.typography.body1, {
  color: (theme.vars || theme).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${round(0.15 / 16)}em`,
  variants: [{
    props: {
      fullWidth: true
    },
    style: {
      width: "100%"
    }
  }]
}));
var PickersInputBaseSectionsContainer = styled(PickersSectionListRoot, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer",
  overridesResolver: (props, styles) => styles.sectionsContainer
})(({
  theme
}) => ({
  padding: "4px 0 5px",
  fontFamily: theme.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      isRtl: true
    },
    style: {
      textAlign: "right /*! @noflip */"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    props: {
      adornedStart: false,
      focused: false,
      filled: false
    },
    style: {
      color: "currentColor",
      opacity: 0
    }
  }, {
    // Can't use the object notation because label can be null or undefined
    props: ({
      adornedStart,
      focused,
      filled,
      label
    }) => !adornedStart && !focused && !filled && label == null,
    style: theme.vars ? {
      opacity: theme.vars.opacity.inputPlaceholder
    } : {
      opacity: theme.palette.mode === "light" ? 0.42 : 0.5
    }
  }]
}));
var PickersInputBaseSection = styled(PickersSectionListSection, {
  name: "MuiPickersInputBase",
  slot: "Section",
  overridesResolver: (props, styles) => styles.section
})(({
  theme
}) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "flex"
}));
var PickersInputBaseSectionContent = styled(PickersSectionListSectionContent, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (props, styles) => styles.content
})(({
  theme
}) => ({
  fontFamily: theme.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none"
}));
var PickersInputBaseSectionSeparator = styled(PickersSectionListSectionSeparator, {
  name: "MuiPickersInputBase",
  slot: "Separator",
  overridesResolver: (props, styles) => styles.separator
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
}));
var PickersInputBaseInput = styled("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (props, styles) => styles.hiddenInput
})(_extends({}, visuallyHidden_default));
var useUtilityClasses4 = (ownerState) => {
  const {
    focused,
    disabled,
    error,
    classes,
    fullWidth,
    readOnly,
    color: color2,
    size,
    endAdornment,
    startAdornment
  } = ownerState;
  const slots = {
    root: ["root", focused && !disabled && "focused", disabled && "disabled", readOnly && "readOnly", error && "error", fullWidth && "fullWidth", `color${capitalize(color2)}`, size === "small" && "inputSizeSmall", Boolean(startAdornment) && "adornedStart", Boolean(endAdornment) && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"]
  };
  return composeClasses(slots, getPickersInputBaseUtilityClass, classes);
};
var PickersInputBase = /* @__PURE__ */ React52.forwardRef(function PickersInputBase2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersInputBase"
  });
  const {
    elements,
    areAllSectionsEmpty,
    value,
    onChange,
    id,
    endAdornment,
    startAdornment,
    renderSuffix,
    slots,
    slotProps,
    contentEditable,
    tabIndex,
    onInput,
    onPaste,
    onKeyDown,
    name,
    readOnly,
    inputProps,
    inputRef,
    sectionListRef
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded9);
  const rootRef = React52.useRef(null);
  const handleRootRef = useForkRef(ref, rootRef);
  const handleInputRef = useForkRef(inputProps?.ref, inputRef);
  const isRtl = useRtl();
  const muiFormControl = useFormControl();
  if (!muiFormControl) {
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  }
  const handleInputFocus = (event) => {
    if (muiFormControl.disabled) {
      event.stopPropagation();
      return;
    }
    muiFormControl.onFocus?.(event);
  };
  React52.useEffect(() => {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  React52.useEffect(() => {
    if (!muiFormControl) {
      return;
    }
    if (areAllSectionsEmpty) {
      muiFormControl.onEmpty();
    } else {
      muiFormControl.onFilled();
    }
  }, [muiFormControl, areAllSectionsEmpty]);
  const ownerState = _extends({}, props, muiFormControl, {
    isRtl
  });
  const classes = useUtilityClasses4(ownerState);
  const InputRoot = slots?.root || PickersInputBaseRoot;
  const inputRootProps = useSlotProps({
    elementType: InputRoot,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    additionalProps: {
      "aria-invalid": muiFormControl.error,
      ref: handleRootRef
    },
    className: classes.root,
    ownerState
  });
  const InputSectionsContainer = slots?.input || PickersInputBaseSectionsContainer;
  return /* @__PURE__ */ jsxs(InputRoot, _extends({}, inputRootProps, {
    children: [startAdornment, /* @__PURE__ */ jsx(PickersSectionList, {
      sectionListRef,
      elements,
      contentEditable,
      tabIndex,
      className: classes.sectionsContainer,
      onFocus: handleInputFocus,
      onBlur: muiFormControl.onBlur,
      onInput,
      onPaste,
      onKeyDown,
      slots: {
        root: InputSectionsContainer,
        section: PickersInputBaseSection,
        sectionContent: PickersInputBaseSectionContent,
        sectionSeparator: PickersInputBaseSectionSeparator
      },
      slotProps: {
        root: {
          ownerState
        },
        sectionContent: {
          className: pickersInputBaseClasses.sectionContent
        },
        sectionSeparator: ({
          position
        }) => ({
          className: position === "before" ? pickersInputBaseClasses.sectionBefore : pickersInputBaseClasses.sectionAfter
        })
      }
    }), endAdornment, renderSuffix ? renderSuffix(_extends({}, muiFormControl)) : null, /* @__PURE__ */ jsx(PickersInputBaseInput, _extends({
      name,
      className: classes.input,
      value,
      onChange,
      id,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly,
      required: muiFormControl.required,
      disabled: muiFormControl.disabled
    }, inputProps, {
      ref: handleInputRef
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? PickersInputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: import_prop_types6.default.bool.isRequired,
  className: import_prop_types6.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: import_prop_types6.default.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: import_prop_types6.default.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: import_prop_types6.default.arrayOf(import_prop_types6.default.shape({
    after: import_prop_types6.default.object.isRequired,
    before: import_prop_types6.default.object.isRequired,
    container: import_prop_types6.default.object.isRequired,
    content: import_prop_types6.default.object.isRequired
  })).isRequired,
  endAdornment: import_prop_types6.default.node,
  fullWidth: import_prop_types6.default.bool,
  id: import_prop_types6.default.string,
  inputProps: import_prop_types6.default.object,
  inputRef: refType_default,
  label: import_prop_types6.default.node,
  margin: import_prop_types6.default.oneOf(["dense", "none", "normal"]),
  name: import_prop_types6.default.string,
  onChange: import_prop_types6.default.func.isRequired,
  onClick: import_prop_types6.default.func.isRequired,
  onInput: import_prop_types6.default.func.isRequired,
  onKeyDown: import_prop_types6.default.func.isRequired,
  onPaste: import_prop_types6.default.func.isRequired,
  ownerState: import_prop_types6.default.any,
  readOnly: import_prop_types6.default.bool,
  renderSuffix: import_prop_types6.default.func,
  sectionListRef: import_prop_types6.default.oneOfType([import_prop_types6.default.func, import_prop_types6.default.shape({
    current: import_prop_types6.default.shape({
      getRoot: import_prop_types6.default.func.isRequired,
      getSectionContainer: import_prop_types6.default.func.isRequired,
      getSectionContent: import_prop_types6.default.func.isRequired,
      getSectionIndexFromDOMElement: import_prop_types6.default.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types6.default.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: import_prop_types6.default.object,
  startAdornment: import_prop_types6.default.node,
  style: import_prop_types6.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types6.default.oneOfType([import_prop_types6.default.arrayOf(import_prop_types6.default.oneOfType([import_prop_types6.default.func, import_prop_types6.default.object, import_prop_types6.default.bool])), import_prop_types6.default.func, import_prop_types6.default.object]),
  value: import_prop_types6.default.string.isRequired
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/PickersOutlinedInput/pickersOutlinedInputClasses.js
function getPickersOutlinedInputUtilityClass(slot) {
  return generateUtilityClass("MuiPickersOutlinedInput", slot);
}
var pickersOutlinedInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"]));
var _excluded10 = ["children", "className", "label", "notched", "shrink"];
var OutlineRoot = styled("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (props, styles) => styles.notchedOutline
})(({
  theme
}) => {
  const borderColor2 = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor2
  };
});
var OutlineLabel = styled("span")(({
  theme
}) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: "inherit"
}));
var OutlineLegend = styled("legend")(({
  theme
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      withLabel: false
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: theme.transitions.create("width", {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      withLabel: true
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: theme.transitions.create("max-width", {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      withLabel: true,
      notched: true
    },
    style: {
      maxWidth: "100%",
      transition: theme.transitions.create("max-width", {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function Outline(props) {
  const {
    className,
    label
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded10);
  const withLabel = label != null && label !== "";
  const ownerState = _extends({}, props, {
    withLabel
  });
  return /* @__PURE__ */ jsx(OutlineRoot, _extends({
    "aria-hidden": true,
    className
  }, other, {
    ownerState,
    children: /* @__PURE__ */ jsx(OutlineLegend, {
      ownerState,
      children: withLabel ? /* @__PURE__ */ jsx(OutlineLabel, {
        children: label
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ jsx(OutlineLabel, {
          className: "notranslate",
          children: "\u200B"
        })
      )
    })
  }));
}
var _excluded11 = ["label", "autoFocus", "ownerState", "notched"];
var PickersOutlinedInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersOutlinedInput",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  const borderColor2 = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (theme.vars || theme).shape.borderRadius,
    [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor2
      }
    },
    [`&.${pickersOutlinedInputClasses.focused} .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${pickersOutlinedInputClasses.disabled}`]: {
      [`& .${pickersOutlinedInputClasses.notchedOutline}`]: {
        borderColor: (theme.vars || theme).palette.action.disabled
      },
      "*": {
        color: (theme.vars || theme).palette.action.disabled
      }
    },
    [`&.${pickersOutlinedInputClasses.error} .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.error.main
    },
    variants: Object.keys((theme.vars ?? theme).palette).filter((key) => (theme.vars ?? theme).palette[key]?.main ?? false).map((color2) => ({
      props: {
        color: color2
      },
      style: {
        [`&.${pickersOutlinedInputClasses.focused}:not(.${pickersOutlinedInputClasses.error}) .${pickersOutlinedInputClasses.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (theme.vars || theme).palette[color2].main
        }
      }
    }))
  };
});
var PickersOutlinedInputSectionsContainer = styled(PickersInputBaseSectionsContainer, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer",
  overridesResolver: (props, styles) => styles.sectionsContainer
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
});
var useUtilityClasses5 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getPickersOutlinedInputUtilityClass, classes);
  return _extends({}, classes, composedClasses);
};
var PickersOutlinedInput = /* @__PURE__ */ React52.forwardRef(function PickersOutlinedInput2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersOutlinedInput"
  });
  const {
    label,
    ownerState: ownerStateProp,
    notched
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded11);
  const muiFormControl = useFormControl();
  const ownerState = _extends({}, props, ownerStateProp, muiFormControl, {
    color: muiFormControl?.color || "primary"
  });
  const classes = useUtilityClasses5(ownerState);
  return /* @__PURE__ */ jsx(PickersInputBase, _extends({
    slots: {
      root: PickersOutlinedInputRoot,
      input: PickersOutlinedInputSectionsContainer
    },
    renderSuffix: (state) => /* @__PURE__ */ jsx(Outline, {
      shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
      notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
      className: classes.notchedOutline,
      label: label != null && label !== "" && muiFormControl?.required ? /* @__PURE__ */ jsxs(React52.Fragment, {
        children: [label, "\u2009", "*"]
      }) : label,
      ownerState
    })
  }, other, {
    label,
    classes,
    ref
  }));
});
process.env.NODE_ENV !== "production" ? PickersOutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: import_prop_types7.default.bool.isRequired,
  className: import_prop_types7.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: import_prop_types7.default.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: import_prop_types7.default.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: import_prop_types7.default.arrayOf(import_prop_types7.default.shape({
    after: import_prop_types7.default.object.isRequired,
    before: import_prop_types7.default.object.isRequired,
    container: import_prop_types7.default.object.isRequired,
    content: import_prop_types7.default.object.isRequired
  })).isRequired,
  endAdornment: import_prop_types7.default.node,
  fullWidth: import_prop_types7.default.bool,
  id: import_prop_types7.default.string,
  inputProps: import_prop_types7.default.object,
  inputRef: refType_default,
  label: import_prop_types7.default.node,
  margin: import_prop_types7.default.oneOf(["dense", "none", "normal"]),
  name: import_prop_types7.default.string,
  notched: import_prop_types7.default.bool,
  onChange: import_prop_types7.default.func.isRequired,
  onClick: import_prop_types7.default.func.isRequired,
  onInput: import_prop_types7.default.func.isRequired,
  onKeyDown: import_prop_types7.default.func.isRequired,
  onPaste: import_prop_types7.default.func.isRequired,
  ownerState: import_prop_types7.default.any,
  readOnly: import_prop_types7.default.bool,
  renderSuffix: import_prop_types7.default.func,
  sectionListRef: import_prop_types7.default.oneOfType([import_prop_types7.default.func, import_prop_types7.default.shape({
    current: import_prop_types7.default.shape({
      getRoot: import_prop_types7.default.func.isRequired,
      getSectionContainer: import_prop_types7.default.func.isRequired,
      getSectionContent: import_prop_types7.default.func.isRequired,
      getSectionIndexFromDOMElement: import_prop_types7.default.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types7.default.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: import_prop_types7.default.object,
  startAdornment: import_prop_types7.default.node,
  style: import_prop_types7.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types7.default.oneOfType([import_prop_types7.default.arrayOf(import_prop_types7.default.oneOfType([import_prop_types7.default.func, import_prop_types7.default.object, import_prop_types7.default.bool])), import_prop_types7.default.func, import_prop_types7.default.object]),
  value: import_prop_types7.default.string.isRequired
} : void 0;
PickersOutlinedInput.muiName = "Input";

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/PickersFilledInput/PickersFilledInput.js
var import_prop_types9 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/createTheme/createBreakpoints.js
var _excluded12 = ["values", "unit", "step"];
var sortBreakpointsValues = (values3) => {
  const breakpointsAsArray = Object.keys(values3).map((key) => ({
    key,
    val: values3[key]
  })) || [];
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends2({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};
function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: values3 = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit = "px",
    step = 5
  } = breakpoints, other = _objectWithoutPropertiesLoose2(breakpoints, _excluded12);
  const sortedValues = sortBreakpointsValues(values3);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values3[key] === "number" ? values3[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values3[key] === "number" ? values3[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values3[start] === "number" ? values3[start] : start}${unit}) and (max-width:${(endIndex !== -1 && typeof values3[keys[endIndex]] === "number" ? values3[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
  }
  return _extends2({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/createTheme/shape.js
var shape = {
  borderRadius: 4
};
var shape_default = shape;

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/responsivePropType.js
var import_prop_types8 = __toESM(require_prop_types());
var responsivePropType = process.env.NODE_ENV !== "production" ? import_prop_types8.default.oneOfType([import_prop_types8.default.number, import_prop_types8.default.string, import_prop_types8.default.object, import_prop_types8.default.array]) : {};
var responsivePropType_default = responsivePropType;

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/merge.js
function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false
    // No need to clone deep, it's way faster.
  });
}
var merge_default = merge;

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/breakpoints.js
var values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (key) => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === "object") {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style3) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style3);
}

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/style.js
function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== "string") {
    return null;
  }
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === "function") {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;
  const fn = (props) => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== "production" ? {
    [prop]: responsivePropType_default
  } : {};
  fn.filterProps = [prop];
  return fn;
}
var style_default = style;

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/memoize.js
function memoize(fn) {
  const cache = {};
  return (arg) => {
    if (cache[arg] === void 0) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/spacing.js
var properties = {
  m: "margin",
  p: "padding"
};
var directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
var aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
var getCssProperties = memoize((prop) => {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split("");
  const property = properties[a];
  const direction = directions[b] || "";
  return Array.isArray(direction) ? direction.map((dir) => property + dir) : [property + direction];
});
var marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
var paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
var spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === "number") {
    return (abs) => {
      if (typeof abs === "string") {
        return abs;
      }
      if (process.env.NODE_ENV !== "production") {
        if (typeof abs !== "number") {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (abs) => {
      if (typeof abs === "string") {
        return abs;
      }
      if (process.env.NODE_ENV !== "production") {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join("\n"));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join("\n"));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== "production") {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, "It should be a number, an array or a function."].join("\n"));
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8, "spacing");
}
function getValue(transformer, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === "number") {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return (propValue) => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style2(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map((prop) => resolveCssProperty(props, keys, prop, transformer)).reduce(merge_default, {});
}
function margin(props) {
  return style2(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType_default;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style2(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType_default;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType_default;
  return obj;
}, {}) : {};

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/createTheme/createSpacing.js
function createSpacing(spacingInput = 8) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const transform = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing2 = (...argsInput) => {
    if (process.env.NODE_ENV !== "production") {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map((argument) => {
      const output = transform(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing2.mui = true;
  return spacing2;
}

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/compose.js
function compose(...styles) {
  const handlers = styles.reduce((acc, style3) => {
    style3.filterProps.forEach((prop) => {
      acc[prop] = style3;
    });
    return acc;
  }, {});
  const fn = (props) => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge_default(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== "production" ? styles.reduce((acc, style3) => Object.assign(acc, style3.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style3) => acc.concat(style3.filterProps), []);
  return fn;
}
var compose_default = compose;

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/borders.js
function borderTransform(value) {
  if (typeof value !== "number") {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
  return style_default({
    prop,
    themeKey: "borders",
    transform
  });
}
var border = createBorderStyle("border", borderTransform);
var borderTop = createBorderStyle("borderTop", borderTransform);
var borderRight = createBorderStyle("borderRight", borderTransform);
var borderBottom = createBorderStyle("borderBottom", borderTransform);
var borderLeft = createBorderStyle("borderLeft", borderTransform);
var borderColor = createBorderStyle("borderColor");
var borderTopColor = createBorderStyle("borderTopColor");
var borderRightColor = createBorderStyle("borderRightColor");
var borderBottomColor = createBorderStyle("borderBottomColor");
var borderLeftColor = createBorderStyle("borderLeftColor");
var outline = createBorderStyle("outline", borderTransform);
var outlineColor = createBorderStyle("outlineColor");
var borderRadius = (props) => {
  if (props.borderRadius !== void 0 && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, "shape.borderRadius", 4, "borderRadius");
    const styleFromPropValue = (propValue) => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType_default
} : {};
borderRadius.filterProps = ["borderRadius"];
compose_default(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/cssGrid.js
var gap = (props) => {
  if (props.gap !== void 0 && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "gap");
    const styleFromPropValue = (propValue) => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType_default
} : {};
gap.filterProps = ["gap"];
var columnGap = (props) => {
  if (props.columnGap !== void 0 && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "columnGap");
    const styleFromPropValue = (propValue) => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType_default
} : {};
columnGap.filterProps = ["columnGap"];
var rowGap = (props) => {
  if (props.rowGap !== void 0 && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "rowGap");
    const styleFromPropValue = (propValue) => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType_default
} : {};
rowGap.filterProps = ["rowGap"];
var gridColumn = style_default({
  prop: "gridColumn"
});
var gridRow = style_default({
  prop: "gridRow"
});
var gridAutoFlow = style_default({
  prop: "gridAutoFlow"
});
var gridAutoColumns = style_default({
  prop: "gridAutoColumns"
});
var gridAutoRows = style_default({
  prop: "gridAutoRows"
});
var gridTemplateColumns = style_default({
  prop: "gridTemplateColumns"
});
var gridTemplateRows = style_default({
  prop: "gridTemplateRows"
});
var gridTemplateAreas = style_default({
  prop: "gridTemplateAreas"
});
var gridArea = style_default({
  prop: "gridArea"
});
compose_default(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/palette.js
function paletteTransform(value, userValue) {
  if (userValue === "grey") {
    return userValue;
  }
  return value;
}
var color = style_default({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
});
var bgcolor = style_default({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
var backgroundColor = style_default({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose_default(color, bgcolor, backgroundColor);

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/sizing.js
function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
var width = style_default({
  prop: "width",
  transform: sizingTransform
});
var maxWidth = (props) => {
  if (props.maxWidth !== void 0 && props.maxWidth !== null) {
    const styleFromPropValue = (propValue) => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || values[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
var minWidth = style_default({
  prop: "minWidth",
  transform: sizingTransform
});
var height = style_default({
  prop: "height",
  transform: sizingTransform
});
var maxHeight = style_default({
  prop: "maxHeight",
  transform: sizingTransform
});
var minHeight = style_default({
  prop: "minHeight",
  transform: sizingTransform
});
style_default({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style_default({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
var boxSizing = style_default({
  prop: "boxSizing"
});
compose_default(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js
var defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: (value) => ({
      "@media print": {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: "typography"
  }
};
var defaultSxConfig_default = defaultSxConfig;

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object2) => keys.concat(Object.keys(object2)), []);
  const union = new Set(allKeys);
  return objects.every((object2) => union.size === Object.keys(object2).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style: style3
    } = options;
    if (val == null) {
      return null;
    }
    if (themeKey === "typography" && val === "inherit") {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style3) {
      return style3(props);
    }
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx2(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null;
    }
    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig_default;
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === "function") {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== "object") {
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach((styleKey) => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== void 0) {
          if (typeof value === "object") {
            if (config[styleKey]) {
              css = merge_default(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, (x) => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx2({
                  sx: value,
                  theme
                });
              } else {
                css = merge_default(css, breakpointsValues);
              }
            }
          } else {
            css = merge_default(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx2;
}
var styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
var styleFunctionSx_default = styleFunctionSx;

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/createTheme/applyStyles.js
function applyStyles(key, styles) {
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
    const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
    return {
      [selector]: styles
    };
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/createTheme/createTheme.js
var _excluded13 = ["breakpoints", "palette", "spacing", "shape"];
function createTheme(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options, other = _objectWithoutPropertiesLoose2(options, _excluded13);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing2 = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends2({
      mode: "light"
    }, paletteInput),
    spacing: spacing2,
    shape: _extends2({}, shape_default, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles;
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends2({}, defaultSxConfig_default, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx_default({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
var createTheme_default = createTheme;

// ../../node_modules/.pnpm/@mui+system@5.15.20_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+styled@_a22e6kwx2xrvrewddk77w23t3y/node_modules/@mui/system/esm/createStyled.js
function shouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
createTheme_default();

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/PickersFilledInput/pickersFilledInputClasses.js
function getPickersFilledInputUtilityClass(slot) {
  return generateUtilityClass("MuiPickersFilledInput", slot);
}
var pickersFilledInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersFilledInput", ["root", "underline", "input"]));
var _excluded14 = ["label", "autoFocus", "disableUnderline", "ownerState"];
var PickersFilledInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root,
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== "disableUnderline"
})(({
  theme
}) => {
  const light2 = theme.palette.mode === "light";
  const bottomLineColor = light2 ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  const backgroundColor2 = light2 ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
  const hoverBackground = light2 ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
  const disabledBackground = light2 ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor2,
    borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
    borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create("background-color", {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor2
      }
    },
    [`&.${pickersFilledInputClasses.focused}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor2
    },
    [`&.${pickersFilledInputClasses.disabled}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
    },
    variants: [...Object.keys((theme.vars ?? theme).palette).filter((key) => (theme.vars ?? theme).palette[key].main).map((color2) => ({
      props: {
        color: color2,
        disableUnderline: false
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(theme.vars || theme).palette[color2]?.main}`
        }
      }
    })), {
      props: {
        disableUnderline: false
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${pickersFilledInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${pickersFilledInputClasses.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (theme.vars || theme).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: theme.transitions.create("border-bottom-color", {
            duration: theme.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${pickersFilledInputClasses.disabled}, .${pickersFilledInputClasses.error}):before`]: {
          borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${pickersFilledInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: ({
        startAdornment
      }) => !!startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        endAdornment
      }) => !!endAdornment,
      style: {
        paddingRight: 12
      }
    }]
  };
});
var PickersFilledSectionsContainer = styled(PickersInputBaseSectionsContainer, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  overridesResolver: (props, styles) => styles.sectionsContainer
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      startAdornment
    }) => !!startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      endAdornment
    }) => !!endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: true
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: true,
      size: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
});
var useUtilityClasses6 = (ownerState) => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ["root", !disableUnderline && "underline"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getPickersFilledInputUtilityClass, classes);
  return _extends({}, classes, composedClasses);
};
var PickersFilledInput = /* @__PURE__ */ React52.forwardRef(function PickersFilledInput2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersFilledInput"
  });
  const {
    label,
    disableUnderline = false,
    ownerState: ownerStateProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded14);
  const muiFormControl = useFormControl();
  const ownerState = _extends({}, props, ownerStateProp, muiFormControl, {
    color: muiFormControl?.color || "primary"
  });
  const classes = useUtilityClasses6(ownerState);
  return /* @__PURE__ */ jsx(PickersInputBase, _extends({
    slots: {
      root: PickersFilledInputRoot,
      input: PickersFilledSectionsContainer
    },
    slotProps: {
      root: {
        disableUnderline
      }
    }
  }, other, {
    label,
    classes,
    ref
  }));
});
process.env.NODE_ENV !== "production" ? PickersFilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: import_prop_types9.default.bool.isRequired,
  className: import_prop_types9.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: import_prop_types9.default.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: import_prop_types9.default.bool.isRequired,
  disableUnderline: import_prop_types9.default.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: import_prop_types9.default.arrayOf(import_prop_types9.default.shape({
    after: import_prop_types9.default.object.isRequired,
    before: import_prop_types9.default.object.isRequired,
    container: import_prop_types9.default.object.isRequired,
    content: import_prop_types9.default.object.isRequired
  })).isRequired,
  endAdornment: import_prop_types9.default.node,
  fullWidth: import_prop_types9.default.bool,
  hiddenLabel: import_prop_types9.default.bool,
  id: import_prop_types9.default.string,
  inputProps: import_prop_types9.default.object,
  inputRef: refType_default,
  label: import_prop_types9.default.node,
  margin: import_prop_types9.default.oneOf(["dense", "none", "normal"]),
  name: import_prop_types9.default.string,
  onChange: import_prop_types9.default.func.isRequired,
  onClick: import_prop_types9.default.func.isRequired,
  onInput: import_prop_types9.default.func.isRequired,
  onKeyDown: import_prop_types9.default.func.isRequired,
  onPaste: import_prop_types9.default.func.isRequired,
  ownerState: import_prop_types9.default.any,
  readOnly: import_prop_types9.default.bool,
  renderSuffix: import_prop_types9.default.func,
  sectionListRef: import_prop_types9.default.oneOfType([import_prop_types9.default.func, import_prop_types9.default.shape({
    current: import_prop_types9.default.shape({
      getRoot: import_prop_types9.default.func.isRequired,
      getSectionContainer: import_prop_types9.default.func.isRequired,
      getSectionContent: import_prop_types9.default.func.isRequired,
      getSectionIndexFromDOMElement: import_prop_types9.default.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types9.default.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: import_prop_types9.default.object,
  startAdornment: import_prop_types9.default.node,
  style: import_prop_types9.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types9.default.oneOfType([import_prop_types9.default.arrayOf(import_prop_types9.default.oneOfType([import_prop_types9.default.func, import_prop_types9.default.object, import_prop_types9.default.bool])), import_prop_types9.default.func, import_prop_types9.default.object]),
  value: import_prop_types9.default.string.isRequired
} : void 0;
PickersFilledInput.muiName = "Input";

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/PickersInput/PickersInput.js
var import_prop_types10 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersTextField/PickersInput/pickersInputClasses.js
function getPickersInputUtilityClass(slot) {
  return generateUtilityClass("MuiPickersFilledInput", slot);
}
var pickersInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersInput", ["root", "input"]));
var _excluded15 = ["label", "autoFocus", "disableUnderline", "ownerState"];
var PickersInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersInput",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  const light2 = theme.palette.mode === "light";
  let bottomLineColor = light2 ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  if (theme.vars) {
    bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
  }
  return {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((theme.vars ?? theme).palette).filter((key) => (theme.vars ?? theme).palette[key].main).map((color2) => ({
      props: {
        color: color2
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(theme.vars || theme).palette[color2].main}`
        }
      }
    })), {
      props: {
        disableUnderline: false
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${pickersInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${pickersInputClasses.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (theme.vars || theme).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${bottomLineColor}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: theme.transitions.create("border-bottom-color", {
            duration: theme.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${pickersInputClasses.disabled}, .${pickersInputClasses.error}):before`]: {
          borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${bottomLineColor}`
          }
        },
        [`&.${pickersInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
});
var useUtilityClasses7 = (ownerState) => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ["root", !disableUnderline && "underline"],
    input: ["input"]
  };
  const composedClasses = composeClasses(slots, getPickersInputUtilityClass, classes);
  return _extends({}, classes, composedClasses);
};
var PickersInput = /* @__PURE__ */ React52.forwardRef(function PickersInput2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersInput"
  });
  const {
    label,
    disableUnderline = false,
    ownerState: ownerStateProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded15);
  const muiFormControl = useFormControl();
  const ownerState = _extends({}, props, ownerStateProp, muiFormControl, {
    disableUnderline,
    color: muiFormControl?.color || "primary"
  });
  const classes = useUtilityClasses7(ownerState);
  return /* @__PURE__ */ jsx(PickersInputBase, _extends({
    slots: {
      root: PickersInputRoot
    }
  }, other, {
    label,
    classes,
    ref
  }));
});
process.env.NODE_ENV !== "production" ? PickersInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: import_prop_types10.default.bool.isRequired,
  className: import_prop_types10.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: import_prop_types10.default.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: import_prop_types10.default.bool.isRequired,
  disableUnderline: import_prop_types10.default.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: import_prop_types10.default.arrayOf(import_prop_types10.default.shape({
    after: import_prop_types10.default.object.isRequired,
    before: import_prop_types10.default.object.isRequired,
    container: import_prop_types10.default.object.isRequired,
    content: import_prop_types10.default.object.isRequired
  })).isRequired,
  endAdornment: import_prop_types10.default.node,
  fullWidth: import_prop_types10.default.bool,
  id: import_prop_types10.default.string,
  inputProps: import_prop_types10.default.object,
  inputRef: refType_default,
  label: import_prop_types10.default.node,
  margin: import_prop_types10.default.oneOf(["dense", "none", "normal"]),
  name: import_prop_types10.default.string,
  onChange: import_prop_types10.default.func.isRequired,
  onClick: import_prop_types10.default.func.isRequired,
  onInput: import_prop_types10.default.func.isRequired,
  onKeyDown: import_prop_types10.default.func.isRequired,
  onPaste: import_prop_types10.default.func.isRequired,
  ownerState: import_prop_types10.default.any,
  readOnly: import_prop_types10.default.bool,
  renderSuffix: import_prop_types10.default.func,
  sectionListRef: import_prop_types10.default.oneOfType([import_prop_types10.default.func, import_prop_types10.default.shape({
    current: import_prop_types10.default.shape({
      getRoot: import_prop_types10.default.func.isRequired,
      getSectionContainer: import_prop_types10.default.func.isRequired,
      getSectionContent: import_prop_types10.default.func.isRequired,
      getSectionIndexFromDOMElement: import_prop_types10.default.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types10.default.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: import_prop_types10.default.object,
  startAdornment: import_prop_types10.default.node,
  style: import_prop_types10.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types10.default.oneOfType([import_prop_types10.default.arrayOf(import_prop_types10.default.oneOfType([import_prop_types10.default.func, import_prop_types10.default.object, import_prop_types10.default.bool])), import_prop_types10.default.func, import_prop_types10.default.object]),
  value: import_prop_types10.default.string.isRequired
} : void 0;
PickersInput.muiName = "Input";
var _excluded16 = ["onFocus", "onBlur", "className", "color", "disabled", "error", "variant", "required", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps"];
var VARIANT_COMPONENT = {
  standard: PickersInput,
  filled: PickersFilledInput,
  outlined: PickersOutlinedInput
};
var PickersTextFieldRoot = styled(FormControl, {
  name: "MuiPickersTextField",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({});
var useUtilityClasses8 = (ownerState) => {
  const {
    focused,
    disabled,
    classes,
    required
  } = ownerState;
  const slots = {
    root: ["root", focused && !disabled && "focused", disabled && "disabled", required && "required"]
  };
  return composeClasses(slots, getPickersTextFieldUtilityClass, classes);
};
var PickersTextField = /* @__PURE__ */ React52.forwardRef(function PickersTextField2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersTextField"
  });
  const {
    // Props used by FormControl
    onFocus,
    onBlur,
    className,
    color: color2 = "primary",
    disabled = false,
    error = false,
    variant = "outlined",
    required = false,
    // Props used by PickersInput
    InputProps: InputProps2,
    inputProps,
    inputRef,
    sectionListRef,
    elements,
    areAllSectionsEmpty,
    onClick,
    onKeyDown,
    onPaste,
    onInput,
    endAdornment,
    startAdornment,
    tabIndex,
    contentEditable,
    focused,
    value,
    onChange,
    fullWidth,
    id: idProp,
    name,
    // Props used by FormHelperText
    helperText,
    FormHelperTextProps,
    // Props used by InputLabel
    label,
    InputLabelProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded16);
  const rootRef = React52.useRef(null);
  const handleRootRef = useForkRef(ref, rootRef);
  const id = useId(idProp);
  const helperTextId = helperText && id ? `${id}-helper-text` : void 0;
  const inputLabelId = label && id ? `${id}-label` : void 0;
  const ownerState = _extends({}, props, {
    color: color2,
    disabled,
    error,
    focused,
    required,
    variant
  });
  const classes = useUtilityClasses8(ownerState);
  const PickersInputComponent = VARIANT_COMPONENT[variant];
  return /* @__PURE__ */ jsxs(PickersTextFieldRoot, _extends({
    className: clsx_default(classes.root, className),
    ref: handleRootRef,
    focused,
    onFocus,
    onBlur,
    disabled,
    variant,
    error,
    color: color2,
    fullWidth,
    required,
    ownerState
  }, other, {
    children: [/* @__PURE__ */ jsx(InputLabel, _extends({
      htmlFor: id,
      id: inputLabelId
    }, InputLabelProps, {
      children: label
    })), /* @__PURE__ */ jsx(PickersInputComponent, _extends({
      elements,
      areAllSectionsEmpty,
      onClick,
      onKeyDown,
      onInput,
      onPaste,
      endAdornment,
      startAdornment,
      tabIndex,
      contentEditable,
      value,
      onChange,
      id,
      fullWidth,
      inputProps,
      inputRef,
      sectionListRef,
      label,
      name,
      role: "group",
      "aria-labelledby": inputLabelId
    }, InputProps2)), helperText && /* @__PURE__ */ jsx(FormHelperText, _extends({
      id: helperTextId
    }, FormHelperTextProps, {
      children: helperText
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? PickersTextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: import_prop_types11.default.bool.isRequired,
  className: import_prop_types11.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: import_prop_types11.default.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: import_prop_types11.default.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: import_prop_types11.default.bool.isRequired,
  disabled: import_prop_types11.default.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: import_prop_types11.default.arrayOf(import_prop_types11.default.shape({
    after: import_prop_types11.default.object.isRequired,
    before: import_prop_types11.default.object.isRequired,
    container: import_prop_types11.default.object.isRequired,
    content: import_prop_types11.default.object.isRequired
  })).isRequired,
  endAdornment: import_prop_types11.default.node,
  error: import_prop_types11.default.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: import_prop_types11.default.bool,
  FormHelperTextProps: import_prop_types11.default.object,
  fullWidth: import_prop_types11.default.bool,
  /**
   * The helper text content.
   */
  helperText: import_prop_types11.default.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: import_prop_types11.default.bool,
  id: import_prop_types11.default.string,
  InputLabelProps: import_prop_types11.default.object,
  inputProps: import_prop_types11.default.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: import_prop_types11.default.object,
  inputRef: refType_default,
  label: import_prop_types11.default.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: import_prop_types11.default.oneOf(["dense", "none", "normal"]),
  name: import_prop_types11.default.string,
  onBlur: import_prop_types11.default.func.isRequired,
  onChange: import_prop_types11.default.func.isRequired,
  onClick: import_prop_types11.default.func.isRequired,
  onFocus: import_prop_types11.default.func.isRequired,
  onInput: import_prop_types11.default.func.isRequired,
  onKeyDown: import_prop_types11.default.func.isRequired,
  onPaste: import_prop_types11.default.func.isRequired,
  readOnly: import_prop_types11.default.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: import_prop_types11.default.bool,
  sectionListRef: import_prop_types11.default.oneOfType([import_prop_types11.default.func, import_prop_types11.default.shape({
    current: import_prop_types11.default.shape({
      getRoot: import_prop_types11.default.func.isRequired,
      getSectionContainer: import_prop_types11.default.func.isRequired,
      getSectionContent: import_prop_types11.default.func.isRequired,
      getSectionIndexFromDOMElement: import_prop_types11.default.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: import_prop_types11.default.oneOf(["medium", "small"]),
  startAdornment: import_prop_types11.default.node,
  style: import_prop_types11.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types11.default.oneOfType([import_prop_types11.default.arrayOf(import_prop_types11.default.oneOfType([import_prop_types11.default.func, import_prop_types11.default.object, import_prop_types11.default.bool])), import_prop_types11.default.func, import_prop_types11.default.object]),
  value: import_prop_types11.default.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: import_prop_types11.default.oneOf(["filled", "outlined", "standard"])
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/convertFieldResponseIntoMuiTextFieldProps.js
var _excluded17 = ["enableAccessibleFieldDOMStructure"];
var _excluded24 = ["InputProps", "readOnly"];
var _excluded33 = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef"];
var convertFieldResponseIntoMuiTextFieldProps = (_ref) => {
  let {
    enableAccessibleFieldDOMStructure
  } = _ref, fieldResponse = _objectWithoutPropertiesLoose(_ref, _excluded17);
  if (enableAccessibleFieldDOMStructure) {
    const {
      InputProps: InputProps3,
      readOnly: readOnly2
    } = fieldResponse, other2 = _objectWithoutPropertiesLoose(fieldResponse, _excluded24);
    return _extends({}, other2, {
      InputProps: _extends({}, InputProps3 ?? {}, {
        readOnly: readOnly2
      })
    });
  }
  const {
    onPaste,
    onKeyDown,
    inputMode,
    readOnly,
    InputProps: InputProps2,
    inputProps,
    inputRef
  } = fieldResponse, other = _objectWithoutPropertiesLoose(fieldResponse, _excluded33);
  return _extends({}, other, {
    InputProps: _extends({}, InputProps2 ?? {}, {
      readOnly
    }),
    inputProps: _extends({}, inputProps ?? {}, {
      inputMode,
      onPaste,
      onKeyDown,
      ref: inputRef
    })
  });
};
var _excluded18 = ["slots", "slotProps", "InputProps", "inputProps"];
var DateField = /* @__PURE__ */ React52.forwardRef(function DateField2(inProps, inRef) {
  const themeProps = useThemeProps({
    props: inProps,
    name: "MuiDateField"
  });
  const {
    slots,
    slotProps,
    InputProps: InputProps2,
    inputProps
  } = themeProps, other = _objectWithoutPropertiesLoose(themeProps, _excluded18);
  const ownerState = themeProps;
  const TextField8 = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? PickersTextField : MuiTextField);
  const textFieldProps = useSlotProps({
    elementType: TextField8,
    externalSlotProps: slotProps?.textField,
    externalForwardedProps: other,
    additionalProps: {
      ref: inRef
    },
    ownerState
  });
  textFieldProps.inputProps = _extends({}, inputProps, textFieldProps.inputProps);
  textFieldProps.InputProps = _extends({}, InputProps2, textFieldProps.InputProps);
  const fieldResponse = useDateField(textFieldProps);
  const convertedFieldResponse = convertFieldResponseIntoMuiTextFieldProps(fieldResponse);
  const processedFieldProps = useClearableField(_extends({}, convertedFieldResponse, {
    slots,
    slotProps
  }));
  return /* @__PURE__ */ jsx(TextField8, _extends({}, processedFieldProps));
});
process.env.NODE_ENV !== "production" ? DateField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: import_prop_types12.default.bool,
  className: import_prop_types12.default.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: import_prop_types12.default.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: import_prop_types12.default.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: import_prop_types12.default.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: import_prop_types12.default.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: import_prop_types12.default.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: import_prop_types12.default.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: import_prop_types12.default.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: import_prop_types12.default.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: import_prop_types12.default.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: import_prop_types12.default.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: import_prop_types12.default.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: import_prop_types12.default.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: import_prop_types12.default.bool,
  /**
   * The helper text content.
   */
  helperText: import_prop_types12.default.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: import_prop_types12.default.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: import_prop_types12.default.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: import_prop_types12.default.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: import_prop_types12.default.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: import_prop_types12.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType_default,
  /**
   * The label content.
   */
  label: import_prop_types12.default.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: import_prop_types12.default.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: import_prop_types12.default.object,
  /**
   * Minimal selectable date.
   */
  minDate: import_prop_types12.default.object,
  /**
   * Name attribute of the `input` element.
   */
  name: import_prop_types12.default.string,
  onBlur: import_prop_types12.default.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: import_prop_types12.default.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: import_prop_types12.default.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: import_prop_types12.default.func,
  onFocus: import_prop_types12.default.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: import_prop_types12.default.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: import_prop_types12.default.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: import_prop_types12.default.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: import_prop_types12.default.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: import_prop_types12.default.oneOfType([import_prop_types12.default.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), import_prop_types12.default.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: import_prop_types12.default.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: import_prop_types12.default.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: import_prop_types12.default.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: import_prop_types12.default.bool,
  /**
   * The size of the component.
   */
  size: import_prop_types12.default.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types12.default.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: import_prop_types12.default.object,
  style: import_prop_types12.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types12.default.oneOfType([import_prop_types12.default.arrayOf(import_prop_types12.default.oneOfType([import_prop_types12.default.func, import_prop_types12.default.object, import_prop_types12.default.bool])), import_prop_types12.default.func, import_prop_types12.default.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: import_prop_types12.default.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: import_prop_types12.default.oneOfType([import_prop_types12.default.func, import_prop_types12.default.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: import_prop_types12.default.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: import_prop_types12.default.oneOf(["filled", "outlined", "standard"])
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DateCalendar/DateCalendar.js
var import_prop_types20 = __toESM(require_prop_types());
var useIsDateDisabled = ({
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  minDate,
  maxDate,
  disableFuture,
  disablePast,
  timezone
}) => {
  const adapter = useLocalizationContext();
  return React52.useCallback((day) => validateDate({
    adapter,
    value: day,
    props: {
      shouldDisableDate,
      shouldDisableMonth,
      shouldDisableYear,
      minDate,
      maxDate,
      disableFuture,
      disablePast,
      timezone
    }
  }) !== null, [adapter, shouldDisableDate, shouldDisableMonth, shouldDisableYear, minDate, maxDate, disableFuture, disablePast, timezone]);
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DateCalendar/useCalendarState.js
var createCalendarStateReducer = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils) => (state, action) => {
  switch (action.type) {
    case "changeMonth":
      return _extends({}, state, {
        slideDirection: action.direction,
        currentMonth: action.newMonth,
        isMonthSwitchingAnimating: !reduceAnimations
      });
    case "finishMonthSwitchingAnimation":
      return _extends({}, state, {
        isMonthSwitchingAnimating: false
      });
    case "changeFocusedDay": {
      if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) {
        return state;
      }
      const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
      return _extends({}, state, {
        focusedDay: action.focusedDay,
        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
};
var useCalendarState = (params) => {
  const {
    value,
    referenceDate: referenceDateProp,
    disableFuture,
    disablePast,
    disableSwitchToMonthOnDayFocus = false,
    maxDate,
    minDate,
    onMonthChange,
    reduceAnimations,
    shouldDisableDate,
    timezone
  } = params;
  const utils = useUtils();
  const reducerFn = React52.useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
  const referenceDate = React52.useMemo(
    () => {
      return singleItemValueManager.getInitialReferenceValue({
        value,
        utils,
        timezone,
        props: params,
        referenceDate: referenceDateProp,
        granularity: SECTION_TYPE_GRANULARITY.day
      });
    },
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  const [calendarState, dispatch] = React52.useReducer(reducerFn, {
    isMonthSwitchingAnimating: false,
    focusedDay: referenceDate,
    currentMonth: utils.startOfMonth(referenceDate),
    slideDirection: "left"
  });
  const handleChangeMonth = React52.useCallback((payload) => {
    dispatch(_extends({
      type: "changeMonth"
    }, payload));
    if (onMonthChange) {
      onMonthChange(payload.newMonth);
    }
  }, [onMonthChange]);
  const changeMonth = React52.useCallback((newDate) => {
    const newDateRequested = newDate;
    if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) {
      return;
    }
    handleChangeMonth({
      newMonth: utils.startOfMonth(newDateRequested),
      direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? "left" : "right"
    });
  }, [calendarState.currentMonth, handleChangeMonth, utils]);
  const isDateDisabled = useIsDateDisabled({
    shouldDisableDate,
    minDate,
    maxDate,
    disableFuture,
    disablePast,
    timezone
  });
  const onMonthSwitchingAnimationEnd = React52.useCallback(() => {
    dispatch({
      type: "finishMonthSwitchingAnimation"
    });
  }, []);
  const changeFocusedDay = useEventCallback_default((newFocusedDate, withoutMonthSwitchingAnimation) => {
    if (!isDateDisabled(newFocusedDate)) {
      dispatch({
        type: "changeFocusedDay",
        focusedDay: newFocusedDate,
        withoutMonthSwitchingAnimation
      });
    }
  });
  return {
    referenceDate,
    calendarState,
    changeMonth,
    changeFocusedDay,
    isDateDisabled,
    onMonthSwitchingAnimationEnd,
    handleChangeMonth
  };
};

// ../../node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}

// ../../node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

// ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/CSSTransition.js
var import_prop_types15 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/hasClass.js
function hasClass(element, className) {
  if (element.classList)
    return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

// ../../node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/addClass.js
function addClass(element, className) {
  if (element.classList)
    element.classList.add(className);
  else if (!hasClass(element, className))
    if (typeof element.className === "string")
      element.className = element.className + " " + className;
    else
      element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
}

// ../../node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === "string") {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
  }
}

// ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/Transition.js
var import_prop_types14 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/config.js
var config_default = {
  disabled: false
};

// ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/utils/PropTypes.js
var import_prop_types13 = __toESM(require_prop_types());
var timeoutsShape = process.env.NODE_ENV !== "production" ? import_prop_types13.default.oneOfType([import_prop_types13.default.number, import_prop_types13.default.shape({
  enter: import_prop_types13.default.number,
  exit: import_prop_types13.default.number,
  appear: import_prop_types13.default.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== "production" ? import_prop_types13.default.oneOfType([import_prop_types13.default.string, import_prop_types13.default.shape({
  enter: import_prop_types13.default.string,
  exit: import_prop_types13.default.string,
  active: import_prop_types13.default.string
}), import_prop_types13.default.shape({
  enter: import_prop_types13.default.string,
  enterDone: import_prop_types13.default.string,
  enterActive: import_prop_types13.default.string,
  exit: import_prop_types13.default.string,
  exitDone: import_prop_types13.default.string,
  exitActive: import_prop_types13.default.string
})]) : null;
var TransitionGroupContext_default = React52__default.createContext(null);

// ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow2(node) {
  return node.scrollTop;
};

// ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/Transition.js
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          if (node)
            forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config_default.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!exit || config_default.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function(event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children; _this$props.in; _this$props.mountOnEnter; _this$props.unmountOnExit; _this$props.appear; _this$props.enter; _this$props.exit; _this$props.timeout; _this$props.addEndListener; _this$props.onEnter; _this$props.onEntering; _this$props.onEntered; _this$props.onExit; _this$props.onExiting; _this$props.onExited; _this$props.nodeRef; var childProps = _objectWithoutPropertiesLoose2(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React52__default.createElement(TransitionGroupContext_default.Provider, {
        value: null
      }, typeof children === "function" ? children(status, childProps) : React52__default.cloneElement(React52__default.Children.only(children), childProps))
    );
  };
  return Transition2;
}(React52__default.Component);
Transition.contextType = TransitionGroupContext_default;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: import_prop_types14.default.shape({
    current: typeof Element === "undefined" ? import_prop_types14.default.any : function(propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return import_prop_types14.default.instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: import_prop_types14.default.oneOfType([import_prop_types14.default.func.isRequired, import_prop_types14.default.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: import_prop_types14.default.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: import_prop_types14.default.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: import_prop_types14.default.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: import_prop_types14.default.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: import_prop_types14.default.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: import_prop_types14.default.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener)
      pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: import_prop_types14.default.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: import_prop_types14.default.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: import_prop_types14.default.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: import_prop_types14.default.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: import_prop_types14.default.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: import_prop_types14.default.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: import_prop_types14.default.func
} : {};
function noop2() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop2,
  onEntering: noop2,
  onEntered: noop2,
  onExit: noop2,
  onExiting: noop2,
  onExited: noop2
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition_default = Transition;

// ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/CSSTransition.js
var _addClass = function addClass2(node, classes) {
  return node && classes && classes.split(" ").forEach(function(c) {
    return addClass(node, c);
  });
};
var removeClass2 = function removeClass3(node, classes) {
  return node && classes && classes.split(" ").forEach(function(c) {
    return removeClass(node, c);
  });
};
var CSSTransition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(CSSTransition2, _React$Component);
  function CSSTransition2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
      _this.removeClasses(node, "exit");
      _this.addClass(node, appearing ? "appear" : "enter", "base");
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
      var type = appearing ? "appear" : "enter";
      _this.addClass(node, type, "active");
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
      var type = appearing ? "appear" : "enter";
      _this.removeClasses(node, type);
      _this.addClass(node, type, "done");
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function(maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
      _this.removeClasses(node, "appear");
      _this.removeClasses(node, "enter");
      _this.addClass(node, "exit", "base");
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function(maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
      _this.addClass(node, "exit", "active");
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function(maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
      _this.removeClasses(node, "exit");
      _this.addClass(node, "exit", "done");
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function(maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function(type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === "string";
      var prefix = isStringClassNames && classNames ? classNames + "-" : "";
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName,
        activeClassName,
        doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition2.prototype;
  _proto.addClass = function addClass3(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
    if (type === "appear" && phase === "done" && doneClassName) {
      className += " " + doneClassName;
    }
    if (phase === "active") {
      if (node)
        forceReflow(node);
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node, className);
    }
  };
  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass2(node, baseClassName);
    }
    if (activeClassName) {
      removeClass2(node, activeClassName);
    }
    if (doneClassName) {
      removeClass2(node, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props; _this$props.classNames; var props = _objectWithoutPropertiesLoose2(_this$props, ["classNames"]);
    return /* @__PURE__ */ React52__default.createElement(Transition_default, _extends2({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition2;
}(React52__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends2({}, Transition_default.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: import_prop_types15.default.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: import_prop_types15.default.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: import_prop_types15.default.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: import_prop_types15.default.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: import_prop_types15.default.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: import_prop_types15.default.func
}) : {};
var CSSTransition_default = CSSTransition;

// ../../node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

// ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/TransitionGroup.js
var import_prop_types16 = __toESM(require_prop_types());
function getChildMapping(children, mapFn) {
  var mapper = function mapper2(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = /* @__PURE__ */ Object.create(null);
  if (children)
    Children.map(children, function(c) {
      return c;
    }).forEach(function(child) {
      result[child.key] = mapper(child);
    });
  return result;
}
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }
  var nextKeysPending = /* @__PURE__ */ Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function(child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, "appear", props),
      enter: getProp(child, "enter", props),
      exit: getProp(child, "exit", props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function(key) {
    var child = children[key];
    if (!isValidElement(child))
      return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in;
    if (hasNext && (!hasPrev || isLeaving)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    }
  });
  return children;
}

// ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/TransitionGroup.js
var values2 = Object.values || function(obj) {
  return Object.keys(obj).map(function(k) {
    return obj[k];
  });
};
var defaultProps = {
  component: "div",
  childFactory: function childFactory(child) {
    return child;
  }
};
var TransitionGroup = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(TransitionGroup2, _React$Component);
  function TransitionGroup2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };
  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping)
      return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function(state) {
        var children = _extends2({}, state.children);
        delete children[child.key];
        return {
          children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props, Component = _this$props.component, childFactory2 = _this$props.childFactory, props = _objectWithoutPropertiesLoose2(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values2(this.state.children).map(childFactory2);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /* @__PURE__ */ React52__default.createElement(TransitionGroupContext_default.Provider, {
        value: contextValue
      }, children);
    }
    return /* @__PURE__ */ React52__default.createElement(TransitionGroupContext_default.Provider, {
      value: contextValue
    }, /* @__PURE__ */ React52__default.createElement(Component, props, children));
  };
  return TransitionGroup2;
}(React52__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: import_prop_types16.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: import_prop_types16.default.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: import_prop_types16.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: import_prop_types16.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: import_prop_types16.default.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: import_prop_types16.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup_default = TransitionGroup;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DateCalendar/pickersFadeTransitionGroupClasses.js
var getPickersFadeTransitionGroupUtilityClass = (slot) => generateUtilityClass("MuiPickersFadeTransitionGroup", slot);
generateUtilityClasses("MuiPickersFadeTransitionGroup", ["root"]);
var useUtilityClasses9 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getPickersFadeTransitionGroupUtilityClass, classes);
};
var PickersFadeTransitionGroupRoot = styled(TransitionGroup_default, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})({
  display: "block",
  position: "relative"
});
function PickersFadeTransitionGroup(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersFadeTransitionGroup"
  });
  const {
    children,
    className,
    reduceAnimations,
    transKey
  } = props;
  const classes = useUtilityClasses9(props);
  const theme = useTheme();
  if (reduceAnimations) {
    return children;
  }
  return /* @__PURE__ */ jsx(PickersFadeTransitionGroupRoot, {
    className: clsx_default(classes.root, className),
    children: /* @__PURE__ */ jsx(Fade, {
      appear: false,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        appear: theme.transitions.duration.enteringScreen,
        enter: theme.transitions.duration.enteringScreen,
        exit: 0
      },
      children
    }, transKey)
  });
}

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DateCalendar/pickersSlideTransitionClasses.js
var getPickersSlideTransitionUtilityClass = (slot) => generateUtilityClass("MuiPickersSlideTransition", slot);
var pickersSlideTransitionClasses = generateUtilityClasses("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]);
var _excluded19 = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"];
var useUtilityClasses10 = (ownerState) => {
  const {
    classes,
    slideDirection
  } = ownerState;
  const slots = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${slideDirection}`],
    exitActive: [`slideExitActiveLeft-${slideDirection}`]
  };
  return composeClasses(slots, getPickersSlideTransitionUtilityClass, classes);
};
var PickersSlideTransitionRoot = styled(TransitionGroup_default, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (_, styles) => [styles.root, {
    [`.${pickersSlideTransitionClasses["slideEnter-left"]}`]: styles["slideEnter-left"]
  }, {
    [`.${pickersSlideTransitionClasses["slideEnter-right"]}`]: styles["slideEnter-right"]
  }, {
    [`.${pickersSlideTransitionClasses.slideEnterActive}`]: styles.slideEnterActive
  }, {
    [`.${pickersSlideTransitionClasses.slideExit}`]: styles.slideExit
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: styles["slideExitActiveLeft-left"]
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: styles["slideExitActiveLeft-right"]
  }]
})(({
  theme
}) => {
  const slideTransition = theme.transitions.create("transform", {
    duration: theme.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: slideTransition
    },
    [`& .${pickersSlideTransitionClasses.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: slideTransition,
      zIndex: 0
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: slideTransition,
      zIndex: 0
    }
  };
});
function PickersSlideTransition(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersSlideTransition"
  });
  const {
    children,
    className,
    reduceAnimations,
    transKey
    // extracting `classes` from `other`
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded19);
  const classes = useUtilityClasses10(props);
  const theme = useTheme();
  if (reduceAnimations) {
    return /* @__PURE__ */ jsx("div", {
      className: clsx_default(classes.root, className),
      children
    });
  }
  const transitionClasses = {
    exit: classes.exit,
    enterActive: classes.enterActive,
    enter: classes.enter,
    exitActive: classes.exitActive
  };
  return /* @__PURE__ */ jsx(PickersSlideTransitionRoot, {
    className: clsx_default(classes.root, className),
    childFactory: (element) => /* @__PURE__ */ React52.cloneElement(element, {
      classNames: transitionClasses
    }),
    role: "presentation",
    children: /* @__PURE__ */ jsx(CSSTransition_default, _extends({
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: theme.transitions.duration.complex,
      classNames: transitionClasses
    }, other, {
      children
    }), transKey)
  });
}

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DateCalendar/dayCalendarClasses.js
var getDayCalendarUtilityClass = (slot) => generateUtilityClass("MuiDayCalendar", slot);
generateUtilityClasses("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
var _excluded20 = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"];
var _excluded25 = ["ownerState"];
var useUtilityClasses11 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  };
  return composeClasses(slots, getDayCalendarUtilityClass, classes);
};
var weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 2) * 6;
var PickersCalendarDayRoot = styled("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})({});
var PickersCalendarDayHeader = styled("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (_, styles) => styles.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
var PickersCalendarWeekDayLabel = styled(Typography4, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (_, styles) => styles.weekDayLabel
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (theme.vars || theme).palette.text.secondary
}));
var PickersCalendarWeekNumberLabel = styled(Typography4, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (_, styles) => styles.weekNumberLabel
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: theme.palette.text.disabled
}));
var PickersCalendarWeekNumber = styled(Typography4, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (_, styles) => styles.weekNumber
})(({
  theme
}) => _extends({}, theme.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  padding: 0,
  margin: `0 ${DAY_MARGIN}px`,
  color: theme.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
}));
var PickersCalendarLoadingContainer = styled("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (_, styles) => styles.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: weeksContainerHeight
});
var PickersCalendarSlideTransition = styled(PickersSlideTransition, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (_, styles) => styles.slideTransition
})({
  minHeight: weeksContainerHeight
});
var PickersCalendarWeekContainer = styled("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (_, styles) => styles.monthContainer
})({
  overflow: "hidden"
});
var PickersCalendarWeek = styled("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (_, styles) => styles.weekContainer
})({
  margin: `${DAY_MARGIN}px 0`,
  display: "flex",
  justifyContent: "center"
});
function WrappedDay(_ref) {
  let {
    parentProps,
    day,
    focusableDay,
    selectedDays,
    isDateDisabled,
    currentMonthNumber,
    isViewFocused
  } = _ref, other = _objectWithoutPropertiesLoose(_ref, _excluded20);
  const {
    disabled,
    disableHighlightToday,
    isMonthSwitchingAnimating,
    showDaysOutsideCurrentMonth,
    slots,
    slotProps,
    timezone
  } = parentProps;
  const utils = useUtils();
  const now = useNow(timezone);
  const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
  const isSelected = selectedDays.some((selectedDay) => utils.isSameDay(selectedDay, day));
  const isToday = utils.isSameDay(day, now);
  const Day = slots?.day ?? PickersDay2;
  const _useSlotProps = useSlotProps({
    elementType: Day,
    externalSlotProps: slotProps?.day,
    additionalProps: _extends({
      disableHighlightToday,
      showDaysOutsideCurrentMonth,
      role: "gridcell",
      isAnimating: isMonthSwitchingAnimating,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": utils.toJsDate(day).valueOf()
    }, other),
    ownerState: _extends({}, parentProps, {
      day,
      selected: isSelected
    })
  }), dayProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded25);
  const isDisabled = React52.useMemo(() => disabled || isDateDisabled(day), [disabled, isDateDisabled, day]);
  const outsideCurrentMonth = React52.useMemo(() => utils.getMonth(day) !== currentMonthNumber, [utils, day, currentMonthNumber]);
  const isFirstVisibleCell = React52.useMemo(() => {
    const startOfMonth3 = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return utils.isSameDay(day, startOfMonth3);
    }
    return utils.isSameDay(day, utils.startOfWeek(startOfMonth3));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, utils]);
  const isLastVisibleCell = React52.useMemo(() => {
    const endOfMonth2 = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return utils.isSameDay(day, endOfMonth2);
    }
    return utils.isSameDay(day, utils.endOfWeek(endOfMonth2));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, utils]);
  return /* @__PURE__ */ jsx(Day, _extends({}, dayProps, {
    day,
    disabled: isDisabled,
    autoFocus: isViewFocused && isFocusableDay,
    today: isToday,
    outsideCurrentMonth,
    isFirstVisibleCell,
    isLastVisibleCell,
    selected: isSelected,
    tabIndex: isFocusableDay ? 0 : -1,
    "aria-selected": isSelected,
    "aria-current": isToday ? "date" : void 0
  }));
}
function DayCalendar(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiDayCalendar"
  });
  const utils = useUtils();
  const {
    onFocusedDayChange,
    className,
    currentMonth,
    selectedDays,
    focusedDay,
    loading,
    onSelectedDaysChange,
    onMonthSwitchingAnimationEnd,
    readOnly,
    reduceAnimations,
    renderLoading = () => /* @__PURE__ */ jsx("span", {
      children: "..."
    }),
    slideDirection,
    TransitionProps,
    disablePast,
    disableFuture,
    minDate,
    maxDate,
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    dayOfWeekFormatter = (date) => utils.format(date, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus,
    onFocusedViewChange,
    gridLabelId,
    displayWeekNumber,
    fixedWeekNumber,
    autoFocus,
    timezone
  } = props;
  const now = useNow(timezone);
  const classes = useUtilityClasses11(props);
  const isRtl = useRtl();
  const isDateDisabled = useIsDateDisabled({
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    minDate,
    maxDate,
    disablePast,
    disableFuture,
    timezone
  });
  const localeText = useLocaleText();
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: hasFocus,
    default: autoFocus ?? false
  });
  const [internalFocusedDay, setInternalFocusedDay] = React52.useState(() => focusedDay || now);
  const handleDaySelect = useEventCallback_default((day) => {
    if (readOnly) {
      return;
    }
    onSelectedDaysChange(day);
  });
  const focusDay = (day) => {
    if (!isDateDisabled(day)) {
      onFocusedDayChange(day);
      setInternalFocusedDay(day);
      onFocusedViewChange?.(true);
      setInternalHasFocus(true);
    }
  };
  const handleKeyDown = useEventCallback_default((event, day) => {
    switch (event.key) {
      case "ArrowUp":
        focusDay(utils.addDays(day, -7));
        event.preventDefault();
        break;
      case "ArrowDown":
        focusDay(utils.addDays(day, 7));
        event.preventDefault();
        break;
      case "ArrowLeft": {
        const newFocusedDayDefault = utils.addDays(day, isRtl ? 1 : -1);
        const nextAvailableMonth = utils.addMonths(day, isRtl ? 1 : -1);
        const closestDayToFocus = findClosestEnabledDate({
          utils,
          date: newFocusedDayDefault,
          minDate: isRtl ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
          maxDate: isRtl ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
          isDateDisabled,
          timezone
        });
        focusDay(closestDayToFocus || newFocusedDayDefault);
        event.preventDefault();
        break;
      }
      case "ArrowRight": {
        const newFocusedDayDefault = utils.addDays(day, isRtl ? -1 : 1);
        const nextAvailableMonth = utils.addMonths(day, isRtl ? -1 : 1);
        const closestDayToFocus = findClosestEnabledDate({
          utils,
          date: newFocusedDayDefault,
          minDate: isRtl ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
          maxDate: isRtl ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
          isDateDisabled,
          timezone
        });
        focusDay(closestDayToFocus || newFocusedDayDefault);
        event.preventDefault();
        break;
      }
      case "Home":
        focusDay(utils.startOfWeek(day));
        event.preventDefault();
        break;
      case "End":
        focusDay(utils.endOfWeek(day));
        event.preventDefault();
        break;
      case "PageUp":
        focusDay(utils.addMonths(day, 1));
        event.preventDefault();
        break;
      case "PageDown":
        focusDay(utils.addMonths(day, -1));
        event.preventDefault();
        break;
    }
  });
  const handleFocus = useEventCallback_default((event, day) => focusDay(day));
  const handleBlur = useEventCallback_default((event, day) => {
    if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) {
      onFocusedViewChange?.(false);
    }
  });
  const currentMonthNumber = utils.getMonth(currentMonth);
  const currentYearNumber = utils.getYear(currentMonth);
  const validSelectedDays = React52.useMemo(() => selectedDays.filter((day) => !!day).map((day) => utils.startOfDay(day)), [utils, selectedDays]);
  const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
  const slideNodeRef = React52.useMemo(() => /* @__PURE__ */ React52.createRef(), [transitionKey]);
  const startOfCurrentWeek = utils.startOfWeek(now);
  const focusableDay = React52.useMemo(() => {
    const startOfMonth3 = utils.startOfMonth(currentMonth);
    const endOfMonth2 = utils.endOfMonth(currentMonth);
    if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth2) || utils.isBeforeDay(internalFocusedDay, startOfMonth3)) {
      return findClosestEnabledDate({
        utils,
        date: internalFocusedDay,
        minDate: startOfMonth3,
        maxDate: endOfMonth2,
        disablePast,
        disableFuture,
        isDateDisabled,
        timezone
      });
    }
    return internalFocusedDay;
  }, [currentMonth, disableFuture, disablePast, internalFocusedDay, isDateDisabled, utils, timezone]);
  const weeksToDisplay = React52.useMemo(() => {
    const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
    const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
    let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
    while (fixedWeekNumber && toDisplay.length < fixedWeekNumber) {
      const additionalWeeks = utils.getWeekArray(nextMonth);
      const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
      additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week) => {
        if (toDisplay.length < fixedWeekNumber) {
          toDisplay.push(week);
        }
      });
      nextMonth = utils.addMonths(nextMonth, 1);
    }
    return toDisplay;
  }, [currentMonth, fixedWeekNumber, utils, timezone]);
  return /* @__PURE__ */ jsxs(PickersCalendarDayRoot, {
    role: "grid",
    "aria-labelledby": gridLabelId,
    className: classes.root,
    children: [/* @__PURE__ */ jsxs(PickersCalendarDayHeader, {
      role: "row",
      className: classes.header,
      children: [displayWeekNumber && /* @__PURE__ */ jsx(PickersCalendarWeekNumberLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": localeText.calendarWeekNumberHeaderLabel,
        className: classes.weekNumberLabel,
        children: localeText.calendarWeekNumberHeaderText
      }), getWeekdays(utils, now).map((weekday, i) => /* @__PURE__ */ jsx(PickersCalendarWeekDayLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), "weekday"),
        className: classes.weekDayLabel,
        children: dayOfWeekFormatter(weekday)
      }, i.toString()))]
    }), loading ? /* @__PURE__ */ jsx(PickersCalendarLoadingContainer, {
      className: classes.loadingContainer,
      children: renderLoading()
    }) : /* @__PURE__ */ jsx(PickersCalendarSlideTransition, _extends({
      transKey: transitionKey,
      onExited: onMonthSwitchingAnimationEnd,
      reduceAnimations,
      slideDirection,
      className: clsx_default(className, classes.slideTransition)
    }, TransitionProps, {
      nodeRef: slideNodeRef,
      children: /* @__PURE__ */ jsx(PickersCalendarWeekContainer, {
        ref: slideNodeRef,
        role: "rowgroup",
        className: classes.monthContainer,
        children: weeksToDisplay.map((week, index) => /* @__PURE__ */ jsxs(PickersCalendarWeek, {
          role: "row",
          className: classes.weekContainer,
          "aria-rowindex": index + 1,
          children: [displayWeekNumber && /* @__PURE__ */ jsx(PickersCalendarWeekNumber, {
            className: classes.weekNumber,
            role: "rowheader",
            "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
            children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
          }), week.map((day, dayIndex) => /* @__PURE__ */ jsx(WrappedDay, {
            parentProps: props,
            day,
            selectedDays: validSelectedDays,
            focusableDay,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onDaySelect: handleDaySelect,
            isDateDisabled,
            currentMonthNumber,
            isViewFocused: internalHasFocus,
            "aria-colindex": dayIndex + 1
          }, day.toString()))]
        }, `week-${week[0]}`))
      })
    }))]
  });
}

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/MonthCalendar/MonthCalendar.js
var import_prop_types17 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/MonthCalendar/pickersMonthClasses.js
function getPickersMonthUtilityClass(slot) {
  return generateUtilityClass("MuiPickersMonth", slot);
}
var pickersMonthClasses = generateUtilityClasses("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]);
var _excluded21 = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow", "slots", "slotProps"];
var useUtilityClasses12 = (ownerState) => {
  const {
    disabled,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    monthButton: ["monthButton", disabled && "disabled", selected && "selected"]
  };
  return composeClasses(slots, getPickersMonthUtilityClass, classes);
};
var PickersMonthRoot = styled("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (_, styles) => [styles.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      monthsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
});
var MonthCalendarButton = styled("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (_, styles) => [styles.monthButton, {
    [`&.${pickersMonthClasses.disabled}`]: styles.disabled
  }, {
    [`&.${pickersMonthClasses.selected}`]: styles.selected
  }]
})(({
  theme
}) => _extends({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${pickersMonthClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${pickersMonthClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));
var PickersMonth = /* @__PURE__ */ React52.memo(function PickersMonth2(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersMonth"
  });
  const {
    autoFocus,
    className,
    children,
    disabled,
    selected,
    value,
    tabIndex,
    onClick,
    onKeyDown,
    onFocus,
    onBlur,
    "aria-current": ariaCurrent,
    "aria-label": ariaLabel,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded21);
  const ref = React52.useRef(null);
  const classes = useUtilityClasses12(props);
  useEnhancedEffect_default(() => {
    if (autoFocus) {
      ref.current?.focus();
    }
  }, [autoFocus]);
  const MonthButton = slots?.monthButton ?? MonthCalendarButton;
  const monthButtonProps = useSlotProps({
    elementType: MonthButton,
    externalSlotProps: slotProps?.monthButton,
    additionalProps: {
      children,
      disabled,
      tabIndex,
      ref,
      type: "button",
      role: "radio",
      "aria-current": ariaCurrent,
      "aria-checked": selected,
      "aria-label": ariaLabel,
      onClick: (event) => onClick(event, value),
      onKeyDown: (event) => onKeyDown(event, value),
      onFocus: (event) => onFocus(event, value),
      onBlur: (event) => onBlur(event, value)
    },
    ownerState: props,
    className: classes.monthButton
  });
  return /* @__PURE__ */ jsx(PickersMonthRoot, _extends({
    className: clsx_default(classes.root, className),
    ownerState: props
  }, other, {
    children: /* @__PURE__ */ jsx(MonthButton, _extends({}, monthButtonProps))
  }));
});

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/MonthCalendar/monthCalendarClasses.js
function getMonthCalendarUtilityClass(slot) {
  return generateUtilityClass("MuiMonthCalendar", slot);
}
generateUtilityClasses("MuiMonthCalendar", ["root"]);
var _excluded26 = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"];
var useUtilityClasses13 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getMonthCalendarUtilityClass, classes);
};
function useMonthCalendarDefaultizedProps(props, name) {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const themeProps = useThemeProps({
    props,
    name
  });
  return _extends({
    disableFuture: false,
    disablePast: false
  }, themeProps, {
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
var MonthCalendarRoot = styled("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: DIALOG_WIDTH,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
});
var MonthCalendar = /* @__PURE__ */ React52.forwardRef(function MonthCalendar2(inProps, ref) {
  const props = useMonthCalendarDefaultizedProps(inProps, "MuiMonthCalendar");
  const {
    className,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    disabled,
    disableFuture,
    disablePast,
    maxDate,
    minDate,
    onChange,
    shouldDisableMonth,
    readOnly,
    autoFocus = false,
    onMonthFocus,
    hasFocus,
    onFocusedViewChange,
    monthsPerRow = 3,
    timezone: timezoneProp,
    gridLabelId,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded26);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValueWithTimezone({
    name: "MonthCalendar",
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange,
    valueManager: singleItemValueManager
  });
  const now = useNow(timezone);
  const isRtl = useRtl();
  const utils = useUtils();
  const referenceDate = React52.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value,
      utils,
      props,
      timezone,
      referenceDate: referenceDateProp,
      granularity: SECTION_TYPE_GRANULARITY.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  const ownerState = props;
  const classes = useUtilityClasses13(ownerState);
  const todayMonth = React52.useMemo(() => utils.getMonth(now), [utils, now]);
  const selectedMonth = React52.useMemo(() => {
    if (value != null) {
      return utils.getMonth(value);
    }
    return null;
  }, [value, utils]);
  const [focusedMonth, setFocusedMonth] = React52.useState(() => selectedMonth || utils.getMonth(referenceDate));
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: hasFocus,
    default: autoFocus ?? false
  });
  const changeHasFocus = useEventCallback_default((newHasFocus) => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isMonthDisabled = React52.useCallback((dateToValidate) => {
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    const monthToValidate = utils.startOfMonth(dateToValidate);
    if (utils.isBefore(monthToValidate, firstEnabledMonth)) {
      return true;
    }
    if (utils.isAfter(monthToValidate, lastEnabledMonth)) {
      return true;
    }
    if (!shouldDisableMonth) {
      return false;
    }
    return shouldDisableMonth(monthToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now, shouldDisableMonth, utils]);
  const handleMonthSelection = useEventCallback_default((event, month) => {
    if (readOnly) {
      return;
    }
    const newDate = utils.setMonth(value ?? referenceDate, month);
    handleValueChange(newDate);
  });
  const focusMonth = useEventCallback_default((month) => {
    if (!isMonthDisabled(utils.setMonth(value ?? referenceDate, month))) {
      setFocusedMonth(month);
      changeHasFocus(true);
      if (onMonthFocus) {
        onMonthFocus(month);
      }
    }
  });
  React52.useEffect(() => {
    setFocusedMonth((prevFocusedMonth) => selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
  }, [selectedMonth]);
  const handleKeyDown = useEventCallback_default((event, month) => {
    const monthsInYear = 12;
    const monthsInRow = 3;
    switch (event.key) {
      case "ArrowUp":
        focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
        event.preventDefault();
        break;
      case "ArrowDown":
        focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
        event.preventDefault();
        break;
      case "ArrowLeft":
        focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
        event.preventDefault();
        break;
      case "ArrowRight":
        focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
        event.preventDefault();
        break;
    }
  });
  const handleMonthFocus = useEventCallback_default((event, month) => {
    focusMonth(month);
  });
  const handleMonthBlur = useEventCallback_default((event, month) => {
    if (focusedMonth === month) {
      changeHasFocus(false);
    }
  });
  return /* @__PURE__ */ jsx(MonthCalendarRoot, _extends({
    ref,
    className: clsx_default(classes.root, className),
    ownerState,
    role: "radiogroup",
    "aria-labelledby": gridLabelId
  }, other, {
    children: getMonthsInYear(utils, value ?? referenceDate).map((month) => {
      const monthNumber = utils.getMonth(month);
      const monthText = utils.format(month, "monthShort");
      const monthLabel = utils.format(month, "month");
      const isSelected = monthNumber === selectedMonth;
      const isDisabled = disabled || isMonthDisabled(month);
      return /* @__PURE__ */ jsx(PickersMonth, {
        selected: isSelected,
        value: monthNumber,
        onClick: handleMonthSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && monthNumber === focusedMonth,
        disabled: isDisabled,
        tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
        onFocus: handleMonthFocus,
        onBlur: handleMonthBlur,
        "aria-current": todayMonth === monthNumber ? "date" : void 0,
        "aria-label": monthLabel,
        monthsPerRow,
        slots,
        slotProps,
        children: monthText
      }, monthText);
    })
  }));
});
process.env.NODE_ENV !== "production" ? MonthCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: import_prop_types17.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: import_prop_types17.default.object,
  className: import_prop_types17.default.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: import_prop_types17.default.object,
  /**
   * If `true` picker is disabled
   */
  disabled: import_prop_types17.default.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: import_prop_types17.default.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: import_prop_types17.default.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: import_prop_types17.default.bool,
  gridLabelId: import_prop_types17.default.string,
  hasFocus: import_prop_types17.default.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: import_prop_types17.default.object,
  /**
   * Minimal selectable date.
   */
  minDate: import_prop_types17.default.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: import_prop_types17.default.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: import_prop_types17.default.func,
  onFocusedViewChange: import_prop_types17.default.func,
  onMonthFocus: import_prop_types17.default.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: import_prop_types17.default.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: import_prop_types17.default.object,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: import_prop_types17.default.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types17.default.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: import_prop_types17.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types17.default.oneOfType([import_prop_types17.default.arrayOf(import_prop_types17.default.oneOfType([import_prop_types17.default.func, import_prop_types17.default.object, import_prop_types17.default.bool])), import_prop_types17.default.func, import_prop_types17.default.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: import_prop_types17.default.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: import_prop_types17.default.object
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/YearCalendar/YearCalendar.js
var import_prop_types18 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/YearCalendar/pickersYearClasses.js
function getPickersYearUtilityClass(slot) {
  return generateUtilityClass("MuiPickersYear", slot);
}
var pickersYearClasses = generateUtilityClasses("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]);
var _excluded27 = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow", "slots", "slotProps"];
var useUtilityClasses14 = (ownerState) => {
  const {
    disabled,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    yearButton: ["yearButton", disabled && "disabled", selected && "selected"]
  };
  return composeClasses(slots, getPickersYearUtilityClass, classes);
};
var PickersYearRoot = styled("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (_, styles) => [styles.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      yearsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
});
var YearCalendarButton = styled("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (_, styles) => [styles.yearButton, {
    [`&.${pickersYearClasses.disabled}`]: styles.disabled
  }, {
    [`&.${pickersYearClasses.selected}`]: styles.selected
  }]
})(({
  theme
}) => _extends({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : alpha(theme.palette.action.active, theme.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${pickersYearClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${pickersYearClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));
var PickersYear = /* @__PURE__ */ React52.memo(function PickersYear2(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersYear"
  });
  const {
    autoFocus,
    className,
    children,
    disabled,
    selected,
    value,
    tabIndex,
    onClick,
    onKeyDown,
    onFocus,
    onBlur,
    "aria-current": ariaCurrent,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded27);
  const ref = React52.useRef(null);
  const classes = useUtilityClasses14(props);
  useEnhancedEffect_default(() => {
    if (autoFocus) {
      ref.current?.focus();
    }
  }, [autoFocus]);
  const YearButton = slots?.yearButton ?? YearCalendarButton;
  const yearButtonProps = useSlotProps({
    elementType: YearButton,
    externalSlotProps: slotProps?.yearButton,
    additionalProps: {
      children,
      disabled,
      tabIndex,
      ref,
      type: "button",
      role: "radio",
      "aria-current": ariaCurrent,
      "aria-checked": selected,
      onClick: (event) => onClick(event, value),
      onKeyDown: (event) => onKeyDown(event, value),
      onFocus: (event) => onFocus(event, value),
      onBlur: (event) => onBlur(event, value)
    },
    ownerState: props,
    className: classes.yearButton
  });
  return /* @__PURE__ */ jsx(PickersYearRoot, _extends({
    className: clsx_default(classes.root, className),
    ownerState: props
  }, other, {
    children: /* @__PURE__ */ jsx(YearButton, _extends({}, yearButtonProps))
  }));
});

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/YearCalendar/yearCalendarClasses.js
function getYearCalendarUtilityClass(slot) {
  return generateUtilityClass("MuiYearCalendar", slot);
}
generateUtilityClasses("MuiYearCalendar", ["root"]);
var _excluded28 = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"];
var useUtilityClasses15 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getYearCalendarUtilityClass, classes);
};
function useYearCalendarDefaultizedProps(props, name) {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const themeProps = useThemeProps({
    props,
    name
  });
  return _extends({
    disablePast: false,
    disableFuture: false
  }, themeProps, {
    yearsPerRow: themeProps.yearsPerRow ?? 3,
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
var YearCalendarRoot = styled("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: DIALOG_WIDTH,
  maxHeight: MAX_CALENDAR_HEIGHT,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
});
var YearCalendar = /* @__PURE__ */ React52.forwardRef(function YearCalendar2(inProps, ref) {
  const props = useYearCalendarDefaultizedProps(inProps, "MuiYearCalendar");
  const {
    autoFocus,
    className,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    disabled,
    disableFuture,
    disablePast,
    maxDate,
    minDate,
    onChange,
    readOnly,
    shouldDisableYear,
    onYearFocus,
    hasFocus,
    onFocusedViewChange,
    yearsPerRow,
    timezone: timezoneProp,
    gridLabelId,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded28);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValueWithTimezone({
    name: "YearCalendar",
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange,
    valueManager: singleItemValueManager
  });
  const now = useNow(timezone);
  const isRtl = useRtl();
  const utils = useUtils();
  const referenceDate = React52.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value,
      utils,
      props,
      timezone,
      referenceDate: referenceDateProp,
      granularity: SECTION_TYPE_GRANULARITY.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  const ownerState = props;
  const classes = useUtilityClasses15(ownerState);
  const todayYear = React52.useMemo(() => utils.getYear(now), [utils, now]);
  const selectedYear = React52.useMemo(() => {
    if (value != null) {
      return utils.getYear(value);
    }
    return null;
  }, [value, utils]);
  const [focusedYear, setFocusedYear] = React52.useState(() => selectedYear || utils.getYear(referenceDate));
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: hasFocus,
    default: autoFocus ?? false
  });
  const changeHasFocus = useEventCallback_default((newHasFocus) => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isYearDisabled = React52.useCallback((dateToValidate) => {
    if (disablePast && utils.isBeforeYear(dateToValidate, now)) {
      return true;
    }
    if (disableFuture && utils.isAfterYear(dateToValidate, now)) {
      return true;
    }
    if (minDate && utils.isBeforeYear(dateToValidate, minDate)) {
      return true;
    }
    if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) {
      return true;
    }
    if (!shouldDisableYear) {
      return false;
    }
    const yearToValidate = utils.startOfYear(dateToValidate);
    return shouldDisableYear(yearToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now, shouldDisableYear, utils]);
  const handleYearSelection = useEventCallback_default((event, year) => {
    if (readOnly) {
      return;
    }
    const newDate = utils.setYear(value ?? referenceDate, year);
    handleValueChange(newDate);
  });
  const focusYear = useEventCallback_default((year) => {
    if (!isYearDisabled(utils.setYear(value ?? referenceDate, year))) {
      setFocusedYear(year);
      changeHasFocus(true);
      onYearFocus?.(year);
    }
  });
  React52.useEffect(() => {
    setFocusedYear((prevFocusedYear) => selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
  }, [selectedYear]);
  const handleKeyDown = useEventCallback_default((event, year) => {
    switch (event.key) {
      case "ArrowUp":
        focusYear(year - yearsPerRow);
        event.preventDefault();
        break;
      case "ArrowDown":
        focusYear(year + yearsPerRow);
        event.preventDefault();
        break;
      case "ArrowLeft":
        focusYear(year + (isRtl ? 1 : -1));
        event.preventDefault();
        break;
      case "ArrowRight":
        focusYear(year + (isRtl ? -1 : 1));
        event.preventDefault();
        break;
    }
  });
  const handleYearFocus = useEventCallback_default((event, year) => {
    focusYear(year);
  });
  const handleYearBlur = useEventCallback_default((event, year) => {
    if (focusedYear === year) {
      changeHasFocus(false);
    }
  });
  const scrollerRef = React52.useRef(null);
  const handleRef = useForkRef(ref, scrollerRef);
  React52.useEffect(() => {
    if (autoFocus || scrollerRef.current === null) {
      return;
    }
    const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
    if (!tabbableButton) {
      return;
    }
    const offsetHeight = tabbableButton.offsetHeight;
    const offsetTop = tabbableButton.offsetTop;
    const clientHeight = scrollerRef.current.clientHeight;
    const scrollTop = scrollerRef.current.scrollTop;
    const elementBottom = offsetTop + offsetHeight;
    if (offsetHeight > clientHeight || offsetTop < scrollTop) {
      return;
    }
    scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
  }, [autoFocus]);
  return /* @__PURE__ */ jsx(YearCalendarRoot, _extends({
    ref: handleRef,
    className: clsx_default(classes.root, className),
    ownerState,
    role: "radiogroup",
    "aria-labelledby": gridLabelId
  }, other, {
    children: utils.getYearRange([minDate, maxDate]).map((year) => {
      const yearNumber = utils.getYear(year);
      const isSelected = yearNumber === selectedYear;
      const isDisabled = disabled || isYearDisabled(year);
      return /* @__PURE__ */ jsx(PickersYear, {
        selected: isSelected,
        value: yearNumber,
        onClick: handleYearSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && yearNumber === focusedYear,
        disabled: isDisabled,
        tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
        onFocus: handleYearFocus,
        onBlur: handleYearBlur,
        "aria-current": todayYear === yearNumber ? "date" : void 0,
        yearsPerRow,
        slots,
        slotProps,
        children: utils.format(year, "year")
      }, utils.format(year, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" ? YearCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: import_prop_types18.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: import_prop_types18.default.object,
  className: import_prop_types18.default.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: import_prop_types18.default.object,
  /**
   * If `true` picker is disabled
   */
  disabled: import_prop_types18.default.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: import_prop_types18.default.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: import_prop_types18.default.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: import_prop_types18.default.bool,
  gridLabelId: import_prop_types18.default.string,
  hasFocus: import_prop_types18.default.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: import_prop_types18.default.object,
  /**
   * Minimal selectable date.
   */
  minDate: import_prop_types18.default.object,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: import_prop_types18.default.func,
  onFocusedViewChange: import_prop_types18.default.func,
  onYearFocus: import_prop_types18.default.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: import_prop_types18.default.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: import_prop_types18.default.object,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: import_prop_types18.default.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types18.default.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: import_prop_types18.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types18.default.oneOfType([import_prop_types18.default.arrayOf(import_prop_types18.default.oneOfType([import_prop_types18.default.func, import_prop_types18.default.object, import_prop_types18.default.bool])), import_prop_types18.default.func, import_prop_types18.default.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: import_prop_types18.default.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: import_prop_types18.default.object,
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: import_prop_types18.default.oneOf([3, 4])
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersCalendarHeader/pickersCalendarHeaderClasses.js
var getPickersCalendarHeaderUtilityClass = (slot) => generateUtilityClass("MuiPickersCalendarHeader", slot);
var pickersCalendarHeaderClasses = generateUtilityClasses("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]);

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersCalendarHeader/PickersCalendarHeader.js
var import_prop_types19 = __toESM(require_prop_types());
var _excluded29 = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone", "format"];
var _excluded210 = ["ownerState"];
var useUtilityClasses16 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  };
  return composeClasses(slots, getPickersCalendarHeaderUtilityClass, classes);
};
var PickersCalendarHeaderRoot = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
});
var PickersCalendarHeaderLabelContainer = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (_, styles) => styles.labelContainer
})(({
  theme
}) => _extends({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, theme.typography.body1, {
  fontWeight: theme.typography.fontWeightMedium
}));
var PickersCalendarHeaderLabel = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (_, styles) => styles.label
})({
  marginRight: 6
});
var PickersCalendarHeaderSwitchViewButton = styled(IconButton4, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (_, styles) => styles.switchViewButton
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${pickersCalendarHeaderClasses.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
});
var PickersCalendarHeaderSwitchViewIcon = styled(ArrowDropDownIcon, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (_, styles) => styles.switchViewIcon
})(({
  theme
}) => ({
  willChange: "transform",
  transition: theme.transitions.create("transform"),
  transform: "rotate(0deg)"
}));
var PickersCalendarHeader = /* @__PURE__ */ React52.forwardRef(function PickersCalendarHeader2(inProps, ref) {
  const localeText = useLocaleText();
  const utils = useUtils();
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersCalendarHeader"
  });
  const {
    slots,
    slotProps,
    currentMonth: month,
    disabled,
    disableFuture,
    disablePast,
    maxDate,
    minDate,
    onMonthChange,
    onViewChange,
    view,
    reduceAnimations,
    views,
    labelId,
    className,
    timezone,
    format: format4 = `${utils.formats.month} ${utils.formats.year}`
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded29);
  const ownerState = props;
  const classes = useUtilityClasses16(props);
  const SwitchViewButton = slots?.switchViewButton ?? PickersCalendarHeaderSwitchViewButton;
  const switchViewButtonProps = useSlotProps({
    elementType: SwitchViewButton,
    externalSlotProps: slotProps?.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": localeText.calendarViewSwitchingButtonAriaLabel(view)
    },
    ownerState,
    className: classes.switchViewButton
  });
  const SwitchViewIcon = slots?.switchViewIcon ?? PickersCalendarHeaderSwitchViewIcon;
  const _useSlotProps = useSlotProps({
    elementType: SwitchViewIcon,
    externalSlotProps: slotProps?.switchViewIcon,
    ownerState: void 0,
    className: classes.switchViewIcon
  }), switchViewIconProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded210);
  const selectNextMonth = () => onMonthChange(utils.addMonths(month, 1), "left");
  const selectPreviousMonth = () => onMonthChange(utils.addMonths(month, -1), "right");
  const isNextMonthDisabled = useNextMonthDisabled(month, {
    disableFuture,
    maxDate,
    timezone
  });
  const isPreviousMonthDisabled = usePreviousMonthDisabled(month, {
    disablePast,
    minDate,
    timezone
  });
  const handleToggleView = () => {
    if (views.length === 1 || !onViewChange || disabled) {
      return;
    }
    if (views.length === 2) {
      onViewChange(views.find((el) => el !== view) || views[0]);
    } else {
      const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
      onViewChange(views[nextIndexToOpen]);
    }
  };
  if (views.length === 1 && views[0] === "year") {
    return null;
  }
  const label = utils.formatByString(month, format4);
  return /* @__PURE__ */ jsxs(PickersCalendarHeaderRoot, _extends({}, other, {
    ownerState,
    className: clsx_default(className, classes.root),
    ref,
    children: [/* @__PURE__ */ jsxs(PickersCalendarHeaderLabelContainer, {
      role: "presentation",
      onClick: handleToggleView,
      ownerState,
      "aria-live": "polite",
      className: classes.labelContainer,
      children: [/* @__PURE__ */ jsx(PickersFadeTransitionGroup, {
        reduceAnimations,
        transKey: label,
        children: /* @__PURE__ */ jsx(PickersCalendarHeaderLabel, {
          id: labelId,
          ownerState,
          className: classes.label,
          children: label
        })
      }), views.length > 1 && !disabled && /* @__PURE__ */ jsx(SwitchViewButton, _extends({}, switchViewButtonProps, {
        children: /* @__PURE__ */ jsx(SwitchViewIcon, _extends({}, switchViewIconProps))
      }))]
    }), /* @__PURE__ */ jsx(Fade, {
      in: view === "day",
      children: /* @__PURE__ */ jsx(PickersArrowSwitcher, {
        slots,
        slotProps,
        onGoToPrevious: selectPreviousMonth,
        isPreviousDisabled: isPreviousMonthDisabled,
        previousLabel: localeText.previousMonth,
        onGoToNext: selectNextMonth,
        isNextDisabled: isNextMonthDisabled,
        nextLabel: localeText.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" ? PickersCalendarHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: import_prop_types19.default.object,
  className: import_prop_types19.default.string,
  currentMonth: import_prop_types19.default.object.isRequired,
  disabled: import_prop_types19.default.bool,
  disableFuture: import_prop_types19.default.bool,
  disablePast: import_prop_types19.default.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: import_prop_types19.default.string,
  labelId: import_prop_types19.default.string,
  maxDate: import_prop_types19.default.object.isRequired,
  minDate: import_prop_types19.default.object.isRequired,
  onMonthChange: import_prop_types19.default.func.isRequired,
  onViewChange: import_prop_types19.default.func,
  reduceAnimations: import_prop_types19.default.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types19.default.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: import_prop_types19.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types19.default.oneOfType([import_prop_types19.default.arrayOf(import_prop_types19.default.oneOfType([import_prop_types19.default.func, import_prop_types19.default.object, import_prop_types19.default.bool])), import_prop_types19.default.func, import_prop_types19.default.object]),
  timezone: import_prop_types19.default.string.isRequired,
  view: import_prop_types19.default.oneOf(["day", "month", "year"]).isRequired,
  views: import_prop_types19.default.arrayOf(import_prop_types19.default.oneOf(["day", "month", "year"]).isRequired).isRequired
} : void 0;
var PREFERS_REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";
var mobileVersionMatches = typeof navigator !== "undefined" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
var androidVersion = mobileVersionMatches && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null;
var iOSVersion = mobileVersionMatches && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null;
var slowAnimationDevices = androidVersion && androidVersion < 10 || iOSVersion && iOSVersion < 13 || false;
var useDefaultReduceAnimations = () => {
  const prefersReduced = useMediaQuery(PREFERS_REDUCED_MOTION, {
    defaultMatches: false
  });
  return prefersReduced || slowAnimationDevices;
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DateCalendar/dateCalendarClasses.js
var getDateCalendarUtilityClass = (slot) => generateUtilityClass("MuiDateCalendar", slot);
generateUtilityClasses("MuiDateCalendar", ["root", "viewTransitionContainer"]);
var _excluded30 = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsPerRow", "monthsPerRow", "timezone"];
var useUtilityClasses17 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  };
  return composeClasses(slots, getDateCalendarUtilityClass, classes);
};
function useDateCalendarDefaultizedProps(props, name) {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const defaultReduceAnimations = useDefaultReduceAnimations();
  const themeProps = useThemeProps({
    props,
    name
  });
  return _extends({}, themeProps, {
    loading: themeProps.loading ?? false,
    disablePast: themeProps.disablePast ?? false,
    disableFuture: themeProps.disableFuture ?? false,
    openTo: themeProps.openTo ?? "day",
    views: themeProps.views ?? ["year", "day"],
    reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
    renderLoading: themeProps.renderLoading ?? (() => /* @__PURE__ */ jsx("span", {
      children: "..."
    })),
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
var DateCalendarRoot = styled(PickerViewRoot, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  display: "flex",
  flexDirection: "column",
  height: VIEW_HEIGHT
});
var DateCalendarViewTransitionContainer = styled(PickersFadeTransitionGroup, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (props, styles) => styles.viewTransitionContainer
})({});
var DateCalendar = /* @__PURE__ */ React52.forwardRef(function DateCalendar2(inProps, ref) {
  const utils = useUtils();
  const id = useId();
  const props = useDateCalendarDefaultizedProps(inProps, "MuiDateCalendar");
  const {
    autoFocus,
    onViewChange,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    disableFuture,
    disablePast,
    onChange,
    onYearChange,
    onMonthChange,
    reduceAnimations,
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    view: inView,
    views,
    openTo,
    className,
    disabled,
    readOnly,
    minDate,
    maxDate,
    disableHighlightToday,
    focusedView: inFocusedView,
    onFocusedViewChange,
    showDaysOutsideCurrentMonth,
    fixedWeekNumber,
    dayOfWeekFormatter,
    slots,
    slotProps,
    loading,
    renderLoading,
    displayWeekNumber,
    yearsPerRow,
    monthsPerRow,
    timezone: timezoneProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded30);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValueWithTimezone({
    name: "DateCalendar",
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange,
    valueManager: singleItemValueManager
  });
  const {
    view,
    setView,
    focusedView,
    setFocusedView,
    goToNextView,
    setValueAndGoToNextView
  } = useViews({
    view: inView,
    views,
    openTo,
    onChange: handleValueChange,
    onViewChange,
    autoFocus,
    focusedView: inFocusedView,
    onFocusedViewChange
  });
  const {
    referenceDate,
    calendarState,
    changeFocusedDay,
    changeMonth,
    handleChangeMonth,
    isDateDisabled,
    onMonthSwitchingAnimationEnd
  } = useCalendarState({
    value,
    referenceDate: referenceDateProp,
    reduceAnimations,
    onMonthChange,
    minDate,
    maxDate,
    shouldDisableDate,
    disablePast,
    disableFuture,
    timezone
  });
  const minDateWithDisabled = disabled && value || minDate;
  const maxDateWithDisabled = disabled && value || maxDate;
  const gridLabelId = `${id}-grid-label`;
  const hasFocus = focusedView !== null;
  const CalendarHeader = slots?.calendarHeader ?? PickersCalendarHeader;
  const calendarHeaderProps = useSlotProps({
    elementType: CalendarHeader,
    externalSlotProps: slotProps?.calendarHeader,
    additionalProps: {
      views,
      view,
      currentMonth: calendarState.currentMonth,
      onViewChange: setView,
      onMonthChange: (newMonth, direction) => handleChangeMonth({
        newMonth,
        direction
      }),
      minDate: minDateWithDisabled,
      maxDate: maxDateWithDisabled,
      disabled,
      disablePast,
      disableFuture,
      reduceAnimations,
      timezone,
      labelId: gridLabelId
    },
    ownerState: props
  });
  const handleDateMonthChange = useEventCallback_default((newDate) => {
    const startOfMonth3 = utils.startOfMonth(newDate);
    const endOfMonth2 = utils.endOfMonth(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfMonth3) ? startOfMonth3 : minDate,
      maxDate: utils.isAfter(maxDate, endOfMonth2) ? endOfMonth2 : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, "finish");
      onMonthChange?.(startOfMonth3);
    } else {
      goToNextView();
      changeMonth(startOfMonth3);
    }
    changeFocusedDay(closestEnabledDate, true);
  });
  const handleDateYearChange = useEventCallback_default((newDate) => {
    const startOfYear2 = utils.startOfYear(newDate);
    const endOfYear2 = utils.endOfYear(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfYear2) ? startOfYear2 : minDate,
      maxDate: utils.isAfter(maxDate, endOfYear2) ? endOfYear2 : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, "finish");
      onYearChange?.(closestEnabledDate);
    } else {
      goToNextView();
      changeMonth(startOfYear2);
    }
    changeFocusedDay(closestEnabledDate, true);
  });
  const handleSelectedDayChange = useEventCallback_default((day) => {
    if (day) {
      return handleValueChange(mergeDateAndTime(utils, day, value ?? referenceDate), "finish", view);
    }
    return handleValueChange(day, "finish", view);
  });
  React52.useEffect(() => {
    if (value != null && utils.isValid(value)) {
      changeMonth(value);
    }
  }, [value]);
  const ownerState = props;
  const classes = useUtilityClasses17(ownerState);
  const baseDateValidationProps = {
    disablePast,
    disableFuture,
    maxDate,
    minDate
  };
  const commonViewProps = {
    disableHighlightToday,
    readOnly,
    disabled,
    timezone,
    gridLabelId,
    slots,
    slotProps
  };
  const prevOpenViewRef = React52.useRef(view);
  React52.useEffect(() => {
    if (prevOpenViewRef.current === view) {
      return;
    }
    if (focusedView === prevOpenViewRef.current) {
      setFocusedView(view, true);
    }
    prevOpenViewRef.current = view;
  }, [focusedView, setFocusedView, view]);
  const selectedDays = React52.useMemo(() => [value], [value]);
  return /* @__PURE__ */ jsxs(DateCalendarRoot, _extends({
    ref,
    className: clsx_default(classes.root, className),
    ownerState
  }, other, {
    children: [/* @__PURE__ */ jsx(CalendarHeader, _extends({}, calendarHeaderProps, {
      slots,
      slotProps
    })), /* @__PURE__ */ jsx(DateCalendarViewTransitionContainer, {
      reduceAnimations,
      className: classes.viewTransitionContainer,
      transKey: view,
      ownerState,
      children: /* @__PURE__ */ jsxs("div", {
        children: [view === "year" && /* @__PURE__ */ jsx(YearCalendar, _extends({}, baseDateValidationProps, commonViewProps, {
          value,
          onChange: handleDateYearChange,
          shouldDisableYear,
          hasFocus,
          onFocusedViewChange: (isViewFocused) => setFocusedView("year", isViewFocused),
          yearsPerRow,
          referenceDate
        })), view === "month" && /* @__PURE__ */ jsx(MonthCalendar, _extends({}, baseDateValidationProps, commonViewProps, {
          hasFocus,
          className,
          value,
          onChange: handleDateMonthChange,
          shouldDisableMonth,
          onFocusedViewChange: (isViewFocused) => setFocusedView("month", isViewFocused),
          monthsPerRow,
          referenceDate
        })), view === "day" && /* @__PURE__ */ jsx(DayCalendar, _extends({}, calendarState, baseDateValidationProps, commonViewProps, {
          onMonthSwitchingAnimationEnd,
          onFocusedDayChange: changeFocusedDay,
          reduceAnimations,
          selectedDays,
          onSelectedDaysChange: handleSelectedDayChange,
          shouldDisableDate,
          shouldDisableMonth,
          shouldDisableYear,
          hasFocus,
          onFocusedViewChange: (isViewFocused) => setFocusedView("day", isViewFocused),
          showDaysOutsideCurrentMonth,
          fixedWeekNumber,
          dayOfWeekFormatter,
          displayWeekNumber,
          loading,
          renderLoading
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" ? DateCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: import_prop_types20.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: import_prop_types20.default.object,
  className: import_prop_types20.default.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: import_prop_types20.default.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: import_prop_types20.default.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: import_prop_types20.default.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: import_prop_types20.default.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: import_prop_types20.default.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: import_prop_types20.default.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: import_prop_types20.default.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: import_prop_types20.default.number,
  /**
   * Controlled focused view.
   */
  focusedView: import_prop_types20.default.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: import_prop_types20.default.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: import_prop_types20.default.object,
  /**
   * Minimal selectable date.
   */
  minDate: import_prop_types20.default.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: import_prop_types20.default.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: import_prop_types20.default.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: import_prop_types20.default.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: import_prop_types20.default.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: import_prop_types20.default.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: import_prop_types20.default.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: import_prop_types20.default.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: import_prop_types20.default.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: import_prop_types20.default.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: import_prop_types20.default.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: import_prop_types20.default.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: import_prop_types20.default.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: import_prop_types20.default.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: import_prop_types20.default.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: import_prop_types20.default.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types20.default.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: import_prop_types20.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types20.default.oneOfType([import_prop_types20.default.arrayOf(import_prop_types20.default.oneOfType([import_prop_types20.default.func, import_prop_types20.default.object, import_prop_types20.default.bool])), import_prop_types20.default.func, import_prop_types20.default.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: import_prop_types20.default.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: import_prop_types20.default.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: import_prop_types20.default.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: import_prop_types20.default.arrayOf(import_prop_types20.default.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: import_prop_types20.default.oneOf([3, 4])
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DatePicker/DatePicker.js
var import_prop_types27 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DesktopDatePicker/DesktopDatePicker.js
var import_prop_types25 = __toESM(require_prop_types());
var import_prop_types21 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/components/pickersToolbarClasses.js
function getPickersToolbarUtilityClass(slot) {
  return generateUtilityClass("MuiPickersToolbar", slot);
}
generateUtilityClasses("MuiPickersToolbar", ["root", "content"]);
var _excluded31 = ["children", "className", "toolbarTitle", "hidden", "titleId", "isLandscape", "classes", "landscapeDirection"];
var useUtilityClasses18 = (ownerState) => {
  const {
    classes,
    isLandscape
  } = ownerState;
  const slots = {
    root: ["root"],
    content: ["content"],
    penIconButton: ["penIconButton", isLandscape && "penIconButtonLandscape"]
  };
  return composeClasses(slots, getPickersToolbarUtilityClass, classes);
};
var PickersToolbarRoot = styled("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: theme.spacing(2, 3),
  variants: [{
    props: {
      isLandscape: true
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
}));
var PickersToolbarContent = styled("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (props, styles) => styles.content
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      isLandscape: true
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      isLandscape: true,
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
});
var PickersToolbar = /* @__PURE__ */ React52.forwardRef(function PickersToolbar2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersToolbar"
  });
  const {
    children,
    className,
    toolbarTitle,
    hidden,
    titleId
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded31);
  const ownerState = props;
  const classes = useUtilityClasses18(ownerState);
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxs(PickersToolbarRoot, _extends({
    ref,
    className: clsx_default(classes.root, className),
    ownerState
  }, other, {
    children: [/* @__PURE__ */ jsx(Typography4, {
      color: "text.secondary",
      variant: "overline",
      id: titleId,
      children: toolbarTitle
    }), /* @__PURE__ */ jsx(PickersToolbarContent, {
      className: classes.content,
      ownerState,
      children
    })]
  }));
});

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DatePicker/datePickerToolbarClasses.js
function getDatePickerToolbarUtilityClass(slot) {
  return generateUtilityClass("MuiDatePickerToolbar", slot);
}
generateUtilityClasses("MuiDatePickerToolbar", ["root", "title"]);
var _excluded34 = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className", "onViewChange", "view"];
var useUtilityClasses19 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    title: ["title"]
  };
  return composeClasses(slots, getDatePickerToolbarUtilityClass, classes);
};
var DatePickerToolbarRoot = styled(PickersToolbar, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})({});
var DatePickerToolbarTitle = styled(Typography4, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (_, styles) => styles.title
})({
  variants: [{
    props: {
      isLandscape: true
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
});
var DatePickerToolbar = /* @__PURE__ */ React52.forwardRef(function DatePickerToolbar2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiDatePickerToolbar"
  });
  const {
    value,
    isLandscape,
    toolbarFormat,
    toolbarPlaceholder = "\u2013\u2013",
    views,
    className
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded34);
  const utils = useUtils();
  const localeText = useLocaleText();
  const classes = useUtilityClasses19(props);
  const dateText = React52.useMemo(() => {
    if (!value) {
      return toolbarPlaceholder;
    }
    const formatFromViews = resolveDateFormat(utils, {
      format: toolbarFormat,
      views
    }, true);
    return utils.formatByString(value, formatFromViews);
  }, [value, toolbarFormat, toolbarPlaceholder, utils, views]);
  const ownerState = props;
  return /* @__PURE__ */ jsx(DatePickerToolbarRoot, _extends({
    ref,
    toolbarTitle: localeText.datePickerToolbarTitle,
    isLandscape,
    className: clsx_default(classes.root, className)
  }, other, {
    children: /* @__PURE__ */ jsx(DatePickerToolbarTitle, {
      variant: "h4",
      align: isLandscape ? "left" : "center",
      ownerState,
      className: classes.title,
      children: dateText
    })
  }));
});
process.env.NODE_ENV !== "production" ? DatePickerToolbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: import_prop_types21.default.object,
  className: import_prop_types21.default.string,
  disabled: import_prop_types21.default.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: import_prop_types21.default.bool,
  isLandscape: import_prop_types21.default.bool.isRequired,
  onChange: import_prop_types21.default.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: import_prop_types21.default.func.isRequired,
  readOnly: import_prop_types21.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types21.default.oneOfType([import_prop_types21.default.arrayOf(import_prop_types21.default.oneOfType([import_prop_types21.default.func, import_prop_types21.default.object, import_prop_types21.default.bool])), import_prop_types21.default.func, import_prop_types21.default.object]),
  titleId: import_prop_types21.default.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: import_prop_types21.default.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: import_prop_types21.default.node,
  value: import_prop_types21.default.object,
  /**
   * Currently visible picker view.
   */
  view: import_prop_types21.default.oneOf(["day", "month", "year"]).isRequired,
  /**
   * Available views.
   */
  views: import_prop_types21.default.arrayOf(import_prop_types21.default.oneOf(["day", "month", "year"]).isRequired).isRequired
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DatePicker/shared.js
function useDatePickerDefaultizedProps(props, name) {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const themeProps = useThemeProps({
    props,
    name
  });
  const localeText = React52.useMemo(() => {
    if (themeProps.localeText?.toolbarTitle == null) {
      return themeProps.localeText;
    }
    return _extends({}, themeProps.localeText, {
      datePickerToolbarTitle: themeProps.localeText.toolbarTitle
    });
  }, [themeProps.localeText]);
  return _extends({}, themeProps, {
    localeText
  }, applyDefaultViewProps({
    views: themeProps.views,
    openTo: themeProps.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: themeProps.disableFuture ?? false,
    disablePast: themeProps.disablePast ?? false,
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate),
    slots: _extends({
      toolbar: DatePickerToolbar
    }, themeProps.slots)
  });
}

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/components/pickersPopperClasses.js
function getPickersPopperUtilityClass(slot) {
  return generateUtilityClass("MuiPickersPopper", slot);
}
generateUtilityClasses("MuiPickersPopper", ["root", "paper"]);
var _excluded35 = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"];
var useUtilityClasses20 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    paper: ["paper"]
  };
  return composeClasses(slots, getPickersPopperUtilityClass, classes);
};
var PickersPopperRoot = styled(MuiPopper, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})(({
  theme
}) => ({
  zIndex: theme.zIndex.modal
}));
var PickersPopperPaper = styled(MuiPaper, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (_, styles) => styles.paper
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      placement
    }) => ["top", "top-start", "top-end"].includes(placement),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
function useClickAwayListener(active, onClickAway) {
  const movedRef = React52.useRef(false);
  const syntheticEventRef = React52.useRef(false);
  const nodeRef = React52.useRef(null);
  const activatedRef = React52.useRef(false);
  React52.useEffect(() => {
    if (!active) {
      return void 0;
    }
    function armClickAwayListener() {
      activatedRef.current = true;
    }
    document.addEventListener("mousedown", armClickAwayListener, true);
    document.addEventListener("touchstart", armClickAwayListener, true);
    return () => {
      document.removeEventListener("mousedown", armClickAwayListener, true);
      document.removeEventListener("touchstart", armClickAwayListener, true);
      activatedRef.current = false;
    };
  }, [active]);
  const handleClickAway = useEventCallback_default((event) => {
    if (!activatedRef.current) {
      return;
    }
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = ownerDocument(nodeRef.current);
    if (!nodeRef.current || // is a TouchEvent?
    "clientX" in event && clickedRootScrollbar(event, doc)) {
      return;
    }
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    let insideDOM;
    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }
    if (!insideDOM && !insideReactTree) {
      onClickAway(event);
    }
  });
  const handleSynthetic = () => {
    syntheticEventRef.current = true;
  };
  React52.useEffect(() => {
    if (active) {
      const doc = ownerDocument(nodeRef.current);
      const handleTouchMove = () => {
        movedRef.current = true;
      };
      doc.addEventListener("touchstart", handleClickAway);
      doc.addEventListener("touchmove", handleTouchMove);
      return () => {
        doc.removeEventListener("touchstart", handleClickAway);
        doc.removeEventListener("touchmove", handleTouchMove);
      };
    }
    return void 0;
  }, [active, handleClickAway]);
  React52.useEffect(() => {
    if (active) {
      const doc = ownerDocument(nodeRef.current);
      doc.addEventListener("click", handleClickAway);
      return () => {
        doc.removeEventListener("click", handleClickAway);
        syntheticEventRef.current = false;
      };
    }
    return void 0;
  }, [active, handleClickAway]);
  return [nodeRef, handleSynthetic, handleSynthetic];
}
var PickersPopperPaperWrapper = /* @__PURE__ */ React52.forwardRef((props, ref) => {
  const {
    PaperComponent,
    popperPlacement,
    ownerState: inOwnerState,
    children,
    paperSlotProps,
    paperClasses,
    onPaperClick,
    onPaperTouchStart
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded35);
  const ownerState = _extends({}, inOwnerState, {
    placement: popperPlacement
  });
  const paperProps = useSlotProps({
    elementType: PaperComponent,
    externalSlotProps: paperSlotProps,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref
    },
    className: paperClasses,
    ownerState
  });
  return /* @__PURE__ */ jsx(PaperComponent, _extends({}, other, paperProps, {
    onClick: (event) => {
      onPaperClick(event);
      paperProps.onClick?.(event);
    },
    onTouchStart: (event) => {
      onPaperTouchStart(event);
      paperProps.onTouchStart?.(event);
    },
    ownerState,
    children
  }));
});
function PickersPopper(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersPopper"
  });
  const {
    anchorEl,
    children,
    containerRef = null,
    shouldRestoreFocus,
    onBlur,
    onDismiss,
    open,
    role,
    placement,
    slots,
    slotProps,
    reduceAnimations: inReduceAnimations
  } = props;
  React52.useEffect(() => {
    function handleKeyDown2(nativeEvent) {
      if (open && nativeEvent.key === "Escape") {
        onDismiss();
      }
    }
    document.addEventListener("keydown", handleKeyDown2);
    return () => {
      document.removeEventListener("keydown", handleKeyDown2);
    };
  }, [onDismiss, open]);
  const lastFocusedElementRef = React52.useRef(null);
  React52.useEffect(() => {
    if (role === "tooltip" || shouldRestoreFocus && !shouldRestoreFocus()) {
      return;
    }
    if (open) {
      lastFocusedElementRef.current = getActiveElement(document);
    } else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) {
      setTimeout(() => {
        if (lastFocusedElementRef.current instanceof HTMLElement) {
          lastFocusedElementRef.current.focus();
        }
      });
    }
  }, [open, role, shouldRestoreFocus]);
  const [clickAwayRef, onPaperClick, onPaperTouchStart] = useClickAwayListener(open, onBlur ?? onDismiss);
  const paperRef = React52.useRef(null);
  const handleRef = useForkRef(paperRef, containerRef);
  const handlePaperRef = useForkRef(handleRef, clickAwayRef);
  const ownerState = props;
  const classes = useUtilityClasses20(ownerState);
  const defaultReduceAnimations = useDefaultReduceAnimations();
  const reduceAnimations = inReduceAnimations ?? defaultReduceAnimations;
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      event.stopPropagation();
      onDismiss();
    }
  };
  const Transition2 = slots?.desktopTransition ?? reduceAnimations ? Fade : Grow;
  const FocusTrap = slots?.desktopTrapFocus ?? BaseFocusTrap;
  const Paper4 = slots?.desktopPaper ?? PickersPopperPaper;
  const Popper = slots?.popper ?? PickersPopperRoot;
  const popperProps = useSlotProps({
    elementType: Popper,
    externalSlotProps: slotProps?.popper,
    additionalProps: {
      transition: true,
      role,
      open,
      anchorEl,
      placement,
      onKeyDown: handleKeyDown
    },
    className: classes.root,
    ownerState: props
  });
  return /* @__PURE__ */ jsx(Popper, _extends({}, popperProps, {
    children: ({
      TransitionProps,
      placement: popperPlacement
    }) => /* @__PURE__ */ jsx(FocusTrap, _extends({
      open,
      disableAutoFocus: true,
      disableRestoreFocus: true,
      disableEnforceFocus: role === "tooltip",
      isEnabled: () => true
    }, slotProps?.desktopTrapFocus, {
      children: /* @__PURE__ */ jsx(Transition2, _extends({}, TransitionProps, slotProps?.desktopTransition, {
        children: /* @__PURE__ */ jsx(PickersPopperPaperWrapper, {
          PaperComponent: Paper4,
          ownerState,
          popperPlacement,
          ref: handlePaperRef,
          onPaperClick,
          onPaperTouchStart,
          paperClasses: classes.paper,
          paperSlotProps: slotProps?.desktopPaper,
          children
        })
      }))
    }))
  }));
}
var useOpenState = ({
  open,
  onOpen,
  onClose
}) => {
  const isControllingOpenProp = React52.useRef(typeof open === "boolean").current;
  const [openState, setIsOpenState] = React52.useState(false);
  React52.useEffect(() => {
    if (isControllingOpenProp) {
      if (typeof open !== "boolean") {
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      }
      setIsOpenState(open);
    }
  }, [isControllingOpenProp, open]);
  const setIsOpen = React52.useCallback((newIsOpen) => {
    if (!isControllingOpenProp) {
      setIsOpenState(newIsOpen);
    }
    if (newIsOpen && onOpen) {
      onOpen();
    }
    if (!newIsOpen && onClose) {
      onClose();
    }
  }, [isControllingOpenProp, onOpen, onClose]);
  return {
    isOpen: openState,
    setIsOpen
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/usePicker/usePickerValue.js
var shouldPublishValue = (params) => {
  const {
    action,
    hasChanged,
    dateState,
    isControlled
  } = params;
  const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
  if (action.name === "setValueFromField") {
    return true;
  }
  if (action.name === "setValueFromAction") {
    if (isCurrentValueTheDefaultValue && ["accept", "today", "clear"].includes(action.pickerAction)) {
      return true;
    }
    return hasChanged(dateState.lastPublishedValue);
  }
  if (action.name === "setValueFromView" && action.selectionState !== "shallow") {
    if (isCurrentValueTheDefaultValue) {
      return true;
    }
    return hasChanged(dateState.lastPublishedValue);
  }
  if (action.name === "setValueFromShortcut") {
    if (isCurrentValueTheDefaultValue) {
      return true;
    }
    return hasChanged(dateState.lastPublishedValue);
  }
  return false;
};
var shouldCommitValue = (params) => {
  const {
    action,
    hasChanged,
    dateState,
    isControlled,
    closeOnSelect
  } = params;
  const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
  if (action.name === "setValueFromAction") {
    if (isCurrentValueTheDefaultValue && ["accept", "today", "clear"].includes(action.pickerAction)) {
      return true;
    }
    return hasChanged(dateState.lastCommittedValue);
  }
  if (action.name === "setValueFromView" && action.selectionState === "finish" && closeOnSelect) {
    if (isCurrentValueTheDefaultValue) {
      return true;
    }
    return hasChanged(dateState.lastCommittedValue);
  }
  if (action.name === "setValueFromShortcut") {
    return action.changeImportance === "accept" && hasChanged(dateState.lastCommittedValue);
  }
  return false;
};
var shouldClosePicker = (params) => {
  const {
    action,
    closeOnSelect
  } = params;
  if (action.name === "setValueFromAction") {
    return true;
  }
  if (action.name === "setValueFromView") {
    return action.selectionState === "finish" && closeOnSelect;
  }
  if (action.name === "setValueFromShortcut") {
    return action.changeImportance === "accept";
  }
  return false;
};
var usePickerValue = ({
  props,
  valueManager,
  valueType,
  wrapperVariant,
  validator
}) => {
  const {
    onAccept,
    onChange,
    value: inValue,
    defaultValue: inDefaultValue,
    closeOnSelect = wrapperVariant === "desktop",
    timezone: timezoneProp
  } = props;
  const {
    current: defaultValue
  } = React52.useRef(inDefaultValue);
  const {
    current: isControlled
  } = React52.useRef(inValue !== void 0);
  if (process.env.NODE_ENV !== "production") {
    React52.useEffect(() => {
      if (isControlled !== (inValue !== void 0)) {
        console.error([`MUI X: A component is changing the ${isControlled ? "" : "un"}controlled value of a picker to be ${isControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled valuefor the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join("\n"));
      }
    }, [inValue]);
    React52.useEffect(() => {
      if (!isControlled && defaultValue !== inDefaultValue) {
        console.error([`MUI X: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value.`].join("\n"));
      }
    }, [JSON.stringify(defaultValue)]);
  }
  const utils = useUtils();
  const adapter = useLocalizationContext();
  const {
    isOpen,
    setIsOpen
  } = useOpenState(props);
  const [dateState, setDateState] = React52.useState(() => {
    let initialValue;
    if (inValue !== void 0) {
      initialValue = inValue;
    } else if (defaultValue !== void 0) {
      initialValue = defaultValue;
    } else {
      initialValue = valueManager.emptyValue;
    }
    return {
      draft: initialValue,
      lastPublishedValue: initialValue,
      lastCommittedValue: initialValue,
      lastControlledValue: inValue,
      hasBeenModifiedSinceMount: false
    };
  });
  const {
    timezone,
    handleValueChange
  } = useValueWithTimezone({
    timezone: timezoneProp,
    value: inValue,
    defaultValue,
    onChange,
    valueManager
  });
  useValidation(_extends({}, props, {
    value: dateState.draft,
    timezone
  }), validator, valueManager.isSameError, valueManager.defaultErrorState);
  const updateDate = useEventCallback_default((action) => {
    const updaterParams = {
      action,
      dateState,
      hasChanged: (comparison) => !valueManager.areValuesEqual(utils, action.value, comparison),
      isControlled,
      closeOnSelect
    };
    const shouldPublish = shouldPublishValue(updaterParams);
    const shouldCommit = shouldCommitValue(updaterParams);
    const shouldClose = shouldClosePicker(updaterParams);
    setDateState((prev) => _extends({}, prev, {
      draft: action.value,
      lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
      lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
      hasBeenModifiedSinceMount: true
    }));
    if (shouldPublish) {
      const validationError = action.name === "setValueFromField" ? action.context.validationError : validator({
        adapter,
        value: action.value,
        props: _extends({}, props, {
          value: action.value,
          timezone
        })
      });
      const context = {
        validationError
      };
      if (action.name === "setValueFromShortcut") {
        context.shortcut = action.shortcut;
      }
      handleValueChange(action.value, context);
    }
    if (shouldCommit && onAccept) {
      onAccept(action.value);
    }
    if (shouldClose) {
      setIsOpen(false);
    }
  });
  if (inValue !== void 0 && (dateState.lastControlledValue === void 0 || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
    const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
    setDateState((prev) => _extends({}, prev, {
      lastControlledValue: inValue
    }, isUpdateComingFromPicker ? {} : {
      lastCommittedValue: inValue,
      lastPublishedValue: inValue,
      draft: inValue,
      hasBeenModifiedSinceMount: true
    }));
  }
  const handleClear = useEventCallback_default(() => {
    updateDate({
      value: valueManager.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  });
  const handleAccept = useEventCallback_default(() => {
    updateDate({
      value: dateState.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  });
  const handleDismiss = useEventCallback_default(() => {
    updateDate({
      value: dateState.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  });
  const handleCancel = useEventCallback_default(() => {
    updateDate({
      value: dateState.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  });
  const handleSetToday = useEventCallback_default(() => {
    updateDate({
      value: valueManager.getTodayValue(utils, timezone, valueType),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  });
  const handleOpen = useEventCallback_default((event) => {
    event.preventDefault();
    setIsOpen(true);
  });
  const handleClose = useEventCallback_default((event) => {
    event?.preventDefault();
    setIsOpen(false);
  });
  const handleChange = useEventCallback_default((newValue, selectionState = "partial") => updateDate({
    name: "setValueFromView",
    value: newValue,
    selectionState
  }));
  const handleSelectShortcut = useEventCallback_default((newValue, changeImportance, shortcut) => updateDate({
    name: "setValueFromShortcut",
    value: newValue,
    changeImportance,
    shortcut
  }));
  const handleChangeFromField = useEventCallback_default((newValue, context) => updateDate({
    name: "setValueFromField",
    value: newValue,
    context
  }));
  const actions = {
    onClear: handleClear,
    onAccept: handleAccept,
    onDismiss: handleDismiss,
    onCancel: handleCancel,
    onSetToday: handleSetToday,
    onOpen: handleOpen,
    onClose: handleClose
  };
  const fieldResponse = {
    value: dateState.draft,
    onChange: handleChangeFromField
  };
  const viewValue = React52.useMemo(() => valueManager.cleanValue(utils, dateState.draft), [utils, valueManager, dateState.draft]);
  const viewResponse = {
    value: viewValue,
    onChange: handleChange,
    onClose: handleClose,
    open: isOpen
  };
  const isValid2 = (testedValue) => {
    const error = validator({
      adapter,
      value: testedValue,
      props: _extends({}, props, {
        value: testedValue,
        timezone
      })
    });
    return !valueManager.hasError(error);
  };
  const layoutResponse = _extends({}, actions, {
    value: viewValue,
    onChange: handleChange,
    onSelectShortcut: handleSelectShortcut,
    isValid: isValid2
  });
  return {
    open: isOpen,
    fieldProps: fieldResponse,
    viewProps: viewResponse,
    layoutProps: layoutResponse,
    actions
  };
};
var _excluded36 = ["className", "sx"];
var usePickerViews = ({
  props,
  propsFromPickerValue,
  additionalViewProps,
  autoFocusView,
  rendererInterceptor,
  fieldRef
}) => {
  const {
    onChange,
    open,
    onClose
  } = propsFromPickerValue;
  const {
    views,
    openTo,
    onViewChange,
    viewRenderers,
    timezone
  } = props;
  const propsToForwardToView = _objectWithoutPropertiesLoose(props, _excluded36);
  const {
    view,
    setView,
    defaultView,
    focusedView,
    setFocusedView,
    setValueAndGoToNextView
  } = useViews({
    view: void 0,
    views,
    openTo,
    onChange,
    onViewChange,
    autoFocus: autoFocusView
  });
  const {
    hasUIView,
    viewModeLookup
  } = React52.useMemo(() => views.reduce((acc, viewForReduce) => {
    let viewMode;
    if (viewRenderers[viewForReduce] != null) {
      viewMode = "UI";
    } else {
      viewMode = "field";
    }
    acc.viewModeLookup[viewForReduce] = viewMode;
    if (viewMode === "UI") {
      acc.hasUIView = true;
    }
    return acc;
  }, {
    hasUIView: false,
    viewModeLookup: {}
  }), [viewRenderers, views]);
  const timeViewsCount = React52.useMemo(() => views.reduce((acc, viewForReduce) => {
    if (viewRenderers[viewForReduce] != null && isTimeView(viewForReduce)) {
      return acc + 1;
    }
    return acc;
  }, 0), [viewRenderers, views]);
  const currentViewMode = viewModeLookup[view];
  const shouldRestoreFocus = useEventCallback_default(() => currentViewMode === "UI");
  const [popperView, setPopperView] = React52.useState(currentViewMode === "UI" ? view : null);
  if (popperView !== view && viewModeLookup[view] === "UI") {
    setPopperView(view);
  }
  useEnhancedEffect_default(() => {
    if (currentViewMode === "field" && open) {
      onClose();
      setTimeout(() => {
        fieldRef?.current?.setSelectedSections(view);
        fieldRef?.current?.focusField(view);
      });
    }
  }, [view]);
  useEnhancedEffect_default(() => {
    if (!open) {
      return;
    }
    let newView = view;
    if (currentViewMode === "field" && popperView != null) {
      newView = popperView;
    }
    if (newView !== defaultView && viewModeLookup[newView] === "UI" && viewModeLookup[defaultView] === "UI") {
      newView = defaultView;
    }
    if (newView !== view) {
      setView(newView);
    }
    setFocusedView(newView, true);
  }, [open]);
  const layoutProps = {
    views,
    view: popperView,
    onViewChange: setView
  };
  return {
    hasUIView,
    shouldRestoreFocus,
    layoutProps,
    renderCurrentView: () => {
      if (popperView == null) {
        return null;
      }
      const renderer = viewRenderers[popperView];
      if (renderer == null) {
        return null;
      }
      const rendererProps = _extends({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
        views,
        timezone,
        onChange: setValueAndGoToNextView,
        view: popperView,
        onViewChange: setView,
        focusedView,
        onFocusedViewChange: setFocusedView,
        showViewSwitcher: timeViewsCount > 1,
        timeViewsCount
      });
      if (rendererInterceptor) {
        return rendererInterceptor(viewRenderers, popperView, rendererProps);
      }
      return renderer(rendererProps);
    }
  };
};
function getOrientation() {
  if (typeof window === "undefined") {
    return "portrait";
  }
  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait";
  }
  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
  }
  return "portrait";
}
var useIsLandscape = (views, customOrientation) => {
  const [orientation, setOrientation] = React52.useState(getOrientation);
  useEnhancedEffect_default(() => {
    const eventHandler = () => {
      setOrientation(getOrientation());
    };
    window.addEventListener("orientationchange", eventHandler);
    return () => {
      window.removeEventListener("orientationchange", eventHandler);
    };
  }, []);
  if (arrayIncludes(views, ["hours", "minutes", "seconds"])) {
    return false;
  }
  const orientationToUse = customOrientation || orientation;
  return orientationToUse === "landscape";
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/usePicker/usePickerLayoutProps.js
var usePickerLayoutProps = ({
  props,
  propsFromPickerValue,
  propsFromPickerViews,
  wrapperVariant
}) => {
  const {
    orientation
  } = props;
  const isLandscape = useIsLandscape(propsFromPickerViews.views, orientation);
  const isRtl = useRtl();
  const layoutProps = _extends({}, propsFromPickerViews, propsFromPickerValue, {
    isLandscape,
    isRtl,
    wrapperVariant,
    disabled: props.disabled,
    readOnly: props.readOnly
  });
  return {
    layoutProps
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/utils/warning.js
var buildWarning = (message, gravity = "warning") => {
  let alreadyWarned = false;
  const cleanMessage = Array.isArray(message) ? message.join("\n") : message;
  return () => {
    if (!alreadyWarned) {
      alreadyWarned = true;
      if (gravity === "error") {
        console.error(cleanMessage);
      } else {
        console.warn(cleanMessage);
      }
    }
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/internals/hooks/usePicker/usePicker.js
var warnRenderInputIsDefined = buildWarning(["The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]);
var usePicker = ({
  props,
  valueManager,
  valueType,
  wrapperVariant,
  additionalViewProps,
  validator,
  autoFocusView,
  rendererInterceptor,
  fieldRef
}) => {
  if (process.env.NODE_ENV !== "production") {
    if (props.renderInput != null) {
      warnRenderInputIsDefined();
    }
  }
  const pickerValueResponse = usePickerValue({
    props,
    valueManager,
    valueType,
    wrapperVariant,
    validator
  });
  const pickerViewsResponse = usePickerViews({
    props,
    additionalViewProps,
    autoFocusView,
    fieldRef,
    propsFromPickerValue: pickerValueResponse.viewProps,
    rendererInterceptor
  });
  const pickerLayoutResponse = usePickerLayoutProps({
    props,
    wrapperVariant,
    propsFromPickerValue: pickerValueResponse.layoutProps,
    propsFromPickerViews: pickerViewsResponse.layoutProps
  });
  return {
    // Picker value
    open: pickerValueResponse.open,
    actions: pickerValueResponse.actions,
    fieldProps: pickerValueResponse.fieldProps,
    // Picker views
    renderCurrentView: pickerViewsResponse.renderCurrentView,
    hasUIView: pickerViewsResponse.hasUIView,
    shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
    // Picker layout
    layoutProps: pickerLayoutResponse.layoutProps
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersLayout/PickersLayout.js
var import_prop_types24 = __toESM(require_prop_types());

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersLayout/pickersLayoutClasses.js
function getPickersLayoutUtilityClass(slot) {
  return generateUtilityClass("MuiPickersLayout", slot);
}
var pickersLayoutClasses = generateUtilityClasses("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]);

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersActionBar/PickersActionBar.js
var import_prop_types22 = __toESM(require_prop_types());
var _excluded37 = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function PickersActionBar(props) {
  const {
    onAccept,
    onClear,
    onCancel,
    onSetToday,
    actions
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded37);
  const localeText = useLocaleText();
  if (actions == null || actions.length === 0) {
    return null;
  }
  const buttons = actions?.map((actionType) => {
    switch (actionType) {
      case "clear":
        return /* @__PURE__ */ jsx(Button$1, {
          onClick: onClear,
          children: localeText.clearButtonLabel
        }, actionType);
      case "cancel":
        return /* @__PURE__ */ jsx(Button$1, {
          onClick: onCancel,
          children: localeText.cancelButtonLabel
        }, actionType);
      case "accept":
        return /* @__PURE__ */ jsx(Button$1, {
          onClick: onAccept,
          children: localeText.okButtonLabel
        }, actionType);
      case "today":
        return /* @__PURE__ */ jsx(Button$1, {
          onClick: onSetToday,
          children: localeText.todayButtonLabel
        }, actionType);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ jsx(DialogActions, _extends({}, other, {
    children: buttons
  }));
}
process.env.NODE_ENV !== "production" ? PickersActionBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: import_prop_types22.default.arrayOf(import_prop_types22.default.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: import_prop_types22.default.bool,
  onAccept: import_prop_types22.default.func.isRequired,
  onCancel: import_prop_types22.default.func.isRequired,
  onClear: import_prop_types22.default.func.isRequired,
  onSetToday: import_prop_types22.default.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types22.default.oneOfType([import_prop_types22.default.arrayOf(import_prop_types22.default.oneOfType([import_prop_types22.default.func, import_prop_types22.default.object, import_prop_types22.default.bool])), import_prop_types22.default.func, import_prop_types22.default.object])
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/PickersShortcuts/PickersShortcuts.js
var import_prop_types23 = __toESM(require_prop_types());
var _excluded38 = ["items", "changeImportance", "isLandscape", "onChange", "isValid"];
var _excluded211 = ["getValue"];
function PickersShortcuts(props) {
  const {
    items,
    changeImportance = "accept",
    onChange,
    isValid: isValid2
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded38);
  if (items == null || items.length === 0) {
    return null;
  }
  const resolvedItems = items.map((_ref) => {
    let {
      getValue: getValue2
    } = _ref, item = _objectWithoutPropertiesLoose(_ref, _excluded211);
    const newValue = getValue2({
      isValid: isValid2
    });
    return _extends({}, item, {
      label: item.label,
      onClick: () => {
        onChange(newValue, changeImportance, item);
      },
      disabled: !isValid2(newValue)
    });
  });
  return /* @__PURE__ */ jsx(List, _extends({
    dense: true,
    sx: [{
      maxHeight: VIEW_HEIGHT,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(other.sx) ? other.sx : [other.sx]]
  }, other, {
    children: resolvedItems.map((item) => {
      return /* @__PURE__ */ jsx(ListItem, {
        children: /* @__PURE__ */ jsx(Chip, _extends({}, item))
      }, item.id ?? item.label);
    })
  }));
}
process.env.NODE_ENV !== "production" ? PickersShortcuts.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: import_prop_types23.default.oneOf(["accept", "set"]),
  className: import_prop_types23.default.string,
  component: import_prop_types23.default.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: import_prop_types23.default.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: import_prop_types23.default.bool,
  isLandscape: import_prop_types23.default.bool.isRequired,
  isValid: import_prop_types23.default.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: import_prop_types23.default.arrayOf(import_prop_types23.default.shape({
    getValue: import_prop_types23.default.func.isRequired,
    id: import_prop_types23.default.string,
    label: import_prop_types23.default.string.isRequired
  })),
  onChange: import_prop_types23.default.func.isRequired,
  style: import_prop_types23.default.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: import_prop_types23.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types23.default.oneOfType([import_prop_types23.default.arrayOf(import_prop_types23.default.oneOfType([import_prop_types23.default.func, import_prop_types23.default.object, import_prop_types23.default.bool])), import_prop_types23.default.func, import_prop_types23.default.object])
} : void 0;
function toolbarHasView(toolbarProps) {
  return toolbarProps.view !== null;
}
var useUtilityClasses21 = (ownerState) => {
  const {
    classes,
    isLandscape
  } = ownerState;
  const slots = {
    root: ["root", isLandscape && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  };
  return composeClasses(slots, getPickersLayoutUtilityClass, classes);
};
var usePickerLayout = (props) => {
  const {
    wrapperVariant,
    onAccept,
    onClear,
    onCancel,
    onSetToday,
    view,
    views,
    onViewChange,
    value,
    onChange,
    onSelectShortcut,
    isValid: isValid2,
    isLandscape,
    disabled,
    readOnly,
    children,
    slots,
    slotProps
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = props;
  const classes = useUtilityClasses21(props);
  const ActionBar = slots?.actionBar ?? PickersActionBar;
  const actionBarProps = useSlotProps({
    elementType: ActionBar,
    externalSlotProps: slotProps?.actionBar,
    additionalProps: {
      onAccept,
      onClear,
      onCancel,
      onSetToday,
      actions: wrapperVariant === "desktop" ? [] : ["cancel", "accept"]
    },
    className: classes.actionBar,
    ownerState: _extends({}, props, {
      wrapperVariant
    })
  });
  const actionBar = /* @__PURE__ */ jsx(ActionBar, _extends({}, actionBarProps));
  const Toolbar = slots?.toolbar;
  const toolbarProps = useSlotProps({
    elementType: Toolbar,
    externalSlotProps: slotProps?.toolbar,
    additionalProps: {
      isLandscape,
      onChange,
      value,
      view,
      onViewChange,
      views,
      disabled,
      readOnly
    },
    className: classes.toolbar,
    ownerState: _extends({}, props, {
      wrapperVariant
    })
  });
  const toolbar = toolbarHasView(toolbarProps) && !!Toolbar ? /* @__PURE__ */ jsx(Toolbar, _extends({}, toolbarProps)) : null;
  const content = children;
  const Tabs = slots?.tabs;
  const tabs = view && Tabs ? /* @__PURE__ */ jsx(Tabs, _extends({
    view,
    onViewChange,
    className: classes.tabs
  }, slotProps?.tabs)) : null;
  const Shortcuts = slots?.shortcuts ?? PickersShortcuts;
  const shortcutsProps = useSlotProps({
    elementType: Shortcuts,
    externalSlotProps: slotProps?.shortcuts,
    additionalProps: {
      isValid: isValid2,
      isLandscape,
      onChange: onSelectShortcut
    },
    className: classes.shortcuts,
    ownerState: {
      isValid: isValid2,
      isLandscape,
      onChange: onSelectShortcut,
      wrapperVariant
    }
  });
  const shortcuts = view && !!Shortcuts ? /* @__PURE__ */ jsx(Shortcuts, _extends({}, shortcutsProps)) : null;
  return {
    toolbar,
    content,
    tabs,
    actionBar,
    shortcuts
  };
};
var usePickerLayout_default = usePickerLayout;
var useUtilityClasses22 = (ownerState) => {
  const {
    isLandscape,
    classes
  } = ownerState;
  const slots = {
    root: ["root", isLandscape && "landscape"],
    contentWrapper: ["contentWrapper"]
  };
  return composeClasses(slots, getPickersLayoutUtilityClass, classes);
};
var PickersLayoutRoot = styled("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${pickersLayoutClasses.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      isLandscape: true
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      },
      [`.${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      }
    }
  }, {
    props: {
      isLandscape: true,
      isRtl: true
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: 3
      }
    }
  }, {
    props: {
      isLandscape: false
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      isLandscape: false,
      isRtl: true
    },
    style: {
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 3
      }
    }
  }]
});
var PickersLayoutContentWrapper = styled("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (props, styles) => styles.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
});
var PickersLayout = function PickersLayout2(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersLayout"
  });
  const {
    toolbar,
    content,
    tabs,
    actionBar,
    shortcuts
  } = usePickerLayout_default(props);
  const {
    sx,
    className,
    isLandscape,
    ref,
    wrapperVariant
  } = props;
  const classes = useUtilityClasses22(props);
  return /* @__PURE__ */ jsxs(PickersLayoutRoot, {
    ref,
    sx,
    className: clsx_default(className, classes.root),
    ownerState: props,
    children: [isLandscape ? shortcuts : toolbar, isLandscape ? toolbar : shortcuts, /* @__PURE__ */ jsx(PickersLayoutContentWrapper, {
      className: classes.contentWrapper,
      children: wrapperVariant === "desktop" ? /* @__PURE__ */ jsxs(React52.Fragment, {
        children: [content, tabs]
      }) : /* @__PURE__ */ jsxs(React52.Fragment, {
        children: [tabs, content]
      })
    }), actionBar]
  });
};
process.env.NODE_ENV !== "production" ? PickersLayout.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: import_prop_types24.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: import_prop_types24.default.object,
  className: import_prop_types24.default.string,
  disabled: import_prop_types24.default.bool,
  isLandscape: import_prop_types24.default.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: import_prop_types24.default.bool.isRequired,
  isValid: import_prop_types24.default.func.isRequired,
  onAccept: import_prop_types24.default.func.isRequired,
  onCancel: import_prop_types24.default.func.isRequired,
  onChange: import_prop_types24.default.func.isRequired,
  onClear: import_prop_types24.default.func.isRequired,
  onClose: import_prop_types24.default.func.isRequired,
  onDismiss: import_prop_types24.default.func.isRequired,
  onOpen: import_prop_types24.default.func.isRequired,
  onSelectShortcut: import_prop_types24.default.func.isRequired,
  onSetToday: import_prop_types24.default.func.isRequired,
  onViewChange: import_prop_types24.default.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: import_prop_types24.default.oneOf(["landscape", "portrait"]),
  readOnly: import_prop_types24.default.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types24.default.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: import_prop_types24.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types24.default.oneOfType([import_prop_types24.default.arrayOf(import_prop_types24.default.oneOfType([import_prop_types24.default.func, import_prop_types24.default.object, import_prop_types24.default.bool])), import_prop_types24.default.func, import_prop_types24.default.object]),
  value: import_prop_types24.default.any,
  view: import_prop_types24.default.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: import_prop_types24.default.arrayOf(import_prop_types24.default.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: import_prop_types24.default.oneOf(["desktop", "mobile"])
} : void 0;
var _excluded39 = ["props", "getOpenDialogAriaText"];
var _excluded212 = ["ownerState"];
var _excluded310 = ["ownerState"];
var useDesktopPicker = (_ref) => {
  let {
    props,
    getOpenDialogAriaText
  } = _ref, pickerParams = _objectWithoutPropertiesLoose(_ref, _excluded39);
  const {
    slots,
    slotProps: innerSlotProps,
    className,
    sx,
    format: format4,
    formatDensity,
    enableAccessibleFieldDOMStructure,
    selectedSections,
    onSelectedSectionsChange,
    timezone,
    name,
    label,
    inputRef,
    readOnly,
    disabled,
    autoFocus,
    localeText,
    reduceAnimations
  } = props;
  const utils = useUtils();
  const containerRef = React52.useRef(null);
  const fieldRef = React52.useRef(null);
  const labelId = useId();
  const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
  const {
    open,
    actions,
    hasUIView,
    layoutProps,
    renderCurrentView,
    shouldRestoreFocus,
    fieldProps: pickerFieldProps
  } = usePicker(_extends({}, pickerParams, {
    props,
    fieldRef,
    autoFocusView: true,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  }));
  const InputAdornment5 = slots.inputAdornment ?? InputAdornment$1;
  const _useSlotProps = useSlotProps({
    elementType: InputAdornment5,
    externalSlotProps: innerSlotProps?.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: props
  }), inputAdornmentProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded212);
  const OpenPickerButton = slots.openPickerButton ?? IconButton4;
  const _useSlotProps2 = useSlotProps({
    elementType: OpenPickerButton,
    externalSlotProps: innerSlotProps?.openPickerButton,
    additionalProps: {
      disabled: disabled || readOnly,
      onClick: open ? actions.onClose : actions.onOpen,
      "aria-label": getOpenDialogAriaText(pickerFieldProps.value, utils),
      edge: inputAdornmentProps.position
    },
    ownerState: props
  }), openPickerButtonProps = _objectWithoutPropertiesLoose(_useSlotProps2, _excluded310);
  const OpenPickerIcon = slots.openPickerIcon;
  const Field = slots.field;
  const fieldProps = useSlotProps({
    elementType: Field,
    externalSlotProps: innerSlotProps?.field,
    additionalProps: _extends({}, pickerFieldProps, isToolbarHidden && {
      id: labelId
    }, {
      readOnly,
      disabled,
      className,
      sx,
      format: format4,
      formatDensity,
      enableAccessibleFieldDOMStructure,
      selectedSections,
      onSelectedSectionsChange,
      timezone,
      label,
      name,
      autoFocus: autoFocus && !props.open,
      focused: open ? true : void 0
    }, inputRef ? {
      inputRef
    } : {}),
    ownerState: props
  });
  if (hasUIView) {
    fieldProps.InputProps = _extends({}, fieldProps.InputProps, {
      ref: containerRef
    }, !props.disableOpenPicker && {
      [`${inputAdornmentProps.position}Adornment`]: /* @__PURE__ */ jsx(InputAdornment5, _extends({}, inputAdornmentProps, {
        children: /* @__PURE__ */ jsx(OpenPickerButton, _extends({}, openPickerButtonProps, {
          children: /* @__PURE__ */ jsx(OpenPickerIcon, _extends({}, innerSlotProps?.openPickerIcon))
        }))
      }))
    });
  }
  const slotsForField = _extends({
    textField: slots.textField,
    clearIcon: slots.clearIcon,
    clearButton: slots.clearButton
  }, fieldProps.slots);
  const Layout = slots.layout ?? PickersLayout;
  let labelledById = labelId;
  if (isToolbarHidden) {
    if (label) {
      labelledById = `${labelId}-label`;
    } else {
      labelledById = void 0;
    }
  }
  const slotProps = _extends({}, innerSlotProps, {
    toolbar: _extends({}, innerSlotProps?.toolbar, {
      titleId: labelId
    }),
    popper: _extends({
      "aria-labelledby": labelledById
    }, innerSlotProps?.popper)
  });
  const handleFieldRef = useForkRef(fieldRef, fieldProps.unstableFieldRef);
  const renderPicker = () => /* @__PURE__ */ jsxs(LocalizationProvider, {
    localeText,
    children: [/* @__PURE__ */ jsx(Field, _extends({}, fieldProps, {
      slots: slotsForField,
      slotProps,
      unstableFieldRef: handleFieldRef
    })), /* @__PURE__ */ jsx(PickersPopper, _extends({
      role: "dialog",
      placement: "bottom-start",
      anchorEl: containerRef.current
    }, actions, {
      open,
      slots,
      slotProps,
      shouldRestoreFocus,
      reduceAnimations,
      children: /* @__PURE__ */ jsx(Layout, _extends({}, layoutProps, slotProps?.layout, {
        slots,
        slotProps,
        children: renderCurrentView()
      }))
    }))]
  });
  return {
    renderPicker
  };
};
var renderDateViewCalendar = ({
  view,
  onViewChange,
  views,
  focusedView,
  onFocusedViewChange,
  value,
  defaultValue,
  referenceDate,
  onChange,
  className,
  classes,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  reduceAnimations,
  onMonthChange,
  monthsPerRow,
  onYearChange,
  yearsPerRow,
  slots,
  slotProps,
  loading,
  renderLoading,
  disableHighlightToday,
  readOnly,
  disabled,
  showDaysOutsideCurrentMonth,
  dayOfWeekFormatter,
  sx,
  autoFocus,
  fixedWeekNumber,
  displayWeekNumber,
  timezone
}) => /* @__PURE__ */ jsx(DateCalendar, {
  view,
  onViewChange,
  views: views.filter(isDatePickerView),
  focusedView: focusedView && isDatePickerView(focusedView) ? focusedView : null,
  onFocusedViewChange,
  value,
  defaultValue,
  referenceDate,
  onChange,
  className,
  classes,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  reduceAnimations,
  onMonthChange,
  monthsPerRow,
  onYearChange,
  yearsPerRow,
  slots,
  slotProps,
  loading,
  renderLoading,
  disableHighlightToday,
  readOnly,
  disabled,
  showDaysOutsideCurrentMonth,
  dayOfWeekFormatter,
  sx,
  autoFocus,
  fixedWeekNumber,
  displayWeekNumber,
  timezone
});

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/DesktopDatePicker/DesktopDatePicker.js
var DesktopDatePicker = /* @__PURE__ */ React52.forwardRef(function DesktopDatePicker2(inProps, ref) {
  const localeText = useLocaleText();
  const utils = useUtils();
  const defaultizedProps = useDatePickerDefaultizedProps(inProps, "MuiDesktopDatePicker");
  const viewRenderers = _extends({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, defaultizedProps.viewRenderers);
  const props = _extends({}, defaultizedProps, {
    viewRenderers,
    format: resolveDateFormat(utils, defaultizedProps, false),
    yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
    slots: _extends({
      openPickerIcon: CalendarIcon,
      field: DateField
    }, defaultizedProps.slots),
    slotProps: _extends({}, defaultizedProps.slotProps, {
      field: (ownerState) => _extends({}, resolveComponentProps(defaultizedProps.slotProps?.field, ownerState), extractValidationProps(defaultizedProps), {
        ref
      }),
      toolbar: _extends({
        hidden: true
      }, defaultizedProps.slotProps?.toolbar)
    })
  });
  const {
    renderPicker
  } = useDesktopPicker({
    props,
    valueManager: singleItemValueManager,
    valueType: "date",
    getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
    validator: validateDate
  });
  return renderPicker();
});
DesktopDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: import_prop_types25.default.bool,
  className: import_prop_types25.default.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: import_prop_types25.default.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: import_prop_types25.default.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: import_prop_types25.default.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: import_prop_types25.default.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: import_prop_types25.default.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: import_prop_types25.default.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: import_prop_types25.default.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: import_prop_types25.default.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: import_prop_types25.default.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: import_prop_types25.default.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: import_prop_types25.default.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: import_prop_types25.default.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: import_prop_types25.default.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType_default,
  /**
   * The label content.
   */
  label: import_prop_types25.default.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: import_prop_types25.default.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: import_prop_types25.default.object,
  /**
   * Maximal selectable date.
   */
  maxDate: import_prop_types25.default.object,
  /**
   * Minimal selectable date.
   */
  minDate: import_prop_types25.default.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: import_prop_types25.default.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: import_prop_types25.default.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: import_prop_types25.default.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: import_prop_types25.default.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: import_prop_types25.default.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: import_prop_types25.default.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: import_prop_types25.default.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: import_prop_types25.default.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: import_prop_types25.default.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: import_prop_types25.default.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: import_prop_types25.default.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: import_prop_types25.default.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: import_prop_types25.default.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: import_prop_types25.default.oneOf(["landscape", "portrait"]),
  readOnly: import_prop_types25.default.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: import_prop_types25.default.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: import_prop_types25.default.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: import_prop_types25.default.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: import_prop_types25.default.oneOfType([import_prop_types25.default.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), import_prop_types25.default.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: import_prop_types25.default.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: import_prop_types25.default.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: import_prop_types25.default.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: import_prop_types25.default.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types25.default.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: import_prop_types25.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types25.default.oneOfType([import_prop_types25.default.arrayOf(import_prop_types25.default.oneOfType([import_prop_types25.default.func, import_prop_types25.default.object, import_prop_types25.default.bool])), import_prop_types25.default.func, import_prop_types25.default.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: import_prop_types25.default.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: import_prop_types25.default.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: import_prop_types25.default.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: import_prop_types25.default.shape({
    day: import_prop_types25.default.func,
    month: import_prop_types25.default.func,
    year: import_prop_types25.default.func
  }),
  /**
   * Available views.
   */
  views: import_prop_types25.default.arrayOf(import_prop_types25.default.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: import_prop_types25.default.oneOf([3, 4])
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/MobileDatePicker/MobileDatePicker.js
var import_prop_types26 = __toESM(require_prop_types());
var PickersModalDialogRoot = styled(MuiDialog)({
  [`& .${dialogClasses.container}`]: {
    outline: 0
  },
  [`& .${dialogClasses.paper}`]: {
    outline: 0,
    minWidth: DIALOG_WIDTH
  }
});
var PickersModalDialogContent = styled(DialogContent)({
  "&:first-of-type": {
    padding: 0
  }
});
function PickersModalDialog(props) {
  const {
    children,
    onDismiss,
    open,
    slots,
    slotProps
  } = props;
  const Dialog2 = slots?.dialog ?? PickersModalDialogRoot;
  const Transition2 = slots?.mobileTransition ?? Fade;
  return /* @__PURE__ */ jsx(Dialog2, _extends({
    open,
    onClose: onDismiss
  }, slotProps?.dialog, {
    TransitionComponent: Transition2,
    TransitionProps: slotProps?.mobileTransition,
    PaperComponent: slots?.mobilePaper,
    PaperProps: slotProps?.mobilePaper,
    children: /* @__PURE__ */ jsx(PickersModalDialogContent, {
      children
    })
  }));
}
var _excluded40 = ["props", "getOpenDialogAriaText"];
var useMobilePicker = (_ref) => {
  let {
    props,
    getOpenDialogAriaText
  } = _ref, pickerParams = _objectWithoutPropertiesLoose(_ref, _excluded40);
  const {
    slots,
    slotProps: innerSlotProps,
    className,
    sx,
    format: format4,
    formatDensity,
    enableAccessibleFieldDOMStructure,
    selectedSections,
    onSelectedSectionsChange,
    timezone,
    name,
    label,
    inputRef,
    readOnly,
    disabled,
    localeText
  } = props;
  const utils = useUtils();
  const fieldRef = React52.useRef(null);
  const labelId = useId();
  const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
  const {
    open,
    actions,
    layoutProps,
    renderCurrentView,
    fieldProps: pickerFieldProps
  } = usePicker(_extends({}, pickerParams, {
    props,
    fieldRef,
    autoFocusView: true,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  }));
  const Field = slots.field;
  const fieldProps = useSlotProps({
    elementType: Field,
    externalSlotProps: innerSlotProps?.field,
    additionalProps: _extends({}, pickerFieldProps, isToolbarHidden && {
      id: labelId
    }, !(disabled || readOnly) && {
      onClick: actions.onOpen,
      onKeyDown: onSpaceOrEnter(actions.onOpen)
    }, {
      readOnly: readOnly ?? true,
      disabled,
      className,
      sx,
      format: format4,
      formatDensity,
      enableAccessibleFieldDOMStructure,
      selectedSections,
      onSelectedSectionsChange,
      timezone,
      label,
      name
    }, inputRef ? {
      inputRef
    } : {}),
    ownerState: props
  });
  fieldProps.inputProps = _extends({}, fieldProps.inputProps, {
    "aria-label": getOpenDialogAriaText(pickerFieldProps.value, utils)
  });
  const slotsForField = _extends({
    textField: slots.textField
  }, fieldProps.slots);
  const Layout = slots.layout ?? PickersLayout;
  let labelledById = labelId;
  if (isToolbarHidden) {
    if (label) {
      labelledById = `${labelId}-label`;
    } else {
      labelledById = void 0;
    }
  }
  const slotProps = _extends({}, innerSlotProps, {
    toolbar: _extends({}, innerSlotProps?.toolbar, {
      titleId: labelId
    }),
    mobilePaper: _extends({
      "aria-labelledby": labelledById
    }, innerSlotProps?.mobilePaper)
  });
  const handleFieldRef = useForkRef(fieldRef, fieldProps.unstableFieldRef);
  const renderPicker = () => /* @__PURE__ */ jsxs(LocalizationProvider, {
    localeText,
    children: [/* @__PURE__ */ jsx(Field, _extends({}, fieldProps, {
      slots: slotsForField,
      slotProps,
      unstableFieldRef: handleFieldRef
    })), /* @__PURE__ */ jsx(PickersModalDialog, _extends({}, actions, {
      open,
      slots,
      slotProps,
      children: /* @__PURE__ */ jsx(Layout, _extends({}, layoutProps, slotProps?.layout, {
        slots,
        slotProps,
        children: renderCurrentView()
      }))
    }))]
  });
  return {
    renderPicker
  };
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/MobileDatePicker/MobileDatePicker.js
var MobileDatePicker = /* @__PURE__ */ React52.forwardRef(function MobileDatePicker2(inProps, ref) {
  const localeText = useLocaleText();
  const utils = useUtils();
  const defaultizedProps = useDatePickerDefaultizedProps(inProps, "MuiMobileDatePicker");
  const viewRenderers = _extends({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, defaultizedProps.viewRenderers);
  const props = _extends({}, defaultizedProps, {
    viewRenderers,
    format: resolveDateFormat(utils, defaultizedProps, false),
    slots: _extends({
      field: DateField
    }, defaultizedProps.slots),
    slotProps: _extends({}, defaultizedProps.slotProps, {
      field: (ownerState) => _extends({}, resolveComponentProps(defaultizedProps.slotProps?.field, ownerState), extractValidationProps(defaultizedProps), {
        ref
      }),
      toolbar: _extends({
        hidden: false
      }, defaultizedProps.slotProps?.toolbar)
    })
  });
  const {
    renderPicker
  } = useMobilePicker({
    props,
    valueManager: singleItemValueManager,
    valueType: "date",
    getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
    validator: validateDate
  });
  return renderPicker();
});
MobileDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: import_prop_types26.default.bool,
  className: import_prop_types26.default.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: import_prop_types26.default.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: import_prop_types26.default.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: import_prop_types26.default.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: import_prop_types26.default.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: import_prop_types26.default.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: import_prop_types26.default.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: import_prop_types26.default.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: import_prop_types26.default.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: import_prop_types26.default.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: import_prop_types26.default.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: import_prop_types26.default.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: import_prop_types26.default.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: import_prop_types26.default.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType_default,
  /**
   * The label content.
   */
  label: import_prop_types26.default.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: import_prop_types26.default.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: import_prop_types26.default.object,
  /**
   * Maximal selectable date.
   */
  maxDate: import_prop_types26.default.object,
  /**
   * Minimal selectable date.
   */
  minDate: import_prop_types26.default.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: import_prop_types26.default.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: import_prop_types26.default.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: import_prop_types26.default.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: import_prop_types26.default.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: import_prop_types26.default.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: import_prop_types26.default.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: import_prop_types26.default.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: import_prop_types26.default.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: import_prop_types26.default.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: import_prop_types26.default.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: import_prop_types26.default.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: import_prop_types26.default.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: import_prop_types26.default.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: import_prop_types26.default.oneOf(["landscape", "portrait"]),
  readOnly: import_prop_types26.default.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: import_prop_types26.default.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: import_prop_types26.default.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: import_prop_types26.default.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: import_prop_types26.default.oneOfType([import_prop_types26.default.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), import_prop_types26.default.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: import_prop_types26.default.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: import_prop_types26.default.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: import_prop_types26.default.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: import_prop_types26.default.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types26.default.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: import_prop_types26.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types26.default.oneOfType([import_prop_types26.default.arrayOf(import_prop_types26.default.oneOfType([import_prop_types26.default.func, import_prop_types26.default.object, import_prop_types26.default.bool])), import_prop_types26.default.func, import_prop_types26.default.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: import_prop_types26.default.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: import_prop_types26.default.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: import_prop_types26.default.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: import_prop_types26.default.shape({
    day: import_prop_types26.default.func,
    month: import_prop_types26.default.func,
    year: import_prop_types26.default.func
  }),
  /**
   * Available views.
   */
  views: import_prop_types26.default.arrayOf(import_prop_types26.default.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: import_prop_types26.default.oneOf([3, 4])
};
var _excluded41 = ["desktopModeMediaQuery"];
var DatePicker = /* @__PURE__ */ React52.forwardRef(function DatePicker2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiDatePicker"
  });
  const {
    desktopModeMediaQuery = DEFAULT_DESKTOP_MODE_MEDIA_QUERY
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded41);
  const isDesktop = useMediaQuery(desktopModeMediaQuery, {
    defaultMatches: true
  });
  if (isDesktop) {
    return /* @__PURE__ */ jsx(DesktopDatePicker, _extends({
      ref
    }, other));
  }
  return /* @__PURE__ */ jsx(MobileDatePicker, _extends({
    ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: import_prop_types27.default.bool,
  className: import_prop_types27.default.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: import_prop_types27.default.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: import_prop_types27.default.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: import_prop_types27.default.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: import_prop_types27.default.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: import_prop_types27.default.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: import_prop_types27.default.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: import_prop_types27.default.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: import_prop_types27.default.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: import_prop_types27.default.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: import_prop_types27.default.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: import_prop_types27.default.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: import_prop_types27.default.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: import_prop_types27.default.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: import_prop_types27.default.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType_default,
  /**
   * The label content.
   */
  label: import_prop_types27.default.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: import_prop_types27.default.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: import_prop_types27.default.object,
  /**
   * Maximal selectable date.
   */
  maxDate: import_prop_types27.default.object,
  /**
   * Minimal selectable date.
   */
  minDate: import_prop_types27.default.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: import_prop_types27.default.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: import_prop_types27.default.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: import_prop_types27.default.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: import_prop_types27.default.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: import_prop_types27.default.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: import_prop_types27.default.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: import_prop_types27.default.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: import_prop_types27.default.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: import_prop_types27.default.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: import_prop_types27.default.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: import_prop_types27.default.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: import_prop_types27.default.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: import_prop_types27.default.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: import_prop_types27.default.oneOf(["landscape", "portrait"]),
  readOnly: import_prop_types27.default.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: import_prop_types27.default.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: import_prop_types27.default.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: import_prop_types27.default.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: import_prop_types27.default.oneOfType([import_prop_types27.default.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), import_prop_types27.default.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: import_prop_types27.default.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: import_prop_types27.default.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: import_prop_types27.default.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: import_prop_types27.default.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: import_prop_types27.default.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: import_prop_types27.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: import_prop_types27.default.oneOfType([import_prop_types27.default.arrayOf(import_prop_types27.default.oneOfType([import_prop_types27.default.func, import_prop_types27.default.object, import_prop_types27.default.bool])), import_prop_types27.default.func, import_prop_types27.default.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: import_prop_types27.default.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: import_prop_types27.default.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: import_prop_types27.default.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: import_prop_types27.default.shape({
    day: import_prop_types27.default.func,
    month: import_prop_types27.default.func,
    year: import_prop_types27.default.func
  }),
  /**
   * Available views.
   */
  views: import_prop_types27.default.arrayOf(import_prop_types27.default.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: import_prop_types27.default.oneOf([3, 4])
} : void 0;

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/AdapterDateFnsBase/AdapterDateFnsBase.js
var formatTokenMap = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
};
var defaultFormats = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  dayOfMonthFull: "do",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
var AdapterDateFnsBase = class {
  constructor(props) {
    this.isMUIAdapter = true;
    this.isTimezoneCompatible = false;
    this.lib = void 0;
    this.locale = void 0;
    this.formats = void 0;
    this.formatTokenMap = formatTokenMap;
    this.escapedCharacters = {
      start: "'",
      end: "'"
    };
    this.longFormatters = void 0;
    this.date = (value) => {
      if (typeof value === "undefined") {
        return /* @__PURE__ */ new Date();
      }
      if (value === null) {
        return null;
      }
      return new Date(value);
    };
    this.getInvalidDate = () => /* @__PURE__ */ new Date("Invalid Date");
    this.getTimezone = () => {
      return "default";
    };
    this.setTimezone = (value) => {
      return value;
    };
    this.toJsDate = (value) => {
      return value;
    };
    this.getCurrentLocaleCode = () => {
      return this.locale?.code || "en-US";
    };
    this.is12HourCycleInCurrentLocale = () => {
      if (this.locale) {
        return /a/.test(this.locale.formatLong.time({
          width: "short"
        }));
      }
      return true;
    };
    this.expandFormat = (format4) => {
      const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return format4.match(longFormatRegexp).map((token) => {
        const firstCharacter = token[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
          const longFormatter = this.longFormatters[firstCharacter];
          return longFormatter(token, this.locale.formatLong);
        }
        return token;
      }).join("");
    };
    this.formatNumber = (numberToFormat) => {
      return numberToFormat;
    };
    this.getDayOfWeek = (value) => {
      return value.getDay() + 1;
    };
    const {
      locale,
      formats,
      longFormatters: longFormatters2,
      lib
    } = props;
    this.locale = locale;
    this.formats = _extends({}, defaultFormats, formats);
    this.longFormatters = longFormatters2;
    this.lib = lib || "date-fns";
  }
};

// ../../node_modules/.pnpm/@mui+x-date-pickers@7.7.0_@emotion+react@11.11.1_@types+react@18.3.3_react@18.3.1__@emotion+s_ez3mkwwa5jkln354gctpmodl4a/node_modules/@mui/x-date-pickers/AdapterDateFnsV3/AdapterDateFnsV3.js
var AdapterDateFns = class extends AdapterDateFnsBase {
  constructor({
    locale,
    formats
  } = {}) {
    if (typeof addDays !== "function") {
      throw new Error([`MUI: The \`date-fns\` package v2.x is not compatible with this adapter.`, "Please, install v3.x of the package or use the `AdapterDateFns` instead."].join("\n"));
    }
    if (!longFormatters) {
      throw new Error("MUI: The minimum supported `date-fns` package version compatible with this adapter is `3.2.x`.");
    }
    super({
      locale: locale ?? enUS,
      formats,
      longFormatters
    });
    this.parse = (value, format4) => {
      if (value === "") {
        return null;
      }
      return parse(value, format4, /* @__PURE__ */ new Date(), {
        locale: this.locale
      });
    };
    this.isValid = (value) => {
      if (value == null) {
        return false;
      }
      return isValid(value);
    };
    this.format = (value, formatKey) => {
      return this.formatByString(value, this.formats[formatKey]);
    };
    this.formatByString = (value, formatString) => {
      return format(value, formatString, {
        locale: this.locale
      });
    };
    this.isEqual = (value, comparing) => {
      if (value === null && comparing === null) {
        return true;
      }
      if (value === null || comparing === null) {
        return false;
      }
      return isEqual(value, comparing);
    };
    this.isSameYear = (value, comparing) => {
      return isSameYear(value, comparing);
    };
    this.isSameMonth = (value, comparing) => {
      return isSameMonth(value, comparing);
    };
    this.isSameDay = (value, comparing) => {
      return isSameDay(value, comparing);
    };
    this.isSameHour = (value, comparing) => {
      return isSameHour(value, comparing);
    };
    this.isAfter = (value, comparing) => {
      return isAfter(value, comparing);
    };
    this.isAfterYear = (value, comparing) => {
      return isAfter(value, endOfYear(comparing));
    };
    this.isAfterDay = (value, comparing) => {
      return isAfter(value, endOfDay(comparing));
    };
    this.isBefore = (value, comparing) => {
      return isBefore(value, comparing);
    };
    this.isBeforeYear = (value, comparing) => {
      return isBefore(value, this.startOfYear(comparing));
    };
    this.isBeforeDay = (value, comparing) => {
      return isBefore(value, this.startOfDay(comparing));
    };
    this.isWithinRange = (value, [start, end]) => {
      return isWithinInterval(value, {
        start,
        end
      });
    };
    this.startOfYear = (value) => {
      return startOfYear(value);
    };
    this.startOfMonth = (value) => {
      return startOfMonth(value);
    };
    this.startOfWeek = (value) => {
      return startOfWeek(value, {
        locale: this.locale
      });
    };
    this.startOfDay = (value) => {
      return startOfDay(value);
    };
    this.endOfYear = (value) => {
      return endOfYear(value);
    };
    this.endOfMonth = (value) => {
      return endOfMonth(value);
    };
    this.endOfWeek = (value) => {
      return endOfWeek(value, {
        locale: this.locale
      });
    };
    this.endOfDay = (value) => {
      return endOfDay(value);
    };
    this.addYears = (value, amount) => {
      return addYears(value, amount);
    };
    this.addMonths = (value, amount) => {
      return addMonths(value, amount);
    };
    this.addWeeks = (value, amount) => {
      return addWeeks(value, amount);
    };
    this.addDays = (value, amount) => {
      return addDays(value, amount);
    };
    this.addHours = (value, amount) => {
      return addHours(value, amount);
    };
    this.addMinutes = (value, amount) => {
      return addMinutes(value, amount);
    };
    this.addSeconds = (value, amount) => {
      return addSeconds(value, amount);
    };
    this.getYear = (value) => {
      return getYear(value);
    };
    this.getMonth = (value) => {
      return getMonth(value);
    };
    this.getDate = (value) => {
      return getDate(value);
    };
    this.getHours = (value) => {
      return getHours(value);
    };
    this.getMinutes = (value) => {
      return getMinutes(value);
    };
    this.getSeconds = (value) => {
      return getSeconds(value);
    };
    this.getMilliseconds = (value) => {
      return getMilliseconds(value);
    };
    this.setYear = (value, year) => {
      return setYear(value, year);
    };
    this.setMonth = (value, month) => {
      return setMonth(value, month);
    };
    this.setDate = (value, date) => {
      return setDate(value, date);
    };
    this.setHours = (value, hours) => {
      return setHours(value, hours);
    };
    this.setMinutes = (value, minutes) => {
      return setMinutes(value, minutes);
    };
    this.setSeconds = (value, seconds) => {
      return setSeconds(value, seconds);
    };
    this.setMilliseconds = (value, milliseconds) => {
      return setMilliseconds(value, milliseconds);
    };
    this.getDaysInMonth = (value) => {
      return getDaysInMonth(value);
    };
    this.getWeekArray = (value) => {
      const start = this.startOfWeek(this.startOfMonth(value));
      const end = this.endOfWeek(this.endOfMonth(value));
      let count = 0;
      let current = start;
      const nestedWeeks = [];
      while (this.isBefore(current, end)) {
        const weekNumber = Math.floor(count / 7);
        nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
        nestedWeeks[weekNumber].push(current);
        current = this.addDays(current, 1);
        count += 1;
      }
      return nestedWeeks;
    };
    this.getWeekNumber = (value) => {
      return getWeek(value, {
        locale: this.locale
      });
    };
    this.getYearRange = ([start, end]) => {
      const startDate = this.startOfYear(start);
      const endDate = this.endOfYear(end);
      const years = [];
      let current = startDate;
      while (this.isBefore(current, endDate)) {
        years.push(current);
        current = this.addYears(current, 1);
      }
      return years;
    };
  }
};

// ../calculator-ui/src/utils/debounce.ts
function debounce(func, wait) {
  let timeout2;
  return (...args) => {
    clearTimeout(timeout2);
    timeout2 = setTimeout(() => func(...args), wait);
  };
}
var TableHeadCellInputType = /* @__PURE__ */ ((TableHeadCellInputType2) => {
  TableHeadCellInputType2["Search"] = "search";
  TableHeadCellInputType2["Date"] = "date";
  TableHeadCellInputType2["Autocomplete"] = "autocomplete";
  TableHeadCellInputType2["Range"] = "range";
  return TableHeadCellInputType2;
})(TableHeadCellInputType || {});
var HistoryTableHeaderCell = ({
  id,
  label,
  length,
  index,
  filterOptions,
  filterValue,
  onFilter,
  isFilterActive,
  tableCellProps,
  inputType,
  datePickerFormat,
  datePickerViews
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [minValue, setMinValue] = useState(null);
  const [maxValue, setMaxValue] = useState(null);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const dropdownOptions = useMemo(
    () => inputType === "autocomplete" /* Autocomplete */ ? generateDropdownOptions(filterOptions) : {},
    [inputType, filterOptions]
  );
  const handleFilterOpen = () => setIsFilterOpen(true);
  const handleFilterClose = () => setIsFilterOpen(false);
  const handleDateChange = (newValue) => {
    onFilter(id, newValue ? newValue.toISOString() : newValue);
  };
  const handleAutocompleteChange = (_, newValue) => {
    const value = typeof newValue === "object" && newValue ? newValue.value : newValue;
    onFilter(id, value);
  };
  const debouncedOnFilter = useCallback(
    debounce((value) => {
      onFilter(id, value);
    }, 1e3),
    [id, onFilter]
  );
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    debouncedOnFilter(event.target.value);
  };
  const handleMinValueChange = (event) => {
    const value = Number(event.target.value);
    setMinValue(value);
    if (maxValue && value < maxValue) {
      debouncedOnFilter({ min: value, max: maxValue });
    }
  };
  const handleMaxValueChange = (event) => {
    const value = Number(event.target.value);
    setMaxValue(value);
    if (minValue && minValue < value) {
      debouncedOnFilter({ min: minValue, max: value });
    }
  };
  const renderSearchInput = () => /* @__PURE__ */ jsx("div", { style: { position: "relative" }, children: /* @__PURE__ */ jsx(
    TextField,
    {
      value: searchTerm,
      onChange: handleSearchChange,
      size: "small",
      variant: "outlined",
      placeholder: "Search...",
      sx: {
        position: "absolute",
        width: "215px",
        right: tableCellProps?.align === "right" ? "15px" : void 0,
        background: isDarkMode ? `${dark6} !important` : white
      }
    }
  ) });
  const renderAutocomplete = () => /* @__PURE__ */ jsx("div", { style: { position: "relative" }, children: /* @__PURE__ */ jsx(
    Autocomplete,
    {
      options: dropdownOptions.options,
      getOptionLabel: dropdownOptions.getOptionLabel,
      value: typeof filterValue === "object" && filterValue !== null ? filterValue.value : filterValue,
      onChange: handleAutocompleteChange,
      size: "small",
      sx: {
        position: "absolute",
        width: "215px",
        right: tableCellProps?.align === "right" ? "15px" : void 0,
        background: isDarkMode ? `${dark6} !important` : white,
        top: length - 1 === index ? "20px" : void 0
      },
      renderInput: (params) => /* @__PURE__ */ jsx(TextField, { ...params, variant: "outlined" })
    }
  ) });
  const renderRange = () => /* @__PURE__ */ jsxs("div", { style: { position: "relative" }, children: [
    /* @__PURE__ */ jsx(
      TextField,
      {
        error: Boolean(
          minValue && (maxValue && minValue >= maxValue || minValue < 0)
        ),
        value: minValue === 0 ? "" : minValue,
        onChange: handleMinValueChange,
        size: "small",
        variant: "outlined",
        placeholder: "Min",
        inputMode: "numeric",
        type: "number",
        InputProps: { inputProps: { min: 1 } },
        sx: {
          position: "absolute",
          width: "100px",
          background: isDarkMode ? `${dark6} !important` : white,
          left: 0
        }
      }
    ),
    /* @__PURE__ */ jsx(
      TextField,
      {
        error: Boolean(
          maxValue && (minValue && minValue >= maxValue || maxValue < 0)
        ),
        value: maxValue === 0 ? "" : maxValue,
        onChange: handleMaxValueChange,
        size: "small",
        inputMode: "numeric",
        type: "number",
        variant: "outlined",
        placeholder: "Max",
        sx: {
          position: "absolute",
          width: "100px",
          background: isDarkMode ? `${dark6} !important` : white,
          left: "110px"
        }
      }
    )
  ] });
  const renderDatePicker = () => /* @__PURE__ */ jsx("div", { style: { position: "relative" }, children: /* @__PURE__ */ jsx(LocalizationProvider, { dateAdapter: AdapterDateFns, children: /* @__PURE__ */ jsx(
    DatePicker,
    {
      format: datePickerFormat || "yyyy-MM-dd",
      views: datePickerViews || ["year", "month", "day"],
      onChange: handleDateChange,
      sx: {
        position: "absolute",
        width: "215px",
        right: tableCellProps?.align === "right" ? "15px" : void 0,
        background: isDarkMode ? `${dark6} !important` : white,
        display: "block"
      },
      slotProps: { textField: { size: "small" } }
    }
  ) }) });
  const renderInputComponent = () => {
    switch (inputType) {
      case "date" /* Date */:
        return renderDatePicker();
      case "search" /* Search */:
        return renderSearchInput();
      case "autocomplete" /* Autocomplete */:
        return renderAutocomplete();
      case "range" /* Range */:
        return renderRange();
      default:
        throw new Error(`${inputType} unknown input type`);
    }
  };
  return /* @__PURE__ */ jsxs(
    TableCell,
    {
      sx: {
        zIndex: length - index
      },
      children: [
        label,
        /* @__PURE__ */ jsx(Tooltip, { title: "Filter", placement: "top", children: /* @__PURE__ */ jsx(
          IconButton,
          {
            onClick: handleFilterOpen,
            color: isFilterActive ? "primary" : "default",
            size: "small",
            edge: "end",
            children: /* @__PURE__ */ jsx(FilterAltOutlined, { fontSize: "small" })
          }
        ) }),
        isFilterOpen && renderInputComponent && /* @__PURE__ */ jsx(ClickAwayListener, { onClickAway: handleFilterClose, children: renderInputComponent() })
      ]
    }
  );
};
var HistoryTableHeaderCell_default = HistoryTableHeaderCell;
var fetcher = (url) => fetch(url).then((res) => {
  if (!res.ok) {
    return res.json().then((x) => {
      throw new Error(parseErrorBody(x));
    }).catch((e) => {
      throw new Error(`${res.statusText}: ${e}`);
    });
  }
  return res.json();
});
var parseErrorBody = (res) => {
  if (typeof res === "string") {
    return res;
  }
  if (typeof res === "object") {
    const item = res.errors ?? res;
    if (item) {
      if (item.constraints) {
        return Object.keys(item.constraints).map((x) => `${x}: ${item.constraints[x]}`).join(", ");
      }
      if (item.message) {
        return item.message;
      }
      if (Array.isArray(item)) {
        return item.map((x) => parseErrorBody(x)).join(", ");
      }
      if (typeof item === "object") {
        return Object.keys(item).map((x) => `${x}: ${parseErrorBody(item[x])}`).join(", ");
      }
    }
    return JSON.stringify(res);
  }
  return "Unknown error";
};
var prepareBody = (body, contentType) => {
  switch (contentType) {
    case "application/json":
      return JSON.stringify(body);
    case "application/x-www-form-urlencoded":
      return Object.keys(body).map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(body[key])}`
      ).join("&");
    default:
      return body;
  }
};
var ResponseError = class _ResponseError extends Error {
  constructor(message, statusCode, body) {
    super(message);
    this.statusCode = statusCode;
    this.body = body;
    Object.setPrototypeOf(this, _ResponseError.prototype);
    this.name = "ResponseError";
  }
};
var lazyFetcher = ({ url, method = "POST", contentType = "application/json" }, { arg }) => {
  const headers = {};
  if (contentType !== null) {
    headers["Content-Type"] = contentType;
  }
  const init = {
    method,
    headers
  };
  if (arg?.body) {
    init.body = prepareBody(arg.body, contentType);
  }
  return fetch(url, init).then((res) => {
    if (!res.ok) {
      try {
        return res.json().then((x) => {
          throw new ResponseError(parseErrorBody(x), res.status, x);
        });
      } catch (e) {
        throw new ResponseError(res.statusText, res.status);
      }
    }
    return res.json();
  });
};
function useAPI(url) {
  return useSWR(url, fetcher, {
    revalidateOnFocus: false
  });
}
function useAdminAPI(url, config) {
  return useSWR(url, fetcher, {
    revalidateOnFocus: false,
    ...config
  });
}
function useApiMutation({
  url,
  method = "POST",
  contentType = "application/json",
  ...extra
}) {
  return useSWRMutation(
    { url, method, contentType, ...extra },
    lazyFetcher
  );
}
function useAdminApiMutation({
  url,
  method = "POST",
  contentType = "application/json",
  ...extra
}) {
  return useSWRMutation(
    { url, method, contentType, ...extra },
    lazyFetcher
  );
}
var DebugPanel = ({ apiRoute, planId, calculationId }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showDebugPlan, setShowDebugPlan] = useState(false);
  const {
    data: plan,
    error,
    trigger,
    isMutating
  } = useAdminApiMutation({
    url: `${apiRoute}?calculationId=${calculationId}&planId=${planId}`,
    method: "GET",
    contentType: "application/json"
  });
  useEffect(() => {
    if (error) {
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    }
  }, [error]);
  useEffect(() => {
    if (plan) {
      setShowDebugPlan(true);
    }
  }, [plan]);
  const handleDebugButtonClick = async () => {
    await trigger();
  };
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };
  const handleCloseDebugData = () => {
    setShowDebugPlan(false);
  };
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "outlined",
        size: "medium",
        color: "primary",
        onClick: handleDebugButtonClick,
        fullWidth: true,
        sx: {
          minHeight: "40px",
          borderRadius: "0.5rem",
          float: "right",
          maxWidth: "200px",
          width: "100%",
          margin: "0.5rem"
        },
        children: "Debug"
      }
    ),
    !error && isMutating && /* @__PURE__ */ jsx(CircularProgress, {}),
    showDebugPlan && plan && /* @__PURE__ */ jsxs(
      Box,
      {
        sx: {
          position: "fixed",
          top: 0,
          right: 0,
          width: "50%",
          height: "100%",
          backgroundColor: isDarkMode ? "rgba(0, 0, 0, 0.95)" : "rgba(255, 255, 255, 0.95)",
          zIndex: 1300,
          overflowY: "auto",
          padding: "1rem"
        },
        children: [
          /* @__PURE__ */ jsxs(
            Box,
            {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              children: [
                /* @__PURE__ */ jsx(Typography, { variant: "h6", children: "Debug Data:" }),
                /* @__PURE__ */ jsx(IconButton, { onClick: handleCloseDebugData, children: /* @__PURE__ */ jsx(CloseIcon, {}) })
              ]
            }
          ),
          /* @__PURE__ */ jsx("pre", { children: JSON.stringify(plan, null, 2) })
        ]
      }
    ),
    /* @__PURE__ */ jsx(Snackbar, { open: snackbarOpen, onClose: handleCloseSnackbar, children: /* @__PURE__ */ jsx(
      Alert,
      {
        onClose: handleCloseSnackbar,
        severity: "error",
        sx: { width: "100%" },
        children: errorMessage
      }
    ) })
  ] });
};
var DebugPanel_default = DebugPanel;
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) {
      t[p] = s[p];
    }
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") {
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) {
        t[p[i]] = s[p[i]];
      }
    }
  }
  return t;
}
var SourceType;
(function(SourceType2) {
  SourceType2["event"] = "event";
  SourceType2["props"] = "prop";
})(SourceType || (SourceType = {}));
function noop3() {
}
function memoizeOnce(cb) {
  var lastArgs;
  var lastValue = void 0;
  return function() {
    var args = [], len = arguments.length;
    while (len--)
      args[len] = arguments[len];
    if (lastArgs && args.length === lastArgs.length && args.every(function(value, index) {
      return value === lastArgs[index];
    })) {
      return lastValue;
    }
    lastArgs = args;
    lastValue = cb.apply(void 0, args);
    return lastValue;
  };
}
function charIsNumber(char) {
  return !!(char || "").match(/\d/);
}
function isNil(val) {
  return val === null || val === void 0;
}
function isNanValue(val) {
  return typeof val === "number" && isNaN(val);
}
function isNotValidValue(val) {
  return isNil(val) || isNanValue(val) || typeof val === "number" && !isFinite(val);
}
function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function getThousandsGroupRegex(thousandsGroupStyle) {
  switch (thousandsGroupStyle) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index = str.search(/[1-9]/);
  index = index === -1 ? str.length : index;
  return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, "$1" + thousandSeparator);
}
function usePersistentCallback(cb) {
  var callbackRef = useRef(cb);
  callbackRef.current = cb;
  var persistentCbRef = useRef(function() {
    var args = [], len = arguments.length;
    while (len--)
      args[len] = arguments[len];
    return callbackRef.current.apply(callbackRef, args);
  });
  return persistentCbRef.current;
}
function splitDecimal(numStr, allowNegative) {
  if (allowNegative === void 0)
    allowNegative = true;
  var hasNegation = numStr[0] === "-";
  var addNegation = hasNegation && allowNegative;
  numStr = numStr.replace("-", "");
  var parts = numStr.split(".");
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || "";
  return {
    beforeDecimal,
    afterDecimal,
    hasNegation,
    addNegation
  };
}
function fixLeadingZero(numStr) {
  if (!numStr) {
    return numStr;
  }
  var isNegative = numStr[0] === "-";
  if (isNegative) {
    numStr = numStr.substring(1, numStr.length);
  }
  var parts = numStr.split(".");
  var beforeDecimal = parts[0].replace(/^0+/, "") || "0";
  var afterDecimal = parts[1] || "";
  return (isNegative ? "-" : "") + beforeDecimal + (afterDecimal ? "." + afterDecimal : "");
}
function limitToScale(numStr, scale, fixedDecimalScale) {
  var str = "";
  var filler = fixedDecimalScale ? "0" : "";
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}
function repeat(str, count) {
  return Array(count + 1).join(str);
}
function toNumericString(num) {
  var _num = num + "";
  var sign = _num[0] === "-" ? "-" : "";
  if (sign) {
    _num = _num.substring(1);
  }
  var ref = _num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1];
  exponent = Number(exponent);
  if (!exponent) {
    return sign + coefficient;
  }
  coefficient = coefficient.replace(".", "");
  var decimalIndex = 1 + exponent;
  var coffiecientLn = coefficient.length;
  if (decimalIndex < 0) {
    coefficient = "0." + repeat("0", Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    coefficient = coefficient + repeat("0", decimalIndex - coffiecientLn);
  } else {
    coefficient = (coefficient.substring(0, decimalIndex) || "0") + "." + coefficient.substring(decimalIndex);
  }
  return sign + coefficient;
}
function roundToPrecision(numStr, scale, fixedDecimalScale) {
  if (["", "-"].indexOf(numStr) !== -1) {
    return numStr;
  }
  var shouldHaveDecimalSeparator = (numStr.indexOf(".") !== -1 || fixedDecimalScale) && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNegation = ref.hasNegation;
  var floatValue = parseFloat("0." + (afterDecimal || "0"));
  var floatValueStr = afterDecimal.length <= scale ? "0." + afterDecimal : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split(".");
  var intPart = beforeDecimal;
  if (beforeDecimal && Number(roundedDecimalParts[0])) {
    intPart = beforeDecimal.split("").reverse().reduce(function(roundedStr, current, idx) {
      if (roundedStr.length > idx) {
        return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
      }
      return current + roundedStr;
    }, roundedDecimalParts[0]);
  }
  var decimalPart = limitToScale(roundedDecimalParts[1] || "", scale, fixedDecimalScale);
  var negation = hasNegation ? "-" : "";
  var decimalSeparator = shouldHaveDecimalSeparator ? "." : "";
  return "" + negation + intPart + decimalSeparator + decimalPart;
}
function setCaretPosition(el, caretPos) {
  el.value = el.value;
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move("character", caretPos);
      range.select();
      return true;
    }
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }
    el.focus();
    return false;
  }
}
var findChangeRange = memoizeOnce(function(prevValue, newValue) {
  var i = 0, j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) {
    i++;
  }
  while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i) {
    j++;
  }
  return {
    from: { start: i, end: prevLength - j },
    to: { start: i, end: newLength - j }
  };
});
var findChangedRangeFromCaretPositions = function(lastCaretPositions, currentCaretPosition) {
  var startPosition = Math.min(lastCaretPositions.selectionStart, currentCaretPosition);
  return {
    from: { start: startPosition, end: lastCaretPositions.selectionEnd },
    to: { start: startPosition, end: currentCaretPosition }
  };
};
function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
function geInputCaretPosition(el) {
  return Math.max(el.selectionStart, el.selectionEnd);
}
function addInputMode() {
  return typeof navigator !== "undefined" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function getDefaultChangeMeta(value) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: value.length
    },
    lastValue: ""
  };
}
function defaultIsCharacterSame(ref) {
  var currentValue = ref.currentValue;
  var formattedValue = ref.formattedValue;
  var currentValueIndex = ref.currentValueIndex;
  var formattedValueIndex = ref.formattedValueIndex;
  return currentValue[currentValueIndex] === formattedValue[formattedValueIndex];
}
function getCaretPosition(newFormattedValue, lastFormattedValue, curValue, curCaretPos, boundary, isValidInputCharacter, isCharacterSame) {
  if (isCharacterSame === void 0)
    isCharacterSame = defaultIsCharacterSame;
  var firstAllowedPosition = boundary.findIndex(function(b) {
    return b;
  });
  var prefixFormat = newFormattedValue.slice(0, firstAllowedPosition);
  if (!lastFormattedValue && !curValue.startsWith(prefixFormat)) {
    lastFormattedValue = prefixFormat;
    curValue = prefixFormat + curValue;
    curCaretPos = curCaretPos + prefixFormat.length;
  }
  var curValLn = curValue.length;
  var formattedValueLn = newFormattedValue.length;
  var addedIndexMap = {};
  var indexMap = new Array(curValLn);
  for (var i = 0; i < curValLn; i++) {
    indexMap[i] = -1;
    for (var j = 0, jLn = formattedValueLn; j < jLn; j++) {
      var isCharSame = isCharacterSame({
        currentValue: curValue,
        lastValue: lastFormattedValue,
        formattedValue: newFormattedValue,
        currentValueIndex: i,
        formattedValueIndex: j
      });
      if (isCharSame && addedIndexMap[j] !== true) {
        indexMap[i] = j;
        addedIndexMap[j] = true;
        break;
      }
    }
  }
  var pos = curCaretPos;
  while (pos < curValLn && (indexMap[pos] === -1 || !isValidInputCharacter(curValue[pos]))) {
    pos++;
  }
  var endIndex = pos === curValLn || indexMap[pos] === -1 ? formattedValueLn : indexMap[pos];
  pos = curCaretPos - 1;
  while (pos > 0 && indexMap[pos] === -1) {
    pos--;
  }
  var startIndex = pos === -1 || indexMap[pos] === -1 ? 0 : indexMap[pos] + 1;
  if (startIndex > endIndex) {
    return endIndex;
  }
  return curCaretPos - startIndex < endIndex - curCaretPos ? startIndex : endIndex;
}
function getCaretPosInBoundary(value, caretPos, boundary, direction) {
  var valLn = value.length;
  caretPos = clamp(caretPos, 0, valLn);
  if (direction === "left") {
    while (caretPos >= 0 && !boundary[caretPos]) {
      caretPos--;
    }
    if (caretPos === -1) {
      caretPos = boundary.indexOf(true);
    }
  } else {
    while (caretPos <= valLn && !boundary[caretPos]) {
      caretPos++;
    }
    if (caretPos > valLn) {
      caretPos = boundary.lastIndexOf(true);
    }
  }
  if (caretPos === -1) {
    caretPos = valLn;
  }
  return caretPos;
}
function caretUnknownFormatBoundary(formattedValue) {
  var boundaryAry = Array.from({ length: formattedValue.length + 1 }).map(function() {
    return true;
  });
  for (var i = 0, ln = boundaryAry.length; i < ln; i++) {
    boundaryAry[i] = Boolean(charIsNumber(formattedValue[i]) || charIsNumber(formattedValue[i - 1]));
  }
  return boundaryAry;
}
function useInternalValues(value, defaultValue, valueIsNumericString, format4, removeFormatting2, onValueChange) {
  if (onValueChange === void 0)
    onValueChange = noop3;
  var getValues = usePersistentCallback(function(value2, valueIsNumericString2) {
    var formattedValue, numAsString;
    if (isNotValidValue(value2)) {
      numAsString = "";
      formattedValue = "";
    } else if (typeof value2 === "number" || valueIsNumericString2) {
      numAsString = typeof value2 === "number" ? toNumericString(value2) : value2;
      formattedValue = format4(numAsString);
    } else {
      numAsString = removeFormatting2(value2, void 0);
      formattedValue = format4(numAsString);
    }
    return { formattedValue, numAsString };
  });
  var ref = useState(function() {
    return getValues(isNil(value) ? defaultValue : value, valueIsNumericString);
  });
  var values3 = ref[0];
  var setValues = ref[1];
  var _onValueChange = function(newValues2, sourceInfo) {
    if (newValues2.formattedValue !== values3.formattedValue) {
      setValues({
        formattedValue: newValues2.formattedValue,
        numAsString: newValues2.value
      });
    }
    onValueChange(newValues2, sourceInfo);
  };
  var _value = value;
  var _valueIsNumericString = valueIsNumericString;
  if (isNil(value)) {
    _value = values3.numAsString;
    _valueIsNumericString = true;
  }
  var newValues = getValues(_value, _valueIsNumericString);
  useMemo(function() {
    setValues(newValues);
  }, [newValues.formattedValue]);
  return [values3, _onValueChange];
}
function defaultRemoveFormatting(value) {
  return value.replace(/[^0-9]/g, "");
}
function defaultFormat(value) {
  return value;
}
function NumberFormatBase(props) {
  var type = props.type;
  if (type === void 0)
    type = "text";
  var displayType = props.displayType;
  if (displayType === void 0)
    displayType = "input";
  var customInput = props.customInput;
  var renderText = props.renderText;
  var getInputRef = props.getInputRef;
  var format4 = props.format;
  if (format4 === void 0)
    format4 = defaultFormat;
  var removeFormatting2 = props.removeFormatting;
  if (removeFormatting2 === void 0)
    removeFormatting2 = defaultRemoveFormatting;
  var defaultValue = props.defaultValue;
  var valueIsNumericString = props.valueIsNumericString;
  var onValueChange = props.onValueChange;
  var isAllowed = props.isAllowed;
  var onChange = props.onChange;
  if (onChange === void 0)
    onChange = noop3;
  var onKeyDown = props.onKeyDown;
  if (onKeyDown === void 0)
    onKeyDown = noop3;
  var onMouseUp = props.onMouseUp;
  if (onMouseUp === void 0)
    onMouseUp = noop3;
  var onFocus = props.onFocus;
  if (onFocus === void 0)
    onFocus = noop3;
  var onBlur = props.onBlur;
  if (onBlur === void 0)
    onBlur = noop3;
  var propValue = props.value;
  var getCaretBoundary2 = props.getCaretBoundary;
  if (getCaretBoundary2 === void 0)
    getCaretBoundary2 = caretUnknownFormatBoundary;
  var isValidInputCharacter = props.isValidInputCharacter;
  if (isValidInputCharacter === void 0)
    isValidInputCharacter = charIsNumber;
  var isCharacterSame = props.isCharacterSame;
  var otherProps = __rest(props, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]);
  var ref = useInternalValues(propValue, defaultValue, Boolean(valueIsNumericString), format4, removeFormatting2, onValueChange);
  var ref_0 = ref[0];
  var formattedValue = ref_0.formattedValue;
  var numAsString = ref_0.numAsString;
  var onFormattedValueChange = ref[1];
  var caretPositionBeforeChange = useRef();
  var lastUpdatedValue = useRef({ formattedValue, numAsString });
  var _onValueChange = function(values3, source) {
    lastUpdatedValue.current = { formattedValue: values3.formattedValue, numAsString: values3.value };
    onFormattedValueChange(values3, source);
  };
  var ref$1 = useState(false);
  var mounted = ref$1[0];
  var setMounted = ref$1[1];
  var focusedElm = useRef(null);
  var timeout2 = useRef({
    setCaretTimeout: null,
    focusTimeout: null
  });
  useEffect(function() {
    setMounted(true);
    return function() {
      clearTimeout(timeout2.current.setCaretTimeout);
      clearTimeout(timeout2.current.focusTimeout);
    };
  }, []);
  var _format = format4;
  var getValueObject = function(formattedValue2, numAsString2) {
    var floatValue = parseFloat(numAsString2);
    return {
      formattedValue: formattedValue2,
      value: numAsString2,
      floatValue: isNaN(floatValue) ? void 0 : floatValue
    };
  };
  var setPatchedCaretPosition = function(el, caretPos, currentValue) {
    if (el.selectionStart === 0 && el.selectionEnd === el.value.length) {
      return;
    }
    setCaretPosition(el, caretPos);
    timeout2.current.setCaretTimeout = setTimeout(function() {
      if (el.value === currentValue && el.selectionStart !== caretPos) {
        setCaretPosition(el, caretPos);
      }
    }, 0);
  };
  var correctCaretPosition = function(value, caretPos, direction) {
    return getCaretPosInBoundary(value, caretPos, getCaretBoundary2(value), direction);
  };
  var getNewCaretPosition = function(inputValue, newFormattedValue, caretPos) {
    var caretBoundary = getCaretBoundary2(newFormattedValue);
    var updatedCaretPos = getCaretPosition(newFormattedValue, formattedValue, inputValue, caretPos, caretBoundary, isValidInputCharacter, isCharacterSame);
    updatedCaretPos = getCaretPosInBoundary(newFormattedValue, updatedCaretPos, caretBoundary);
    return updatedCaretPos;
  };
  var updateValueAndCaretPosition = function(params) {
    var newFormattedValue = params.formattedValue;
    if (newFormattedValue === void 0)
      newFormattedValue = "";
    var input = params.input;
    var source = params.source;
    var event = params.event;
    var numAsString2 = params.numAsString;
    var caretPos;
    if (input) {
      var inputValue = params.inputValue || input.value;
      var currentCaretPosition2 = geInputCaretPosition(input);
      input.value = newFormattedValue;
      caretPos = getNewCaretPosition(inputValue, newFormattedValue, currentCaretPosition2);
      if (caretPos !== void 0) {
        setPatchedCaretPosition(input, caretPos, newFormattedValue);
      }
    }
    if (newFormattedValue !== formattedValue) {
      _onValueChange(getValueObject(newFormattedValue, numAsString2), { event, source });
    }
  };
  useEffect(function() {
    var ref2 = lastUpdatedValue.current;
    var lastFormattedValue = ref2.formattedValue;
    var lastNumAsString = ref2.numAsString;
    if (formattedValue !== lastFormattedValue || numAsString !== lastNumAsString) {
      _onValueChange(getValueObject(formattedValue, numAsString), {
        event: void 0,
        source: SourceType.props
      });
    }
  }, [formattedValue, numAsString]);
  var currentCaretPosition = focusedElm.current ? geInputCaretPosition(focusedElm.current) : void 0;
  var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
  useIsomorphicLayoutEffect(function() {
    var input = focusedElm.current;
    if (formattedValue !== lastUpdatedValue.current.formattedValue && input) {
      var caretPos = getNewCaretPosition(lastUpdatedValue.current.formattedValue, formattedValue, currentCaretPosition);
      input.value = formattedValue;
      setPatchedCaretPosition(input, caretPos, formattedValue);
    }
  }, [formattedValue]);
  var formatInputValue = function(inputValue, event, source) {
    var input = event.target;
    var changeRange = caretPositionBeforeChange.current ? findChangedRangeFromCaretPositions(caretPositionBeforeChange.current, input.selectionEnd) : findChangeRange(formattedValue, inputValue);
    var changeMeta = Object.assign(Object.assign({}, changeRange), { lastValue: formattedValue });
    var _numAsString = removeFormatting2(inputValue, changeMeta);
    var _formattedValue = _format(_numAsString);
    _numAsString = removeFormatting2(_formattedValue, void 0);
    if (isAllowed && !isAllowed(getValueObject(_formattedValue, _numAsString))) {
      var input$1 = event.target;
      var currentCaretPosition2 = geInputCaretPosition(input$1);
      var caretPos = getNewCaretPosition(inputValue, formattedValue, currentCaretPosition2);
      input$1.value = formattedValue;
      setPatchedCaretPosition(input$1, caretPos, formattedValue);
      return false;
    }
    updateValueAndCaretPosition({
      formattedValue: _formattedValue,
      numAsString: _numAsString,
      inputValue,
      event,
      source,
      input: event.target
    });
    return true;
  };
  var setCaretPositionInfoBeforeChange = function(el, endOffset) {
    if (endOffset === void 0)
      endOffset = 0;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    caretPositionBeforeChange.current = { selectionStart, selectionEnd: selectionEnd + endOffset };
  };
  var _onChange = function(e) {
    var el = e.target;
    var inputValue = el.value;
    var changed = formatInputValue(inputValue, e, SourceType.event);
    if (changed) {
      onChange(e);
    }
    caretPositionBeforeChange.current = void 0;
  };
  var _onKeyDown = function(e) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value;
    if (value === void 0)
      value = "";
    var expectedCaretPosition;
    if (key === "ArrowLeft" || key === "Backspace") {
      expectedCaretPosition = Math.max(selectionStart - 1, 0);
    } else if (key === "ArrowRight") {
      expectedCaretPosition = Math.min(selectionStart + 1, value.length);
    } else if (key === "Delete") {
      expectedCaretPosition = selectionStart;
    }
    var endOffset = 0;
    if (key === "Delete" && selectionStart === selectionEnd) {
      endOffset = 1;
    }
    var isArrowKey = key === "ArrowLeft" || key === "ArrowRight";
    if (expectedCaretPosition === void 0 || selectionStart !== selectionEnd && !isArrowKey) {
      onKeyDown(e);
      setCaretPositionInfoBeforeChange(el, endOffset);
      return;
    }
    var newCaretPosition = expectedCaretPosition;
    if (isArrowKey) {
      var direction = key === "ArrowLeft" ? "left" : "right";
      newCaretPosition = correctCaretPosition(value, expectedCaretPosition, direction);
      if (newCaretPosition !== expectedCaretPosition) {
        e.preventDefault();
      }
    } else if (key === "Delete" && !isValidInputCharacter(value[expectedCaretPosition])) {
      newCaretPosition = correctCaretPosition(value, expectedCaretPosition, "right");
    } else if (key === "Backspace" && !isValidInputCharacter(value[expectedCaretPosition])) {
      newCaretPosition = correctCaretPosition(value, expectedCaretPosition, "left");
    }
    if (newCaretPosition !== expectedCaretPosition) {
      setPatchedCaretPosition(el, newCaretPosition, value);
    }
    onKeyDown(e);
    setCaretPositionInfoBeforeChange(el, endOffset);
  };
  var _onMouseUp = function(e) {
    var el = e.target;
    var correctCaretPositionIfRequired = function() {
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value;
      if (value === void 0)
        value = "";
      if (selectionStart === selectionEnd) {
        var caretPosition = correctCaretPosition(value, selectionStart);
        if (caretPosition !== selectionStart) {
          setPatchedCaretPosition(el, caretPosition, value);
        }
      }
    };
    correctCaretPositionIfRequired();
    requestAnimationFrame(function() {
      correctCaretPositionIfRequired();
    });
    onMouseUp(e);
    setCaretPositionInfoBeforeChange(el);
  };
  var _onFocus = function(e) {
    if (e.persist) {
      e.persist();
    }
    var el = e.target;
    var currentTarget = e.currentTarget;
    focusedElm.current = el;
    timeout2.current.focusTimeout = setTimeout(function() {
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value;
      if (value === void 0)
        value = "";
      var caretPosition = correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) {
        setPatchedCaretPosition(el, caretPosition, value);
      }
      onFocus(Object.assign(Object.assign({}, e), { currentTarget }));
    }, 0);
  };
  var _onBlur = function(e) {
    focusedElm.current = null;
    clearTimeout(timeout2.current.focusTimeout);
    clearTimeout(timeout2.current.setCaretTimeout);
    onBlur(e);
  };
  var inputMode = mounted && addInputMode() ? "numeric" : void 0;
  var inputProps = Object.assign({ inputMode }, otherProps, {
    type,
    value: formattedValue,
    onChange: _onChange,
    onKeyDown: _onKeyDown,
    onMouseUp: _onMouseUp,
    onFocus: _onFocus,
    onBlur: _onBlur
  });
  if (displayType === "text") {
    return renderText ? React52__default.createElement(React52__default.Fragment, null, renderText(formattedValue, otherProps) || null) : React52__default.createElement("span", Object.assign({}, otherProps, { ref: getInputRef }), formattedValue);
  } else if (customInput) {
    var CustomInput = customInput;
    return React52__default.createElement(CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
  }
  return React52__default.createElement("input", Object.assign({}, inputProps, { ref: getInputRef }));
}
function format2(numStr, props) {
  var decimalScale = props.decimalScale;
  var fixedDecimalScale = props.fixedDecimalScale;
  var prefix = props.prefix;
  if (prefix === void 0)
    prefix = "";
  var suffix = props.suffix;
  if (suffix === void 0)
    suffix = "";
  var allowNegative = props.allowNegative;
  var thousandsGroupStyle = props.thousandsGroupStyle;
  if (thousandsGroupStyle === void 0)
    thousandsGroupStyle = "thousand";
  if (numStr === "" || numStr === "-") {
    return numStr;
  }
  var ref = getSeparators(props);
  var thousandSeparator = ref.thousandSeparator;
  var decimalSeparator = ref.decimalSeparator;
  var hasDecimalSeparator = decimalScale !== 0 && numStr.indexOf(".") !== -1 || decimalScale && fixedDecimalScale;
  var ref$1 = splitDecimal(numStr, allowNegative);
  var beforeDecimal = ref$1.beforeDecimal;
  var afterDecimal = ref$1.afterDecimal;
  var addNegation = ref$1.addNegation;
  if (decimalScale !== void 0) {
    afterDecimal = limitToScale(afterDecimal, decimalScale, !!fixedDecimalScale);
  }
  if (thousandSeparator) {
    beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
  }
  if (prefix) {
    beforeDecimal = prefix + beforeDecimal;
  }
  if (suffix) {
    afterDecimal = afterDecimal + suffix;
  }
  if (addNegation) {
    beforeDecimal = "-" + beforeDecimal;
  }
  numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || "") + afterDecimal;
  return numStr;
}
function getSeparators(props) {
  var decimalSeparator = props.decimalSeparator;
  if (decimalSeparator === void 0)
    decimalSeparator = ".";
  var thousandSeparator = props.thousandSeparator;
  var allowedDecimalSeparators = props.allowedDecimalSeparators;
  if (thousandSeparator === true) {
    thousandSeparator = ",";
  }
  if (!allowedDecimalSeparators) {
    allowedDecimalSeparators = [decimalSeparator, "."];
  }
  return {
    decimalSeparator,
    thousandSeparator,
    allowedDecimalSeparators
  };
}
function handleNegation(value, allowNegative) {
  if (value === void 0)
    value = "";
  var negationRegex = new RegExp("(-)");
  var doubleNegationRegex = new RegExp("(-)(.)*(-)");
  var hasNegation = negationRegex.test(value);
  var removeNegation = doubleNegationRegex.test(value);
  value = value.replace(/-/g, "");
  if (hasNegation && !removeNegation && allowNegative) {
    value = "-" + value;
  }
  return value;
}
function getNumberRegex(decimalSeparator, global) {
  return new RegExp("(^-)|[0-9]|" + escapeRegExp(decimalSeparator), global ? "g" : void 0);
}
function isNumericString(val, prefix, suffix) {
  if (val === "") {
    return true;
  }
  return !(prefix === null || prefix === void 0 ? void 0 : prefix.match(/\d/)) && !(suffix === null || suffix === void 0 ? void 0 : suffix.match(/\d/)) && typeof val === "string" && !isNaN(Number(val));
}
function removeFormatting(value, changeMeta, props) {
  var assign;
  if (changeMeta === void 0)
    changeMeta = getDefaultChangeMeta(value);
  var allowNegative = props.allowNegative;
  var prefix = props.prefix;
  if (prefix === void 0)
    prefix = "";
  var suffix = props.suffix;
  if (suffix === void 0)
    suffix = "";
  var decimalScale = props.decimalScale;
  var from = changeMeta.from;
  var to = changeMeta.to;
  var start = to.start;
  var end = to.end;
  var ref = getSeparators(props);
  var allowedDecimalSeparators = ref.allowedDecimalSeparators;
  var decimalSeparator = ref.decimalSeparator;
  var isBeforeDecimalSeparator = value[end] === decimalSeparator;
  if (charIsNumber(value) && (value === prefix || value === suffix) && changeMeta.lastValue === "") {
    return value;
  }
  if (end - start === 1 && allowedDecimalSeparators.indexOf(value[start]) !== -1) {
    var separator = decimalScale === 0 ? "" : decimalSeparator;
    value = value.substring(0, start) + separator + value.substring(start + 1, value.length);
  }
  var stripNegation = function(value2, start2, end2) {
    var hasNegation2 = false;
    var hasDoubleNegation = false;
    if (prefix.startsWith("-")) {
      hasNegation2 = false;
    } else if (value2.startsWith("--")) {
      hasNegation2 = false;
      hasDoubleNegation = true;
    } else if (suffix.startsWith("-") && value2.length === suffix.length) {
      hasNegation2 = false;
    } else if (value2[0] === "-") {
      hasNegation2 = true;
    }
    var charsToRemove = hasNegation2 ? 1 : 0;
    if (hasDoubleNegation) {
      charsToRemove = 2;
    }
    if (charsToRemove) {
      value2 = value2.substring(charsToRemove);
      start2 -= charsToRemove;
      end2 -= charsToRemove;
    }
    return { value: value2, start: start2, end: end2, hasNegation: hasNegation2 };
  };
  var toMetadata = stripNegation(value, start, end);
  var hasNegation = toMetadata.hasNegation;
  assign = toMetadata, value = assign.value, start = assign.start, end = assign.end;
  var ref$1 = stripNegation(changeMeta.lastValue, from.start, from.end);
  var fromStart = ref$1.start;
  var fromEnd = ref$1.end;
  var lastValue = ref$1.value;
  var updatedSuffixPart = value.substring(start, end);
  if (value.length && lastValue.length && (fromStart > lastValue.length - suffix.length || fromEnd < prefix.length) && !(updatedSuffixPart && suffix.startsWith(updatedSuffixPart))) {
    value = lastValue;
  }
  var startIndex = 0;
  if (value.startsWith(prefix)) {
    startIndex += prefix.length;
  } else if (start < prefix.length) {
    startIndex = start;
  }
  value = value.substring(startIndex);
  end -= startIndex;
  var endIndex = value.length;
  var suffixStartIndex = value.length - suffix.length;
  if (value.endsWith(suffix)) {
    endIndex = suffixStartIndex;
  } else if (end > suffixStartIndex) {
    endIndex = end;
  } else if (end > value.length - suffix.length) {
    endIndex = end;
  }
  value = value.substring(0, endIndex);
  value = handleNegation(hasNegation ? "-" + value : value, allowNegative);
  value = (value.match(getNumberRegex(decimalSeparator, true)) || []).join("");
  var firstIndex = value.indexOf(decimalSeparator);
  value = value.replace(new RegExp(escapeRegExp(decimalSeparator), "g"), function(match, index) {
    return index === firstIndex ? "." : "";
  });
  var ref$2 = splitDecimal(value, allowNegative);
  var beforeDecimal = ref$2.beforeDecimal;
  var afterDecimal = ref$2.afterDecimal;
  var addNegation = ref$2.addNegation;
  if (to.end - to.start < from.end - from.start && beforeDecimal === "" && isBeforeDecimalSeparator && !parseFloat(afterDecimal)) {
    value = addNegation ? "-" : "";
  }
  return value;
}
function getCaretBoundary(formattedValue, props) {
  var prefix = props.prefix;
  if (prefix === void 0)
    prefix = "";
  var suffix = props.suffix;
  if (suffix === void 0)
    suffix = "";
  var boundaryAry = Array.from({ length: formattedValue.length + 1 }).map(function() {
    return true;
  });
  var hasNegation = formattedValue[0] === "-";
  boundaryAry.fill(false, 0, prefix.length + (hasNegation ? 1 : 0));
  var valLn = formattedValue.length;
  boundaryAry.fill(false, valLn - suffix.length + 1, valLn + 1);
  return boundaryAry;
}
function validateAndUpdateProps(props) {
  var ref = getSeparators(props);
  var thousandSeparator = ref.thousandSeparator;
  var decimalSeparator = ref.decimalSeparator;
  var prefix = props.prefix;
  if (prefix === void 0)
    prefix = "";
  var allowNegative = props.allowNegative;
  if (allowNegative === void 0)
    allowNegative = true;
  if (thousandSeparator === decimalSeparator) {
    throw new Error("\n        Decimal separator can't be same as thousand separator.\n        thousandSeparator: " + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n        decimalSeparator: ' + decimalSeparator + " (default value for decimalSeparator is .)\n     ");
  }
  if (prefix.startsWith("-") && allowNegative) {
    console.error("\n      Prefix can't start with '-' when allowNegative is true.\n      prefix: " + prefix + "\n      allowNegative: " + allowNegative + "\n    ");
    allowNegative = false;
  }
  return Object.assign(Object.assign({}, props), { allowNegative });
}
function useNumericFormat(props) {
  props = validateAndUpdateProps(props);
  props.decimalSeparator;
  props.allowedDecimalSeparators;
  props.thousandsGroupStyle;
  var suffix = props.suffix;
  var allowNegative = props.allowNegative;
  var allowLeadingZeros = props.allowLeadingZeros;
  var onKeyDown = props.onKeyDown;
  if (onKeyDown === void 0)
    onKeyDown = noop3;
  var onBlur = props.onBlur;
  if (onBlur === void 0)
    onBlur = noop3;
  var thousandSeparator = props.thousandSeparator;
  var decimalScale = props.decimalScale;
  var fixedDecimalScale = props.fixedDecimalScale;
  var prefix = props.prefix;
  if (prefix === void 0)
    prefix = "";
  var defaultValue = props.defaultValue;
  var value = props.value;
  var valueIsNumericString = props.valueIsNumericString;
  var onValueChange = props.onValueChange;
  var restProps = __rest(props, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]);
  var ref = getSeparators(props);
  var decimalSeparator = ref.decimalSeparator;
  var allowedDecimalSeparators = ref.allowedDecimalSeparators;
  var _format = function(numStr) {
    return format2(numStr, props);
  };
  var _removeFormatting = function(inputValue, changeMeta) {
    return removeFormatting(inputValue, changeMeta, props);
  };
  var _value = isNil(value) ? defaultValue : value;
  var _valueIsNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : isNumericString(_value, prefix, suffix);
  if (!isNil(value)) {
    _valueIsNumericString = _valueIsNumericString || typeof value === "number";
  } else if (!isNil(defaultValue)) {
    _valueIsNumericString = _valueIsNumericString || typeof defaultValue === "number";
  }
  var roundIncomingValueToPrecision = function(value2) {
    if (isNotValidValue(value2)) {
      return value2;
    }
    if (typeof value2 === "number") {
      value2 = toNumericString(value2);
    }
    if (_valueIsNumericString && typeof decimalScale === "number") {
      return roundToPrecision(value2, decimalScale, Boolean(fixedDecimalScale));
    }
    return value2;
  };
  var ref$1 = useInternalValues(roundIncomingValueToPrecision(value), roundIncomingValueToPrecision(defaultValue), Boolean(_valueIsNumericString), _format, _removeFormatting, onValueChange);
  var ref$1_0 = ref$1[0];
  var numAsString = ref$1_0.numAsString;
  var formattedValue = ref$1_0.formattedValue;
  var _onValueChange = ref$1[1];
  var _onKeyDown = function(e) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value2 = el.value;
    if (value2 === void 0)
      value2 = "";
    if ((key === "Backspace" || key === "Delete") && selectionEnd < prefix.length) {
      e.preventDefault();
      return;
    }
    if (selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }
    if (key === "Backspace" && value2[0] === "-" && selectionStart === prefix.length + 1 && allowNegative) {
      setCaretPosition(el, 1);
    }
    if (decimalScale && fixedDecimalScale) {
      if (key === "Backspace" && value2[selectionStart - 1] === decimalSeparator) {
        setCaretPosition(el, selectionStart - 1);
        e.preventDefault();
      } else if (key === "Delete" && value2[selectionStart] === decimalSeparator) {
        e.preventDefault();
      }
    }
    if ((allowedDecimalSeparators === null || allowedDecimalSeparators === void 0 ? void 0 : allowedDecimalSeparators.includes(key)) && value2[selectionStart] === decimalSeparator) {
      setCaretPosition(el, selectionStart + 1);
    }
    var _thousandSeparator = thousandSeparator === true ? "," : thousandSeparator;
    if (key === "Backspace" && value2[selectionStart - 1] === _thousandSeparator) {
      setCaretPosition(el, selectionStart - 1);
    }
    if (key === "Delete" && value2[selectionStart] === _thousandSeparator) {
      setCaretPosition(el, selectionStart + 1);
    }
    onKeyDown(e);
  };
  var _onBlur = function(e) {
    var _value2 = numAsString;
    if (!_value2.match(/\d/g)) {
      _value2 = "";
    }
    if (!allowLeadingZeros) {
      _value2 = fixLeadingZero(_value2);
    }
    if (fixedDecimalScale && decimalScale) {
      _value2 = roundToPrecision(_value2, decimalScale, fixedDecimalScale);
    }
    if (_value2 !== numAsString) {
      var formattedValue2 = format2(_value2, props);
      _onValueChange({
        formattedValue: formattedValue2,
        value: _value2,
        floatValue: parseFloat(_value2)
      }, {
        event: e,
        source: SourceType.event
      });
    }
    onBlur(e);
  };
  var isValidInputCharacter = function(inputChar) {
    if (inputChar === decimalSeparator) {
      return true;
    }
    return charIsNumber(inputChar);
  };
  var isCharacterSame = function(ref2) {
    var currentValue = ref2.currentValue;
    var lastValue = ref2.lastValue;
    var formattedValue2 = ref2.formattedValue;
    var currentValueIndex = ref2.currentValueIndex;
    var formattedValueIndex = ref2.formattedValueIndex;
    var curChar = currentValue[currentValueIndex];
    var newChar = formattedValue2[formattedValueIndex];
    var typedRange = findChangeRange(lastValue, currentValue);
    var to = typedRange.to;
    if (currentValueIndex >= to.start && currentValueIndex < to.end && allowedDecimalSeparators && allowedDecimalSeparators.includes(curChar) && newChar === decimalSeparator) {
      return true;
    }
    return curChar === newChar;
  };
  return Object.assign(Object.assign({}, restProps), {
    value: formattedValue,
    valueIsNumericString: false,
    isValidInputCharacter,
    isCharacterSame,
    onValueChange: _onValueChange,
    format: _format,
    removeFormatting: _removeFormatting,
    getCaretBoundary: function(formattedValue2) {
      return getCaretBoundary(formattedValue2, props);
    },
    onKeyDown: _onKeyDown,
    onBlur: _onBlur
  });
}
function NumericFormat(props) {
  var numericFormatProps = useNumericFormat(props);
  return React52__default.createElement(NumberFormatBase, Object.assign({}, numericFormatProps));
}
var midDay = (date) => {
  const newDate = new Date(date);
  newDate.setHours(12, 0, 0, 0);
  return newDate;
};
var getMonthsArray = () => {
  const today = /* @__PURE__ */ new Date();
  const currentDay = today.getDate();
  let baseDate = currentDay > 20 ? addMonths(today, 1) : today;
  const resMonths = Array.from({ length: 12 }, (_, i) => {
    const date = midDay(startOfMonth(addMonths(baseDate, i)));
    return date;
  });
  return resMonths;
};
var getMonthsArrayWithLabels = () => {
  return getMonthsArray().map((date) => {
    const shortMonthName = date.toLocaleString(void 0, { month: "short" });
    const lastTwoDigitsOfYear = date.getFullYear().toString().slice(-2);
    return {
      label: `${shortMonthName} \u2013 ${lastTwoDigitsOfYear}`,
      value: date.toISOString()
    };
  });
};
var convertCbftToHectoliter = (cbft) => {
  return Math.round(3531 / cbft);
};
var getCopyMonthLabel = (month) => {
  const date = typeof month === "string" ? new Date(month) : month;
  return `${date.toLocaleString(void 0, { month: "short" })}-${date.getFullYear()}`;
};
var CopyOutputButton = ({
  data: data2,
  disabled,
  selectedMonth
}) => {
  const ctx = useContext(CalcContext);
  if (!ctx) {
    throw new Error("CalcContext is not provided");
  }
  const theme = useTheme$1();
  const isDarkMode = theme.palette.mode === "dark";
  const { apiRoutes } = ctx;
  const { trigger, isMutating } = useAdminApiMutation(
    {
      url: apiRoutes.copyOutput,
      method: "POST"
    }
  );
  const [copySuccess, setCopySuccess] = useState("");
  const [copyError, setCopyError] = useState("");
  useEffect(() => {
    setCopySuccess("");
  }, [data2, selectedMonth]);
  const copyOutput = async () => {
    setCopyError("");
    try {
      const response = await trigger({
        body: { calculationsIds: data2, selectedMonth }
      });
      await navigator.clipboard.writeText(response.copyText);
      setCopySuccess(response.copyText);
    } catch (error) {
      setCopyError("Error copying output to clipboard: " + error.message);
    }
  };
  const onNotificationClose = useCallback(
    (_, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setCopyError("");
    },
    [setCopyError]
  );
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(
      Tooltip,
      {
        title: /* @__PURE__ */ jsx("span", { style: { whiteSpace: "pre-line" }, children: copySuccess ? copySuccess : "Copy Calculator Output" }),
        children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
          IconButton,
          {
            "aria-label": "copy output",
            color: "primary",
            onClick: copyOutput,
            disabled: isMutating || disabled,
            sx: {
              "&.Mui-disabled": {
                opacity: 0.5
              }
            },
            children: /* @__PURE__ */ jsx(ContentCopy, { fontSize: "medium" })
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx(
      Snackbar,
      {
        open: copyError !== "",
        autoHideDuration: 1e4,
        anchorOrigin: { vertical: "top", horizontal: "center" },
        onClose: onNotificationClose,
        message: copyError,
        sx: {
          ".MuiSnackbarContent-root": {
            background: isDarkMode ? darkGrey : void 0
          }
        }
      },
      "notification"
    )
  ] });
};
var CopyOutputButton_default = CopyOutputButton;
var CalculatorModeToggle = ({
  control
}) => {
  const ctx = useContext(CalcContext);
  if (ctx?.isCFROptimizer) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    FormControlLabel,
    {
      control: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "mode",
          control,
          render: ({ field }) => /* @__PURE__ */ jsxs(
            ToggleButtonGroup,
            {
              value: field.value,
              exclusive: true,
              onChange: (_, newMode) => {
                if (newMode !== null) {
                  field.onChange(newMode);
                }
              },
              "aria-label": "calculator mode",
              children: [
                /* @__PURE__ */ jsx(
                  ToggleButton,
                  {
                    value: 0 /* simple */,
                    "aria-label": "Simple mode",
                    sx: {
                      paddingTop: "5px",
                      paddingBottom: "5px"
                    },
                    children: "Simple"
                  }
                ),
                /* @__PURE__ */ jsx(
                  ToggleButton,
                  {
                    value: 1 /* advanced */,
                    "aria-label": "Advanced mode",
                    sx: {
                      paddingTop: "5px",
                      paddingBottom: "5px"
                    },
                    children: "Advanced"
                  }
                ),
                /* @__PURE__ */ jsx(
                  ToggleButton,
                  {
                    value: 2 /* multi */,
                    "aria-label": "Multi mode",
                    sx: {
                      paddingTop: "5px",
                      paddingBottom: "5px"
                    },
                    children: "Multi"
                  }
                )
              ]
            }
          )
        }
      ),
      label: "",
      sx: { mr: 0, ml: 0 }
    }
  );
};
var OptimizerModeToggle = ({
  control
}) => {
  const ctx = useContext(CalcContext);
  if (!ctx?.isCFROptimizer) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    FormControlLabel,
    {
      control: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "optimizerMode",
          control,
          render: ({ field }) => /* @__PURE__ */ jsxs(
            ToggleButtonGroup,
            {
              value: field.value,
              exclusive: true,
              onChange: (_, newMode) => {
                if (newMode !== null) {
                  field.onChange(newMode);
                }
              },
              "aria-label": "optimizer mode",
              children: [
                /* @__PURE__ */ jsx(
                  ToggleButton,
                  {
                    value: "optimize",
                    "aria-label": "Optimize route order",
                    sx: {
                      paddingTop: "5px",
                      paddingBottom: "5px"
                    },
                    children: "Optimize route order"
                  }
                ),
                /* @__PURE__ */ jsx(
                  ToggleButton,
                  {
                    value: "fixed",
                    "aria-label": "Fixed route order",
                    sx: {
                      paddingTop: "5px",
                      paddingBottom: "5px"
                    },
                    children: "Fixed route order"
                  }
                )
              ]
            }
          )
        }
      ),
      label: "",
      sx: { mr: 0, ml: 0 }
    }
  );
};
var OptimizeBaseToggle = ({
  control
}) => {
  const ctx = useContext(CalcContext);
  if (!ctx?.isCFROptimizer) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    FormControlLabel,
    {
      control: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "optimizeBase",
          control,
          render: ({ field }) => /* @__PURE__ */ jsxs(
            ToggleButtonGroup,
            {
              value: field.value,
              exclusive: true,
              onChange: (_, newMode) => {
                if (newMode !== null) {
                  field.onChange(newMode);
                }
              },
              "aria-label": "optimizer basis",
              children: [
                /* @__PURE__ */ jsx(
                  ToggleButton,
                  {
                    value: "cheapest",
                    "aria-label": "Cheapest freight",
                    sx: {
                      paddingTop: "5px",
                      paddingBottom: "5px"
                    },
                    children: "Cheapest freight"
                  }
                ),
                /* @__PURE__ */ jsx(
                  ToggleButton,
                  {
                    value: "profitLoss",
                    "aria-label": "Profit/loss",
                    sx: {
                      paddingTop: "5px",
                      paddingBottom: "5px"
                    },
                    children: "Profit/loss"
                  }
                )
              ]
            }
          )
        }
      ),
      label: "",
      sx: { mr: 0, ml: 0 }
    }
  );
};
var CalculatorButtons = ({
  calculatorMode,
  onResetButtonClick,
  canCalculate
}) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(
    Button,
    {
      disabled: !canCalculate,
      variant: "contained",
      size: "medium",
      type: "submit",
      fullWidth: true,
      sx: {
        minHeight: "40px",
        // Same height as input fields
        borderRadius: "0.5rem",
        float: "right",
        width: {
          lg: calculatorMode !== 0 /* simple */ ? "60%" : void 0
        },
        "&.Mui-disabled": {
          color: (theme) => theme.palette.mode === "light" ? white : "rgba(0, 0, 0, 0.87)",
          boxShadow: "inherit",
          backgroundColor: (theme) => theme.palette.mode === "light" ? lightBlue : lightGreen,
          opacity: 0.5
        }
      },
      children: "Calculate Freight Rate"
    }
  ),
  /* @__PURE__ */ jsx(
    Button,
    {
      variant: "outlined",
      size: "medium",
      color: "primary",
      type: "reset",
      onClick: onResetButtonClick,
      fullWidth: true,
      sx: {
        minHeight: "40px",
        // Same height as input fields
        borderRadius: "0.5rem",
        float: "right",
        width: {
          lg: calculatorMode !== 0 /* simple */ ? "60%" : void 0
        }
      },
      children: "Reset Calculator"
    }
  )
] });
var CalcControlsLayout = ({
  topLeftNode,
  topRightNode,
  bottomRightNode,
  children,
  calculatorMode,
  onResetButtonClick,
  control,
  canCalculate
}) => {
  useContext(CalcContext);
  const hasTopLeftNode = Boolean(topLeftNode);
  const modeToggle = /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        alignItems: "center"
      },
      children: [
        topRightNode,
        /* @__PURE__ */ jsx(CalculatorModeToggle, { control })
      ]
    }
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Box,
      {
        sx: {
          display: "flex",
          gap: {
            xs: "1.25rem",
            sm: "0.625rem"
          },
          flexDirection: {
            xs: "column-reverse",
            sm: "column"
          }
        },
        children: [
          /* @__PURE__ */ jsxs(
            Box,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                flexDirection: {
                  xs: "column",
                  sm: "column",
                  md: "row",
                  lg: "row"
                },
                gap: "16px"
              },
              children: [
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    sx: {
                      display: hasTopLeftNode ? "block" : "none",
                      width: "300%"
                    },
                    children: topLeftNode
                  }
                ),
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    display: "flex",
                    sx: {
                      width: "100%",
                      justifyContent: {
                        xs: "center",
                        md: "flex-end"
                      }
                    },
                    children: modeToggle
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            Box,
            {
              sx: {
                display: "flex",
                gap: {
                  xs: "0",
                  sm: "0",
                  md: "0",
                  lg: "16px"
                },
                margin: {
                  md: "0 auto"
                },
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "60%",
                  lg: "100%"
                }
              },
              children: [
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    sx: {
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "100%",
                        lg: "60%"
                      },
                      ...calculatorMode !== 0 /* simple */ ? {
                        width: {
                          xs: "100%",
                          sm: "100%",
                          md: "100%",
                          lg: "75%"
                        }
                      } : null
                    },
                    children: /* @__PURE__ */ jsx(
                      Box,
                      {
                        sx: {
                          display: "flex",
                          alignItems: "flex-start",
                          // justifyContent: 'center',
                          gap: "32px",
                          flexWrap: calculatorMode === 1 /* advanced */ ? "wrap" : "nowrap",
                          flexDirection: {
                            xs: "column",
                            sm: "column",
                            md: "column",
                            lg: "row"
                          }
                        },
                        children
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsx(Box, { sx: { flexGrow: 1 } }),
                /* @__PURE__ */ jsxs(
                  Box,
                  {
                    sx: {
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "none",
                        lg: "flex"
                      },
                      justifySelf: "flex-end",
                      width: "40%",
                      gap: "32px",
                      ...calculatorMode !== 0 /* simple */ ? {
                        flexDirection: "column",
                        alignItems: "flex-end",
                        width: "25%"
                      } : null
                    },
                    children: [
                      /* @__PURE__ */ jsx(
                        CalculatorButtons,
                        {
                          canCalculate,
                          calculatorMode,
                          onResetButtonClick
                        }
                      ),
                      bottomRightNode
                    ]
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          display: {
            xs: "flex",
            sm: "flex",
            lg: "none"
          },
          justifyContent: "center",
          paddingTop: "32px"
        },
        children: /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              display: "flex",
              flexDirection: "column",
              gap: "32px",
              width: {
                xs: "100%",
                sm: "100%",
                md: "60%",
                lg: "100%"
              }
            },
            children: [
              /* @__PURE__ */ jsx(
                CalculatorButtons,
                {
                  canCalculate,
                  calculatorMode,
                  onResetButtonClick
                }
              ),
              bottomRightNode
            ]
          }
        )
      }
    )
  ] });
};
var SquareIconButton = styled$1(Button)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: 0,
  width: 40,
  height: 40,
  minWidth: "auto",
  borderColor: theme.palette.divider
}));

// ../calculator-ui/src/CalcControls/CalcMultiModeWidget/defaults.ts
var multiModeDefaultOperation = {
  operation: OperationType.L,
  amount: void 0,
  commodity: void 0,
  cadence: void 0,
  terms: void 0,
  draft: void 0,
  useVesselGear: void 0,
  tolerance: void 0,
  commodityPrice: void 0,
  userCfrPrice: void 0,
  stowageFactor: void 0
};
var multiModeDefaultValues = {
  ports: [
    {
      port: void 0,
      operations: [structuredClone(multiModeDefaultOperation)]
    }
  ],
  useCache: true
};
var isMultiModeInput = (input) => {
  return input.ports !== void 0;
};
var clonePortInput = (input, isLoadOperation) => {
  const res = structuredClone(isMultiModeInput(input) ? input.ports[0] : input);
  if (!isLoadOperation && res.operations[0]) {
    res.operations[0].operation = OperationType.D;
  }
  return res;
};
var DEFAULT_OVERRIDE_VAL = -1;
var OperationRowError = ({ children }) => /* @__PURE__ */ jsx(
  Box,
  {
    sx: {
      display: "flex",
      flexDirection: "row",
      paddingLeft: "44px",
      gap: "8px"
    },
    children: /* @__PURE__ */ jsx(Alert, { severity: "error", children })
  }
);
var StyledAutocomplete = styled$1(Autocomplete)(({ theme }) => ({
  ".MuiAutocomplete-inputRoot fieldset": {
    borderColor: theme.palette.divider
  },
  ".MuiOutlinedInput-root": {
    borderRadius: "0.25rem"
  },
  ".MuiOutlinedInput-root .MuiInputBase-input.MuiInputBase-input": {
    paddingTop: "4.5px",
    paddingBottom: "4.5px"
  }
}));
var StyledSmallAutocomplete = styled$1(Autocomplete)(({ theme }) => ({
  ".MuiAutocomplete-inputRoot fieldset": {
    borderColor: theme.palette.divider
  },
  ".MuiOutlinedInput-root": {
    borderRadius: "0.25rem"
  },
  ".MuiOutlinedInput-root .MuiInputBase-input.MuiInputBase-input": {
    paddingTop: "2.5px",
    paddingBottom: "2.5px"
  }
}));
var StyledTextField = styled$1(TextField)(({ theme }) => ({
  ".MuiOutlinedInput-root": {
    borderRadius: "0.25rem"
  },
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.divider
  }
}));

// ../calculator-ui/src/CalcControls/CalcMultiModeWidget/overrides/helpers.ts
var getDefaultVal = (field) => {
  if (field.endsWith("seVesselGear")) {
    return true;
  }
  return DEFAULT_OVERRIDE_VAL;
};
var getFieldLabel = (field) => {
  switch (field) {
    case "hireOverride":
      return "Hire";
    case "mgoOverride":
      return "LSMGO";
    case "sfoOverride":
      return "VLSFO";
    case "ballastBonusOverride":
      return "Ballast Bonus";
    case "stowageFactorOverride":
      return "Stowage Factor";
    case "loadPortDA":
      return "Load Port DA";
    case "loadPortDraft":
      return "Load Port Draft";
    case "dischPortDA":
      return "Disch Port DA";
    case "dischPortDraft":
      return "Disch Port Draft";
    case "loadPortUseVesselGear":
      return "Load Port Use Vessel Gear";
    case "dischPortUseVesselGear":
      return "Disch Port Use Vessel Gear";
  }
  if (field.endsWith("stowageFactor")) {
    return "Stowage Factor";
  }
  if (field.endsWith("ortDA")) {
    return "Port DA";
  }
  if (field.endsWith("draft")) {
    return "Port Draft";
  }
  if (field.endsWith("cadence")) {
    return "Cadence";
  }
  if (field.endsWith("terms")) {
    return "Terms";
  }
  if (field.endsWith("tolerance")) {
    return "Tolerance";
  }
  if (field.endsWith("commodityPrice")) {
    return "FOB Price";
  }
  if (field.endsWith("userCfrPrice")) {
    return "CFR Price";
  }
  if (field.endsWith("useVesselGear")) {
    return "Use Vessel Gear";
  }
  return field;
};
function OverrideSelector({
  hasAnyExtraOverrides,
  isMobileView,
  fields,
  setValue
}) {
  return /* @__PURE__ */ jsxs(
    SquareIconButton,
    {
      "aria-label": "Add overrides",
      title: "Add overrides",
      disabled: !hasAnyExtraOverrides,
      sx: {
        position: "relative",
        "&:disabled > .MuiIconButton-root": {
          color: "action.disabled"
        }
      },
      children: [
        /* @__PURE__ */ jsx(AppRegistration, {}),
        isMobileView ? /* @__PURE__ */ jsxs(
          "select",
          {
            name: "overrides",
            style: {
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              opacity: 0
            },
            disabled: !hasAnyExtraOverrides,
            value: "",
            onChange: (e) => {
              const selectedOverride = e.target.value;
              setValue(selectedOverride, getDefaultVal(selectedOverride));
            },
            children: [
              /* @__PURE__ */ jsxs("option", { disabled: true, selected: true, value: "", children: [
                " ",
                "-- select an option --",
                " "
              ] }),
              fields.map((fieldName) => /* @__PURE__ */ jsx("option", { value: fieldName, selected: false, children: getFieldLabel(fieldName) }, fieldName))
            ]
          }
        ) : /* @__PURE__ */ jsx(
          Select,
          {
            value: "",
            label: "override",
            sx: {
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              opacity: 0
            },
            disabled: !hasAnyExtraOverrides,
            onChange: (e) => {
              const selectedOverride = e.target.value;
              setValue(selectedOverride, getDefaultVal(selectedOverride));
            },
            children: fields.map((fieldName) => /* @__PURE__ */ jsx(MenuItem, { value: fieldName, children: getFieldLabel(fieldName) }, fieldName))
          }
        )
      ]
    }
  );
}
var isCustomField = (cfg) => {
  return cfg.render !== void 0;
};
var isDefaultField = (cfg) => {
  return cfg.adornment !== void 0;
};
function getFieldConfig(field, termsOptions, AutoCompleteField) {
  const AutoCompleteComponent = AutoCompleteField ?? StyledAutocomplete;
  switch (field) {
    case "ballastBonusOverride":
      return {
        adornment: "%",
        max: 100
      };
    case "hireOverride":
    case "mgoOverride":
    case "sfoOverride":
      return {
        adornment: "USD",
        max: Number.MAX_SAFE_INTEGER
      };
  }
  if (field === "stowageFactorOverride" || field.endsWith("stowageFactor")) {
    return {
      adornment: "cbft/mt",
      max: Number.MAX_SAFE_INTEGER,
      wider: true
    };
  }
  if (field.endsWith("ortDA")) {
    return {
      adornment: "USD",
      max: Number.MAX_SAFE_INTEGER
    };
  }
  if (field.endsWith("commodityPrice") || field.endsWith("userCfrPrice")) {
    return {
      adornment: "USD",
      max: Number.MAX_SAFE_INTEGER
    };
  }
  if (field.endsWith("tolerance")) {
    return {
      adornment: "%",
      max: 100
    };
  }
  if (field.endsWith("ortDraft")) {
    return {
      adornment: "m",
      max: Number.MAX_SAFE_INTEGER
    };
  }
  if (field.endsWith("cadence")) {
    return {
      adornment: "mt",
      max: Number.MAX_SAFE_INTEGER
    };
  }
  if (field.endsWith("terms")) {
    return {
      manualDelete: true,
      render: ({
        field: { onChange, value: fieldValue, ...field2 },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx(
        AutoCompleteComponent,
        {
          options: termsOptions,
          autoSelect: true,
          value: termsOptions?.find((o) => o.value === fieldValue) || null,
          renderInput: ({
            key,
            ...params
          }) => /* @__PURE__ */ jsx(
            TextField,
            {
              ...params,
              error: !!error,
              label: "Terms",
              variant: "outlined",
              fullWidth: true,
              size: "small",
              required: true,
              sx: {
                minWidth: "200px"
              }
            },
            key
          ),
          onChange: (_, value) => {
            const newVal = value?.value ?? "";
            onChange(newVal ? newVal : void 0);
          },
          ...field2
        }
      )
    };
  }
  if (field.endsWith("seVesselGear")) {
    return {
      manualDelete: true,
      render: ({
        field: { onChange, value: fieldValue, ...field2 },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx(
        AutoCompleteComponent,
        {
          options: yesNoChoices,
          autoSelect: true,
          size: "small",
          value: yesNoChoices?.find(
            (o) => fieldValue ? o.value === "yes" : o.value === "no"
          ) || null,
          renderInput: ({
            key,
            ...params
          }) => /* @__PURE__ */ jsx(
            TextField,
            {
              ...params,
              error: !!error,
              label: "Using Vessel Gear?",
              variant: "outlined",
              fullWidth: true,
              size: "small",
              required: true,
              sx: {
                minWidth: "200px"
              }
            },
            key
          ),
          onChange: (_, value) => {
            const newVal = value?.value ?? "";
            onChange(newVal ? newVal === "yes" : void 0);
          },
          ...field2
        }
      )
    };
  }
  return {
    adornment: "",
    max: Number.MAX_SAFE_INTEGER
  };
}
var yesNoChoices = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" }
];
var InputWithDeleteAction = ({
  children,
  onDelete
}) => {
  return /* @__PURE__ */ jsxs(Box, { sx: { position: "relative" }, children: [
    children,
    /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          position: "absolute",
          right: "8px",
          top: 0,
          bottom: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: /* @__PURE__ */ jsx(
          SquareIconButton,
          {
            "aria-label": "Remove override",
            title: "Remove override",
            onClick: onDelete,
            children: /* @__PURE__ */ jsx(Delete, { sx: { color: "action.active" } })
          }
        )
      }
    )
  ] });
};
function OverrideField({
  label,
  removeItem,
  field,
  control,
  termsOptions,
  AutoCompleteField,
  visibleByDefault
}) {
  const deleteItem = useCallback(() => {
    removeItem(field);
  }, [field, removeItem]);
  const cfg = useMemo(
    () => getFieldConfig(field, termsOptions, AutoCompleteField),
    [field, termsOptions]
  );
  const renderFn = useMemo(() => {
    if (isCustomField(cfg)) {
      return cfg.render;
    }
    if (isDefaultField(cfg)) {
      const fn = ({
        field: { value, onChange },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx(
        StyledTextField,
        {
          label,
          onChange: (e) => {
            if (e.target.value === "") {
              onChange(0);
              return;
            }
            let value2 = parseFloat(e.target.value) ?? 0;
            if (isNaN(value2)) {
              return;
            }
            if (value2 === Infinity || value2 > cfg.max) {
              value2 = cfg.max;
            }
            onChange(value2);
          },
          type: "number",
          size: "small",
          value: value === DEFAULT_OVERRIDE_VAL ? "" : value,
          InputLabelProps: {
            shrink: (value === DEFAULT_OVERRIDE_VAL ? "" : `${value}`) !== ""
          },
          error: !!error,
          InputProps: {
            endAdornment: /* @__PURE__ */ jsx(
              InputAdornment,
              {
                position: "end",
                sx: visibleByDefault ? {} : { paddingRight: "44px" },
                children: cfg.adornment
              }
            ),
            sx: {
              width: cfg.wider ? "300px" : "215px"
            }
          }
        }
      );
      return fn;
    }
    throw new Error("Invalid field config");
  }, [cfg]);
  if (cfg.manualDelete || visibleByDefault) {
    return /* @__PURE__ */ jsx(Controller, { name: field, control, render: renderFn });
  }
  return /* @__PURE__ */ jsx(InputWithDeleteAction, { onDelete: deleteItem, children: /* @__PURE__ */ jsx(Controller, { name: field, control, render: renderFn }) });
}
var globalOverrideFieldNames = [
  "hireOverride",
  "sfoOverride",
  "mgoOverride",
  "ballastBonusOverride"
];
var isPortOverrides = (props) => {
  return props.level === "port";
};
var isOperationOverrides = (props) => {
  return props.level === "operation";
};
var OverridesForm = ({
  control,
  setValue,
  ...rest
}) => {
  let fields;
  let termsOptions = emptyArr;
  const ctx = useContext(CalcContext);
  let alwaysVisibleFields = [];
  let fieldNames;
  if (isPortOverrides(rest)) {
    const { portIndex } = rest;
    fieldNames = [`ports.${portIndex}.port`, "optimizeBase"];
  } else if (isOperationOverrides(rest)) {
    const { portIndex } = rest;
    fieldNames = [
      `ports.${portIndex}.operations.${rest.operationIndex}.operation`,
      "optimizeBase"
    ];
  } else {
    fieldNames = ["optimizerMode", "optimizeBase"];
  }
  const [operationType, optimizeBase] = useWatch({
    control,
    name: fieldNames
  });
  if (isPortOverrides(rest)) {
    const { portIndex } = rest;
    fields = [`ports.${portIndex}.portDA`];
  } else if (isOperationOverrides(rest)) {
    const { portIndex } = rest;
    fields = [
      `ports.${portIndex}.operations.${rest.operationIndex}.cadence`,
      `ports.${portIndex}.operations.${rest.operationIndex}.terms`,
      `ports.${portIndex}.operations.${rest.operationIndex}.useVesselGear`,
      `ports.${portIndex}.operations.${rest.operationIndex}.tolerance`,
      `ports.${portIndex}.operations.${rest.operationIndex}.stowageFactor`,
      `ports.${portIndex}.operations.${rest.operationIndex}.draft`
    ];
    if (rest.isCFROptimizer) {
      alwaysVisibleFields.push(
        `ports.${portIndex}.operations.${rest.operationIndex}.tolerance`
      );
      const fobField = `ports.${portIndex}.operations.${rest.operationIndex}.commodityPrice`;
      const cfrField = `ports.${portIndex}.operations.${rest.operationIndex}.userCfrPrice`;
      if (optimizeBase === "profitLoss") {
        if (operationType === OperationType.L) {
          alwaysVisibleFields.push(fobField);
          fields.push(fobField);
        } else {
          alwaysVisibleFields.push(cfrField);
          fields.push(cfrField);
        }
      }
    }
    termsOptions = rest.termsOptions;
  } else {
    fields = globalOverrideFieldNames.filter((x) => {
      if (x === "ballastBonusOverride") {
        if (ctx?.disableBallastBonus) {
          return false;
        }
      }
      return true;
    });
  }
  const values3 = useWatch({
    control,
    name: fields
  });
  if (!ctx) {
    throw new Error("CalcContext is not provided");
  }
  const hasAnyExtraOverrides = useMemo(
    () => values3.some((x) => x === void 0),
    [values3]
  );
  const removeItem = useCallback(
    (field) => {
      setValue(field, void 0);
    },
    [setValue]
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "row",
        gap: "32px",
        alignItems: "center",
        position: "relative"
      },
      children: [
        /* @__PURE__ */ jsx(
          OverrideSelector,
          {
            hasAnyExtraOverrides,
            setValue,
            isMobileView: ctx.isMobileView,
            fields: fields.filter(
              (fieldName, i) => values3[i] === void 0 && !alwaysVisibleFields.includes(fieldName)
            )
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              display: "flex",
              flexWrap: "wrap",
              gap: "16px"
            },
            children: fields.filter(
              (fieldName, i) => values3[i] !== void 0 || alwaysVisibleFields.includes(fieldName)
            ).map((fieldName) => /* @__PURE__ */ jsx(
              OverrideField,
              {
                label: getFieldLabel(fieldName),
                removeItem,
                field: fieldName,
                control,
                termsOptions,
                visibleByDefault: alwaysVisibleFields.includes(fieldName)
              },
              fieldName
            ))
          }
        )
      ]
    }
  );
};
var emptyArr = [];
var StyledToggleButtonGroup = styled$1(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: theme.shape.borderRadius,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0
    }
  }
}));
var OperationRowWidgetComponent = ({
  id,
  commodities,
  control,
  portIndex,
  index,
  remove,
  setValue,
  termsOptions,
  isCFROptimizer
}) => {
  const theme = useTheme$1();
  const isDarkMode = theme.palette.mode === "dark";
  const {
    setNodeRef,
    setActivatorNodeRef,
    listeners,
    isDragging,
    transform,
    transition
  } = useSortable({
    id,
    data: {
      type: "operation",
      origIndex: index,
      portIndex
    }
  });
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        paddingLeft: "44px",
        gap: "8px",
        ...isDragging ? {
          opacity: 0.3
        } : {}
      },
      ref: setNodeRef,
      style: {
        transition,
        transform: CSS.Translate.toString(transform)
      },
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            component: "button",
            sx: {
              backgroundColor: "transparent",
              border: "none",
              cursor: "grab",
              padding: "8px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: isDarkMode ? darkGrey : dragHandleLightTheme
            },
            ref: setActivatorNodeRef,
            ...listeners,
            children: /* @__PURE__ */ jsx(DragHandle, {})
          }
        ),
        /* @__PURE__ */ jsx(
          Paper,
          {
            elevation: 0,
            sx: {
              display: "flex",
              border: (theme2) => `1px solid ${theme2.palette.divider}`,
              flexWrap: "wrap"
            },
            children: /* @__PURE__ */ jsx(
              Controller,
              {
                name: `ports.${portIndex}.operations.${index}.operation`,
                control,
                render: ({ field: { value, onChange } }) => /* @__PURE__ */ jsxs(
                  StyledToggleButtonGroup,
                  {
                    value,
                    exclusive: true,
                    onChange: (_, newVal) => {
                      onChange(newVal);
                    },
                    "aria-label": "operation",
                    children: [
                      /* @__PURE__ */ jsx(
                        ToggleButton,
                        {
                          value: OperationType.L,
                          "aria-label": "Load operation",
                          sx: {
                            paddingTop: "3px",
                            paddingBottom: "3px"
                          },
                          children: "Load"
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        ToggleButton,
                        {
                          value: OperationType.D,
                          "aria-label": "Discharge operation",
                          sx: {
                            paddingTop: "3px",
                            paddingBottom: "3px"
                          },
                          children: "Discharge"
                        }
                      )
                    ]
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(
          Controller,
          {
            name: `ports.${portIndex}.operations.${index}.amount`,
            control,
            render: ({ field: { value, onChange }, fieldState: { error } }) => /* @__PURE__ */ jsx(
              StyledTextField,
              {
                label: "Amount",
                variant: "outlined",
                size: "small",
                type: "number",
                value,
                error: !!error,
                onChange: (e) => {
                  const val = parseInt(e.target.value, 10);
                  if (val < 1) {
                    onChange(1);
                  } else {
                    onChange(val);
                  }
                },
                required: true,
                InputProps: {
                  endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: "mt" }),
                  sx: {
                    paddingBottom: "10.5px",
                    paddingTop: "10.5px",
                    height: "44px"
                  }
                }
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(Box, { minWidth: "200px", children: /* @__PURE__ */ jsx(
          Controller,
          {
            name: `ports.${portIndex}.operations.${index}.commodity`,
            control,
            render: ({
              field: { onChange, value: fieldValue, ...field },
              fieldState: { error }
            }) => /* @__PURE__ */ jsx(
              StyledAutocomplete,
              {
                options: commodities ?? [],
                autoSelect: true,
                value: commodities?.find((o) => o.value === fieldValue) || null,
                renderInput: ({
                  key,
                  ...params
                }) => /* @__PURE__ */ jsx(
                  TextField,
                  {
                    ...params,
                    error: !!error,
                    label: "Commodity",
                    variant: "outlined",
                    fullWidth: true,
                    size: "small",
                    required: true
                  },
                  key
                ),
                onChange: (_, value) => onChange(value?.value ?? ""),
                ...field
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsx(
          OverridesForm,
          {
            control,
            portIndex,
            operationIndex: index,
            setValue,
            level: "operation",
            termsOptions,
            isCFROptimizer
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              alignItems: "center",
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ jsx(
              SquareIconButton,
              {
                "aria-label": "delete operation",
                title: "Delete operation",
                sx: {
                  color: theme.palette.divider
                },
                onClick: () => remove(index),
                children: /* @__PURE__ */ jsx(Delete, {})
              }
            )
          }
        )
      ]
    }
  );
};
var OperationRowWidget = React52__default.memo(OperationRowWidgetComponent);
function isSet(value) {
  return value !== void 0 && value !== "" && value !== null;
}
var isEmpty = (operation) => {
  return !isSet(operation.amount) && !isSet(operation.commodity) && !isSet(operation.cadence) && !isSet(operation.terms);
};
var PortWidgetLayoutComponent = ({
  index,
  control,
  portOptions,
  commodities,
  termsOptions,
  portOperations,
  rootProps,
  handleProps,
  errorMessage,
  suggestions,
  addOperation,
  updateOperation,
  removeOperation,
  deletePort,
  addPortBeforeNode,
  addPortAfterNode,
  isDragging,
  setValue
}) => {
  const ctx = React52__default.useContext(CalcContext);
  const isCFROptimizer = ctx?.isCFROptimizer;
  const maybeAppend = useCallback(
    (item) => {
      for (const [i, operation] of portOperations.entries()) {
        if (isEmpty(operation) || operation.commodity === item.commodity && operation.operation === item.operation) {
          updateOperation(i, {
            ...item,
            amount: (operation.amount ?? 0) + (item.amount ?? 0)
          });
          return;
        }
      }
      addOperation(item);
    },
    [portOperations, addOperation, updateOperation]
  );
  const theme = useTheme$1();
  const isDarkMode = theme.palette.mode === "dark";
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        border: "1px solid #000",
        borderColor: theme.palette.divider,
        borderRadius: "0.25rem",
        padding: "12px 10px",
        gap: "12px",
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        ...isDragging ? {
          opacity: 0.3
        } : {}
      },
      ...rootProps,
      children: [
        addPortBeforeNode,
        /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              gap: "8px"
            },
            children: [
              /* @__PURE__ */ jsx(
                Box,
                {
                  component: "button",
                  sx: {
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "grab",
                    marginLeft: "-10px",
                    marginTop: "-8px",
                    padding: "8px 10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: isDarkMode ? darkGrey : dragHandleLightTheme
                  },
                  ...handleProps,
                  children: /* @__PURE__ */ jsx(DragHandle, {})
                }
              ),
              /* @__PURE__ */ jsx(Box, { minWidth: "30%", children: /* @__PURE__ */ jsx(
                Controller,
                {
                  name: `ports.${index}.port`,
                  control,
                  render: ({
                    field: { onChange, value: fieldValue, ...field },
                    fieldState: { error }
                  }) => /* @__PURE__ */ jsx(
                    StyledAutocomplete,
                    {
                      options: portOptions ?? [],
                      autoSelect: true,
                      value: portOptions?.find((o) => o.value === fieldValue) || null,
                      renderInput: ({
                        key,
                        ...params
                      }) => /* @__PURE__ */ jsx(
                        TextField,
                        {
                          ...params,
                          label: "Port",
                          variant: "outlined",
                          fullWidth: true,
                          size: "small",
                          required: true,
                          error: !!error
                        },
                        key
                      ),
                      onChange: (_, value) => onChange(value?.value ?? ""),
                      ...field
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ jsx(
                OverridesForm,
                {
                  control,
                  setValue,
                  level: "port",
                  portIndex: index
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          SortableContext,
          {
            items: portOperations,
            strategy: verticalListSortingStrategy,
            children: portOperations.map((item, i) => /* @__PURE__ */ jsx(
              OperationRowWidget,
              {
                id: item.id,
                portIndex: index,
                commodities,
                control,
                index: i,
                remove: removeOperation,
                setValue,
                termsOptions,
                isCFROptimizer
              },
              item.id
            ))
          }
        ),
        errorMessage && /* @__PURE__ */ jsx(OperationRowError, { children: errorMessage }),
        /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              paddingBottom: "16px",
              paddingTop: "16px",
              gap: "12px 24px",
              flexWrap: "wrap",
              marginRight: "60px"
            },
            children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "text",
                  sx: { marginRight: "42px" },
                  startIcon: /* @__PURE__ */ jsx(Add, {}),
                  onClick: () => addOperation({
                    ...structuredClone(multiModeDefaultOperation),
                    operation: index > 0 ? OperationType.D : OperationType.L
                  }),
                  children: "Add row"
                }
              ),
              suggestions.length > 0 && suggestions.map((suggestion, i) => /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "text",
                  onClick: () => maybeAppend(suggestion),
                  children: `Add ${suggestion.operation === OperationType.L ? "load" : "discharge"} ${suggestion.amount} ${suggestion.commodity}`
                },
                i
              ))
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          SquareIconButton,
          {
            sx: {
              position: "absolute",
              bottom: "10px",
              right: "10px",
              color: theme.palette.divider
            },
            "aria-label": "delete port",
            title: "Delete port",
            onClick: deletePort,
            children: /* @__PURE__ */ jsx(Delete, {})
          }
        ),
        addPortAfterNode
      ]
    }
  );
};
var PortWidgetLayout = React52__default.memo(PortWidgetLayoutComponent);
var PortWidgetComponent = ({
  id,
  portOptions,
  commodities,
  termsOptions,
  inOverlay,
  operationIdRef,
  moveRefs,
  index,
  addRoutePointBefore,
  addRoutePointAfter,
  deleteRoutePoint,
  isLast,
  control,
  errorMessage,
  suggestions,
  setValue
}) => {
  const theme = useTheme$1();
  const addPortBefore = useCallback(() => {
    addRoutePointBefore(index);
  }, [index, addRoutePointBefore]);
  const addPortAfter = useCallback(() => {
    addRoutePointAfter(index);
  }, [index, addRoutePointAfter]);
  const deletePort = useCallback(() => {
    deleteRoutePoint(index);
  }, [index, deleteRoutePoint]);
  const {
    setNodeRef,
    setActivatorNodeRef,
    listeners,
    isDragging,
    transform,
    transition
  } = useSortable({
    id,
    data: {
      type: "port"
    }
  });
  const {
    fields: portOperations,
    append,
    remove,
    move,
    update
  } = useFieldArray({
    control,
    name: `ports.${index}.operations`
  });
  useEffect(() => {
    if (operationIdRef?.current) {
      for (const operation of portOperations) {
        operationIdRef.current[operation.id] = {
          ...operation,
          portId: id
        };
      }
    }
  }, [portOperations]);
  useEffect(() => {
    if (moveRefs?.current) {
      moveRefs.current[id] = move;
    }
  }, [move, id]);
  return /* @__PURE__ */ jsx(
    PortWidgetLayout,
    {
      isDragging,
      index,
      control,
      portOptions,
      commodities,
      termsOptions,
      portOperations,
      errorMessage,
      suggestions,
      deletePort,
      addOperation: (operation) => append(operation),
      removeOperation: (i) => remove(i),
      updateOperation: update,
      rootProps: {
        ref: setNodeRef,
        style: {
          transition,
          transform: CSS.Translate.toString(transform)
        }
      },
      handleProps: {
        ref: setActivatorNodeRef,
        ...listeners
      },
      addPortBeforeNode: !inOverlay && /* @__PURE__ */ jsxs(
        Box,
        {
          sx: {
            position: "absolute",
            top: "-35px",
            right: "-50px"
          },
          children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                sx: {
                  height: "1px",
                  backgroundColor: theme.palette.divider,
                  position: "absolute",
                  top: "calc(50% - 0.5px)",
                  left: "-50px",
                  width: "50px"
                }
              }
            ),
            /* @__PURE__ */ jsx(
              SquareIconButton,
              {
                variant: "outlined",
                onClick: addPortBefore,
                "aria-label": "Add port before",
                title: "Add port before",
                children: /* @__PURE__ */ jsx(Add, {})
              }
            )
          ]
        }
      ),
      addPortAfterNode: !inOverlay && isLast && /* @__PURE__ */ jsxs(
        Box,
        {
          sx: {
            position: "absolute",
            bottom: "-35px",
            right: "-50px"
          },
          children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                sx: {
                  height: "1px",
                  backgroundColor: theme.palette.divider,
                  position: "absolute",
                  top: "calc(50% - 0.5px)",
                  left: "-50px",
                  width: "50px"
                }
              }
            ),
            /* @__PURE__ */ jsx(
              SquareIconButton,
              {
                variant: "outlined",
                onClick: addPortAfter,
                "aria-label": "Add port after",
                title: "Add port after",
                children: /* @__PURE__ */ jsx(Add, {})
              }
            )
          ]
        }
      ),
      setValue
    }
  );
};
var PortWidget = React52__default.memo(PortWidgetComponent);
function useDebouncedValidation({
  onChange,
  state,
  trigger
}) {
  const isMounted = useRef(false);
  useEffect(() => {
    onChange?.(state);
    const timeout2 = setTimeout(() => {
      if (isMounted.current) {
        trigger();
      } else {
        isMounted.current = true;
      }
    }, 500);
    return () => clearTimeout(timeout2);
  }, [state, trigger, onChange]);
}
function useMultiModeSuggestions(state, setSuggestions, suggestionDefaults, extraFields2 = null) {
  useEffect(() => {
    const ports = state.ports ?? [];
    const suggestions = /* @__PURE__ */ new Map();
    const cargoQuantities = /* @__PURE__ */ new Map();
    const extraFieldDefaults = /* @__PURE__ */ new Map();
    ports.forEach((port, i) => {
      const operations = port.operations ?? [];
      for (const operation of operations) {
        if (!operation.commodity || !operation.amount) {
          continue;
        }
        const target = cargoQuantities.get(operation.commodity) ?? 0;
        if (operation.operation === OperationType.L) {
          cargoQuantities.set(operation.commodity, target + operation.amount);
        } else if (operation.operation === OperationType.D) {
          cargoQuantities.set(operation.commodity, target - operation.amount);
        }
        extraFieldDefaults.set(operation.commodity, /* @__PURE__ */ new Map());
        for (const extraField of extraFields2 ?? []) {
          if (operation[extraField]) {
            const fieldMap = extraFieldDefaults.get(operation.commodity) ?? /* @__PURE__ */ new Map();
            fieldMap.set(extraField, operation[extraField]);
            extraFieldDefaults.set(operation.commodity, fieldMap);
          }
        }
      }
      const suggestionsForPort = [];
      const previousPorts = ports.slice(0, i);
      const futurePorts = ports.slice(i + 1);
      operations.forEach((operation) => {
        if (operation.operation === OperationType.L) {
          const commodity = operation.commodity;
          const amount = operation.amount;
          if (!commodity || !amount) {
            return;
          }
          const futureDischarges = futurePorts.map(
            (p) => (p.operations ?? []).find(
              (o) => o.operation === OperationType.D && o.commodity === commodity && o?.amount
            )
          ).filter((o) => o);
          if (futureDischarges.length === 0) {
            futurePorts.forEach((futurePort, j) => {
              if (!suggestionsForPort.some((s) => s.operation === OperationType.D)) {
                suggestionsForPort.push({
                  port: j + i + 1,
                  operation: OperationType.D,
                  commodity,
                  amount,
                  terms: void 0,
                  cadence: void 0,
                  useVesselGear: void 0,
                  draft: void 0,
                  tolerance: void 0,
                  commodityPrice: void 0,
                  userCfrPrice: void 0,
                  stowageFactor: void 0,
                  ...Object.fromEntries(
                    (extraFields2 ?? []).map((f) => [f, operation[f]])
                  )
                });
              }
            });
          }
        } else if (operation.operation === OperationType.D) {
          const commodity = operation.commodity;
          const amount = operation.amount;
          if (!commodity || !amount) {
            return;
          }
          const previousLoads = previousPorts.map(
            (p) => (p.operations ?? []).find(
              (o) => o.operation === OperationType.L && o.commodity === commodity && o?.amount
            )
          ).filter((o) => o);
          if (previousLoads.length === 0) {
            previousPorts.forEach((previousPort, j) => {
              if (!suggestionsForPort.some(
                (s) => s.port === j && s.operation === OperationType.L
              )) {
                suggestionsForPort.push({
                  port: j,
                  operation: OperationType.L,
                  commodity,
                  amount,
                  terms: void 0,
                  cadence: void 0,
                  useVesselGear: void 0,
                  draft: void 0,
                  tolerance: void 0,
                  commodityPrice: void 0,
                  userCfrPrice: void 0,
                  stowageFactor: void 0,
                  ...Object.fromEntries(
                    (extraFields2 ?? []).map((f) => [f, operation[f]])
                  )
                });
              }
            });
          }
        }
      });
      for (const suggestion of suggestionsForPort) {
        const target = suggestions.get(suggestion.port) ?? [];
        target.push({
          ...suggestionDefaults,
          operation: suggestion.operation,
          commodity: suggestion.commodity,
          amount: suggestion.amount,
          terms: void 0,
          cadence: void 0,
          ...Object.fromEntries(
            (extraFields2 ?? []).map((f) => [
              f,
              suggestion[f]
            ])
          )
        });
        suggestions.set(suggestion.port, target);
      }
    });
    const lastPort = ports.length - 1;
    if (lastPort > 0) {
      cargoQuantities.forEach((amount, commodity) => {
        if (amount > 0) {
          const target = suggestions.get(lastPort) ?? [];
          if (target.findIndex((o) => {
            return o.commodity === commodity && o.operation === OperationType.D && o.amount === amount;
          }) === -1) {
            target.push({
              ...suggestionDefaults,
              operation: OperationType.D,
              commodity,
              amount,
              terms: void 0,
              cadence: void 0,
              ...Object.fromEntries(
                (extraFields2 ?? []).map((f) => [
                  f,
                  extraFieldDefaults?.get(commodity)?.get(f)
                ])
              )
            });
            suggestions.set(lastPort, target);
          }
        }
      });
    }
    setSuggestions(suggestions);
  }, [state.ports, setSuggestions, extraFields2]);
}
var MultiModeHooks = ({
  control,
  setSuggestions,
  trigger,
  onChange,
  extraFields: extraFields2
}) => {
  const state = useWatch({
    control
  });
  useDebouncedValidation({
    onChange,
    state,
    trigger
  });
  useMultiModeSuggestions(
    state,
    setSuggestions,
    {
      operation: OperationType.L,
      amount: 0,
      commodity: "",
      cadence: "",
      terms: "",
      useVesselGear: void 0,
      draft: void 0,
      stowageFactor: void 0
    },
    extraFields2
  );
  return null;
};
var directions2 = [
  KeyboardCode.Down,
  KeyboardCode.Right,
  KeyboardCode.Up,
  KeyboardCode.Left
];
var coordinateGetter = (event, { context: { active, droppableRects, droppableContainers, collisionRect } }) => {
  if (directions2.includes(event.code)) {
    event.preventDefault();
    if (!active || !collisionRect) {
      return;
    }
    const curType = active.data.current?.type;
    const filteredContainers = [];
    droppableContainers.getEnabled().forEach((entry) => {
      if (!entry || entry?.disabled) {
        return;
      }
      const rect = droppableRects.get(entry.id);
      if (!rect) {
        return;
      }
      const data2 = entry.data.current;
      if (data2) {
        const { type, children } = data2;
        if (type !== curType) {
          return;
        }
      }
      switch (event.code) {
        case KeyboardCode.Down:
          if (collisionRect.top < rect.top) {
            filteredContainers.push(entry);
          }
          break;
        case KeyboardCode.Up:
          if (collisionRect.top > rect.top) {
            filteredContainers.push(entry);
          }
          break;
        case KeyboardCode.Left:
          if (collisionRect.left >= rect.left + rect.width) {
            filteredContainers.push(entry);
          }
          break;
        case KeyboardCode.Right:
          if (collisionRect.left + collisionRect.width <= rect.left) {
            filteredContainers.push(entry);
          }
          break;
      }
    });
    const collisions = closestCorners({
      active,
      collisionRect,
      droppableRects,
      droppableContainers: filteredContainers,
      pointerCoordinates: null
    });
    const closestId = getFirstCollision(collisions, "id");
    if (closestId != null) {
      const newDroppable = droppableContainers.get(closestId);
      const newNode = newDroppable?.node.current;
      const newRect = newDroppable?.rect.current;
      if (newNode && newRect) {
        return {
          x: newRect.left,
          y: newRect.top
        };
      }
    }
  }
  return void 0;
};
var extraFields = [
  "tolerance",
  "commodityPrice",
  "userCfrPrice"
];
var CalcMultiModeWidget = ({
  commodities,
  portOptions,
  termsOptions,
  control,
  errors,
  trigger,
  setValue,
  onChange,
  watch
}) => {
  const ctx = useContext(CalcContext);
  const isCFROptimizer = ctx?.isCFROptimizer;
  const [suggestions, setSuggestions] = useState(/* @__PURE__ */ new Map());
  const { fields, append, remove, insert, move } = useFieldArray({
    control,
    name: "ports"
  });
  const addBefore = useCallback(
    (index) => {
      insert(index, clonePortInput(multiModeDefaultValues, index === 0));
    },
    [insert]
  );
  const addAfter = useCallback(
    (index) => {
      insert(index + 1, clonePortInput(multiModeDefaultValues, index === 0));
    },
    [insert]
  );
  const deleteRoutePoint = useCallback(
    (index) => {
      remove(index);
    },
    [remove]
  );
  const fieldCount = fields.length;
  const addToEnd = useCallback(() => {
    append(clonePortInput(multiModeDefaultValues, fieldCount === 0));
  }, [append, fieldCount]);
  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter
    })
  );
  const [draggedId, setDraggedId] = useState(null);
  const lastOverId = useRef(null);
  const recentlyMovedToNewContainer = useRef(false);
  const collisionDetectionStrategy = useCallback(
    (args) => {
      if (draggedId && fields.find((field) => field.id === draggedId)) {
        return closestCenter({
          ...args,
          droppableContainers: args.droppableContainers.filter(
            (container) => fields.find((field) => field.id === container.id)
          )
        });
      }
      const pointerIntersections = pointerWithin(args);
      const intersections = pointerIntersections.length > 0 ? (
        // If there are droppables intersecting with the pointer, return those
        pointerIntersections
      ) : rectIntersection(args);
      let overId = getFirstCollision(intersections, "id");
      if (overId != null) {
        const overItem = fields.find((field) => field.id === overId);
        if (overItem) {
          const children = overItem.operations;
          if (children.length > 0) {
            overId = closestCenter({
              ...args,
              droppableContainers: args.droppableContainers.filter(
                (container) => container.id !== overId && children.find(
                  (x) => x.id === container.id
                )
              )
            })[0]?.id;
          }
        }
        lastOverId.current = overId;
        return [{ id: overId }];
      }
      if (recentlyMovedToNewContainer.current) {
        lastOverId.current = draggedId;
      }
      return lastOverId.current ? [
        {
          id: Array.isArray(lastOverId.current) ? lastOverId.current[2] : lastOverId.current
        }
      ] : [];
    },
    [draggedId, fields]
  );
  useEffect(() => {
    requestAnimationFrame(() => {
      recentlyMovedToNewContainer.current = false;
    });
  }, [fields]);
  let draggedItemType = null;
  let draggedItem = null;
  let draggedPortIndex = null;
  let draggedItemIndex = null;
  if (draggedId) {
    if (Array.isArray(draggedId)) {
      draggedItemType = "operation";
      draggedPortIndex = draggedId[0];
      draggedItem = {
        ...fields[draggedPortIndex].operations[draggedId[1]],
        id: `${draggedId[2]}`
      };
      draggedItemIndex = draggedId[1];
    } else {
      draggedItemType = "port";
      draggedPortIndex = fields.findIndex((field) => field.id === draggedId);
      draggedItem = draggedPortIndex !== -1 ? fields[draggedPortIndex] : null;
      draggedPortIndex = draggedPortIndex !== -1 ? draggedPortIndex : null;
    }
  }
  const operationIdRef = useRef({});
  const findPort = (id) => {
    if (fields.find((field) => field.id === id)) {
      return id;
    }
    if (operationIdRef.current) {
      for (const [operationId, operation] of Object.entries(
        operationIdRef.current
      )) {
        if (operationId === id) {
          return operation.portId;
        }
      }
    }
    return null;
  };
  const portOperationMoveRefs = useRef({});
  const onFormChange = useCallback(
    (data2) => {
      if (onChange) {
        onChange(data2);
      }
      if (isCFROptimizer) {
        const toleranceMap = /* @__PURE__ */ new Map();
        const commodityPriceMap = /* @__PURE__ */ new Map();
        const shouldUpdate = (current, newVal) => {
          return current !== newVal && (current === void 0 || current === DEFAULT_OVERRIDE_VAL);
        };
        for (const [i, port] of (data2.ports ?? []).entries()) {
          for (const [j, operation] of (port.operations ?? []).entries()) {
            if (!operation.commodity) {
              continue;
            }
            if (operation.operation === OperationType.D) {
              const tolerance = toleranceMap.get(operation.commodity);
              const commodityPrice = commodityPriceMap.get(operation.commodity);
              if (tolerance !== void 0) {
                const current = operation.tolerance;
                if (shouldUpdate(current, tolerance)) {
                  setValue(`ports.${i}.operations.${j}.tolerance`, tolerance);
                }
              }
              if (commodityPrice !== void 0) {
                const current = operation.commodityPrice;
                if (shouldUpdate(current, commodityPrice)) {
                  setValue(
                    `ports.${i}.operations.${j}.commodityPrice`,
                    commodityPrice
                  );
                }
              }
            }
            if (operation.operation === OperationType.L) {
              if (operation.tolerance !== void 0) {
                toleranceMap.set(operation.commodity, operation.tolerance);
              }
              if (operation.commodityPrice !== void 0) {
                commodityPriceMap.set(
                  operation.commodity,
                  operation.commodityPrice
                );
              }
            }
          }
        }
      }
    },
    [onChange, isCFROptimizer]
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      width: "100%",
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: "30px",
        paddingBottom: "40px"
      },
      children: [
        /* @__PURE__ */ jsx(
          MultiModeHooks,
          {
            control,
            setSuggestions,
            trigger,
            onChange: onFormChange,
            extraFields
          }
        ),
        /* @__PURE__ */ jsx(OverridesForm, { control, setValue, level: "global" }),
        /* @__PURE__ */ jsxs(
          DndContext,
          {
            sensors,
            collisionDetection: collisionDetectionStrategy,
            measuring: {
              droppable: {
                strategy: MeasuringStrategy.Always
              }
            },
            onDragStart: ({ active }) => {
              let activeId = active.id;
              if (active?.data?.current?.origIndex !== void 0) {
                activeId = [
                  active?.data?.current?.portIndex,
                  active?.data?.current?.origIndex,
                  active.id
                ];
              }
              setDraggedId(activeId);
            },
            onDragCancel: () => {
              setDraggedId(null);
            },
            onDragEnd: ({ active, over }) => {
              setDraggedId(null);
              const activeIndex = fields.findIndex(
                (field) => field.id === active.id
              );
              const isPortMoving = activeIndex !== -1;
              if (over?.id) {
                const targetIndex = fields.findIndex(
                  (field) => field.id === over.id
                );
                if (isPortMoving && targetIndex !== -1) {
                  move(activeIndex, targetIndex);
                  return;
                } else if (!isPortMoving) {
                  const activePortIndex = active?.data?.current?.portIndex;
                  const activeOperationIndex = active?.data?.current?.origIndex;
                  const overPortIndex = over?.data?.current?.portIndex;
                  const overOperationIndex = over?.data?.current?.origIndex;
                  const activePortId = findPort(active.id);
                  if (typeof activePortIndex === "undefined" || typeof overPortIndex === "undefined" || typeof activeOperationIndex === "undefined" || typeof overOperationIndex === "undefined" || activePortId === null) {
                    return;
                  }
                  portOperationMoveRefs?.current?.[activePortId]?.(
                    activeOperationIndex,
                    overOperationIndex
                  );
                }
              }
            },
            children: [
              /* @__PURE__ */ jsx(SortableContext, { items: fields, strategy: verticalListSortingStrategy, children: fields.map((item, index) => /* @__PURE__ */ jsx(
                PortWidget,
                {
                  id: item.id,
                  index,
                  portOptions,
                  commodities,
                  isLast: index === fields.length - 1,
                  addRoutePointBefore: addBefore,
                  addRoutePointAfter: addAfter,
                  deleteRoutePoint,
                  control,
                  errorMessage: errors.ports?.[index]?.operations?.message ?? errors.ports?.[index]?.operations?.root?.message,
                  suggestions: suggestions.get(index) ?? [],
                  operationIdRef,
                  moveRefs: portOperationMoveRefs,
                  setValue,
                  termsOptions
                },
                item.id
              )) }),
              /* @__PURE__ */ jsxs(DragOverlay, { dropAnimation, children: [
                draggedItemType === "port" && draggedItem && draggedPortIndex ? /* @__PURE__ */ jsx(
                  PortWidget,
                  {
                    inOverlay: true,
                    id: draggedItem.id,
                    index: draggedPortIndex,
                    portOptions,
                    commodities,
                    isLast: false,
                    addRoutePointBefore: addBefore,
                    addRoutePointAfter: addAfter,
                    deleteRoutePoint,
                    control,
                    errorMessage: errors.ports?.[draggedPortIndex]?.operations?.message ?? errors.ports?.[draggedPortIndex]?.operations?.root?.message,
                    suggestions: suggestions.get(draggedPortIndex) ?? emptyArr2,
                    setValue: noop4,
                    termsOptions
                  },
                  draggedItem.id
                ) : null,
                draggedItemType === "operation" && draggedItem && draggedPortIndex !== null && draggedItemIndex !== null ? /* @__PURE__ */ jsx(
                  OperationRowWidget,
                  {
                    id: draggedItem.id,
                    portIndex: draggedPortIndex,
                    commodities,
                    control,
                    index: draggedItemIndex,
                    remove: noop4,
                    setValue: noop4,
                    termsOptions,
                    isCFROptimizer
                  },
                  draggedItem.id
                ) : null
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              justifyContent: "center",
              display: errors.ports?.root?.message ? "flex" : "none"
            },
            children: /* @__PURE__ */ jsx(Alert, { severity: "error", children: errors.ports?.root?.message })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ jsx(Button, { variant: "outlined", startIcon: /* @__PURE__ */ jsx(Add, {}), onClick: addToEnd, children: "Add new port" })
          }
        )
      ]
    }
  );
};
var dropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "0.5"
      }
    }
  })
};
var noop4 = () => {
};
var emptyArr2 = [];
var PortOperationInputSchema = yup.object().shape({
  operation: yup.string().oneOf([OperationType.L, OperationType.D]).required(),
  amount: yup.number().required().min(1),
  commodity: yup.string().required(),
  cadence: yup.number().min(DEFAULT_OVERRIDE_VAL),
  terms: yup.string(),
  useVesselGear: yup.boolean(),
  tolerance: yup.number().min(0).max(100),
  commodityPrice: yup.number().min(0),
  userCfrPrice: yup.number().min(0),
  stowageFactor: yup.number().min(DEFAULT_OVERRIDE_VAL).test(
    "stowageFactorMin",
    "Stowage factor must be greater than 0",
    (value) => {
      if (value === void 0 || value === DEFAULT_OVERRIDE_VAL) {
        return true;
      }
      return value > 0;
    }
  )
});
var PortInputSchema = yup.object().shape({
  port: yup.string().required(),
  portDA: yup.number().min(DEFAULT_OVERRIDE_VAL),
  draft: yup.number().min(DEFAULT_OVERRIDE_VAL),
  operations: yup.array(PortOperationInputSchema).min(1, "At least one operation is required").test(
    "uniqueCommodities",
    "Commodities must be unique per port",
    (value) => {
      if (!value) {
        return true;
      }
      const curValues = value.filter((x) => x?.commodity && x?.operation).map((x) => `${x?.commodity}-${x?.operation}`);
      return curValues.length === new Set(curValues).size;
    }
  )
});
var MultiModeInputSchema = yup.object().shape({
  ports: yup.array(PortInputSchema).min(2, "At least two ports are required"),
  useCache: yup.bool().default(true),
  optimizerMode: yup.string().oneOf(["optimize", "fixed"]),
  // not required
  optimizeBase: yup.string().oneOf(["cheapest", "profitLoss"]),
  // not required
  // Note: If its DEFAULT_OVERRIDE_VAL then we submit it as undefined to the
  //  backend (DEFAULT_OVERRIDE_VAL is -1 internally but the ui shows an empty field instead)
  hireOverride: yup.number().min(DEFAULT_OVERRIDE_VAL),
  mgoOverride: yup.number().min(DEFAULT_OVERRIDE_VAL),
  sfoOverride: yup.number().min(DEFAULT_OVERRIDE_VAL),
  ballastBonusOverride: yup.number().min(DEFAULT_OVERRIDE_VAL).max(100)
}).test("ensureValidPlan", (value, { createError }) => {
  const cargoTracker = /* @__PURE__ */ new Map();
  for (const [index, port] of value.ports.entries()) {
    for (const operation of port.operations ?? []) {
      const key = operation.commodity;
      if (!key) {
        continue;
      }
      if (operation.operation === OperationType.L) {
        let target = cargoTracker.get(key) ?? 0;
        target += operation.amount ?? 0;
        cargoTracker.set(key, target);
      } else {
        let target = cargoTracker.get(key) ?? 0;
        target -= operation.amount ?? 0;
        cargoTracker.set(key, target);
        if (target < 0) {
          return createError({
            message: `Unloading more cargo than available in vessel.`,
            path: `ports.${index}.operations`
          });
        }
        cargoTracker.set(key, target);
      }
    }
  }
  return true;
});
var OptimizerInputSchema = MultiModeInputSchema.test(
  "ensureFOBPrice",
  (value, { createError }) => {
    if (value.optimizeBase !== "profitLoss") {
      return true;
    }
    for (const [index, port] of value.ports.entries()) {
      for (const operation of port.operations ?? []) {
        if (!operation.commodityPrice) {
          return new yup.ValidationError([
            createError({
              message: `FOB price is required in profit/loss mode.`,
              path: `ports.${index}.operations.root`
            }),
            createError({
              message: `FOB price is required in profit/loss mode.`,
              path: `ports.${index}.operations.${index}.commodityPrice`
            })
          ]);
        }
      }
    }
    return true;
  }
);
var voyageFields = [
  "hireOverride",
  "sfoOverride",
  "mgoOverride",
  "ballastBonusOverride",
  "stowageFactorOverride"
];
var loadFields = [
  "loadPortDA",
  "loadPortDraft",
  "loadPortUseVesselGear"
];
var dischFields = [
  "dischPortDA",
  "dischPortDraft",
  "dischPortUseVesselGear"
];
var AdvancedModePortOverrides = ({
  type,
  control,
  setValue,
  targetNode
}) => {
  let fields;
  const ctx = useContext(CalcContext);
  if (type === "voyage") {
    fields = voyageFields.filter((x) => {
      if (x === "ballastBonusOverride") {
        if (ctx?.disableBallastBonus) {
          return false;
        }
      }
      return true;
    });
  } else if (type === "load") {
    fields = loadFields;
  } else {
    fields = dischFields;
  }
  const values3 = useWatch({
    control,
    name: fields
  });
  if (!ctx) {
    throw new Error("CalcContext is not provided");
  }
  const hasAnyExtraOverrides = useMemo(
    () => values3.some((x) => x === void 0),
    [values3]
  );
  useEffect(() => {
    if (targetNode) {
      targetNode.style.width = values3.some((x) => x !== void 0) ? "100%" : "0";
    }
  }, [values3, targetNode]);
  const removeItem = useCallback(
    (field) => {
      setValue(field, void 0);
    },
    [setValue]
  );
  const body = /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        width: targetNode ? "100%" : "calc(100% - 100px)"
      },
      children: /* @__PURE__ */ jsx(
        Box,
        {
          sx: {
            display: "flex",
            flexWrap: "wrap",
            gap: "16px"
          },
          children: fields.filter((_, i) => values3[i] !== void 0).map((fieldName) => /* @__PURE__ */ jsx(
            OverrideField,
            {
              label: getFieldLabel(fieldName),
              removeItem,
              field: fieldName,
              control,
              termsOptions: emptyArr3,
              AutoCompleteField: StyledSmallAutocomplete
            },
            fieldName
          ))
        }
      )
    }
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      OverrideSelector,
      {
        hasAnyExtraOverrides,
        setValue,
        isMobileView: ctx.isMobileView,
        fields: fields.filter((_, i) => values3[i] === void 0)
      }
    ),
    targetNode ? createPortal(body, targetNode) : body
  ] });
};
var emptyArr3 = [];

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/AutoNumericEnum.js
var AutoNumericEnum = {};
AutoNumericEnum.allowedTagList = [
  "b",
  "caption",
  "cite",
  "code",
  "const",
  "dd",
  "del",
  "div",
  "dfn",
  "dt",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "input",
  "ins",
  "kdb",
  "label",
  "li",
  "option",
  "output",
  "p",
  "q",
  "s",
  "sample",
  "span",
  "strong",
  "td",
  "th",
  "u"
];
Object.freeze(AutoNumericEnum.allowedTagList);
Object.defineProperty(AutoNumericEnum, "allowedTagList", { configurable: false, writable: false });
AutoNumericEnum.fromCharCodeKeyCode = {
  0: "LaunchCalculator",
  8: "Backspace",
  9: "Tab",
  13: "Enter",
  16: "Shift",
  17: "Ctrl",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  48: "0",
  49: "1",
  50: "2",
  51: "3",
  52: "4",
  53: "5",
  54: "6",
  55: "7",
  56: "8",
  57: "9",
  // 65: 'a',
  // 66: 'b',
  // 67: 'c',
  // 68: 'd',
  // 69: 'e',
  // 70: 'f',
  // 71: 'g',
  // 72: 'h',
  // 73: 'i',
  // 74: 'j',
  // 75: 'k',
  // 76: 'l',
  // 77: 'm',
  // 78: 'n',
  // 79: 'o',
  // 80: 'p',
  // 81: 'q',
  // 82: 'r',
  // 83: 's',
  // 84: 't',
  // 85: 'u',
  // 86: 'v',
  // 87: 'w',
  // 88: 'x',
  // 89: 'y',
  // 90: 'z',
  91: "OS",
  // Note: Firefox and Chrome reports 'OS' instead of 'OSLeft'
  92: "OSRight",
  93: "ContextMenu",
  96: "0",
  97: "1",
  98: "2",
  99: "3",
  100: "4",
  101: "5",
  102: "6",
  103: "7",
  104: "8",
  105: "9",
  106: "*",
  107: "+",
  109: "-",
  // The 'NumpadSubtract' code
  110: ".",
  111: "/",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  173: "-",
  // The 'Minus' sign on Firefox. This is only needed when using the Selenium bot though.
  182: "MyComputer",
  183: "MyCalculator",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  // The 'Minus' sign on all other browsers
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'",
  224: "Meta",
  225: "AltGraph"
};
Object.freeze(AutoNumericEnum.fromCharCodeKeyCode);
Object.defineProperty(AutoNumericEnum, "fromCharCodeKeyCode", { configurable: false, writable: false });
AutoNumericEnum.keyName = {
  // Special values
  Unidentified: "Unidentified",
  AndroidDefault: "AndroidDefault",
  // Modifier keys
  Alt: "Alt",
  AltGr: "AltGraph",
  CapsLock: "CapsLock",
  // Under Chrome, e.key is empty for CapsLock
  Ctrl: "Control",
  Fn: "Fn",
  FnLock: "FnLock",
  Hyper: "Hyper",
  // 'OS' under Firefox
  Meta: "Meta",
  OSLeft: "OS",
  OSRight: "OS",
  Command: "OS",
  NumLock: "NumLock",
  ScrollLock: "ScrollLock",
  Shift: "Shift",
  Super: "Super",
  // 'OS' under Firefox
  Symbol: "Symbol",
  SymbolLock: "SymbolLock",
  // Whitespace keys
  Enter: "Enter",
  Tab: "Tab",
  Space: " ",
  // 'Spacebar' for Firefox <37, and IE9
  // Navigation keys
  LeftArrow: "ArrowLeft",
  // 'Left' for Firefox <=36, and IE9
  UpArrow: "ArrowUp",
  // 'Up' for Firefox <=36, and IE9
  RightArrow: "ArrowRight",
  // 'Right' for Firefox <=36, and IE9
  DownArrow: "ArrowDown",
  // 'Down' for Firefox <=36, and IE9
  End: "End",
  Home: "Home",
  PageUp: "PageUp",
  PageDown: "PageDown",
  // Editing keys
  Backspace: "Backspace",
  Clear: "Clear",
  Copy: "Copy",
  CrSel: "CrSel",
  // 'Crsel' for Firefox <=36, and IE9
  Cut: "Cut",
  Delete: "Delete",
  // 'Del' for Firefox <=36, and IE9
  EraseEof: "EraseEof",
  ExSel: "ExSel",
  // 'Exsel' for Firefox <=36, and IE9
  Insert: "Insert",
  Paste: "Paste",
  Redo: "Redo",
  Undo: "Undo",
  // UI keys
  Accept: "Accept",
  Again: "Again",
  Attn: "Attn",
  // 'Unidentified' for Firefox, Chrome, and IE9 ('KanaMode' when using the Japanese keyboard layout)
  Cancel: "Cancel",
  ContextMenu: "ContextMenu",
  // 'Apps' for Firefox <=36, and IE9
  Esc: "Escape",
  // 'Esc' for Firefox <=36, and IE9
  Execute: "Execute",
  Find: "Find",
  Finish: "Finish",
  // 'Unidentified' for Firefox, Chrome, and IE9 ('Katakana' when using the Japanese keyboard layout)
  Help: "Help",
  Pause: "Pause",
  Play: "Play",
  Props: "Props",
  Select: "Select",
  ZoomIn: "ZoomIn",
  ZoomOut: "ZoomOut",
  // Device keys
  BrightnessDown: "BrightnessDown",
  BrightnessUp: "BrightnessUp",
  Eject: "Eject",
  LogOff: "LogOff",
  Power: "Power",
  PowerOff: "PowerOff",
  PrintScreen: "PrintScreen",
  Hibernate: "Hibernate",
  // 'Unidentified' for Firefox <=37
  Standby: "Standby",
  // 'Unidentified' for Firefox <=36, and IE9
  WakeUp: "WakeUp",
  // IME and composition keys
  Compose: "Compose",
  Dead: "Dead",
  // Function keys
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  F9: "F9",
  F10: "F10",
  F11: "F11",
  F12: "F12",
  // Document keys
  Print: "Print",
  // 'Normal' keys
  num0: "0",
  num1: "1",
  num2: "2",
  num3: "3",
  num4: "4",
  num5: "5",
  num6: "6",
  num7: "7",
  num8: "8",
  num9: "9",
  a: "a",
  b: "b",
  c: "c",
  d: "d",
  e: "e",
  f: "f",
  g: "g",
  h: "h",
  i: "i",
  j: "j",
  k: "k",
  l: "l",
  m: "m",
  n: "n",
  o: "o",
  p: "p",
  q: "q",
  r: "r",
  s: "s",
  t: "t",
  u: "u",
  v: "v",
  w: "w",
  x: "x",
  y: "y",
  z: "z",
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  I: "I",
  J: "J",
  K: "K",
  L: "L",
  M: "M",
  N: "N",
  O: "O",
  P: "P",
  Q: "Q",
  R: "R",
  S: "S",
  T: "T",
  U: "U",
  V: "V",
  W: "W",
  X: "X",
  Y: "Y",
  Z: "Z",
  Semicolon: ";",
  Equal: "=",
  Comma: ",",
  Hyphen: "-",
  Minus: "-",
  Plus: "+",
  Dot: ".",
  Slash: "/",
  Backquote: "`",
  LeftParenthesis: "(",
  RightParenthesis: ")",
  LeftBracket: "[",
  RightBracket: "]",
  Backslash: "\\",
  Quote: "'",
  // Numeric keypad keys
  numpad0: "0",
  numpad1: "1",
  numpad2: "2",
  numpad3: "3",
  numpad4: "4",
  numpad5: "5",
  numpad6: "6",
  numpad7: "7",
  numpad8: "8",
  numpad9: "9",
  NumpadDot: ".",
  NumpadDotAlt: ",",
  // Modern browsers automatically adapt the character sent by this key to the decimal character of the current language
  NumpadMultiply: "*",
  NumpadPlus: "+",
  NumpadMinus: "-",
  NumpadSubtract: "-",
  NumpadSlash: "/",
  NumpadDotObsoleteBrowsers: "Decimal",
  NumpadMultiplyObsoleteBrowsers: "Multiply",
  NumpadPlusObsoleteBrowsers: "Add",
  NumpadMinusObsoleteBrowsers: "Subtract",
  NumpadSlashObsoleteBrowsers: "Divide",
  // Special arrays for quicker tests
  _allFnKeys: ["F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12"],
  _someNonPrintableKeys: ["Tab", "Enter", "Shift", "ShiftLeft", "ShiftRight", "Control", "ControlLeft", "ControlRight", "Alt", "AltLeft", "AltRight", "Pause", "CapsLock", "Escape"],
  _directionKeys: ["PageUp", "PageDown", "End", "Home", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp"]
};
Object.freeze(AutoNumericEnum.keyName._allFnKeys);
Object.freeze(AutoNumericEnum.keyName._someNonPrintableKeys);
Object.freeze(AutoNumericEnum.keyName._directionKeys);
Object.freeze(AutoNumericEnum.keyName);
Object.defineProperty(AutoNumericEnum, "keyName", { configurable: false, writable: false });
Object.freeze(AutoNumericEnum);
var AutoNumericEnum_default = AutoNumericEnum;

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/AutoNumericHelper.js
var AutoNumericHelper = class _AutoNumericHelper {
  /**
   * Return `true` if the `value` is null
   *
   * @static
   * @param {*} value The value to test
   * @returns {boolean} Return `true` if the `value` is null, FALSE otherwise
   */
  static isNull(value) {
    return value === null;
  }
  /**
   * Return `true` if the `value` is undefined
   *
   * @static
   * @param {*} value The value to test
   * @returns {boolean} Return `true` if the `value` is undefined, FALSE otherwise
   */
  static isUndefined(value) {
    return value === void 0;
  }
  /**
   * Return `true` if the `value` is undefined, null or empty
   *
   * @param {*} value
   * @returns {boolean}
   */
  static isUndefinedOrNullOrEmpty(value) {
    return value === null || value === void 0 || "" === value;
  }
  /**
   * Return `true` if the given parameter is a String
   *
   * @param {*} str
   * @returns {boolean}
   */
  static isString(str) {
    return typeof str === "string" || str instanceof String;
  }
  /**
   * Return `true` if the `value` is an empty string ''
   *
   * @static
   * @param {*} value The value to test
   * @returns {boolean} Return `true` if the `value` is an empty string '', FALSE otherwise
   */
  static isEmptyString(value) {
    return value === "";
  }
  /**
   * Return `true` if the parameter is a boolean
   *
   * @static
   * @param {*} value
   * @returns {boolean}
   */
  static isBoolean(value) {
    return typeof value === "boolean";
  }
  /**
   * Return `true` if the parameter is a string 'true' or 'false'
   *
   * This function accepts any cases for those strings.
   * @param {string} value
   * @returns {boolean}
   */
  static isTrueOrFalseString(value) {
    const lowercaseValue = String(value).toLowerCase();
    return lowercaseValue === "true" || lowercaseValue === "false";
  }
  /**
   * Return `true` if the parameter is an object
   *
   * @param {*} reference
   * @returns {boolean}
   */
  static isObject(reference) {
    return typeof reference === "object" && reference !== null && !Array.isArray(reference);
  }
  /**
   * Return `true` if the given object is empty
   * cf. http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object and http://jsperf.com/empty-object-test
   *
   * @param {object} obj
   * @returns {boolean}
   */
  static isEmptyObj(obj) {
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  }
  /**
   * Return `true` if the parameter is a real number (and not a numeric string).
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isNumberStrict(n) {
    return typeof n === "number";
  }
  /**
   * Return `true` if the parameter is a number (or a number written as a string).
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isNumber(n) {
    return !this.isArray(n) && !isNaN(parseFloat(n)) && isFinite(n);
  }
  /**
   * Return `true` if the given character is a number (0 to 9)
   *
   * @param {char} char
   * @returns {boolean}
   */
  static isDigit(char) {
    return /\d/.test(char);
  }
  /**
   * Return `true` if the parameter is a number (or a number written as a string).
   * This version also accepts Arabic and Persian numbers.
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isNumberOrArabic(n) {
    const latinConvertedNumber = this.arabicToLatinNumbers(n, false, true, true);
    return this.isNumber(latinConvertedNumber);
  }
  /**
   * Return `true` if the parameter is an integer (and not a float).
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isInt(n) {
    return typeof n === "number" && parseFloat(n) === parseInt(n, 10) && !isNaN(n);
  }
  /**
   * Return `true` if the parameter is a function.
   *
   * @param {function} func
   * @returns {boolean}
   */
  static isFunction(func) {
    return typeof func === "function";
  }
  /**
   * Return `true` is the string `str` contains the string `needle`
   * Note: this function does not coerce the parameters types
   *
   * @param {string} str
   * @param {string} needle
   * @returns {boolean}
   */
  static contains(str, needle) {
    if (!this.isString(str) || !this.isString(needle) || str === "" || needle === "") {
      return false;
    }
    return str.indexOf(needle) !== -1;
  }
  /**
   * Return `true` if the `needle` is in the array
   *
   * @param {*} needle
   * @param {Array} array
   * @returns {boolean}
   */
  static isInArray(needle, array2) {
    if (!this.isArray(array2) || array2 === [] || this.isUndefined(needle)) {
      return false;
    }
    return array2.indexOf(needle) !== -1;
  }
  /**
   * Return `true` if the parameter is an Array
   * //TODO Replace this by the default `Array.isArray()` function?
   *
   * @param {*} arr
   * @throws Error
   * @returns {*|boolean}
   */
  static isArray(arr) {
    if (Object.prototype.toString.call([]) === "[object Array]") {
      return Array.isArray(arr) || typeof arr === "object" && Object.prototype.toString.call(arr) === "[object Array]";
    } else {
      throw new Error("toString message changed for Object Array");
    }
  }
  /**
   * Return `true` if the parameter is a DOM element
   * cf. http://stackoverflow.com/a/4754104/2834898
   *
   * @param {*} obj
   * @returns {boolean}
   */
  static isElement(obj) {
    if (typeof Element === "undefined") {
      return false;
    }
    return obj instanceof Element;
  }
  /**
   * Return `true` in the given DOM element is an <input>.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @returns {boolean}
   * @private
   */
  static isInputElement(domElement) {
    return this.isElement(domElement) && domElement.tagName.toLowerCase() === "input";
  }
  /**
   * Return `true` if the parameter is a string that represents a float number, and that number has a decimal part
   *
   * @param {string} str
   * @returns {boolean}
   */
  // static hasDecimals(str) {
  //     const [, decimalPart] = str.split('.');
  //     return !isUndefined(decimalPart);
  // }
  /**
   * Return the number of decimal places if the parameter is a string that represents a float number, and that number has a decimal part.
   *
   * @param {string} str
   * @returns {int}
   */
  static decimalPlaces(str) {
    const [, decimalPart] = str.split(".");
    if (!this.isUndefined(decimalPart)) {
      return decimalPart.length;
    }
    return 0;
  }
  /**
   * Return the index of the first non-zero decimal place in the given value.
   * The index starts after the decimal point, if any, and begins at '1'.
   * If no decimal places are found in the value, this function returns `0`.
   *
   * @example
   * indexFirstNonZeroDecimalPlace('0.00') -> 0
   * indexFirstNonZeroDecimalPlace('1.00') -> 0
   * indexFirstNonZeroDecimalPlace('0.12') -> 1
   * indexFirstNonZeroDecimalPlace('0.1234') -> 1
   * indexFirstNonZeroDecimalPlace('0.01234') -> 2
   * indexFirstNonZeroDecimalPlace('0.001234') -> 3
   * indexFirstNonZeroDecimalPlace('0.0001234') -> 4
   *
   * @param {number} value
   * @returns {Number|number}
   */
  static indexFirstNonZeroDecimalPlace(value) {
    const [, decimalPart] = String(Math.abs(value)).split(".");
    if (this.isUndefined(decimalPart)) {
      return 0;
    }
    let result = decimalPart.lastIndexOf("0");
    if (result === -1) {
      result = 0;
    } else {
      result += 2;
    }
    return result;
  }
  /**
   * Return the code for the key used to generate the given event.
   *
   * @param {Event} event
   * @returns {string|Number}
   */
  static keyCodeNumber(event) {
    return typeof event.which === "undefined" ? event.keyCode : event.which;
  }
  /**
   * Return the character from the event key code.
   * If the KeyboardEvent does not represent a printable character, then the key name is used (ie. 'Meta', 'Shift', 'F1', etc.)
   * @example character(50) => '2'
   *
   * @param {KeyboardEvent} event
   * @returns {string}
   */
  static character(event) {
    let result;
    if (event.key === "Unidentified" || event.key === void 0 || this.isSeleniumBot()) {
      const keyCode = this.keyCodeNumber(event);
      if (keyCode === 229) {
        return AutoNumericEnum_default.keyName.AndroidDefault;
      }
      const potentialResult = AutoNumericEnum_default.fromCharCodeKeyCode[keyCode];
      if (!_AutoNumericHelper.isUndefinedOrNullOrEmpty(potentialResult)) {
        result = potentialResult;
      } else {
        result = String.fromCharCode(keyCode);
      }
    } else {
      switch (event.key) {
        case "Add":
          result = AutoNumericEnum_default.keyName.NumpadPlus;
          break;
        case "Apps":
          result = AutoNumericEnum_default.keyName.ContextMenu;
          break;
        case "Crsel":
          result = AutoNumericEnum_default.keyName.CrSel;
          break;
        case "Decimal":
          if (event.char) {
            result = event.char;
          } else {
            result = AutoNumericEnum_default.keyName.NumpadDot;
          }
          break;
        case "Del":
          result = AutoNumericEnum_default.keyName.Delete;
          break;
        case "Divide":
          result = AutoNumericEnum_default.keyName.NumpadSlash;
          break;
        case "Down":
          result = AutoNumericEnum_default.keyName.DownArrow;
          break;
        case "Esc":
          result = AutoNumericEnum_default.keyName.Esc;
          break;
        case "Exsel":
          result = AutoNumericEnum_default.keyName.ExSel;
          break;
        case "Left":
          result = AutoNumericEnum_default.keyName.LeftArrow;
          break;
        case "Meta":
        case "Super":
          result = AutoNumericEnum_default.keyName.OSLeft;
          break;
        case "Multiply":
          result = AutoNumericEnum_default.keyName.NumpadMultiply;
          break;
        case "Right":
          result = AutoNumericEnum_default.keyName.RightArrow;
          break;
        case "Spacebar":
          result = AutoNumericEnum_default.keyName.Space;
          break;
        case "Subtract":
          result = AutoNumericEnum_default.keyName.NumpadMinus;
          break;
        case "Up":
          result = AutoNumericEnum_default.keyName.UpArrow;
          break;
        default:
          result = event.key;
      }
    }
    return result;
  }
  /**
   * Return an object containing the name and version of the current browser.
   * @example `browserVersion()` => { name: 'Firefox', version: '42' }
   * Based on http://stackoverflow.com/a/38080051/2834898
   *
   * @returns {{ name: string, version: string }}
   */
  static browser() {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: "ie", version: tem[1] || "" };
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem !== null) {
        return { name: tem[1].replace("OPR", "opera"), version: tem[2] };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
      M.splice(1, 1, tem[1]);
    }
    return { name: M[0].toLowerCase(), version: M[1] };
  }
  /**
   * Check if the browser is controlled by Selenium.
   * Note: This only works within the geckodriver.
   * cf. http://stackoverflow.com/questions/33225947/can-a-website-detect-when-you-are-using-selenium-with-chromedriver
   *
   * @returns {boolean}
   */
  static isSeleniumBot() {
    return window.navigator.webdriver === true;
  }
  /**
   * Return `true` if the given number is negative, or if the given string contains a negative sign :
   * - everywhere in the string (by default), or
   * - on the first character only if the `checkEverywhere` parameter is set to `false`.
   *
   * Note: `-0` is not a negative number since it's equal to `0`.
   *
   * @param {number|string} numberOrNumericString A Number, or a number represented by a string
   * @param {string} negativeSignCharacter The single character that represent the negative sign
   * @param {boolean} checkEverywhere If TRUE, then the negative sign is search everywhere in the numeric string (this is needed for instance if the string is '1234.56-')
   * @returns {boolean}
   */
  static isNegative(numberOrNumericString, negativeSignCharacter = "-", checkEverywhere = true) {
    if (numberOrNumericString === negativeSignCharacter) {
      return true;
    }
    if (numberOrNumericString === "") {
      return false;
    }
    if (_AutoNumericHelper.isNumber(numberOrNumericString)) {
      return numberOrNumericString < 0;
    }
    if (checkEverywhere) {
      return this.contains(numberOrNumericString, negativeSignCharacter);
    }
    return this.isNegativeStrict(numberOrNumericString, negativeSignCharacter);
  }
  /**
   * Return `true` if the given string contains a negative sign on the first character (on the far left).
   *
   * @example isNegativeStrict('1234.56')     => false
   * @example isNegativeStrict('1234.56-')    => false
   * @example isNegativeStrict('-1234.56')    => true
   * @example isNegativeStrict('-1,234.56 €') => true
   *
   * @param {string} numericString
   * @param {string} negativeSignCharacter The single character that represent the negative sign
   * @returns {boolean}
   */
  static isNegativeStrict(numericString, negativeSignCharacter = "-") {
    return numericString.charAt(0) === negativeSignCharacter;
  }
  /**
   * Return `true` if the very first character is the opening bracket, and if the rest of the `valueString` also has the closing bracket.
   *
   * @param {string} valueString
   * @param {string} leftBracket
   * @param {string} rightBracket
   * @returns {boolean}
   */
  static isNegativeWithBrackets(valueString, leftBracket, rightBracket) {
    return valueString.charAt(0) === leftBracket && this.contains(valueString, rightBracket);
  }
  /**
   * Return `true` if the formatted or unformatted numeric string represent the value 0 (ie. '0,00 €'), or is empty (' €').
   * This works since we test if there are any numbers from 1 to 9 in the string. If there is none, then the number is zero (or the string is empty).
   *
   * @param {string} numericString
   * @returns {boolean}
   */
  static isZeroOrHasNoValue(numericString) {
    return !/[1-9]/g.test(numericString);
  }
  /**
   * Return the negative version of the value (represented as a string) given as a parameter.
   * The numeric string is a valid Javascript number when typecast to a `Number`.
   *
   * @param {string} value
   * @returns {*}
   */
  static setRawNegativeSign(value) {
    if (!this.isNegativeStrict(value, "-")) {
      return `-${value}`;
    }
    return value;
  }
  /**
   * Replace the character at the position `index` in the string `string` by the character(s) `newCharacter`.
   *
   * @param {string} string
   * @param {int} index
   * @param {string} newCharacter
   * @returns {string}
   */
  static replaceCharAt(string2, index, newCharacter) {
    return `${string2.substr(0, index)}${newCharacter}${string2.substr(index + newCharacter.length)}`;
  }
  /**
   * Return the value clamped to the nearest minimum/maximum value, as defined in the settings.
   *
   * @param {string|number} value
   * @param {object} settings
   * @returns {number}
   */
  static clampToRangeLimits(value, settings) {
    return Math.max(settings.minimumValue, Math.min(settings.maximumValue, value));
  }
  /**
   * Return the number of number or dot characters on the left side of the caret, in a formatted number.
   *
   * @param {string} formattedNumberString
   * @param {int} caretPosition This must be a positive integer
   * @param {string} decimalCharacter
   * @returns {number}
   */
  static countNumberCharactersOnTheCaretLeftSide(formattedNumberString, caretPosition, decimalCharacter) {
    const numberDotOrNegativeSign = new RegExp(`[0-9${decimalCharacter}-]`);
    let numberDotAndNegativeSignCount = 0;
    for (let i = 0; i < caretPosition; i++) {
      if (numberDotOrNegativeSign.test(formattedNumberString[i])) {
        numberDotAndNegativeSignCount++;
      }
    }
    return numberDotAndNegativeSignCount;
  }
  /**
   * Walk the `formattedNumberString` from left to right, one char by one, counting the `formattedNumberStringIndex`.
   * If the char is in the `rawNumberString` (starting at index 0), then `rawNumberStringIndex++`, and continue until
   * there is no more characters in `rawNumberString`) or that `rawNumberStringIndex === caretPositionInRawValue`.
   * When you stop, the `formattedNumberStringIndex` is the position where the caret should be set.
   *
   * @example
   * 1234567|89.01   : position 7 (rawNumberString)
   * 123.456.7|89,01 : position 9 (formattedNumberString)
   *
   * @param {string} rawNumberString
   * @param {int} caretPositionInRawValue
   * @param {string} formattedNumberString
   * @param {string} decimalCharacter
   * @returns {*}
   */
  static findCaretPositionInFormattedNumber(rawNumberString, caretPositionInRawValue, formattedNumberString, decimalCharacter) {
    const formattedNumberStringSize = formattedNumberString.length;
    const rawNumberStringSize = rawNumberString.length;
    let formattedNumberStringIndex;
    let rawNumberStringIndex = 0;
    for (formattedNumberStringIndex = 0; formattedNumberStringIndex < formattedNumberStringSize && rawNumberStringIndex < rawNumberStringSize && rawNumberStringIndex < caretPositionInRawValue; formattedNumberStringIndex++) {
      if (rawNumberString[rawNumberStringIndex] === formattedNumberString[formattedNumberStringIndex] || rawNumberString[rawNumberStringIndex] === "." && formattedNumberString[formattedNumberStringIndex] === decimalCharacter) {
        rawNumberStringIndex++;
      }
    }
    return formattedNumberStringIndex;
  }
  /**
   * Count the number of occurrence of the given character, in the given text.
   *
   * @param {string} character
   * @param {string} text
   * @returns {number}
   */
  static countCharInText(character, text) {
    let charCounter = 0;
    for (let i = 0; i < text.length; i++) {
      if (text[i] === character) {
        charCounter++;
      }
    }
    return charCounter;
  }
  /**
   * Return the index that can be used to set the caret position.
   * This takes into account that the position is starting at '0', not 1.
   *
   * @param {int} characterCount
   * @returns {number}
   */
  static convertCharacterCountToIndexPosition(characterCount) {
    return Math.max(characterCount, characterCount - 1);
  }
  /**
   * Cross browser routine for getting selected range/cursor position.
   * Note: this also works with edge cases like contenteditable-enabled elements, and hidden inputs.
   *
   * @param {HTMLInputElement|EventTarget} element
   * @returns {{}}
   */
  static getElementSelection(element) {
    const position = {};
    let isSelectionStartUndefined;
    try {
      isSelectionStartUndefined = this.isUndefined(element.selectionStart);
    } catch (error) {
      isSelectionStartUndefined = false;
    }
    try {
      if (isSelectionStartUndefined) {
        const selection = window.getSelection();
        const selectionInfo = selection.getRangeAt(0);
        position.start = selectionInfo.startOffset;
        position.end = selectionInfo.endOffset;
        position.length = position.end - position.start;
      } else {
        position.start = element.selectionStart;
        position.end = element.selectionEnd;
        position.length = position.end - position.start;
      }
    } catch (error) {
      position.start = 0;
      position.end = 0;
      position.length = 0;
    }
    return position;
  }
  /**
   * Cross browser routine for setting selected range/cursor position
   *
   * @param {HTMLInputElement|EventTarget} element
   * @param {int} start
   * @param {int|null} end
   */
  static setElementSelection(element, start, end = null) {
    if (this.isUndefinedOrNullOrEmpty(end)) {
      end = start;
    }
    if (this.isInputElement(element)) {
      element.setSelectionRange(start, end);
    } else if (!_AutoNumericHelper.isNull(element.firstChild)) {
      const range = document.createRange();
      range.setStart(element.firstChild, start);
      range.setEnd(element.firstChild, end);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
  /**
   * Function that throw error messages
   *
   * @param {string} message
   * @throws
   */
  static throwError(message) {
    throw new Error(message);
  }
  /**
   * Function that display a warning messages, according to the debug level.
   *
   * @param {string} message
   * @param {boolean} showWarning If FALSE, then the warning message is not displayed
   */
  static warning(message, showWarning = true) {
    if (showWarning) {
      console.warn(`Warning: ${message}`);
    }
  }
  /**
   * Return `true` if the given event is an instance of WheelEvent
   *
   * @static
   * @param {event} event The event to test
   * @returns {boolean} Return `true` if the event is an instance of WheelEvent, FALSE otherwise
  */
  static isWheelEvent(event) {
    return event instanceof WheelEvent;
  }
  /**
   * Return `true` if the given event is a wheelup event
   *
   * @param {WheelEvent} wheelEvent
   * @returns {boolean}
   */
  static isWheelUpEvent(wheelEvent) {
    if (!this.isWheelEvent(wheelEvent) || this.isUndefinedOrNullOrEmpty(wheelEvent.deltaY)) {
      this.throwError(`The event passed as a parameter is not a valid wheel event, '${wheelEvent.type}' given.`);
    }
    return wheelEvent.deltaY < 0;
  }
  /**
   * Return `true` if the given event is a wheeldown event
   *
   * @param {WheelEvent} wheelEvent
   * @returns {boolean}
   */
  static isWheelDownEvent(wheelEvent) {
    if (!this.isWheelEvent(wheelEvent) || this.isUndefinedOrNullOrEmpty(wheelEvent.deltaY)) {
      this.throwError(`The event passed as a parameter is not a valid wheel event, '${wheelEvent.type}' given.`);
    }
    return wheelEvent.deltaY > 0;
  }
  /**
   * Return `true` if the given event is an instance of WheelEvent and the deltaY value is equal to zero
   *
   * @param {WheelEvent} wheelEvent The event to test
   * @returns {boolean} Return `true` if the event is an instance of WheelEvent and the deltaY value is equal to zero, FALSE otherwise
   */
  static isWheelEventWithZeroDeltaY(wheelEvent) {
    return this.isWheelEvent(wheelEvent) && !this.isUndefinedOrNullOrEmpty(wheelEvent.deltaY) && wheelEvent.deltaY === 0;
  }
  /**
   * Return the given raw value truncated at the given number of decimal places `decimalPlaces`.
   * This function does not round the value.
   *
   * @example
   * forceDecimalPlaces(123.45678, 0) -> '123.45678'
   * forceDecimalPlaces(123.45678, 1) -> '123.4'
   * forceDecimalPlaces(123.45678, 2) -> '123.45'
   * forceDecimalPlaces(123.45678, 3) -> '123.456'
   *
   * @param {number} value
   * @param {int} decimalPlaces
   * @returns {number|string}
   */
  static forceDecimalPlaces(value, decimalPlaces) {
    const [integerPart, decimalPart] = String(value).split(".");
    if (!decimalPart) {
      return value;
    }
    return `${integerPart}.${decimalPart.substr(0, decimalPlaces)}`;
  }
  /**
   * Return the 'nearest rounded' value, according to the given step size.
   * @example roundToNearest(264789, 10000)) => 260000
   *
   * @param {number} value
   * @param {number} stepPlace
   * @returns {*}
   */
  static roundToNearest(value, stepPlace = 1e3) {
    if (0 === value) {
      return 0;
    }
    if (stepPlace === 0) {
      this.throwError("The `stepPlace` used to round is equal to `0`. This value must not be equal to zero.");
    }
    return Math.round(value / stepPlace) * stepPlace;
  }
  /**
   * Return the 'nearest rounded' value by automatically adding or subtracting the calculated offset to the initial value.
   * This is done without having to pass a step to this function, and based on the size of the given `value`.
   *
   * @example                    Calculated offset
   *           1 ->           1 (1)
   *          14 ->          10 (10)
   *         143 ->         140 (10)
   *       1.278 ->       1.300 (100)
   *      28.456 ->      28.500 (100)
   *     276.345 ->     276.000 (1.000)
   *   4.534.061 ->   4.530.000 (10.000)
   *  66.723.844 ->  66.700.000 (100.000)
   * 257.833.411 -> 258.000.000 (1.000.000)
   *
   *                           Initial   Added   Offset
   * 2 decimalPlacesRawValue : 1.12   -> 2.00   (1)
   * 3 decimalPlacesRawValue : 1.123  -> 2.000  (1)
   *
   * Special case when the `value` to round is between -1 and 1, excluded :
   * @example
   *     Number of             Initial   Result  Calculated
   *     decimal places        value     (add)   offset
   * 2 decimalPlacesRawValue : 0.12   -> 0.13    (0.01) : Math.pow(10, -2)
   * 2 decimalPlacesRawValue : 0.01   -> 0.02    (0.01)
   * 2 decimalPlacesRawValue : 0.00   -> 0.01    (0.01)
   *
   * 3 decimalPlacesRawValue : 0.123  -> 0.133   (0.01)  : Math.pow(10, -2)
   * 3 decimalPlacesRawValue : 0.012  -> 0.013   (0.001) : Math.pow(10, -3)
   * 3 decimalPlacesRawValue : 0.001  -> 0.001   (0.001)
   * 3 decimalPlacesRawValue : 0.000  -> 0.001   (0.001)
   *
   * 4 decimalPlacesRawValue : 0.4123 -> 0.4200  (0.01)   : Math.pow(10, -2)
   * 4 decimalPlacesRawValue : 0.0412 -> 0.0420  (0.001)  : Math.pow(10, -3)
   * 4 decimalPlacesRawValue : 0.0041 -> 0.0042  (0.0001) : Math.pow(10, -4)
   * 4 decimalPlacesRawValue : 0.0004 -> 0.0005  (0.0001)
   * 4 decimalPlacesRawValue : 0.0000 -> 0.0001  (0.0001)
   *
   * @param {number} value
   * @param {boolean} isAddition
   * @param {int} decimalPlacesRawValue The precision needed by the `rawValue`
   * @returns {*}
   */
  static modifyAndRoundToNearestAuto(value, isAddition, decimalPlacesRawValue) {
    value = Number(this.forceDecimalPlaces(value, decimalPlacesRawValue));
    const absValue = Math.abs(value);
    if (absValue >= 0 && absValue < 1) {
      const rawValueMinimumOffset = Math.pow(10, -decimalPlacesRawValue);
      if (value === 0) {
        return isAddition ? rawValueMinimumOffset : -rawValueMinimumOffset;
      }
      let offset;
      const minimumOffsetFirstDecimalPlaceIndex = decimalPlacesRawValue;
      const indexFirstNonZeroDecimalPlace = this.indexFirstNonZeroDecimalPlace(value);
      if (indexFirstNonZeroDecimalPlace >= minimumOffsetFirstDecimalPlaceIndex - 1) {
        offset = rawValueMinimumOffset;
      } else {
        offset = Math.pow(10, -(indexFirstNonZeroDecimalPlace + 1));
      }
      let result;
      if (isAddition) {
        result = value + offset;
      } else {
        result = value - offset;
      }
      return this.roundToNearest(result, offset);
    } else {
      value = parseInt(value, 10);
      const lengthValue = Math.abs(value).toString().length;
      let pow;
      switch (lengthValue) {
        case 1:
          pow = 0;
          break;
        case 2:
        case 3:
          pow = 1;
          break;
        case 4:
        case 5:
          pow = 2;
          break;
        default:
          pow = lengthValue - 3;
      }
      const offset = Math.pow(10, pow);
      let result;
      if (isAddition) {
        result = value + offset;
      } else {
        result = value - offset;
      }
      if (result <= 10 && result >= -10) {
        return result;
      }
      return this.roundToNearest(result, offset);
    }
  }
  /**
   * Return the 'nearest rounded' value automatically by adding the calculated offset to the initial value.
   * This will limit the result to the given number of decimal places `decimalPlacesLimit`.
   *
   * @param {number} value
   * @param {int} decimalPlacesLimit
   * @returns {*}
   */
  static addAndRoundToNearestAuto(value, decimalPlacesLimit) {
    return this.modifyAndRoundToNearestAuto(value, true, decimalPlacesLimit);
  }
  /**
   * Return the 'nearest rounded' value automatically by subtracting the calculated offset to the initial value.
   * This will limit the result to the given number of decimal places `decimalPlacesLimit`.
   *
   * @param {number} value
   * @param {int} decimalPlacesLimit
   * @returns {*}
   */
  static subtractAndRoundToNearestAuto(value, decimalPlacesLimit) {
    return this.modifyAndRoundToNearestAuto(value, false, decimalPlacesLimit);
  }
  /**
   * Take an arabic number as a string and return a javascript number.
   * By default, this function does not try to convert the arabic decimal and thousand separator characters.
   * This returns `NaN` is the conversion is not possible.
   * Based on http://stackoverflow.com/a/17025392/2834898
   *
   * @param {string} arabicNumbers
   * @param {boolean} returnANumber If `true`, return a Number, otherwise return a String
   * @param {boolean} parseDecimalCharacter
   * @param {boolean} parseThousandSeparator
   * @returns {string|number|NaN}
   */
  static arabicToLatinNumbers(arabicNumbers, returnANumber = true, parseDecimalCharacter = false, parseThousandSeparator = false) {
    if (this.isNull(arabicNumbers)) {
      return arabicNumbers;
    }
    let result = arabicNumbers.toString();
    if (result === "") {
      return arabicNumbers;
    }
    if (result.match(/[٠١٢٣٤٥٦٧٨٩۴۵۶]/g) === null) {
      if (returnANumber) {
        result = Number(result);
      }
      return result;
    }
    if (parseDecimalCharacter) {
      result = result.replace(/٫/, ".");
    }
    if (parseThousandSeparator) {
      result = result.replace(/٬/g, "");
    }
    result = result.replace(/[٠١٢٣٤٥٦٧٨٩]/g, (d) => d.charCodeAt(0) - 1632).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, (d) => d.charCodeAt(0) - 1776);
    const resultAsNumber = Number(result);
    if (isNaN(resultAsNumber)) {
      return resultAsNumber;
    }
    if (returnANumber) {
      result = resultAsNumber;
    }
    return result;
  }
  /**
   * Create a custom event and immediately sent it from the given element.
   * By default, if no element is given, the event is thrown from `document`.
   *
   * @param {string} eventName
   * @param {HTMLElement|HTMLDocument|EventTarget} element
   * @param {object} detail
   * @param {boolean} bubbles Set to `true` if the event must bubble up
   * @param {boolean} cancelable Set to `true` if the event must be cancelable
   */
  static triggerEvent(eventName, element = document, detail = null, bubbles = true, cancelable = true) {
    let event;
    if (window.CustomEvent) {
      event = new CustomEvent(eventName, { detail, bubbles, cancelable });
    } else {
      event = document.createEvent("CustomEvent");
      event.initCustomEvent(eventName, bubbles, cancelable, { detail });
    }
    element.dispatchEvent(event);
  }
  /**
   * Function to parse minimumValue, maximumValue & the input value to prepare for testing to determine if the value falls within the min / max range.
   * Return an object example: minimumValue: "999999999999999.99" returns the following "{s: -1, e: 12, c: Array[15]}".
   *
   * This function is adapted from Big.js https://github.com/MikeMcl/big.js/. Many thanks to Mike.
   *
   * @param {number|string} n A numeric value.
   * @returns {{}}
   */
  static parseStr(n) {
    const x = {};
    let e;
    let i;
    let nL;
    let j;
    if (n === 0 && 1 / n < 0) {
      n = "-0";
    }
    n = n.toString();
    if (this.isNegativeStrict(n, "-")) {
      n = n.slice(1);
      x.s = -1;
    } else {
      x.s = 1;
    }
    e = n.indexOf(".");
    if (e > -1) {
      n = n.replace(".", "");
    }
    if (e < 0) {
      e = n.length;
    }
    i = n.search(/[1-9]/i) === -1 ? n.length : n.search(/[1-9]/i);
    nL = n.length;
    if (i === nL) {
      x.e = 0;
      x.c = [0];
    } else {
      for (j = nL - 1; n.charAt(j) === "0"; j -= 1) {
        nL -= 1;
      }
      nL -= 1;
      x.e = e - i - 1;
      x.c = [];
      for (e = 0; i <= nL; i += 1) {
        x.c[e] = +n.charAt(i);
        e += 1;
      }
    }
    return x;
  }
  /**
   * Function to test if the input value falls with the Min / Max settings.
   * This uses the parsed strings for the above parseStr function.
   *
   * This function is adapted from Big.js https://github.com/MikeMcl/big.js/. Many thanks to Mike.
   *
   * @param {object} y Big number instance
   * @param {object} x Big number instance
   * @returns {*}
   */
  static testMinMax(y, x) {
    const xc = x.c;
    const yc = y.c;
    let i = x.s;
    let j = y.s;
    let k = x.e;
    let l = y.e;
    if (!xc[0] || !yc[0]) {
      let result2;
      if (!xc[0]) {
        result2 = !yc[0] ? 0 : -j;
      } else {
        result2 = i;
      }
      return result2;
    }
    if (i !== j) {
      return i;
    }
    const xNeg = i < 0;
    if (k !== l) {
      return k > l ^ xNeg ? 1 : -1;
    }
    i = -1;
    k = xc.length;
    l = yc.length;
    j = k < l ? k : l;
    for (i += 1; i < j; i += 1) {
      if (xc[i] !== yc[i]) {
        return xc[i] > yc[i] ^ xNeg ? 1 : -1;
      }
    }
    let result;
    if (k === l) {
      result = 0;
    } else {
      result = k > l ^ xNeg ? 1 : -1;
    }
    return result;
  }
  /**
   * Generate a random string.
   * cf. http://stackoverflow.com/a/8084248/2834898
   *
   * @param {Number} strLength Length of the generated string (in character count)
   * @returns {string}
   */
  static randomString(strLength = 5) {
    return Math.random().toString(36).substr(2, strLength);
  }
  /**
   * Return the DOM element when passed either a DOM element or a selector string.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @returns {HTMLElement}
   */
  static domElement(domElementOrSelector) {
    let domElement;
    if (_AutoNumericHelper.isString(domElementOrSelector)) {
      domElement = document.querySelector(domElementOrSelector);
    } else {
      domElement = domElementOrSelector;
    }
    return domElement;
  }
  /**
   * Retrieve the current element value.
   *
   * @param {HTMLElement|HTMLInputElement|EventTarget} element
   * @returns {number|string|null}
   */
  static getElementValue(element) {
    if (element.tagName.toLowerCase() === "input") {
      return element.value;
    }
    return this.text(element);
  }
  /**
   * Modify the element value directly.
   *
   * @param {HTMLElement|HTMLInputElement} element
   * @param {number|string|null} value
   */
  static setElementValue(element, value = null) {
    if (element.tagName.toLowerCase() === "input") {
      element.value = value;
    } else {
      element.textContent = value;
    }
  }
  /**
   * Set the invalid state for the given element.
   * A custom message can be passed as the second argument.
   * Note: This does not work with contenteditable elements
   *
   * @param {HTMLElement|HTMLInputElement} element
   * @param {string|null} message
   * @throws Error
   */
  static setInvalidState(element, message = "Invalid") {
    if (message === "" || this.isNull(message))
      this.throwError("Cannot set the invalid state with an empty message.");
    element.setCustomValidity(message);
  }
  /**
   * Set the valid state for the given element.
   * Note: This does not work with contenteditable elements
   *
   * @param {HTMLElement|HTMLInputElement} element
   */
  static setValidState(element) {
    element.setCustomValidity("");
  }
  /**
   * This clone the given object, and return it.
   * WARNING: This does not do a deep cloning.
   * cf. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Examples
   * //TODO Add a `deep` option to clone object with more than one depth
   *
   * @param {object} obj
   * @returns {object}
   */
  static cloneObject(obj) {
    return Object.assign({}, obj);
  }
  /**
   * Return a 'camelized' version of the given string.
   * By default, this assume that :
   * - the separators are hyphens '-',
   * - the 'data-' string should be removed, and
   * - that the very first word should not be capitalized.
   *
   * @example camelize('data-currency-symbol') => 'currencySymbol'
   *
   * @param {string} str Text to camelize
   * @param {string} separator Character that separate each word
   * @param {boolean} removeData If set to `true`, remove the `data-` part that you can find on some html attributes
   * @param {boolean} skipFirstWord If set to `true`, do not capitalize the very first word
   * @returns {string|null}
   */
  static camelize(str, separator = "-", removeData = true, skipFirstWord = true) {
    if (this.isNull(str)) {
      return null;
    }
    if (removeData) {
      str = str.replace(/^data-/, "");
    }
    const words = str.split(separator);
    let result = words.map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`);
    result = result.join("");
    if (skipFirstWord) {
      result = `${result.charAt(0).toLowerCase()}${result.slice(1)}`;
    }
    return result;
  }
  /**
   * Return the text component of the given DOM element.
   *
   * @param {Element} domElement
   * @returns {string}
   */
  static text(domElement) {
    const nodeType = domElement.nodeType;
    let result;
    if (nodeType === Node.ELEMENT_NODE || nodeType === Node.DOCUMENT_NODE || nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      result = domElement.textContent;
    } else if (nodeType === Node.TEXT_NODE) {
      result = domElement.nodeValue;
    } else {
      result = "";
    }
    return result;
  }
  /**
   * Set the text content of the given DOM element.
   * @param {Element} domElement
   * @param {string} text
   */
  static setText(domElement, text) {
    const nodeType = domElement.nodeType;
    if (nodeType === Node.ELEMENT_NODE || nodeType === Node.DOCUMENT_NODE || nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      domElement.textContent = text;
    }
  }
  /**
   * Filter out the given `arr` array with the elements found in `excludedElements`.
   * This returns a new array and does not modify the source.
   * cf. verification here : http://codepen.io/AnotherLinuxUser/pen/XpvrMg?editors=0012
   *
   * @param {Array} arr
   * @param {Array} excludedElements
   * @returns {*|Array.<T>}
   */
  static filterOut(arr, excludedElements) {
    return arr.filter((element) => !this.isInArray(element, excludedElements));
  }
  /**
   * Remove the trailing zeros in the decimal part of a number.
   *
   * @param {string} numericString
   * @returns {*}
   */
  static trimPaddedZerosFromDecimalPlaces(numericString) {
    numericString = String(numericString);
    if (numericString === "") {
      return "";
    }
    const [integerPart, decimalPart] = numericString.split(".");
    if (this.isUndefinedOrNullOrEmpty(decimalPart)) {
      return integerPart;
    }
    const trimmedDecimalPart = decimalPart.replace(/0+$/g, "");
    let result;
    if (trimmedDecimalPart === "") {
      result = integerPart;
    } else {
      result = `${integerPart}.${trimmedDecimalPart}`;
    }
    return result;
  }
  /**
   * Return the top-most hovered item by the mouse cursor.
   *
   * @returns {*}
   */
  static getHoveredElement() {
    const hoveredElements = [...document.querySelectorAll(":hover")];
    return hoveredElements[hoveredElements.length - 1];
  }
  /**
   * Return the given array trimmed to the given length.
   * @example arrayTrim([1, 2, 3, 4], 2) -> [1, 2]
   *
   * @param {Array} array
   * @param {Number} length
   * @returns {*}
   */
  static arrayTrim(array2, length) {
    const arrLength = array2.length;
    if (arrLength === 0 || length > arrLength) {
      return array2;
    }
    if (length < 0) {
      return [];
    }
    array2.length = parseInt(length, 10);
    return array2;
  }
  /**
   * Merge all the given arrays by keeping only unique elements, and return an array with de-duplicated values.
   * cf. http://stackoverflow.com/a/27664971/2834898
   *
   * @param {...array} arrays
   * @returns {[*]}
   */
  static arrayUnique(...arrays) {
    return [...new Set([].concat(...arrays))];
  }
  /**
   * Merge all the given Maps by keeping only unique elements, and return a new Map with de-duplicated keys.
   *
   * @param {...Map} mapObjects
   * @returns {Map}
   */
  static mergeMaps(...mapObjects) {
    return new Map(mapObjects.reduce((as, b) => as.concat([...b]), []));
  }
  /**
   * Search the given `value` in the object `obj`, and return the very first key it finds
   *
   * @param {object} obj
   * @param {string|number} value
   * @returns {*|null}
   */
  static objectKeyLookup(obj, value) {
    const result = Object.entries(obj).find((array2) => array2[1] === value);
    let key = null;
    if (result !== void 0) {
      key = result[0];
    }
    return key;
  }
  /**
   * Insert the single character `char` in the string `str` at the given position `index`
   *
   * @param {string} str
   * @param {string} char
   * @param {int} index
   * @returns {string}
   */
  static insertAt(str, char, index) {
    str = String(str);
    if (index > str.length) {
      throw new Error(`The given index is out of the string range.`);
    }
    if (char.length !== 1) {
      throw new Error("The given string `char` should be only one character long.");
    }
    if (str === "" && index === 0) {
      return char;
    }
    return `${str.slice(0, index)}${char}${str.slice(index)}`;
  }
  /**
   * Convert the given scientific notation to the 'expanded' decimal notation
   *
   * @example scientificToDecimal('-123.4567e-6') returns '-0.0001234567'
   *
   * @param {number|string} val
   * @returns {number|string}
   */
  static scientificToDecimal(val) {
    const numericValue = Number(val);
    if (isNaN(numericValue)) {
      return NaN;
    }
    val = String(val);
    const isScientific = this.contains(val, "e") || this.contains(val, "E");
    if (!isScientific) {
      return val;
    }
    let [value, exponent] = val.split(/e/i);
    const isNegative = value < 0;
    if (isNegative) {
      value = value.replace("-", "");
    }
    const isNegativeExponent = +exponent < 0;
    if (isNegativeExponent) {
      exponent = exponent.replace("-", "");
    }
    const [int, float] = value.split(/\./);
    let result;
    if (isNegativeExponent) {
      if (int.length > exponent) {
        result = this.insertAt(int, ".", int.length - exponent);
      } else {
        result = `0.${"0".repeat(exponent - int.length)}${int}`;
      }
      result = `${result}${float ? float : ""}`;
    } else {
      if (float) {
        value = `${int}${float}`;
        if (exponent < float.length) {
          result = this.insertAt(value, ".", +exponent + int.length);
        } else {
          result = `${value}${"0".repeat(exponent - float.length)}`;
        }
      } else {
        value = value.replace(".", "");
        result = `${value}${"0".repeat(Number(exponent))}`;
      }
    }
    if (isNegative) {
      result = `-${result}`;
    }
    return result;
  }
};

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/maths/Evaluator.js
var Evaluator = class {
  constructor(ast) {
    if (ast === null) {
      throw new Error(`Invalid AST`);
    }
  }
  evaluate(subtree) {
    if (subtree === void 0 || subtree === null) {
      throw new Error(`Invalid AST sub-tree`);
    }
    if (subtree.type === "number") {
      return subtree.value;
    } else if (subtree.type === "unaryMinus") {
      return -this.evaluate(subtree.left);
    } else {
      const left = this.evaluate(subtree.left);
      const right = this.evaluate(subtree.right);
      switch (subtree.type) {
        case "op_+":
          return Number(left) + Number(right);
        case "op_-":
          return left - right;
        case "op_*":
          return left * right;
        case "op_/":
          return left / right;
        default:
          throw new Error(`Invalid operator '${subtree.type}'`);
      }
    }
  }
};

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/maths/ASTNode.js
var ASTNode = class _ASTNode {
  /*
  constructor() {
      // this.type = void(0);
      // this.value = 0;
      // this.left = null;
      // this.right = null;
  }
  */
  static createNode(type, left, right) {
    const node = new _ASTNode();
    node.type = type;
    node.left = left;
    node.right = right;
    return node;
  }
  static createUnaryNode(left) {
    const node = new _ASTNode();
    node.type = "unaryMinus";
    node.left = left;
    node.right = null;
    return node;
  }
  static createLeaf(value) {
    const node = new _ASTNode();
    node.type = "number";
    node.value = value;
    return node;
  }
};

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/maths/Token.js
var Token = class {
  constructor(type, value, symbol) {
    this.type = type;
    this.value = value;
    this.symbol = symbol;
  }
};

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/maths/Lexer.js
var Lexer = class {
  constructor(text) {
    this.text = text;
    this.textLength = text.length;
    this.index = 0;
    this.token = new Token("Error", 0, 0);
  }
  /**
   * Ignore white spaces and increment the index count until a non-space character is found
   * @private
   */
  _skipSpaces() {
    while (this.text[this.index] === " " && this.index <= this.textLength) {
      this.index++;
    }
  }
  /**
   * Return the current index
   *
   * @returns {number}
   */
  getIndex() {
    return this.index;
  }
  /**
   * Return the next token object
   *
   * @param {string} decimalCharacter The decimal character to use in the float numbers
   * @returns {Token}
   */
  getNextToken(decimalCharacter = ".") {
    this._skipSpaces();
    if (this.textLength === this.index) {
      this.token.type = "EOT";
      return this.token;
    }
    if (AutoNumericHelper.isDigit(this.text[this.index])) {
      this.token.type = "num";
      this.token.value = this._getNumber(decimalCharacter);
      return this.token;
    }
    this.token.type = "Error";
    switch (this.text[this.index]) {
      case "+":
        this.token.type = "+";
        break;
      case "-":
        this.token.type = "-";
        break;
      case "*":
        this.token.type = "*";
        break;
      case "/":
        this.token.type = "/";
        break;
      case "(":
        this.token.type = "(";
        break;
      case ")":
        this.token.type = ")";
        break;
    }
    if (this.token.type !== "Error") {
      this.token.symbol = this.text[this.index];
      this.index++;
    } else {
      throw new Error(`Unexpected token '${this.token.symbol}' at position '${this.token.index}' in the token function`);
    }
    return this.token;
  }
  /**
   * Return the integer or float number starting from the `this.index` string index
   *
   * @param {string} decimalCharacter The decimal character to use in the float numbers
   *
   * @returns {string}
   * @private
   */
  _getNumber(decimalCharacter) {
    this._skipSpaces();
    const startIndex = this.index;
    while (this.index <= this.textLength && AutoNumericHelper.isDigit(this.text[this.index])) {
      this.index++;
    }
    if (this.text[this.index] === decimalCharacter) {
      this.index++;
    }
    while (this.index <= this.textLength && AutoNumericHelper.isDigit(this.text[this.index])) {
      this.index++;
    }
    if (this.index === startIndex) {
      throw new Error(`No number has been found while it was expected`);
    }
    return this.text.substring(startIndex, this.index).replace(decimalCharacter, ".");
  }
};

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/maths/Parser.js
var Parser = class {
  /**
   * Parse the given string, and generate an abstract syntax tree (AST) from the math expression
   *
   * @param {string} text
   * @param {string} customDecimalCharacter The custom decimal character to use in floats
   * @returns {ASTNode}
   */
  constructor(text, customDecimalCharacter = ".") {
    this.text = text;
    this.decimalCharacter = customDecimalCharacter;
    this.lexer = new Lexer(text);
    this.token = this.lexer.getNextToken(this.decimalCharacter);
    return this._exp();
  }
  _exp() {
    const termNode = this._term();
    const exprNode = this._moreExp();
    return ASTNode.createNode("op_+", termNode, exprNode);
  }
  _moreExp() {
    let termNode;
    let exprNode;
    switch (this.token.type) {
      case "+":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        termNode = this._term();
        exprNode = this._moreExp();
        return ASTNode.createNode("op_+", exprNode, termNode);
      case "-":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        termNode = this._term();
        exprNode = this._moreExp();
        return ASTNode.createNode("op_-", exprNode, termNode);
    }
    return ASTNode.createLeaf(0);
  }
  _term() {
    const factorNode = this._factor();
    const termsNode = this._moreTerms();
    return ASTNode.createNode("op_*", factorNode, termsNode);
  }
  _moreTerms() {
    let factorNode;
    let termsNode;
    switch (this.token.type) {
      case "*":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        factorNode = this._factor();
        termsNode = this._moreTerms();
        return ASTNode.createNode("op_*", termsNode, factorNode);
      case "/":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        factorNode = this._factor();
        termsNode = this._moreTerms();
        return ASTNode.createNode("op_/", termsNode, factorNode);
    }
    return ASTNode.createLeaf(1);
  }
  _factor() {
    let expression;
    let factor;
    let value;
    switch (this.token.type) {
      case "num":
        value = this.token.value;
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        return ASTNode.createLeaf(value);
      case "-":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        factor = this._factor();
        return ASTNode.createUnaryNode(factor);
      case "(":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        expression = this._exp();
        this._match(")");
        return expression;
      default: {
        throw new Error(`Unexpected token '${this.token.symbol}' with type '${this.token.type}' at position '${this.token.index}' in the factor function`);
      }
    }
  }
  _match(expected) {
    const index = this.lexer.getIndex() - 1;
    if (this.text[index] === expected) {
      this.token = this.lexer.getNextToken(this.decimalCharacter);
    } else {
      throw new Error(`Unexpected token '${this.token.symbol}' at position '${index}' in the match function`);
    }
  }
};

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/AutoNumeric.js
var AutoNumeric = class _AutoNumeric {
  static options;
  // Those static declarations are only used by the IDE, to prevent error messages not finding those fields declarations
  static events;
  static defaultSettings;
  static predefinedOptions;
  /**
   * Return the autoNumeric version number (for debugging purpose)
   *
   * @returns {string}
   */
  static version() {
    return "4.10.5";
  }
  /**
   * Initialize the AutoNumeric object onto the given DOM element, and attach the settings and related event listeners to it.
   * The options passed as a parameter is an object that contains the settings (i.e. {digitGroupSeparator: ".", decimalCharacter: ",", currencySymbol: '€ '})
   *
   * @example
   * anElement = new AutoNumeric(domElement); // With the default options
   * anElement = new AutoNumeric(domElement, { options }); // With one option object
   * anElement = new AutoNumeric(domElement, 'euroPos'); // With a named pre-defined string
   * anElement = new AutoNumeric(domElement, [{ options1 }, 'euroPos', { options2 }]); // With multiple option objects (the latest option overwriting the previous ones)
   * anElement = new AutoNumeric(domElement, null, { options }); // With one option object, and a failed initial value
   * anElement = new AutoNumeric(domElement).french(); // With one pre-defined language object
   * anElement = new AutoNumeric(domElement).french({ options });// With one pre-defined language object and additional options that will override the defaults
   *
   * // ...or init and set the value in one call :
   * anElement = new AutoNumeric(domElement, 12345.789); // With the default options, and an initial value
   * anElement = new AutoNumeric(domElement, 12345.789, { options });
   * anElement = new AutoNumeric(domElement, '12345.789', { options });
   * anElement = new AutoNumeric(domElement, 12345.789, 'euroPos');
   * anElement = new AutoNumeric(domElement, 12345.789, [{ options1 }, 'euroPos', { options2 }]);
   * anElement = new AutoNumeric(domElement, 12345.789).french({ options });
   * anElement = new AutoNumeric(domElement, 12345.789, { options }).french({ options }); // Not really helpful, but possible
   *
   * // The AutoNumeric constructor class can also accept a string as a css selector. Under the hood this use `QuerySelector` and limit itself to only the first element it finds.
   * anElement = new AutoNumeric('.myCssClass > input');
   * anElement = new AutoNumeric('.myCssClass > input', { options });
   * anElement = new AutoNumeric('.myCssClass > input', 'euroPos');
   * anElement = new AutoNumeric('.myCssClass > input', [{ options1 }, 'euroPos', { options2 }]);
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789);
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789, { options });
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789, 'euroPos');
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789, [{ options1 }, 'euroPos', { options2 }]);
   * anElement = new AutoNumeric('.myCssClass > input', null, { options }); // With a failed initial value
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789).french({ options });
   *
   * @param {object|Array|number|string} arg1
   * @param {object|Array|number|string|null} arg2
   * @param {object|Array|number|string|null} arg3
   * @throws
   */
  constructor(arg1 = null, arg2 = null, arg3 = null) {
    const { domElement, initialValue, userOptions } = _AutoNumeric._setArgumentsValues(arg1, arg2, arg3);
    this.domElement = domElement;
    this.defaultRawValue = "";
    this._setSettings(userOptions, false);
    this._checkElement();
    this.savedCancellableValue = null;
    this.historyTable = [];
    this.historyTableIndex = -1;
    this.onGoingRedo = false;
    this.parentForm = this._getParentForm();
    if (!this.runOnce && this.settings.formatOnPageLoad) {
      this._formatDefaultValueOnPageLoad(initialValue);
    } else {
      let valueToSet;
      if (AutoNumericHelper.isNull(initialValue)) {
        switch (this.settings.emptyInputBehavior) {
          case _AutoNumeric.options.emptyInputBehavior.min:
            valueToSet = this.settings.minimumValue;
            break;
          case _AutoNumeric.options.emptyInputBehavior.max:
            valueToSet = this.settings.maximumValue;
            break;
          case _AutoNumeric.options.emptyInputBehavior.zero:
            valueToSet = "0";
            break;
          case _AutoNumeric.options.emptyInputBehavior.focus:
          case _AutoNumeric.options.emptyInputBehavior.press:
          case _AutoNumeric.options.emptyInputBehavior.always:
            valueToSet = "";
            break;
          case _AutoNumeric.options.emptyInputBehavior.null:
            valueToSet = null;
            break;
          default:
            valueToSet = this.settings.emptyInputBehavior;
        }
      } else {
        valueToSet = initialValue;
      }
      this._setElementAndRawValue(valueToSet);
    }
    this.runOnce = true;
    this.hasEventListeners = false;
    if (this.isInputElement || this.isContentEditable) {
      if (!this.settings.noEventListeners) {
        this._createEventListeners();
      }
      this._setWritePermissions(true);
    }
    this._saveInitialValues(initialValue);
    this.storageNamePrefix = "AUTO_";
    this._setPersistentStorageName();
    this.validState = true;
    this.isFocused = false;
    this.isWheelEvent = false;
    this.isDropEvent = false;
    this.isEditing = false;
    this.rawValueOnFocus = void 0;
    this.internalModification = false;
    this.attributeToWatch = this._getAttributeToWatch();
    this.getterSetter = Object.getOwnPropertyDescriptor(this.domElement.__proto__, this.attributeToWatch);
    this._addWatcher();
    if (this.settings.createLocalList) {
      this._createLocalList();
    }
    this.constructor._addToGlobalList(this);
    this.global = {
      /**
       * Set the same given element value for each element in the local AutoNumeric element list, and format those elements immediately
       *
       * @param {number|string} newValue The value must be a number or a numeric string
       * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
       */
      set: (newValue, options = null) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.set(newValue, options);
        });
      },
      /**
       * Set the value given value directly as the DOM element value, without formatting it beforehand.
       * This sets the same unformatted value for each element in the local AutoNumeric element list.
       *
       * @param {number|string} value
       * @param {object} options
       */
      setUnformatted: (value, options = null) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.setUnformatted(value, options);
        });
      },
      /**
       * This is an alias of the `getNumericString()` function, and should not be used anymore.
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       * @deprecated
       */
      get: (callback = null) => {
        const result = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result.push(aNObject.get());
        });
        this._executeCallback(result, callback);
        return result;
      },
      /**
       * Return an array of the unformatted values (as a string) of each AutoNumeric element of the local AutoNumeric element list
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       */
      getNumericString: (callback = null) => {
        const result = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result.push(aNObject.getNumericString());
        });
        this._executeCallback(result, callback);
        return result;
      },
      /**
       * Return an array of the current formatted values (as a string) of each AutoNumeric element of the local AutoNumeric element list
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       */
      getFormatted: (callback = null) => {
        const result = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result.push(aNObject.getFormatted());
        });
        this._executeCallback(result, callback);
        return result;
      },
      /**
       * Return an array of the element unformatted values (as a real Javascript number), for each element of the local AutoNumeric element list
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<number>}
       */
      getNumber: (callback = null) => {
        const result = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result.push(aNObject.getNumber());
        });
        this._executeCallback(result, callback);
        return result;
      },
      /**
       * Returns the unformatted values (following the `outputFormat` setting) of each element of the local AutoNumeric element list into an array
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       */
      getLocalized: (callback = null) => {
        const result = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result.push(aNObject.getLocalized());
        });
        this._executeCallback(result, callback);
        return result;
      },
      /**
       * Force each element of the local AutoNumeric element list to reformat its value
       */
      reformat: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.reformat();
        });
      },
      /**
       * Remove the formatting and keep only the raw unformatted value (as a numericString) in each element of the local AutoNumeric element list
       */
      unformat: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.unformat();
        });
      },
      /**
       * Remove the formatting and keep only the localized unformatted value in the element, with the option to override the default outputFormat if needed
       *
       * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
       */
      unformatLocalized: (forcedOutputFormat = null) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.unformatLocalized(forcedOutputFormat);
        });
      },
      /**
       * Updates the AutoNumeric settings, and immediately format the elements accordingly, for each element of the local AutoNumeric element list
       *
       * @param {object} newOptions This can be either one or more option objects
       */
      update: (...newOptions) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.update(...newOptions);
        });
      },
      /**
       * Return `true` if *all* the autoNumeric-managed elements are pristine, if their raw value hasn't changed.
       * By default, this returns `true` if the raw unformatted value is still the same even if the formatted one has changed (due to a configuration update for instance).
       *
       * @param {boolean} checkOnlyRawValue If set to `true`, the pristine value is done on the raw unformatted value, not the formatted one. If set to `false`, this also checks that the formatted value hasn't changed.
       * @returns {boolean}
       */
      isPristine: (checkOnlyRawValue = true) => {
        let isPristine = true;
        this.autoNumericLocalList.forEach((aNObject) => {
          if (isPristine && !aNObject.isPristine(checkOnlyRawValue)) {
            isPristine = false;
          }
        });
        return isPristine;
      },
      /**
       * Execute the `clear()` method on each AutoNumeric object in the local AutoNumeric element list
       *
       * @param {boolean} forceClearAll
       */
      clear: (forceClearAll = false) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.clear(forceClearAll);
        });
      },
      /**
       * Execute the `remove()` method on each AutoNumeric object in the local AutoNumeric element list
       */
      remove: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.remove();
        });
      },
      /**
       * Execute the `wipe()` method on each AutoNumeric object in the local AutoNumeric element list
       */
      wipe: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.wipe();
        });
      },
      /**
       * Execute the `nuke()` method on each AutoNumeric object in the local AutoNumeric element list
       */
      nuke: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.nuke();
        });
      },
      /**
       * Return `true` if the given AutoNumeric object (or DOM element) is in the local AutoNumeric element list
       *
       * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
       * @returns {*}
       */
      has: (domElementOrAutoNumericObject) => {
        let result;
        if (domElementOrAutoNumericObject instanceof _AutoNumeric) {
          result = this.autoNumericLocalList.has(domElementOrAutoNumericObject.node());
        } else {
          result = this.autoNumericLocalList.has(domElementOrAutoNumericObject);
        }
        return result;
      },
      /**
       * Add an existing AutoNumeric object (or DOM element) to the local AutoNumeric element list, using the DOM element as the key.
       * This manages the case where `addObject` is used on an AutoNumeric object that already has multiple elements in its local list.
       *
       * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
       */
      addObject: (domElementOrAutoNumericObject) => {
        let domElement2;
        let otherAutoNumericObject;
        if (domElementOrAutoNumericObject instanceof _AutoNumeric) {
          domElement2 = domElementOrAutoNumericObject.node();
          otherAutoNumericObject = domElementOrAutoNumericObject;
        } else {
          domElement2 = domElementOrAutoNumericObject;
          otherAutoNumericObject = _AutoNumeric.getAutoNumericElement(domElement2);
        }
        if (!this._hasLocalList()) {
          this._createLocalList();
        }
        let otherANLocalList = otherAutoNumericObject._getLocalList();
        if (otherANLocalList.size === 0) {
          otherAutoNumericObject._createLocalList();
          otherANLocalList = otherAutoNumericObject._getLocalList();
        }
        let mergedLocalLists;
        if (otherANLocalList instanceof Map) {
          mergedLocalLists = AutoNumericHelper.mergeMaps(this._getLocalList(), otherANLocalList);
        } else {
          this._addToLocalList(domElement2, otherAutoNumericObject);
          mergedLocalLists = this._getLocalList();
        }
        mergedLocalLists.forEach((aNObject) => {
          aNObject._setLocalList(mergedLocalLists);
        });
      },
      /**
       * Remove the given AutoNumeric object (or DOM element) from the local AutoNumeric element list, using the DOM element as the key.
       * If this function attempts to remove the current AutoNumeric object from the local list, a warning is shown, but the deletion is still done.
       *
       * Special cases :
       * - If the current object removes itself, then it's removed from the shared local list, then a new empty local list is used/created
       * - If another object remove this object, then a local list with only this object is used/created
       *
       * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
       * @param {boolean} keepCurrentANObject If set to `false`, then the function will also remove the current AutoNumeric object if asked, otherwise it will ignore it and print a warning message
       */
      removeObject: (domElementOrAutoNumericObject, keepCurrentANObject = false) => {
        let domElement2;
        let otherAutoNumericObject;
        if (domElementOrAutoNumericObject instanceof _AutoNumeric) {
          domElement2 = domElementOrAutoNumericObject.node();
          otherAutoNumericObject = domElementOrAutoNumericObject;
        } else {
          domElement2 = domElementOrAutoNumericObject;
          otherAutoNumericObject = _AutoNumeric.getAutoNumericElement(domElement2);
        }
        const initialCompleteLocalList = this.autoNumericLocalList;
        this.autoNumericLocalList.delete(domElement2);
        initialCompleteLocalList.forEach((aNObject) => {
          aNObject._setLocalList(this.autoNumericLocalList);
        });
        if (!keepCurrentANObject && domElement2 === this.node()) {
          otherAutoNumericObject._setLocalList(/* @__PURE__ */ new Map());
        } else {
          otherAutoNumericObject._createLocalList();
        }
      },
      /**
       * Remove all elements from the shared list, effectively emptying it.
       * This is the equivalent of calling `detach()` on each of its elements.
       *
       * @param {boolean} keepEachANObjectInItsOwnList If set to `true`, then instead of completely emptying the local list of each AutoNumeric objects, each one of those keeps itself in its own local list
       */
      empty: (keepEachANObjectInItsOwnList = false) => {
        const initialCompleteLocalList = this.autoNumericLocalList;
        initialCompleteLocalList.forEach((aNObject) => {
          if (keepEachANObjectInItsOwnList) {
            aNObject._createLocalList();
          } else {
            aNObject._setLocalList(/* @__PURE__ */ new Map());
          }
        });
      },
      /**
       * Return an array containing all the AutoNumeric DOM elements that have been initialized by each other
       *
       * @returns {Array<HTMLElement>}
       */
      elements: () => {
        const result = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result.push(aNObject.node());
        });
        return result;
      },
      /**
       * Return the `Map` object directly
       * @returns {Map}
       */
      getList: () => this.autoNumericLocalList,
      /**
       * Return the number of element in the local AutoNumeric element list
       * @returns {number}
       */
      size: () => this.autoNumericLocalList.size
    };
    this.options = {
      /**
       * Reset any options set previously, by overwriting them with the default settings
       *
       * @returns {AutoNumeric}
       */
      reset: () => {
        this.settings = { rawValue: this.defaultRawValue };
        this.update(_AutoNumeric.defaultSettings);
        return this;
      },
      allowDecimalPadding: (allowDecimalPadding) => {
        this.update({ allowDecimalPadding });
        return this;
      },
      alwaysAllowDecimalCharacter: (alwaysAllowDecimalCharacter) => {
        this.update({ alwaysAllowDecimalCharacter });
        return this;
      },
      caretPositionOnFocus: (caretPositionOnFocus) => {
        this.settings.caretPositionOnFocus = caretPositionOnFocus;
        return this;
      },
      createLocalList: (createLocalList) => {
        this.settings.createLocalList = createLocalList;
        if (this.settings.createLocalList) {
          if (!this._hasLocalList()) {
            this._createLocalList();
          }
        } else {
          this._deleteLocalList();
        }
        return this;
      },
      currencySymbol: (currencySymbol) => {
        this.update({ currencySymbol });
        return this;
      },
      currencySymbolPlacement: (currencySymbolPlacement) => {
        this.update({ currencySymbolPlacement });
        return this;
      },
      decimalCharacter: (decimalCharacter) => {
        this.update({ decimalCharacter });
        return this;
      },
      decimalCharacterAlternative: (decimalCharacterAlternative) => {
        this.settings.decimalCharacterAlternative = decimalCharacterAlternative;
        return this;
      },
      /**
       * Update the decimal places globally, which means this override any previously set number of decimal shown on focus, on blur, or in the raw value.
       *
       * @param {int} decimalPlaces
       * @returns {AutoNumeric}
       */
      decimalPlaces: (decimalPlaces) => {
        AutoNumericHelper.warning("Using `options.decimalPlaces()` instead of calling the specific `options.decimalPlacesRawValue()`, `options.decimalPlacesShownOnFocus()` and `options.decimalPlacesShownOnBlur()` methods will reset those options.\nPlease call the specific methods if you do not want to reset those.", this.settings.showWarnings);
        this.update({ decimalPlaces });
        return this;
      },
      decimalPlacesRawValue: (decimalPlacesRawValue) => {
        this.update({ decimalPlacesRawValue });
        return this;
      },
      decimalPlacesShownOnBlur: (decimalPlacesShownOnBlur) => {
        this.update({ decimalPlacesShownOnBlur });
        return this;
      },
      decimalPlacesShownOnFocus: (decimalPlacesShownOnFocus) => {
        this.update({ decimalPlacesShownOnFocus });
        return this;
      },
      defaultValueOverride: (defaultValueOverride) => {
        this.update({ defaultValueOverride });
        return this;
      },
      digitalGroupSpacing: (digitalGroupSpacing) => {
        this.update({ digitalGroupSpacing });
        return this;
      },
      digitGroupSeparator: (digitGroupSeparator) => {
        this.update({ digitGroupSeparator });
        return this;
      },
      divisorWhenUnfocused: (divisorWhenUnfocused) => {
        this.update({ divisorWhenUnfocused });
        return this;
      },
      emptyInputBehavior: (emptyInputBehavior) => {
        if (this.rawValue === null && emptyInputBehavior !== _AutoNumeric.options.emptyInputBehavior.null) {
          AutoNumericHelper.warning(`You are trying to modify the \`emptyInputBehavior\` option to something different than \`'null'\` (${emptyInputBehavior}), but the element raw value is currently set to \`null\`. This would result in an invalid \`rawValue\`. In order to fix that, the element value has been changed to the empty string \`''\`.`, this.settings.showWarnings);
          this.rawValue = "";
        }
        this.update({ emptyInputBehavior });
        return this;
      },
      eventBubbles: (eventBubbles) => {
        this.settings.eventBubbles = eventBubbles;
        return this;
      },
      eventIsCancelable: (eventIsCancelable) => {
        this.settings.eventIsCancelable = eventIsCancelable;
        return this;
      },
      failOnUnknownOption: (failOnUnknownOption) => {
        this.settings.failOnUnknownOption = failOnUnknownOption;
        return this;
      },
      formatOnPageLoad: (formatOnPageLoad) => {
        this.settings.formatOnPageLoad = formatOnPageLoad;
        return this;
      },
      formulaMode: (formulaMode) => {
        this.settings.formulaMode = formulaMode;
        return this;
      },
      historySize: (historySize) => {
        this.settings.historySize = historySize;
        return this;
      },
      invalidClass: (invalidClass) => {
        this.settings.invalidClass = invalidClass;
        return this;
      },
      isCancellable: (isCancellable) => {
        this.settings.isCancellable = isCancellable;
        return this;
      },
      leadingZero: (leadingZero) => {
        this.update({ leadingZero });
        return this;
      },
      maximumValue: (maximumValue) => {
        this.update({ maximumValue });
        return this;
      },
      minimumValue: (minimumValue) => {
        this.update({ minimumValue });
        return this;
      },
      modifyValueOnUpDownArrow: (modifyValueOnUpDownArrow) => {
        this.settings.modifyValueOnUpDownArrow = modifyValueOnUpDownArrow;
        return this;
      },
      modifyValueOnWheel: (modifyValueOnWheel) => {
        this.settings.modifyValueOnWheel = modifyValueOnWheel;
        return this;
      },
      negativeBracketsTypeOnBlur: (negativeBracketsTypeOnBlur) => {
        this.update({ negativeBracketsTypeOnBlur });
        return this;
      },
      negativePositiveSignPlacement: (negativePositiveSignPlacement) => {
        this.update({ negativePositiveSignPlacement });
        return this;
      },
      negativeSignCharacter: (negativeSignCharacter) => {
        this.update({ negativeSignCharacter });
        return this;
      },
      negativePositiveSignBehavior: (negativePositiveSignBehavior) => {
        this.settings.negativePositiveSignBehavior = negativePositiveSignBehavior;
        return this;
      },
      noEventListeners: (noEventListeners) => {
        if (noEventListeners === _AutoNumeric.options.noEventListeners.noEvents && this.settings.noEventListeners === _AutoNumeric.options.noEventListeners.addEvents) {
          this._removeEventListeners();
        }
        this.update({ noEventListeners });
        return this;
      },
      onInvalidPaste: (onInvalidPaste) => {
        this.settings.onInvalidPaste = onInvalidPaste;
        return this;
      },
      outputFormat: (outputFormat) => {
        this.settings.outputFormat = outputFormat;
        return this;
      },
      overrideMinMaxLimits: (overrideMinMaxLimits) => {
        this.update({ overrideMinMaxLimits });
        return this;
      },
      positiveSignCharacter: (positiveSignCharacter) => {
        this.update({ positiveSignCharacter });
        return this;
      },
      rawValueDivisor: (rawValueDivisor) => {
        this.update({ rawValueDivisor });
        return this;
      },
      readOnly: (readOnly) => {
        this.settings.readOnly = readOnly;
        this._setWritePermissions();
        return this;
      },
      roundingMethod: (roundingMethod) => {
        this.update({ roundingMethod });
        return this;
      },
      saveValueToSessionStorage: (saveValueToSessionStorage) => {
        this.update({ saveValueToSessionStorage });
        return this;
      },
      symbolWhenUnfocused: (symbolWhenUnfocused) => {
        this.update({ symbolWhenUnfocused });
        return this;
      },
      selectNumberOnly: (selectNumberOnly) => {
        this.settings.selectNumberOnly = selectNumberOnly;
        return this;
      },
      selectOnFocus: (selectOnFocus) => {
        this.settings.selectOnFocus = selectOnFocus;
        return this;
      },
      serializeSpaces: (serializeSpaces) => {
        this.settings.serializeSpaces = serializeSpaces;
        return this;
      },
      showOnlyNumbersOnFocus: (showOnlyNumbersOnFocus) => {
        this.update({ showOnlyNumbersOnFocus });
        return this;
      },
      showPositiveSign: (showPositiveSign) => {
        this.update({ showPositiveSign });
        return this;
      },
      showWarnings: (showWarnings) => {
        this.settings.showWarnings = showWarnings;
        return this;
      },
      styleRules: (styleRules) => {
        this.update({ styleRules });
        return this;
      },
      suffixText: (suffixText) => {
        this.update({ suffixText });
        return this;
      },
      unformatOnHover: (unformatOnHover) => {
        this.settings.unformatOnHover = unformatOnHover;
        return this;
      },
      unformatOnSubmit: (unformatOnSubmit) => {
        this.settings.unformatOnSubmit = unformatOnSubmit;
        return this;
      },
      upDownStep: (upDownStep) => {
        this.settings.upDownStep = upDownStep;
        return this;
      },
      valuesToStrings: (valuesToStrings) => {
        this.update({ valuesToStrings });
        return this;
      },
      watchExternalChanges: (watchExternalChanges) => {
        this.update({ watchExternalChanges });
        return this;
      },
      wheelOn: (wheelOn) => {
        this.settings.wheelOn = wheelOn;
        return this;
      },
      wheelStep: (wheelStep) => {
        this.settings.wheelStep = wheelStep;
        return this;
      }
    };
    this._triggerEvent(_AutoNumeric.events.initialized, this.domElement, {
      newValue: AutoNumericHelper.getElementValue(this.domElement),
      newRawValue: this.rawValue,
      error: null,
      aNElement: this
    });
  }
  /**
   * Take the parameters given to the AutoNumeric object, and output the three variables that are needed to finish initializing it :
   * - domElement : The target DOM element
   * - initialValue : The initial value, or `null` if none is given
   * - userOptions : The option object
   *
   * @param {object|Array|number|string} arg1
   * @param {object|Array|number|string|null} arg2
   * @param {object|Array|number|string|null} arg3
   * @returns {{domElement: *, initialValue: *, userOptions: *}}
   * @throws
   * @private
   */
  static _setArgumentsValues(arg1, arg2, arg3) {
    if (AutoNumericHelper.isNull(arg1)) {
      AutoNumericHelper.throwError("At least one valid parameter is needed in order to initialize an AutoNumeric object");
    }
    const isArg1Element = AutoNumericHelper.isElement(arg1);
    const isArg1String = AutoNumericHelper.isString(arg1);
    const isArg2Object = AutoNumericHelper.isObject(arg2);
    const isArg2Array = Array.isArray(arg2) && arg2.length > 0;
    const isArg2Number = AutoNumericHelper.isNumberOrArabic(arg2) || arg2 === "";
    const isArg2PreDefinedOptionName = this._isPreDefinedOptionValid(arg2);
    const isArg2Null = AutoNumericHelper.isNull(arg2);
    const isArg2EmptyString = AutoNumericHelper.isEmptyString(arg2);
    const isArg3Object = AutoNumericHelper.isObject(arg3);
    const isArg3Array = Array.isArray(arg3) && arg3.length > 0;
    const isArg3Null = AutoNumericHelper.isNull(arg3);
    const isArg3PreDefinedOptionName = this._isPreDefinedOptionValid(arg3);
    let domElement;
    let userOptions;
    let initialValue;
    if (isArg1Element && isArg2Null && isArg3Null) {
      domElement = arg1;
      initialValue = null;
      userOptions = null;
    } else if (isArg1Element && isArg2Number && isArg3Null) {
      domElement = arg1;
      initialValue = arg2;
      userOptions = null;
    } else if (isArg1Element && isArg2Object && isArg3Null) {
      domElement = arg1;
      initialValue = null;
      userOptions = arg2;
    } else if (isArg1Element && isArg2PreDefinedOptionName && isArg3Null) {
      domElement = arg1;
      initialValue = null;
      userOptions = this._getOptionObject(arg2);
    } else if (isArg1Element && isArg2Array && isArg3Null) {
      domElement = arg1;
      initialValue = null;
      userOptions = this.mergeOptions(arg2);
    } else if (isArg1Element && (isArg2Null || isArg2EmptyString) && isArg3Object) {
      domElement = arg1;
      initialValue = null;
      userOptions = arg3;
    } else if (isArg1Element && (isArg2Null || isArg2EmptyString) && isArg3Array) {
      domElement = arg1;
      initialValue = null;
      userOptions = this.mergeOptions(arg3);
    } else if (isArg1String && isArg2Null && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = null;
    } else if (isArg1String && isArg2Object && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = arg2;
    } else if (isArg1String && isArg2PreDefinedOptionName && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = this._getOptionObject(arg2);
    } else if (isArg1String && isArg2Array && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = this.mergeOptions(arg2);
    } else if (isArg1String && (isArg2Null || isArg2EmptyString) && isArg3Object) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = arg3;
    } else if (isArg1String && (isArg2Null || isArg2EmptyString) && isArg3Array) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = this.mergeOptions(arg3);
    } else if (isArg1String && isArg2Number && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = arg2;
      userOptions = null;
    } else if (isArg1String && isArg2Number && isArg3Object) {
      domElement = document.querySelector(arg1);
      initialValue = arg2;
      userOptions = arg3;
    } else if (isArg1String && isArg2Number && isArg3PreDefinedOptionName) {
      domElement = document.querySelector(arg1);
      initialValue = arg2;
      userOptions = this._getOptionObject(arg3);
    } else if (isArg1String && isArg2Number && isArg3Array) {
      domElement = document.querySelector(arg1);
      initialValue = arg2;
      userOptions = this.mergeOptions(arg3);
    } else if (isArg1Element && isArg2Number && isArg3Object) {
      domElement = arg1;
      initialValue = arg2;
      userOptions = arg3;
    } else if (isArg1Element && isArg2Number && isArg3PreDefinedOptionName) {
      domElement = arg1;
      initialValue = arg2;
      userOptions = this._getOptionObject(arg3);
    } else if (isArg1Element && isArg2Number && isArg3Array) {
      domElement = arg1;
      initialValue = arg2;
      userOptions = this.mergeOptions(arg3);
    } else {
      AutoNumericHelper.throwError(`The parameters given to the AutoNumeric object are not valid, '${arg1}', '${arg2}' and '${arg3}' given.`);
    }
    if (AutoNumericHelper.isNull(domElement)) {
      AutoNumericHelper.throwError(`The selector '${arg1}' did not select any valid DOM element. Please check on which element you called AutoNumeric.`);
    }
    return { domElement, initialValue, userOptions };
  }
  /**
   * Merge the option objects found in the given array `optionsArray`.
   * If a `string` is found, then we try to get the related pre-defined option using that string as its name.
   * When merging the options, the latest option overwrite any previously set. This allows to fine tune a pre-defined option for instance.
   *
   * @param {Array<object|string>} optionsArray
   * @returns {{}}
   */
  static mergeOptions(optionsArray) {
    const mergedOptions = {};
    optionsArray.forEach((optionObjectOrPredefinedOptionString) => {
      Object.assign(mergedOptions, this._getOptionObject(optionObjectOrPredefinedOptionString));
    });
    return mergedOptions;
  }
  /**
   * Return `true` if the given pre-defined option name is an attribute of the `AutoNumeric.predefinedOptions` object
   *
   * @param {string} preDefinedOptionName
   * @returns {boolean}
   * @private
   */
  static _isPreDefinedOptionValid(preDefinedOptionName) {
    return Object.prototype.hasOwnProperty.call(_AutoNumeric.predefinedOptions, preDefinedOptionName);
  }
  /**
   * Return an option object based on the given parameter.
   * If `optionObjectOrPredefinedName` is as string, then we retrieve the pre-defined option object, if it's an object, we use it as is.
   *
   * @param {object|string} optionObjectOrPredefinedName
   * @returns {object}
   */
  static _getOptionObject(optionObjectOrPredefinedName) {
    let options;
    if (AutoNumericHelper.isString(optionObjectOrPredefinedName)) {
      options = _AutoNumeric.getPredefinedOptions()[optionObjectOrPredefinedName];
      if (options === void 0 || options === null) {
        AutoNumericHelper.warning(`The given pre-defined option [${optionObjectOrPredefinedName}] is not recognized by autoNumeric. Please check that pre-defined option name.`, true);
      }
    } else {
      options = optionObjectOrPredefinedName;
    }
    return options;
  }
  /**
   * Save the initial element values for later use in the pristine test.
   * Those values are :
   * - the html attribute (i.e. <input value='42'>), and
   * - the script `value` (i.e. `let domElement.value`)
   *
   * @param {null|number|string} initialValue
   * @private
   */
  _saveInitialValues(initialValue) {
    this.initialValueHtmlAttribute = AutoNumericHelper.scientificToDecimal(this.domElement.getAttribute("value"));
    if (AutoNumericHelper.isNull(this.initialValueHtmlAttribute)) {
      this.initialValueHtmlAttribute = "";
    }
    this.initialValue = initialValue;
    if (AutoNumericHelper.isNull(this.initialValue)) {
      this.initialValue = "";
    }
  }
  /**
   * Generate all the event listeners for the given DOM element
   * @private
   */
  _createEventListeners() {
    this.formulaMode = false;
    this._onFocusInFunc = (e) => {
      this._onFocusIn(e);
    };
    this._onFocusInAndMouseEnterFunc = (e) => {
      this._onFocusInAndMouseEnter(e);
    };
    this._onFocusFunc = () => {
      this._onFocus();
    };
    this._onKeydownFunc = (e) => {
      this._onKeydown(e);
    };
    this._onKeypressFunc = (e) => {
      this._onKeypress(e);
    };
    this._onKeyupFunc = (e) => {
      this._onKeyup(e);
    };
    this._onFocusOutAndMouseLeaveFunc = (e) => {
      this._onFocusOutAndMouseLeave(e);
    };
    this._onPasteFunc = (e) => {
      this._onPaste(e);
    };
    this._onWheelFunc = (e) => {
      this._onWheel(e);
    };
    this._onDropFunc = (e) => {
      this._onDrop(e);
    };
    this._onKeydownGlobalFunc = (e) => {
      this._onKeydownGlobal(e);
    };
    this._onKeyupGlobalFunc = (e) => {
      this._onKeyupGlobal(e);
    };
    this.domElement.addEventListener("focusin", this._onFocusInFunc, false);
    this.domElement.addEventListener("focus", this._onFocusInAndMouseEnterFunc, false);
    this.domElement.addEventListener("focus", this._onFocusFunc, false);
    this.domElement.addEventListener("mouseenter", this._onFocusInAndMouseEnterFunc, false);
    this.domElement.addEventListener("keydown", this._onKeydownFunc, false);
    this.domElement.addEventListener("keypress", this._onKeypressFunc, false);
    this.domElement.addEventListener("keyup", this._onKeyupFunc, false);
    this.domElement.addEventListener("blur", this._onFocusOutAndMouseLeaveFunc, false);
    this.domElement.addEventListener("mouseleave", this._onFocusOutAndMouseLeaveFunc, false);
    this.domElement.addEventListener("paste", this._onPasteFunc, false);
    this.domElement.addEventListener("wheel", this._onWheelFunc, false);
    this.domElement.addEventListener("drop", this._onDropFunc, false);
    this._setupFormListener();
    this.hasEventListeners = true;
    if (!_AutoNumeric._doesGlobalListExists()) {
      document.addEventListener("keydown", this._onKeydownGlobalFunc, false);
      document.addEventListener("keyup", this._onKeyupGlobalFunc, false);
    }
  }
  /**
   * Remove all the autoNumeric-related event listeners for the given DOM element
   * @private
   */
  _removeEventListeners() {
    this.domElement.removeEventListener("focusin", this._onFocusInFunc, false);
    this.domElement.removeEventListener("focus", this._onFocusInAndMouseEnterFunc, false);
    this.domElement.removeEventListener("focus", this._onFocusFunc, false);
    this.domElement.removeEventListener("mouseenter", this._onFocusInAndMouseEnterFunc, false);
    this.domElement.removeEventListener("blur", this._onFocusOutAndMouseLeaveFunc, false);
    this.domElement.removeEventListener("mouseleave", this._onFocusOutAndMouseLeaveFunc, false);
    this.domElement.removeEventListener("keydown", this._onKeydownFunc, false);
    this.domElement.removeEventListener("keypress", this._onKeypressFunc, false);
    this.domElement.removeEventListener("keyup", this._onKeyupFunc, false);
    this.domElement.removeEventListener("paste", this._onPasteFunc, false);
    this.domElement.removeEventListener("wheel", this._onWheelFunc, false);
    this.domElement.removeEventListener("drop", this._onDropFunc, false);
    this._removeFormListener();
    this.hasEventListeners = false;
    document.removeEventListener("keydown", this._onKeydownGlobalFunc, false);
    document.removeEventListener("keyup", this._onKeyupGlobalFunc, false);
  }
  /**
   * Toggle the event listeners according to the `noEventListeners` option, if those were not activated/deactivated before
   * @private
   */
  _updateEventListeners() {
    if (!this.settings.noEventListeners && !this.hasEventListeners) {
      this._createEventListeners();
    }
    if (this.settings.noEventListeners && this.hasEventListeners) {
      this._removeEventListeners();
    }
  }
  /**
   * Mark the parent <form> so that other AutoNumeric object will not add more listeners.
   * Add a counter so that when removing the AutoNumeric object, we only remove the submit listener if that count is equal to 0.
   * Also keep a reference to the 'submit' event handler function to be able to remove that handler later if the `_removeFormListener()` function is called from another AutoNumeric object.
   *
   * @private
   */
  _setupFormListener() {
    if (!AutoNumericHelper.isNull(this.parentForm)) {
      this._onFormSubmitFunc = () => {
        this._onFormSubmit();
      };
      this._onFormResetFunc = () => {
        this._onFormReset();
      };
      if (this._hasParentFormCounter()) {
        this._incrementParentFormCounter();
      } else {
        this._initializeFormCounterToOne();
        this.parentForm.addEventListener("submit", this._onFormSubmitFunc, false);
        this.parentForm.addEventListener("reset", this._onFormResetFunc, false);
        this._storeFormHandlerFunction();
      }
    }
  }
  /**
   * Remove the form 'submit' event listener, as well as the `dataset` info (`anCount` and `anFormHandler`) from the parent form, only when there are only one AutoNumeric child element left in that <form>.
   * Otherwise, decrement the `anCount`.
   *
   * @private
   */
  _removeFormListener() {
    if (!AutoNumericHelper.isNull(this.parentForm)) {
      const anCount = this._getParentFormCounter();
      if (anCount === 1) {
        this.parentForm.removeEventListener("submit", this._getFormHandlerFunction().submitFn, false);
        this.parentForm.removeEventListener("reset", this._getFormHandlerFunction().resetFn, false);
        this._removeFormDataSetInfo();
      } else if (anCount > 1) {
        this._decrementParentFormCounter();
      } else {
        AutoNumericHelper.throwError(`The AutoNumeric object count on the form is incoherent.`);
      }
    }
  }
  /**
   * Return `true` if the parent form has the form counter attribute
   *
   * @returns {boolean}
   * @private
   */
  _hasParentFormCounter() {
    return "anCount" in this.parentForm.dataset;
  }
  /**
   * Return the count of AutoNumeric form children
   *
   * @returns {number}
   * @private
   */
  _getParentFormCounter() {
    return Number(this.parentForm.dataset.anCount);
  }
  /**
   * Set the count of AutoNumeric form children to 1 for the given form element, or if none are passed, the current `this.parentForm` one.
   *
   * @param {HTMLFormElement|null} formElement
   * @private
   */
  _initializeFormCounterToOne(formElement = null) {
    this._getFormElement(formElement).dataset.anCount = 1;
  }
  /**
   * Increment the AutoNumeric form children count for the given form element, or if none are passed, the current `this.parentForm` one.
   *
   * @param {HTMLFormElement|null} formElement
   * @private
   */
  _incrementParentFormCounter(formElement = null) {
    this._getFormElement(formElement).dataset.anCount++;
  }
  /**
   * Decrement the AutoNumeric form children count for the current `this.parentForm` form element.
   *
   * @private
   */
  _decrementParentFormCounter() {
    this.parentForm.dataset.anCount--;
  }
  /**
   * Return `true` if the global form handler list exists on the `window` object.
   *
   * @returns {boolean}
   * @private
   */
  static _doesFormHandlerListExists() {
    const type = typeof window.aNFormHandlerMap;
    return type !== "undefined" && type === "object";
  }
  /**
   * Create the global form handler list on the `window` object.
   *
   * @private
   */
  static _createFormHandlerList() {
    window.aNFormHandlerMap = /* @__PURE__ */ new Map();
  }
  /**
   * Return `true` if the given form element, or if none are passed, the current `this.parentForm` one has a form handler name.
   *
   * @param {HTMLFormElement|null} formElement
   * @returns {boolean}
   * @private
   */
  _hasFormHandlerFunction(formElement = null) {
    return "anFormHandler" in this._getFormElement(formElement).dataset;
  }
  /**
   * Return the given form element, or defaults to `this.parentForm` if no argument is passed.
   *
   * @param {HTMLFormElement|null} formElement
   * @returns {*}
   * @private
   */
  _getFormElement(formElement = null) {
    let formElementToUse;
    if (!AutoNumericHelper.isNull(formElement)) {
      formElementToUse = formElement;
    } else {
      formElementToUse = this.parentForm;
    }
    return formElementToUse;
  }
  /**
   * Generate a form handler unique name and store it in the global form handler list.
   * This also save that name in the dataset of the given form element.
   *
   * @param {HTMLFormElement|null} formElement
   * @private
   */
  _storeFormHandlerFunction(formElement = null) {
    if (!this.constructor._doesFormHandlerListExists()) {
      this.constructor._createFormHandlerList();
    }
    const formHandlerName = AutoNumericHelper.randomString();
    this._getFormElement(formElement).dataset.anFormHandler = formHandlerName;
    window.aNFormHandlerMap.set(formHandlerName, { submitFn: this._onFormSubmitFunc, resetFn: this._onFormResetFunc });
  }
  /**
   * Return the form handler key name from the parent form element, for the global form handler list.
   *
   * @returns {string|*}
   * @private
   */
  _getFormHandlerKey() {
    if (!this._hasFormHandlerFunction()) {
      AutoNumericHelper.throwError(`Unable to retrieve the form handler name`);
    }
    const formHandlerName = this.parentForm.dataset.anFormHandler;
    if (formHandlerName === "") {
      AutoNumericHelper.throwError(`The form handler name is invalid`);
    }
    return formHandlerName;
  }
  /**
   * Return the 'submit' event handler function used for the parent form.
   *
   * @returns {function}
   * @private
   */
  _getFormHandlerFunction() {
    const formHandlerName = this._getFormHandlerKey();
    return window.aNFormHandlerMap.get(formHandlerName);
  }
  /**
   * Remove the dataset attributes `data-an-count` and `data-an-form-handler` from the parent form element.
   *
   * @private
   */
  _removeFormDataSetInfo() {
    this._decrementParentFormCounter();
    window.aNFormHandlerMap.delete(this._getFormHandlerKey());
    this.parentForm.removeAttribute("data-an-count");
    this.parentForm.removeAttribute("data-an-form-handler");
  }
  /**
   * Set the DOM element write permissions according to the current settings, by setting the `readonly` or `contenteditable` attributes depending on its tag type.
   * If the `useHtmlAttribute` parameter is set to `true`, then the `readonly` html attribute is used and has precedence over the `readOnly` option to set the element as read-only.
   *
   * @param {boolean} useHtmlAttribute If set to `true`, then the write permissions are set by taking into account the html 'readonly' attribute, even if the `readOnly` option is set to false
   * @private
   */
  _setWritePermissions(useHtmlAttribute = false) {
    if (useHtmlAttribute && this.domElement.readOnly || this.settings.readOnly) {
      this._setReadOnly();
    } else {
      this._setReadWrite();
    }
  }
  /**
   * Set the element to be read-only.
   * If the DOM element tag is not an `input`, then it `contenteditable` attribute is set to `false`.
   *
   * @private
   */
  _setReadOnly() {
    if (this.isInputElement) {
      this.domElement.readOnly = true;
    } else {
      this.domElement.setAttribute("contenteditable", false);
    }
  }
  /**
   * Set the element to be read-write.
   *
   * @private
   */
  _setReadWrite() {
    if (this.isInputElement) {
      this.domElement.readOnly = false;
    } else {
      this.domElement.setAttribute("contenteditable", true);
    }
  }
  /**
   * Add a watcher so that any external change to the AutoNumeric-managed element would be detected.
   * As soon as such change is detected, AutoNumeric then tries to `set()` the value so that it gets formatted and stored in the history.
   * //XXX For now, this only works when watching the `value` attribute, not the `textContent` one
   * @private
   */
  _addWatcher() {
    if (!AutoNumericHelper.isUndefined(this.getterSetter)) {
      const { set: setter, get: getter } = this.getterSetter;
      Object.defineProperty(this.domElement, this.attributeToWatch, {
        configurable: true,
        // This is needed in some rare cases
        get: () => getter.call(this.domElement),
        set: (val) => {
          setter.call(this.domElement, val);
          if (this.settings.watchExternalChanges && !this.internalModification) {
            this.set(val);
          }
        }
      });
    }
  }
  /**
   * Remove the watcher on the AutoNumeric-managed element
   * Note: This needs to be called when the AutoNumeric element is 'removed', otherwise the getter/setter stays on the DOM element and that can lead to problem if the user initialize another AutoNumeric object on it.
   * @private
   */
  _removeWatcher() {
    if (!AutoNumericHelper.isUndefined(this.getterSetter)) {
      const { set: setter, get: getter } = this.getterSetter;
      Object.defineProperty(this.domElement, this.attributeToWatch, {
        configurable: true,
        // This is needed in some rare cases
        get: () => getter.call(this.domElement),
        set: (val) => {
          setter.call(this.domElement, val);
        }
      });
    }
  }
  /**
   * Return the name of the object attribute that store the current formatted data in the DOM element.
   *
   * @returns {string}
   * @private
   */
  _getAttributeToWatch() {
    let attributeToWatch;
    if (this.isInputElement) {
      attributeToWatch = "value";
    } else {
      const nodeType = this.domElement.nodeType;
      if (nodeType === Node.ELEMENT_NODE || nodeType === Node.DOCUMENT_NODE || nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        attributeToWatch = "textContent";
      } else if (nodeType === Node.TEXT_NODE) {
        attributeToWatch = "nodeValue";
      }
    }
    return attributeToWatch;
  }
  /**
   * Save the current raw value into the history table, along with the selection information.
   *
   * If the user has done some undos and tries to enter:
   * - a new and different number than the 'next' state, this drops the rest of the history table
   * - the very same number that result in the same rawValue as the 'next' state, we only move the history table pointer to the next state
   *
   * @private
   */
  _historyTableAdd() {
    const isEmptyHistoryTable = this.historyTable.length === 0;
    if (isEmptyHistoryTable || this.rawValue !== this._historyTableCurrentValueUsed()) {
      let addNewHistoryState = true;
      if (!isEmptyHistoryTable) {
        const nextHistoryStateIndex = this.historyTableIndex + 1;
        if (nextHistoryStateIndex < this.historyTable.length && this.rawValue === this.historyTable[nextHistoryStateIndex].value) {
          addNewHistoryState = false;
        } else {
          AutoNumericHelper.arrayTrim(this.historyTable, this.historyTableIndex + 1);
        }
      }
      this.historyTableIndex++;
      if (addNewHistoryState) {
        const selection = AutoNumericHelper.getElementSelection(this.domElement);
        this.selectionStart = selection.start;
        this.selectionEnd = selection.end;
        this.historyTable.push({
          // Save the rawValue and selection start/end
          value: this.rawValue,
          // The selection for this element is temporary, and will be updated when the next history state will be recorded.
          // That way, we are always sure we save the last caret or selection positions just before the value is changed. Otherwise, we would only save those positions when the value is first changed, and would not take into account that the user could move the caret around afterward.
          // For instance, this is needed if the user change the element value, and immediately undo it ; if he then does a redo, he'll see the value and the right selection
          // To sum up; The selection position are not always +1 character, since it could also be '2' if a group separator is added when entering one character. That's why the current history state caret/selection position is updated on each `keyup` event.
          start: this.selectionStart + 1,
          // Here we add one since the user added one character too
          end: this.selectionEnd + 1
        });
        if (this.historyTable.length > 1) {
          this.historyTable[this.historyTableIndex - 1].start = this.selectionStart;
          this.historyTable[this.historyTableIndex - 1].end = this.selectionEnd;
        }
      }
      if (this.historyTable.length > this.settings.historySize) {
        this._historyTableForget();
      }
    }
  }
  /**
   * Debug function for the history table
   * @private
   */
  /*
  _debugHistoryTable() {
      let i = 0;
      let mark;
      this.historyTable.forEach(history => {
          if (this.historyTableIndex === i) {
              mark = '> ';
          } else {
              mark = '';
          }
          console.log(`${mark}${i++}: ${history.value} ${history.start}|${history.end} [onGoingRedo: ${this.onGoingRedo}]`); //DEBUG
      });
  }
  */
  /**
   * 'Undo' or 'Redo' the last/next user entry in the history table.
   * This does not modify the history table, only the pointer to the current state.
   *
   * @param {boolean} undo If set to `true`, then this function does an 'Undo', otherwise it does a 'Redo'
   * @private
   */
  _historyTableUndoOrRedo(undo = true) {
    let check;
    if (undo) {
      check = this.historyTableIndex > 0;
      if (check) {
        this.historyTableIndex--;
      }
    } else {
      check = this.historyTableIndex + 1 < this.historyTable.length;
      if (check) {
        this.historyTableIndex++;
      }
    }
    if (check) {
      const undoInfo = this.historyTable[this.historyTableIndex];
      this.set(undoInfo.value, null, false);
      AutoNumericHelper.setElementSelection(this.domElement, undoInfo.start, undoInfo.end);
    }
  }
  /**
   * 'Undo' the last user entry by going back one entry in the history table.
   * This keeps the following entries in order to allow for a 'redo'.
   * This does not modify the history table, only the pointer to the current state.
   * @private
   */
  _historyTableUndo() {
    this._historyTableUndoOrRedo(true);
  }
  /**
   * 'Redo' the next user entry in the history table.
   * This does not modify the history table, only the pointer to the current state.
   * @private
   */
  _historyTableRedo() {
    this._historyTableUndoOrRedo(false);
  }
  /**
   * Reset the history table to its initial state, and select the value.
   * @private
   */
  /*
  resetHistoryTable() { //FIXME Test this
      this.set(this.rawValue, null, false);
      this.select();
      const selection = AutoNumericHelper.getElementSelection(this.domElement);
      this.historyTableIndex = 0;
      this.historyTable = [{
          // Save the rawValue and selection start/end
          value: this.rawValue,
          start: selection.start,
          end  : selection.end,
      }];
  }
  */
  /**
   * Make the history table forget its first N elements, shifting its indexes in the process.
   * `N` being given as the `numberOfEntriesToForget` parameter.
   *
   * @param {Number} numberOfEntriesToForget
   * @returns {object|Array<object>} The discarded objects, in an Array.
   * @private
   */
  _historyTableForget(numberOfEntriesToForget = 1) {
    const shiftedAway = [];
    for (let i = 0; i < numberOfEntriesToForget; i++) {
      shiftedAway.push(this.historyTable.shift());
      this.historyTableIndex--;
      if (this.historyTableIndex < 0) {
        this.historyTableIndex = 0;
      }
    }
    if (shiftedAway.length === 1) {
      return shiftedAway[0];
    }
    return shiftedAway;
  }
  /**
   * Return the currently used value from the history table.
   *
   * @returns {string|number}
   * @private
   */
  _historyTableCurrentValueUsed() {
    let indexToUse = this.historyTableIndex;
    if (indexToUse < 0) {
      indexToUse = 0;
    }
    let result;
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(this.historyTable[indexToUse])) {
      result = "";
    } else {
      result = this.historyTable[indexToUse].value;
    }
    return result;
  }
  /**
   * Parse the `styleRules` option and run the test for each given rules, either pre-defined ones like `positive`, `negative` and `ranges`, or user defined callbacks within the `userDefined` attribute.
   * @private
   */
  _parseStyleRules() {
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules) || this.rawValue === "") {
      return;
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules.positive)) {
      if (this.rawValue >= 0) {
        this._addCSSClass(this.settings.styleRules.positive);
      } else {
        this._removeCSSClass(this.settings.styleRules.positive);
      }
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules.negative)) {
      if (this.rawValue < 0) {
        this._addCSSClass(this.settings.styleRules.negative);
      } else {
        this._removeCSSClass(this.settings.styleRules.negative);
      }
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules.ranges) && this.settings.styleRules.ranges.length !== 0) {
      this.settings.styleRules.ranges.forEach((range) => {
        if (this.rawValue >= range.min && this.rawValue < range.max) {
          this._addCSSClass(range.class);
        } else {
          this._removeCSSClass(range.class);
        }
      });
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules.userDefined) && this.settings.styleRules.userDefined.length !== 0) {
      this.settings.styleRules.userDefined.forEach((userObject) => {
        if (AutoNumericHelper.isFunction(userObject.callback)) {
          if (AutoNumericHelper.isString(userObject.classes)) {
            if (userObject.callback(this.rawValue)) {
              this._addCSSClass(userObject.classes);
            } else {
              this._removeCSSClass(userObject.classes);
            }
          } else if (AutoNumericHelper.isArray(userObject.classes)) {
            if (userObject.classes.length === 2) {
              if (userObject.callback(this.rawValue)) {
                this._addCSSClass(userObject.classes[0]);
                this._removeCSSClass(userObject.classes[1]);
              } else {
                this._removeCSSClass(userObject.classes[0]);
                this._addCSSClass(userObject.classes[1]);
              }
            } else if (userObject.classes.length > 2) {
              const callbackResult = userObject.callback(this.rawValue);
              if (AutoNumericHelper.isArray(callbackResult)) {
                userObject.classes.forEach((userClass, index) => {
                  if (AutoNumericHelper.isInArray(index, callbackResult)) {
                    this._addCSSClass(userClass);
                  } else {
                    this._removeCSSClass(userClass);
                  }
                });
              } else if (AutoNumericHelper.isInt(callbackResult)) {
                userObject.classes.forEach((userClass, index) => {
                  if (index === callbackResult) {
                    this._addCSSClass(userClass);
                  } else {
                    this._removeCSSClass(userClass);
                  }
                });
              } else if (AutoNumericHelper.isNull(callbackResult)) {
                userObject.classes.forEach((userClass) => {
                  this._removeCSSClass(userClass);
                });
              } else {
                AutoNumericHelper.throwError(`The callback result is not an array nor a valid array index, ${typeof callbackResult} given.`);
              }
            } else {
              AutoNumericHelper.throwError("The classes attribute is not valid for the `styleRules` option.");
            }
          } else if (AutoNumericHelper.isUndefinedOrNullOrEmpty(userObject.classes)) {
            userObject.callback(this);
          } else {
            AutoNumericHelper.throwError("The callback/classes structure is not valid for the `styleRules` option.");
          }
        } else {
          AutoNumericHelper.warning(`The given \`styleRules\` callback is not a function, ${typeof userObject.callback} given.`, this.settings.showWarnings);
        }
      });
    }
  }
  /**
   * Add the given CSS class to the DOM element.
   *
   * @param {string} cssClassName
   * @private
   */
  _addCSSClass(cssClassName) {
    this.domElement.classList.add(cssClassName);
  }
  /**
   * Remove the given CSS class from the DOM element.
   *
   * @param {string} cssClassName
   * @private
   */
  _removeCSSClass(cssClassName) {
    this.domElement.classList.remove(cssClassName);
  }
  // Those are the public function available on each autoNumeric-managed element
  /**
   * Method that updates the AutoNumeric settings, and immediately format the element accordingly.
   * The options passed as parameter(s) is either one or many objects that each contains some settings, i.e. :
   * {
   *     digitGroupSeparator: ".",
   *     decimalCharacter: ",",
   *     currencySymbol: '€ ',
   * }
   * If multiple options are passed, the latter overwrite the previous ones.
   *
   * Note: If the new settings are not validated, or the call to `set()` fails, then the previous valid settings are reverted back to.
   *
   * @example anElement.update({ options }) // Updates the settings
   * @example anElement.update({ options1 }, { options2 }) // Updates the settings with multiple option objects
   * @example anElement.update([{ options1 }, { options2 }]) // Updates the settings with multiple option objects in a single array
   *
   * @param {object|string|array} newOptions
   * @returns {AutoNumeric}
   */
  update(...newOptions) {
    if (Array.isArray(newOptions) && Array.isArray(newOptions[0])) {
      newOptions = newOptions[0];
    }
    const originalSettings = AutoNumericHelper.cloneObject(this.settings);
    const numericString = this.rawValue;
    let optionsToUse = {};
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(newOptions) || newOptions.length === 0) {
      optionsToUse = null;
    } else if (newOptions.length >= 1) {
      newOptions.forEach((optionObject) => {
        if (this.constructor._isPreDefinedOptionValid(optionObject)) {
          optionObject = this.constructor._getOptionObject(optionObject);
        }
        Object.assign(optionsToUse, optionObject);
      });
    }
    try {
      this._setSettings(optionsToUse, true);
      this._setWritePermissions();
      this._updateEventListeners();
      this.set(numericString);
    } catch (error) {
      this._setSettings(originalSettings, true);
      AutoNumericHelper.throwError(`Unable to update the settings, those are invalid: [${error}]`);
      return this;
    }
    return this;
  }
  /**
   * Return the options object containing all the current autoNumeric settings in effect.
   * You can then directly access each option by using its name : `anElement.getSettings().optionNameAutoCompleted`.
   *
   * @example
   * anElement.getSettings()
   * anElement.getSettings().decimalCharacter // Return the decimalCharacter setting as a string - any valid option name can be used
   *
   * @returns {object}
   */
  getSettings() {
    return this.settings;
  }
  /**
   * Set the given element value, and format it immediately.
   * Additionally, this `set()` method can accept options that will be merged into the current AutoNumeric element, taking precedence over any previous settings.
   *
   * @example anElement.set('12345.67') // Formats the value
   * @example anElement.set(12345.67) // Formats the value
   * @example anElement.set(12345.67, { decimalCharacter : ',' }) // Update the settings and formats the value in one go
   * @example anElement.northAmerican().set('$12,345.67') // Set an already formatted value (this does not _exactly_ respect the currency symbol/negative placements, but only remove all non-numbers characters, according to the ones given in the settings)
   * @example anElement.set(null) // Set the rawValue and element value to `null`
   *
   * @param {number|string|null} newValue The value must be a Number, a numeric string or `null` (if `emptyInputBehavior` is set to `'null'`)
   * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history table
   * @returns {AutoNumeric}
   * @throws
   */
  set(newValue, options = null, saveChangeToHistory = true) {
    if (AutoNumericHelper.isUndefined(newValue)) {
      AutoNumericHelper.warning(`You are trying to set an 'undefined' value ; an error could have occurred.`, this.settings.showWarnings);
      return this;
    }
    if (!AutoNumericHelper.isNull(options)) {
      this._setSettings(options, true);
    }
    if (newValue === null && this.settings.emptyInputBehavior !== _AutoNumeric.options.emptyInputBehavior.null) {
      AutoNumericHelper.warning(`You are trying to set the \`null\` value while the \`emptyInputBehavior\` option is set to ${this.settings.emptyInputBehavior}. If you want to be able to set the \`null\` value, you need to change the 'emptyInputBehavior' option to \`'null'\`.`, this.settings.showWarnings);
      return this;
    }
    let value;
    if (newValue === null) {
      this._setElementAndRawValue(null, null, saveChangeToHistory);
      this._saveValueToPersistentStorage();
      return this;
    }
    value = this.constructor._toNumericValue(newValue, this.settings);
    if (isNaN(Number(value))) {
      AutoNumericHelper.warning(`The value you are trying to set results in \`NaN\`. The element value is set to the empty string instead.`, this.settings.showWarnings);
      this.setValue("", saveChangeToHistory);
      return this;
    }
    if (value === "") {
      switch (this.settings.emptyInputBehavior) {
        case _AutoNumeric.options.emptyInputBehavior.zero:
          value = 0;
          break;
        case _AutoNumeric.options.emptyInputBehavior.min:
          value = this.settings.minimumValue;
          break;
        case _AutoNumeric.options.emptyInputBehavior.max:
          value = this.settings.maximumValue;
          break;
        default:
          if (AutoNumericHelper.isNumber(this.settings.emptyInputBehavior)) {
            value = Number(this.settings.emptyInputBehavior);
          }
      }
    }
    if (value !== "") {
      const [minTest, maxTest] = this.constructor._checkIfInRangeWithOverrideOption(value, this.settings);
      if (minTest && maxTest && this.settings.valuesToStrings && this._checkValuesToStrings(value)) {
        this._setElementAndRawValue(this.settings.valuesToStrings[value], value, saveChangeToHistory);
        this._saveValueToPersistentStorage();
        return this;
      }
      const isZero = AutoNumericHelper.isZeroOrHasNoValue(value);
      if (isZero) {
        value = "0";
      }
      if (minTest && maxTest) {
        let forcedRawValue = this.constructor._roundRawValue(value, this.settings);
        forcedRawValue = this._trimLeadingAndTrailingZeros(forcedRawValue.replace(this.settings.decimalCharacter, "."));
        value = this._getRawValueToFormat(value);
        if (this.isFocused) {
          value = this.constructor._roundFormattedValueShownOnFocus(value, this.settings);
        } else {
          if (this.settings.divisorWhenUnfocused) {
            value = value / this.settings.divisorWhenUnfocused;
            value = value.toString();
          }
          value = this.constructor._roundFormattedValueShownOnBlur(value, this.settings);
        }
        value = this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(value, this.settings);
        value = this.constructor._addGroupSeparators(value, this.settings, this.isFocused, this.rawValue, forcedRawValue);
        if (!this.isFocused && this.settings.symbolWhenUnfocused) {
          value = `${value}${this.settings.symbolWhenUnfocused}`;
        }
        if (this.settings.decimalPlacesShownOnFocus || this.settings.divisorWhenUnfocused) {
          this._saveValueToPersistentStorage();
        }
        this._setElementAndRawValue(value, forcedRawValue, saveChangeToHistory);
        this._setValidOrInvalidState(forcedRawValue);
        return this;
      } else {
        this._triggerRangeEvents(minTest, maxTest);
        AutoNumericHelper.throwError(`The value [${value}] being set falls outside of the minimumValue [${this.settings.minimumValue}] and maximumValue [${this.settings.maximumValue}] range set for this element`);
        this._removeValueFromPersistentStorage();
        this.setValue("", saveChangeToHistory);
        return this;
      }
    } else {
      let result;
      if (this.settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.always) {
        result = this.settings.currencySymbol;
      } else {
        result = "";
      }
      this._setElementAndRawValue(result, "", saveChangeToHistory);
      return this;
    }
  }
  /**
   * Set the given value directly as the DOM element value, without formatting it beforehand.
   * You can also set the value and update the setting in one go (the value will again not be formatted immediately).
   *
   * @param {number|string} value
   * @param {object} options
   * @returns {AutoNumeric}
   * @throws
   */
  setUnformatted(value, options = null) {
    if (value === null || AutoNumericHelper.isUndefined(value)) {
      return this;
    }
    if (!AutoNumericHelper.isNull(options)) {
      this._setSettings(options, true);
    }
    const strippedValue = this.constructor._removeBrackets(value, this.settings);
    const normalizedValue = this.constructor._stripAllNonNumberCharacters(strippedValue, this.settings, true, this.isFocused);
    if (!AutoNumericHelper.isNumber(normalizedValue)) {
      AutoNumericHelper.throwError(`The value is not a valid one, it's not a numeric string nor a recognized currency.`);
    }
    if (this.constructor._isWithinRangeWithOverrideOption(normalizedValue, this.settings)) {
      this.setValue(value);
    } else {
      AutoNumericHelper.throwError(`The value is out of the range limits [${this.settings.minimumValue}, ${this.settings.maximumValue}].`);
    }
    return this;
  }
  /**
   * Set the given value directly as the DOM element value, without formatting it beforehand, and without checking its validity.
   * This also updates the `rawValue` with the given `newValue`, without checking it too ; if it's not formatted like a number recognized by Javascript, this *will* likely make other AutoNumeric methods fail.
   *
   * @param {string|number|null} newValue The new value to set on the element
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history array, otherwise it is not
   * @returns {AutoNumeric}
   */
  setValue(newValue, saveChangeToHistory = true) {
    this._setElementAndRawValue(newValue, saveChangeToHistory);
    return this;
  }
  /**
   * Save the raw value inside the AutoNumeric object.
   *
   * @param {number|string|null} rawValue The numeric value as understood by Javascript like a `Number`
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history array, otherwise it is not
   * @private
   */
  _setRawValue(rawValue, saveChangeToHistory = true) {
    if (this.rawValue !== rawValue) {
      const oldRawValue = this.rawValue;
      this.rawValue = rawValue;
      if (!AutoNumericHelper.isNull(this.settings.rawValueDivisor) && this.settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
      rawValue !== "" && rawValue !== null && // Do not modify the `rawValue` if it's an empty string or null
      this._isUserManuallyEditingTheValue()) {
        this.rawValue /= this.settings.rawValueDivisor;
      }
      this._triggerEvent(_AutoNumeric.events.rawValueModified, this.domElement, {
        oldRawValue,
        newRawValue: this.rawValue,
        isPristine: this.isPristine(true),
        error: null,
        aNElement: this
      });
      this._parseStyleRules();
      if (saveChangeToHistory) {
        window.requestAnimationFrame(() => this._historyTableAdd());
      }
    }
  }
  /**
   * Set the given value on the DOM element, without affecting the `rawValue`.
   * This sends an 'autoNumeric:formatted' event if the new value is different from the old one.
   *
   * @param {number|string} newElementValue
   * @param {boolean} sendFormattedEvent If set to `true`, then the `AutoNumeric.events.formatted` event is sent if the value has changed
   * @returns {AutoNumeric}
   * @private
   */
  _setElementValue(newElementValue, sendFormattedEvent = true) {
    const oldElementValue = AutoNumericHelper.getElementValue(this.domElement);
    if (newElementValue !== oldElementValue) {
      this.internalModification = true;
      AutoNumericHelper.setElementValue(this.domElement, newElementValue);
      this.internalModification = false;
      if (sendFormattedEvent) {
        this._triggerEvent(_AutoNumeric.events.formatted, this.domElement, {
          oldValue: oldElementValue,
          newValue: newElementValue,
          oldRawValue: this.rawValue,
          newRawValue: this.rawValue,
          isPristine: this.isPristine(false),
          error: null,
          aNElement: this
        });
      }
    }
    return this;
  }
  /**
   * Set the given value on the DOM element, and the raw value on `this.rawValue`, if both are given.
   * If only one value is given, then both the DOM element value and the raw value are set with that value.
   * The third argument `saveChangeToHistory` defines if the change should be recorded in the history array.
   * Note: if the second argument `rawValue` is a boolean, we consider that is really is the `saveChangeToHistory` argument.
   *
   * @param {number|string|null} newElementValue
   * @param {number|string|null|boolean} rawValue
   * @param {boolean} saveChangeToHistory
   * @returns {AutoNumeric}
   * @private
   */
  _setElementAndRawValue(newElementValue, rawValue = null, saveChangeToHistory = true) {
    if (AutoNumericHelper.isNull(rawValue)) {
      rawValue = newElementValue;
    } else if (AutoNumericHelper.isBoolean(rawValue)) {
      saveChangeToHistory = rawValue;
      rawValue = newElementValue;
    }
    this._setElementValue(newElementValue);
    this._setRawValue(rawValue, saveChangeToHistory);
    return this;
  }
  /**
   * Return the multiplied raw value with the `rawValueDivisor`.
   * This is used to display different values between the raw and formatted values.
   *
   * @param {number|string|null} rawValue The numeric value as understood by Javascript like a `Number`
   * @returns {number|string|null}
   * @private
   */
  _getRawValueToFormat(rawValue) {
    let rawValueForTheElementValue;
    if (!AutoNumericHelper.isNull(this.settings.rawValueDivisor) && this.settings.rawValueDivisor !== 0 && // Only multiply if the `rawValueDivisor` option is set
    rawValue !== "" && rawValue !== null) {
      rawValueForTheElementValue = rawValue * this.settings.rawValueDivisor;
    } else {
      rawValueForTheElementValue = rawValue;
    }
    return rawValueForTheElementValue;
  }
  /**
   * Check if the given value has a corresponding key in the `valuesToStrings` option object.
   *
   * @param {number|string} value
   * @returns {boolean} Returns `true` if such a key is found.
   * @private
   */
  _checkValuesToStrings(value) {
    return this.constructor._checkValuesToStringsArray(value, this.valuesToStringsKeys);
  }
  /**
   * Check if the given value has a corresponding key in the `stringsArray` array.
   *
   * @param {number|string} key
   * @param {array} stringsArray Array where the `key` is checked against its keys
   * @returns {boolean} Returns `true` if such a key is found.
   * @private
   */
  static _checkValuesToStringsArray(key, stringsArray) {
    return AutoNumericHelper.isInArray(String(key), stringsArray);
  }
  /**
   * Static helper for checking if the given `key` is found in the settings' `valuesToStrings` option object.
   *
   * @param {number|string} key
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _checkValuesToStringsSettings(key, settings) {
    return this._checkValuesToStringsArray(key, Object.keys(settings.valuesToStrings));
  }
  /**
   * Static helper for checking if the given `value` is found in the settings' `valuesToStrings` option object.
   *
   * @param {number|string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _checkStringsToValuesSettings(value, settings) {
    return this._checkValuesToStringsArray(value, Object.values(settings.valuesToStrings));
  }
  /**
   * Return `true` if the user is currently modifying the element value manually.
   *
   * @returns {boolean}
   * @private
   */
  _isUserManuallyEditingTheValue() {
    return this.isFocused && this.isEditing || this.isDropEvent;
  }
  /**
   * Execute the given callback function using the given result as its first parameter, and the AutoNumeric object as its second.
   *
   * @param {number|string|Array|null} result
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   * @private
   */
  _executeCallback(result, callback) {
    if (!AutoNumericHelper.isNull(callback) && AutoNumericHelper.isFunction(callback)) {
      callback(result, this);
    }
  }
  /**
   * Trigger the given event on the given element with the given detail.
   * This takes into account the `eventBubbles` and `eventIsCancelable` options.
   *
   * @param {string} eventName
   * @param {HTMLElement|HTMLDocument|EventTarget} element
   * @param {object} detail
   * @private
   */
  _triggerEvent(eventName, element = document, detail = null) {
    AutoNumericHelper.triggerEvent(eventName, element, detail, this.settings.eventBubbles, this.settings.eventIsCancelable);
  }
  /**
   * Alias of the `getNumericString()` function.
   * Developers should use one of the more explicit function names to get what they want :
   * - a numeric string : `getNumericString()`
   * - a formatted string : `getFormatted()`
   * - a number : `getNumber()`, or
   * - a localized numeric string : `getLocalized()`
   *
   * @usage anElement.get();
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @deprecated
   * @returns {string|null}
   */
  get(callback = null) {
    return this.getNumericString(callback);
  }
  /**
   * Return the unformatted value as a string.
   * This can also return `null` if `rawValue` is null.
   *
   * @usage anElement.getNumericString();
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {string|null}
   */
  getNumericString(callback = null) {
    let result;
    if (AutoNumericHelper.isNull(this.rawValue)) {
      result = null;
    } else {
      result = AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(this.rawValue);
    }
    this._executeCallback(result, callback);
    return result;
  }
  /**
   * Return the current formatted value of the AutoNumeric element as a string
   *
   * @usage anElement.getFormatted()
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {string}
   */
  getFormatted(callback = null) {
    if (!("value" in this.domElement || "textContent" in this.domElement)) {
      AutoNumericHelper.throwError("Unable to get the formatted string from the element.");
    }
    const result = AutoNumericHelper.getElementValue(this.domElement);
    this._executeCallback(result, callback);
    return result;
  }
  /**
   * Return the element unformatted value as a real Javascript number.
   * Warning: This can lead to precision problems with big numbers that should be stored as strings.
   *
   * @usage anElement.getNumber()
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {number|null}
   */
  getNumber(callback = null) {
    let result;
    if (this.rawValue === null) {
      result = null;
    } else {
      result = this.constructor._toLocale(this.getNumericString(), "number", this.settings);
    }
    this._executeCallback(result, callback);
    return result;
  }
  /**
   * Returns the unformatted value, but following the `outputFormat` setting, which means the output can either be :
   * - a string (that could or could not represent a number (i.e. "12345,67-")), or
   * - a plain number (if the setting 'number' is used).
   *
   * By default, the returned values are an ISO numeric string "1234.56" or "-1234.56" where the decimal character is a period.
   * Check the "outputFormat" option definition for more details.
   *
   * @usage anElement.getLocalized();
   *
   * @param {null|string|function} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {*}
   */
  getLocalized(forcedOutputFormat = null, callback = null) {
    if (AutoNumericHelper.isFunction(forcedOutputFormat) && AutoNumericHelper.isNull(callback)) {
      callback = forcedOutputFormat;
      forcedOutputFormat = null;
    }
    let value;
    if (AutoNumericHelper.isEmptyString(this.rawValue)) {
      value = "";
    } else {
      value = "" + Number(this.rawValue);
    }
    if (value !== "" && Number(value) === 0 && this.settings.leadingZero !== _AutoNumeric.options.leadingZero.keep) {
      value = "0";
    }
    let outputFormatToUse;
    if (AutoNumericHelper.isNull(forcedOutputFormat)) {
      outputFormatToUse = this.settings.outputFormat;
    } else {
      outputFormatToUse = forcedOutputFormat;
    }
    const result = this.constructor._toLocale(value, outputFormatToUse, this.settings);
    this._executeCallback(result, callback);
    return result;
  }
  /**
   * Force the element to reformat its value again (just in case the formatting has been lost).
   * This can be used right after a form submission for instance (after a previous call to `unformat`).
   *
   * @example anElement.reformat()
   *
   * @returns {AutoNumeric}
   */
  reformat() {
    this.set(this.rawValue);
    return this;
  }
  /**
   * Remove the formatting and keep only the raw unformatted value in the element (as a numericString)
   * Note: this is loosely based on the previous 'unSet()' function
   *
   * By default, values are returned as ISO numeric strings (i.e. "1234.56" or "-1234.56"), where the decimal character is a period.
   * @example anElement.unformat()
   *
   * @returns {AutoNumeric}
   */
  unformat() {
    this._setElementValue(this.getNumericString());
    return this;
  }
  /**
   * Remove the formatting and keep only the localized unformatted value in the element, with the option to override the default outputFormat if needed
   *
   * Locale formats are supported "1234.56-" or "1234,56" or "-1234,56 or "1234,56-", or even plain numbers.
   * Take a look at the `outputFormat` option definition in the default settings for more details.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {AutoNumeric}
   */
  unformatLocalized(forcedOutputFormat = null) {
    this._setElementValue(this.getLocalized(forcedOutputFormat));
    return this;
  }
  /**
   * Return `true` if the current value is the same as when the element got initialized.
   * Note: By default, this returns `true` if the raw unformatted value is still the same even if the formatted one has changed (due to a configuration update for instance).
   * In order to test if the formatted value is the same (which means neither the raw value nor the settings have been changed), then you must pass `false` as its argument.
   *
   * @param {boolean} checkOnlyRawValue If set to `true`, the pristine value is done on the raw unformatted value, not the formatted one.  If set to `false`, this also checks that the formatted value hasn't changed.
   * @returns {boolean}
   */
  isPristine(checkOnlyRawValue = true) {
    let result;
    if (checkOnlyRawValue) {
      result = this.initialValue === this.getNumericString();
    } else {
      result = this.initialValueHtmlAttribute === this.getFormatted();
    }
    return result;
  }
  /**
   * Select the formatted element content, based on the `selectNumberOnly` option
   *
   * @returns {AutoNumeric}
   */
  select() {
    if (this.settings.selectNumberOnly) {
      this.selectNumber();
    } else {
      this._defaultSelectAll();
    }
    return this;
  }
  /**
   * Select the whole element content (including the currency symbol).
   * @private
   */
  _defaultSelectAll() {
    AutoNumericHelper.setElementSelection(this.domElement, 0, AutoNumericHelper.getElementValue(this.domElement).length);
  }
  /**
   * Select only the numbers in the formatted element content, leaving out the currency symbol, whatever the value of the `selectNumberOnly` option
   *
   * @returns {AutoNumeric}
   */
  selectNumber() {
    const unformattedValue = AutoNumericHelper.getElementValue(this.domElement);
    const valueLen = unformattedValue.length;
    const currencySymbolSize = this.settings.currencySymbol.length;
    const currencySymbolPlacement = this.settings.currencySymbolPlacement;
    const negLen = !AutoNumericHelper.isNegative(unformattedValue, this.settings.negativeSignCharacter) ? 0 : 1;
    const suffixTextLen = this.settings.suffixText.length;
    let start;
    if (currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
      start = 0;
    } else if (this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.left && negLen === 1 && currencySymbolSize > 0) {
      start = currencySymbolSize + 1;
    } else {
      start = currencySymbolSize;
    }
    let end;
    if (currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
      end = valueLen - suffixTextLen;
    } else {
      switch (this.settings.negativePositiveSignPlacement) {
        case _AutoNumeric.options.negativePositiveSignPlacement.left:
          end = valueLen - (suffixTextLen + currencySymbolSize);
          break;
        case _AutoNumeric.options.negativePositiveSignPlacement.right:
          if (currencySymbolSize > 0) {
            end = valueLen - (currencySymbolSize + negLen + suffixTextLen);
          } else {
            end = valueLen - (currencySymbolSize + suffixTextLen);
          }
          break;
        default:
          end = valueLen - (currencySymbolSize + suffixTextLen);
      }
    }
    AutoNumericHelper.setElementSelection(this.domElement, start, end);
    return this;
  }
  /**
   * Select only the integer part in the formatted element content, whatever the value of `selectNumberOnly`
   *
   * @returns {AutoNumeric}
   */
  selectInteger() {
    let start = 0;
    const isPositive = this.rawValue >= 0;
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix || this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix && (this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.prefix || this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.none)) {
      if (this.settings.showPositiveSign && isPositive || // This only exclude the positive sign from being selected
      !isPositive && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.left) {
        start = start + 1;
      }
    }
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
      start = start + this.settings.currencySymbol.length;
    }
    const elementValue = AutoNumericHelper.getElementValue(this.domElement);
    let end = elementValue.indexOf(this.settings.decimalCharacter);
    if (end === -1) {
      if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
        end = elementValue.length - this.settings.currencySymbol.length;
      } else {
        end = elementValue.length;
      }
      if (!isPositive && (this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix)) {
        end = end - 1;
      }
      end = end - this.settings.suffixText.length;
    }
    AutoNumericHelper.setElementSelection(this.domElement, start, end);
    return this;
  }
  /**
   * Select only the decimal part in the formatted element content, whatever the value of `selectNumberOnly`
   * Multiple cases are possible :
   * +1.234,57suffixText
   *
   * € +1.234,57suffixText
   * +€ 1.234,57suffixText
   * € 1.234,57+suffixText
   *
   * 1.234,57+ €suffixText
   * 1.234,57 €+suffixText
   * +1.234,57 €suffixText
   *
   * @returns {AutoNumeric}
   */
  selectDecimal() {
    let start = AutoNumericHelper.getElementValue(this.domElement).indexOf(this.settings.decimalCharacter);
    let end;
    if (start === -1) {
      start = 0;
      end = 0;
    } else {
      start = start + 1;
      let decimalCount;
      if (this.isFocused) {
        decimalCount = this.settings.decimalPlacesShownOnFocus;
      } else {
        decimalCount = this.settings.decimalPlacesShownOnBlur;
      }
      end = start + Number(decimalCount);
    }
    AutoNumericHelper.setElementSelection(this.domElement, start, end);
    return this;
  }
  /**
   * Return the DOM element reference of the autoNumeric-managed element
   *
   * @returns {HTMLElement|HTMLInputElement}
   */
  node() {
    return this.domElement;
  }
  /**
   * Return the DOM element reference of the parent node of the autoNumeric-managed element
   *
   * @returns {HTMLElement|HTMLInputElement|Node}
   */
  parent() {
    return this.domElement.parentNode;
  }
  /**
   * Detach the current AutoNumeric element from the shared local 'init' list.
   * This means any changes made on that local shared list will not be transmitted to that element anymore.
   * Note : The user can provide another AutoNumeric element, and detach this one instead of the current one.
   *
   * @param {AutoNumeric} otherAnElement
   * @returns {AutoNumeric}
   */
  detach(otherAnElement = null) {
    let domElementToDetach;
    if (!AutoNumericHelper.isNull(otherAnElement)) {
      domElementToDetach = otherAnElement.node();
    } else {
      domElementToDetach = this.domElement;
    }
    this._removeFromLocalList(domElementToDetach);
    return this;
  }
  /**
   * Attach the given AutoNumeric element to the shared local 'init' list.
   * When doing that, by default the DOM content is left untouched.
   * The user can force a reformat with the new shared list options by passing a second argument to `true`.
   *
   * @param {AutoNumeric} otherAnElement
   * @param {boolean} reFormat
   * @returns {AutoNumeric}
   */
  attach(otherAnElement, reFormat = true) {
    this._addToLocalList(otherAnElement.node());
    if (reFormat) {
      otherAnElement.update(this.settings);
    }
    return this;
  }
  /**
   * Format and return the given value, or set the formatted value into the given DOM element if one is passed as an argument.
   * By default, this use the current element settings.
   * The user can override any option of its choosing by passing an option object.
   *
   * @param {number|HTMLElement|HTMLInputElement} valueOrElement
   * @param {null|object} optionOverride
   * @returns {string|null}
   */
  formatOther(valueOrElement, optionOverride = null) {
    return this._formatOrUnformatOther(true, valueOrElement, optionOverride);
  }
  /**
       * Unformat and return the raw numeric string corresponding to the given value, or directly set the unformatted value into the given DOM element if one is passed as an argument.
       * By default, this use the current element settings.
       * The user can override any option of its choosing by passing an option object.
  
       * @param {string|HTMLElement|HTMLInputElement} stringOrElement
       * @param {null|object} optionOverride
       * @returns {string|null}
       */
  unformatOther(stringOrElement, optionOverride = null) {
    return this._formatOrUnformatOther(false, stringOrElement, optionOverride);
  }
  /**
   * Method that either format or unformat the value of another element.
   *
   * - Format and return the given value, or set the formatted value into the given DOM element if one is passed as an argument.
   * - Unformat and return the raw numeric string corresponding to the given value, or directly set the unformatted value into the given DOM element if one is passed as an argument.
   *
   * By default, this use the current element settings.
   * The user can override any option of its choosing by passing an option object.
   *
   * @param {boolean} isFormatting If set to `true`, then the method formats, otherwise if set to `false`, it unformats
   * @param {number|string|HTMLElement|HTMLInputElement} valueOrStringOrElement
   * @param {null|object} optionOverride
   * @returns {string|null}
   * @private
   */
  _formatOrUnformatOther(isFormatting, valueOrStringOrElement, optionOverride = null) {
    let settingsToUse;
    if (!AutoNumericHelper.isNull(optionOverride)) {
      settingsToUse = this._cloneAndMergeSettings(optionOverride);
    } else {
      settingsToUse = this.settings;
    }
    let result;
    if (AutoNumericHelper.isElement(valueOrStringOrElement)) {
      const elementValue = AutoNumericHelper.getElementValue(valueOrStringOrElement);
      if (isFormatting) {
        result = _AutoNumeric.format(elementValue, settingsToUse);
      } else {
        result = _AutoNumeric.unformat(elementValue, settingsToUse);
      }
      AutoNumericHelper.setElementValue(valueOrStringOrElement, result);
      return null;
    }
    if (isFormatting) {
      result = _AutoNumeric.format(valueOrStringOrElement, settingsToUse);
    } else {
      result = _AutoNumeric.unformat(valueOrStringOrElement, settingsToUse);
    }
    return result;
  }
  /**
   * Use the current AutoNumeric element settings to initialize the DOM element(s) given as a parameter.
   * Doing so will *link* the AutoNumeric elements together since they will share the same local AutoNumeric element list.
   * (cf. prototype pattern : https://en.wikipedia.org/wiki/Prototype_pattern)
   *
   * You can `init` either a single DOM element (in that case an AutoNumeric object will be returned), or an array of DOM elements or a string that will be used as a CSS selector. In the latter cases, an array of AutoNumeric objects will then be returned (or an empty array if nothing gets selected by the CSS selector).
   *
   * Use case : Once you have an AutoNumeric element already setup correctly with the right options, you can use it as many times you want to initialize as many other DOM elements as needed.
   * Note : this works only on elements that can be managed by autoNumeric.
   *
   * @param {HTMLElement|HTMLInputElement|Array<HTMLElement|HTMLInputElement>|string} domElementOrArrayOrString
   * @param {boolean} attached If set to `false`, then the newly generated AutoNumeric element will not share the same local element list
   * @returns {AutoNumeric|[AutoNumeric]}
   */
  init(domElementOrArrayOrString, attached = true) {
    let returnASingleAutoNumericObject = false;
    let domElementsArray = [];
    if (AutoNumericHelper.isString(domElementOrArrayOrString)) {
      domElementsArray = [...document.querySelectorAll(domElementOrArrayOrString)];
    } else if (AutoNumericHelper.isElement(domElementOrArrayOrString)) {
      domElementsArray.push(domElementOrArrayOrString);
      returnASingleAutoNumericObject = true;
    } else if (AutoNumericHelper.isArray(domElementOrArrayOrString)) {
      domElementsArray = domElementOrArrayOrString;
    } else {
      AutoNumericHelper.throwError(`The given parameters to the 'init' function are invalid.`);
    }
    if (domElementsArray.length === 0) {
      AutoNumericHelper.warning(`No valid DOM elements were given hence no AutoNumeric object were instantiated.`, true);
      return [];
    }
    const currentLocalList = this._getLocalList();
    const autoNumericObjectsArray = [];
    domElementsArray.forEach((domElement) => {
      const originalCreateLocalListSetting = this.settings.createLocalList;
      if (attached) {
        this.settings.createLocalList = false;
      }
      const newAutoNumericElement = new _AutoNumeric(domElement, AutoNumericHelper.getElementValue(domElement), this.settings);
      if (attached) {
        newAutoNumericElement._setLocalList(currentLocalList);
        this._addToLocalList(domElement, newAutoNumericElement);
        this.settings.createLocalList = originalCreateLocalListSetting;
      }
      autoNumericObjectsArray.push(newAutoNumericElement);
    });
    if (returnASingleAutoNumericObject) {
      return autoNumericObjectsArray[0];
    }
    return autoNumericObjectsArray;
  }
  /**
   * Reset the element value either to the empty string '', or the currency sign, depending on the `emptyInputBehavior` option value.
   * If you set the `forceClearAll` argument to `true`, then the `emptyInputBehavior` option is overridden and the whole input is clear, including any currency sign.
   *
   * @param {boolean} forceClearAll
   * @returns {AutoNumeric}
   */
  clear(forceClearAll = false) {
    if (forceClearAll) {
      const temporaryForcedOptions = {
        emptyInputBehavior: _AutoNumeric.options.emptyInputBehavior.focus
      };
      this.set("", temporaryForcedOptions);
    } else {
      this.set("");
    }
    return this;
  }
  /**
   * Remove the autoNumeric data and event listeners from the element, but keep the element content intact.
   * This also clears the value from sessionStorage (or cookie, depending on browser supports).
   * Note: this does not remove the formatting.
   *
   * @example anElement.remove()
   */
  remove() {
    this._removeValueFromPersistentStorage();
    this._removeEventListeners();
    this._removeWatcher();
    this._removeFromLocalList(this.domElement);
    this.constructor._removeFromGlobalList(this);
  }
  /**
   * Remove the autoNumeric data and event listeners from the element, and reset its value to the empty string ''.
   * This also clears the value from sessionStorage (or cookie, depending on browser supports).
   *
   * @example anElement.wipe()
   */
  wipe() {
    this._setElementValue("", false);
    this.remove();
  }
  /**
   * Remove the autoNumeric data and event listeners from the element, and delete the DOM element altogether
   */
  nuke() {
    this.remove();
    this.domElement.parentNode.removeChild(this.domElement);
  }
  // Special functions that really work on the parent <form> element, instead of the <input> element itself
  /**
   * Return a reference to the parent <form> element if it exists, otherwise return `null`.
   * If the parent form element as already been found, this directly return a reference to it.
   * However, you can force AutoNumeric to search again for its reference by passing `true` as a parameter to this method.
   * This method updates the `this.parentForm` attribute.
   *
   * In either case, whenever a new parent form is set for the current AutoNumeric element, we make sure to update the anCount and anFormHandler attributes on both the old form and the new one (for instance in case the user moved the input elements with `appendChild()` since AutoNumeric cannot not detect that).
   *
   * @param {boolean} forceSearch If set to `true`, the parent form is searched again, even if `this.parentForm` is already set.
   *
   * @returns {HTMLFormElement|null}
   */
  form(forceSearch = false) {
    if (forceSearch || AutoNumericHelper.isUndefinedOrNullOrEmpty(this.parentForm)) {
      const newParentForm = this._getParentForm();
      if (!AutoNumericHelper.isNull(newParentForm) && newParentForm !== this.parentForm) {
        const oldANChildren = this._getFormAutoNumericChildren(this.parentForm);
        this.parentForm.dataset.anCount = oldANChildren.length;
        if (this._hasFormHandlerFunction(newParentForm)) {
          this._incrementParentFormCounter(newParentForm);
        } else {
          this._storeFormHandlerFunction(newParentForm);
          this._initializeFormCounterToOne(newParentForm);
        }
      }
      this.parentForm = newParentForm;
    }
    return this.parentForm;
  }
  /**
   * Returns an array of the AutoNumeric-managed elements for the given form element is passed, otherwise for the current `this.parentForm` element.
   * This search for <input> elements, as well as contenteditable non-input tag ones. This also search for elements outside the `form` elements.
   *
   * @param {HTMLFormElement|null} formElement
   *
   * @returns {Array.<HTMLInputElement>}
   * @private
   */
  _getFormAutoNumericChildren(formElement) {
    const inputElementsList = [...formElement.elements];
    const nonInputContentEditableElementsList = this._getContenteditableElements(formElement);
    const elementsList = AutoNumericHelper.arrayUnique(inputElementsList, nonInputContentEditableElementsList);
    return elementsList.filter((element) => this.constructor.isManagedByAutoNumeric(element));
  }
  /**
   * Returns an array of the non-input contenteditable elements linked to the given form element.
   * Two types of elements are possible, either located inside the form element, or outside.
   * For the outside elements, this only works if the form element has a defined id and that id is referenced on the non-input element as the `form` attribute.
   * If no elements can be found, then an empty array is returned.
   *
   * @param {HTMLFormElement|null} formElement
   *
   * @returns {Array.<HTMLInputElement>}
   * @private
   */
  _getContenteditableElements(formElement) {
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(formElement) || !formElement.hasAttribute("id")) {
      return [];
    }
    const elementsInside = [...formElement.querySelectorAll("[contenteditable=true]")];
    const elementsOutside = [...document.querySelectorAll(`*:not(input)[form=${formElement.id}][contenteditable=true]`)];
    return AutoNumericHelper.arrayUnique(elementsInside, elementsOutside);
  }
  /**
   * Returns a reference to the parent <form> element if it exists, otherwise return `null`.
   *
   * @returns {HTMLFormElement|null}
   * @private
   */
  _getParentForm() {
    if (!AutoNumericHelper.isUndefined(this.domElement.form))
      return this.domElement.form;
    if (this.domElement.tagName.toLowerCase() === "body") {
      return null;
    }
    let node = this.domElement;
    let tagName;
    do {
      node = node.parentNode;
      if (AutoNumericHelper.isNull(node)) {
        return null;
      }
      if (node.tagName) {
        tagName = node.tagName.toLowerCase();
      } else {
        tagName = "";
      }
      if (tagName === "body") {
        break;
      }
    } while (tagName !== "form");
    if (tagName === "form") {
      return node;
    } else {
      return null;
    }
  }
  /**
   * Return a string in standard URL-encoded notation with the form input values being unformatted.
   * This string can be used as a query for instance.
   *
   * @returns {string}
   */
  formNumericString() {
    return this.constructor._serializeNumericString(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return a string in standard URL-encoded notation with the form input values being formatted.
   *
   * @returns {string}
   */
  formFormatted() {
    return this.constructor._serializeFormatted(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return a string in standard URL-encoded notation with the form input values, with localized values.
   * The default output format can be overridden by passing the option as a parameter.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {string}
   */
  formLocalized(forcedOutputFormat = null) {
    let outputFormatToUse;
    if (AutoNumericHelper.isNull(forcedOutputFormat)) {
      outputFormatToUse = this.settings.outputFormat;
    } else {
      outputFormatToUse = forcedOutputFormat;
    }
    return this.constructor._serializeLocalized(this.form(), this.settings.serializeSpaces, outputFormatToUse);
  }
  /**
   * Return an array containing an object for each form <input> element.
   * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is an unformatted numeric string.
   *
   * @returns {Array}
   */
  formArrayNumericString() {
    return this.constructor._serializeNumericStringArray(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return an array containing an object for each form <input> element.
   * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is the formatted string.
   *
   * @returns {Array}
   */
  formArrayFormatted() {
    return this.constructor._serializeFormattedArray(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return an array containing an object for each form <input> element.
   * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is the localized numeric string.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {Array}
   */
  formArrayLocalized(forcedOutputFormat = null) {
    let outputFormatToUse;
    if (AutoNumericHelper.isNull(forcedOutputFormat)) {
      outputFormatToUse = this.settings.outputFormat;
    } else {
      outputFormatToUse = forcedOutputFormat;
    }
    return this.constructor._serializeLocalizedArray(this.form(), this.settings.serializeSpaces, outputFormatToUse);
  }
  /**
   * Return a JSON string containing an object representing the form input values.
   * This is based on the result of the `formArrayNumericString()` function.
   *
   * @returns {string}
   */
  formJsonNumericString() {
    return JSON.stringify(this.formArrayNumericString());
  }
  /**
   * Return a JSON string containing an object representing the form input values.
   * This is based on the result of the `formArrayFormatted()` function.
   *
   * @returns {string}
   */
  formJsonFormatted() {
    return JSON.stringify(this.formArrayFormatted());
  }
  /**
   * Return a JSON string containing an object representing the form input values.
   * This is based on the result of the `formArrayLocalized()` function.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {string}
   */
  formJsonLocalized(forcedOutputFormat = null) {
    return JSON.stringify(this.formArrayLocalized(forcedOutputFormat));
  }
  /**
   * Unformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element, to numeric strings
   *
   * @returns {AutoNumeric}
   */
  formUnformat() {
    const inputs = this.constructor._getChildANInputElement(this.form());
    inputs.forEach((input) => {
      _AutoNumeric.getAutoNumericElement(input).unformat();
    });
    return this;
  }
  /**
   * Unformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element, to localized strings
   *
   * @returns {AutoNumeric}
   */
  formUnformatLocalized() {
    const inputs = this.constructor._getChildANInputElement(this.form());
    inputs.forEach((input) => {
      _AutoNumeric.getAutoNumericElement(input).unformatLocalized();
    });
    return this;
  }
  /**
   * Reformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element
   *
   * @returns {AutoNumeric}
   */
  formReformat() {
    const inputs = this.constructor._getChildANInputElement(this.form());
    inputs.forEach((input) => {
      _AutoNumeric.getAutoNumericElement(input).reformat();
    });
    return this;
  }
  /**
   * Convert the input values to numeric strings, submit the form, then reformat those back.
   * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
   * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formNumericString()`.
   *
   * @param {function|null} callback
   * @returns {AutoNumeric}
   */
  formSubmitNumericString(callback = null) {
    if (AutoNumericHelper.isNull(callback)) {
      this.formUnformat();
      this.form().submit();
      this.formReformat();
    } else if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formNumericString());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Submit the form with the current formatted values.
   * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
   * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formFormatted()`.
   *
   * @param {function|null} callback
   * @returns {AutoNumeric}
   */
  formSubmitFormatted(callback = null) {
    if (AutoNumericHelper.isNull(callback)) {
      this.form().submit();
    } else if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formFormatted());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Convert the input values to localized strings, submit the form, then reformat those back.
   * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
   * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formLocalized()`.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @param {function|null} callback
   * @returns {AutoNumeric}
   */
  formSubmitLocalized(forcedOutputFormat = null, callback = null) {
    if (AutoNumericHelper.isNull(callback)) {
      this.formUnformatLocalized();
      this.form().submit();
      this.formReformat();
    } else if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formLocalized(forcedOutputFormat));
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate an array of numeric strings from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formArrayNumericString()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitArrayNumericString(callback) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formArrayNumericString());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate an array of the current formatted values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formArrayFormatted()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitArrayFormatted(callback) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formArrayFormatted());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate an array of localized strings from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formArrayLocalized()`.
   *
   * @param {function} callback
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {AutoNumeric}
   */
  formSubmitArrayLocalized(callback, forcedOutputFormat = null) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formArrayLocalized(forcedOutputFormat));
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate a JSON string with the numeric strings values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formJsonNumericString()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitJsonNumericString(callback) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formJsonNumericString());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate a JSON string with the current formatted values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formJsonFormatted()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitJsonFormatted(callback) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formJsonFormatted());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate a JSON string with the localized strings values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formJsonLocalized()`.
   *
   * @param {function} callback
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {AutoNumeric}
   */
  formSubmitJsonLocalized(callback, forcedOutputFormat = null) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formJsonLocalized(forcedOutputFormat));
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Unformat the given AutoNumeric element, and update the `hoveredWithAlt` variable.
   *
   * @param {AutoNumeric} anElement
   * @private
   */
  static _unformatAltHovered(anElement) {
    anElement.hoveredWithAlt = true;
    anElement.unformat();
  }
  /**
   * Reformat the given AutoNumeric element, and update the `hoveredWithAlt` variable.
   *
   * @param {AutoNumeric} anElement
   * @private
   */
  static _reformatAltHovered(anElement) {
    anElement.hoveredWithAlt = false;
    anElement.reformat();
  }
  /**
   * Return an array of autoNumeric elements, child of the <form> element passed as a parameter.
   *
   * @param {HTMLElement} formNode
   * @returns {Array}
   * @private
   */
  static _getChildANInputElement(formNode) {
    const inputList = formNode.getElementsByTagName("input");
    const autoNumericInputs = [];
    const inputElements = Array.prototype.slice.call(inputList, 0);
    inputElements.forEach((input) => {
      if (this.test(input)) {
        autoNumericInputs.push(input);
      }
    });
    return autoNumericInputs;
  }
  // Static methods
  /**
   * Test if the given DOM element, or the element selected by the given selector string is already managed by AutoNumeric (if it has been initialized on the current page).
   *
   * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
   * @returns {boolean}
   */
  static test(domElementOrSelector) {
    return this._isInGlobalList(AutoNumericHelper.domElement(domElementOrSelector));
  }
  /**
   * Create a WeakMap with the given name.
   *
   * @param {string} weakMapName
   * @private
   */
  static _createWeakMap(weakMapName) {
    window[weakMapName] = /* @__PURE__ */ new WeakMap();
  }
  /**
   * Create a list of all the AutoNumeric elements that are initialized on the current page.
   * This is needed in order to determine if a given dom element is already managed by autoNumeric.
   * This uses a WeakMap in order to limit potential garbage collection problems.
   * (cf. my tests on http://codepen.io/AnotherLinuxUser/pen/pRQGaM?editors=1011)
   * @private
   */
  static _createGlobalList() {
    this.autoNumericGlobalListName = "autoNumericGlobalList";
    this._createWeakMap(this.autoNumericGlobalListName);
  }
  /**
   * Return `true` if the global AutoNumeric element list exists.
   *
   * @returns {boolean}
   * @private
   */
  static _doesGlobalListExists() {
    const type = typeof window[this.autoNumericGlobalListName];
    return type !== "undefined" && type === "object";
  }
  /**
   * Add the given object to the global AutoNumeric element list.
   *
   * @param {AutoNumeric} autoNumericObject
   * @private
   */
  static _addToGlobalList(autoNumericObject) {
    if (!this._doesGlobalListExists()) {
      this._createGlobalList();
    }
    const domElement = autoNumericObject.node();
    if (this._isInGlobalList(domElement)) {
      if (this._getFromGlobalList(domElement) === this) {
        return;
      } else {
        AutoNumericHelper.warning(`A reference to the DOM element you just initialized already exists in the global AutoNumeric element list. Please make sure to not initialize the same DOM element multiple times.`, autoNumericObject.getSettings().showWarnings);
      }
    }
    window[this.autoNumericGlobalListName].set(domElement, autoNumericObject);
  }
  /**
   * Remove the given object from the global AutoNumeric element list.
   *
   * @param {AutoNumeric} autoNumericObject
   * @private
   */
  static _removeFromGlobalList(autoNumericObject) {
    if (this._doesGlobalListExists()) {
      window[this.autoNumericGlobalListName].delete(autoNumericObject.node());
    }
  }
  /**
   * Return the value associated to the key `domElement` passed as a parameter.
   * The value is the AutoNumeric object that manages the DOM element `domElement`.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @returns {null|AutoNumeric}
   * @private
   */
  static _getFromGlobalList(domElement) {
    if (this._doesGlobalListExists()) {
      return window[this.autoNumericGlobalListName].get(domElement);
    }
    return null;
  }
  /**
   * Check if the given DOM element is in the global AutoNumeric element list.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @returns {boolean}
   * @private
   */
  static _isInGlobalList(domElement) {
    if (!this._doesGlobalListExists()) {
      return false;
    }
    return window[this.autoNumericGlobalListName].has(domElement);
  }
  /**
   * Create a `Map` that will store all the autoNumeric elements that are initialized from this current element.
   * @private
   */
  _createLocalList() {
    this.autoNumericLocalList = /* @__PURE__ */ new Map();
    this._addToLocalList(this.domElement);
  }
  /**
   * In some rare cases, you could want to delete the local list generated during the element initialization (in order to use another one instead for instance).
   * @private
   */
  _deleteLocalList() {
    delete this.autoNumericLocalList;
  }
  /**
   * Set the local list with the given Map object.
   *
   * @param {Map} localList
   * @private
   */
  _setLocalList(localList) {
    this.autoNumericLocalList = localList;
  }
  /**
   * Return the local list Map object.
   *
   * @returns {*|Map}
   * @private
   */
  _getLocalList() {
    return this.autoNumericLocalList;
  }
  /**
   * Return `true` if the AutoNumeric object has a local list defined already and has at least one element in it (itself usually).
   *
   * @returns {boolean}
   * @private
   */
  _hasLocalList() {
    return this.autoNumericLocalList instanceof Map && this.autoNumericLocalList.size !== 0;
  }
  /**
   * Add the given object to the local autoNumeric element list.
   * Note: in order to keep a coherent list, we only add DOM elements in it, not the autoNumeric object.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @param {AutoNumeric} autoNumericObject A reference to the AutoNumeric object that manage the given DOM element
   * @throws
   * @private
   */
  _addToLocalList(domElement, autoNumericObject = null) {
    if (AutoNumericHelper.isNull(autoNumericObject)) {
      autoNumericObject = this;
    }
    if (!AutoNumericHelper.isUndefined(this.autoNumericLocalList)) {
      this.autoNumericLocalList.set(domElement, autoNumericObject);
    } else {
      AutoNumericHelper.throwError(`The local list provided does not exists when trying to add an element. [${this.autoNumericLocalList}] given.`);
    }
  }
  /**
   * Remove the given object from the local autoNumeric element list.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @private
   */
  _removeFromLocalList(domElement) {
    if (!AutoNumericHelper.isUndefined(this.autoNumericLocalList)) {
      this.autoNumericLocalList.delete(domElement);
    } else if (this.settings.createLocalList) {
      AutoNumericHelper.throwError(`The local list provided does not exists when trying to remove an element. [${this.autoNumericLocalList}] given.`);
    }
  }
  /**
   * Merge the `newSettings` given as parameters into the current element settings.
   *
   * WARNING: Using `Object.assign()` here means the merge is not recursive and only one depth is merged.
   * cf. http://stackoverflow.com/a/39188108/2834898
   * cf. tests on http://codepen.io/AnotherLinuxUser/pen/KaJORq?editors=0011
   *
   * @param {object} newSettings
   * @private
   */
  _mergeSettings(...newSettings) {
    Object.assign(this.settings, ...newSettings);
  }
  /**
   * Return a new object with the current element settings merged with the new settings.
   *
   * @param {object} newSettings
   * @returns {object}
   * @private
   */
  _cloneAndMergeSettings(...newSettings) {
    const result = {};
    Object.assign(result, this.settings, ...newSettings);
    return result;
  }
  /**
   * Validate the given option object.
   * If the options are valid, this function returns nothing, otherwise if the options are invalid, this function throws an error.
   *
   * This tests if the options are not conflicting and are well formatted.
   * This function is lenient since it only tests the settings properties ; it ignores any other properties the options object could have.
   *
   * @param {*} userOptions
   * @param {Boolean} shouldExtendDefaultOptions If `true`, then this function will extend the `userOptions` passed by the user, with the default options.
   * @param {object|null} originalOptions The user can pass the original options (and not the one that are generated from the default settings and the various usability corrections), in order to add compatibility and conflicts checks.
   * @throws Error This throws if the `userOptions` are not valid
   */
  static validate(userOptions, shouldExtendDefaultOptions = true, originalOptions = null) {
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(userOptions) || !AutoNumericHelper.isObject(userOptions)) {
      AutoNumericHelper.throwError(`The userOptions are invalid ; it should be a valid object, [${userOptions}] given.`);
    }
    const isOriginalOptionAnObject = AutoNumericHelper.isObject(originalOptions);
    if (!isOriginalOptionAnObject && !AutoNumericHelper.isNull(originalOptions)) {
      AutoNumericHelper.throwError(`The 'originalOptions' parameter is invalid ; it should either be a valid option object or \`null\`, [${userOptions}] given.`);
    }
    if (!AutoNumericHelper.isNull(userOptions)) {
      this._convertOldOptionsToNewOnes(userOptions);
    }
    let options;
    if (shouldExtendDefaultOptions) {
      options = Object.assign({}, this.getDefaultConfig(), userOptions);
    } else {
      options = userOptions;
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.showWarnings) && !AutoNumericHelper.isBoolean(options.showWarnings)) {
      AutoNumericHelper.throwError(`The debug option 'showWarnings' is invalid ; it should be either 'true' or 'false', [${options.showWarnings}] given.`);
    }
    const testPositiveInteger = /^[0-9]+$/;
    const testNumericalCharacters = /[0-9]+/;
    const testFloatOrIntegerAndPossibleNegativeSign = /^-?[0-9]+(\.?[0-9]+)?$/;
    const testPositiveFloatOrInteger = /^[0-9]+(\.?[0-9]+)?$/;
    if (!AutoNumericHelper.isTrueOrFalseString(options.allowDecimalPadding) && !AutoNumericHelper.isBoolean(options.allowDecimalPadding) && options.allowDecimalPadding !== _AutoNumeric.options.allowDecimalPadding.floats && !(AutoNumericHelper.isNumber(options.allowDecimalPadding) && options.allowDecimalPadding > 0)) {
      AutoNumericHelper.throwError(`The decimal padding option 'allowDecimalPadding' is invalid ; it should either be \`false\`, \`true\`, \`'floats'\` or a positive integer superior to 0, [${options.allowDecimalPadding}] given.`);
    }
    if (AutoNumericHelper.isNumber(options.allowDecimalPadding) && options.allowDecimalPadding > options.decimalPlaces) {
      AutoNumericHelper.warning(`Setting 'allowDecimalPadding' to a number [${options.allowDecimalPadding}] superior to the current 'decimalPlaces' settings [${options.decimalPlaces}] is useless, since the padding will not be shown.`, options.showWarnings);
    }
    if ((options.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.never || options.allowDecimalPadding === "false") && (options.decimalPlaces !== _AutoNumeric.options.decimalPlaces.none || options.decimalPlacesShownOnBlur !== _AutoNumeric.options.decimalPlacesShownOnBlur.none || options.decimalPlacesShownOnFocus !== _AutoNumeric.options.decimalPlacesShownOnFocus.none)) {
      AutoNumericHelper.warning(`Setting 'allowDecimalPadding' to [${options.allowDecimalPadding}] will override the current 'decimalPlaces*' settings [${options.decimalPlaces}, ${options.decimalPlacesShownOnBlur} and ${options.decimalPlacesShownOnFocus}].`, options.showWarnings);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.alwaysAllowDecimalCharacter) && !AutoNumericHelper.isBoolean(options.alwaysAllowDecimalCharacter)) {
      AutoNumericHelper.throwError(`The option 'alwaysAllowDecimalCharacter' is invalid ; it should either be \`true\` or \`false\`, [${options.alwaysAllowDecimalCharacter}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.caretPositionOnFocus) && !AutoNumericHelper.isInArray(options.caretPositionOnFocus, [
      _AutoNumeric.options.caretPositionOnFocus.start,
      _AutoNumeric.options.caretPositionOnFocus.end,
      _AutoNumeric.options.caretPositionOnFocus.decimalLeft,
      _AutoNumeric.options.caretPositionOnFocus.decimalRight
    ])) {
      AutoNumericHelper.throwError(`The display on empty string option 'caretPositionOnFocus' is invalid ; it should either be \`null\`, 'focus', 'press', 'always' or 'zero', [${options.caretPositionOnFocus}] given.`);
    }
    let optionsToUse;
    if (isOriginalOptionAnObject) {
      optionsToUse = originalOptions;
    } else {
      optionsToUse = this._correctCaretPositionOnFocusAndSelectOnFocusOptions(userOptions);
    }
    if (!AutoNumericHelper.isNull(optionsToUse) && (optionsToUse.caretPositionOnFocus !== _AutoNumeric.options.caretPositionOnFocus.doNoForceCaretPosition && optionsToUse.selectOnFocus === _AutoNumeric.options.selectOnFocus.select)) {
      AutoNumericHelper.warning(`The 'selectOnFocus' option is set to 'select', which is in conflict with the 'caretPositionOnFocus' which is set to '${optionsToUse.caretPositionOnFocus}'. As a result, if this has been called when instantiating an AutoNumeric object, the 'selectOnFocus' option is forced to 'doNotSelect'.`, options.showWarnings);
    }
    if (!AutoNumericHelper.isInArray(options.digitGroupSeparator, [
      _AutoNumeric.options.digitGroupSeparator.comma,
      _AutoNumeric.options.digitGroupSeparator.dot,
      _AutoNumeric.options.digitGroupSeparator.normalSpace,
      _AutoNumeric.options.digitGroupSeparator.thinSpace,
      _AutoNumeric.options.digitGroupSeparator.narrowNoBreakSpace,
      _AutoNumeric.options.digitGroupSeparator.noBreakSpace,
      _AutoNumeric.options.digitGroupSeparator.noSeparator,
      _AutoNumeric.options.digitGroupSeparator.apostrophe,
      _AutoNumeric.options.digitGroupSeparator.arabicThousandsSeparator,
      _AutoNumeric.options.digitGroupSeparator.dotAbove,
      _AutoNumeric.options.digitGroupSeparator.privateUseTwo
    ])) {
      AutoNumericHelper.throwError(`The thousand separator character option 'digitGroupSeparator' is invalid ; it should be ',', '.', '\u066C', '\u02D9', "'", '\x92', ' ', '\u2009', '\u202F', '\xA0' or empty (''), [${options.digitGroupSeparator}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.showOnlyNumbersOnFocus) && !AutoNumericHelper.isBoolean(options.showOnlyNumbersOnFocus)) {
      AutoNumericHelper.throwError(`The 'showOnlyNumbersOnFocus' option is invalid ; it should be either 'true' or 'false', [${options.showOnlyNumbersOnFocus}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.digitalGroupSpacing, [
      _AutoNumeric.options.digitalGroupSpacing.two,
      _AutoNumeric.options.digitalGroupSpacing.twoThree,
      _AutoNumeric.options.digitalGroupSpacing.twoScaled,
      _AutoNumeric.options.digitalGroupSpacing.three,
      _AutoNumeric.options.digitalGroupSpacing.four
    ]) && !(options.digitalGroupSpacing >= 2 && options.digitalGroupSpacing <= 4)) {
      AutoNumericHelper.throwError(`The grouping separator option for thousands 'digitalGroupSpacing' is invalid ; it should be '2', '2t', '2s', '3', or '4', [${options.digitalGroupSpacing}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.decimalCharacter, [
      _AutoNumeric.options.decimalCharacter.comma,
      _AutoNumeric.options.decimalCharacter.dot,
      _AutoNumeric.options.decimalCharacter.middleDot,
      _AutoNumeric.options.decimalCharacter.arabicDecimalSeparator,
      _AutoNumeric.options.decimalCharacter.decimalSeparatorKeySymbol
    ])) {
      AutoNumericHelper.throwError(`The decimal separator character option 'decimalCharacter' is invalid ; it should be '.', ',', '\xB7', '\u2396' or '\u066B', [${options.decimalCharacter}] given.`);
    }
    if (options.decimalCharacter === options.digitGroupSeparator) {
      AutoNumericHelper.throwError(`autoNumeric will not function properly when the decimal character 'decimalCharacter' [${options.decimalCharacter}] and the thousand separator 'digitGroupSeparator' [${options.digitGroupSeparator}] are the same character.`);
    }
    if (!AutoNumericHelper.isNull(options.decimalCharacterAlternative) && !AutoNumericHelper.isString(options.decimalCharacterAlternative)) {
      AutoNumericHelper.throwError(`The alternate decimal separator character option 'decimalCharacterAlternative' is invalid ; it should be a string, [${options.decimalCharacterAlternative}] given.`);
    }
    if (options.currencySymbol !== "" && !AutoNumericHelper.isString(options.currencySymbol)) {
      AutoNumericHelper.throwError(`The currency symbol option 'currencySymbol' is invalid ; it should be a string, [${options.currencySymbol}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.currencySymbolPlacement, [
      _AutoNumeric.options.currencySymbolPlacement.prefix,
      _AutoNumeric.options.currencySymbolPlacement.suffix
    ])) {
      AutoNumericHelper.throwError(`The placement of the currency sign option 'currencySymbolPlacement' is invalid ; it should either be 'p' (prefix) or 's' (suffix), [${options.currencySymbolPlacement}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.negativePositiveSignPlacement, [
      _AutoNumeric.options.negativePositiveSignPlacement.prefix,
      _AutoNumeric.options.negativePositiveSignPlacement.suffix,
      _AutoNumeric.options.negativePositiveSignPlacement.left,
      _AutoNumeric.options.negativePositiveSignPlacement.right,
      _AutoNumeric.options.negativePositiveSignPlacement.none
    ])) {
      AutoNumericHelper.throwError(`The placement of the negative sign option 'negativePositiveSignPlacement' is invalid ; it should either be 'p' (prefix), 's' (suffix), 'l' (left), 'r' (right) or 'null', [${options.negativePositiveSignPlacement}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.showPositiveSign) && !AutoNumericHelper.isBoolean(options.showPositiveSign)) {
      AutoNumericHelper.throwError(`The show positive sign option 'showPositiveSign' is invalid ; it should be either 'true' or 'false', [${options.showPositiveSign}] given.`);
    }
    if (!AutoNumericHelper.isString(options.suffixText) || options.suffixText !== "" && (AutoNumericHelper.isNegative(options.suffixText, options.negativeSignCharacter) || testNumericalCharacters.test(options.suffixText))) {
      AutoNumericHelper.throwError(`The additional suffix option 'suffixText' is invalid ; it should not contains the negative sign '${options.negativeSignCharacter}' nor any numerical characters, [${options.suffixText}] given.`);
    }
    if (!AutoNumericHelper.isString(options.negativeSignCharacter) || options.negativeSignCharacter.length !== 1 || AutoNumericHelper.isUndefinedOrNullOrEmpty(options.negativeSignCharacter) || testNumericalCharacters.test(options.negativeSignCharacter)) {
      AutoNumericHelper.throwError(`The negative sign character option 'negativeSignCharacter' is invalid ; it should be a single character, and cannot be any numerical characters, [${options.negativeSignCharacter}] given.`);
    }
    if (!AutoNumericHelper.isString(options.positiveSignCharacter) || options.positiveSignCharacter.length !== 1 || AutoNumericHelper.isUndefinedOrNullOrEmpty(options.positiveSignCharacter) || testNumericalCharacters.test(options.positiveSignCharacter)) {
      AutoNumericHelper.throwError(`The positive sign character option 'positiveSignCharacter' is invalid ; it should be a single character, and cannot be any numerical characters, [${options.positiveSignCharacter}] given.
If you want to show the positive sign character, you need to set the \`showPositiveSign\` option to \`true\`.`);
    }
    if (options.negativeSignCharacter === options.positiveSignCharacter) {
      AutoNumericHelper.throwError(`The positive 'positiveSignCharacter' and negative 'negativeSignCharacter' sign characters cannot be identical ; [${options.negativeSignCharacter}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.negativePositiveSignBehavior) && !AutoNumericHelper.isBoolean(options.negativePositiveSignBehavior)) {
      AutoNumericHelper.throwError(`The option 'negativePositiveSignBehavior' is invalid ; it should be either 'true' or 'false', [${options.negativePositiveSignBehavior}] given.`);
    }
    const [leftBracket, rightBracket] = AutoNumericHelper.isNull(options.negativeBracketsTypeOnBlur) ? ["", ""] : options.negativeBracketsTypeOnBlur.split(",");
    if (AutoNumericHelper.contains(options.digitGroupSeparator, options.negativeSignCharacter) || AutoNumericHelper.contains(options.decimalCharacter, options.negativeSignCharacter) || AutoNumericHelper.contains(options.decimalCharacterAlternative, options.negativeSignCharacter) || AutoNumericHelper.contains(leftBracket, options.negativeSignCharacter) || AutoNumericHelper.contains(rightBracket, options.negativeSignCharacter) || AutoNumericHelper.contains(options.suffixText, options.negativeSignCharacter)) {
      AutoNumericHelper.throwError(`The negative sign character option 'negativeSignCharacter' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [${options.negativeSignCharacter}] given.`);
    }
    if (AutoNumericHelper.contains(options.digitGroupSeparator, options.positiveSignCharacter) || AutoNumericHelper.contains(options.decimalCharacter, options.positiveSignCharacter) || AutoNumericHelper.contains(options.decimalCharacterAlternative, options.positiveSignCharacter) || AutoNumericHelper.contains(leftBracket, options.positiveSignCharacter) || AutoNumericHelper.contains(rightBracket, options.positiveSignCharacter) || AutoNumericHelper.contains(options.suffixText, options.positiveSignCharacter)) {
      AutoNumericHelper.throwError(`The positive sign character option 'positiveSignCharacter' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [${options.positiveSignCharacter}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.overrideMinMaxLimits) && !AutoNumericHelper.isInArray(options.overrideMinMaxLimits, [
      _AutoNumeric.options.overrideMinMaxLimits.ceiling,
      _AutoNumeric.options.overrideMinMaxLimits.floor,
      _AutoNumeric.options.overrideMinMaxLimits.ignore,
      _AutoNumeric.options.overrideMinMaxLimits.invalid
    ])) {
      AutoNumericHelper.throwError(`The override min & max limits option 'overrideMinMaxLimits' is invalid ; it should either be 'ceiling', 'floor', 'ignore' or 'invalid', [${options.overrideMinMaxLimits}] given.`);
    }
    if (options.overrideMinMaxLimits !== _AutoNumeric.options.overrideMinMaxLimits.invalid && options.overrideMinMaxLimits !== _AutoNumeric.options.overrideMinMaxLimits.ignore && (options.minimumValue > 0 || options.maximumValue < 0)) {
      AutoNumericHelper.warning(`You've set a \`minimumValue\` or a \`maximumValue\` excluding the value \`0\`. AutoNumeric will force the users to always have a valid value in the input, hence preventing them to clear the field. If you want to allow for temporary invalid values (i.e. out-of-range), you should use the 'invalid' option for the 'overrideMinMaxLimits' setting.`);
    }
    if (!AutoNumericHelper.isString(options.maximumValue) || !testFloatOrIntegerAndPossibleNegativeSign.test(options.maximumValue)) {
      AutoNumericHelper.throwError(`The maximum possible value option 'maximumValue' is invalid ; it should be a string that represents a positive or negative number, [${options.maximumValue}] given.`);
    }
    if (!AutoNumericHelper.isString(options.minimumValue) || !testFloatOrIntegerAndPossibleNegativeSign.test(options.minimumValue)) {
      AutoNumericHelper.throwError(`The minimum possible value option 'minimumValue' is invalid ; it should be a string that represents a positive or negative number, [${options.minimumValue}] given.`);
    }
    if (parseFloat(options.minimumValue) > parseFloat(options.maximumValue)) {
      AutoNumericHelper.throwError(`The minimum possible value option is greater than the maximum possible value option ; 'minimumValue' [${options.minimumValue}] should be smaller than 'maximumValue' [${options.maximumValue}].`);
    }
    if (!(AutoNumericHelper.isInt(options.decimalPlaces) && options.decimalPlaces >= 0 || // If integer option
    AutoNumericHelper.isString(options.decimalPlaces) && testPositiveInteger.test(options.decimalPlaces))) {
      AutoNumericHelper.throwError(`The number of decimal places option 'decimalPlaces' is invalid ; it should be a positive integer, [${options.decimalPlaces}] given.`);
    }
    if (!(AutoNumericHelper.isNull(options.decimalPlacesRawValue) || AutoNumericHelper.isInt(options.decimalPlacesRawValue) && options.decimalPlacesRawValue >= 0 || // If integer option
    AutoNumericHelper.isString(options.decimalPlacesRawValue) && testPositiveInteger.test(options.decimalPlacesRawValue))) {
      AutoNumericHelper.throwError(`The number of decimal places for the raw value option 'decimalPlacesRawValue' is invalid ; it should be a positive integer or \`null\`, [${options.decimalPlacesRawValue}] given.`);
    }
    this._validateDecimalPlacesRawValue(options);
    if (!AutoNumericHelper.isNull(options.decimalPlacesShownOnFocus) && !testPositiveInteger.test(String(options.decimalPlacesShownOnFocus))) {
      AutoNumericHelper.throwError(`The number of expanded decimal places option 'decimalPlacesShownOnFocus' is invalid ; it should be a positive integer or \`null\`, [${options.decimalPlacesShownOnFocus}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.decimalPlacesShownOnFocus) && Number(options.decimalPlaces) > Number(options.decimalPlacesShownOnFocus)) {
      AutoNumericHelper.warning(`The extended decimal places 'decimalPlacesShownOnFocus' [${options.decimalPlacesShownOnFocus}] should be greater than the 'decimalPlaces' [${options.decimalPlaces}] value. Currently, this will limit the ability of your user to manually change some of the decimal places. Do you really want to do that?`, options.showWarnings);
    }
    if (!AutoNumericHelper.isNull(options.divisorWhenUnfocused) && !testPositiveFloatOrInteger.test(options.divisorWhenUnfocused) || options.divisorWhenUnfocused === 0 || options.divisorWhenUnfocused === "0" || options.divisorWhenUnfocused === 1 || options.divisorWhenUnfocused === "1") {
      AutoNumericHelper.throwError(`The divisor option 'divisorWhenUnfocused' is invalid ; it should be a positive number higher than one, preferably an integer, [${options.divisorWhenUnfocused}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.decimalPlacesShownOnBlur) && !testPositiveInteger.test(options.decimalPlacesShownOnBlur)) {
      AutoNumericHelper.throwError(`The number of decimals shown when unfocused option 'decimalPlacesShownOnBlur' is invalid ; it should be a positive integer or \`null\`, [${options.decimalPlacesShownOnBlur}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.symbolWhenUnfocused) && !AutoNumericHelper.isString(options.symbolWhenUnfocused)) {
      AutoNumericHelper.throwError(`The symbol to show when unfocused option 'symbolWhenUnfocused' is invalid ; it should be a string, [${options.symbolWhenUnfocused}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.saveValueToSessionStorage) && !AutoNumericHelper.isBoolean(options.saveValueToSessionStorage)) {
      AutoNumericHelper.throwError(`The save to session storage option 'saveValueToSessionStorage' is invalid ; it should be either 'true' or 'false', [${options.saveValueToSessionStorage}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.onInvalidPaste, [
      _AutoNumeric.options.onInvalidPaste.error,
      _AutoNumeric.options.onInvalidPaste.ignore,
      _AutoNumeric.options.onInvalidPaste.clamp,
      _AutoNumeric.options.onInvalidPaste.truncate,
      _AutoNumeric.options.onInvalidPaste.replace
    ])) {
      AutoNumericHelper.throwError(`The paste behavior option 'onInvalidPaste' is invalid ; it should either be 'error', 'ignore', 'clamp', 'truncate' or 'replace' (cf. documentation), [${options.onInvalidPaste}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.roundingMethod, [
      _AutoNumeric.options.roundingMethod.halfUpSymmetric,
      _AutoNumeric.options.roundingMethod.halfUpAsymmetric,
      _AutoNumeric.options.roundingMethod.halfDownSymmetric,
      _AutoNumeric.options.roundingMethod.halfDownAsymmetric,
      _AutoNumeric.options.roundingMethod.halfEvenBankersRounding,
      _AutoNumeric.options.roundingMethod.upRoundAwayFromZero,
      _AutoNumeric.options.roundingMethod.downRoundTowardZero,
      _AutoNumeric.options.roundingMethod.toCeilingTowardPositiveInfinity,
      _AutoNumeric.options.roundingMethod.toFloorTowardNegativeInfinity,
      _AutoNumeric.options.roundingMethod.toNearest05,
      _AutoNumeric.options.roundingMethod.toNearest05Alt,
      _AutoNumeric.options.roundingMethod.upToNext05,
      _AutoNumeric.options.roundingMethod.downToNext05
    ])) {
      AutoNumericHelper.throwError(`The rounding method option 'roundingMethod' is invalid ; it should either be 'S', 'A', 's', 'a', 'B', 'U', 'D', 'C', 'F', 'N05', 'CHF', 'U05' or 'D05' (cf. documentation), [${options.roundingMethod}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.negativeBracketsTypeOnBlur) && !AutoNumericHelper.isInArray(options.negativeBracketsTypeOnBlur, [
      _AutoNumeric.options.negativeBracketsTypeOnBlur.parentheses,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.brackets,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.chevrons,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.curlyBraces,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.angleBrackets,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.japaneseQuotationMarks,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.halfBrackets,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.whiteSquareBrackets,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.quotationMarks,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.guillemets
    ])) {
      AutoNumericHelper.throwError(`The brackets for negative values option 'negativeBracketsTypeOnBlur' is invalid ; it should either be '(,)', '[,]', '<,>', '{,}', '\u3008,\u3009', '\uFF62,\uFF63', '\u2E24,\u2E25', '\u27E6,\u27E7', '\u2039,\u203A' or '\xAB,\xBB', [${options.negativeBracketsTypeOnBlur}] given.`);
    }
    if (!(AutoNumericHelper.isString(options.emptyInputBehavior) || AutoNumericHelper.isNumber(options.emptyInputBehavior)) || !(AutoNumericHelper.isInArray(options.emptyInputBehavior, [
      _AutoNumeric.options.emptyInputBehavior.focus,
      _AutoNumeric.options.emptyInputBehavior.press,
      _AutoNumeric.options.emptyInputBehavior.always,
      _AutoNumeric.options.emptyInputBehavior.min,
      _AutoNumeric.options.emptyInputBehavior.max,
      _AutoNumeric.options.emptyInputBehavior.zero,
      _AutoNumeric.options.emptyInputBehavior.null
    ]) || testFloatOrIntegerAndPossibleNegativeSign.test(options.emptyInputBehavior))) {
      AutoNumericHelper.throwError(`The display on empty string option 'emptyInputBehavior' is invalid ; it should either be 'focus', 'press', 'always', 'min', 'max', 'zero', 'null', a number, or a string that represents a number, [${options.emptyInputBehavior}] given.`);
    }
    if (options.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.zero && (options.minimumValue > 0 || options.maximumValue < 0)) {
      AutoNumericHelper.throwError(`The 'emptyInputBehavior' option is set to 'zero', but this value is outside of the range defined by 'minimumValue' and 'maximumValue' [${options.minimumValue}, ${options.maximumValue}].`);
    }
    if (testFloatOrIntegerAndPossibleNegativeSign.test(String(options.emptyInputBehavior))) {
      if (!this._isWithinRangeWithOverrideOption(options.emptyInputBehavior, options)) {
        AutoNumericHelper.throwError(`The 'emptyInputBehavior' option is set to a number or a string that represents a number, but its value [${options.emptyInputBehavior}] is outside of the range defined by the 'minimumValue' and 'maximumValue' options [${options.minimumValue}, ${options.maximumValue}].`);
      }
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.eventBubbles) && !AutoNumericHelper.isBoolean(options.eventBubbles)) {
      AutoNumericHelper.throwError(`The event bubbles option 'eventBubbles' is invalid ; it should be either 'true' or 'false', [${options.eventBubbles}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.eventIsCancelable) && !AutoNumericHelper.isBoolean(options.eventIsCancelable)) {
      AutoNumericHelper.throwError(`The event is cancelable option 'eventIsCancelable' is invalid ; it should be either 'true' or 'false', [${options.eventIsCancelable}] given.`);
    }
    if (AutoNumericHelper.isBoolean(options.invalidClass) || !/^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$/.test(options.invalidClass)) {
      AutoNumericHelper.throwError(`The name of the 'invalidClass' option is not a valid CSS class name ; it should not be empty, and should follow the '^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$' regex, [${options.invalidClass}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.leadingZero, [
      _AutoNumeric.options.leadingZero.allow,
      _AutoNumeric.options.leadingZero.deny,
      _AutoNumeric.options.leadingZero.keep
    ])) {
      AutoNumericHelper.throwError(`The leading zero behavior option 'leadingZero' is invalid ; it should either be 'allow', 'deny' or 'keep', [${options.leadingZero}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.formatOnPageLoad) && !AutoNumericHelper.isBoolean(options.formatOnPageLoad)) {
      AutoNumericHelper.throwError(`The format on initialization option 'formatOnPageLoad' is invalid ; it should be either 'true' or 'false', [${options.formatOnPageLoad}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.formulaMode) && !AutoNumericHelper.isBoolean(options.formulaMode)) {
      AutoNumericHelper.throwError(`The formula mode option 'formulaMode' is invalid ; it should be either 'true' or 'false', [${options.formulaMode}] given.`);
    }
    if (!testPositiveInteger.test(options.historySize) || options.historySize === 0) {
      AutoNumericHelper.throwError(`The history size option 'historySize' is invalid ; it should be a positive integer, [${options.historySize}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.selectNumberOnly) && !AutoNumericHelper.isBoolean(options.selectNumberOnly)) {
      AutoNumericHelper.throwError(`The select number only option 'selectNumberOnly' is invalid ; it should be either 'true' or 'false', [${options.selectNumberOnly}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.selectOnFocus) && !AutoNumericHelper.isBoolean(options.selectOnFocus)) {
      AutoNumericHelper.throwError(`The select on focus option 'selectOnFocus' is invalid ; it should be either 'true' or 'false', [${options.selectOnFocus}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.defaultValueOverride) && (options.defaultValueOverride !== "" && !testFloatOrIntegerAndPossibleNegativeSign.test(options.defaultValueOverride))) {
      AutoNumericHelper.throwError(`The unformatted default value option 'defaultValueOverride' is invalid ; it should be a string that represents a positive or negative number, [${options.defaultValueOverride}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.unformatOnSubmit) && !AutoNumericHelper.isBoolean(options.unformatOnSubmit)) {
      AutoNumericHelper.throwError(`The remove formatting on submit option 'unformatOnSubmit' is invalid ; it should be either 'true' or 'false', [${options.unformatOnSubmit}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.valuesToStrings) && !AutoNumericHelper.isObject(options.valuesToStrings)) {
      AutoNumericHelper.throwError(`The option 'valuesToStrings' is invalid ; it should be an object, ideally with 'key -> value' entries, [${options.valuesToStrings}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.outputFormat) && !AutoNumericHelper.isInArray(options.outputFormat, [
      _AutoNumeric.options.outputFormat.string,
      _AutoNumeric.options.outputFormat.number,
      _AutoNumeric.options.outputFormat.dot,
      _AutoNumeric.options.outputFormat.negativeDot,
      _AutoNumeric.options.outputFormat.comma,
      _AutoNumeric.options.outputFormat.negativeComma,
      _AutoNumeric.options.outputFormat.dotNegative,
      _AutoNumeric.options.outputFormat.commaNegative
    ])) {
      AutoNumericHelper.throwError(`The custom locale format option 'outputFormat' is invalid ; it should either be null, 'string', 'number', '.', '-.', ',', '-,', '.-' or ',-', [${options.outputFormat}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.isCancellable) && !AutoNumericHelper.isBoolean(options.isCancellable)) {
      AutoNumericHelper.throwError(`The cancellable behavior option 'isCancellable' is invalid ; it should be either 'true' or 'false', [${options.isCancellable}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.modifyValueOnUpDownArrow) && !AutoNumericHelper.isBoolean(options.modifyValueOnUpDownArrow)) {
      AutoNumericHelper.throwError(`The increment/decrement on up and down arrow keys 'modifyValueOnUpDownArrow' is invalid ; it should be either 'true' or 'false', [${options.modifyValueOnUpDownArrow}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.modifyValueOnWheel) && !AutoNumericHelper.isBoolean(options.modifyValueOnWheel)) {
      AutoNumericHelper.throwError(`The increment/decrement on mouse wheel option 'modifyValueOnWheel' is invalid ; it should be either 'true' or 'false', [${options.modifyValueOnWheel}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.watchExternalChanges) && !AutoNumericHelper.isBoolean(options.watchExternalChanges)) {
      AutoNumericHelper.throwError(`The option 'watchExternalChanges' is invalid ; it should be either 'true' or 'false', [${options.watchExternalChanges}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.wheelOn, [
      _AutoNumeric.options.wheelOn.focus,
      _AutoNumeric.options.wheelOn.hover
    ])) {
      AutoNumericHelper.throwError(`The wheel behavior option 'wheelOn' is invalid ; it should either be 'focus' or 'hover', [${options.wheelOn}] given.`);
    }
    if (!(AutoNumericHelper.isString(options.upDownStep) || AutoNumericHelper.isNumber(options.upDownStep)) || options.upDownStep !== "progressive" && !testPositiveFloatOrInteger.test(options.upDownStep) || Number(options.upDownStep) === 0) {
      AutoNumericHelper.throwError(`The up/down arrow step value option 'upDownStep' is invalid ; it should either be the string 'progressive', or a number or a string that represents a positive number (excluding zero), [${options.upDownStep}] given.`);
    }
    if (!(AutoNumericHelper.isString(options.wheelStep) || AutoNumericHelper.isNumber(options.wheelStep)) || options.wheelStep !== "progressive" && !testPositiveFloatOrInteger.test(options.wheelStep) || Number(options.wheelStep) === 0) {
      AutoNumericHelper.throwError(`The wheel step value option 'wheelStep' is invalid ; it should either be the string 'progressive', or a number or a string that represents a positive number (excluding zero), [${options.wheelStep}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.serializeSpaces, [
      _AutoNumeric.options.serializeSpaces.plus,
      _AutoNumeric.options.serializeSpaces.percent
    ])) {
      AutoNumericHelper.throwError(`The space replacement character option 'serializeSpaces' is invalid ; it should either be '+' or '%20', [${options.serializeSpaces}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.noEventListeners) && !AutoNumericHelper.isBoolean(options.noEventListeners)) {
      AutoNumericHelper.throwError(`The option 'noEventListeners' that prevent the creation of event listeners is invalid ; it should be either 'true' or 'false', [${options.noEventListeners}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.styleRules) && !(AutoNumericHelper.isObject(options.styleRules) && (Object.prototype.hasOwnProperty.call(options.styleRules, "positive") || Object.prototype.hasOwnProperty.call(options.styleRules, "negative") || Object.prototype.hasOwnProperty.call(options.styleRules, "ranges") || Object.prototype.hasOwnProperty.call(options.styleRules, "userDefined")))) {
      AutoNumericHelper.throwError(`The option 'styleRules' is invalid ; it should be a correctly structured object, with one or more 'positive', 'negative', 'ranges' or 'userDefined' attributes, [${options.styleRules}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.styleRules) && Object.prototype.hasOwnProperty.call(options.styleRules, "userDefined") && !AutoNumericHelper.isNull(options.styleRules.userDefined)) {
      options.styleRules.userDefined.forEach((rule) => {
        if (Object.prototype.hasOwnProperty.call(rule, "callback") && !AutoNumericHelper.isFunction(rule.callback)) {
          AutoNumericHelper.throwError(`The callback defined in the \`userDefined\` attribute is not a function, ${typeof rule.callback} given.`);
        }
      });
    }
    if (!AutoNumericHelper.isNull(options.rawValueDivisor) && !testPositiveFloatOrInteger.test(options.rawValueDivisor) || options.rawValueDivisor === 0 || options.rawValueDivisor === "0" || options.rawValueDivisor === 1 || options.rawValueDivisor === "1") {
      AutoNumericHelper.throwError(`The raw value divisor option 'rawValueDivisor' is invalid ; it should be a positive number higher than one, preferably an integer, [${options.rawValueDivisor}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.readOnly) && !AutoNumericHelper.isBoolean(options.readOnly)) {
      AutoNumericHelper.throwError(`The option 'readOnly' is invalid ; it should be either 'true' or 'false', [${options.readOnly}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.unformatOnHover) && !AutoNumericHelper.isBoolean(options.unformatOnHover)) {
      AutoNumericHelper.throwError(`The option 'unformatOnHover' is invalid ; it should be either 'true' or 'false', [${options.unformatOnHover}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.failOnUnknownOption) && !AutoNumericHelper.isBoolean(options.failOnUnknownOption)) {
      AutoNumericHelper.throwError(`The debug option 'failOnUnknownOption' is invalid ; it should be either 'true' or 'false', [${options.failOnUnknownOption}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.createLocalList) && !AutoNumericHelper.isBoolean(options.createLocalList)) {
      AutoNumericHelper.throwError(`The debug option 'createLocalList' is invalid ; it should be either 'true' or 'false', [${options.createLocalList}] given.`);
    }
  }
  /**
   * Check the `decimalPlaces*` options and output the relevant warnings if some of those will get overwritten during the initialization or settings update.
   *
   * @param {object} options
   * @private
   */
  static _validateDecimalPlacesRawValue(options) {
    if (!AutoNumericHelper.isNull(options.decimalPlacesRawValue)) {
      if (options.decimalPlacesRawValue < options.decimalPlaces) {
        AutoNumericHelper.warning(`The number of decimal places to store in the raw value [${options.decimalPlacesRawValue}] is lower than the ones to display [${options.decimalPlaces}]. This will likely confuse your users.
To solve that, you'd need to either set \`decimalPlacesRawValue\` to \`null\`, or set a number of decimal places for the raw value equal of bigger than \`decimalPlaces\`.`, options.showWarnings);
      }
      if (options.decimalPlacesRawValue < options.decimalPlacesShownOnFocus) {
        AutoNumericHelper.warning(`The number of decimal places to store in the raw value [${options.decimalPlacesRawValue}] is lower than the ones shown on focus [${options.decimalPlacesShownOnFocus}]. This will likely confuse your users.
To solve that, you'd need to either set \`decimalPlacesRawValue\` to \`null\`, or set a number of decimal places for the raw value equal of bigger than \`decimalPlacesShownOnFocus\`.`, options.showWarnings);
      }
      if (options.decimalPlacesRawValue < options.decimalPlacesShownOnBlur) {
        AutoNumericHelper.warning(`The number of decimal places to store in the raw value [${options.decimalPlacesRawValue}] is lower than the ones shown when unfocused [${options.decimalPlacesShownOnBlur}]. This will likely confuse your users.
To solve that, you'd need to either set \`decimalPlacesRawValue\` to \`null\`, or set a number of decimal places for the raw value equal of bigger than \`decimalPlacesShownOnBlur\`.`, options.showWarnings);
      }
    }
  }
  /**
   * Return `true` if the settings/options are valid, `false` otherwise.
   *
   * @param {object} options
   * @returns {boolean}
   */
  static areSettingsValid(options) {
    let isValid2 = true;
    try {
      this.validate(options, true);
    } catch (error) {
      isValid2 = false;
    }
    return isValid2;
  }
  /**
   * Return the default autoNumeric settings.
   *
   * @returns {object}
   */
  static getDefaultConfig() {
    return _AutoNumeric.defaultSettings;
  }
  /**
   * Return all the predefined language options in one object.
   * You can also access a specific language object directly by using `AutoNumeric.getPredefinedOptions().French` for instance.
   *
   * @returns {object}
   */
  static getPredefinedOptions() {
    return _AutoNumeric.predefinedOptions;
  }
  /**
   * Analyse the given array `options` and return a single 'merged' option objet.
   * `options` can be `null`, or an array of an option objects, or an array containing another array of option objects / strings (pre-defined option names)
   *
   * @param {null|Array<object|string|Array<string|object>>} options
   * @returns {null|object}
   * @private
   */
  static _generateOptionsObjectFromOptionsArray(options) {
    let optionsResult;
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(options) || options.length === 0) {
      optionsResult = null;
    } else {
      optionsResult = {};
      if (options.length === 1 && Array.isArray(options[0])) {
        options[0].forEach((optionObject) => {
          Object.assign(optionsResult, this._getOptionObject(optionObject));
        });
      } else if (options.length >= 1) {
        options.forEach((optionObject) => {
          Object.assign(optionsResult, this._getOptionObject(optionObject));
        });
      }
    }
    return optionsResult;
  }
  /**
   * Format the given number (or numeric string) with the given options. This returns the formatted value as a string.
   * This can also format the given DOM element value with the given options and returns the formatted value as a string.
   * Note : This function does *not* update that element value with the newly formatted value.
   * This basically allows to get the formatted value without first having to initialize an AutoNumeric object.
   *
   * @param {number|string|HTMLElement|HTMLInputElement} numericStringOrDomElement A number, or a string that represent a javascript number, or a DOM element
   * @param {object|null} options Multiple objects can be passed, the latter overwriting the settings from the former ones
   * @returns {string|null}
   */
  static format(numericStringOrDomElement, ...options) {
    if (AutoNumericHelper.isUndefined(numericStringOrDomElement) || numericStringOrDomElement === null) {
      return null;
    }
    let value;
    if (AutoNumericHelper.isElement(numericStringOrDomElement)) {
      value = AutoNumericHelper.getElementValue(numericStringOrDomElement);
    } else {
      value = numericStringOrDomElement;
    }
    if (!AutoNumericHelper.isString(value) && !AutoNumericHelper.isNumber(value)) {
      AutoNumericHelper.throwError(`The value "${value}" being "set" is not numeric and therefore cannot be used appropriately.`);
    }
    const optionsToUse = this._generateOptionsObjectFromOptionsArray(options);
    const settings = Object.assign({}, this.getDefaultConfig(), optionsToUse);
    settings.isNegativeSignAllowed = value < 0;
    settings.isPositiveSignAllowed = value >= 0;
    this._setBrackets(settings);
    const regex = {};
    this._cachesUsualRegularExpressions(settings, regex);
    let valueString = this._toNumericValue(value, settings);
    if (isNaN(Number(valueString))) {
      AutoNumericHelper.throwError(`The value [${valueString}] that you are trying to format is not a recognized number.`);
    }
    if (!this._isWithinRangeWithOverrideOption(valueString, settings)) {
      AutoNumericHelper.triggerEvent(_AutoNumeric.events.formatted, document, {
        oldValue: null,
        newValue: null,
        oldRawValue: null,
        newRawValue: null,
        isPristine: null,
        error: "Range test failed",
        aNElement: null
      }, true, true);
      AutoNumericHelper.throwError(`The value [${valueString}] being set falls outside of the minimumValue [${settings.minimumValue}] and maximumValue [${settings.maximumValue}] range set for this element`);
    }
    if (settings.valuesToStrings && this._checkValuesToStringsSettings(value, settings)) {
      return settings.valuesToStrings[value];
    }
    this._correctNegativePositiveSignPlacementOption(settings);
    this._calculateDecimalPlacesOnInit(settings);
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(settings.rawValueDivisor) && settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
    valueString !== "" && valueString !== null) {
      valueString *= settings.rawValueDivisor;
    }
    valueString = this._roundFormattedValueShownOnFocus(valueString, settings);
    valueString = this._modifyNegativeSignAndDecimalCharacterForFormattedValue(valueString, settings);
    valueString = this._addGroupSeparators(valueString, settings, false, valueString);
    return valueString;
  }
  /**
   * Format the given DOM element value, and set the resulting value back as the element value.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @param {object} options
   * @returns {string|null}
   */
  static formatAndSet(domElement, options = null) {
    const formattedValue = this.format(domElement, options);
    AutoNumericHelper.setElementValue(domElement, formattedValue);
    return formattedValue;
  }
  /**
   * Unformat the given formatted string with the given options. This returns a numeric string.
   * It can also unformat the given DOM element value with the given options and returns the unformatted numeric string.
   * Note: This does *not* update that element value.
   * This basically allows to get the unformatted value without first having to initialize an AutoNumeric object.
   *
   * @param {string|number|HTMLElement|HTMLInputElement} numericStringOrDomElement A number, or a string that represent a javascript number, or a DOM element
   * @param {object|null} options Multiple objects can be passed, the latter overwriting the settings from the former ones
   * @returns {string|number|NaN}
   */
  static unformat(numericStringOrDomElement, ...options) {
    if (AutoNumericHelper.isNumberStrict(numericStringOrDomElement)) {
      return numericStringOrDomElement;
    }
    let value;
    if (AutoNumericHelper.isElement(numericStringOrDomElement)) {
      value = AutoNumericHelper.getElementValue(numericStringOrDomElement);
    } else {
      value = numericStringOrDomElement;
    }
    if (value === "") {
      return "";
    }
    if (AutoNumericHelper.isUndefined(value) || value === null) {
      return null;
    }
    if (AutoNumericHelper.isArray(value) || AutoNumericHelper.isObject(value)) {
      AutoNumericHelper.throwError(`A number or a string representing a number is needed to be able to unformat it, [${value}] given.`);
    }
    const optionsToUse = this._generateOptionsObjectFromOptionsArray(options);
    const settings = Object.assign({}, this.getDefaultConfig(), optionsToUse);
    settings.isNegativeSignAllowed = false;
    settings.isPositiveSignAllowed = true;
    value = value.toString();
    if (settings.valuesToStrings && this._checkStringsToValuesSettings(value, settings)) {
      return AutoNumericHelper.objectKeyLookup(settings.valuesToStrings, value);
    }
    if (AutoNumericHelper.isNegative(value, settings.negativeSignCharacter)) {
      settings.isNegativeSignAllowed = true;
      settings.isPositiveSignAllowed = false;
    } else if (!AutoNumericHelper.isNull(settings.negativeBracketsTypeOnBlur)) {
      [settings.firstBracket, settings.lastBracket] = settings.negativeBracketsTypeOnBlur.split(",");
      if (value.charAt(0) === settings.firstBracket && value.charAt(value.length - 1) === settings.lastBracket) {
        settings.isNegativeSignAllowed = true;
        settings.isPositiveSignAllowed = false;
        value = this._removeBrackets(value, settings, false);
      }
    }
    value = this._convertToNumericString(value, settings);
    if (AutoNumericHelper.isNumber(Number(value))) {
      value = AutoNumericHelper.scientificToDecimal(value);
    }
    const unwantedCharacters = new RegExp(`[^+-0123456789.]`, "gi");
    if (unwantedCharacters.test(value)) {
      return NaN;
    }
    this._correctNegativePositiveSignPlacementOption(settings);
    if (settings.decimalPlacesRawValue) {
      settings.originalDecimalPlacesRawValue = settings.decimalPlacesRawValue;
    } else {
      settings.originalDecimalPlacesRawValue = settings.decimalPlaces;
    }
    this._calculateDecimalPlacesOnInit(settings);
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(settings.rawValueDivisor) && settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
    value !== "" && value !== null) {
      value /= settings.rawValueDivisor;
    }
    value = this._roundRawValue(value, settings);
    value = value.replace(settings.decimalCharacter, ".");
    value = this._toLocale(value, settings.outputFormat, settings);
    return value;
  }
  /**
   * Unformat the given DOM element value, and set the resulting value back as the element value.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @param {object} options
   * @returns {*}
   */
  static unformatAndSet(domElement, options = null) {
    const unformattedValue = this.unformat(domElement, options);
    AutoNumericHelper.setElementValue(domElement, unformattedValue);
    return unformattedValue;
  }
  /**
   * Unformat and localize the given formatted string with the given options. This returns a numeric string.
   * It can also unformat and localize the given DOM element value with the given options and returns the unformatted numeric string.
   * Note: This does *not* update that element value.
   * This basically allows to get the localized value without first having to initialize an AutoNumeric object.
   *
   * @param {string|number|HTMLElement|HTMLInputElement} numericStringOrDomElement
   * @param {object} settings
   * @returns {*}
   */
  static localize(numericStringOrDomElement, settings = null) {
    let value;
    if (AutoNumericHelper.isElement(numericStringOrDomElement)) {
      value = AutoNumericHelper.getElementValue(numericStringOrDomElement);
    } else {
      value = numericStringOrDomElement;
    }
    if (value === "") {
      return "";
    }
    if (AutoNumericHelper.isNull(settings)) {
      settings = _AutoNumeric.defaultSettings;
    }
    value = this.unformat(value, settings);
    if (Number(value) === 0 && settings.leadingZero !== _AutoNumeric.options.leadingZero.keep) {
      value = "0";
    }
    let outputFormatToUse;
    if (AutoNumericHelper.isNull(settings)) {
      outputFormatToUse = settings.outputFormat;
    } else {
      outputFormatToUse = _AutoNumeric.defaultSettings.outputFormat;
    }
    return this._toLocale(value, outputFormatToUse, settings);
  }
  static localizeAndSet(domElement, options = null) {
    const localizedValue = this.localize(domElement, options);
    AutoNumericHelper.setElementValue(domElement, localizedValue);
    return localizedValue;
  }
  /**
   * Return `true` if the given DOM element has an AutoNumeric object that manages it.
   * This function also accepts a selector string.
   *
   * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
   * @returns {boolean}
   */
  static isManagedByAutoNumeric(domElementOrSelector) {
    return this._isInGlobalList(AutoNumericHelper.domElement(domElementOrSelector));
  }
  /**
   * Return the AutoNumeric object that manages the given DOM element.
   * This function also accepts a selector string.
   *
   * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
   * @returns {null|AutoNumeric}
   */
  static getAutoNumericElement(domElementOrSelector) {
    const domElement = AutoNumericHelper.domElement(domElementOrSelector);
    if (!this.isManagedByAutoNumeric(domElement)) {
      return null;
    }
    return this._getFromGlobalList(domElement);
  }
  /**
   * Set the given element value, and format it immediately.
   * Return `null` if no AutoNumeric object is found, else, return the AutoNumeric object.
   *
   * @param {HTMLElement|string} domElementOrSelector Either a DOM element reference, or a selector string can be used
   * @param {number|string|null} newValue The value must be a Number, a numeric string or `null` (if `emptyInputBehavior` is set to `'null'`)
   * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history table
   * @returns {AutoNumeric|null}
   */
  static set(domElementOrSelector, newValue, options = null, saveChangeToHistory = true) {
    const domElement = AutoNumericHelper.domElement(domElementOrSelector);
    if (!this.isManagedByAutoNumeric(domElement)) {
      let showWarnings;
      if (!AutoNumericHelper.isNull(options) && Object.prototype.hasOwnProperty.call(options, "showWarnings")) {
        showWarnings = options.showWarnings;
      } else {
        showWarnings = true;
      }
      AutoNumericHelper.warning(`Impossible to find an AutoNumeric object for the given DOM element or selector.`, showWarnings);
      return null;
    }
    return this.getAutoNumericElement(domElement).set(newValue, options, saveChangeToHistory);
  }
  /**
   * Return the unformatted value as a string from the given DOM element or query selector.
   * This can also return `null` if `rawValue` is null.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {function|null} callback
   * @returns {string|null}
   */
  static getNumericString(domElementOrSelector, callback = null) {
    return this._get(domElementOrSelector, "getNumericString", callback);
  }
  /**
   * Return the current formatted value of the AutoNumeric element as a string, from the given DOM element or query selector.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {function|null} callback
   * @returns {string}
   */
  static getFormatted(domElementOrSelector, callback = null) {
    return this._get(domElementOrSelector, "getFormatted", callback);
  }
  /**
   * Return the element unformatted value as a real Javascript number, from the given DOM element or query selector.
   * Warning: This can lead to precision problems with big numbers that should be stored as strings.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {function|null} callback
   * @returns {number|null}
   */
  static getNumber(domElementOrSelector, callback = null) {
    return this._get(domElementOrSelector, "getNumber", callback);
  }
  /**
   * DRY the code between the static `get*` functions
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {string} getFunction The name of the non-static `get*` function as a string
   * @param {function|null} callback
   * @returns {*}
   * @private
   */
  static _get(domElementOrSelector, getFunction, callback = null) {
    const domElement = AutoNumericHelper.domElement(domElementOrSelector);
    if (!this.isManagedByAutoNumeric(domElement)) {
      AutoNumericHelper.throwError(`Impossible to find an AutoNumeric object for the given DOM element or selector.`);
    }
    return this.getAutoNumericElement(domElement)[getFunction](callback);
  }
  /**
   * Returns the unformatted value following the `outputFormat` setting, from the given DOM element or query selector.
   * See the non-static `getLocalized()` method documentation for more details.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {null|string|function} forcedOutputFormat
   * @param {function|null} callback
   * @returns {*}
   */
  static getLocalized(domElementOrSelector, forcedOutputFormat = null, callback = null) {
    const domElement = AutoNumericHelper.domElement(domElementOrSelector);
    if (!this.isManagedByAutoNumeric(domElement)) {
      AutoNumericHelper.throwError(`Impossible to find an AutoNumeric object for the given DOM element or selector.`);
    }
    return this.getAutoNumericElement(domElement).getLocalized(forcedOutputFormat, callback);
  }
  // Pre-defined options can be called to update the current default options with their specificities
  //XXX A better way would be to not initialize first, but that's not possible since `new` is called first and we do not pass the language options (i.e. `French`) to the constructor
  /**
   * Update the AutoNumeric object with the predefined options, and possibly some option overrides.
   *
   * @param {object} predefinedOption
   * @param {object} optionOverride
   * @private
   * @returns {AutoNumeric}
   */
  _updatePredefinedOptions(predefinedOption, optionOverride = null) {
    if (!AutoNumericHelper.isNull(optionOverride)) {
      this._mergeSettings(predefinedOption, optionOverride);
      this.update(this.settings);
    } else {
      this.update(predefinedOption);
    }
    return this;
  }
  /**
   * Update the settings to use the French pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  french(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().French, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the North American pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  northAmerican(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().NorthAmerican, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the British pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  british(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().British, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Swiss pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  swiss(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Swiss, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Japanese pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  japanese(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Japanese, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Spanish pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  spanish(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Spanish, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Chinese pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  chinese(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Chinese, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Brazilian pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  brazilian(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Brazilian, optionOverride);
    return this;
  }
  // Internal private functions
  /**
   * Run any callbacks found in the settings object in order to set the settings value back.
   * Any parameter can have a callback defined.
   * The callback takes the current AutoNumeric element as the first argument, and the key name as the second.
   * @example callback(this, 'currencySymbol')
   */
  _runCallbacksFoundInTheSettingsObject() {
    for (const key in this.settings) {
      if (Object.prototype.hasOwnProperty.call(this.settings, key)) {
        const value = this.settings[key];
        if (typeof value === "function") {
          this.settings[key] = value(this, key);
        } else {
          let htmlAttribute = "";
          if (key in this.domElement.dataset) {
            htmlAttribute = this.domElement.dataset[key];
          }
          htmlAttribute = AutoNumericHelper.camelize(htmlAttribute);
          if (typeof this.settings[htmlAttribute] === "function") {
            this.settings[key] = htmlAttribute(this, key);
          }
        }
      }
    }
  }
  /**
   * Keep track if the settings configuration leads to a trailing negative sign (only when the raw value is negative), so we do not have to test the settings values every time we need to know that.
   * `isTrailingNegative` is set to `true` if the settings result in a trailing negative character, `false` otherwise.
   * Note: This returns `true` even if the raw value is positive.
   * @private
   */
  _setTrailingNegativeSignInfo() {
    this.isTrailingNegative = this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix && (this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.left || this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.right);
  }
  /**
   * Strip all the unwanted non-number characters.
   * However, it does not reorder the localized negative sign.
   *
   * @param {string} s
   * @param {object} settings
   * @param {boolean} stripZeros If set to `false`, then the leading zero(s) are not stripped, otherwise if set to `true`, the `leadingZero` option is followed
   * @param {boolean} isFocused If the element is focused, then this is `true`
   * @returns {string}
   * @private
   */
  static _stripAllNonNumberCharacters(s, settings, stripZeros, isFocused) {
    return this._stripAllNonNumberCharactersExceptCustomDecimalChar(s, settings, stripZeros, isFocused).replace(settings.decimalCharacter, ".");
  }
  /**
   * Strip all unwanted non-number characters except the custom decimal character.
   *
   * It converts the custom negative sign and removes the positive sign (custom or not).
   * This keeps :
   * - the numbers,
   * - the normal negative sign '-' if any,
   * - and the *custom* decimal character.
   *
   * @param {string} s
   * @param {object} settings
   * @param {boolean} stripZeros If set to `false`, then the leading zero(s) are not stripped, otherwise if set to `true`, the `leadingZero` option is followed
   * @param {boolean} isFocused If the element is focused, then this is `true`
   * @returns {string|*}
   */
  static _stripAllNonNumberCharactersExceptCustomDecimalChar(s, settings, stripZeros, isFocused) {
    s = this._normalizeCurrencySuffixAndNegativeSignCharacters(s, settings);
    s = s.replace(settings.allowedAutoStrip, "");
    const m = s.match(settings.numRegAutoStrip);
    s = m ? [m[1], m[2], m[3]].join("") : "";
    if (settings.leadingZero === _AutoNumeric.options.leadingZero.allow || settings.leadingZero === _AutoNumeric.options.leadingZero.keep) {
      let negativeSign = "";
      const [integerPart, decimalPart] = s.split(settings.decimalCharacter);
      let modifiedIntegerPart = integerPart;
      if (AutoNumericHelper.contains(modifiedIntegerPart, settings.negativeSignCharacter)) {
        negativeSign = settings.negativeSignCharacter;
        modifiedIntegerPart = modifiedIntegerPart.replace(settings.negativeSignCharacter, "");
      }
      if (negativeSign === "" && modifiedIntegerPart.length > settings.mIntPos && modifiedIntegerPart.charAt(0) === "0") {
        modifiedIntegerPart = modifiedIntegerPart.slice(1);
      }
      if (negativeSign !== "" && modifiedIntegerPart.length > settings.mIntNeg && modifiedIntegerPart.charAt(0) === "0") {
        modifiedIntegerPart = modifiedIntegerPart.slice(1);
      }
      s = `${negativeSign}${modifiedIntegerPart}${AutoNumericHelper.isUndefined(decimalPart) ? "" : settings.decimalCharacter + decimalPart}`;
    }
    if (stripZeros && settings.leadingZero === _AutoNumeric.options.leadingZero.deny || !isFocused && settings.leadingZero === _AutoNumeric.options.leadingZero.allow) {
      s = s.replace(settings.stripReg, "$1$2");
    }
    return s;
  }
  /**
   * Sets or removes brackets on negative values, depending on the focus state, which is passed as `isFocused`.
   * The focus state is 'stored' in that object property.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} isFocused
   * @returns {*}
   */
  static _toggleNegativeBracket(value, settings, isFocused) {
    let result;
    if (isFocused) {
      result = this._removeBrackets(value, settings);
    } else {
      result = this._addBrackets(value, settings);
    }
    return result;
  }
  /**
   * Add the bracket types specified in the `settings` object, to the given string `value`.
   *
   * @param {string} value
   * @param {object} settings
   * @returns {string}
   * @private
   */
  static _addBrackets(value, settings) {
    if (AutoNumericHelper.isNull(settings.negativeBracketsTypeOnBlur)) {
      return value;
    }
    return `${settings.firstBracket}${value.replace(settings.negativeSignCharacter, "")}${settings.lastBracket}`;
  }
  /**
   * Remove the bracket types specified in the `settings` object, from the given string `value`.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} rearrangeSignsAndValueOrder If set to `true`, then only the brackets are remove and a negative sign is added, without reordering the negative sign, currency symbol and value according to the settings.
   * @returns {string}
   * @private
   */
  static _removeBrackets(value, settings, rearrangeSignsAndValueOrder = true) {
    let result;
    if (!AutoNumericHelper.isNull(settings.negativeBracketsTypeOnBlur) && value.charAt(0) === settings.firstBracket) {
      result = value.replace(settings.firstBracket, "");
      result = result.replace(settings.lastBracket, "");
      if (rearrangeSignsAndValueOrder) {
        result = result.replace(settings.currencySymbol, "");
        result = this._mergeCurrencySignNegativePositiveSignAndValue(result, settings, true, false);
      } else {
        result = `${settings.negativeSignCharacter}${result}`;
      }
    } else {
      result = value;
    }
    return result;
  }
  /**
   * Analyze the `negativeBracketsTypeOnBlur` options and keep track of the first and last bracket characters to use.
   *
   * @param {object} settings
   * @private
   */
  static _setBrackets(settings) {
    if (AutoNumericHelper.isNull(settings.negativeBracketsTypeOnBlur)) {
      settings.firstBracket = "";
      settings.lastBracket = "";
    } else {
      const [firstBracket, lastBracket] = settings.negativeBracketsTypeOnBlur.split(",");
      settings.firstBracket = firstBracket;
      settings.lastBracket = lastBracket;
    }
  }
  /**
   * Return a number as a numeric string that can be typecast to a Number that Javascript will understand.
   *
   * This function returns the given string by stripping:
   * - the currency sign (currencySymbol),
   * - the grouping separators (digitalGroupSpacing),
   * - the suffix text (suffixText),
   * - the positive sign (positiveSignCharacter),
   * - the brackets if any,
   * - by replacing the negative sign character with a hyphen,
   * - and by replacing the decimal character (decimalCharacter) by a dot.
   *
   * Lastly, it also put the negative sign back to its normal position if needed.
   * Bonus; it converts any arabic numbers found to the latin ones.
   *
   * @param {string} s
   * @param {object} settings
   * @returns {string|void|*}
   */
  static _convertToNumericString(s, settings) {
    s = this._removeBrackets(s, settings, false);
    s = this._normalizeCurrencySuffixAndNegativeSignCharacters(s, settings);
    s = s.replace(new RegExp(`[${settings.digitGroupSeparator}]`, "g"), "");
    if (settings.decimalCharacter !== ".") {
      s = s.replace(settings.decimalCharacter, ".");
    }
    if (AutoNumericHelper.isNegative(s) && s.lastIndexOf("-") === s.length - 1) {
      s = s.replace("-", "");
      s = `-${s}`;
    }
    if (settings.showPositiveSign) {
      s = s.replace(settings.positiveSignCharacter, "");
    }
    const convertToNumber = settings.leadingZero !== _AutoNumeric.options.leadingZero.keep;
    const temp = AutoNumericHelper.arabicToLatinNumbers(s, convertToNumber, false, false);
    if (!isNaN(temp)) {
      s = temp.toString();
    }
    return s;
  }
  /**
   * Removes the currency symbol and the suffix text from the given string, and replace the custom negative sign with a hyphen.
   *
   * @param {string} s
   * @param {object} settings
   * @returns {string | *}
   * @private
   */
  static _normalizeCurrencySuffixAndNegativeSignCharacters(s, settings) {
    s = String(s);
    if (settings.currencySymbol !== _AutoNumeric.options.currencySymbol.none) {
      s = s.replace(settings.currencySymbol, "");
    }
    if (settings.suffixText !== _AutoNumeric.options.suffixText.none) {
      s = s.replace(settings.suffixText, "");
    }
    if (settings.negativeSignCharacter !== _AutoNumeric.options.negativeSignCharacter.hyphen) {
      s = s.replace(settings.negativeSignCharacter, "-");
    }
    return s;
  }
  /**
   * Converts the ISO numeric string to the locale decimal and minus sign placement.
   * See the "outputFormat" option definition for more details.
   * Note: If the `outputFormat` is set to a number, the custom `negativeSignCharacter` is ignored.
   *
   * @param {string|null} value The unformatted value
   * @param {string|null} locale
   * @param {object} settings
   * @returns {*}
   */
  static _toLocale(value, locale, settings) {
    if (AutoNumericHelper.isNull(locale) || locale === _AutoNumeric.options.outputFormat.string) {
      return value;
    }
    let result;
    switch (locale) {
      case _AutoNumeric.options.outputFormat.number:
        result = Number(value);
        break;
      case _AutoNumeric.options.outputFormat.dotNegative:
        result = AutoNumericHelper.isNegative(value) ? value.replace("-", "") + "-" : value;
        break;
      case _AutoNumeric.options.outputFormat.comma:
      case _AutoNumeric.options.outputFormat.negativeComma:
        result = value.replace(".", ",");
        break;
      case _AutoNumeric.options.outputFormat.commaNegative:
        result = value.replace(".", ",");
        result = AutoNumericHelper.isNegative(result) ? result.replace("-", "") + "-" : result;
        break;
      case _AutoNumeric.options.outputFormat.dot:
      case _AutoNumeric.options.outputFormat.negativeDot:
        result = value;
        break;
      default:
        AutoNumericHelper.throwError(`The given outputFormat [${locale}] option is not recognized.`);
    }
    if (locale !== _AutoNumeric.options.outputFormat.number && settings.negativeSignCharacter !== "-") {
      result = result.replace("-", settings.negativeSignCharacter);
    }
    return result;
  }
  /**
   * Modify the negative sign and the decimal character of the given string value to a hyphen (-) and a dot (.) in order to make that value 'typecastable' to a real number.
   *
   * @param {string} s The formatted value
   * @returns {string} The value with the 'normal' minus sign and decimal character
   */
  _modifyNegativeSignAndDecimalCharacterForRawValue(s) {
    if (this.settings.decimalCharacter !== ".") {
      s = s.replace(this.settings.decimalCharacter, ".");
    }
    if (this.settings.negativeSignCharacter !== "-" && this.settings.isNegativeSignAllowed) {
      s = s.replace(this.settings.negativeSignCharacter, "-");
    }
    if (!s.match(/\d/)) {
      s += "0";
    }
    return s;
  }
  /**
   * Modify the negative sign and the decimal character to use those defined in the settings.
   *
   * @param {string} s
   * @param {object} settings
   * @returns {string}
   */
  static _modifyNegativeSignAndDecimalCharacterForFormattedValue(s, settings) {
    if (settings.negativeSignCharacter !== "-") {
      s = s.replace("-", settings.negativeSignCharacter);
    }
    if (settings.decimalCharacter !== ".") {
      s = s.replace(".", settings.decimalCharacter);
    }
    return s;
  }
  /**
   * Return `true` if the given value is empty or is equal to the negative sign character defined in the given settings.
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isElementValueEmptyOrOnlyTheNegativeSign(value, settings) {
    return value === "" || value === settings.negativeSignCharacter;
  }
  /**
   * Return the value with the currency symbol and the suffix text ordered according to the given settings.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} signOnEmpty
   * @returns {*}
   * @private
   */
  static _orderValueCurrencySymbolAndSuffixText(value, settings, signOnEmpty) {
    let result;
    if (settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.always || signOnEmpty) {
      switch (settings.negativePositiveSignPlacement) {
        case _AutoNumeric.options.negativePositiveSignPlacement.left:
        case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
        case _AutoNumeric.options.negativePositiveSignPlacement.none:
          result = value + settings.currencySymbol + settings.suffixText;
          break;
        default:
          result = settings.currencySymbol + value + settings.suffixText;
      }
    } else {
      result = value;
    }
    return result;
  }
  /**
   * Modify the input value by adding the group separators, as defined in the settings, and the negative brackets if needed.
   *
   * @param {string} inputValue The formatted value (i.e. with the `decimalCharacter` defined in the settings, not the raw value)
   * @param {object} settings
   * @param {boolean} isFocused
   * @param {number|string|null} currentRawValue The object current raw value (`this.rawValue`)
   * @param {number|string|null} forcedRawValue If this is set, then this rawValue is used instead of the one passed through the `settings` object. This is useful is some very specific cases where we need to set the raw value *after* settings the formatted value, using the `_addGroupSeparators()` method.
   * @returns {*}
   */
  static _addGroupSeparators(inputValue, settings, isFocused, currentRawValue, forcedRawValue = null) {
    let isValueNegative;
    if (!AutoNumericHelper.isNull(forcedRawValue)) {
      isValueNegative = forcedRawValue < 0;
    } else {
      isValueNegative = AutoNumericHelper.isNegative(inputValue, settings.negativeSignCharacter) || AutoNumericHelper.isNegativeWithBrackets(inputValue, settings.firstBracket, settings.lastBracket);
    }
    inputValue = this._stripAllNonNumberCharactersExceptCustomDecimalChar(inputValue, settings, false, isFocused);
    if (this._isElementValueEmptyOrOnlyTheNegativeSign(inputValue, settings)) {
      return this._orderValueCurrencySymbolAndSuffixText(inputValue, settings, true);
    }
    const isZeroOrHasNoValue = AutoNumericHelper.isZeroOrHasNoValue(inputValue);
    if (isValueNegative) {
      inputValue = inputValue.replace("-", "");
    }
    let [integerPart, decimalPart] = inputValue.split(settings.decimalCharacter);
    if (settings.decimalCharacterAlternative && AutoNumericHelper.isUndefined(decimalPart)) {
      [integerPart, decimalPart] = inputValue.split(settings.decimalCharacterAlternative);
    }
    if (settings.digitGroupSeparator !== "") {
      settings.digitalGroupSpacing = settings.digitalGroupSpacing.toString();
      let digitalGroup;
      switch (settings.digitalGroupSpacing) {
        case _AutoNumeric.options.digitalGroupSpacing.twoThree:
          digitalGroup = /(\d)((\d)(\d{2}?)+)$/;
          break;
        case _AutoNumeric.options.digitalGroupSpacing.twoScaled:
          digitalGroup = /(\d)((?:\d{2}){0,2}\d{3}(?:(?:\d{2}){2}\d{3})*?)$/;
          break;
        case _AutoNumeric.options.digitalGroupSpacing.two:
        case _AutoNumeric.options.digitalGroupSpacing.three:
        case _AutoNumeric.options.digitalGroupSpacing.four:
        default:
          digitalGroup = new RegExp(`(\\d)((\\d{${settings.digitalGroupSpacing}}?)+)$`);
      }
      while (digitalGroup.test(integerPart)) {
        integerPart = integerPart.replace(digitalGroup, `$1${settings.digitGroupSeparator}$2`);
      }
    }
    let decimalPlacesToRoundTo;
    if (isFocused) {
      decimalPlacesToRoundTo = settings.decimalPlacesShownOnFocus;
    } else {
      decimalPlacesToRoundTo = settings.decimalPlacesShownOnBlur;
    }
    if (decimalPlacesToRoundTo !== 0 && !AutoNumericHelper.isUndefined(decimalPart)) {
      if (decimalPart.length > decimalPlacesToRoundTo) {
        decimalPart = decimalPart.substring(0, decimalPlacesToRoundTo);
      }
      inputValue = `${integerPart}${settings.decimalCharacter}${decimalPart}`;
    } else {
      inputValue = integerPart;
    }
    inputValue = _AutoNumeric._mergeCurrencySignNegativePositiveSignAndValue(inputValue, settings, isValueNegative, isZeroOrHasNoValue);
    if (AutoNumericHelper.isNull(forcedRawValue)) {
      forcedRawValue = currentRawValue;
    }
    if (settings.negativeBracketsTypeOnBlur !== null && (forcedRawValue < 0 || AutoNumericHelper.isNegativeStrict(inputValue, settings.negativeSignCharacter))) {
      inputValue = this._toggleNegativeBracket(inputValue, settings, isFocused);
    }
    let result;
    if (settings.suffixText) {
      result = `${inputValue}${settings.suffixText}`;
    } else {
      result = inputValue;
    }
    return result;
  }
  /**
   * Return a semi-formatted string where the input value, the negative or positive sign, and the currency symbol are stitched together at the right positions, using the options set in the `settings` object.
   * Note : the `inputValue` is usually not a numeric string since the grouping symbols are already added to it at this point.
   *
   * @param {string} inputValue
   * @param {object} settings
   * @param {boolean} isValueNegative
   * @param {boolean} isZeroOrHasNoValue
   * @returns {*}
   * @throws
   * @private
   */
  static _mergeCurrencySignNegativePositiveSignAndValue(inputValue, settings, isValueNegative, isZeroOrHasNoValue) {
    let signToUse = "";
    if (isValueNegative) {
      signToUse = settings.negativeSignCharacter;
    } else if (settings.showPositiveSign && !isZeroOrHasNoValue) {
      signToUse = settings.positiveSignCharacter;
    }
    let result;
    if (settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
      if (settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && settings.showPositiveSign && !isZeroOrHasNoValue)) {
        switch (settings.negativePositiveSignPlacement) {
          case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
          case _AutoNumeric.options.negativePositiveSignPlacement.left:
            result = `${signToUse}${settings.currencySymbol}${inputValue}`;
            break;
          case _AutoNumeric.options.negativePositiveSignPlacement.right:
            result = `${settings.currencySymbol}${signToUse}${inputValue}`;
            break;
          case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            result = `${settings.currencySymbol}${inputValue}${signToUse}`;
            break;
        }
      } else {
        result = settings.currencySymbol + inputValue;
      }
    } else if (settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
      if (settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && settings.showPositiveSign && !isZeroOrHasNoValue)) {
        switch (settings.negativePositiveSignPlacement) {
          case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
          case _AutoNumeric.options.negativePositiveSignPlacement.right:
            result = `${inputValue}${settings.currencySymbol}${signToUse}`;
            break;
          case _AutoNumeric.options.negativePositiveSignPlacement.left:
            result = `${inputValue}${signToUse}${settings.currencySymbol}`;
            break;
          case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            result = `${signToUse}${inputValue}${settings.currencySymbol}`;
            break;
        }
      } else {
        result = inputValue + settings.currencySymbol;
      }
    }
    return result;
  }
  /**
   * Calculate where to put the caret position on focus if the element content is not selected.
   * This calculation is affected by the `caretPositionOnFocus` option which can be either `null`, `'start'`, `'end'`, `'decimalLeft'` or 'decimalRight'`, and will decide where to put the caret (on the left or right of the value or the decimal character, respectively) :
   * - `null` : the caret position is not forced
   * - `'start'` : the caret is positioned on the left hand side of the value
   * - `'end'` : the caret is positioned on the right hand side of the value
   * - `'decimalLeft'` : the caret is positioned on the left side of the decimal character
   * - `'decimalRight'` : the caret is positioned on the right side of the decimal character
   *
   * @param {string} value The formatted string stripped of the currency symbol and negative/positive sign
   * @returns {number}
   * @throws
   * @private
   */
  _initialCaretPosition(value) {
    if (AutoNumericHelper.isNull(this.settings.caretPositionOnFocus) && this.settings.selectOnFocus === _AutoNumeric.options.selectOnFocus.doNotSelect) {
      AutoNumericHelper.throwError("`_initialCaretPosition()` should never be called when the `caretPositionOnFocus` option is `null`.");
    }
    const isValueNegative = this.rawValue < 0;
    const isZeroOrHasNoValue = AutoNumericHelper.isZeroOrHasNoValue(value);
    const totalLength = value.length;
    let valueSize = 0;
    let integerSize = 0;
    let hasDecimalChar = false;
    let offsetDecimalChar = 0;
    if (this.settings.caretPositionOnFocus !== _AutoNumeric.options.caretPositionOnFocus.start) {
      value = value.replace(this.settings.negativeSignCharacter, "");
      value = value.replace(this.settings.positiveSignCharacter, "");
      value = value.replace(this.settings.currencySymbol, "");
      valueSize = value.length;
      hasDecimalChar = AutoNumericHelper.contains(value, this.settings.decimalCharacter);
      if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalLeft || this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalRight) {
        if (hasDecimalChar) {
          integerSize = value.indexOf(this.settings.decimalCharacter);
          offsetDecimalChar = this.settings.decimalCharacter.length;
        } else {
          integerSize = valueSize;
          offsetDecimalChar = 0;
        }
      }
    }
    let signToUse = "";
    if (isValueNegative) {
      signToUse = this.settings.negativeSignCharacter;
    } else if (this.settings.showPositiveSign && !isZeroOrHasNoValue) {
      signToUse = this.settings.positiveSignCharacter;
    }
    const positiveNegativeSignSize = signToUse.length;
    const currencySymbolSize = this.settings.currencySymbol.length;
    let caretPosition;
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
      if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.start) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
              caretPosition = positiveNegativeSignSize + currencySymbolSize;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
              caretPosition = currencySymbolSize;
              break;
          }
        } else {
          caretPosition = currencySymbolSize;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.end) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
              caretPosition = totalLength;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
              caretPosition = currencySymbolSize + valueSize;
              break;
          }
        } else {
          caretPosition = totalLength;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalLeft) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
              caretPosition = positiveNegativeSignSize + currencySymbolSize + integerSize;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
              caretPosition = currencySymbolSize + integerSize;
              break;
          }
        } else {
          caretPosition = currencySymbolSize + integerSize;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalRight) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
              caretPosition = positiveNegativeSignSize + currencySymbolSize + integerSize + offsetDecimalChar;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
              caretPosition = currencySymbolSize + integerSize + offsetDecimalChar;
              break;
          }
        } else {
          caretPosition = currencySymbolSize + integerSize + offsetDecimalChar;
        }
      }
    } else if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
      if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.start) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
              caretPosition = 0;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
              caretPosition = positiveNegativeSignSize;
              break;
          }
        } else {
          caretPosition = 0;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.end) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
              caretPosition = valueSize;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
              caretPosition = positiveNegativeSignSize + valueSize;
              break;
          }
        } else {
          caretPosition = valueSize;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalLeft) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
              caretPosition = integerSize;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
              caretPosition = positiveNegativeSignSize + integerSize;
              break;
          }
        } else {
          caretPosition = integerSize;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalRight) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
              caretPosition = integerSize + offsetDecimalChar;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
              caretPosition = positiveNegativeSignSize + integerSize + offsetDecimalChar;
              break;
          }
        } else {
          caretPosition = integerSize + offsetDecimalChar;
        }
      }
    }
    return caretPosition;
  }
  /**
   * Truncate the trailing zeroes to the given number of decimal places
   *
   * @param {string} roundedInputValue
   * @param {int} decimalPlacesNeeded The number of decimal places to keep
   * @returns {string}
   */
  static _truncateZeros(roundedInputValue, decimalPlacesNeeded) {
    let regex;
    switch (decimalPlacesNeeded) {
      case 0:
        regex = /(\.(?:\d*[1-9])?)0*$/;
        break;
      case 1:
        regex = /(\.\d(?:\d*[1-9])?)0*$/;
        break;
      default:
        regex = new RegExp(`(\\.\\d{${decimalPlacesNeeded}}(?:\\d*[1-9])?)0*`);
    }
    roundedInputValue = roundedInputValue.replace(regex, "$1");
    if (decimalPlacesNeeded === 0) {
      roundedInputValue = roundedInputValue.replace(/\.$/, "");
    }
    return roundedInputValue;
  }
  /**
   * Round the given `value` with the number of decimal places to keep for the raw value.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @returns {*}
   * @private
   */
  static _roundRawValue(value, settings) {
    return this._roundValue(value, settings, settings.decimalPlacesRawValue);
  }
  /**
   * Round the given `value` with the number of decimal places to show for the element if focused.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @returns {*}
   * @private
   */
  static _roundFormattedValueShownOnFocus(value, settings) {
    return this._roundValue(value, settings, Number(settings.decimalPlacesShownOnFocus));
  }
  /**
   * Round the given `value` with the number of decimal places to show for the element if unfocused.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @returns {*}
   * @private
   */
  static _roundFormattedValueShownOnBlur(value, settings) {
    return this._roundValue(value, settings, Number(settings.decimalPlacesShownOnBlur));
  }
  /**
   * Round the given `value` with the number of decimal places to show for the element based on the value of isFocused.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @param {boolean} isFocused
   * @returns {*}
   * @private
   */
  static _roundFormattedValueShownOnFocusOrBlur(value, settings, isFocused) {
    if (isFocused) {
      return this._roundFormattedValueShownOnFocus(value, settings);
    } else {
      return this._roundFormattedValueShownOnBlur(value, settings);
    }
  }
  /**
   * Round the input value using the rounding method defined in the settings.
   * This function accepts multiple rounding methods. See the documentation for more details about those.
   *
   * Note : This is handled as text since JavaScript math functions can return inaccurate values.
   *
   * @param {string|null} inputValue An unformatted numeric value
   * @param {object} settings
   * @param {int} decimalPlacesToRoundTo
   * @returns {*}
   */
  static _roundValue(inputValue, settings, decimalPlacesToRoundTo) {
    if (AutoNumericHelper.isNull(inputValue)) {
      return inputValue;
    }
    inputValue = inputValue === "" ? "0" : inputValue.toString();
    if (settings.roundingMethod === _AutoNumeric.options.roundingMethod.toNearest05 || settings.roundingMethod === _AutoNumeric.options.roundingMethod.toNearest05Alt || settings.roundingMethod === _AutoNumeric.options.roundingMethod.upToNext05 || settings.roundingMethod === _AutoNumeric.options.roundingMethod.downToNext05) {
      return this._roundCloseTo05(inputValue, settings);
    }
    const [negativeSign, preparedValue] = _AutoNumeric._prepareValueForRounding(inputValue, settings);
    inputValue = preparedValue;
    const decimalCharacterPosition = inputValue.lastIndexOf(".");
    const inputValueHasNoDot = decimalCharacterPosition === -1;
    const [integerPart, decimalPart] = inputValue.split(".");
    const hasDecimals = decimalPart > 0;
    if (!hasDecimals && (settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.never || settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.floats)) {
      return Number(inputValue) === 0 ? integerPart : `${negativeSign}${integerPart}`;
    }
    let temporaryDecimalPlacesOverride;
    if (settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.always || settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.floats) {
      temporaryDecimalPlacesOverride = decimalPlacesToRoundTo;
    } else if (settings.allowDecimalPadding > 0) {
      temporaryDecimalPlacesOverride = settings.allowDecimalPadding;
    } else {
      temporaryDecimalPlacesOverride = 0;
    }
    const decimalPositionToUse = inputValueHasNoDot ? inputValue.length - 1 : decimalCharacterPosition;
    let checkDecimalPlaces = inputValue.length - 1 - decimalPositionToUse;
    let inputValueRounded = "";
    if (checkDecimalPlaces <= decimalPlacesToRoundTo) {
      inputValueRounded = inputValue;
      if (checkDecimalPlaces < temporaryDecimalPlacesOverride) {
        if (inputValueHasNoDot) {
          inputValueRounded = `${inputValueRounded}${settings.decimalCharacter}`;
        }
        let zeros = "000000";
        while (checkDecimalPlaces < temporaryDecimalPlacesOverride) {
          zeros = zeros.substring(0, temporaryDecimalPlacesOverride - checkDecimalPlaces);
          inputValueRounded += zeros;
          checkDecimalPlaces += zeros.length;
        }
      } else if (checkDecimalPlaces > temporaryDecimalPlacesOverride) {
        inputValueRounded = this._truncateZeros(inputValueRounded, temporaryDecimalPlacesOverride);
      } else if (checkDecimalPlaces === 0 && temporaryDecimalPlacesOverride === 0) {
        inputValueRounded = inputValueRounded.replace(/\.$/, "");
      }
      return Number(inputValueRounded) === 0 ? inputValueRounded : `${negativeSign}${inputValueRounded}`;
    }
    let roundedStrLength;
    if (inputValueHasNoDot) {
      roundedStrLength = decimalPlacesToRoundTo - 1;
    } else {
      roundedStrLength = Number(decimalPlacesToRoundTo) + Number(decimalCharacterPosition);
    }
    const lastDigit = Number(inputValue.charAt(roundedStrLength + 1));
    let inputValueArray = inputValue.substring(0, roundedStrLength + 1).split("");
    let odd;
    if (inputValue.charAt(roundedStrLength) === ".") {
      odd = inputValue.charAt(roundedStrLength - 1) % 2;
    } else {
      odd = inputValue.charAt(roundedStrLength) % 2;
    }
    if (this._shouldRoundUp(lastDigit, settings, negativeSign, odd)) {
      for (let i = inputValueArray.length - 1; i >= 0; i -= 1) {
        if (inputValueArray[i] !== ".") {
          inputValueArray[i] = +inputValueArray[i] + 1;
          if (inputValueArray[i] < 10) {
            break;
          }
          if (i > 0) {
            inputValueArray[i] = "0";
          }
        }
      }
    }
    inputValueArray = inputValueArray.slice(0, roundedStrLength + 1);
    inputValueRounded = this._truncateZeros(inputValueArray.join(""), temporaryDecimalPlacesOverride);
    return Number(inputValueRounded) === 0 ? inputValueRounded : `${negativeSign}${inputValueRounded}`;
  }
  /**
   * Round the `value` when the rounding method deals with '.05'
   *
   * @param {string} value
   * @param {object} settings
   * @returns {string}
   * @private
   */
  static _roundCloseTo05(value, settings) {
    switch (settings.roundingMethod) {
      case _AutoNumeric.options.roundingMethod.toNearest05:
      case _AutoNumeric.options.roundingMethod.toNearest05Alt:
        value = (Math.round(value * 20) / 20).toString();
        break;
      case _AutoNumeric.options.roundingMethod.upToNext05:
        value = (Math.ceil(value * 20) / 20).toString();
        break;
      default:
        value = (Math.floor(value * 20) / 20).toString();
    }
    let result;
    if (!AutoNumericHelper.contains(value, ".")) {
      result = value + ".00";
    } else if (value.length - value.indexOf(".") < 3) {
      result = value + "0";
    } else {
      result = value;
    }
    return result;
  }
  /**
   * Modify the given `value` in order to make it usable for the rest of the rounding function.
   * This convert the `value` to a positive one, trim any leading zeros and make sure it does not start with a leading dot.
   *
   * @param {string} value The unformatted value
   * @param {object} settings
   * @returns {[string, string]}
   * @private
   */
  static _prepareValueForRounding(value, settings) {
    let negativeSign = "";
    if (AutoNumericHelper.isNegativeStrict(value, "-")) {
      negativeSign = "-";
      value = value.replace("-", "");
    }
    if (!value.match(/^\d/)) {
      value = `0${value}`;
    }
    if (Number(value) === 0) {
      negativeSign = "";
    }
    if (Number(value) > 0 && settings.leadingZero !== _AutoNumeric.options.leadingZero.keep || value.length > 0 && settings.leadingZero === _AutoNumeric.options.leadingZero.allow) {
      value = value.replace(/^0*(\d)/, "$1");
    }
    return [negativeSign, value];
  }
  /**
   * Return `true` if a round up should be done given the last digit, the settings and other information about the value.
   *
   * @param {number} lastDigit
   * @param {object} settings
   * @param {string} negativeSign This variable comes from `_prepareValueForRounding()`, which return `'-'` if the initial value was negative
   * @param {number} odd
   * @returns {boolean}
   * @private
   */
  static _shouldRoundUp(lastDigit, settings, negativeSign, odd) {
    return lastDigit > 4 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfUpSymmetric || // Round half up symmetric
    lastDigit > 4 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfUpAsymmetric && negativeSign === "" || // Round half up asymmetric positive values
    lastDigit > 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfUpAsymmetric && negativeSign === "-" || // Round half up asymmetric negative values
    lastDigit > 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfDownSymmetric || // Round half down symmetric
    lastDigit > 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfDownAsymmetric && negativeSign === "" || // Round half down asymmetric positive values
    lastDigit > 4 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfDownAsymmetric && negativeSign === "-" || // Round half down asymmetric negative values
    lastDigit > 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfEvenBankersRounding || lastDigit === 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfEvenBankersRounding && odd === 1 || lastDigit > 0 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.toCeilingTowardPositiveInfinity && negativeSign === "" || lastDigit > 0 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.toFloorTowardNegativeInfinity && negativeSign === "-" || lastDigit > 0 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.upRoundAwayFromZero;
  }
  /**
   * Truncates the decimal part of a number to the given number of decimal places `decimalPlacesToRoundTo`.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} isPaste
   * @param {int} decimalPlacesToRoundTo
   * @returns {*}
   */
  static _truncateDecimalPlaces(value, settings, isPaste, decimalPlacesToRoundTo) {
    if (isPaste) {
      value = this._roundFormattedValueShownOnFocus(value, settings);
    }
    const [integerPart, decimalPart] = value.split(settings.decimalCharacter);
    if (decimalPart && decimalPart.length > decimalPlacesToRoundTo) {
      if (decimalPlacesToRoundTo > 0) {
        const modifiedDecimalPart = decimalPart.substring(0, decimalPlacesToRoundTo);
        value = `${integerPart}${settings.decimalCharacter}${modifiedDecimalPart}`;
      } else {
        value = integerPart;
      }
    }
    return value;
  }
  /**
   * Check if the given value is within the `minimumValue` and `maximumValue` range, while using the override options set with `overrideMinMaxLimits`.
   * The minimum and maximum limit test results are returned in an array like `[isMinimumLimitRespected, isMaximumLimitRespected]`.
   *
   * @param {string} value
   * @param {object} settings
   * @returns {[boolean, boolean]}
   */
  static _checkIfInRangeWithOverrideOption(value, settings) {
    if (AutoNumericHelper.isNull(value) && settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.null || // When the `null` value is accepted as the `rawValue`, the limits are ignored
    settings.overrideMinMaxLimits === _AutoNumeric.options.overrideMinMaxLimits.ignore || settings.overrideMinMaxLimits === _AutoNumeric.options.overrideMinMaxLimits.invalid) {
      return [true, true];
    }
    value = value.toString();
    value = value.replace(",", ".");
    const minParse = AutoNumericHelper.parseStr(settings.minimumValue);
    const maxParse = AutoNumericHelper.parseStr(settings.maximumValue);
    const valParse = AutoNumericHelper.parseStr(value);
    let result;
    switch (settings.overrideMinMaxLimits) {
      case _AutoNumeric.options.overrideMinMaxLimits.floor:
        result = [AutoNumericHelper.testMinMax(minParse, valParse) > -1, true];
        break;
      case _AutoNumeric.options.overrideMinMaxLimits.ceiling:
        result = [true, AutoNumericHelper.testMinMax(maxParse, valParse) < 1];
        break;
      default:
        result = [AutoNumericHelper.testMinMax(minParse, valParse) > -1, AutoNumericHelper.testMinMax(maxParse, valParse) < 1];
    }
    return result;
  }
  /**
   * Returns `true` if the given value is within the `minimumValue` and `maximumValue` limits, while using the override options set with `overrideMinMaxLimits`, `false` otherwise
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isWithinRangeWithOverrideOption(value, settings) {
    const [minTest, maxTest] = this._checkIfInRangeWithOverrideOption(value, settings);
    return minTest && maxTest;
  }
  /**
   * Helper function that prepares the value string for the min/max test
   *
   * @param {string} value
   * @returns {{}}
   * @private
   */
  static _cleanValueForRangeParse(value) {
    value = value.toString().replace(",", ".");
    return AutoNumericHelper.parseStr(value);
  }
  /**
   * Returns `true` is the value is superior or equal to the `minimumValue` limit, discarding any override options
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isMinimumRangeRespected(value, settings) {
    return AutoNumericHelper.testMinMax(AutoNumericHelper.parseStr(settings.minimumValue), this._cleanValueForRangeParse(value)) > -1;
  }
  /**
   * Returns `true` is the value is inferior or equal to the `maximumValue` limit, discarding any override options
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isMaximumRangeRespected(value, settings) {
    return AutoNumericHelper.testMinMax(AutoNumericHelper.parseStr(settings.maximumValue), this._cleanValueForRangeParse(value)) < 1;
  }
  /**
   * Helper function that triggers the range events if they are needed
   *
   * @param {boolean} minTest
   * @param {boolean} maxTest
   * @private
   */
  _triggerRangeEvents(minTest, maxTest) {
    if (!minTest) {
      this._triggerEvent(_AutoNumeric.events.minRangeExceeded, this.domElement);
    }
    if (!maxTest) {
      this._triggerEvent(_AutoNumeric.events.maxRangeExceeded, this.domElement);
    }
  }
  /**
   * Set the invalid state on the AutoNumeric element.
   * If the element is not an input, and therefore a contenteditable-enabled element, its validity state cannot be changed.
   * In that case, the invalid css class defined with the `settings.invalidClass` option is added to the element.
   * The 'autoNumeric:invalidValue' event is always sent when this function is called.
   *
   * @private
   */
  _setInvalidState() {
    if (this.isInputElement) {
      AutoNumericHelper.setInvalidState(this.domElement);
    } else {
      this._addCSSClass(this.settings.invalidClass);
    }
    this._triggerEvent(_AutoNumeric.events.invalidValue, this.domElement);
    this.validState = false;
  }
  /**
   * Set the valid state on the AutoNumeric element.
   * If the element is not an input, and therefore a contenteditable-enabled element, its validity state cannot be changed.
   * In that case, the invalid css class defined with the `settings.invalidClass` option is removed.
   * The 'autoNumeric:correctedValue' event is sent if the element state is invalid when this is called.
   *
   * @private
   */
  _setValidState() {
    if (this.isInputElement) {
      AutoNumericHelper.setValidState(this.domElement);
    } else {
      this._removeCSSClass(this.settings.invalidClass);
    }
    if (!this.validState) {
      this._triggerEvent(_AutoNumeric.events.correctedValue, this.domElement);
    }
    this.validState = true;
  }
  /**
   * Sets the valid or invalid state on the DOM element, if the value is within the range set by the minimum and maximum value
   *
   * @param {string} value
   * @private
   */
  _setValidOrInvalidState(value) {
    if (this.settings.overrideMinMaxLimits === _AutoNumeric.options.overrideMinMaxLimits.invalid) {
      const minRangeOk = this.constructor._isMinimumRangeRespected(value, this.settings);
      const maxRangeOk = this.constructor._isMaximumRangeRespected(value, this.settings);
      if (minRangeOk && maxRangeOk) {
        this._setValidState();
      } else {
        this._setInvalidState();
      }
      this._triggerRangeEvents(minRangeOk, maxRangeOk);
    }
  }
  /**
   * Original settings saved for use when the `decimalPlacesShownOnFocus` and `showOnlyNumbersOnFocus` options are used.
   * Those original settings are used exclusively in the `focusin` and `focusout` event handlers.
   */
  _keepAnOriginalSettingsCopy() {
    this.originalDigitGroupSeparator = this.settings.digitGroupSeparator;
    this.originalCurrencySymbol = this.settings.currencySymbol;
    this.originalSuffixText = this.settings.suffixText;
  }
  /**
   * Removes any zeros in excess in the front and back of the given `value`, according to the `settings`.
   * This also manages the cases where the decimal point is on the far left or far right of the `value`.
   *
   * @param {string} value
   * @returns {string|null}
   */
  _trimLeadingAndTrailingZeros(value) {
    if (value === "" || value === null) {
      return value;
    }
    if (this.settings.leadingZero !== _AutoNumeric.options.leadingZero.keep) {
      if (Number(value) === 0) {
        return "0";
      }
      value = value.replace(/^(-)?0+(?=\d)/g, "$1");
    }
    if (AutoNumericHelper.contains(value, ".")) {
      value = value.replace(/(\.[0-9]*?)0+$/, "$1");
    }
    value = value.replace(/\.$/, "");
    return value;
  }
  /**
   * Generate the name for the persistent stored data variable
   * @private
   */
  _setPersistentStorageName() {
    if (this.settings.saveValueToSessionStorage) {
      if (this.domElement.name !== "" && !AutoNumericHelper.isUndefined(this.domElement.name)) {
        this.rawValueStorageName = `${this.storageNamePrefix}${decodeURIComponent(this.domElement.name)}`;
      } else {
        this.rawValueStorageName = `${this.storageNamePrefix}${this.domElement.id}`;
      }
    }
  }
  /**
   * Save the raw Value into sessionStorage or a cookie depending on what the browser is supporting.
   * @private
   */
  _saveValueToPersistentStorage() {
    if (this.settings.saveValueToSessionStorage) {
      sessionStorage.setItem(this.rawValueStorageName, this.rawValue);
    }
  }
  /**
   * Retrieve the raw value from sessionStorage or the cookie depending on what the browser is supporting.
   *
   * @returns {*}
   * @private
   */
  _getValueFromPersistentStorage() {
    if (this.settings.saveValueToSessionStorage) {
      return sessionStorage.getItem(this.rawValueStorageName);
    }
    AutoNumericHelper.warning("`_getValueFromPersistentStorage()` is called but `settings.saveValueToSessionStorage` is false. There must be an error that needs fixing.", this.settings.showWarnings);
    return null;
  }
  /**
   * Remove the raw value data from sessionStorage or the cookie depending on what the browser is supporting.
   * @private
   */
  _removeValueFromPersistentStorage() {
    if (this.settings.saveValueToSessionStorage) {
      sessionStorage.removeItem(this.rawValueStorageName);
    }
  }
  /**
   * Get the default value from the html `value` attribute.
   * Return the empty string if such attribute is not found.
   *
   * @param {HTMLElement} domElement
   *
   * @returns {string}
   * @private
   */
  _getDefaultValue(domElement) {
    const value = domElement.getAttribute("value");
    if (AutoNumericHelper.isNull(value)) {
      return "";
    }
    return value;
  }
  /**
   * Handler for 'focusin' and 'mouseenter' events
   * On focusin, multiple things happens :
   * - If `Alt` is pressed, unformat
   * - Remove the separators if `showOnlyNumbersOnFocus` is set
   * - Depending on `emptyInputBehavior`, reformat the empty formatted value
   * - Display the correct number of decimal places (on focus/blur)
   * - Place the caret correctly if the element is empty
   *
   * Note: On focusin, the `rawValue` is never changed. Only the formatted value can be modified.
   *
   * @param {KeyboardEvent|MouseEvent} e
   * @private
   */
  _onFocusInAndMouseEnter(e) {
    this.isEditing = false;
    if (!this.formulaMode && this.settings.unformatOnHover && e.type === "mouseenter" && e.altKey) {
      this.constructor._unformatAltHovered(this);
      return;
    }
    if (e.type === "focus") {
      this.isFocused = true;
      this.rawValueOnFocus = this.rawValue;
    }
    if (e.type === "focus" && this.settings.unformatOnHover && this.hoveredWithAlt) {
      this.constructor._reformatAltHovered(this);
    }
    if (e.type === "focus" || e.type === "mouseenter" && !this.isFocused) {
      let elementValueToSet = null;
      if (this.settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.focus && this.rawValue < 0 && this.settings.negativeBracketsTypeOnBlur !== null && this.settings.isNegativeSignAllowed) {
        elementValueToSet = this.constructor._removeBrackets(AutoNumericHelper.getElementValue(this.domElement), this.settings);
      }
      const rawValueToFormat = this._getRawValueToFormat(this.rawValue);
      if (rawValueToFormat !== "") {
        const roundedValue = this.constructor._roundFormattedValueShownOnFocusOrBlur(rawValueToFormat, this.settings, this.isFocused);
        if (this.settings.showOnlyNumbersOnFocus === _AutoNumeric.options.showOnlyNumbersOnFocus.onlyNumbers) {
          this.settings.digitGroupSeparator = "";
          this.settings.currencySymbol = "";
          this.settings.suffixText = "";
          elementValueToSet = roundedValue.replace(".", this.settings.decimalCharacter);
        } else {
          let formattedValue;
          if (AutoNumericHelper.isNull(roundedValue)) {
            formattedValue = "";
          } else {
            formattedValue = this.constructor._addGroupSeparators(roundedValue.replace(".", this.settings.decimalCharacter), this.settings, this.isFocused, rawValueToFormat);
          }
          elementValueToSet = formattedValue;
        }
      }
      if (AutoNumericHelper.isNull(elementValueToSet)) {
        this.valueOnFocus = "";
      } else {
        this.valueOnFocus = elementValueToSet;
      }
      this.lastVal = this.valueOnFocus;
      const isEmptyValue = this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(this.valueOnFocus, this.settings);
      const orderedValue = this.constructor._orderValueCurrencySymbolAndSuffixText(this.valueOnFocus, this.settings, true);
      const orderedValueTest = isEmptyValue && orderedValue !== "" && this.settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.focus;
      if (orderedValueTest) {
        elementValueToSet = orderedValue;
      }
      if (!AutoNumericHelper.isNull(elementValueToSet)) {
        this._setElementValue(elementValueToSet);
      }
      if (orderedValueTest && orderedValue === this.settings.currencySymbol && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
        AutoNumericHelper.setElementSelection(e.target, 0);
      }
    }
  }
  /**
   * Handler for the 'focus' event.
   * We update the info of the focused state in the `this.isFocused` variable when the element gets focused.
   * @private
   */
  _onFocus() {
    if (this.settings.isCancellable) {
      this._saveCancellableValue();
    }
  }
  /**
   * Handler for the 'focusin' event.
   * This is called before the 'focus' event, and is necessary to change the selection on focus under Firefox for instance.
   *
   * @param {Event} e
   * @private
   */
  _onFocusIn(e) {
    if (this.settings.selectOnFocus) {
      this.select();
    } else {
      if (!AutoNumericHelper.isNull(this.settings.caretPositionOnFocus)) {
        AutoNumericHelper.setElementSelection(e.target, this._initialCaretPosition(AutoNumericHelper.getElementValue(this.domElement)));
      }
    }
  }
  /**
   * Enter the special 'formula mode' where users can enter a math expression that will be evaluated on blur and `enter`
   * @private
   */
  _enterFormulaMode() {
    if (this.settings.formulaMode) {
      this.formulaMode = true;
      AutoNumericHelper.setElementValue(this.domElement, "=");
      AutoNumericHelper.setElementSelection(this.domElement, 1);
    }
  }
  /**
   * Exit the formula mode
   * Tries to parse and evaluate the math expression, then `set()` the result if it's correct, otherwise reformat with the previous `rawValue`
   * @private
   */
  _exitFormulaMode() {
    let formula = AutoNumericHelper.getElementValue(this.domElement);
    formula = formula.replace(/^\s*=/, "");
    let result;
    try {
      const ast = new Parser(formula, this.settings.decimalCharacter);
      result = new Evaluator().evaluate(ast);
    } catch (e) {
      this._triggerEvent(_AutoNumeric.events.invalidFormula, this.domElement, {
        formula,
        aNElement: this
      });
      this.reformat();
      this.formulaMode = false;
      return;
    }
    this._triggerEvent(_AutoNumeric.events.validFormula, this.domElement, {
      formula,
      result,
      aNElement: this
    });
    this.set(result);
    this.formulaMode = false;
  }
  /**
   * Returns `true` if the non-printable key is accepted in formula mode
   *
   * @returns {boolean}
   * @private
   */
  _acceptNonPrintableKeysInFormulaMode() {
    return this.eventKey === AutoNumericEnum_default.keyName.Backspace || this.eventKey === AutoNumericEnum_default.keyName.Delete || this.eventKey === AutoNumericEnum_default.keyName.LeftArrow || this.eventKey === AutoNumericEnum_default.keyName.RightArrow || this.eventKey === AutoNumericEnum_default.keyName.Home || this.eventKey === AutoNumericEnum_default.keyName.End;
  }
  /**
   * Handler for 'keydown' events.
   * The user just started pushing any key, hence one event is sent.
   *
   * Note :
   * By default a 'normal' input output those events in the right order when inputting a character key (i.e. 'a') :
   * - keydown
   * - keypress
   * - input
   * - keyup
   *
   * ...when inputting a modifier key (i.e. 'ctrl') :
   * - keydown
   * - keyup
   *
   * If 'delete' or 'backspace' are entered 'normally', the following events are sent :
   * - keydown
   * - input
   * - keyup
   *
   * If 'delete' or 'backspace' are entered continuously (with the key still pressed), the following events are sent :
   * - keydown
   * - input
   * [- keydown
   * - input] x times
   * - keyup
   *
   * If 'enter' is entered and the value has not changed, the following events are sent :
   * - keydown
   * - keypress
   * - keyup
   *
   * If 'enter' is entered and the value has been changed, the following events are sent :
   * - keydown
   * - keypress
   * - change
   * - keyup
   *
   * When a paste is done, the following events are sent :
   * - input (if paste is done with the mouse)
   *
   * - keydown (if paste is done with ctrl+v)
   * - keydown
   * - input
   * - keyup
   * - keyup
   *
   * @param {KeyboardEvent} e
   */
  _onKeydown(e) {
    this.formatted = false;
    this.isEditing = true;
    if (!this.formulaMode && !this.isFocused && this.settings.unformatOnHover && e.altKey && this.domElement === AutoNumericHelper.getHoveredElement()) {
      this.constructor._unformatAltHovered(this);
      return;
    }
    this._updateEventKeyInfo(e);
    this.keydownEventCounter += 1;
    if (this.keydownEventCounter === 1) {
      this.initialValueOnFirstKeydown = AutoNumericHelper.getElementValue(e.target);
      this.initialRawValueOnFirstKeydown = this.rawValue;
    }
    if (this.formulaMode) {
      if (this.eventKey === AutoNumericEnum_default.keyName.Esc) {
        this.formulaMode = false;
        this.reformat();
        return;
      }
      if (this.eventKey === AutoNumericEnum_default.keyName.Enter) {
        this._exitFormulaMode();
        return;
      }
      if (this._acceptNonPrintableKeysInFormulaMode()) {
        return;
      }
    } else {
      if (this.eventKey === AutoNumericEnum_default.keyName.Equal) {
        this._enterFormulaMode();
        return;
      }
      if (this.settings.modifyValueOnUpDownArrow && (this.eventKey === AutoNumericEnum_default.keyName.UpArrow || this.eventKey === AutoNumericEnum_default.keyName.DownArrow)) {
        this.upDownArrowAction(e);
        return;
      }
    }
    if (this.domElement.readOnly || this.settings.readOnly || this.domElement.disabled) {
      this.processed = true;
      return;
    }
    if (this.eventKey === AutoNumericEnum_default.keyName.Esc) {
      e.preventDefault();
      if (this.settings.isCancellable) {
        if (this.rawValue !== this.savedCancellableValue) {
          this.set(this.savedCancellableValue);
          this._triggerEvent(_AutoNumeric.events.native.input, e.target);
        }
      }
      this.select();
    }
    let targetValue = AutoNumericHelper.getElementValue(e.target);
    if (this.eventKey === AutoNumericEnum_default.keyName.Enter && this.rawValue !== this.rawValueOnFocus) {
      this._triggerEvent(_AutoNumeric.events.native.change, e.target);
      this.valueOnFocus = targetValue;
      this.rawValueOnFocus = this.rawValue;
      if (this.settings.isCancellable) {
        this._saveCancellableValue();
      }
    }
    this._updateInternalProperties(e);
    if (this._processNonPrintableKeysAndShortcuts(e)) {
      this.processed = true;
      return;
    }
    if (this.eventKey === AutoNumericEnum_default.keyName.Backspace || this.eventKey === AutoNumericEnum_default.keyName.Delete) {
      const isDeletionAllowed = this._processCharacterDeletion(e);
      this.processed = true;
      if (!isDeletionAllowed) {
        e.preventDefault();
        return;
      }
      this._formatValue(e);
      targetValue = AutoNumericHelper.getElementValue(e.target);
      if (targetValue !== this.lastVal && this.throwInput) {
        this._triggerEvent(_AutoNumeric.events.native.input, e.target);
        e.preventDefault();
      }
      this.lastVal = targetValue;
      this.throwInput = true;
    }
  }
  /**
   * Handler for 'keypress' events.
   * The user is still pressing the key, which will output a character (i.e. '2') continuously until he releases the key.
   * Note: 'keypress' events are not sent for delete keys like Backspace/Delete.
   *
   * @param {KeyboardEvent} e
   */
  _onKeypress(e) {
    if (this.formulaMode) {
      if (this._acceptNonPrintableKeysInFormulaMode()) {
        return;
      }
      if (this.settings.formulaChars.test(this.eventKey)) {
        return;
      } else {
        e.preventDefault();
      }
      return;
    }
    if (this.eventKey === AutoNumericEnum_default.keyName.Insert) {
      return;
    }
    const processed = this.processed;
    this._updateInternalProperties(e);
    if (this._processNonPrintableKeysAndShortcuts(e)) {
      return;
    }
    if (processed) {
      e.preventDefault();
      return;
    }
    const isCharacterInsertionAllowed = this._processCharacterInsertion();
    if (isCharacterInsertionAllowed) {
      this._formatValue(e);
      const targetValue = AutoNumericHelper.getElementValue(e.target);
      if (targetValue !== this.lastVal && this.throwInput) {
        this._triggerEvent(_AutoNumeric.events.native.input, e.target);
        e.preventDefault();
      } else {
        if ((this.eventKey === this.settings.decimalCharacter || this.eventKey === this.settings.decimalCharacterAlternative) && AutoNumericHelper.getElementSelection(e.target).start === AutoNumericHelper.getElementSelection(e.target).end && AutoNumericHelper.getElementSelection(e.target).start === targetValue.indexOf(this.settings.decimalCharacter)) {
          const position = AutoNumericHelper.getElementSelection(e.target).start + 1;
          AutoNumericHelper.setElementSelection(e.target, position);
        }
        e.preventDefault();
      }
      this.lastVal = AutoNumericHelper.getElementValue(e.target);
      this.throwInput = true;
      this._setValidOrInvalidState(this.rawValue);
      return;
    }
    e.preventDefault();
  }
  /**
   * Handler for 'keyup' events.
   * The user just released any key, hence one event is sent.
   *
   * @param {KeyboardEvent} e
   */
  _onKeyup(e) {
    this.isEditing = false;
    this.keydownEventCounter = 0;
    if (this.formulaMode) {
      return;
    }
    if (this.settings.isCancellable && this.eventKey === AutoNumericEnum_default.keyName.Esc) {
      e.preventDefault();
      return;
    }
    this._updateEventKeyInfo(e);
    if (this.eventKey === AutoNumericEnum_default.keyName.Z || this.eventKey === AutoNumericEnum_default.keyName.z) {
      if (e.ctrlKey && e.shiftKey) {
        e.preventDefault();
        this._historyTableRedo();
        this._triggerEvent(_AutoNumeric.events.native.input, e.target);
        this.onGoingRedo = true;
        return;
      } else if (e.ctrlKey && !e.shiftKey) {
        if (this.onGoingRedo) {
          this.onGoingRedo = false;
        } else {
          e.preventDefault();
          this._historyTableUndo();
          this._triggerEvent(_AutoNumeric.events.native.input, e.target);
          return;
        }
      }
    } else if ((this.eventKey === AutoNumericEnum_default.keyName.Y || this.eventKey === AutoNumericEnum_default.keyName.y) && e.ctrlKey) {
      e.preventDefault();
      this._historyTableRedo();
      this._triggerEvent(_AutoNumeric.events.native.input, e.target);
      this.onGoingRedo = true;
      return;
    }
    if (this.onGoingRedo && (e.ctrlKey || e.shiftKey)) {
      this.onGoingRedo = false;
    }
    if ((e.ctrlKey || e.metaKey) && (this.eventKey === AutoNumericEnum_default.keyName.X || this.eventKey === AutoNumericEnum_default.keyName.x)) {
      const caretPosition = AutoNumericHelper.getElementSelection(this.domElement).start;
      const cutNumber = this.constructor._toNumericValue(AutoNumericHelper.getElementValue(e.target), this.settings);
      this.set(cutNumber);
      this._setCaretPosition(caretPosition);
    }
    if (this.eventKey === AutoNumericEnum_default.keyName.Alt && this.settings.unformatOnHover && this.hoveredWithAlt) {
      this.constructor._reformatAltHovered(this);
      return;
    }
    if ((e.ctrlKey || e.metaKey) && (this.eventKey === AutoNumericEnum_default.keyName.Backspace || this.eventKey === AutoNumericEnum_default.keyName.Delete)) {
      const targetValue2 = AutoNumericHelper.getElementValue(e.target);
      this._setRawValue(this._formatOrUnformatOther(false, targetValue2));
      return;
    }
    this._updateInternalProperties(e);
    const skip = this._processNonPrintableKeysAndShortcuts(e);
    delete this.valuePartsBeforePaste;
    const targetValue = AutoNumericHelper.getElementValue(e.target);
    if (skip || targetValue === "" && this.initialValueOnFirstKeydown === "") {
      return;
    }
    if (targetValue === this.settings.currencySymbol) {
      if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
        AutoNumericHelper.setElementSelection(e.target, 0);
      } else {
        AutoNumericHelper.setElementSelection(e.target, this.settings.currencySymbol.length);
      }
    } else if (this.eventKey === AutoNumericEnum_default.keyName.Tab) {
      AutoNumericHelper.setElementSelection(e.target, 0, targetValue.length);
    }
    if (targetValue === this.settings.suffixText || this.rawValue === "" && this.settings.currencySymbol !== "" && this.settings.suffixText !== "") {
      AutoNumericHelper.setElementSelection(e.target, 0);
    }
    if (this.settings.decimalPlacesShownOnFocus !== null) {
      this._saveValueToPersistentStorage();
    }
    if (!this.formatted) {
      this._formatValue(e);
    }
    this._setValidOrInvalidState(this.rawValue);
    this._saveRawValueForAndroid();
    if (targetValue !== this.initialValueOnFirstKeydown) {
      this._triggerEvent(_AutoNumeric.events.formatted, e.target, {
        oldValue: this.initialValueOnFirstKeydown,
        newValue: targetValue,
        oldRawValue: this.initialRawValueOnFirstKeydown,
        newRawValue: this.rawValue,
        isPristine: this.isPristine(false),
        error: null,
        aNElement: this
      });
    }
    if (this.historyTable.length > 1) {
      const selection = AutoNumericHelper.getElementSelection(this.domElement);
      this.selectionStart = selection.start;
      this.selectionEnd = selection.end;
      this.historyTable[this.historyTableIndex].start = this.selectionStart;
      this.historyTable[this.historyTableIndex].end = this.selectionEnd;
    }
  }
  /**
   * On Android Chrome, the `rawValue` is not updated when the user changes the input value.
   * This function updates the `rawValue` accordingly.
   * @private
   */
  _saveRawValueForAndroid() {
    if (this.eventKey === AutoNumericEnum_default.keyName.AndroidDefault) {
      let normalizedValue = this.constructor._stripAllNonNumberCharactersExceptCustomDecimalChar(this.getFormatted(), this.settings, true, this.isFocused);
      normalizedValue = this.constructor._convertToNumericString(normalizedValue, this.settings);
      this._setRawValue(normalizedValue);
    }
  }
  /**
   * Handler for 'focusout' events
   * On focusout, multiple things happens :
   * - The element value is formatted back if the `Alt` key was pressed,
   * - The element value is formatted back if `showOnlyNumbersOnFocus` was set to only show numbers,
   * - The element value is multiplied by `rawValueDivisor` on `blur`
   *
   * Note: On focusout, the `rawValue` is never changed. Only the formatted value can be modified.
   *
   * @param {Event} e
   */
  _onFocusOutAndMouseLeave(e) {
    this.isEditing = false;
    if (e.type === "mouseleave" && this.formulaMode) {
      return;
    }
    if (this.settings.unformatOnHover && e.type === "mouseleave" && this.hoveredWithAlt) {
      this.constructor._reformatAltHovered(this);
      return;
    }
    if (e.type === "mouseleave" && !this.isFocused || e.type === "blur") {
      if (e.type === "blur" && this.formulaMode) {
        this._exitFormulaMode();
      }
      this._saveValueToPersistentStorage();
      if (this.settings.showOnlyNumbersOnFocus === _AutoNumeric.options.showOnlyNumbersOnFocus.onlyNumbers) {
        this.settings.digitGroupSeparator = this.originalDigitGroupSeparator;
        this.settings.currencySymbol = this.originalCurrencySymbol;
        this.settings.suffixText = this.originalSuffixText;
      }
      const rawValueToFormat = this._getRawValueToFormat(this.rawValue);
      const isRawValueNull = AutoNumericHelper.isNull(rawValueToFormat);
      const [minTest, maxTest] = this.constructor._checkIfInRangeWithOverrideOption(rawValueToFormat, this.settings);
      let elementValueIsAlreadySet = false;
      if (rawValueToFormat !== "" && !isRawValueNull) {
        this._triggerRangeEvents(minTest, maxTest);
        if (this.settings.valuesToStrings && this._checkValuesToStrings(rawValueToFormat)) {
          this._setElementValue(this.settings.valuesToStrings[rawValueToFormat]);
          elementValueIsAlreadySet = true;
        }
      }
      if (!elementValueIsAlreadySet) {
        let value;
        if (isRawValueNull || rawValueToFormat === "") {
          value = rawValueToFormat;
        } else {
          value = String(rawValueToFormat);
        }
        if (rawValueToFormat !== "" && !isRawValueNull) {
          if (minTest && maxTest && !this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(rawValueToFormat, this.settings)) {
            value = this._modifyNegativeSignAndDecimalCharacterForRawValue(value);
            if (this.settings.divisorWhenUnfocused && !AutoNumericHelper.isNull(value)) {
              value = value / this.settings.divisorWhenUnfocused;
              value = value.toString();
            }
            value = this.constructor._roundFormattedValueShownOnBlur(value, this.settings);
            value = this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(value, this.settings);
          } else {
            this._triggerRangeEvents(minTest, maxTest);
          }
        } else if (rawValueToFormat === "") {
          switch (this.settings.emptyInputBehavior) {
            case _AutoNumeric.options.emptyInputBehavior.zero:
              this._setRawValue("0");
              value = this.constructor._roundValue("0", this.settings, 0);
              break;
            case _AutoNumeric.options.emptyInputBehavior.min:
              this._setRawValue(this.settings.minimumValue);
              value = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.minimumValue, this.settings, this.isFocused);
              break;
            case _AutoNumeric.options.emptyInputBehavior.max:
              this._setRawValue(this.settings.maximumValue);
              value = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.maximumValue, this.settings, this.isFocused);
              break;
            default:
              if (AutoNumericHelper.isNumber(this.settings.emptyInputBehavior)) {
                this._setRawValue(this.settings.emptyInputBehavior);
                value = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.emptyInputBehavior, this.settings, this.isFocused);
              }
          }
        }
        let groupedValue = this.constructor._orderValueCurrencySymbolAndSuffixText(value, this.settings, false);
        if (!(this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(value, this.settings) || isRawValueNull && this.settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.null)) {
          groupedValue = this.constructor._addGroupSeparators(value, this.settings, false, rawValueToFormat);
        }
        if (groupedValue !== rawValueToFormat || rawValueToFormat === "" || // This make sure we get rid on any currency symbol or suffix that might have been added on focus
        this.settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.never || this.settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.floats) {
          if (this.settings.symbolWhenUnfocused && rawValueToFormat !== "" && rawValueToFormat !== null) {
            groupedValue = `${groupedValue}${this.settings.symbolWhenUnfocused}`;
          }
          this._setElementValue(groupedValue);
        }
      }
      this._setValidOrInvalidState(this.rawValue);
      if (e.type === "blur") {
        this._onBlur(e);
      }
    }
  }
  /**
   * Handler for 'paste' event
   *
   * @param {Event|ClipboardEvent} e
   */
  _onPaste(e) {
    e.preventDefault();
    if (this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled) {
      return;
    }
    let rawPastedText;
    if (e.clipboardData && e.clipboardData.getData) {
      rawPastedText = e.clipboardData.getData("text/plain");
    } else {
      AutoNumericHelper.throwError("Unable to retrieve the pasted value. Please use a modern browser (i.e. Firefox or Chromium).");
    }
    let eventTarget;
    if (!e.target.tagName) {
      eventTarget = e.explicitOriginalTarget;
    } else {
      eventTarget = e.target;
    }
    const initialFormattedValue = AutoNumericHelper.getElementValue(eventTarget);
    const selectionStart = eventTarget.selectionStart || 0;
    const selectionEnd = eventTarget.selectionEnd || 0;
    const selectionSize = selectionEnd - selectionStart;
    if (selectionSize === initialFormattedValue.length) {
      const untranslatedPastedText2 = this._preparePastedText(rawPastedText);
      const pastedRawValue = AutoNumericHelper.arabicToLatinNumbers(untranslatedPastedText2, false, false, false);
      if (pastedRawValue === "." || pastedRawValue === "" || pastedRawValue !== "." && !AutoNumericHelper.isNumber(pastedRawValue)) {
        this.formatted = true;
        if (this.settings.onInvalidPaste === _AutoNumeric.options.onInvalidPaste.error) {
          AutoNumericHelper.throwError(`The pasted value '${rawPastedText}' is not a valid paste content.`);
        }
        return;
      }
      this.set(pastedRawValue);
      this.formatted = true;
      this._triggerEvent(_AutoNumeric.events.native.input, eventTarget);
      return;
    }
    const isPasteNegative = AutoNumericHelper.isNegativeStrict(rawPastedText, this.settings.negativeSignCharacter);
    if (isPasteNegative) {
      rawPastedText = rawPastedText.slice(1, rawPastedText.length);
    }
    const untranslatedPastedText = this._preparePastedText(rawPastedText);
    let pastedText;
    if (untranslatedPastedText === ".") {
      pastedText = ".";
    } else {
      pastedText = AutoNumericHelper.arabicToLatinNumbers(untranslatedPastedText, false, false, false);
    }
    if (pastedText !== "." && (!AutoNumericHelper.isNumber(pastedText) || pastedText === "")) {
      this.formatted = true;
      if (this.settings.onInvalidPaste === _AutoNumeric.options.onInvalidPaste.error) {
        AutoNumericHelper.throwError(`The pasted value '${rawPastedText}' is not a valid paste content.`);
      }
      return;
    }
    let caretPositionOnInitialTextAfterPasting;
    let isInitialValueNegative = AutoNumericHelper.isNegativeStrict(this.getNumericString(), this.settings.negativeSignCharacter);
    let isPasteNegativeAndInitialValueIsPositive;
    let result;
    if (isPasteNegative && !isInitialValueNegative) {
      isInitialValueNegative = true;
      isPasteNegativeAndInitialValueIsPositive = true;
    } else {
      isPasteNegativeAndInitialValueIsPositive = false;
    }
    const leftFormattedPart = initialFormattedValue.slice(0, selectionStart);
    const rightFormattedPart = initialFormattedValue.slice(selectionEnd, initialFormattedValue.length);
    if (selectionStart !== selectionEnd) {
      result = this._preparePastedText(leftFormattedPart + rightFormattedPart);
    } else {
      result = this._preparePastedText(initialFormattedValue);
    }
    if (isInitialValueNegative) {
      result = AutoNumericHelper.setRawNegativeSign(result);
    }
    caretPositionOnInitialTextAfterPasting = AutoNumericHelper.convertCharacterCountToIndexPosition(AutoNumericHelper.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionStart, this.settings.decimalCharacter));
    if (isPasteNegativeAndInitialValueIsPositive) {
      caretPositionOnInitialTextAfterPasting++;
    }
    let leftPart = result.slice(0, caretPositionOnInitialTextAfterPasting);
    let rightPart = result.slice(caretPositionOnInitialTextAfterPasting, result.length);
    let leftPartContainedADot = false;
    if (pastedText === ".") {
      if (AutoNumericHelper.contains(leftPart, ".")) {
        leftPartContainedADot = true;
        leftPart = leftPart.replace(".", "");
      }
      rightPart = rightPart.replace(".", "");
    }
    let negativePasteOnNegativeNumber = false;
    if (leftPart === "" && rightPart === "-") {
      leftPart = "-";
      rightPart = "";
      negativePasteOnNegativeNumber = true;
    }
    switch (this.settings.onInvalidPaste) {
      case _AutoNumeric.options.onInvalidPaste.truncate:
      case _AutoNumeric.options.onInvalidPaste.replace:
        const minParse = AutoNumericHelper.parseStr(this.settings.minimumValue);
        const maxParse = AutoNumericHelper.parseStr(this.settings.maximumValue);
        let lastGoodKnownResult = result;
        let pastedTextIndex = 0;
        let modifiedLeftPart = leftPart;
        while (pastedTextIndex < pastedText.length) {
          modifiedLeftPart += pastedText[pastedTextIndex];
          result = modifiedLeftPart + rightPart;
          if (!this.constructor._checkIfInRange(result, minParse, maxParse)) {
            break;
          }
          lastGoodKnownResult = result;
          pastedTextIndex++;
        }
        caretPositionOnInitialTextAfterPasting += pastedTextIndex;
        if (negativePasteOnNegativeNumber)
          caretPositionOnInitialTextAfterPasting++;
        if (this.settings.onInvalidPaste === _AutoNumeric.options.onInvalidPaste.truncate) {
          result = lastGoodKnownResult;
          if (leftPartContainedADot) {
            caretPositionOnInitialTextAfterPasting--;
          }
          break;
        }
        let lastGoodKnownResultIndex = caretPositionOnInitialTextAfterPasting;
        const lastGoodKnownResultSize = lastGoodKnownResult.length;
        while (pastedTextIndex < pastedText.length && lastGoodKnownResultIndex < lastGoodKnownResultSize) {
          if (lastGoodKnownResult[lastGoodKnownResultIndex] === ".") {
            lastGoodKnownResultIndex++;
            continue;
          }
          result = AutoNumericHelper.replaceCharAt(lastGoodKnownResult, lastGoodKnownResultIndex, pastedText[pastedTextIndex]);
          if (!this.constructor._checkIfInRange(result, minParse, maxParse)) {
            break;
          }
          lastGoodKnownResult = result;
          pastedTextIndex++;
          lastGoodKnownResultIndex++;
        }
        caretPositionOnInitialTextAfterPasting = lastGoodKnownResultIndex;
        if (leftPartContainedADot) {
          caretPositionOnInitialTextAfterPasting--;
        }
        result = lastGoodKnownResult;
        break;
      case _AutoNumeric.options.onInvalidPaste.error:
      case _AutoNumeric.options.onInvalidPaste.ignore:
      case _AutoNumeric.options.onInvalidPaste.clamp:
      default:
        result = `${leftPart}${pastedText}${rightPart}`;
        if (selectionStart === selectionEnd) {
          const indexWherePastedTextHasBeenInserted = AutoNumericHelper.convertCharacterCountToIndexPosition(AutoNumericHelper.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionStart, this.settings.decimalCharacter));
          caretPositionOnInitialTextAfterPasting = indexWherePastedTextHasBeenInserted + pastedText.length;
        } else if (rightPart === "") {
          caretPositionOnInitialTextAfterPasting = AutoNumericHelper.convertCharacterCountToIndexPosition(AutoNumericHelper.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionStart, this.settings.decimalCharacter)) + pastedText.length;
          if (negativePasteOnNegativeNumber)
            caretPositionOnInitialTextAfterPasting++;
        } else {
          const indexSelectionEndInRawValue = AutoNumericHelper.convertCharacterCountToIndexPosition(AutoNumericHelper.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionEnd, this.settings.decimalCharacter));
          const selectedText = AutoNumericHelper.getElementValue(eventTarget).slice(selectionStart, selectionEnd);
          caretPositionOnInitialTextAfterPasting = indexSelectionEndInRawValue - selectionSize + AutoNumericHelper.countCharInText(this.settings.digitGroupSeparator, selectedText) + pastedText.length;
        }
        if (isPasteNegativeAndInitialValueIsPositive) {
          caretPositionOnInitialTextAfterPasting++;
        }
        if (leftPartContainedADot) {
          caretPositionOnInitialTextAfterPasting--;
        }
    }
    if (!AutoNumericHelper.isNumber(result) || result === "") {
      if (this.settings.onInvalidPaste === _AutoNumeric.options.onInvalidPaste.error) {
        AutoNumericHelper.throwError(`The pasted value '${rawPastedText}' would result into an invalid content '${result}'.`);
      }
      return;
    }
    let valueHasBeenSet = false;
    let valueHasBeenClamped = false;
    try {
      this.set(result);
      valueHasBeenSet = true;
    } catch (error) {
      let clampedValue;
      switch (this.settings.onInvalidPaste) {
        case _AutoNumeric.options.onInvalidPaste.clamp:
          clampedValue = AutoNumericHelper.clampToRangeLimits(result, this.settings);
          try {
            this.set(clampedValue);
          } catch (error2) {
            AutoNumericHelper.throwError(`Fatal error: Unable to set the clamped value '${clampedValue}'.`);
          }
          valueHasBeenClamped = true;
          valueHasBeenSet = true;
          result = clampedValue;
          break;
        case _AutoNumeric.options.onInvalidPaste.error:
        case _AutoNumeric.options.onInvalidPaste.truncate:
        case _AutoNumeric.options.onInvalidPaste.replace:
          AutoNumericHelper.throwError(`The pasted value '${rawPastedText}' results in a value '${result}' that is outside of the minimum [${this.settings.minimumValue}] and maximum [${this.settings.maximumValue}] value range.`);
        case _AutoNumeric.options.onInvalidPaste.ignore:
        default:
          return;
      }
    }
    const targetValue = AutoNumericHelper.getElementValue(eventTarget);
    let caretPositionInFormattedNumber;
    if (valueHasBeenSet) {
      switch (this.settings.onInvalidPaste) {
        case _AutoNumeric.options.onInvalidPaste.clamp:
          if (valueHasBeenClamped) {
            if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
              AutoNumericHelper.setElementSelection(eventTarget, targetValue.length - this.settings.currencySymbol.length);
            } else {
              AutoNumericHelper.setElementSelection(eventTarget, targetValue.length);
            }
            break;
          }
        case _AutoNumeric.options.onInvalidPaste.error:
        case _AutoNumeric.options.onInvalidPaste.ignore:
        case _AutoNumeric.options.onInvalidPaste.truncate:
        case _AutoNumeric.options.onInvalidPaste.replace:
        default:
          caretPositionInFormattedNumber = AutoNumericHelper.findCaretPositionInFormattedNumber(result, caretPositionOnInitialTextAfterPasting, targetValue, this.settings.decimalCharacter);
          AutoNumericHelper.setElementSelection(eventTarget, caretPositionInFormattedNumber);
      }
    }
    if (valueHasBeenSet && initialFormattedValue !== targetValue) {
      this._triggerEvent(_AutoNumeric.events.native.input, eventTarget);
    }
  }
  /**
   * When focusing out of the input, we check if the value has changed, and if it has, then we send a `change` event (since the native one would have been prevented by `e.preventDefault()` called in the other event listeners).
   * We also update the info of the focused state in the `this.isFocused` variable.
   *
   * @param {Event} e
   */
  _onBlur(e) {
    this.isFocused = false;
    this.isEditing = false;
    if (AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(this.rawValue) !== AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(this.rawValueOnFocus)) {
      this._triggerEvent(_AutoNumeric.events.native.change, e.target);
    }
    this.rawValueOnFocus = void 0;
  }
  /**
   * Helper function that DRY the similar behaviors of the mousewheel and up/down arrow keys, which increment/decrement the element value, either by a fixed value, or using the 'progressive' heuristic
   *
   * @param {WheelEvent|KeyboardEvent} e The `wheel` or keyboard event
   * @param {boolean} isUp Defines if the event should increment the value
   * @param {boolean} isDown Defines if the event should decrement the value
   * @param {string|number} step The step to be applied to the increment/decrement action
   * @private
   */
  _wheelAndUpDownActions(e, isUp, isDown, step) {
    const selectionStart = e.target.selectionStart || 0;
    const selectionEnd = e.target.selectionEnd || 0;
    const currentUnformattedValue = this.rawValue;
    let result;
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(currentUnformattedValue)) {
      if (this.settings.minimumValue > 0 || this.settings.maximumValue < 0) {
        if (isUp) {
          result = this.settings.minimumValue;
        } else {
          result = this.settings.maximumValue;
        }
      } else {
        result = 0;
      }
    } else {
      result = currentUnformattedValue;
    }
    result = +result;
    if (AutoNumericHelper.isNumber(step)) {
      const stepToUse = +step;
      if (isUp) {
        result += stepToUse;
      } else if (isDown) {
        result -= stepToUse;
      }
    } else {
      if (isUp) {
        result = AutoNumericHelper.addAndRoundToNearestAuto(result, this.settings.decimalPlacesRawValue);
      } else if (isDown) {
        result = AutoNumericHelper.subtractAndRoundToNearestAuto(result, this.settings.decimalPlacesRawValue);
      }
    }
    result = AutoNumericHelper.clampToRangeLimits(result, this.settings);
    if (result !== +currentUnformattedValue) {
      this.set(result);
      this._triggerEvent(_AutoNumeric.events.native.input, e.target);
    }
    e.preventDefault();
    this._setSelection(selectionStart, selectionEnd);
  }
  /**
   * Handler for up and down arrow keys
   * Increment or decrement the element value according to the `upDownStep` option chosen
   *
   * @param {KeyboardEvent} e
   */
  upDownArrowAction(e) {
    if (this.formulaMode || this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled) {
      return;
    }
    let isUp = false;
    let isDown = false;
    if (this.eventKey === AutoNumericEnum_default.keyName.UpArrow) {
      isUp = true;
    } else if (this.eventKey === AutoNumericEnum_default.keyName.DownArrow) {
      isDown = true;
    } else {
      AutoNumericHelper.throwError("Something has gone wrong since neither an Up or Down arrow key is detected, but the function was still called!");
    }
    this._wheelAndUpDownActions(e, isUp, isDown, this.settings.upDownStep);
  }
  /**
   * Handler for 'wheel' event
   *
   * @param {WheelEvent} e
   */
  _onWheel(e) {
    if (this.formulaMode) {
      return;
    }
    if (this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled) {
      return;
    }
    if (this.settings.modifyValueOnWheel) {
      if (this.settings.wheelOn === _AutoNumeric.options.wheelOn.focus) {
        if (this.isFocused) {
          if (!e.shiftKey) {
            this.wheelAction(e);
          }
        } else if (e.shiftKey) {
          this.wheelAction(e);
        }
      } else if (this.settings.wheelOn === _AutoNumeric.options.wheelOn.hover) {
        if (!e.shiftKey) {
          this.wheelAction(e);
        } else {
          e.preventDefault();
          window.scrollBy(0, AutoNumericHelper.isNegativeStrict(String(e.deltaY)) ? -50 : 50);
        }
      } else {
        AutoNumericHelper.throwError("Unknown `wheelOn` option.");
      }
    }
  }
  /**
   * Increment or decrement the element value according to the `wheelStep` option chosen
   *
   * @param {WheelEvent} e The `wheel` event
   */
  wheelAction(e) {
    this.isWheelEvent = true;
    let isUp = false;
    let isDown = false;
    let isDeltaYZero = false;
    if (AutoNumericHelper.isWheelUpEvent(e)) {
      isUp = true;
    } else if (AutoNumericHelper.isWheelDownEvent(e)) {
      isDown = true;
    } else if (AutoNumericHelper.isWheelEventWithZeroDeltaY(e)) {
      isDeltaYZero = true;
    } else {
      AutoNumericHelper.throwError(`The event is not a 'wheel' event.`);
    }
    if (!isDeltaYZero) {
      this._wheelAndUpDownActions(e, isUp, isDown, this.settings.wheelStep);
    }
    this.isWheelEvent = false;
  }
  /**
   * Handler for 'drop' event
   *
   * @param {DragEvent} e
   */
  _onDrop(e) {
    if (this.formulaMode) {
      return;
    }
    this.isDropEvent = true;
    e.preventDefault();
    const droppedText = e.dataTransfer.getData("text/plain");
    const cleanedValue = this.unformatOther(droppedText);
    const previousValue = this.rawValue;
    this.set(cleanedValue);
    this.isDropEvent = false;
    const newValue = this.constructor._toNumericValue(cleanedValue, this.settings);
    if (!isNaN(Number(newValue))) {
      if (AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(previousValue) !== AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(newValue)) {
        this._triggerEvent(_AutoNumeric.events.native.change, this.domElement);
      }
    }
  }
  /**
   * Handler for 'submit' events happening on the parent <form> element.
   * If `unformatOnSubmit` is set to `true`, the element value is first unformatted before the form is submitted.
   *
   * @returns {boolean}
   */
  _onFormSubmit() {
    const inputElements = this._getFormAutoNumericChildren(this.parentForm);
    const aNElements = inputElements.map((aNElement) => this.constructor.getAutoNumericElement(aNElement));
    aNElements.forEach((aNElement) => aNElement._unformatOnSubmit());
    return true;
  }
  /**
   * Handler for 'reset' events caught on the parent <form> element.
   * When such event is detected, then every child AutoNumeric elements must format their default value that the browser is forcing upon them.
   *
   * @private
   */
  _onFormReset() {
    const inputElements = this._getFormAutoNumericChildren(this.parentForm);
    const aNElements = inputElements.map((aNElement) => this.constructor.getAutoNumericElement(aNElement));
    aNElements.forEach((aNElement) => {
      const val = this._getDefaultValue(aNElement.node());
      setTimeout(() => aNElement.set(val), 0);
    });
  }
  /**
   * Unformat the element value according to the `unformatOnSubmit` option
   *
   * @private
   */
  _unformatOnSubmit() {
    if (this.settings.unformatOnSubmit) {
      this._setElementValue(this.rawValue);
    }
  }
  /**
   * Listen for the `alt` key keydown event globally, and if the event is caught, unformat the AutoNumeric element that is hovered by the mouse.
   *
   * @param {KeyboardEvent} e
   * @private
   */
  _onKeydownGlobal(e) {
    if (AutoNumericHelper.character(e) === AutoNumericEnum_default.keyName.Alt) {
      const hoveredElement = AutoNumericHelper.getHoveredElement();
      if (_AutoNumeric.isManagedByAutoNumeric(hoveredElement)) {
        const anElement = _AutoNumeric.getAutoNumericElement(hoveredElement);
        if (!anElement.formulaMode && anElement.settings.unformatOnHover) {
          this.constructor._unformatAltHovered(anElement);
        }
      }
    }
  }
  /**
   * Listen for the `alt` key keyup event globally, and if the event is caught, reformat the AutoNumeric element that is hovered by the mouse.
   *
   * @param {KeyboardEvent} e
   * @private
   */
  _onKeyupGlobal(e) {
    if (AutoNumericHelper.character(e) === AutoNumericEnum_default.keyName.Alt) {
      const hoveredElement = AutoNumericHelper.getHoveredElement();
      if (_AutoNumeric.isManagedByAutoNumeric(hoveredElement)) {
        const anElement = _AutoNumeric.getAutoNumericElement(hoveredElement);
        if (anElement.formulaMode || !anElement.settings.unformatOnHover) {
          return;
        }
        this.constructor._reformatAltHovered(anElement);
      }
    }
  }
  /**
   * Return `true` if the DOM element is supported by autoNumeric.
   * A supported element is an element whitelisted in the `allowedTagList`.
   *
   * @returns {boolean}
   * @private
   */
  _isElementTagSupported() {
    if (!AutoNumericHelper.isElement(this.domElement)) {
      AutoNumericHelper.throwError(`The DOM element is not valid, ${this.domElement} given.`);
    }
    return AutoNumericHelper.isInArray(this.domElement.tagName.toLowerCase(), this.allowedTagList);
  }
  /**
   * Return `true` in the DOM element is an <input>.
   *
   * @returns {boolean}
   * @private
   */
  _isInputElement() {
    return this.domElement.tagName.toLowerCase() === "input";
  }
  /**
   * Return `true` if the input type is supported by AutoNumeric
   *
   * @returns {boolean}
   * @throws
   */
  _isInputTypeSupported() {
    return this.domElement.type === "text" || this.domElement.type === "hidden" || this.domElement.type === "tel" || AutoNumericHelper.isUndefinedOrNullOrEmpty(this.domElement.type);
  }
  /**
   * Check if the DOM element is supported by autoNumeric.
   * A supported element is either an <input> element with the correct 'type' attribute, or a tag whitelisted in the `allowedTagList` array.
   * If the check fails, this method throws.
   * This function also sets the info `this.isInputElement` which keep tracks if the DOM element is an <input> or not, and the `this.isContentEditable` if the element has the `contenteditable` attribute set to `true` initially.
   *
   * @throws
   * @private
   */
  _checkElement() {
    const currentElementTag = this.domElement.tagName.toLowerCase();
    if (!this._isElementTagSupported()) {
      AutoNumericHelper.throwError(`The <${currentElementTag}> tag is not supported by autoNumeric`);
    }
    if (this._isInputElement()) {
      if (!this._isInputTypeSupported()) {
        AutoNumericHelper.throwError(`The input type "${this.domElement.type}" is not supported by autoNumeric`);
      }
      this.isInputElement = true;
    } else {
      this.isInputElement = false;
      this.isContentEditable = this._isContentEditable(this.domElement);
    }
  }
  /**
   * Returns `true` if the given DOM element is a contenteditable one (set to `true`)
   *
   * @param {HTMLElement} domElement
   * @returns {boolean}
   */
  _isContentEditable(domElement) {
    return domElement.hasAttribute("contenteditable") && domElement.getAttribute("contenteditable") === "true";
  }
  /**
   * Formats the default value on page load.
   * This is called only if the `formatOnPageLoad` option is set to `true`.
   *
   * @param {number|string|null} forcedInitialValue The value that should be used for initialization, in place on the eventual html one
   */
  _formatDefaultValueOnPageLoad(forcedInitialValue = null) {
    let setValue = true;
    let currentValue;
    if (!AutoNumericHelper.isNull(forcedInitialValue)) {
      currentValue = forcedInitialValue;
    } else {
      currentValue = AutoNumericHelper.getElementValue(this.domElement).trim();
      this.domElement.setAttribute("value", currentValue);
    }
    if (this.isInputElement || this.isContentEditable) {
      const unLocalizedCurrentValue = this.constructor._toNumericValue(currentValue, this.settings);
      if (!this.domElement.hasAttribute("value") || this.domElement.getAttribute("value") === "") {
        if (!isNaN(Number(unLocalizedCurrentValue)) && Infinity !== unLocalizedCurrentValue) {
          this.set(unLocalizedCurrentValue);
          setValue = false;
        } else {
          AutoNumericHelper.throwError(`The value [${currentValue}] used in the input is not a valid value autoNumeric can work with.`);
        }
      } else {
        if (this.settings.defaultValueOverride !== null && this.settings.defaultValueOverride.toString() !== currentValue || this.settings.defaultValueOverride === null && currentValue !== "" && currentValue !== this.domElement.getAttribute("value") || currentValue !== "" && this.domElement.getAttribute("type") === "hidden" && !AutoNumericHelper.isNumber(unLocalizedCurrentValue)) {
          if (this.settings.saveValueToSessionStorage && (this.settings.decimalPlacesShownOnFocus !== null || this.settings.divisorWhenUnfocused)) {
            this._setRawValue(this._getValueFromPersistentStorage());
          }
          if (!this.settings.saveValueToSessionStorage) {
            const toStrip = this.constructor._removeBrackets(currentValue, this.settings);
            if ((this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.prefix && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) && this.settings.negativeSignCharacter !== "" && AutoNumericHelper.isNegative(currentValue, this.settings.negativeSignCharacter)) {
              this._setRawValue(`-${this.constructor._stripAllNonNumberCharacters(toStrip, this.settings, true, this.isFocused)}`);
            } else {
              this._setRawValue(this.constructor._stripAllNonNumberCharacters(toStrip, this.settings, true, this.isFocused));
            }
          }
          setValue = false;
        }
      }
      if (currentValue === "") {
        switch (this.settings.emptyInputBehavior) {
          case _AutoNumeric.options.emptyInputBehavior.focus:
          case _AutoNumeric.options.emptyInputBehavior.press:
            break;
          case _AutoNumeric.options.emptyInputBehavior.always:
            this._setElementValue(this.settings.currencySymbol);
            break;
          case _AutoNumeric.options.emptyInputBehavior.min:
            this.set(this.settings.minimumValue);
            break;
          case _AutoNumeric.options.emptyInputBehavior.max:
            this.set(this.settings.maximumValue);
            break;
          case _AutoNumeric.options.emptyInputBehavior.zero:
            this.set("0");
            break;
          case _AutoNumeric.options.emptyInputBehavior.null:
            this.set(null);
            break;
          default:
            this.set(this.settings.emptyInputBehavior);
        }
      } else if (setValue && currentValue === this.domElement.getAttribute("value")) {
        this.set(currentValue);
      }
    } else if (this.settings.defaultValueOverride === null || this.settings.defaultValueOverride === currentValue) {
      this.set(currentValue);
    }
  }
  /**
   * Enhance the user experience by modifying the default `negativePositiveSignPlacement` option depending on `currencySymbol` and `currencySymbolPlacement`.
   *
   * If the user has not set the placement of the negative sign (`negativePositiveSignPlacement`), but has set a currency symbol (`currencySymbol`),
   * then we modify the default value of `negativePositiveSignPlacement` in order to keep the resulting output logical by default :
   * - "$-1,234.56" instead of "-$1,234.56" ({currencySymbol: "$", negativePositiveSignPlacement: "r"})
   * - "-1,234.56$" instead of "1,234.56-$" ({currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "p"})
   *
   * @param {object} settings
   */
  static _correctNegativePositiveSignPlacementOption(settings) {
    if (!AutoNumericHelper.isNull(settings.negativePositiveSignPlacement)) {
      return;
    }
    if (!AutoNumericHelper.isUndefined(settings) && AutoNumericHelper.isUndefinedOrNullOrEmpty(settings.negativePositiveSignPlacement) && !AutoNumericHelper.isUndefinedOrNullOrEmpty(settings.currencySymbol)) {
      switch (settings.currencySymbolPlacement) {
        case _AutoNumeric.options.currencySymbolPlacement.suffix:
          settings.negativePositiveSignPlacement = _AutoNumeric.options.negativePositiveSignPlacement.prefix;
          break;
        case _AutoNumeric.options.currencySymbolPlacement.prefix:
          settings.negativePositiveSignPlacement = _AutoNumeric.options.negativePositiveSignPlacement.left;
          break;
      }
    } else {
      settings.negativePositiveSignPlacement = _AutoNumeric.options.negativePositiveSignPlacement.left;
    }
  }
  /**
   * Correct the `caretPositionOnFocus` and `selectOnFocus` options, since setting both leads to a conflict.
   * This method directly modifies the `options` object passed as a parameter, then returns it.
   * It returns `null` if the given option is `null`.
   *
   * @param {object} options The options passed as an argument by the user
   * @returns {object|null}
   * @private
   */
  static _correctCaretPositionOnFocusAndSelectOnFocusOptions(options) {
    if (AutoNumericHelper.isNull(options)) {
      return null;
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(options.caretPositionOnFocus) && AutoNumericHelper.isUndefinedOrNullOrEmpty(options.selectOnFocus)) {
      options.selectOnFocus = _AutoNumeric.options.selectOnFocus.doNotSelect;
    }
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(options.caretPositionOnFocus) && !AutoNumericHelper.isUndefinedOrNullOrEmpty(options.selectOnFocus) && options.selectOnFocus === _AutoNumeric.options.selectOnFocus.select) {
      options.caretPositionOnFocus = _AutoNumeric.options.caretPositionOnFocus.doNoForceCaretPosition;
    }
    return options;
  }
  /**
   * Calculate the number de decimal places to be used by the AutoNumeric object, for each of its state, and for its formatted and raw value.
   * By default, the `rawValue` precision is the same as the formatted value one.
   *
   * This method is called during the AutoNumeric object initialization. This assumes some internal variable state.
   *
   * This method set the following options accordingly to their own value and the mandatory `decimalPlaces` option:
   * - decimalPlacesRawValue     (nullable)
   * - decimalPlacesShownOnBlur  (nullable)
   * - decimalPlacesShownOnFocus (nullable)
   *
   * Note: the `decimalPlaces` option is only used here and only serve to define those three previous options value.
   * AutoNumeric will then *only* use `decimalPlacesRawValue`, `decimalPlacesShownOnBlur` and `decimalPlacesShownOnFocus` from there.
   *
   * This method directly modifies the `settings` object passed as a parameter.
   *
   * @param {object} settings This is an object with the new settings to use.
   * @private
   */
  static _calculateDecimalPlacesOnInit(settings) {
    this._validateDecimalPlacesRawValue(settings);
    if (settings.decimalPlacesShownOnFocus === _AutoNumeric.options.decimalPlacesShownOnFocus.useDefault) {
      settings.decimalPlacesShownOnFocus = settings.decimalPlaces;
    }
    if (settings.decimalPlacesShownOnBlur === _AutoNumeric.options.decimalPlacesShownOnBlur.useDefault) {
      settings.decimalPlacesShownOnBlur = settings.decimalPlaces;
    }
    if (settings.decimalPlacesRawValue === _AutoNumeric.options.decimalPlacesRawValue.useDefault) {
      settings.decimalPlacesRawValue = settings.decimalPlaces;
    }
    let additionalDecimalPlacesRawValue = 0;
    if (settings.rawValueDivisor && settings.rawValueDivisor !== _AutoNumeric.options.rawValueDivisor.none) {
      additionalDecimalPlacesRawValue = String(settings.rawValueDivisor).length - 1;
      if (additionalDecimalPlacesRawValue < 0) {
        additionalDecimalPlacesRawValue = 0;
      }
    }
    settings.decimalPlacesRawValue = Math.max(
      Math.max(settings.decimalPlacesShownOnBlur, settings.decimalPlacesShownOnFocus) + additionalDecimalPlacesRawValue,
      Number(settings.originalDecimalPlacesRawValue) + additionalDecimalPlacesRawValue
    );
  }
  /**
   * Recalculate the number de decimal places to be used by the AutoNumeric object, for each of its state, and for its formatted and raw value.
   * By default, the `rawValue` precision is the same as the formatted value one.
   *
   * This method is close to the one called during initialization, `_calculateDecimalPlacesOnInit()`, but with slight difference so that the `decimalPlaces*` options are correctly updated as needed.
   *
   * This methods set the following options accordingly to their own value and the mandatory `decimalPlaces` option:
   * - decimalPlacesRawValue     (nullable)
   * - decimalPlacesShownOnBlur  (nullable)
   * - decimalPlacesShownOnFocus (nullable)
   *
   * Note: the `decimalPlaces` option is only used here and only serve to define those three previous options value.
   * AutoNumeric will then *only* use `decimalPlacesRawValue`, `decimalPlacesShownOnBlur` and `decimalPlacesShownOnFocus` from there.
   *
   * This methods directly modifies the `settings` object passed as a parameter.
   *
   * @param {object} settings This is an object with the new settings to use.
   * @param {object} currentSettings This is the current settings (`this.settings`) used by the element.
   * @private
   */
  static _calculateDecimalPlacesOnUpdate(settings, currentSettings = null) {
    this._validateDecimalPlacesRawValue(settings);
    if (AutoNumericHelper.isNull(currentSettings)) {
      AutoNumericHelper.throwError(`When updating the settings, the previous ones should be passed as an argument.`);
    }
    const decimalPlacesInOptions = "decimalPlaces" in settings;
    if (!(decimalPlacesInOptions || "decimalPlacesRawValue" in settings || "decimalPlacesShownOnFocus" in settings || "decimalPlacesShownOnBlur" in settings || "rawValueDivisor" in settings)) {
      return;
    }
    if (decimalPlacesInOptions) {
      if (!("decimalPlacesShownOnFocus" in settings) || settings.decimalPlacesShownOnFocus === _AutoNumeric.options.decimalPlacesShownOnFocus.useDefault) {
        settings.decimalPlacesShownOnFocus = settings.decimalPlaces;
      }
      if (!("decimalPlacesShownOnBlur" in settings) || settings.decimalPlacesShownOnBlur === _AutoNumeric.options.decimalPlacesShownOnBlur.useDefault) {
        settings.decimalPlacesShownOnBlur = settings.decimalPlaces;
      }
      if (!("decimalPlacesRawValue" in settings) || settings.decimalPlacesRawValue === _AutoNumeric.options.decimalPlacesRawValue.useDefault) {
        settings.decimalPlacesRawValue = settings.decimalPlaces;
      }
    } else {
      if (AutoNumericHelper.isUndefined(settings.decimalPlacesShownOnFocus)) {
        settings.decimalPlacesShownOnFocus = currentSettings.decimalPlacesShownOnFocus;
      }
      if (AutoNumericHelper.isUndefined(settings.decimalPlacesShownOnBlur)) {
        settings.decimalPlacesShownOnBlur = currentSettings.decimalPlacesShownOnBlur;
      }
    }
    let additionalDecimalPlacesRawValue = 0;
    if (settings.rawValueDivisor && settings.rawValueDivisor !== _AutoNumeric.options.rawValueDivisor.none) {
      additionalDecimalPlacesRawValue = String(settings.rawValueDivisor).length - 1;
      if (additionalDecimalPlacesRawValue < 0) {
        additionalDecimalPlacesRawValue = 0;
      }
    }
    if (!settings.decimalPlaces && !settings.decimalPlacesRawValue) {
      settings.decimalPlacesRawValue = Math.max(
        Math.max(settings.decimalPlacesShownOnBlur, settings.decimalPlacesShownOnFocus) + additionalDecimalPlacesRawValue,
        Number(currentSettings.originalDecimalPlacesRawValue) + additionalDecimalPlacesRawValue
      );
    } else {
      settings.decimalPlacesRawValue = Math.max(
        Math.max(settings.decimalPlacesShownOnBlur, settings.decimalPlacesShownOnFocus) + additionalDecimalPlacesRawValue,
        Number(settings.decimalPlacesRawValue) + additionalDecimalPlacesRawValue
      );
    }
  }
  /**
   * Analyze and save the minimumValue and maximumValue integer size for later uses
   * @private
   */
  _calculateVMinAndVMaxIntegerSizes() {
    let [maximumValueIntegerPart] = this.settings.maximumValue.toString().split(".");
    let [minimumValueIntegerPart] = !this.settings.minimumValue && this.settings.minimumValue !== 0 ? [] : this.settings.minimumValue.toString().split(".");
    maximumValueIntegerPart = maximumValueIntegerPart.replace(this.settings.negativeSignCharacter, "");
    minimumValueIntegerPart = minimumValueIntegerPart.replace(this.settings.negativeSignCharacter, "");
    this.settings.mIntPos = Math.max(maximumValueIntegerPart.length, 1);
    this.settings.mIntNeg = Math.max(minimumValueIntegerPart.length, 1);
  }
  /**
   * Calculate once what are the `valuesToStrings` option keys.
   * @private
   */
  _calculateValuesToStringsKeys() {
    if (this.settings.valuesToStrings) {
      this.valuesToStringsKeys = Object.keys(this.settings.valuesToStrings);
    } else {
      this.valuesToStringsKeys = [];
    }
  }
  /**
   * Caches regular expressions for _stripAllNonNumberCharactersExceptCustomDecimalChar
   *
   * @param {object} settings
   * @param {object} regex
   */
  static _cachesUsualRegularExpressions(settings, regex) {
    let negativeSignReg;
    if (settings.negativeSignCharacter !== _AutoNumeric.options.negativeSignCharacter.hyphen) {
      negativeSignReg = `([-\\${settings.negativeSignCharacter}]?)`;
    } else {
      negativeSignReg = "(-?)";
    }
    regex.aNegRegAutoStrip = negativeSignReg;
    settings.allowedAutoStrip = new RegExp(`[^-0123456789\\${settings.decimalCharacter}]`, "g");
    settings.numRegAutoStrip = new RegExp(`${negativeSignReg}(?:\\${settings.decimalCharacter}?([0-9]+\\${settings.decimalCharacter}[0-9]+)|([0-9]*(?:\\${settings.decimalCharacter}[0-9]*)?))`);
    settings.stripReg = new RegExp(`^${regex.aNegRegAutoStrip}0*([0-9])`);
    settings.formulaChars = new RegExp(`[0-9${settings.decimalCharacter}+\\-*/() ]`);
  }
  /**
   * Modify the user settings to make them 'exploitable' later.
   */
  _transformOptionsValuesToDefaultTypes() {
    for (const key in this.settings) {
      if (Object.prototype.hasOwnProperty.call(this.settings, key)) {
        const value = this.settings[key];
        if (value === "true" || value === "false") {
          this.settings[key] = value === "true";
        }
        if (typeof value === "number") {
          this.settings[key] = value.toString();
        }
      }
    }
  }
  /**
   * Convert the old settings options name to new ones.
   *
   * @param {object} options
   */
  static _convertOldOptionsToNewOnes(options) {
    const oldOptionsConverter = {
      // Old option names, with their corresponding new names
      aSep: "digitGroupSeparator",
      nSep: "showOnlyNumbersOnFocus",
      dGroup: "digitalGroupSpacing",
      aDec: "decimalCharacter",
      altDec: "decimalCharacterAlternative",
      aSign: "currencySymbol",
      pSign: "currencySymbolPlacement",
      pNeg: "negativePositiveSignPlacement",
      aSuffix: "suffixText",
      oLimits: "overrideMinMaxLimits",
      vMax: "maximumValue",
      vMin: "minimumValue",
      mDec: "decimalPlacesOverride",
      eDec: "decimalPlacesShownOnFocus",
      scaleDecimal: "decimalPlacesShownOnBlur",
      aStor: "saveValueToSessionStorage",
      mRound: "roundingMethod",
      aPad: "allowDecimalPadding",
      nBracket: "negativeBracketsTypeOnBlur",
      wEmpty: "emptyInputBehavior",
      lZero: "leadingZero",
      aForm: "formatOnPageLoad",
      sNumber: "selectNumberOnly",
      anDefault: "defaultValueOverride",
      unSetOnSubmit: "unformatOnSubmit",
      outputType: "outputFormat",
      debug: "showWarnings",
      // Current options :
      allowDecimalPadding: true,
      alwaysAllowDecimalCharacter: true,
      caretPositionOnFocus: true,
      createLocalList: true,
      currencySymbol: true,
      currencySymbolPlacement: true,
      decimalCharacter: true,
      decimalCharacterAlternative: true,
      decimalPlaces: true,
      decimalPlacesRawValue: true,
      decimalPlacesShownOnBlur: true,
      decimalPlacesShownOnFocus: true,
      defaultValueOverride: true,
      digitalGroupSpacing: true,
      digitGroupSeparator: true,
      divisorWhenUnfocused: true,
      emptyInputBehavior: true,
      eventBubbles: true,
      eventIsCancelable: true,
      failOnUnknownOption: true,
      formatOnPageLoad: true,
      formulaMode: true,
      historySize: true,
      isCancellable: true,
      leadingZero: true,
      maximumValue: true,
      minimumValue: true,
      modifyValueOnUpDownArrow: true,
      modifyValueOnWheel: true,
      negativeBracketsTypeOnBlur: true,
      negativePositiveSignPlacement: true,
      negativeSignCharacter: true,
      negativePositiveSignBehavior: true,
      noEventListeners: true,
      onInvalidPaste: true,
      outputFormat: true,
      overrideMinMaxLimits: true,
      positiveSignCharacter: true,
      rawValueDivisor: true,
      readOnly: true,
      roundingMethod: true,
      saveValueToSessionStorage: true,
      selectNumberOnly: true,
      selectOnFocus: true,
      serializeSpaces: true,
      showOnlyNumbersOnFocus: true,
      showPositiveSign: true,
      showWarnings: true,
      styleRules: true,
      suffixText: true,
      symbolWhenUnfocused: true,
      upDownStep: true,
      unformatOnHover: true,
      unformatOnSubmit: true,
      valuesToStrings: true,
      watchExternalChanges: true,
      wheelOn: true,
      wheelStep: true,
      // Additional information that are added to the `settings` object :
      //TODO Find a way to exclude those internal data from the settings object (ideally by using another object, or better yet, class attributes) -->
      allowedAutoStrip: true,
      formulaChars: true,
      isNegativeSignAllowed: true,
      isPositiveSignAllowed: true,
      mIntNeg: true,
      mIntPos: true,
      numRegAutoStrip: true,
      originalDecimalPlaces: true,
      originalDecimalPlacesRawValue: true,
      stripReg: true
    };
    for (const option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option)) {
        if (oldOptionsConverter[option] === true) {
          continue;
        }
        if (Object.prototype.hasOwnProperty.call(oldOptionsConverter, option)) {
          AutoNumericHelper.warning(`You are using the deprecated option name '${option}'. Please use '${oldOptionsConverter[option]}' instead from now on. The old option name will be dropped very soon\u2122.`, true);
          options[oldOptionsConverter[option]] = options[option];
          delete options[option];
        } else if (options.failOnUnknownOption) {
          AutoNumericHelper.throwError(`Option name '${option}' is unknown. Please fix the options passed to autoNumeric`);
        }
      }
    }
    if ("mDec" in options) {
      AutoNumericHelper.warning("The old `mDec` option has been deprecated in favor of more accurate options ; `decimalPlaces`, `decimalPlacesRawValue`, `decimalPlacesShownOnFocus` and `decimalPlacesShownOnBlur`.", true);
    }
  }
  /**
   * Analyse the settings/options passed by the user, validate and clean them, then set them into `this.settings`.
   * Note: This sets the settings to `null` if somehow the settings objet is undefined or empty
   *       If only `decimalPlaces` is defined in the option, overwrite the other decimalPlaces* options, otherwise, use those options
   *
   * @param {object} options
   * @param {boolean} update - If set to `true`, then the settings already exists and this function only updates them instead of recreating them from scratch
   * @throws
   */
  _setSettings(options, update = false) {
    if (update || !AutoNumericHelper.isNull(options)) {
      this.constructor._convertOldOptionsToNewOnes(options);
    }
    if (update) {
      const decimalPlacesRawValueInOptions = "decimalPlacesRawValue" in options;
      if (decimalPlacesRawValueInOptions) {
        this.settings.originalDecimalPlacesRawValue = options.decimalPlacesRawValue;
      }
      const decimalPlacesInOptions = "decimalPlaces" in options;
      if (decimalPlacesInOptions) {
        this.settings.originalDecimalPlaces = options.decimalPlaces;
      }
      this.constructor._calculateDecimalPlacesOnUpdate(options, this.settings);
      this._mergeSettings(options);
    } else {
      this.settings = {};
      this._mergeSettings(this.constructor.getDefaultConfig(), this.domElement.dataset, options, { rawValue: this.defaultRawValue });
      this.caretFix = false;
      this.throwInput = true;
      this.allowedTagList = AutoNumericEnum_default.allowedTagList;
      this.runOnce = false;
      this.hoveredWithAlt = false;
    }
    this._transformOptionsValuesToDefaultTypes();
    this._runCallbacksFoundInTheSettingsObject();
    this.constructor._correctNegativePositiveSignPlacementOption(this.settings);
    this.constructor._correctCaretPositionOnFocusAndSelectOnFocusOptions(this.settings);
    this.constructor._setNegativePositiveSignPermissions(this.settings);
    if (!update) {
      if (AutoNumericHelper.isNull(options) || !options.decimalPlaces) {
        this.settings.originalDecimalPlaces = null;
      } else {
        this.settings.originalDecimalPlaces = options.decimalPlaces;
      }
      this.settings.originalDecimalPlacesRawValue = this.settings.decimalPlacesRawValue;
      this.constructor._calculateDecimalPlacesOnInit(this.settings);
    }
    this._calculateVMinAndVMaxIntegerSizes();
    this._setTrailingNegativeSignInfo();
    this.regex = {};
    this.constructor._cachesUsualRegularExpressions(this.settings, this.regex);
    this.constructor._setBrackets(this.settings);
    this._calculateValuesToStringsKeys();
    if (AutoNumericHelper.isEmptyObj(this.settings)) {
      AutoNumericHelper.throwError("Unable to set the settings, those are invalid ; an empty object was given.");
    }
    this.constructor.validate(this.settings, false, options);
    this._keepAnOriginalSettingsCopy();
  }
  /**
   * Define if the negative or positive signs are allowed, and update the given settings object directly.
   *
   * @param {object} settings
   * @private
   */
  static _setNegativePositiveSignPermissions(settings) {
    settings.isNegativeSignAllowed = settings.minimumValue < 0;
    settings.isPositiveSignAllowed = settings.maximumValue >= 0;
  }
  /**
   * Convert the `value` parameter that can either be :
   * - a real number,
   * - a number represented in the scientific notation (i.e. -123.4567e-6)
   * - a string representing a real number, or
   * - a string representing a localized number (with specific group separators and decimal character),
   * ...to a string representing a real 'javascript' number (i.e. '1234' or '1234.567').
   *
   * This function returns `NaN` if such conversion fails.
   *
   * @param {int|float|string} value
   * @param {object} settings
   * @returns {string|NaN}
   */
  static _toNumericValue(value, settings) {
    let result;
    if (AutoNumericHelper.isNumber(Number(value))) {
      if (!AutoNumericHelper.isNumberStrict(value)) {
        value = String(value).trim();
      }
      result = AutoNumericHelper.scientificToDecimal(value);
    } else {
      result = this._convertToNumericString(value.toString(), settings);
      if (!AutoNumericHelper.isNumber(Number(result))) {
        AutoNumericHelper.warning(`The given value "${value}" cannot be converted to a numeric one and therefore cannot be used appropriately.`, settings.showWarnings);
        result = NaN;
      }
    }
    return result;
  }
  /**
   * Return the pasted text that will be used, by stripping most non-numeric characters
   *
   * @param {string} text
   * @returns {string}
   */
  _preparePastedText(text) {
    return this.constructor._stripAllNonNumberCharacters(text, this.settings, true, this.isFocused);
  }
  /**
   * Return TRUE if the given value (a number as a string) is within the range set in the settings `minimumValue` and `maximumValue`, FALSE otherwise.
   *
   * @param {string} value
   * @param {object} parsedMinValue Parsed via the `parseStr()` function
   * @param {object} parsedMaxValue Parsed via the `parseStr()` function
   * @returns {boolean}
   */
  static _checkIfInRange(value, parsedMinValue, parsedMaxValue) {
    const parsedValue = AutoNumericHelper.parseStr(value);
    return AutoNumericHelper.testMinMax(parsedMinValue, parsedValue) > -1 && AutoNumericHelper.testMinMax(parsedMaxValue, parsedValue) < 1;
  }
  /**
   * Update the selection values as well as resets the internal state of the current AutoNumeric object.
   * This keeps tracks of the current selection and resets the 'processed' state.
   *
   * Note : This state can change between the keydown, keypress and keyup events, that's why
   *        this function is called on each event handler.
   *
   * @private
   */
  _updateInternalProperties() {
    this.selection = AutoNumericHelper.getElementSelection(this.domElement);
    this.processed = false;
  }
  /**
   * Update the `event.key` attribute that triggered the given event.
   *
   * `event.key` describes:
   * - the key name (if a non-printable character),
   * - or directly the character that result from the key press used to trigger the event.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
   * The key list is described here:
   * @link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
   *
   * @param {Event|KeyboardEvent} e
   * @private
   */
  _updateEventKeyInfo(e) {
    this.eventKey = AutoNumericHelper.character(e);
  }
  /**
   * Save the unformatted element value.
   * This is used in the 'cancellable' feature where the element value is saved on focus and input validation, to be used if the user wants to cancel his modifications by hitting the 'Escape' key.
   *
   * @private
   */
  _saveCancellableValue() {
    this.savedCancellableValue = this.rawValue;
  }
  /**
   * Set the text selection inside the input with the given start and end position.
   *
   * @param {int} start
   * @param {int} end
   * @private
   */
  _setSelection(start, end) {
    start = Math.max(start, 0);
    end = Math.min(end, AutoNumericHelper.getElementValue(this.domElement).length);
    this.selection = {
      start,
      end,
      length: end - start
    };
    AutoNumericHelper.setElementSelection(this.domElement, start, end);
  }
  /**
   * Set the caret position inside the input at the given position.
   *
   * @param {int} position
   * @private
   */
  _setCaretPosition(position) {
    this._setSelection(position, position);
  }
  /**
   * Return an array containing the string parts located on the left and right side of the caret or selection.
   * Those parts are left 'untouched', i.e. formatted by autoNumeric.
   *
   * @returns {[string, string]} The parts on the left and right of the caret or selection
   * @private
   */
  _getLeftAndRightPartAroundTheSelection() {
    const value = AutoNumericHelper.getElementValue(this.domElement);
    const left = value.substring(0, this.selection.start);
    const right = value.substring(this.selection.end, value.length);
    return [left, right];
  }
  /**
   * Return an array containing the string parts located on the left and right side of the caret or selection.
   * Those parts are unformatted (stripped) of any non-numbers characters, and any trailing negative character is put back on the left hand side of the number.
   *
   * @returns {[string, string]} The parts on the left and right of the caret or selection, unformatted.
   * @private
   */
  _getUnformattedLeftAndRightPartAroundTheSelection() {
    let [left, right] = this._getLeftAndRightPartAroundTheSelection();
    if (left === "" && right === "") {
      return ["", ""];
    }
    let stripZeros = true;
    if ((this.eventKey === AutoNumericEnum_default.keyName.Hyphen || this.eventKey === AutoNumericEnum_default.keyName.Minus) && Number(left) === 0) {
      stripZeros = false;
    }
    if (this.isTrailingNegative && (AutoNumericHelper.isNegative(right, this.settings.negativeSignCharacter) && // The caret is placed on the left of the negative sign
    !AutoNumericHelper.isNegative(left, this.settings.negativeSignCharacter) || right === "" && // ...or the caret is placed on the far right of the input (Fix issue #481)
    AutoNumericHelper.isNegative(left, this.settings.negativeSignCharacter, true))) {
      left = left.replace(this.settings.negativeSignCharacter, "");
      right = right.replace(this.settings.negativeSignCharacter, "");
      left = left.replace("-", "");
      right = right.replace("-", "");
      left = `-${left}`;
    }
    left = _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(left, this.settings, stripZeros, this.isFocused);
    right = _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(right, this.settings, false, this.isFocused);
    return [left, right];
  }
  /**
   * Strip parts from excess characters and leading zeros.
   *
   * @param {string} left
   * @param {string} right
   * @returns {[*,*,*]}
   * @private
   */
  _normalizeParts(left, right) {
    let stripZeros = true;
    if ((this.eventKey === AutoNumericEnum_default.keyName.Hyphen || this.eventKey === AutoNumericEnum_default.keyName.Minus) && Number(left) === 0) {
      stripZeros = false;
    }
    if (this.isTrailingNegative && AutoNumericHelper.isNegative(right, this.settings.negativeSignCharacter) && !AutoNumericHelper.isNegative(left, this.settings.negativeSignCharacter)) {
      left = `-${left}`;
      right = right.replace(this.settings.negativeSignCharacter, "");
    }
    left = _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(left, this.settings, stripZeros, this.isFocused);
    right = _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(right, this.settings, false, this.isFocused);
    if (this.settings.leadingZero === _AutoNumeric.options.leadingZero.deny && (this.eventKey === AutoNumericEnum_default.keyName.num0 || this.eventKey === AutoNumericEnum_default.keyName.numpad0) && Number(left) === 0 && // If `right` is not empty and the first character is not `decimalCharacter`
    !AutoNumericHelper.contains(left, this.settings.decimalCharacter) && right !== "") {
      left = left.substring(0, left.length - 1);
    }
    let newValue = left + right;
    if (this.settings.decimalCharacter) {
      const m = newValue.match(new RegExp(`^${this.regex.aNegRegAutoStrip}\\${this.settings.decimalCharacter}`));
      if (m) {
        left = left.replace(m[1], m[1] + "0");
        newValue = left + right;
      }
    }
    return [left, right, newValue];
  }
  /**
   * Set the formatted element value as well as the `rawValue`.
   * This returns `true` if the element and raw value have been modified, `false` otherwise.
   * This method also adjust the caret position according to the `leadingZero` option and the normalized value. //TODO What about the cursor *selection*?
   *
   * @param {string} left
   * @param {string} right
   * @param {boolean} isPaste
   * @returns {boolean}
   * @private
   */
  _setValueParts(left, right, isPaste = false) {
    const [normalizedLeft, normalizedRight, normalizedNewValue] = this._normalizeParts(left, right);
    const [minTest, maxTest] = _AutoNumeric._checkIfInRangeWithOverrideOption(normalizedNewValue, this.settings);
    if (minTest && maxTest) {
      const roundedRawValue = _AutoNumeric._truncateDecimalPlaces(normalizedNewValue, this.settings, isPaste, this.settings.decimalPlacesRawValue);
      const testValue = roundedRawValue.replace(this.settings.decimalCharacter, ".");
      if (testValue === "" || testValue === this.settings.negativeSignCharacter) {
        let valueToSetOnEmpty;
        switch (this.settings.emptyInputBehavior) {
          case _AutoNumeric.options.emptyInputBehavior.focus:
          case _AutoNumeric.options.emptyInputBehavior.press:
          case _AutoNumeric.options.emptyInputBehavior.always:
            valueToSetOnEmpty = "";
            break;
          case _AutoNumeric.options.emptyInputBehavior.min:
            valueToSetOnEmpty = this.settings.minimumValue;
            break;
          case _AutoNumeric.options.emptyInputBehavior.max:
            valueToSetOnEmpty = this.settings.maximumValue;
            break;
          case _AutoNumeric.options.emptyInputBehavior.zero:
            valueToSetOnEmpty = "0";
            break;
          case _AutoNumeric.options.emptyInputBehavior.null:
            valueToSetOnEmpty = null;
            break;
          default:
            valueToSetOnEmpty = this.settings.emptyInputBehavior;
        }
        this._setRawValue(valueToSetOnEmpty);
      } else {
        this._setRawValue(this._trimLeadingAndTrailingZeros(testValue));
      }
      const roundedValueToShow = _AutoNumeric._truncateDecimalPlaces(normalizedNewValue, this.settings, isPaste, this.settings.decimalPlacesShownOnFocus);
      let position = normalizedLeft.length;
      if (position > roundedValueToShow.length) {
        position = roundedValueToShow.length;
      }
      if (position === 1 && normalizedLeft === "0" && this.settings.leadingZero === _AutoNumeric.options.leadingZero.deny) {
        if (normalizedRight === "" || normalizedLeft === "0" && normalizedRight !== "") {
          position = 1;
        } else {
          position = 0;
        }
      }
      this._setElementValue(roundedValueToShow, false);
      this._setCaretPosition(position);
      return true;
    }
    this._triggerRangeEvents(minTest, maxTest);
    return false;
  }
  /**
   * Helper function for `_expandSelectionOnSign()`.
   *
   * @returns {Array} Array containing [signPosition, currencySymbolPosition] of a formatted value
   * @private
   */
  _getSignPosition() {
    let result;
    if (this.settings.currencySymbol) {
      const currencySymbolLen = this.settings.currencySymbol.length;
      const value = AutoNumericHelper.getElementValue(this.domElement);
      if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
        const hasNeg = this.settings.negativeSignCharacter && value && value.charAt(0) === this.settings.negativeSignCharacter;
        if (hasNeg) {
          result = [1, currencySymbolLen + 1];
        } else {
          result = [0, currencySymbolLen];
        }
      } else {
        const valueLen = value.length;
        result = [valueLen - currencySymbolLen, valueLen];
      }
    } else {
      result = [1e3, -1];
    }
    return result;
  }
  /**
   * Expands selection to cover whole sign
   * Prevents partial deletion/copying/overwriting of a sign
   * @private
   */
  _expandSelectionOnSign() {
    const [signPosition, currencySymbolPosition] = this._getSignPosition();
    const selection = this.selection;
    if (selection.start < currencySymbolPosition && selection.end > signPosition) {
      if ((selection.start < signPosition || selection.end > currencySymbolPosition) && AutoNumericHelper.getElementValue(this.domElement).substring(Math.max(selection.start, signPosition), Math.min(selection.end, currencySymbolPosition)).match(/^\s*$/)) {
        if (selection.start < signPosition) {
          this._setSelection(selection.start, signPosition);
        } else {
          this._setSelection(currencySymbolPosition, selection.end);
        }
      } else {
        this._setSelection(Math.min(selection.start, signPosition), Math.max(selection.end, currencySymbolPosition));
      }
    }
  }
  /**
   * Try to strip pasted value to digits
   */
  _checkPaste() {
    if (this.formatted) {
      return;
    }
    if (!AutoNumericHelper.isUndefined(this.valuePartsBeforePaste)) {
      const oldParts = this.valuePartsBeforePaste;
      const [left, right] = this._getLeftAndRightPartAroundTheSelection();
      delete this.valuePartsBeforePaste;
      const modifiedLeftPart = left.substr(0, oldParts[0].length) + _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(left.substr(oldParts[0].length), this.settings, true, this.isFocused);
      if (!this._setValueParts(modifiedLeftPart, right, true)) {
        this._setElementValue(oldParts.join(""), false);
        this._setCaretPosition(oldParts[0].length);
      }
    }
  }
  /**
   * Return `true` if the given key should be ignored or not.
   *
   * @param {string} eventKeyName
   * @returns {boolean}
   * @private
   */
  static _shouldSkipEventKey(eventKeyName) {
    const isFnKeys = AutoNumericHelper.isInArray(eventKeyName, AutoNumericEnum_default.keyName._allFnKeys);
    const isOSKeys = eventKeyName === AutoNumericEnum_default.keyName.OSLeft || eventKeyName === AutoNumericEnum_default.keyName.OSRight;
    const isContextMenu = eventKeyName === AutoNumericEnum_default.keyName.ContextMenu;
    const isSomeNonPrintableKeys = AutoNumericHelper.isInArray(eventKeyName, AutoNumericEnum_default.keyName._someNonPrintableKeys);
    const isOtherNonPrintableKeys = eventKeyName === AutoNumericEnum_default.keyName.NumLock || eventKeyName === AutoNumericEnum_default.keyName.ScrollLock || eventKeyName === AutoNumericEnum_default.keyName.Insert || eventKeyName === AutoNumericEnum_default.keyName.Command;
    const isUnrecognizableKeys = eventKeyName === AutoNumericEnum_default.keyName.Unidentified;
    return isFnKeys || isOSKeys || isContextMenu || isSomeNonPrintableKeys || isUnrecognizableKeys || isOtherNonPrintableKeys;
  }
  /**
   * Process copying, cutting and pasting, as well as undo/redoing and cursor moving.
   * Return `true` if further processing should not be performed.
   *
   * @param {KeyboardEvent} e
   * @returns {boolean}
   * @private
   */
  _processNonPrintableKeysAndShortcuts(e) {
    if ((e.ctrlKey || e.metaKey) && e.type === "keyup" && !AutoNumericHelper.isUndefined(this.valuePartsBeforePaste) || e.shiftKey && this.eventKey === AutoNumericEnum_default.keyName.Insert) {
      this._checkPaste();
      return false;
    }
    if (this.constructor._shouldSkipEventKey(this.eventKey)) {
      return true;
    }
    if ((e.ctrlKey || e.metaKey) && this.eventKey === AutoNumericEnum_default.keyName.a) {
      if (this.settings.selectNumberOnly) {
        e.preventDefault();
        this.selectNumber();
      }
      return true;
    }
    if ((e.ctrlKey || e.metaKey) && (this.eventKey === AutoNumericEnum_default.keyName.c || this.eventKey === AutoNumericEnum_default.keyName.v || this.eventKey === AutoNumericEnum_default.keyName.x)) {
      if (e.type === "keydown") {
        this._expandSelectionOnSign();
      }
      if (this.eventKey === AutoNumericEnum_default.keyName.v || this.eventKey === AutoNumericEnum_default.keyName.Insert) {
        if (e.type === "keydown" || e.type === "keypress") {
          if (AutoNumericHelper.isUndefined(this.valuePartsBeforePaste)) {
            this.valuePartsBeforePaste = this._getLeftAndRightPartAroundTheSelection();
          }
        } else {
          this._checkPaste();
        }
      }
      return e.type === "keydown" || e.type === "keypress" || this.eventKey === AutoNumericEnum_default.keyName.c;
    }
    if (e.ctrlKey || e.metaKey) {
      return !(this.eventKey === AutoNumericEnum_default.keyName.Z || this.eventKey === AutoNumericEnum_default.keyName.z);
    }
    if (this.eventKey === AutoNumericEnum_default.keyName.LeftArrow || this.eventKey === AutoNumericEnum_default.keyName.RightArrow) {
      if (e.type === "keydown" && !e.shiftKey) {
        const value = AutoNumericHelper.getElementValue(this.domElement);
        if (this.eventKey === AutoNumericEnum_default.keyName.LeftArrow && (value.charAt(this.selection.start - 2) === this.settings.digitGroupSeparator || value.charAt(this.selection.start - 2) === this.settings.decimalCharacter)) {
          this._setCaretPosition(this.selection.start - 1);
        } else if (this.eventKey === AutoNumericEnum_default.keyName.RightArrow && (value.charAt(this.selection.start + 1) === this.settings.digitGroupSeparator || value.charAt(this.selection.start + 1) === this.settings.decimalCharacter)) {
          this._setCaretPosition(this.selection.start + 1);
        }
      }
      return true;
    }
    return AutoNumericHelper.isInArray(this.eventKey, AutoNumericEnum_default.keyName._directionKeys);
  }
  /**
   * Process deletion of characters when the minus sign is to the right of the numeric characters.
   *
   * @param {string[]} leftAndRight The parts on the left and on the right of the caret or selection as an array with [left, right]
   * @returns {string[]} Processed left and right as an array with [left, right]
   * @private
   */
  _processCharacterDeletionIfTrailingNegativeSign([left, right]) {
    const value = AutoNumericHelper.getElementValue(this.domElement);
    const isValNegative = AutoNumericHelper.isNegative(value, this.settings.negativeSignCharacter);
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix) {
      if (this.eventKey === AutoNumericEnum_default.keyName.Backspace) {
        this.caretFix = this.selection.start >= value.indexOf(this.settings.suffixText) && this.settings.suffixText !== "";
        if (value.charAt(this.selection.start - 1) === "-") {
          left = left.substring(1);
        } else if (this.selection.start <= value.length - this.settings.suffixText.length) {
          left = left.substring(0, left.length - 1);
        }
      } else {
        this.caretFix = this.selection.start >= value.indexOf(this.settings.suffixText) && this.settings.suffixText !== "";
        if (this.selection.start >= value.indexOf(this.settings.currencySymbol) + this.settings.currencySymbol.length) {
          right = right.substring(1, right.length);
        }
        if (AutoNumericHelper.isNegative(left, this.settings.negativeSignCharacter) && value.charAt(this.selection.start) === "-") {
          left = left.substring(1);
        }
      }
    }
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
      switch (this.settings.negativePositiveSignPlacement) {
        case _AutoNumeric.options.negativePositiveSignPlacement.left:
          this.caretFix = this.selection.start >= value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length;
          if (this.eventKey === AutoNumericEnum_default.keyName.Backspace) {
            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length && isValNegative) {
              left = left.substring(1);
            } else if (left !== "-" && (this.selection.start <= value.indexOf(this.settings.negativeSignCharacter) || !isValNegative)) {
              left = left.substring(0, left.length - 1);
            }
          } else {
            if (left[0] === "-") {
              right = right.substring(1);
            }
            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter) && isValNegative) {
              left = left.substring(1);
            }
          }
          break;
        case _AutoNumeric.options.negativePositiveSignPlacement.right:
          this.caretFix = this.selection.start >= value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length;
          if (this.eventKey === AutoNumericEnum_default.keyName.Backspace) {
            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length) {
              left = left.substring(1);
            } else if (left !== "-" && this.selection.start <= value.indexOf(this.settings.negativeSignCharacter) - this.settings.currencySymbol.length) {
              left = left.substring(0, left.length - 1);
            } else if (left !== "" && !isValNegative) {
              left = left.substring(0, left.length - 1);
            }
          } else {
            this.caretFix = this.selection.start >= value.indexOf(this.settings.currencySymbol) && this.settings.currencySymbol !== "";
            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter)) {
              left = left.substring(1);
            }
            right = right.substring(1);
          }
          break;
      }
    }
    return [left, right];
  }
  /**
   * Process the deletion of characters.
   * Returns `true` if the deletion is allowed (within the min and max range, according to the `overrideMinMaxLimits` option), `false` otherwise.
   *
   * @param {Event} e
   * @returns {boolean}
   */
  _processCharacterDeletion(e) {
    let left;
    let right;
    if (!this.selection.length) {
      [left, right] = this._getUnformattedLeftAndRightPartAroundTheSelection();
      if (left === "" && right === "") {
        this.throwInput = false;
      }
      if (this.isTrailingNegative && AutoNumericHelper.isNegative(AutoNumericHelper.getElementValue(this.domElement), this.settings.negativeSignCharacter)) {
        [left, right] = this._processCharacterDeletionIfTrailingNegativeSign([left, right]);
      } else {
        if (this.eventKey === AutoNumericEnum_default.keyName.Backspace) {
          left = left.substring(0, left.length - 1);
        } else {
          right = right.substring(1, right.length);
        }
      }
    } else {
      this._expandSelectionOnSign();
      [left, right] = this._getUnformattedLeftAndRightPartAroundTheSelection();
    }
    if (!this.constructor._isWithinRangeWithOverrideOption(`${left}${right}`, this.settings)) {
      return false;
    }
    if (AutoNumericHelper.getElementValue(e.target) === this.settings.currencySymbol) {
      return false;
    }
    this._setValueParts(left, right);
    return true;
  }
  /**
   * Return `true` if a decimal character is allowed to be typed.
   * If the number of decimal places shown on focus is zero, then the decimal character is not allowed.
   *
   * @returns {boolean}
   * @private
   */
  _isDecimalCharacterInsertionAllowed() {
    return String(this.settings.decimalPlacesShownOnFocus) !== String(_AutoNumeric.options.decimalPlacesShownOnFocus.none) && String(this.settings.decimalPlaces) !== String(_AutoNumeric.options.decimalPlaces.none);
  }
  /**
   * Return `true` if the key is allowed.
   * This function decides if the key pressed should be dropped or accepted, and modify the value 'on-the-fly' accordingly.
   * //TODO This should use another function in order to separate the test and the modification
   *
   * @returns {boolean}
   */
  _processCharacterInsertion() {
    let [left, right] = this._getUnformattedLeftAndRightPartAroundTheSelection();
    if (this.eventKey !== AutoNumericEnum_default.keyName.AndroidDefault) {
      this.throwInput = true;
    }
    if (this.eventKey === this.settings.decimalCharacter || this.settings.decimalCharacterAlternative && this.eventKey === this.settings.decimalCharacterAlternative) {
      if (!this._isDecimalCharacterInsertionAllowed() || !this.settings.decimalCharacter) {
        return false;
      }
      if (this.settings.alwaysAllowDecimalCharacter) {
        left = left.replace(this.settings.decimalCharacter, "");
        right = right.replace(this.settings.decimalCharacter, "");
      } else {
        if (AutoNumericHelper.contains(left, this.settings.decimalCharacter)) {
          return true;
        }
        if (right.indexOf(this.settings.decimalCharacter) > 0) {
          return true;
        }
        if (right.indexOf(this.settings.decimalCharacter) === 0) {
          right = right.substr(1);
        }
      }
      if (this.settings.negativeSignCharacter && AutoNumericHelper.contains(right, this.settings.negativeSignCharacter)) {
        left = `${this.settings.negativeSignCharacter}${left}`;
        right = right.replace(this.settings.negativeSignCharacter, "");
      }
      this._setValueParts(left + this.settings.decimalCharacter, right);
      return true;
    }
    if ((this.eventKey === "-" || this.eventKey === "+") && this.settings.isNegativeSignAllowed) {
      if (left === "" && AutoNumericHelper.contains(right, "-")) {
        if (this.settings.negativePositiveSignBehavior || !this.settings.negativePositiveSignBehavior && this.eventKey === "+") {
          right = right.replace("-", "");
        }
      } else if (AutoNumericHelper.isNegativeStrict(left, "-")) {
        if (this.settings.negativePositiveSignBehavior || !this.settings.negativePositiveSignBehavior && this.eventKey === "+") {
          left = left.replace("-", "");
        }
      } else if (this.settings.negativePositiveSignBehavior || !this.settings.negativePositiveSignBehavior && this.eventKey === "-") {
        left = `${this.settings.negativeSignCharacter}${left}`;
      }
      this._setValueParts(left, right);
      return true;
    }
    const eventNumber = Number(this.eventKey);
    if (eventNumber >= 0 && eventNumber <= 9) {
      if (this.settings.isNegativeSignAllowed && left === "" && AutoNumericHelper.contains(right, "-")) {
        left = "-";
        right = right.substring(1, right.length);
      }
      if (this.settings.maximumValue <= 0 && this.settings.minimumValue < this.settings.maximumValue && !AutoNumericHelper.contains(AutoNumericHelper.getElementValue(this.domElement), this.settings.negativeSignCharacter) && this.eventKey !== "0") {
        left = `-${left}`;
      }
      this._setValueParts(`${left}${this.eventKey}`, right);
      return true;
    }
    this.throwInput = false;
    return false;
  }
  /**
   * Formatting of just processed value while keeping the cursor position
   *
   * @param {Event} e
   * @private
   */
  _formatValue(e) {
    const elementValue = AutoNumericHelper.getElementValue(this.domElement);
    let [left] = this._getUnformattedLeftAndRightPartAroundTheSelection();
    if ((this.settings.digitGroupSeparator === "" || this.settings.digitGroupSeparator !== "" && !AutoNumericHelper.contains(elementValue, this.settings.digitGroupSeparator)) && (this.settings.currencySymbol === "" || this.settings.currencySymbol !== "" && !AutoNumericHelper.contains(elementValue, this.settings.currencySymbol))) {
      let [subParts] = elementValue.split(this.settings.decimalCharacter);
      let negativeSign = "";
      if (AutoNumericHelper.isNegative(subParts, this.settings.negativeSignCharacter)) {
        negativeSign = this.settings.negativeSignCharacter;
        subParts = subParts.replace(this.settings.negativeSignCharacter, "");
        left = left.replace("-", "");
      }
      if (negativeSign === "" && subParts.length > this.settings.mIntPos && left.charAt(0) === "0") {
        left = left.slice(1);
      }
      if (negativeSign === this.settings.negativeSignCharacter && subParts.length > this.settings.mIntNeg && left.charAt(0) === "0") {
        left = left.slice(1);
      }
      if (!this.isTrailingNegative) {
        left = `${negativeSign}${left}`;
      }
    }
    const value = this.constructor._addGroupSeparators(elementValue, this.settings, this.isFocused, this.rawValue);
    let position = value.length;
    if (value) {
      const leftAr = left.split("");
      if ((this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.prefix && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) && leftAr[0] === this.settings.negativeSignCharacter && !this.settings.isNegativeSignAllowed) {
        leftAr.shift();
        if ((this.eventKey === AutoNumericEnum_default.keyName.Backspace || this.eventKey === AutoNumericEnum_default.keyName.Delete) && this.caretFix) {
          if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.left || this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix) {
            leftAr.push(this.settings.negativeSignCharacter);
            this.caretFix = e.type === "keydown";
          }
          if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.right) {
            const signParts = this.settings.currencySymbol.split("");
            const escapeChr = ["\\", "^", "$", ".", "|", "?", "*", "+", "(", ")", "["];
            const escapedParts = [];
            signParts.forEach((i, miniParts) => {
              miniParts = signParts[i];
              if (AutoNumericHelper.isInArray(miniParts, escapeChr)) {
                escapedParts.push("\\" + miniParts);
              } else {
                escapedParts.push(miniParts);
              }
            });
            if (this.eventKey === AutoNumericEnum_default.keyName.Backspace && this.settings.negativeSignCharacter === "-") {
              escapedParts.push("-");
            }
            leftAr.push(escapedParts.join(""));
            this.caretFix = e.type === "keydown";
          }
        }
      }
      for (let i = 0; i < leftAr.length; i++) {
        if (!leftAr[i].match("\\d")) {
          leftAr[i] = "\\" + leftAr[i];
        }
      }
      let leftReg;
      if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
        leftReg = new RegExp(`^.*?${leftAr.join(".*?")}`);
      } else {
        leftReg = new RegExp(`^.*?[${this.settings.currencySymbol}]*${leftAr.join(".*?")}`);
      }
      const newLeft = value.match(leftReg);
      if (newLeft) {
        position = newLeft[0].length;
        if (this.settings.showPositiveSign) {
          if (position === 0 && newLeft.input.charAt(0) === this.settings.positiveSignCharacter) {
            position = newLeft.input.indexOf(this.settings.currencySymbol) === 1 ? this.settings.currencySymbol.length + 1 : 1;
          }
          if (position === 0 && newLeft.input.charAt(this.settings.currencySymbol.length) === this.settings.positiveSignCharacter) {
            position = this.settings.currencySymbol.length + 1;
          }
        }
        if ((position === 0 && value.charAt(0) !== this.settings.negativeSignCharacter || position === 1 && value.charAt(0) === this.settings.negativeSignCharacter) && this.settings.currencySymbol && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
          position = this.settings.currencySymbol.length + (AutoNumericHelper.isNegativeStrict(value, this.settings.negativeSignCharacter) ? 1 : 0);
        }
      } else {
        if (this.settings.currencySymbol && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
          position -= this.settings.currencySymbol.length;
        }
        if (this.settings.suffixText) {
          position -= this.settings.suffixText.length;
        }
      }
    }
    if (value !== elementValue) {
      this._setElementValue(value, false);
      this._setCaretPosition(position);
    }
    this.formatted = true;
  }
  /**
   * Serialize the form child <input> element values to a string, or an Array.
   * The output format is defined with the `formatType` argument.
   * This is loosely based upon http://stackoverflow.com/a/40705993/2834898.
   *
   * @param {HTMLFormElement} form
   * @param {boolean} intoAnArray If `true`, instead of generating a string, it generates an Array.
   * @param {string} formatType If `'unformatted'`, then the AutoNumeric elements values are unformatted, if `'localized'`, then the AutoNumeric elements values are localized, and if `'formatted'`, then the AutoNumeric elements values are kept formatted. In either way, this function does not modify the value of each DOM element, but only affect the value that is returned by that serialize function.
   * @param {string} serializedSpaceCharacter Can either be the '+' character, or the '%20' string.
   * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
   * @returns {string|Array}
   * @private
   */
  static _serialize(form, intoAnArray = false, formatType = "unformatted", serializedSpaceCharacter = "+", forcedOutputFormat = null) {
    const result = [];
    if (typeof form === "object" && form.nodeName.toLowerCase() === "form") {
      Array.prototype.slice.call(form.elements).forEach((element) => {
        if (element.name && !element.disabled && ["file", "reset", "submit", "button"].indexOf(element.type) === -1) {
          if (element.type === "select-multiple") {
            Array.prototype.slice.call(element.options).forEach((option) => {
              if (option.selected) {
                if (intoAnArray) {
                  result.push({ name: element.name, value: option.value });
                } else {
                  result.push(`${encodeURIComponent(element.name)}=${encodeURIComponent(option.value)}`);
                }
              }
            });
          } else if (["checkbox", "radio"].indexOf(element.type) === -1 || element.checked) {
            let valueResult;
            if (this.isManagedByAutoNumeric(element)) {
              let anObject;
              switch (formatType) {
                case "unformatted":
                  anObject = this.getAutoNumericElement(element);
                  if (!AutoNumericHelper.isNull(anObject)) {
                    valueResult = this.unformat(element, anObject.getSettings());
                  }
                  break;
                case "localized":
                  anObject = this.getAutoNumericElement(element);
                  if (!AutoNumericHelper.isNull(anObject)) {
                    const currentSettings = AutoNumericHelper.cloneObject(anObject.getSettings());
                    if (!AutoNumericHelper.isNull(forcedOutputFormat)) {
                      currentSettings.outputFormat = forcedOutputFormat;
                    }
                    valueResult = this.localize(element, currentSettings);
                  }
                  break;
                case "formatted":
                default:
                  valueResult = element.value;
              }
            } else {
              valueResult = element.value;
            }
            if (AutoNumericHelper.isUndefined(valueResult)) {
              AutoNumericHelper.throwError("This error should never be hit. If it has, something really wrong happened!");
            }
            if (intoAnArray) {
              result.push({ name: element.name, value: valueResult });
            } else {
              result.push(`${encodeURIComponent(element.name)}=${encodeURIComponent(valueResult)}`);
            }
          }
        }
      });
    }
    let finalResult;
    if (intoAnArray) {
      finalResult = result;
    } else {
      finalResult = result.join("&");
      if ("+" === serializedSpaceCharacter) {
        finalResult = finalResult.replace(/%20/g, "+");
      }
    }
    return finalResult;
  }
  /**
   * Serialize the form values to a string, outputting numeric strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {string}
   */
  static _serializeNumericString(form, serializedSpaceCharacter = "+") {
    return this._serialize(form, false, "unformatted", serializedSpaceCharacter);
  }
  /**
   * Serialize the form values to a string, outputting the formatted value as strings for each AutoNumeric-managed elements.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {string}
   */
  static _serializeFormatted(form, serializedSpaceCharacter = "+") {
    return this._serialize(form, false, "formatted", serializedSpaceCharacter);
  }
  /**
   * Serialize the form values to a string, outputting localized strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
   * @returns {string}
   */
  static _serializeLocalized(form, serializedSpaceCharacter = "+", forcedOutputFormat = null) {
    return this._serialize(form, false, "localized", serializedSpaceCharacter, forcedOutputFormat);
  }
  /**
   * Generate an Array with the form values, outputting numeric strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {Array}
   */
  static _serializeNumericStringArray(form, serializedSpaceCharacter = "+") {
    return this._serialize(form, true, "unformatted", serializedSpaceCharacter);
  }
  /**
   * Generate an Array with the form values, outputting the formatted value as strings for each AutoNumeric-managed elements.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {Array}
   */
  static _serializeFormattedArray(form, serializedSpaceCharacter = "+") {
    return this._serialize(form, true, "formatted", serializedSpaceCharacter);
  }
  /**
   * Generate an Array with the form values, outputting localized strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
   * @returns {Array}
   */
  static _serializeLocalizedArray(form, serializedSpaceCharacter = "+", forcedOutputFormat = null) {
    return this._serialize(form, true, "localized", serializedSpaceCharacter, forcedOutputFormat);
  }
};
AutoNumeric.multiple = (arg1, initialValue = null, options = null) => {
  const result = [];
  if (AutoNumericHelper.isObject(initialValue)) {
    options = initialValue;
    initialValue = null;
  }
  if (AutoNumericHelper.isString(arg1)) {
    arg1 = [...document.querySelectorAll(arg1)];
  } else if (AutoNumericHelper.isObject(arg1)) {
    if (!Object.prototype.hasOwnProperty.call(arg1, "rootElement")) {
      AutoNumericHelper.throwError(`The object passed to the 'multiple' function is invalid ; no 'rootElement' attribute found.`);
    }
    const elements = [...arg1.rootElement.querySelectorAll("input")];
    if (Object.prototype.hasOwnProperty.call(arg1, "exclude")) {
      if (!Array.isArray(arg1.exclude)) {
        AutoNumericHelper.throwError(`The 'exclude' array passed to the 'multiple' function is invalid.`);
      }
      arg1 = AutoNumericHelper.filterOut(elements, arg1.exclude);
    } else {
      arg1 = elements;
    }
  } else if (!AutoNumericHelper.isArray(arg1)) {
    AutoNumericHelper.throwError(`The given parameters to the 'multiple' function are invalid.`);
  }
  if (arg1.length === 0) {
    let showWarnings = true;
    if (!AutoNumericHelper.isNull(options) && AutoNumericHelper.isBoolean(options.showWarnings)) {
      showWarnings = options.showWarnings;
    }
    AutoNumericHelper.warning(`No valid DOM elements were given hence no AutoNumeric objects were instantiated.`, showWarnings);
    return [];
  }
  const isInitialValueArray = AutoNumericHelper.isArray(initialValue);
  const isInitialValueArrayAndNotEmpty = isInitialValueArray && initialValue.length >= 1;
  let secondArgumentIsInitialValueArray = false;
  let secondArgumentIsOptionArray = false;
  if (isInitialValueArrayAndNotEmpty) {
    const typeOfFirstArrayElement = typeof Number(initialValue[0]);
    secondArgumentIsInitialValueArray = typeOfFirstArrayElement === "number" && !isNaN(Number(initialValue[0]));
    if (!secondArgumentIsInitialValueArray) {
      if (typeOfFirstArrayElement === "string" || isNaN(typeOfFirstArrayElement) || typeOfFirstArrayElement === "object") {
        secondArgumentIsOptionArray = true;
      }
    }
  }
  const isOptionsArrayAndNotEmpty = AutoNumericHelper.isArray(options) && options.length >= 1;
  let thirdArgumentIsOptionArray = false;
  if (isOptionsArrayAndNotEmpty) {
    const typeOfFirstArrayElement = typeof options[0];
    if (typeOfFirstArrayElement === "string" || typeOfFirstArrayElement === "object") {
      thirdArgumentIsOptionArray = true;
    }
  }
  let optionsToUse;
  if (secondArgumentIsOptionArray) {
    optionsToUse = AutoNumeric.mergeOptions(initialValue);
  } else if (thirdArgumentIsOptionArray) {
    optionsToUse = AutoNumeric.mergeOptions(options);
  } else {
    optionsToUse = options;
  }
  const isInitialValueNumber = AutoNumericHelper.isNumber(initialValue);
  let initialValueArraySize;
  if (secondArgumentIsInitialValueArray) {
    initialValueArraySize = initialValue.length;
  }
  arg1.forEach((domElement, index) => {
    if (isInitialValueNumber) {
      result.push(new AutoNumeric(domElement, initialValue, optionsToUse));
    } else if (secondArgumentIsInitialValueArray && index <= initialValueArraySize) {
      result.push(new AutoNumeric(domElement, initialValue[index], optionsToUse));
    } else {
      result.push(new AutoNumeric(domElement, null, optionsToUse));
    }
  });
  return result;
};

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/AutoNumericEvents.js
AutoNumeric.events = {
  correctedValue: "autoNumeric:correctedValue",
  initialized: "autoNumeric:initialized",
  invalidFormula: "autoNumeric:invalidFormula",
  invalidValue: "autoNumeric:invalidValue",
  formatted: "autoNumeric:formatted",
  rawValueModified: "autoNumeric:rawValueModified",
  minRangeExceeded: "autoNumeric:minExceeded",
  maxRangeExceeded: "autoNumeric:maxExceeded",
  native: {
    input: "input",
    change: "change"
  },
  validFormula: "autoNumeric:validFormula"
};
Object.freeze(AutoNumeric.events.native);
Object.freeze(AutoNumeric.events);
Object.defineProperty(AutoNumeric, "events", { configurable: false, writable: false });

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/AutoNumericOptions.js
AutoNumeric.options = {
  /* Defines if the decimal places should be padded with zeroes
   * `true`     : always pad decimals with zeros (ie. '12.3400')
   * `false`    : never pad with zeros (ie. '12.34')
   * `'floats'` : pad with zeroes only when there are decimals (ie. '12' and '12.3400')
   * Note: setting allowDecimalPadding to 'false' will override the 'decimalPlaces' setting.
   */
  allowDecimalPadding: {
    always: true,
    never: false,
    floats: "floats"
  },
  /* Defines if the decimal character or decimal character alternative should be accepted when there is already a decimal character shown in the element.
   * If set to `true`, any decimal character input will be accepted and will subsequently modify the decimal character position, as well as the `rawValue`.
   * If set to `false`, the decimal character and its alternative key will be dropped as before. This is the default setting.
   */
  alwaysAllowDecimalCharacter: {
    alwaysAllow: true,
    doNotAllow: false
  },
  /* Defines where should be positioned the caret on focus
   * null : Do not enforce any caret positioning on focus (this is needed when using `selectOnFocus`)
   * `'start'` : put the caret of the far left side of the value (excluding the positive/negative sign and currency symbol, if any)
   * `'end'` : put the caret of the far right side of the value (excluding the positive/negative sign and currency symbol, if any)
   * `'decimalLeft'` : put the caret of the left of the decimal character if any
   * `'decimalRight'` : put the caret of the right of the decimal character if any
   */
  caretPositionOnFocus: {
    start: "start",
    end: "end",
    decimalLeft: "decimalLeft",
    decimalRight: "decimalRight",
    doNoForceCaretPosition: null
  },
  /* Defines if a local list of AutoNumeric objects should be kept when initializing this object.
   * This list is used by the `global.*` functions.
   */
  createLocalList: {
    createList: true,
    doNotCreateList: false
  },
  /* Defines the currency symbol string.
   * It can be a string of more than one character (allowing for instance to use a space on either side of it, example: '$ ' or ' $')
   * cf. https://en.wikipedia.org/wiki/Currency_symbol
   */
  currencySymbol: {
    none: "",
    currencySign: "\xA4",
    austral: "\u20B3",
    // ARA
    australCentavo: "\xA2",
    baht: "\u0E3F",
    // THB
    cedi: "\u20B5",
    // GHS
    cent: "\xA2",
    colon: "\u20A1",
    // CRC
    cruzeiro: "\u20A2",
    // BRB - Not used anymore since 1993
    dollar: "$",
    dong: "\u20AB",
    // VND
    drachma: "\u20AF",
    // GRD (or 'Δρχ.' or 'Δρ.')
    dram: "\u200B\u058F",
    // AMD
    european: "\u20A0",
    // XEU (old currency before the Euro)
    euro: "\u20AC",
    // EUR
    florin: "\u0192",
    franc: "\u20A3",
    // FRF
    guarani: "\u20B2",
    // PYG
    hryvnia: "\u20B4",
    // грн
    kip: "\u20AD",
    // LAK
    att: "\u0EAD\u0EB1\u0E94",
    // cents of the Kip
    lepton: "\u039B.",
    // cents of the Drachma
    lira: "\u20BA",
    // TRY
    liraOld: "\u20A4",
    lari: "\u20BE",
    // GEL
    mark: "\u2133",
    mill: "\u20A5",
    naira: "\u20A6",
    // NGN
    peseta: "\u20A7",
    peso: "\u20B1",
    // PHP
    pfennig: "\u20B0",
    // cents of the Mark
    pound: "\xA3",
    real: "R$ ",
    // Brazilian real
    riel: "\u17DB",
    // KHR
    ruble: "\u20BD",
    // RUB
    rupee: "\u20B9",
    // INR
    rupeeOld: "\u20A8",
    shekel: "\u20AA",
    shekelAlt: "\u05E9\u05F4\u05D7\u200E\u200E",
    taka: "\u09F3",
    // BDT
    tenge: "\u20B8",
    // KZT
    togrog: "\u20AE",
    // MNT
    won: "\u20A9",
    yen: "\xA5"
  },
  /* Defines where the currency symbol should be placed (before of after the numbers)
   * for prefix currencySymbolPlacement: "p" (default)
   * for suffix currencySymbolPlacement: "s"
   */
  currencySymbolPlacement: {
    prefix: "p",
    suffix: "s"
  },
  /* Defines what decimal separator character is used
   */
  decimalCharacter: {
    comma: ",",
    dot: ".",
    middleDot: "\xB7",
    arabicDecimalSeparator: "\u066B",
    decimalSeparatorKeySymbol: "\u2396"
  },
  /* Allow to declare an alternative decimal separator which is automatically replaced by `decimalCharacter` when typed.
   * This is used by countries that use a comma ',' as the decimal character and have keyboards with a numeric pads that have
   * a period 'full stop' as the decimal character (France or Spain for instance).
   */
  decimalCharacterAlternative: {
    none: null,
    comma: ",",
    dot: "."
  },
  /* Defines the default number of decimal places to show on the formatted value, and keep for the precision.
   * Incidentally, since we need to be able to show that many decimal places, this also defines the raw value precision by default.
   */
  decimalPlaces: {
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Defines how many decimal places should be kept for the raw value (ie. This is the precision for float values).
   *
   * If this option is set to `null` (which is the default), then the value of `decimalPlaces` is used for `decimalPlacesRawValue` as well.
   * Note: Setting this to a lower number of decimal places than the one to be shown will lead to confusion for the users.
   */
  decimalPlacesRawValue: {
    useDefault: null,
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Defines how many decimal places should be visible when the element is unfocused.
   * If this is set to `null`, then this option is ignored, and the `decimalPlaces` option value will be used instead.
   * This means this is optional ; if omitted the decimal places will be the same when the input has the focus.
   *
   * This option can be used in conjonction with the two other `scale*` options, which allows to display a different formatted value when the element is unfocused, while another formatted value is shown when focused.
   * For those `scale*` options to have any effect, `divisorWhenUnfocused` must not be `null`.
   */
  decimalPlacesShownOnBlur: {
    useDefault: null,
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Defines how many decimal places should be visible when the element has the focus.
   * If this is set to `null`, then this option is ignored, and the `decimalPlaces` option value will be used instead.
   *
   * Example:
   * For instance if `decimalPlacesShownOnFocus` is set to `5` and the default number of decimal places is `2`, then on focus `1,000.12345` will be shown, while without focus `1,000.12` will be set back.
   * Note 1: the results depends on the rounding method used.
   * Note 2: the `getNumericString()` method returns the extended decimal places
   */
  decimalPlacesShownOnFocus: {
    useDefault: null,
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Helper option for ASP.NET postback
   * This should be set as the value of the unformatted default value
   * examples:
   * no default value="" {defaultValueOverride: ""}
   * value=1234.56 {defaultValueOverride: '1234.56'}
   */
  defaultValueOverride: {
    doNotOverride: null
  },
  /* Defines how many numbers should be grouped together (usually for the thousand separator)
   * - "2",  results in 99,99,99,99 Group by two
   * - "2t", results in 99,99,99,999 India's lakhs
   * - "2s", results in 99,999,99,99,999 India's lakhs scaled
   * - "3",  results in 999,999,999 (default)
   * - "4",  results in 9999,9999,9999 used in some Asian countries
   * Note: This option does not accept other grouping choice.
   */
  digitalGroupSpacing: {
    two: "2",
    twoThree: "2t",
    twoScaled: "2s",
    three: "3",
    four: "4"
  },
  /* Defines the thousand grouping separator character
   * Example : If `'.'` is set, then you'll get `'1.234.567'`
   */
  digitGroupSeparator: {
    comma: ",",
    dot: ".",
    normalSpace: " ",
    thinSpace: "\u2009",
    narrowNoBreakSpace: "\u202F",
    noBreakSpace: "\xA0",
    noSeparator: "",
    apostrophe: `'`,
    arabicThousandsSeparator: "\u066C",
    dotAbove: "\u02D9",
    privateUseTwo: "\u2019"
    // \u0092
  },
  /* The `divisorWhenUnfocused` divide the element value on focus.
   * On blur, the element value is multiplied back.
   *
   * Example : Display percentages using { divisorWhenUnfocused: 100 } (or directly in the Html with `<input data-divisor-when-unfocused="100">`)
   * The divisor value does not need to be an integer, but please understand that Javascript has limited accuracy in math ; use with caution.
   * Note: The `getNumericString` method returns the full value, including the 'hidden' decimals.
   */
  divisorWhenUnfocused: {
    none: null,
    percentage: 100,
    permille: 1e3,
    basisPoint: 1e4
  },
  /* Defines what should be displayed in the element if the raw value is an empty string ('').
   * - 'focus'  : The currency sign is displayed when the input receives focus (default)
   * - 'press'  : The currency sign is displayed whenever a key is being pressed
   * - 'always' : The currency sign is always displayed
   * - 'zero'   : A zero is displayed ('rounded' with or without a currency sign) if the input has no value on focus out
   * - 'min'    : The minimum value is displayed if the input has no value on focus out
   * - 'max'    : The maximum value is displayed if the input has no value on focus out
   * - 'null'   : When the element is empty, the `rawValue` and the element value/text is set to `null`. This also allows to set the value to `null` using `anElement.set(null)`.
   */
  emptyInputBehavior: {
    focus: "focus",
    press: "press",
    always: "always",
    zero: "zero",
    min: "min",
    max: "max",
    null: "null"
  },
  /* Defines if the custom and native events triggered by AutoNumeric should bubble up or not.
   */
  eventBubbles: {
    bubbles: true,
    doesNotBubble: false
  },
  /* Defines if the custom and native events triggered by AutoNumeric should be cancelable.
   */
  eventIsCancelable: {
    isCancelable: true,
    isNotCancelable: false
  },
  /* This option is the 'strict mode' (aka 'debug' mode), which allows autoNumeric to strictly analyse the options passed, and fails if an unknown options is used in the settings object.
   * You should set that to `true` if you want to make sure you are only using 'pure' autoNumeric settings objects in your code.
   * If you see uncaught errors in the console and your code starts to fail, this means somehow those options gets polluted by another program (which usually happens when using frameworks).
   */
  failOnUnknownOption: {
    fail: true,
    ignore: false
  },
  /* Determine if the default value will be formatted on initialization.
   */
  formatOnPageLoad: {
    format: true,
    // automatically formats the default value on initialization
    doNotFormat: false
    // will not format the default value on initialization
  },
  /* Defines if the 'formula mode' can be activated by the user.
   * If set to `true`, then the user can enter the formula mode by entering the '=' character.
   * He will then be allowed to enter any simple math formula using numeric characters as well as the following operators +, -, *, /, ( and ).
   * The formula mode is closed when the user either validate their math expression using the `Enter` key, or when the element is blurred.
   * If the formula is invalid, the previous valid `rawValue` is set back, and the `autoNumeric:invalidFormula` event is sent.
   * When a valid formula is accepted, then its result is `set()`, and the `autoNumeric:validFormula` event is sent.
   *
   * By default, this mode is disabled.
   */
  formulaMode: {
    enabled: true,
    disabled: false
  },
  /* Set the undo/redo history table size.
   * Each record keeps the raw value as well and the last known caret/selection positions.
   */
  historySize: {
    verySmall: 5,
    small: 10,
    medium: 20,
    large: 50,
    veryLarge: 100,
    insane: Number.MAX_SAFE_INTEGER
  },
  /* Defines the name of the CSS class to use on contenteditable-enabled elements when the value is invalid
   * This is not used when the HTML element used is an input.
   */
  invalidClass: "an-invalid",
  /* Allow the user to 'cancel' and undo the changes he made to the given autonumeric-managed element, by pressing the 'Escape' key.
   * Whenever the user 'validate' the input (either by hitting 'Enter', or blurring the element), the new value is saved for subsequent 'cancellation'.
   *
   * The process :
   *   - save the input value on focus
   *   - if the user change the input value, and hit `Escape`, then the initial value saved on focus is set back
   *   - on the other hand if the user either have used `Enter` to validate (`Enter` throws a change event) his entries, or if the input value has been changed by another script in the mean time, then we save the new input value
   *   - on a successful 'cancel', select the whole value (while respecting the `selectNumberOnly` option)
   *   - bonus; if the value has not changed, hitting 'Esc' just select all the input value (while respecting the `selectNumberOnly` option)
   */
  isCancellable: {
    cancellable: true,
    notCancellable: false
  },
  /* Controls the leading zero behavior
   * - 'allow' : allows leading zeros to be entered. Zeros will be truncated when entering additional digits. On focusout zeros will be deleted
   * - 'deny'  : allows only one leading zero on values that are between 1 and -1
   * - 'keep'  : allows leading zeros to be entered. on focusout zeros will be retained
   */
  leadingZero: {
    allow: "allow",
    deny: "deny",
    keep: "keep"
  },
  /* Defines the maximum possible value a user can enter.
   * Notes:
   * - this value must be a string and use the period for the decimal point
   * - this value needs to be larger than `minimumValue`
   */
  maximumValue: {
    tenTrillions: "10000000000000",
    // 10000 billions
    oneBillion: "1000000000",
    zero: "0"
  },
  /* Defines the minimum possible value a user can enter.
   * Notes:
   * - this value must be a string and use the period for the decimal point
   * - this value needs to be smaller than `maximumValue`
   * - if this is superior to 0, then you'll effectively prevent your user to entirely delete the content of your element
   */
  minimumValue: {
    tenTrillions: "-10000000000000",
    // 10000 billions
    oneBillion: "-1000000000",
    zero: "0"
  },
  /* Allows the user to increment or decrement the element value with the up and down arrow keys.
   * The behavior is similar to the mouse wheel one.
   * The up and down arrow keys behavior can be modified by the `upDownStep` option.
   * This `upDownStep` option can be used in two ways, either by setting:
   * - a 'fixed' step value (`upDownStep : 1000`), or
   * - the 'progressive' string (`upDownStep : 'progressive'`), which will then activate a special mode where the step is automatically calculated based on the element value size.
   */
  modifyValueOnUpDownArrow: {
    modifyValue: true,
    doNothing: false
  },
  /* Allows the user to increment or decrement the element value with the mouse wheel.
   * The behavior is similar to the up/down arrow one.
   * The wheel behavior can be modified by the `wheelStep` option.
   * This `wheelStep` option can be used in two ways, either by setting:
   * - a 'fixed' step value (`wheelStep : 1000`), or
   * - the 'progressive' string (`wheelStep : 'progressive'`), which will then activate a special mode where the step is automatically calculated based on the element value size.
   *
   * Note :
   * You can activate/deactivate the wheel event for each `wheelOn` option value by using the 'Shift' modifier key while using the mouse wheel.
   */
  modifyValueOnWheel: {
    modifyValue: true,
    doNothing: false
  },
  /* Adds brackets on negative values (ie. transforms '-$ 999.99' to '($999.99)')
   * Those brackets are visible only when the field does NOT have the focus.
   * The left and right symbols should be enclosed in quotes and separated by a comma.
   */
  negativeBracketsTypeOnBlur: {
    parentheses: "(,)",
    brackets: "[,]",
    chevrons: "<,>",
    curlyBraces: "{,}",
    angleBrackets: "\u3008,\u3009",
    japaneseQuotationMarks: "\uFF62,\uFF63",
    halfBrackets: "\u2E24,\u2E25",
    whiteSquareBrackets: "\u27E6,\u27E7",
    quotationMarks: "\u2039,\u203A",
    guillemets: "\xAB,\xBB",
    none: null
    // This is the default value, which deactivate this feature
  },
  /* Placement of the negative/positive sign relative to the `currencySymbol` option.
   *
   * Example:
   * // Default values
   * -1,234.56  => default no options required
   * $-1,234.56 => {currencySymbol: "$", negativePositiveSignPlacement: "r"} // Default if negativePositiveSignPlacement is 'null' and currencySymbol is not empty
   *
   * // Sign on the left hand side of the whole number
   * -$1,234.56 => {currencySymbol: "$"} or {currencySymbol: "$", negativePositiveSignPlacement: "l"}
   * -1,234.56$ => {currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "p"} // Default if negativePositiveSignPlacement is 'null' and currencySymbol is not empty
   *
   * // Sign on the right hand side of the whole number
   * 1,234.56-  => {negativePositiveSignPlacement: "s"}
   * $1,234.56- => {currencySymbol: "$", negativePositiveSignPlacement: "s"}
   * 1,234.56-$ => {currencySymbol: "$", currencySymbolPlacement: "s"}
   * 1,234.56$- => {currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "r"}
   */
  negativePositiveSignPlacement: {
    prefix: "p",
    suffix: "s",
    left: "l",
    right: "r",
    none: null
  },
  /* Defines the negative sign symbol.
   * It can be a string of only one character.
   */
  negativeSignCharacter: {
    hyphen: "-",
    minus: "\u2212",
    heavyMinus: "\u2796",
    fullWidthHyphen: "\uFF0D",
    circledMinus: "\u2296",
    squaredMinus: "\u229F",
    triangleMinus: "\u2A3A",
    plusMinus: "\xB1",
    minusPlus: "\u2213",
    dotMinus: "\u2238",
    minusTilde: "\u2242",
    not: "\xAC"
  },
  /*
   * Defines if the negative sign should be toggled when hitting the negative or positive key multiple times.
   * When `toggle` is used, using the same '-' on '+' key will toggle between a positive and negative value.
   * When `doNotToggle` is used, using '-' will always set the value negative, and '+' will always set the value positive.
   */
  negativePositiveSignBehavior: {
    toggle: true,
    doNotToggle: false
  },
  /* Defines if the element should have event listeners activated on it.
   * By default, those event listeners are only added to <input> elements and html element with the `contenteditable` attribute set to `true`, but not on the other html tags.
   * This allows to initialize elements without any event listeners.
   * Warning: Since AutoNumeric will not check the input content after its initialization, using some autoNumeric methods afterwards *will* probably leads to formatting problems.
   */
  noEventListeners: {
    noEvents: true,
    addEvents: false
  },
  /* Manage how autoNumeric react when the user tries to paste an invalid number.
   * - 'error'    : (This is the default behavior) The input value is not changed and an error is output in the console.
   * - 'ignore'   : idem than 'error', but fail silently without outputting any error/warning in the console.
   * - 'clamp'    : if the pasted value is either too small or too big regarding the minimumValue and maximumValue range, then the result is clamped to those limits.
   * - 'truncate' : autoNumeric will insert as many pasted numbers it can at the initial caret/selection, until everything is pasted, or the range limit is hit.
   *                The non-pasted numbers are dropped and therefore not used at all.
   * - 'replace'  : autoNumeric will first insert as many pasted numbers it can at the initial caret/selection, then if the range limit is hit, it will try
   *                to replace one by one the remaining initial numbers (on the right side of the caret) with the rest of the pasted numbers.
   *
   * Note 1 : A paste content starting with a negative sign '-' will be accepted anywhere in the input, and will set the resulting value as a negative number
   * Note 2 : A paste content starting with a number will be accepted, even if the rest is gibberish (ie. '123foobar456').
   *          Only the first number will be used (here '123').
   * Note 3 : The paste event works with the `decimalPlacesShownOnFocus` option too.
   */
  onInvalidPaste: {
    error: "error",
    ignore: "ignore",
    clamp: "clamp",
    truncate: "truncate",
    replace: "replace"
  },
  /* Defines how the value should be formatted when wanting a 'localized' version of it.
   * - null or 'string' => 'nnnn.nn' or '-nnnn.nn' as text type. This is the default behavior.
   * - 'number'         => nnnn.nn or -nnnn.nn as a Number (Warning: this works only for integers inferior to Number.MAX_SAFE_INTEGER)
   * - ',' or '-,'      => 'nnnn,nn' or '-nnnn,nn'
   * - '.-'             => 'nnnn.nn' or 'nnnn.nn-'
   * - ',-'             => 'nnnn,nn' or 'nnnn,nn-'
   *
   * Note: The hyphen '-' is translated to the custom negative sign defined in `negativeSignCharacter`
   */
  outputFormat: {
    string: "string",
    number: "number",
    dot: ".",
    negativeDot: "-.",
    comma: ",",
    negativeComma: "-,",
    dotNegative: ".-",
    commaNegative: ",-",
    none: null
  },
  /* Defines if AutoNumeric should let the user override the minimum and/or maximum limits when he types numbers in the element.
   * - 'ceiling' Strictly adheres to `maximumValue` and ignores the `minimumValue` settings
   *             It allows the user to enter anything between -∞ `and maximumValue`
   *             If `maximumValue` is less than 0, then it will prevent the user emptying the field or typing value above `maximumValue`, making sure the value entered is always valid
   * - 'floor'   Strictly adheres to `minimumValue` and ignores the `maximumValue` settings
   *             It allows the user to enter anything between `minimumValue` and +∞
   *             If `minimumValue` is higher than 0, then it will prevent the user emptying the field or typing value below `minimumValue`, making sure the value entered is always valid
   * - 'ignore'  Ignores both the `minimumValue` and `maximumValue` settings
   *             When using this option, the field will always be valid range-wise
   * - 'invalid' The user can temporarily type out-of-bound values. In doing so, the invalid state is set on the field.
   *             Whenever an invalid value is typed, an 'autoNumeric:invalidValue' event is sent
   *             When the value is correctly set back within the limit boundaries, the invalid state is removed, and the 'autoNumeric:correctedValue' event is sent
   * - 'doNotOverride' Strictly adheres to the `maximumValue` and `minimumValue` settings
   *                   This is the default behavior
   *                   If `0` is out of the min/max range, this will prevent the user clearing the input field, making sure the value entered is always valid
   */
  overrideMinMaxLimits: {
    ceiling: "ceiling",
    floor: "floor",
    ignore: "ignore",
    invalid: "invalid",
    doNotOverride: null
  },
  /* Defines the positive sign symbol.
   * It can be a string of only one character.
   * This is shown only if `showPositiveSign` is set to `true`.
   */
  positiveSignCharacter: {
    plus: "+",
    fullWidthPlus: "\uFF0B",
    heavyPlus: "\u2795",
    doublePlus: "\u29FA",
    triplePlus: "\u29FB",
    circledPlus: "\u2295",
    squaredPlus: "\u229E",
    trianglePlus: "\u2A39",
    plusMinus: "\xB1",
    minusPlus: "\u2213",
    dotPlus: "\u2214",
    altHebrewPlus: "\uFB29",
    normalSpace: " ",
    thinSpace: "\u2009",
    narrowNoBreakSpace: "\u202F",
    noBreakSpace: "\xA0"
  },
  /* The `rawValueDivisor` divides the formatted value shown in the AutoNumeric element and store the result in `rawValue`.
   * @example { rawValueDivisor: '100' } or <input data-raw-value-divisor="100">
   * Given the `0.01234` raw value, the formatted value will be displayed as `'1.234'`.
   * This is useful when displaying percentage for instance, and avoid the need to divide/multiply by 100 between the number shown and the raw value.
   */
  rawValueDivisor: {
    none: null,
    percentage: 100,
    permille: 1e3,
    basisPoint: 1e4
  },
  /* Defines if the element (`<input>` or another allowed html tag) should be set as read-only on initialization.
   * When set to `true`, then:
   * - the `readonly` html property is added to the <input> element on initialization, or
   * - the `contenteditable` attribute is set to `false` on non-input elements.
   */
  readOnly: {
    readOnly: true,
    readWrite: false
  },
  /* Defines the rounding method to use.
   * roundingMethod: "S", Round-Half-Up Symmetric (default)
   * roundingMethod: "A", Round-Half-Up Asymmetric
   * roundingMethod: "s", Round-Half-Down Symmetric (lower case s)
   * roundingMethod: "a", Round-Half-Down Asymmetric (lower case a)
   * roundingMethod: "B", Round-Half-Even "Bankers Rounding"
   * roundingMethod: "U", Round Up "Round-Away-From-Zero"
   * roundingMethod: "D", Round Down "Round-Toward-Zero" - same as truncate
   * roundingMethod: "C", Round to Ceiling "Toward Positive Infinity"
   * roundingMethod: "F", Round to Floor "Toward Negative Infinity"
   * roundingMethod: "N05" Rounds to the nearest .05 => same as "CHF" used in 1.9X and still valid
   * roundingMethod: "U05" Rounds up to next .05
   * roundingMethod: "D05" Rounds down to next .05
   */
  roundingMethod: {
    halfUpSymmetric: "S",
    halfUpAsymmetric: "A",
    halfDownSymmetric: "s",
    halfDownAsymmetric: "a",
    halfEvenBankersRounding: "B",
    upRoundAwayFromZero: "U",
    downRoundTowardZero: "D",
    toCeilingTowardPositiveInfinity: "C",
    toFloorTowardNegativeInfinity: "F",
    toNearest05: "N05",
    toNearest05Alt: "CHF",
    upToNext05: "U05",
    downToNext05: "D05"
  },
  /* Set to `true` to allow the `decimalPlacesShownOnFocus` value to be saved with sessionStorage
   * If IE 6 or 7 is detected, the value will be saved as a session cookie.
   */
  saveValueToSessionStorage: {
    save: true,
    doNotSave: false
  },
  /* Determine if the select all keyboard command will select the complete input text, or only the input numeric value
   * Note : If the currency symbol is between the numeric value and the negative sign, only the numeric value will be selected
   */
  selectNumberOnly: {
    selectNumbersOnly: true,
    selectAll: false
  },
  /* Defines if the element value should be selected on focus.
   * Note: The selection is done using the `selectNumberOnly` option.
   */
  selectOnFocus: {
    select: true,
    doNotSelect: false
  },
  /* Defines how the serialize functions should treat the spaces.
   * Those spaces ' ' can either be converted to the plus sign '+', which is the default, or to '%20'.
   * Both values being valid per the spec (http://www.w3.org/Addressing/URL/uri-spec.html).
   * Also see the summed up answer on http://stackoverflow.com/a/33939287.
   *
   * tl;dr : Spaces should be converted to '%20' before the '?' sign, then converted to '+' after.
   * In our case since we serialize the query, we use '+' as the default (but allow the user to get back the old *wrong* behavior).
   */
  serializeSpaces: {
    plus: "+",
    percent: "%20"
  },
  /* Defines if the element value should be converted to the raw value on focus (and back to the formatted on blur).
   * If set to `true`, then autoNumeric remove the thousand separator, currency symbol and suffix on focus.
   * Example:
   * If the input value is '$ 1,999.88 suffix', on focus it becomes '1999.88' and back to '$ 1,999.88 suffix' on blur.
   */
  showOnlyNumbersOnFocus: {
    onlyNumbers: true,
    showAll: false
  },
  /* Allow the positive sign symbol `+` to be displayed for positive numbers.
   * By default, this positive sign is not shown.
   * The sign placement is controlled by the 'negativePositiveSignPlacement' option, mimicking the negative sign placement rules.
   */
  showPositiveSign: {
    show: true,
    hide: false
  },
  /* Defines if warnings should be shown in the console.
   * Those warnings can be ignored, but are usually printed when something could be improved by the user (ie. option conflicts).
   */
  showWarnings: {
    show: true,
    // All warning are shown
    hide: false
    // No warnings are shown, only the thrown errors
  },
  /* Defines the rules that calculate the CSS class(es) to apply on the element, based on the raw unformatted value.
   * This can also be used to call callbacks whenever the `rawValue` is updated.
   * Important: all callbacks must return `null` if no ranges/userDefined classes are selected
   * @example
   * {
   *     positive   : 'autoNumeric-positive', // Or `null` to not use it
   *     negative   : 'autoNumeric-negative',
   *     ranges     : [
   *         { min: 0, max: 25, class: 'autoNumeric-red' },
   *         { min: 25, max: 50, class: 'autoNumeric-orange' },
   *         { min: 50, max: 75, class: 'autoNumeric-yellow' },
   *         { min: 75, max: Number.MAX_SAFE_INTEGER, class: 'autoNumeric-green' },
   *     ],
   *     userDefined: [
   *         // If 'classes' is a string, set it if `true`, remove it if `false`
   *         { callback: rawValue => { return true; }, classes: 'thisIsTrue' },
   *         // If 'classes' is an array with only 2 elements, set the first class if `true`, the second if `false`
   *         { callback: rawValue => rawValue % 2 === 0, classes: ['autoNumeric-even', 'autoNumeric-odd'] },
   *         // Return only one index to use on the `classes` array (here, 'class3')
   *         { callback: rawValue => { return 2; }, classes: ['class1', 'class2', 'class3'] },
   *         // Return an array of indexes to use on the `classes` array (here, 'class1' and 'class3')
   *         { callback: rawValue => { return [0, 2]; }, classes: ['class1', 'class2', 'class3'] },
   *         // If 'classes' is `undefined` or `null`, then the callback is called with the AutoNumeric object passed as a parameter
   *         { callback: anElement => { return anElement.getFormatted(); } },
   *     ],
   * }
   */
  styleRules: {
    none: null,
    positiveNegative: {
      positive: "autoNumeric-positive",
      negative: "autoNumeric-negative"
    },
    range0To100With4Steps: {
      ranges: [
        { min: 0, max: 25, class: "autoNumeric-red" },
        { min: 25, max: 50, class: "autoNumeric-orange" },
        { min: 50, max: 75, class: "autoNumeric-yellow" },
        { min: 75, max: 100, class: "autoNumeric-green" }
      ]
    },
    evenOdd: {
      userDefined: [
        { callback: (rawValue) => rawValue % 2 === 0, classes: ["autoNumeric-even", "autoNumeric-odd"] }
      ]
    },
    rangeSmallAndZero: {
      userDefined: [
        {
          callback: (rawValue) => {
            if (rawValue >= -1 && rawValue < 0) {
              return 0;
            }
            if (Number(rawValue) === 0) {
              return 1;
            }
            if (rawValue > 0 && rawValue <= 1) {
              return 2;
            }
            return null;
          },
          classes: [
            "autoNumeric-small-negative",
            "autoNumeric-zero",
            "autoNumeric-small-positive"
          ]
        }
      ]
    }
  },
  /* Add a text on the right hand side of the element value.
   * This suffix text can have any characters in its string, except numeric characters and the negative/positive sign.
   * Example: ' dollars'
   */
  suffixText: {
    none: "",
    percentage: "%",
    permille: "\u2030",
    basisPoint: "\u2031"
  },
  /* The three options (divisorWhenUnfocused, decimalPlacesShownOnBlur & symbolWhenUnfocused) handle scaling of the input when the input does not have focus
   * Please note that the non-scaled value is held in data and it is advised that you use the `saveValueToSessionStorage` option to ensure retaining the value
   * ["divisor", "decimal places", "symbol"]
   * Example: with the following options set {divisorWhenUnfocused: '1000', decimalPlacesShownOnBlur: '1', symbolWhenUnfocused: ' K'}
   * Example: focusin value "1,111.11" focusout value "1.1 K"
   */
  /* The `symbolWhenUnfocused` option is a symbol placed as a suffix when not in focus.
   * This is optional too.
   */
  symbolWhenUnfocused: {
    none: null,
    percentage: "%",
    permille: "\u2030",
    basisPoint: "\u2031"
  },
  /* Defines if the element value should be unformatted when the user hover his mouse over it while holding the `Alt` key.
   * Unformatting there means that this removes any non-number characters and displays the *raw* value, as understood by Javascript (ie. `12.34` is a valid number, while `12,34` is not).
   *
   * We reformat back before anything else if :
   * - the user focus on the element by tabbing or clicking into it,
   * - the user releases the `Alt` key, and
   * - if we detect a mouseleave event.
   *
   * We unformat again if :
   * - while the mouse is over the element, the user hit `Alt` again
   */
  unformatOnHover: {
    unformat: true,
    doNotUnformat: false
    //TODO Rename to `keepFormat`
  },
  /* Removes the formatting and use the raw value in each autoNumeric elements of the parent form element, on the form `submit` event.
   * The output format is a numeric string (nnnn.nn or -nnnn.nn).
   */
  unformatOnSubmit: {
    unformat: true,
    keepCurrentValue: false
  },
  /* That option is linked to the `modifyValueOnUpDownArrow` one and will only be used if the latter is set to `true`.
   * This option will modify the up/down arrow behavior and can be used in two ways, either by setting :
   * - a 'fixed' step value (a positive float or integer number (ex: `1000`)), or
   * - the `'progressive'` string.
   *
   * The 'fixed' mode always increment/decrement the element value by that amount, while respecting the `minimumValue` and `maximumValue` settings.
   * The 'progressive' mode will increment/decrement the element value based on its current value. The bigger the number, the bigger the step, and vice versa.
   */
  upDownStep: {
    progressive: "progressive"
  },
  /* Provides a way for automatically replacing the formatted value with a pre-defined string, when the raw value is equal to a specific value
   * Here you can specify as many 'conversion' as needed.
   */
  valuesToStrings: {
    none: null,
    zeroDash: {
      0: "-"
    },
    oneAroundZero: {
      "-1": "Min",
      1: "Max"
    }
  },
  /* Defines if the AutoNumeric element should watch external changes made without using `.set()`, but by using the basic `aNElement.node().value = 42` notation.
   * If set to `watch`, then AutoNumeric will format the new value using `.set()` internally.
   * Otherwise it will neither format it, nor save it in the history.
   */
  watchExternalChanges: {
    watch: true,
    doNotWatch: false
  },
  /* Defines when the wheel event will increment or decrement the element value.
   * When set to `'focus'`, the AutoNumeric-managed element needs to be focused for the wheel event to change the value.
   * When set to `'hover'`, using the wheel event while the mouse is hovering the element is sufficient (no focus needed).
   *
   * Note :
   * When `wheelOn` is set to `'focus'`, you can use the 'Shift' modifier key while using the mouse wheel in order to temporarily activate the increment/decrement feature even if the element is not focused.
   * When `wheelOn` is set to `'hover'`, you can use the 'Shift' modifier key while using the mouse wheel in order to temporarily disable the increment/decrement feature even if the element is not hovered.
   */
  wheelOn: {
    focus: "focus",
    hover: "hover"
  },
  /* That option is linked to the `modifyValueOnWheel` one and will only be used if the latter is set to `true`.
   * This option will modify the wheel behavior and can be used in two ways, either by setting :
   * - a 'fixed' step value (a positive float or integer (ex: number `1000`)), or
   * - the `'progressive'` string.
   *
   * The 'fixed' mode always increment/decrement the element value by that amount, while respecting the `minimumValue` and `maximumValue` settings.
   * The 'progressive' mode will increment/decrement the element value based on its current value. The bigger the number, the bigger the step, and vice versa.
   */
  wheelStep: {
    progressive: "progressive"
  }
};
function freezeOptions(options) {
  Object.getOwnPropertyNames(options).forEach((optionName) => {
    if (optionName === "valuesToStrings") {
      const vsProps = Object.getOwnPropertyNames(options.valuesToStrings);
      vsProps.forEach((valuesToStringObjectName) => {
        if (options.valuesToStrings[valuesToStringObjectName] !== null) {
          Object.freeze(options.valuesToStrings[valuesToStringObjectName]);
        }
      });
    } else if (optionName !== "styleRules") {
      if (options[optionName] !== null) {
        Object.freeze(options[optionName]);
      }
    }
  });
  return Object.freeze(options);
}
freezeOptions(AutoNumeric.options);
Object.defineProperty(AutoNumeric, "options", { configurable: false, writable: false });

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/AutoNumericDefaultSettings.js
AutoNumeric.defaultSettings = {
  allowDecimalPadding: AutoNumeric.options.allowDecimalPadding.always,
  alwaysAllowDecimalCharacter: AutoNumeric.options.alwaysAllowDecimalCharacter.doNotAllow,
  caretPositionOnFocus: AutoNumeric.options.caretPositionOnFocus.doNoForceCaretPosition,
  createLocalList: AutoNumeric.options.createLocalList.createList,
  currencySymbol: AutoNumeric.options.currencySymbol.none,
  currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
  decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
  decimalCharacterAlternative: AutoNumeric.options.decimalCharacterAlternative.none,
  decimalPlaces: AutoNumeric.options.decimalPlaces.two,
  decimalPlacesRawValue: AutoNumeric.options.decimalPlacesRawValue.useDefault,
  decimalPlacesShownOnBlur: AutoNumeric.options.decimalPlacesShownOnBlur.useDefault,
  decimalPlacesShownOnFocus: AutoNumeric.options.decimalPlacesShownOnFocus.useDefault,
  defaultValueOverride: AutoNumeric.options.defaultValueOverride.doNotOverride,
  digitalGroupSpacing: AutoNumeric.options.digitalGroupSpacing.three,
  digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
  divisorWhenUnfocused: AutoNumeric.options.divisorWhenUnfocused.none,
  emptyInputBehavior: AutoNumeric.options.emptyInputBehavior.focus,
  eventBubbles: AutoNumeric.options.eventBubbles.bubbles,
  eventIsCancelable: AutoNumeric.options.eventIsCancelable.isCancelable,
  failOnUnknownOption: AutoNumeric.options.failOnUnknownOption.ignore,
  formatOnPageLoad: AutoNumeric.options.formatOnPageLoad.format,
  formulaMode: AutoNumeric.options.formulaMode.disabled,
  historySize: AutoNumeric.options.historySize.medium,
  invalidClass: AutoNumeric.options.invalidClass,
  isCancellable: AutoNumeric.options.isCancellable.cancellable,
  leadingZero: AutoNumeric.options.leadingZero.deny,
  maximumValue: AutoNumeric.options.maximumValue.tenTrillions,
  minimumValue: AutoNumeric.options.minimumValue.tenTrillions,
  modifyValueOnUpDownArrow: AutoNumeric.options.modifyValueOnUpDownArrow.modifyValue,
  modifyValueOnWheel: AutoNumeric.options.modifyValueOnWheel.modifyValue,
  negativeBracketsTypeOnBlur: AutoNumeric.options.negativeBracketsTypeOnBlur.none,
  negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.none,
  negativeSignCharacter: AutoNumeric.options.negativeSignCharacter.hyphen,
  negativePositiveSignBehavior: AutoNumeric.options.negativePositiveSignBehavior.doNotToggle,
  noEventListeners: AutoNumeric.options.noEventListeners.addEvents,
  //TODO Shouldn't we use `truncate` as the default value?
  onInvalidPaste: AutoNumeric.options.onInvalidPaste.error,
  outputFormat: AutoNumeric.options.outputFormat.none,
  overrideMinMaxLimits: AutoNumeric.options.overrideMinMaxLimits.doNotOverride,
  positiveSignCharacter: AutoNumeric.options.positiveSignCharacter.plus,
  rawValueDivisor: AutoNumeric.options.rawValueDivisor.none,
  readOnly: AutoNumeric.options.readOnly.readWrite,
  roundingMethod: AutoNumeric.options.roundingMethod.halfUpSymmetric,
  saveValueToSessionStorage: AutoNumeric.options.saveValueToSessionStorage.doNotSave,
  selectNumberOnly: AutoNumeric.options.selectNumberOnly.selectNumbersOnly,
  selectOnFocus: AutoNumeric.options.selectOnFocus.select,
  serializeSpaces: AutoNumeric.options.serializeSpaces.plus,
  showOnlyNumbersOnFocus: AutoNumeric.options.showOnlyNumbersOnFocus.showAll,
  showPositiveSign: AutoNumeric.options.showPositiveSign.hide,
  showWarnings: AutoNumeric.options.showWarnings.show,
  styleRules: AutoNumeric.options.styleRules.none,
  suffixText: AutoNumeric.options.suffixText.none,
  symbolWhenUnfocused: AutoNumeric.options.symbolWhenUnfocused.none,
  unformatOnHover: AutoNumeric.options.unformatOnHover.unformat,
  unformatOnSubmit: AutoNumeric.options.unformatOnSubmit.keepCurrentValue,
  upDownStep: "1",
  // To mimic the behavior of 'numeric'-typed input
  valuesToStrings: AutoNumeric.options.valuesToStrings.none,
  watchExternalChanges: AutoNumeric.options.watchExternalChanges.doNotWatch,
  wheelOn: AutoNumeric.options.wheelOn.focus,
  wheelStep: AutoNumeric.options.wheelStep.progressive
};
Object.freeze(AutoNumeric.defaultSettings);
Object.defineProperty(AutoNumeric, "defaultSettings", { configurable: false, writable: false });

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/AutoNumericPredefinedOptions.js
var euro = {
  // Français
  digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.dot,
  // or '\u202f'
  decimalCharacter: AutoNumeric.options.decimalCharacter.comma,
  decimalCharacterAlternative: AutoNumeric.options.decimalCharacterAlternative.dot,
  currencySymbol: "\u202F\u20AC",
  currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.suffix,
  negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.prefix
};
var dollar = {
  digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
  decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
  currencySymbol: AutoNumeric.options.currencySymbol.dollar,
  currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
  negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.right
};
var japanese = {
  // 日本語
  digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
  decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
  currencySymbol: AutoNumeric.options.currencySymbol.yen,
  currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
  negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.right
};
var euroF = AutoNumericHelper.cloneObject(euro);
euroF.formulaMode = AutoNumeric.options.formulaMode.enabled;
var euroPos = AutoNumericHelper.cloneObject(euro);
euroPos.minimumValue = 0;
var euroNeg = AutoNumericHelper.cloneObject(euro);
euroNeg.maximumValue = 0;
euroNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
var euroSpace = AutoNumericHelper.cloneObject(euro);
euroSpace.digitGroupSeparator = AutoNumeric.options.digitGroupSeparator.normalSpace;
var euroSpacePos = AutoNumericHelper.cloneObject(euroSpace);
euroSpacePos.minimumValue = 0;
var euroSpaceNeg = AutoNumericHelper.cloneObject(euroSpace);
euroSpaceNeg.maximumValue = 0;
euroSpaceNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
var percentageEU2dec = AutoNumericHelper.cloneObject(euro);
percentageEU2dec.currencySymbol = AutoNumeric.options.currencySymbol.none;
percentageEU2dec.suffixText = `\u202F${AutoNumeric.options.suffixText.percentage}`;
percentageEU2dec.wheelStep = 1e-4;
percentageEU2dec.rawValueDivisor = AutoNumeric.options.rawValueDivisor.percentage;
var percentageEU2decPos = AutoNumericHelper.cloneObject(percentageEU2dec);
percentageEU2decPos.minimumValue = 0;
var percentageEU2decNeg = AutoNumericHelper.cloneObject(percentageEU2dec);
percentageEU2decNeg.maximumValue = 0;
percentageEU2decNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
var percentageEU3dec = AutoNumericHelper.cloneObject(percentageEU2dec);
percentageEU3dec.decimalPlaces = 3;
var percentageEU3decPos = AutoNumericHelper.cloneObject(percentageEU2decPos);
percentageEU3decPos.decimalPlaces = 3;
var percentageEU3decNeg = AutoNumericHelper.cloneObject(percentageEU2decNeg);
percentageEU3decNeg.decimalPlaces = 3;
var dollarF = AutoNumericHelper.cloneObject(dollar);
dollarF.formulaMode = AutoNumeric.options.formulaMode.enabled;
var dollarPos = AutoNumericHelper.cloneObject(dollar);
dollarPos.minimumValue = 0;
var dollarNeg = AutoNumericHelper.cloneObject(dollar);
dollarNeg.maximumValue = 0;
dollarNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
var dollarNegBrackets = AutoNumericHelper.cloneObject(dollarNeg);
dollarNegBrackets.negativeBracketsTypeOnBlur = AutoNumeric.options.negativeBracketsTypeOnBlur.parentheses;
var percentageUS2dec = AutoNumericHelper.cloneObject(dollar);
percentageUS2dec.currencySymbol = AutoNumeric.options.currencySymbol.none;
percentageUS2dec.suffixText = AutoNumeric.options.suffixText.percentage;
percentageUS2dec.wheelStep = 1e-4;
percentageUS2dec.rawValueDivisor = AutoNumeric.options.rawValueDivisor.percentage;
var percentageUS2decPos = AutoNumericHelper.cloneObject(percentageUS2dec);
percentageUS2decPos.minimumValue = 0;
var percentageUS2decNeg = AutoNumericHelper.cloneObject(percentageUS2dec);
percentageUS2decNeg.maximumValue = 0;
percentageUS2decNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
var percentageUS3dec = AutoNumericHelper.cloneObject(percentageUS2dec);
percentageUS3dec.decimalPlaces = 3;
var percentageUS3decPos = AutoNumericHelper.cloneObject(percentageUS2decPos);
percentageUS3decPos.decimalPlaces = 3;
var percentageUS3decNeg = AutoNumericHelper.cloneObject(percentageUS2decNeg);
percentageUS3decNeg.decimalPlaces = 3;
var turkish = AutoNumericHelper.cloneObject(euro);
turkish.currencySymbol = AutoNumeric.options.currencySymbol.lira;
AutoNumeric.predefinedOptions = {
  euro,
  euroPos,
  euroNeg,
  euroSpace,
  euroSpacePos,
  euroSpaceNeg,
  percentageEU2dec,
  percentageEU2decPos,
  percentageEU2decNeg,
  percentageEU3dec,
  percentageEU3decPos,
  percentageEU3decNeg,
  dollar,
  dollarPos,
  dollarNeg,
  dollarNegBrackets,
  percentageUS2dec,
  percentageUS2decPos,
  percentageUS2decNeg,
  percentageUS3dec,
  percentageUS3decPos,
  percentageUS3decNeg,
  French: euro,
  // Français
  Spanish: euro,
  // Español
  NorthAmerican: dollar,
  British: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: AutoNumeric.options.currencySymbol.pound,
    currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
    negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.right
  },
  Swiss: {
    // Suisse
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.apostrophe,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: "\u202FCHF",
    currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.suffix,
    negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.prefix
  },
  Japanese: japanese,
  // 日本語
  Chinese: japanese,
  // 中国語 (Chinese)
  Brazilian: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.dot,
    decimalCharacter: AutoNumeric.options.decimalCharacter.comma,
    currencySymbol: AutoNumeric.options.currencySymbol.real,
    currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
    negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.right
  },
  Turkish: turkish,
  dotDecimalCharCommaSeparator: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot
  },
  commaDecimalCharDotSeparator: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.dot,
    decimalCharacter: AutoNumeric.options.decimalCharacter.comma,
    decimalCharacterAlternative: AutoNumeric.options.decimalCharacterAlternative.dot
  },
  integer: {
    decimalPlaces: 0
  },
  integerPos: {
    minimumValue: AutoNumeric.options.minimumValue.zero,
    decimalPlaces: 0
  },
  integerNeg: {
    maximumValue: AutoNumeric.options.maximumValue.zero,
    decimalPlaces: 0
  },
  float: {
    allowDecimalPadding: AutoNumeric.options.allowDecimalPadding.never
  },
  floatPos: {
    allowDecimalPadding: AutoNumeric.options.allowDecimalPadding.never,
    minimumValue: AutoNumeric.options.minimumValue.zero,
    maximumValue: AutoNumeric.options.maximumValue.tenTrillions
  },
  floatNeg: {
    allowDecimalPadding: AutoNumeric.options.allowDecimalPadding.never,
    minimumValue: AutoNumeric.options.minimumValue.tenTrillions,
    maximumValue: AutoNumeric.options.maximumValue.zero
  },
  numeric: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.noSeparator,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: AutoNumeric.options.currencySymbol.none
  },
  numericPos: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.noSeparator,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: AutoNumeric.options.currencySymbol.none,
    minimumValue: AutoNumeric.options.minimumValue.zero,
    maximumValue: AutoNumeric.options.maximumValue.tenTrillions
  },
  numericNeg: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.noSeparator,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: AutoNumeric.options.currencySymbol.none,
    minimumValue: AutoNumeric.options.minimumValue.tenTrillions,
    maximumValue: AutoNumeric.options.maximumValue.zero
  }
};
Object.getOwnPropertyNames(AutoNumeric.predefinedOptions).forEach((optionName) => {
  Object.freeze(AutoNumeric.predefinedOptions[optionName]);
});
Object.freeze(AutoNumeric.predefinedOptions);
Object.defineProperty(AutoNumeric, "predefinedOptions", { configurable: false, writable: false });

// ../../node_modules/.pnpm/autonumeric@4.10.5/node_modules/autonumeric/src/main.js
var main_default = AutoNumeric;
var useUpdateMultiSearchParams = (router, db_version, pathName) => {
  return useCallback(
    (values3) => {
      const qs = toSearchParams(values3, db_version);
      router.push(`${pathName}?${qs.toString()}`);
    },
    [router, pathName, db_version]
  );
};
var paramToField = {
  hire: "hireOverride",
  sfo: "sfoOverride",
  mgo: "mgoOverride",
  ballastBonus: "ballastBonusOverride",
  c: "useCache",
  optimizer: "optimizerMode",
  oBase: "optimizeBase"
};
var serializeParam = (value) => {
  if (typeof value === "boolean") {
    return value ? "1" : "0";
  }
  if (value === void 0) {
    return "";
  }
  return `${value}`;
};
var toSearchParams = (data2, db_version, mode = 2 /* multi */) => {
  const params = new URLSearchParams();
  if (isSet(mode)) {
    params.append("mode", `${mode}`);
  }
  for (const [param, field] of Object.entries(paramToField)) {
    if (isSet(data2[field])) {
      params.append(param, serializeParam(data2[field]));
    }
  }
  if (isSet(db_version)) {
    params.append("db_version", db_version);
  }
  for (const [i, port] of data2.ports.entries()) {
    if (!isSet(port.port)) {
      continue;
    }
    params.append(`port`, port.port);
    if (isSet(port.portDA)) {
      params.append(`port-${i}-da`, `${port.portDA}`);
    }
    for (const [j, operation] of port.operations.entries()) {
      params.append(
        `p${i}-o`,
        operation.operation === OperationType.D ? "D" : "L"
      );
      const tag = `p${i}-${j}-`;
      if (isSet(operation.amount)) {
        params.append(`${tag}amount`, `${operation.amount}`);
      }
      if (isSet(operation.commodity)) {
        params.append(`${tag}commodity`, operation.commodity);
      }
      if (isSet(operation.cadence)) {
        params.append(`${tag}cadence`, `${operation.cadence}`);
      }
      if (isSet(operation.terms)) {
        params.append(`${tag}terms`, operation.terms);
      }
      if (isSet(operation.useVesselGear)) {
        params.append(`${tag}gear`, serializeParam(operation.useVesselGear));
      }
      if (isSet(operation.tolerance)) {
        params.append(`${tag}tolerance`, `${operation.tolerance}`);
      }
      if (isSet(operation.commodityPrice)) {
        params.append(`${tag}price`, `${operation.commodityPrice}`);
      }
      if (isSet(operation.userCfrPrice)) {
        params.append(`${tag}cfr`, `${operation.userCfrPrice}`);
      }
      if (isSet(operation.stowageFactor)) {
        params.append(`${tag}sf`, `${operation.stowageFactor}`);
      }
      if (isSet(operation.draft)) {
        params.append(`${tag}draft`, `${operation.draft}`);
      }
    }
  }
  return params;
};
var asNumber = (params, key) => {
  const value = params.get(key);
  if (!isSet(value)) {
    return void 0;
  }
  return parseFloat(value);
};
function fromSearchParams(params) {
  const hire = asNumber(params, "hire");
  const sfoPrice = asNumber(params, "sfo");
  const mgoPrice = asNumber(params, "mgo");
  const ballastBonusOverride = asNumber(params, "ballastBonus");
  let optimizerMode = params.get("optimizer");
  if (optimizerMode !== "optimize" && optimizerMode !== "fixed") {
    optimizerMode = "optimize";
  }
  let optimizeBase = params.get("oBase");
  if (optimizeBase !== "cheapest" && optimizeBase !== "profitLoss") {
    optimizeBase = "cheapest";
  }
  const ports = params.getAll("port");
  const portList = [];
  const toNumber = (value) => {
    if (!isSet(value)) {
      return void 0;
    }
    return parseFloat(value);
  };
  for (const [i, port] of ports.entries()) {
    const portDa = params.get(`port-${i}-da`);
    params.get(`port-${i}-draft`);
    const operations = params.getAll(`p${i}-o`).map(
      (o) => o.toLowerCase() === "d" ? OperationType.D : OperationType.L
    );
    const portData = {
      port,
      portDA: toNumber(portDa),
      operations: []
    };
    for (const [j, operation] of operations.entries()) {
      const tag = `p${i}-${j}-`;
      const amount = params.get(`${tag}amount`);
      const commodity = params.get(`${tag}commodity`);
      const cadence = params.get(`${tag}cadence`);
      const term = params.get(`${tag}terms`);
      const useVesselGear = params.get(`${tag}gear`);
      const tolerance = params.get(`${tag}tolerance`);
      const commodityPrice = params.get(`${tag}price`);
      const userCfrPrice = params.get(`${tag}cfr`);
      const stowageFactor = params.get(`${tag}sf`);
      const draft2 = params.get(`${tag}draft`);
      if (!commodity) {
        continue;
      }
      portData.operations.push({
        operation,
        amount: toNumber(amount),
        commodity,
        cadence: toNumber(cadence),
        terms: term ?? void 0,
        commodityPrice: toNumber(commodityPrice),
        userCfrPrice: toNumber(userCfrPrice),
        tolerance: toNumber(tolerance),
        useVesselGear: useVesselGear ? useVesselGear === "1" : void 0,
        draft: toNumber(draft2),
        stowageFactor: toNumber(stowageFactor)
      });
    }
    portList.push(portData);
  }
  return {
    hireOverride: hire,
    sfoOverride: sfoPrice,
    mgoOverride: mgoPrice,
    ballastBonusOverride,
    optimizerMode,
    optimizeBase,
    ports: portList
  };
}
var mergeWithUrlParams = (defaults, urlValues) => {
  return {
    ...defaults,
    ...urlValues,
    ports: mergePorts(
      defaults.ports,
      urlValues?.ports ?? [],
      defaults.ports[0]
    )
  };
};
var mergeObjects = (a, b) => {
  const res = {
    ...a
  };
  for (const key of Object.keys(b)) {
    if (b[key] !== void 0) {
      res[key] = b[key];
    }
  }
  return res;
};
var mergeOperations = (a, b, defaults) => {
  if (!b || b.length === 0) {
    return a;
  }
  const res = [];
  for (const [i, operation] of a.entries()) {
    res.push(mergeObjects(operation, b[i]));
  }
  if (b.length > a.length) {
    for (const [i, operation] of b.slice(a.length).entries()) {
      res.push(mergeObjects(defaults, operation));
    }
  }
  return res;
};
var mergePorts = (a, b, defaults) => {
  if (!b || b.length === 0) {
    return a;
  }
  const res = [];
  for (const [i, port] of a.entries()) {
    const resPort = {
      ...port,
      ...b[i],
      operations: mergeOperations(
        port.operations,
        b?.[i]?.operations,
        defaults.operations[0]
      )
    };
    res.push(resPort);
  }
  if (b.length > a.length) {
    for (const [i, port] of b.slice(a.length).entries()) {
      res.push(mergePorts([defaults], [port], defaults)[0]);
    }
  }
  return res;
};
function renderAutocompleteField({
  value,
  onChange,
  error,
  field,
  extraProps
}, input) {
  return /* @__PURE__ */ jsx(
    Autocomplete,
    {
      options: input.selectOptions ?? [],
      autoSelect: true,
      value: input.selectOptions?.find((o) => o.value === value) || null,
      renderInput: (params) => {
        const { key, ...restParams } = params;
        return /* @__PURE__ */ jsx(
          TextField,
          {
            ...restParams,
            label: input.label,
            variant: "outlined",
            fullWidth: true,
            size: "small",
            error: !!error,
            required: input.required,
            helperText: error?.message
          },
          key
        );
      },
      onChange: (_, value2) => onChange(value2?.value ?? ""),
      ...field,
      ...extraProps ? extraProps : {}
    }
  );
}
var CalcControls = ({
  terms,
  commodities,
  ports,
  onSubmit: onSubmitProp,
  periodRates,
  showDBVersionDropdown,
  canDebugCalculation,
  dbVersion,
  versionsList,
  calculationsToCopy,
  isCalculating,
  hasPendingCalculations,
  formRef,
  periods: monthsArray,
  onChange,
  onMultiModeChange,
  onCalculatorModeChange
}) => {
  const htmlFormRef = useRef(null);
  const ctx = React52.useContext(CalcContext);
  if (!ctx) {
    throw new Error("CalcControls must be used within a CalcContext");
  }
  let initialMode = 0 /* simple */;
  if (ctx.isCFROptimizer) {
    initialMode = 2 /* multi */;
  }
  const { router, pathName, searchParams, isMobileView } = ctx;
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [onlyOptimizerInput, setOnlyOptimizerInput] = useState(false);
  const toggleOptimizerInputOnly = useCallback(() => {
    setOnlyOptimizerInput((prev) => !prev);
  }, [setOnlyOptimizerInput]);
  const periods = useMemo(() => {
    const months = monthsArray.map((data2) => {
      return {
        ...data2,
        amount: periodRates[data2.value],
        isPending: periodRates[data2.value] === true
      };
    });
    return months;
  }, [periodRates, monthsArray]);
  const defaultPeriodValue = periods[0].value;
  const defaultValues = {
    mode: initialMode,
    cargo: "",
    tolerance: `${TOLERANCE_DEFAULT_VALUE}`,
    commodity: "",
    load_port: "",
    load_cadence: "",
    load_terms: "",
    disch_port: "",
    disch_cadence: "",
    disch_terms: "",
    period: defaultPeriodValue,
    db_version: void 0,
    // Advanced mode overrides
    hireOverride: void 0,
    mgoOverride: void 0,
    sfoOverride: void 0,
    ballastBonusOverride: void 0,
    stowageFactorOverride: void 0,
    loadPortDA: void 0,
    loadPortDraft: void 0,
    loadPortUseVesselGear: void 0,
    dischPortDA: void 0,
    dischPortDraft: void 0,
    dischPortUseVesselGear: void 0
  };
  const [useCache, setUseCache] = useState(true);
  const handleToggleUseCache = () => {
    setUseCache(!useCache);
  };
  const values3 = Object.entries(defaultValues).reduce(
    (acc, [key, defaultValue]) => {
      if (key === "db_version") {
        return {
          ...acc,
          [key]: dbVersion
        };
      }
      if (key === "mode") {
        let mode = ctx.isCFROptimizer ? 2 /* multi */ : getCalculatorMode(searchParams.get(key)) ?? defaultValue;
        return {
          ...acc,
          [key]: mode
        };
      }
      let newValue = searchParams.get(key) ?? defaultValue;
      if ([
        "hireOverride",
        "mgoOverride",
        "sfoOverride",
        "loadPortDA",
        "loadPortDraft",
        "loadPortUseVesselGear",
        "dischPortDA",
        "dischPortDraft",
        "dischPortUseVesselGear"
      ].includes(key)) {
        if (newValue === DEFAULT_OVERRIDE_VAL || newValue === `${DEFAULT_OVERRIDE_VAL}`) {
          newValue = defaultValue;
        } else if (key === "loadPortUseVesselGear" || key === "dischPortUseVesselGear") {
          newValue = parseBool(newValue);
        }
      }
      return {
        ...acc,
        [key]: newValue
      };
    },
    {}
  );
  const {
    handleSubmit,
    control,
    watch,
    reset: resetForm,
    setValue,
    getValues
  } = useForm({
    defaultValues,
    values: values3
  });
  const onChangeHandler = useCallback(
    (data2) => {
      if (onChange) {
        onChange(data2);
      }
    },
    [onChange]
  );
  useEffect(() => {
    const watcher = watch(onChangeHandler);
    return () => {
      watcher?.unsubscribe();
    };
  }, [onChangeHandler, watch]);
  const calculatorMode = watch("mode");
  const calculatorModeTracker = useRef(calculatorMode);
  useEffect(() => {
    if (calculatorModeTracker.current !== calculatorMode) {
      onCalculatorModeChange?.(calculatorMode);
      calculatorModeTracker.current = calculatorMode;
    }
  }, [calculatorMode, onCalculatorModeChange]);
  const portChoices = ports.map((port) => ({
    label: `${port.displayName} (${port.unlocode})`,
    value: port.unlocode
  }));
  const commoditiesOptions = commodities.map((commodity) => ({
    label: `${commodity.commodity} (${commodity.stowageFactorCBFT} cbft/mt, ${convertCbftToHectoliter(commodity.stowageFactorCBFT)} kg/hl)`,
    value: commodity.commodity
  }));
  const termsChoices = terms.map((term) => ({
    label: `${term.code} (${term.description} ${term.timeFactor})`,
    value: term.code
  }));
  const [openPeriodDialog, setOpenPeriodDialog] = useState(false);
  const selectedPeriodValue = watch("period") || defaultPeriodValue;
  const selectedPeriodLabel = periods.find(
    (obj) => obj.value === selectedPeriodValue
  )?.label;
  const handleClickOpen = () => {
    setOpenPeriodDialog(true);
  };
  const handleClose = () => {
    setOpenPeriodDialog(false);
  };
  const [loadOverridesRef, setLoadOverridesRef] = useState(null);
  const [dischargeOverridesRef, setDischargeOverridesRef] = useState(null);
  const isAdvancedView = calculatorMode === 1 /* advanced */;
  const inputsConstructor = [
    {
      name: "commodity",
      label: "Commodity",
      selectOptions: commoditiesOptions,
      required: true,
      visibleInSimpleView: true,
      order: {
        lg: 1
      }
    },
    {
      name: "cargo",
      label: ctx.disableAutoNumeric ? "Cargo" : "Cargo (use react-number-format)",
      valueType: "number",
      required: true,
      decimalScale: 0,
      visibleInSimpleView: false,
      inputProps: {
        inputProps: {
          min: 1,
          inputMode: "numeric"
        },
        endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "end", sx: { textTransform: "uppercase" }, children: "mt" })
      },
      warningTooltips: [
        {
          condition: (value) => value < 100,
          message: "Cargo input is in metric tons not in kilotons"
        },
        {
          condition: (value) => value <= 1e4,
          message: "Warning: We do not calculate coaster voyages"
        }
      ],
      order: {
        lg: 2
      }
    },
    {
      name: "tolerance",
      label: "Tolerance",
      valueType: "number",
      decimalScale: 0,
      required: true,
      visibleInSimpleView: false,
      inputProps: {
        inputProps: {
          itemType: "number",
          min: 0,
          max: 100
        },
        endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: "%" })
      },
      order: {
        lg: isAdvancedView ? 3 : 2
      }
    },
    {
      name: "load_port",
      label: "Load Port",
      selectOptions: portChoices,
      required: true,
      visibleInSimpleView: true,
      order: {
        lg: calculatorMode === 0 /* simple */ ? 2 : 5
      }
    },
    {
      name: "load_cadence",
      label: ctx.disableAutoNumeric ? "Load Cadence" : "Load Cadence (use autonumeric)",
      valueType: "number",
      required: false,
      decimalScale: 0,
      visibleInSimpleView: false,
      inputProps: {
        inputProps: {
          min: 1,
          inputMode: "numeric"
        },
        endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "end", sx: { textTransform: "uppercase" }, children: "mt/day" })
      },
      order: {
        lg: 6
      }
    },
    {
      name: "load_terms",
      label: "Load Terms",
      required: false,
      visibleInSimpleView: false,
      selectOptions: termsChoices,
      order: {
        lg: 7
      },
      after: (control2) => /* @__PURE__ */ jsx(
        Box,
        {
          sx: {
            position: "absolute",
            top: "0",
            bottom: "0",
            right: "-60px"
          },
          children: /* @__PURE__ */ jsx(
            AdvancedModePortOverrides,
            {
              control: control2,
              setValue,
              type: "load",
              targetNode: loadOverridesRef
            }
          )
        }
      )
    },
    {
      name: "disch_port",
      label: "Disch Port",
      selectOptions: portChoices,
      required: true,
      visibleInSimpleView: true,
      order: {
        lg: calculatorMode === 0 /* simple */ ? 3 : 9
      }
    },
    {
      name: "disch_cadence",
      label: ctx.disableAutoNumeric ? "Disch Cadence" : "Disch Cadence (use autonumeric)",
      valueType: "number",
      required: false,
      decimalScale: 0,
      visibleInSimpleView: false,
      inputProps: {
        inputProps: {
          min: 1,
          inputMode: "numeric"
        },
        endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "end", sx: { textTransform: "uppercase" }, children: "mt/day" })
      },
      order: {
        lg: 10
      }
    },
    {
      name: "disch_terms",
      label: "Disch Terms",
      selectOptions: termsChoices,
      required: false,
      visibleInSimpleView: false,
      order: {
        lg: 11
      },
      after: (control2) => /* @__PURE__ */ jsx(
        Box,
        {
          sx: {
            position: "absolute",
            top: "0",
            bottom: "0",
            right: "-60px"
          },
          children: /* @__PURE__ */ jsx(
            AdvancedModePortOverrides,
            {
              control: control2,
              setValue,
              type: "disch",
              targetNode: dischargeOverridesRef
            }
          )
        }
      )
    }
  ];
  useEffect(() => {
    if (dbVersion === "latest" || dbVersion === "latest-version") {
      const latest = versionsList.find((version2) => version2.isLatest)?.id;
      if (latest) {
        setValue("db_version", latest);
      }
    }
  }, [dbVersion, versionsList, setValue]);
  if (showDBVersionDropdown) {
    inputsConstructor.push({
      name: "db_version",
      label: "DB Version",
      selectOptions: versionsList.map((version2) => {
        let prefix = version2.publishedAt ? "" : "[D] ";
        if (version2.isLatest) {
          prefix = `[LATEST] ${prefix}`;
        }
        return {
          label: `${prefix}${format(
            typeof version2.datekey === "string" ? parseISO(version2.datekey) : version2.datekey,
            "HH:mm dd.MM.yyyy"
          )} (${version2.id})`,
          value: version2.id
        };
      }),
      required: true,
      visibleInSimpleView: true,
      order: {
        lg: 12
      }
    });
  }
  const onResetButtonClick = useCallback(() => {
    router.push(`${pathName}`);
    resetForm({
      mode: calculatorMode
      // But keep user's selected mode
    });
  }, [router.push, pathName, resetForm, calculatorMode]);
  const handleFormSubmit = handleSubmit((values4) => {
    const queryAdvancedFilter = (key) => values4.mode === 1 /* advanced */ ? true : ["mode", "commodity", "load_port", "disch_port"].includes(key);
    const stringValues = Object.keys(values4).filter((item) => item === "db_version" || queryAdvancedFilter(item)).filter((item) => {
      return item === "db_version" ? values4[item] !== void 0 : true;
    }).reduce(
      (acc, key) => {
        const value = values4[key];
        if (value !== void 0) {
          if (key === "mode") {
            acc[key] = value.toString();
          } else {
            acc[key] = value;
          }
        }
        return acc;
      },
      {}
    );
    const query = new URLSearchParams(stringValues);
    router.push(`${pathName}?${query.toString()}`);
    onSubmitProp({ ...values4, useCache });
  });
  const resolver = useMemo(() => {
    return ctx.isCFROptimizer ? yupResolver(OptimizerInputSchema) : yupResolver(MultiModeInputSchema);
  }, [ctx.isCFROptimizer]);
  const multiForm = useForm({
    defaultValues: mergeWithUrlParams(
      multiModeDefaultValues,
      fromSearchParams(searchParams)
    ),
    resolver
  });
  const doSetValue = useCallback(
    (key, value) => {
      if (!isSet(value)) {
        return;
      }
      if (Array.isArray(value)) {
        for (const [i, subValue] of value.entries()) {
          doSetValue([...key, `${i}`], subValue);
        }
      } else if (typeof value === "object" && value) {
        for (const [subKey, subValue] of Object.entries(value)) {
          doSetValue([...key, subKey], subValue);
        }
      } else {
        multiForm.setValue(
          Array.isArray(key) ? key.join(".") : key,
          value
        );
      }
    },
    [multiForm.setValue]
  );
  useEffect(() => {
    const fromUrl = fromSearchParams(searchParams);
    for (const [key, value] of Object.entries(fromUrl ?? {})) {
      doSetValue(key, value);
    }
  }, [searchParams, doSetValue]);
  const dbVersionSelected = watch("db_version");
  const updateMultiSearchParams = useUpdateMultiSearchParams(
    router,
    dbVersionSelected,
    pathName
  );
  const onMultiFormSubmit = multiForm.handleSubmit;
  const handleMultiFormSubmit = useCallback(
    (...args) => {
      return onMultiFormSubmit((values4) => {
        updateMultiSearchParams(values4);
        onSubmitProp({
          ...values4,
          period: selectedPeriodValue,
          mode: 2 /* multi */,
          useCache,
          db_version: dbVersionSelected,
          onlyOptimizerInput
        });
      })(...args);
    },
    [
      onMultiFormSubmit,
      selectedPeriodValue,
      onSubmitProp,
      useCache,
      updateMultiSearchParams,
      dbVersionSelected,
      onlyOptimizerInput
    ]
  );
  const onFormSubmit = useCallback(
    (...args) => {
      const method = calculatorMode === 2 /* multi */ ? handleMultiFormSubmit : handleFormSubmit;
      return method(...args);
    },
    [calculatorMode, handleFormSubmit, handleMultiFormSubmit]
  );
  useImperativeHandle(
    formRef,
    () => ({
      setValue,
      getValues,
      reset: onResetButtonClick,
      submit: () => {
        onFormSubmit();
      }
    }),
    [setValue, getValues, onResetButtonClick, onFormSubmit]
  );
  useMemo(() => {
    return multiForm.getValues;
  }, [multiForm.getValues]);
  const renderInput = (input) => {
    const commonStyles = {
      ".MuiOutlinedInput-root": {
        color: isDarkMode ? "secondary.main" : void 0,
        borderRadius: "0.5rem",
        "& fieldset": {
          borderColor: isDarkMode ? darkGrey : void 0
        },
        "&:hover fieldset": {
          borderColor: isDarkMode ? darkGrey : void 0
        },
        "&.Mui-focused fieldset": {
          borderColor: isDarkMode ? darkGrey : void 0
        }
      }
    };
    const renderTextField = ({
      value,
      onChange: onChange2,
      error
    }) => /* @__PURE__ */ jsx(
      TextField,
      {
        label: input.label,
        sx: commonStyles,
        error: !!error,
        type: input.valueType,
        value: value ?? "",
        onChange: onChange2,
        InputProps: input.inputProps,
        variant: "outlined",
        fullWidth: true,
        size: "small",
        required: input.required,
        helperText: error?.message
      }
    );
    const renderNumberFormatFieldV1 = ({
      value,
      onChange: onChange2,
      error,
      warningTooltips
    }) => {
      const node = /* @__PURE__ */ jsx(
        NumericFormat,
        {
          InputProps: input.inputProps,
          onValueChange: (values4) => onChange2(values4.value),
          thousandSeparator: " ",
          decimalScale: input.decimalScale,
          valueIsNumericString: true,
          allowNegative: false,
          value,
          customInput: TextField,
          label: input.label,
          sx: commonStyles,
          error: !!error,
          inputMode: "numeric",
          variant: "outlined",
          fullWidth: true,
          size: "small",
          onKeyDown: (event) => {
            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
              event.preventDefault();
              const step = event.key === "ArrowUp" ? 1 : -1;
              const currentValue = Number(value);
              const newValue = currentValue + step;
              onChange2(newValue.toString());
            }
          },
          required: input.required,
          helperText: error?.message
        },
        input.label
      );
      const hasWarnings = warningTooltips.length > 0;
      let numValue = -1;
      if (value && hasWarnings) {
        if (typeof value === "string") {
          numValue = parseFloat(value);
          if (isNaN(numValue)) {
            numValue = -1;
          }
        } else if (typeof value === "number") {
          numValue = value;
        }
      }
      if (hasWarnings) {
        const warning = numValue != -1 ? warningTooltips.find((tooltip) => tooltip.condition(numValue)) : void 0;
        return /* @__PURE__ */ jsx(
          Tooltip,
          {
            title: warning?.message ?? "-",
            placement: "top",
            open: !!warning,
            disableInteractive: true,
            disableHoverListener: true,
            disableTouchListener: true,
            children: node
          }
        );
      }
      return node;
    };
    const RenderNumberFormatFieldV2 = ({ value, onChange: onChange2, error }) => {
      const inputRef = useRef();
      useEffect(() => {
        if (inputRef.current) {
          const options = {
            digitGroupSeparator: " ",
            decimalPlaces: input.decimalScale
          };
          if (input.inputProps?.inputProps?.min || input.inputProps?.inputProps?.min === 0) {
            options.minimumValue = input.inputProps?.inputProps?.min === 1 ? "0" : input.inputProps?.inputProps?.min.toString();
          }
          if (input.inputProps?.inputProps?.max || input.inputProps?.inputProps?.max === 0) {
            options.maximumValue = input.inputProps?.inputProps?.max.toString();
          }
          const autoNumericInstance = new main_default(
            inputRef.current,
            options
          );
          if (value !== void 0) {
            autoNumericInstance.set(value.toString());
          }
          const handleChange = (event) => {
            const element = event.target;
            onChange2(element.value);
          };
          inputRef.current.addEventListener("change", handleChange);
          return () => {
            inputRef.current?.removeEventListener("change", handleChange);
            autoNumericInstance.remove();
          };
        }
      }, [inputRef, input, onChange2, value]);
      return /* @__PURE__ */ jsx(
        TextField,
        {
          sx: commonStyles,
          inputRef,
          label: input.label,
          error: !!error,
          variant: "outlined",
          fullWidth: true,
          size: "small",
          inputMode: "numeric",
          required: input.required,
          helperText: error?.message,
          InputProps: input.inputProps
        }
      );
    };
    const inputController = () => /* @__PURE__ */ jsx(
      Controller,
      {
        control,
        name: input.name,
        rules: {
          required: input.required ? `Please enter a ${input.valueType === "number" ? "numeric value." : "value."}` : false,
          min: {
            value: input.inputProps?.inputProps?.min,
            message: `Minimum value is ${input.inputProps?.inputProps?.min}.`
          },
          max: {
            value: input.inputProps?.inputProps?.max,
            message: `Maximum value is ${input.inputProps?.inputProps?.max}.`
          },
          validate: {
            // Check if valueType is number and if it is, check if the value is a number
            isNumber: (v) => input.valueType === "number" && v !== "" ? !isNaN(parseFloat(v)) || "Please enter a numeric value." : true
          }
        },
        render: ({ field: { value, onChange: onChange2 }, fieldState: { error } }) => {
          if (!ctx.disableAutoNumeric) {
            if (input.name === "cargo") {
              const warningTooltips = input.warningTooltips ?? [];
              return renderNumberFormatFieldV1({
                value,
                onChange: onChange2,
                error,
                warningTooltips
              });
            }
            if (input.name === "load_cadence" || input.name === "disch_cadence") {
              return RenderNumberFormatFieldV2({ value, onChange: onChange2, error });
            }
          }
          return renderTextField({ value, onChange: onChange2, error });
        }
      }
    );
    const autocompleteController = () => /* @__PURE__ */ jsx(
      Controller,
      {
        name: input.name,
        control,
        rules: {
          required: input.required ? "Please select a value." : false,
          validate: (v) => input.selectOptions?.some((o) => o.value === v) || v === "" || "Please select a valid value."
        },
        render: ({
          field: { onChange: onChange2, value: fieldValue, ...field },
          fieldState: { error }
        }) => renderAutocompleteField(
          { value: fieldValue, onChange: onChange2, error, field },
          input
        )
      }
    );
    const isSelectOptions = Boolean(input.selectOptions);
    return /* @__PURE__ */ jsxs(
      Box,
      {
        sx: {
          width: calculatorMode === 1 /* advanced */ ? {
            xs: "100%",
            sm: "100%",
            lg: input.name === "db_version" ? "100%" : "calc(33.33% - 32px)"
          } : {
            xs: "100%",
            sm: "100%",
            lg: input.name === "db_version" ? "100%" : "33.33%"
          },
          ...input.after ? { position: "relative" } : void 0
        },
        children: [
          isSelectOptions ? autocompleteController() : inputController(),
          input.after ? input.after(control) : null
        ]
      },
      input.name
    );
  };
  let canCalculate = false;
  switch (calculatorMode) {
    case 2 /* multi */:
      canCalculate = multiForm.formState.isValid;
      break;
    case 0 /* simple */:
    case 1 /* advanced */:
    default:
      canCalculate = true;
      break;
  }
  const bottomRightNode = ctx.isCFROptimizer ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        width: {
          lg: "60%"
        },
        children: /* @__PURE__ */ jsx(
          Controller,
          {
            name: "period",
            control,
            render: ({
              field: { onChange: onChange2, value: fieldValue, ...field },
              fieldState: { error }
            }) => {
              return renderAutocompleteField(
                {
                  value: fieldValue,
                  onChange: onChange2,
                  error: void 0,
                  field,
                  extraProps: {
                    fullWidth: true
                  }
                },
                {
                  label: "Period",
                  selectOptions: periods.map((period) => ({
                    label: period.label,
                    value: period.value
                  })),
                  required: true
                }
              );
            }
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          justifyContent: "center",
          lg: {
            width: "90%",
            display: "flex",
            justifyContent: "flex-end"
          }
        },
        children: /* @__PURE__ */ jsx(OptimizerModeToggle, { control: multiForm.control })
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          justifyContent: "center",
          lg: {
            width: "90%",
            display: "flex",
            justifyContent: "flex-end"
          }
        },
        children: /* @__PURE__ */ jsx(OptimizeBaseToggle, { control: multiForm.control })
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          justifyContent: "center",
          lg: {
            width: "90%",
            display: "flex",
            justifyContent: "flex-end"
          },
          mt: -2
        },
        children: /* @__PURE__ */ jsx(
          FormControlLabel,
          {
            sx: { ".MuiTypography-root": { lineHeight: "0.5rem" } },
            control: /* @__PURE__ */ jsx(
              Switch,
              {
                defaultChecked: false,
                onChange: () => toggleOptimizerInputOnly()
              }
            ),
            label: "Only optimizer input",
            labelPlacement: "start"
          }
        )
      }
    )
  ] }) : null;
  return /* @__PURE__ */ jsxs(
    "form",
    {
      onSubmit: onFormSubmit,
      noValidate: true,
      autoComplete: "off",
      ref: htmlFormRef,
      children: [
        /* @__PURE__ */ jsx(
          CalcControlsLayout,
          {
            canCalculate,
            calculatorMode,
            topLeftNode: /* @__PURE__ */ jsxs(Fragment, { children: [
              showDBVersionDropdown ? inputsConstructor.filter((input) => input.name === "db_version").map(renderInput) : null,
              /* @__PURE__ */ jsx(
                Box,
                {
                  sx: {
                    display: "flex",
                    gap: "16px",
                    pb: "16px"
                  },
                  children: isAdvancedView && /* @__PURE__ */ jsx(
                    AdvancedModePortOverrides,
                    {
                      control,
                      setValue,
                      type: "voyage",
                      targetNode: null
                    }
                  )
                }
              )
            ] }),
            bottomRightNode,
            topRightNode: /* @__PURE__ */ jsxs(Fragment, { children: [
              canDebugCalculation && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
                FormControlLabel,
                {
                  sx: { ".MuiTypography-root": { lineHeight: "0.5rem" } },
                  control: /* @__PURE__ */ jsx(
                    Switch,
                    {
                      defaultChecked: true,
                      onChange: () => handleToggleUseCache()
                    }
                  ),
                  label: "Cache",
                  labelPlacement: "start"
                }
              ) }),
              /* @__PURE__ */ jsx(
                CopyOutputButton_default,
                {
                  data: calculationsToCopy,
                  disabled: isCalculating || hasPendingCalculations || !calculationsToCopy.length || calculationsToCopy.some((c) => !c || !c.planId),
                  selectedMonth: getCopyMonthLabel(selectedPeriodValue)
                }
              )
            ] }),
            onResetButtonClick,
            control,
            children: calculatorMode === 2 /* multi */ ? /* @__PURE__ */ jsx(
              CalcMultiModeWidget,
              {
                portOptions: portChoices,
                commodities: commoditiesOptions,
                termsOptions: termsChoices,
                control: multiForm.control,
                setValue: multiForm.setValue,
                errors: multiForm.formState.errors,
                trigger: multiForm.trigger,
                onChange: onMultiModeChange,
                watch: multiForm.watch
              }
            ) : inputsConstructor.filter(
              (input) => calculatorMode === 1 /* advanced */ ? true : input.visibleInSimpleView
            ).filter((input) => input.name !== "db_version").map((input) => {
              const res = renderInput(input);
              if (input.name === "load_terms") {
                return /* @__PURE__ */ jsxs(Fragment, { children: [
                  res,
                  /* @__PURE__ */ jsx(Box, { ref: setLoadOverridesRef })
                ] });
              }
              if (input.name === "disch_terms") {
                return /* @__PURE__ */ jsxs(Fragment, { children: [
                  res,
                  /* @__PURE__ */ jsx(Box, { ref: setDischargeOverridesRef })
                ] });
              }
              return res;
            })
          }
        ),
        ctx.isCFROptimizer ? null : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Grid, { xs: 12, sm: 6, children: /* @__PURE__ */ jsx(
            Button,
            {
              variant: "outlined",
              size: "medium",
              onClick: handleClickOpen,
              fullWidth: true,
              sx: {
                display: { sm: "flex", md: "none" },
                minHeight: "40px",
                mt: "2rem",
                borderRadius: "0.5rem"
              },
              children: selectedPeriodValue ? `Selected Period: ${selectedPeriodLabel}` : "Select Period"
            }
          ) }),
          /* @__PURE__ */ jsx(
            Controller,
            {
              name: "period",
              control,
              render: ({ field: { value, onChange: onChange2 } }) => {
                if (isMobileView) {
                  return /* @__PURE__ */ jsx(
                    Dialog,
                    {
                      open: openPeriodDialog,
                      fullWidth: true,
                      onClose: handleClose,
                      "aria-labelledby": "alert-dialog-title",
                      "aria-describedby": "alert-dialog-description",
                      children: /* @__PURE__ */ jsx(
                        ToggleButtonGroup,
                        {
                          color: "primary",
                          sx: {
                            background: isDarkMode ? dark2 : void 0
                          },
                          value,
                          orientation: "vertical",
                          exclusive: true,
                          onChange: (_, value2) => {
                            onChange2(value2);
                            periods[0].amount !== void 0 && onFormSubmit();
                            handleClose();
                          },
                          "aria-label": "Platform",
                          fullWidth: true,
                          children: periods.map((month) => /* @__PURE__ */ jsx(
                            ToggleButton,
                            {
                              value: month.value,
                              sx: {
                                padding: 0,
                                "&.Mui-selected": {
                                  "& .MuiListItemText-primary, & .MuiListItemText-secondary": {
                                    color: isDarkMode ? `${light} !important` : void 0
                                  }
                                }
                              },
                              children: /* @__PURE__ */ jsx(
                                ListItemText,
                                {
                                  sx: {
                                    mt: "1.25rem",
                                    mb: "1.25rem",
                                    display: "flex",
                                    justifyContent: "center"
                                  },
                                  primary: month.label,
                                  secondary: month.isPending ? /* @__PURE__ */ jsx(
                                    Skeleton,
                                    {
                                      variant: "rounded",
                                      width: 36,
                                      sx: { margin: "0 auto", height: 24 }
                                    }
                                  ) : month.amount === true || month.amount === void 0 ? "..." : formatNumberWithCommas(month.amount),
                                  primaryTypographyProps: { fontWeight: 600 },
                                  secondaryTypographyProps: {
                                    fontSize: "1rem",
                                    ml: "0.9375rem"
                                  }
                                }
                              )
                            },
                            month.value
                          ))
                        }
                      )
                    }
                  );
                } else {
                  return /* @__PURE__ */ jsx(
                    ToggleButtonGroup,
                    {
                      color: isDarkMode ? "secondary" : "primary",
                      sx: {
                        mt: "2rem",
                        ".MuiToggleButtonGroup-grouped": {
                          "&:not(:first-of-type)": {
                            borderLeft: isDarkMode ? `1px solid ${darkGrey}` : "1px solid #0000001f",
                            borderRadius: "0.5rem",
                            ml: "10px"
                          },
                          "&:not(:last-of-type)": {
                            borderRadius: "0.5rem"
                          }
                        }
                      },
                      value,
                      orientation: "horizontal",
                      exclusive: true,
                      onChange: (_, value2) => {
                        onChange2(value2);
                        periods[0].amount !== void 0 && onFormSubmit();
                      },
                      "aria-label": "Platform",
                      fullWidth: true,
                      children: periods.map((month) => /* @__PURE__ */ jsx(
                        ToggleButton,
                        {
                          value: month.value,
                          sx: {
                            padding: 0,
                            borderColor: isDarkMode ? darkGrey : void 0,
                            borderRadius: "0.5rem",
                            "&.Mui-selected": {
                              borderColor: isDarkMode ? light : void 0,
                              "& .MuiListItemText-primary, & .MuiListItemText-secondary": {
                                color: isDarkMode ? `${light} !important` : dark7
                              }
                            }
                          },
                          children: /* @__PURE__ */ jsx(
                            ListItemText,
                            {
                              primary: month.label,
                              secondary: month.isPending ? /* @__PURE__ */ jsx(
                                Skeleton,
                                {
                                  variant: "rounded",
                                  width: 36,
                                  sx: { margin: "0 auto", height: 24 }
                                }
                              ) : month.amount === true || month.amount === void 0 ? "..." : formatNumberWithCommas(month.amount),
                              primaryTypographyProps: { fontWeight: 600 },
                              secondaryTypographyProps: {
                                align: "center",
                                fontSize: "1rem",
                                height: 24
                              }
                            }
                          )
                        },
                        month.value
                      ))
                    }
                  );
                }
              }
            }
          )
        ] })
      ]
    }
  );
};
var CalcControls_default = CalcControls;

// ../calculator-ui/src/Calculator/types.ts
var CalculationSchedulingType = /* @__PURE__ */ ((CalculationSchedulingType2) => {
  CalculationSchedulingType2["Foreground"] = "foreground";
  CalculationSchedulingType2["Background"] = "background";
  return CalculationSchedulingType2;
})(CalculationSchedulingType || {});

// ../calculator-ui/src/Calculator/api-util.ts
var isMultiMode = (data2) => {
  return data2.mode === 2 /* multi */;
};
var getApiCallCacheKey = (data2) => {
  if (isMultiMode(data2)) {
    return JSON.stringify([
      data2.period,
      data2.ports.map((port) => [
        port.port,
        port.operations.map((operation) => [
          operation.operation,
          operation.amount,
          operation.commodity,
          operation.cadence === DEFAULT_OVERRIDE_VAL ? null : operation.cadence,
          operation.terms || null,
          operation.useVesselGear,
          operation.stowageFactor === DEFAULT_OVERRIDE_VAL ? null : operation.stowageFactor,
          operation.draft === DEFAULT_OVERRIDE_VAL ? null : operation.draft
        ]),
        port.portDA === DEFAULT_OVERRIDE_VAL ? null : port.portDA
      ]),
      data2.useCache,
      data2.hireOverride === DEFAULT_OVERRIDE_VAL ? null : data2.hireOverride,
      data2.mgoOverride === DEFAULT_OVERRIDE_VAL ? null : data2.mgoOverride,
      data2.sfoOverride === DEFAULT_OVERRIDE_VAL ? null : data2.sfoOverride,
      data2.ballastBonusOverride === DEFAULT_OVERRIDE_VAL ? null : data2.ballastBonusOverride,
      data2.db_version
    ]);
  }
  return JSON.stringify([
    data2.cargo,
    data2.tolerance,
    data2.commodity,
    data2.load_port,
    data2.load_cadence,
    data2.load_terms,
    data2.disch_port,
    data2.disch_cadence,
    data2.disch_terms,
    data2.db_version,
    data2.useCache,
    data2.loadPortDA,
    data2.loadPortDraft,
    data2.loadPortUseVesselGear,
    data2.dischPortDA,
    data2.dischPortDraft,
    data2.dischPortUseVesselGear,
    data2.stowageFactorOverride,
    data2.hireOverride,
    data2.mgoOverride,
    data2.sfoOverride,
    data2.ballastBonusOverride
  ]);
};
var serializeCadence = (cadence) => {
  if (!isSet(cadence)) {
    return void 0;
  }
  if (typeof cadence === "string") {
    cadence = cadence.replaceAll(" ", "");
    cadence = parseFloat(cadence);
  }
  return cadence;
};
var getApiPayload = (data2, optimizerMode, optimizeBase, onlyOptimizerInput) => {
  if (isMultiMode(data2)) {
    return {
      type: "multi",
      db_version: data2.db_version || void 0,
      period: data2.period,
      useCache: data2.useCache,
      optimizerMode,
      optimizeBase,
      onlyOptimizerInput,
      voyage: data2.ports.map((port) => ({
        port: port.port,
        ...getNumericOverride(port.portDA, "portDA"),
        operations: port.operations.map((operation) => ({
          operation: operation.operation,
          amount: operation.amount,
          commodity: operation.commodity,
          cadence: void 0,
          terms: void 0,
          useVesselGear: void 0,
          draft: void 0,
          stowageFactor: void 0,
          tolerance: operation.tolerance,
          commodityPrice: operation.commodityPrice,
          userCfrPrice: operation.userCfrPrice,
          ...getNumericOverride(operation.draft ?? operation.draft, "draft"),
          ...getNumericOverride(operation.cadence, "cadence"),
          ...getBooleanOverride(operation.useVesselGear, "useVesselGear"),
          ...operation.terms ? { terms: operation.terms } : {},
          ...getNumericOverride(operation.stowageFactor, "stowageFactor")
        }))
      })),
      overrides: {
        ...getNumericOverride(data2.hireOverride, "hire"),
        ...getNumericOverride(data2.mgoOverride, "mgo"),
        ...getNumericOverride(data2.sfoOverride, "sfo"),
        ...getNumericOverride(data2.ballastBonusOverride, "ballastBonus")
      }
    };
  }
  switch (data2.mode) {
    case 0 /* simple */:
      return {
        type: "simple",
        db_version: data2.db_version || void 0,
        period: data2.period,
        useCache: data2.useCache,
        voyage: [
          {
            port: data2.load_port,
            operations: [
              {
                operation: OperationType.L,
                commodity: data2.commodity,
                amount: void 0,
                cadence: void 0,
                terms: void 0,
                draft: void 0,
                useVesselGear: void 0,
                tolerance: void 0,
                commodityPrice: void 0,
                userCfrPrice: void 0,
                stowageFactor: void 0
              }
            ]
          },
          {
            port: data2.disch_port,
            operations: [
              {
                operation: OperationType.D,
                commodity: data2.commodity,
                amount: void 0,
                cadence: void 0,
                terms: void 0,
                draft: void 0,
                useVesselGear: void 0,
                tolerance: void 0,
                commodityPrice: void 0,
                userCfrPrice: void 0,
                stowageFactor: void 0
              }
            ]
          }
        ]
      };
    case 1 /* advanced */:
      return {
        type: "advanced",
        db_version: data2.db_version || void 0,
        period: data2.period,
        useCache: data2.useCache,
        tolerance: parseInt(data2.tolerance) / 100,
        voyage: [
          {
            port: data2.load_port,
            ...getNumericOverride(data2.loadPortDA, "portDA"),
            operations: [
              {
                operation: OperationType.L,
                commodity: data2.commodity,
                amount: parseInt(data2.cargo),
                cadence: serializeCadence(data2.load_cadence),
                terms: isSet(data2.load_terms) ? data2.load_terms : void 0,
                useVesselGear: void 0,
                draft: void 0,
                tolerance: void 0,
                commodityPrice: void 0,
                userCfrPrice: void 0,
                stowageFactor: void 0,
                ...getNumericOverride(data2.loadPortDraft, "draft"),
                ...getBooleanOverride(
                  data2.loadPortUseVesselGear,
                  "useVesselGear"
                ),
                ...getNumericOverride(
                  data2.stowageFactorOverride,
                  "stowageFactor"
                )
              }
            ]
          },
          {
            port: data2.disch_port,
            ...getNumericOverride(data2.dischPortDA, "portDA"),
            operations: [
              {
                operation: OperationType.D,
                commodity: data2.commodity,
                amount: parseInt(data2.cargo),
                cadence: serializeCadence(data2.disch_cadence),
                terms: isSet(data2.disch_terms) ? data2.disch_terms : void 0,
                useVesselGear: void 0,
                draft: void 0,
                tolerance: void 0,
                commodityPrice: void 0,
                userCfrPrice: void 0,
                stowageFactor: void 0,
                ...getNumericOverride(data2.dischPortDraft, "draft"),
                ...getBooleanOverride(
                  data2.dischPortUseVesselGear,
                  "useVesselGear"
                ),
                ...getNumericOverride(
                  data2.stowageFactorOverride,
                  "stowageFactor"
                )
              }
            ]
          }
        ],
        overrides: {
          ...getNumericOverride(data2.hireOverride, "hire"),
          ...getNumericOverride(data2.mgoOverride, "mgo"),
          ...getNumericOverride(data2.sfoOverride, "sfo"),
          ...getNumericOverride(data2.ballastBonusOverride, "ballastBonus")
        }
      };
  }
  throw new Error("Invalid mode");
};
var getNumericOverride = (val, field) => {
  let res = val;
  if (typeof val === "string") {
    res = val === "" ? void 0 : parseFloat(val);
  }
  if (res === DEFAULT_OVERRIDE_VAL) {
    return {};
  }
  return {
    [field]: res
  };
};
var getBooleanOverride = (val, field) => {
  if (val === DEFAULT_OVERRIDE_VAL || `${val}` === `${DEFAULT_OVERRIDE_VAL}`) {
    return {};
  }
  if (typeof val === "string") {
    return {
      [field]: val === "true" || val === "1" || val === "yes"
    };
  }
  return {
    [field]: val
  };
};

// ../calculator-ui/src/Calculator/hooks.ts
var useCalculatorInputOptions = (apiRoutes, dbVersion, loadVersions, onError) => {
  const {
    data: terms = [],
    error: termsError,
    isLoading: isTermsLoading
  } = useAdminAPI(`${apiRoutes.terms}`);
  const {
    data: commodities = [],
    error: commoditiesError,
    isLoading: isCommoditiesLoading
  } = useAdminAPI(
    `${apiRoutes.commodities}?versionId=${dbVersion ?? "null"}`
  );
  const {
    data: ports = [],
    error: portsError,
    isLoading: isPortsLoading
  } = useAdminAPI(`${apiRoutes.ports}`);
  const {
    data: { data: versionsList } = { data: [] },
    error: versionsListError,
    isLoading: isVersionsListLoading
  } = useAPI(
    loadVersions && apiRoutes.dbVersions ? `${apiRoutes.dbVersions}` : null
  );
  const {
    data: vessels = [],
    error: vesselsError,
    isLoading: isVesselsLoading
  } = useAdminAPI(
    `${apiRoutes.vessels}?versionId=${dbVersion ?? "null"}`
  );
  const vesselMap = useMemo(() => {
    if (!vessels)
      return {};
    return vessels.reduce(
      (acc, vessel) => {
        acc[vessel.vessel] = vessel;
        return acc;
      },
      {}
    );
  }, [vessels]);
  const apiLoadingProgress = ((...args) => {
    return args.filter((v) => !v).length / args.length * 100;
  })(
    isTermsLoading,
    isCommoditiesLoading,
    isCommoditiesLoading,
    isVesselsLoading,
    loadVersions && isVersionsListLoading
  );
  const apiErrorMessage = ((obj) => {
    const arr = Object.keys(obj).filter((key) => obj[key]);
    return arr.length ? `Error fetching API for ${arr.join(", ")}.` : null;
  })({
    terms: termsError,
    commodities: commoditiesError,
    ports: portsError,
    versionsList: versionsListError,
    vessels: vesselsError
  });
  useEffect(() => {
    if (apiErrorMessage) {
      onError?.(apiErrorMessage);
    }
  }, [apiErrorMessage, onError]);
  const [isApiLoaded, setIsApiLoaded] = useState(
    !isTermsLoading && !!terms && !isCommoditiesLoading && !!commodities && !isPortsLoading && !!ports && (!loadVersions || !isVersionsListLoading && !!versionsList)
  );
  useEffect(() => {
    if (apiLoadingProgress === 100) {
      setIsApiLoaded(true);
    }
  }, [apiLoadingProgress, setIsApiLoaded]);
  return useMemo(() => {
    return {
      terms,
      termsError,
      isTermsLoading,
      commodities,
      commoditiesError,
      isCommoditiesLoading,
      ports,
      portsError,
      isPortsLoading,
      vesselMap,
      apiLoadingProgress,
      apiErrorMessage,
      isVersionsListLoading,
      versionsList,
      isApiLoaded,
      setIsApiLoaded
    };
  }, [
    terms,
    termsError,
    isTermsLoading,
    commodities,
    commoditiesError,
    isCommoditiesLoading,
    ports,
    portsError,
    isPortsLoading,
    vesselMap,
    apiLoadingProgress,
    apiErrorMessage,
    isVersionsListLoading,
    versionsList,
    isApiLoaded,
    setIsApiLoaded
  ]);
};
var useCalculator = (apiRoutes, onSubmitEvent, onError, addBreadcrumb, onReceiveCalculation, isCFROptimizer, optimizerTwoStep) => {
  const apiPath = isCFROptimizer ? apiRoutes.optimize : apiRoutes.calculate;
  const {
    trigger: runCalculation,
    isMutating: isCalculating,
    data: calculationResponse,
    error: calculationError,
    reset: resetMain
  } = useApiMutation({
    url: apiPath,
    method: "POST"
  });
  useEffect(() => {
    onError?.(calculationError?.message ?? calculationError);
  }, [calculationError, onError]);
  const { trigger: runBackgroundCalculation } = useApiMutation({
    url: apiPath,
    method: "POST"
  });
  const [resultCacheKey, setResultCacheKey] = useState("");
  const [resultsCache, setResultCache] = useState({});
  const [pendingResults, setPendingResults] = useState(
    {}
  );
  const [optimizerInput, setOptimizerInput] = useState(
    null
  );
  useEffect(() => {
    setResultCache({});
    setPendingResults({});
  }, [resultCacheKey, setResultCache]);
  const runInBackground = useCallback(
    async (payload) => {
      const baseDate = payload.period ? parseISO(payload.period) : /* @__PURE__ */ new Date();
      const allMissingMonths = getMonthsArray().filter(
        (x) => !isSameMonth(x, baseDate)
      );
      allMissingMonths.map((month) => {
        setPendingResults((prev) => {
          return {
            ...prev,
            [month.toISOString()]: true
          };
        });
        return runBackgroundCalculation({
          body: {
            ...payload,
            period: month.toISOString()
          }
        }).then((result) => {
          setResultCache((prev) => {
            return {
              ...prev,
              [month.toISOString()]: result?.data
            };
          });
          onReceiveCalculation?.(
            "background" /* Background */,
            month.toISOString(),
            result?.data
          );
          setPendingResults((prev) => {
            if (!Object.keys(prev).length) {
              return {};
            }
            return {
              ...prev,
              [month.toISOString()]: false
            };
          });
        });
      });
    },
    [runBackgroundCalculation, onReceiveCalculation]
  );
  const onSubmit = useCallback(
    async (data2) => {
      if (isCalculating) {
        return;
      }
      await resetMain();
      onSubmitEvent?.(data2);
      const key = getApiCallCacheKey(data2);
      const keyChanged = key !== resultCacheKey;
      if (keyChanged) {
        setResultCacheKey(key);
      }
      const onlyOptimizerInput = !!(isCFROptimizer && isMultiMode(data2) ? data2.onlyOptimizerInput : void 0);
      const payload = getApiPayload(
        data2,
        isCFROptimizer && isMultiMode(data2) ? data2.optimizerMode : void 0,
        isCFROptimizer && isMultiMode(data2) ? data2.optimizeBase : void 0,
        onlyOptimizerInput
      );
      let extraPayload = null;
      if (isCFROptimizer && optimizerTwoStep) {
        const idResponse = await runCalculation({
          body: {
            ...payload,
            // This is a special flag that tells the API to only initialize the optimizer
            //  and return the optimizer request ID.
            twoStep: 1,
            optimizerRequestId: ""
          }
        });
        if (idResponse?.optimizerRequestId) {
          await optimizerTwoStep(idResponse.optimizerRequestId, true);
          extraPayload = {
            twoStep: 2,
            optimizerRequestId: idResponse.optimizerRequestId
          };
        }
      }
      try {
        const result = await runCalculation({
          body: {
            ...payload,
            ...extraPayload ?? {}
          }
        });
        if (isCFROptimizer && optimizerTwoStep && extraPayload?.optimizerRequestId) {
          await optimizerTwoStep?.(extraPayload?.optimizerRequestId, false);
        }
        if (onlyOptimizerInput) {
          setOptimizerInput(result?.data);
          return;
        }
        setOptimizerInput(null);
        onReceiveCalculation?.(
          "foreground" /* Foreground */,
          data2.period,
          result?.data
        );
        setResultCache((prev) => {
          return {
            ...prev,
            [data2.period]: result?.data
          };
        });
        if (keyChanged && !isCFROptimizer) {
          runInBackground({
            ...payload,
            period: data2.period
          });
        }
      } catch (err) {
        if (isCFROptimizer && optimizerTwoStep && extraPayload?.optimizerRequestId) {
          await optimizerTwoStep?.(extraPayload?.optimizerRequestId, false);
        }
      }
    },
    [
      isCalculating,
      onReceiveCalculation,
      onSubmitEvent,
      resultCacheKey,
      runCalculation,
      runInBackground,
      isCFROptimizer,
      optimizerTwoStep,
      setOptimizerInput
    ]
  );
  const plans = useMemo(() => {
    if (!calculationResponse)
      return void 0;
    return calculationResponse.data?.plans ?? [];
  }, [calculationResponse]);
  const [messages, skippedVoyageMessages] = useMemo(() => {
    let logs = [];
    if (calculationError) {
      logs = calculationError?.body?.logs;
    } else if (calculationResponse) {
      logs = calculationResponse.data?.logs;
    } else {
      return [[], []];
    }
    const allLogs = logs ?? [];
    const matchingLogs = allLogs.filter(
      (log) => getLogLevelValue(log.level) <= getLogLevelValue("warn")
    );
    const skippedLogs = matchingLogs.filter(
      (log) => log.message?.startsWith("Voyage skipped")
    );
    const otherLogs = matchingLogs.filter(
      (log) => !log.message?.startsWith("Voyage skipped")
    );
    return [otherLogs, skippedLogs];
  }, [calculationResponse, calculationError]);
  const calculationId = useMemo(() => {
    if (!calculationResponse)
      return null;
    const theId = calculationResponse.data?.id ?? null;
    if (theId && addBreadcrumb) {
      addBreadcrumb({
        category: "calculation",
        message: "Calculation ID",
        level: "info",
        data: {
          id: theId
        }
      });
    }
    return theId;
  }, [calculationResponse, addBreadcrumb]);
  const periodFreightRates = useMemo(() => {
    if (!Object.keys(pendingResults).length) {
      return {};
    }
    return Object.fromEntries(
      Object.entries({
        ...resultsCache,
        ...Object.fromEntries(
          Object.entries(pendingResults).filter((item) => item[1] === true)
        )
      }).filter(
        (item) => item[1] !== void 0
      ).map(([key, value]) => {
        return [key, value.plans?.[0]?.price ?? pendingResults[key] === true];
      })
    );
  }, [resultsCache, pendingResults]);
  const calculationsToCopy = useMemo(() => {
    if (!Object.keys(pendingResults).length) {
      return [];
    }
    return Object.entries({
      ...resultsCache,
      ...Object.fromEntries(
        Object.entries(pendingResults).filter(([_, value]) => value === true)
      )
    }).filter(
      (item) => item[0] !== void 0 && item[1] !== true && item[1] !== false && item[1]?.id !== void 0
    ).map(([date, value]) => {
      return {
        calculationId: value.id,
        planId: value.plans?.[0]?.id,
        month: getCopyMonthLabel(date)
      };
    });
  }, [resultsCache, pendingResults]);
  const hasPendingCalculations = useMemo(() => {
    if (Object.keys(pendingResults).length === 0) {
      return false;
    }
    return Object.values(pendingResults).some((value) => value === true);
  }, [pendingResults]);
  return useMemo(
    () => ({
      onSubmit,
      isCalculating,
      periodFreightRates,
      calculationError,
      plans,
      calculationId,
      calculationsToCopy,
      hasPendingCalculations,
      messages,
      skippedVoyageMessages,
      optimizerInput
    }),
    [
      onSubmit,
      isCalculating,
      periodFreightRates,
      calculationError,
      plans,
      calculationId,
      calculationsToCopy,
      hasPendingCalculations,
      messages,
      skippedVoyageMessages,
      optimizerInput
    ]
  );
};
var Calculator = forwardRef(
  function Calculator2({
    isWidget,
    onReady,
    onSubmit: onSubmitEvent,
    onChange,
    onMultiModeChange,
    onError,
    addBreadcrumb,
    onReceiveCalculation,
    onCopyValuesConfirm,
    loadProgress
  }, ref) {
    const ctx = useContext(CalcContext);
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === "dark";
    if (!ctx) {
      throw new Error("CalcContext is not provided");
    }
    const { searchParams, apiRoutes, permissions } = ctx;
    const formRef = useRef();
    const dbVersion = searchParams.get("db_version") ?? DEFAULT_DB_VERSION;
    const showDBVersionDropdown = true;
    const canDebugCalculation = permissions.includes(
      Permission.DebugCalculation
    );
    const {
      terms,
      isApiLoaded,
      commodities,
      ports,
      versionsList,
      vesselMap,
      apiLoadingProgress,
      apiErrorMessage
    } = useCalculatorInputOptions(
      apiRoutes,
      dbVersion,
      showDBVersionDropdown,
      onError
    );
    let calculatorMode = searchParams.get("mode");
    if (ctx.isCFROptimizer) {
      calculatorMode = `${2 /* multi */}`;
    }
    const periods = useMemo(() => getMonthsArrayWithLabels(), []);
    useImperativeHandle(
      ref,
      () => ({
        getPeriods: () => periods,
        submit: () => {
          formRef.current?.submit();
        },
        getFormState: () => formRef.current?.getValues(),
        setFormState: (state) => {
          Object.keys(state).forEach((key) => {
            formRef.current?.setValue(
              key,
              state[key]
            );
          });
        },
        setFormFieldValue: (field, value) => {
          formRef.current?.setValue(field, value);
        },
        toggleAdvancedMode: () => {
          const curMode = formRef.current?.getValues("mode");
          switch (curMode) {
            case 0 /* simple */:
            case 2 /* multi */:
              formRef.current?.setValue("mode", 1 /* advanced */);
              break;
            case 1 /* advanced */:
              formRef.current?.setValue("mode", 0 /* simple */);
              break;
          }
        },
        setCalculatorMode: (mode) => {
          formRef.current?.setValue("mode", mode);
        },
        reset: () => {
          formRef.current?.reset();
        }
      }),
      [periods]
    );
    const {
      onSubmit,
      isCalculating,
      hasPendingCalculations,
      plans,
      messages,
      skippedVoyageMessages,
      calculationError,
      calculationId,
      periodFreightRates,
      calculationsToCopy,
      optimizerInput
    } = useCalculator(
      apiRoutes,
      onSubmitEvent,
      onError,
      addBreadcrumb,
      onReceiveCalculation,
      ctx.isCFROptimizer,
      ctx.onOptimizerTwoStep
    );
    const [outputPlans, setOutputPlans] = useState();
    const [notificationMessage, setNotificationMessage] = useState("");
    const onNotificationClose = useCallback(
      (_, reason) => {
        if (reason === "clickaway") {
          return;
        }
        setNotificationMessage("");
      },
      [setNotificationMessage]
    );
    const onCalculatorModeChange = useCallback(
      (mode) => {
        if (mode !== 1 /* advanced */) {
          return;
        }
        const curPeriod = formRef.current?.getValues("period");
        if (!curPeriod) {
          return;
        }
        if (!outputPlans) {
          return;
        }
        let message;
        let foundRate = outputPlans.find((rate) => {
          return rate.isWithinTolerance;
        });
        if (!foundRate) {
          foundRate = outputPlans[0];
          message = "No rates found within tolerance. Using cheapest rate to auto-fill inputs.";
        }
        if (!foundRate) {
          message = "No rates found for this period.";
        }
        if (foundRate) {
          const curData = formRef.current?.getValues();
          if (curData) {
            const loadPort = curData?.load_port;
            const dischargePort = curData?.disch_port;
            const valuesForFields = [
              curData?.cargo,
              curData?.load_cadence,
              curData?.load_terms,
              curData?.disch_cadence,
              curData?.disch_terms
            ];
            const updateValues = {};
            updateValues.cargo = `${Math.floor(foundRate.debugData.cargoIntake)}`;
            const loadPortInfo = foundRate.debugData.portInfos?.find?.(
              (port) => port.UNLOCODE === loadPort && port.operations[0].operation === OperationType.L
            );
            if (loadPortInfo) {
              updateValues.load_cadence = `${loadPortInfo.operations[0].cadence}`;
              updateValues.load_terms = loadPortInfo.operations[0].terms;
            }
            const dischargePortInfo = foundRate.debugData.portInfos?.find?.(
              (port) => port.UNLOCODE === dischargePort && port.operations[0].operation === OperationType.D
            );
            if (dischargePortInfo) {
              updateValues.disch_cadence = `${dischargePortInfo.operations[0].cadence}`;
              updateValues.disch_terms = dischargePortInfo.operations[0].terms;
            }
            const needsConfirm = valuesForFields.some((value) => !!value);
            onCopyValuesConfirm?.(curData, updateValues, needsConfirm);
            if (needsConfirm) {
              const confirmed = window.confirm(
                "This will overwrite any existing values in the form. Are you sure you want to continue?"
              );
              onCopyValuesConfirm?.(
                curData,
                updateValues,
                needsConfirm,
                confirmed
              );
              if (!confirmed) {
                return;
              }
            }
            for (const key in updateValues) {
              formRef.current?.setValue(
                key,
                updateValues[key]
              );
            }
          }
          if (message) {
            setNotificationMessage(message);
          }
        }
      },
      [outputPlans, onCopyValuesConfirm]
    );
    if (!isApiLoaded) {
      return /* @__PURE__ */ jsx(
        LinearProgressWithLabel_default,
        {
          value: apiLoadingProgress,
          onCompleted: () => {
            onReady?.();
          }
        }
      );
    }
    if (apiErrorMessage) {
      return /* @__PURE__ */ jsxs(Alert, { severity: "error", children: [
        /* @__PURE__ */ jsx(AlertTitle, { children: "Error" }),
        apiErrorMessage
      ] });
    }
    const skippedItems = skippedVoyageMessages.length ? skippedVoyageMessages.map((message, idx) => /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          p: 1,
          mb: 1,
          background: isDarkMode ? dark6 : void 0
        },
        children: /* @__PURE__ */ jsx("span", { style: { whiteSpace: "pre" }, children: message.message })
      },
      idx
    )) : null;
    const skippedMessagesElement = plans?.length === 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx("br", {}),
      skippedItems
    ] }) : skippedItems?.length && /* @__PURE__ */ jsxs(Alert, { severity: "warning", children: [
      /* @__PURE__ */ jsx(AlertTitle, { children: "Warning" }),
      skippedItems
    ] });
    const messagesElement = ctx.showInfoBox && messages.length ? /* @__PURE__ */ jsxs(Alert, { severity: "info", children: [
      /* @__PURE__ */ jsx(AlertTitle, { children: "Information (discarded plans):" }),
      messages.map((message, idx) => /* @__PURE__ */ jsx(
        Box,
        {
          sx: {
            p: 1,
            mb: 1,
            background: isDarkMode ? dark6 : void 0
          },
          children: /* @__PURE__ */ jsx("span", { style: { whiteSpace: "pre" }, children: message.message })
        },
        idx
      ))
    ] }) : null;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        CalcControls_default,
        {
          periods,
          terms,
          commodities,
          ports,
          onChange,
          onMultiModeChange,
          onSubmit,
          showDBVersionDropdown,
          canDebugCalculation,
          dbVersion: dbVersion || void 0,
          periodRates: periodFreightRates,
          versionsList: versionsList ?? [],
          formRef,
          isWidget: isWidget ?? false,
          isCalculating,
          hasPendingCalculations,
          calculationsToCopy,
          onCalculatorModeChange
        }
      ),
      /* @__PURE__ */ jsx(
        Snackbar,
        {
          open: notificationMessage !== "",
          autoHideDuration: 1e4,
          anchorOrigin: { vertical: "top", horizontal: "center" },
          onClose: onNotificationClose,
          message: notificationMessage,
          sx: {
            ".MuiSnackbarContent-root": {
              background: isDarkMode ? darkGrey : void 0
            }
          }
        },
        "notification"
      ),
      (() => {
        if (isCalculating) {
          if (loadProgress) {
            return /* @__PURE__ */ jsx(LinearProgressWithLabel_default, { value: loadProgress });
          } else {
            return /* @__PURE__ */ jsx(IndeterminateProgress_default, {});
          }
        } else if (calculationError) {
          if (calculationError?.statusCode === 409) {
            let severity = "info";
            let title = "Info";
            switch (calculationError?.body?.level ?? "info") {
              default:
              case "info":
                severity = "info";
                title = "Info";
                break;
              case "warning":
                severity = "warning";
                title = "Warning";
                break;
            }
            return /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsxs(Alert, { severity, children: [
                /* @__PURE__ */ jsx(AlertTitle, { children: title }),
                calculationError?.message ?? calculationError,
                skippedMessagesElement
              ] }),
              messagesElement
            ] });
          }
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsxs(Alert, { severity: "error", children: [
              /* @__PURE__ */ jsx(AlertTitle, { children: "Error" }),
              calculationError?.message ?? calculationError,
              skippedMessagesElement
            ] }),
            messagesElement
          ] });
        } else if (!plans) {
          return /* @__PURE__ */ jsx(Fragment, {});
        } else if (optimizerInput) {
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsxs(Alert, { severity: "info", children: [
              /* @__PURE__ */ jsx(AlertTitle, { children: "Info" }),
              "Optimizer input generated"
            ] }),
            /* @__PURE__ */ jsx(
              Box,
              {
                sx: {
                  backgroundColor: isDarkMode ? "rgba(0, 0, 0, 0.95)" : "rgba(255, 255, 255, 0.95)",
                  height: "400px",
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                  overflowY: "auto",
                  mt: -2
                },
                children: /* @__PURE__ */ jsx("pre", { children: JSON.stringify(optimizerInput, null, 2) })
              }
            )
          ] });
        } else if (plans.length === 0) {
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsxs(Alert, { severity: "warning", children: [
              /* @__PURE__ */ jsx(AlertTitle, { children: "Warning" }),
              "No plans could be made by the engine for this voyage",
              skippedMessagesElement
            ] }),
            messagesElement
          ] });
        } else {
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              CalcTableOutput_default,
              {
                isAdvancedView: calculatorMode === `${1 /* advanced */}`,
                data: plans,
                calculationId: calculationId ?? "",
                vesselMap,
                apiRoutes,
                canDebugCalculation,
                setOutputPlans,
                renderMapButton: ctx.renderMapButton,
                databaseVersion: dbVersion,
                isCFROptimizer: !!ctx.isCFROptimizer
              }
            ),
            skippedMessagesElement,
            messagesElement
          ] });
        }
      })()
    ] });
  }
);
var CalculatorWithTheme = forwardRef(function CalculatorWithTheme2({
  isWidget,
  onReady,
  onSubmit: onSubmitEvent,
  onChange,
  onError,
  addBreadcrumb,
  onReceiveCalculation,
  onCopyValuesConfirm,
  theme,
  loadProgress
}, ref) {
  if (!theme) {
    return /* @__PURE__ */ jsx(
      Calculator,
      {
        isWidget,
        onReady,
        onSubmit: onSubmitEvent,
        onChange,
        onError,
        addBreadcrumb,
        onReceiveCalculation,
        onCopyValuesConfirm,
        loadProgress,
        ref
      }
    );
  }
  return /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsx(
    Calculator,
    {
      isWidget,
      onReady,
      onSubmit: onSubmitEvent,
      onChange,
      onError,
      addBreadcrumb,
      onReceiveCalculation,
      onCopyValuesConfirm,
      loadProgress,
      ref
    }
  ) });
});
var Calculator_default = CalculatorWithTheme;

// ../calculator-ui/src/calculation-history-hooks.ts
var useCalculationDetails = (id, calculationDetailsUrl) => {
  return useAdminAPI(`${calculationDetailsUrl}?id=${id}`);
};
var useCalculationMapData = (id, planId, calculationMapDataUrl) => {
  return useAdminAPI(
    `${calculationMapDataUrl}?id=${id}&planId=${planId}`
  );
};
var useBatchCalculationDetails = (id, apiUrl) => {
  return useAdminAPI(`${apiUrl}?id=${id}`);
};
var useBatchCalculationFilterOptions = (id, apiUrl) => {
  return useAdminAPI(
    apiUrl === null ? apiUrl : `${apiUrl}?id=${id}`
  );
};
var useBatchCalculationGraphData = (id, apiUrl, grouping = "all", routePointFilter = null) => {
  const params = new URLSearchParams();
  params.append("id", id);
  params.append("grouping", grouping);
  if (routePointFilter) {
    routePointFilter.forEach(
      (routePoint) => params.append("routePoints", routePoint)
    );
  }
  return useAdminAPI(`${apiUrl}?${params.toString()}`);
};
var useBatchCalculationResultPlans = (id, date, apiUrl, grouping = "all") => {
  return useAdminAPI(
    `${apiUrl}?id=${id}&date=${date}&grouping=${grouping}`
  );
};

// src/api/lib/routes/generic.ts
var generic_exports = {};
__export(generic_exports, {
  GET: () => GET11,
  POST: () => POST5,
  dynamic: () => dynamic
});

// src/api/lib/routes/terms-api.ts
var terms_api_exports = {};
__export(terms_api_exports, {
  GET: () => GET
});

// src/api/lib/api-types.ts
var ResponseError2 = class _ResponseError extends Error {
  response;
  constructor(message, response) {
    super(message);
    Object.setPrototypeOf(this, _ResponseError.prototype);
    this.response = response;
  }
};

// src/api/lib/api.ts
var getAdminApiUrl = (path) => {
  return `${process.env.WEB_BACKEND_ADMIN_API_URL?.replace(/\$/, "")}${path.startsWith("/") ? "" : "/"}${path}`;
};
var mutateRequest = null;
var setWidgetRequestMiddleware = async (mutate) => {
  mutateRequest = mutate;
};
async function fetchFromBackendApi(request, path, options = {
  format: "json"
}, init = {}) {
  const theUrl = getAdminApiUrl(path);
  const format4 = options.format || "json";
  let next = void 0;
  if (options.revalidate) {
    next = {
      revalidate: options.revalidate
    };
  }
  const requestInit = {
    ...init,
    headers: {
      ...init.headers
    },
    next
  };
  const response = await fetch(
    theUrl,
    await mutateRequest?.(request, requestInit) ?? requestInit
  );
  if (!response.ok) {
    const errorMessage = await response.clone().json();
    throw new ResponseError2(
      `Error fetching from API: ${response.status} ${response.statusText} ${errorMessage.message || ""}`,
      response
    );
  }
  if (format4 === "json") {
    return await response.json();
  }
  if (format4 === "text") {
    return await response.text();
  }
  if (format4 === "blob") {
    return await response.blob();
  }
  return response;
}

// src/api/lib/routes/terms-api.ts
async function GET(request) {
  const terms = await fetchFromBackendApi(request, "/terms", {
    revalidate: 2 * 60
  });
  return NextResponse.json(terms);
}

// src/api/lib/routes/commodities-api.ts
var commodities_api_exports = {};
__export(commodities_api_exports, {
  GET: () => GET2,
  POST: () => POST
});
async function GET2(request) {
  const { query } = __require("url").parse(request.url, true);
  const versionId = query.versionId === "null" ? "" : `?versionId=${query.versionId}`;
  const commodities = await fetchFromBackendApi(
    request,
    `/commodities${versionId}`,
    {
      revalidate: 2 * 60
    }
  );
  return NextResponse.json(commodities);
}
async function POST(request) {
  const data2 = await request.json();
  try {
    const response = await fetchFromBackendApi(
      request,
      "/commodities",
      {
        revalidate: 0
      },
      {
        method: "POST",
        body: JSON.stringify(data2),
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    return NextResponse.json(response);
  } catch (error) {
    if (error instanceof ResponseError2) {
      return NextResponse.json(await error.response.json(), {
        status: error.response.status
      });
    }
    throw error;
  }
}

// src/api/lib/routes/ports-api.ts
var ports_api_exports = {};
__export(ports_api_exports, {
  GET: () => GET3
});
async function GET3(request) {
  const ports = await fetchFromBackendApi(request, "/ports", {
    revalidate: 2 * 60
  });
  return NextResponse.json(ports);
}

// src/api/lib/routes/vessels-api.ts
var vessels_api_exports = {};
__export(vessels_api_exports, {
  GET: () => GET4
});
async function GET4(request) {
  const { query } = __require("url").parse(request.url, true);
  const versionId = query.versionId === "null" ? "" : `?versionId=${query.versionId}`;
  const vessels = await fetchFromBackendApi(request, `/vessels${versionId}`, {
    revalidate: 2 * 60
  });
  return NextResponse.json(vessels);
}

// src/api/lib/routes/calculate-api.ts
var calculate_api_exports = {};
__export(calculate_api_exports, {
  POST: () => POST2
});
var getPayload = (data2) => {
  const { db_version, period, ...rest } = data2;
  return {
    ...rest,
    baseDate: data2.period,
    version: data2.db_version || "latest-version",
    engineVersion: "latest-version",
    overrides: data2.overrides || {}
  };
};
async function POST2(request, apiPath = "/calculator") {
  const data2 = await request.json();
  const payload = getPayload(data2);
  try {
    const response = await fetchFromBackendApi(
      request,
      apiPath,
      {
        revalidate: 0
      },
      {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    return NextResponse.json(response);
  } catch (error) {
    if (error instanceof ResponseError2) {
      return NextResponse.json(await error.response.json(), {
        status: error.response.status
      });
    }
    throw error;
  }
}

// src/api/lib/routes/db-versions-api.ts
var db_versions_api_exports = {};
__export(db_versions_api_exports, {
  GET: () => GET5
});
async function GET5(request) {
  const { query } = __require("url").parse(request.url, true);
  const params = new URLSearchParams();
  const { page, take, onlyWithPremiums } = query;
  if (page) {
    params.set("page", page);
  }
  if (take) {
    params.set("take", take);
  }
  if (onlyWithPremiums) {
    params.set("onlyWithPremiums", onlyWithPremiums);
  }
  const versions = await fetchFromBackendApi(
    request,
    `/versions?${params.toString()}`,
    {
      revalidate: 0
    }
  );
  return NextResponse.json(versions);
}
async function GET6(request) {
  try {
    const { query } = __require("url").parse(request.url, true);
    const { calculationId, planId } = query;
    const plan = await fetchFromBackendApi(
      request,
      `/calculations/${calculationId}/debug-plan/${planId}`,
      {
        revalidate: 0
      }
    );
    return NextResponse.json(plan);
  } catch (error) {
    if (error instanceof ResponseError2) {
      return NextResponse.json(await error.response.json(), {
        status: error.response.status
      });
    }
    throw error;
  }
}

// src/api/lib/routes/copying-output-api.ts
var copying_output_api_exports = {};
__export(copying_output_api_exports, {
  POST: () => POST3
});
async function POST3(request) {
  const data2 = await request.json();
  try {
    const response = await fetchFromBackendApi(
      request,
      `/calculations/copying-output`,
      {
        revalidate: 0
      },
      {
        method: "POST",
        body: JSON.stringify(data2),
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    return NextResponse.json(response);
  } catch (error) {
    if (error instanceof ResponseError2) {
      return NextResponse.json(await error.response.json(), {
        status: error.response.status
      });
    }
    throw error;
  }
}
async function GET7(request, basePath = "/calculations/history") {
  const params = new URL(request.url).searchParams;
  const groupingParam = params.get("grouping") ?? "";
  const finalParams = new URLSearchParams();
  if (groupingParam) {
    finalParams.append("grouping", groupingParam);
  }
  const routePointFilter = params.getAll("routePoints");
  if (routePointFilter.length) {
    routePointFilter.forEach((routePoint) => {
      finalParams.append("routePoints", routePoint);
    });
  }
  try {
    const data2 = await fetchFromBackendApi(
      request,
      `${basePath}/${params.get("id")}?${finalParams.toString()}`,
      {
        revalidate: 0
      }
    );
    return NextResponse.json(data2);
  } catch (error) {
    if (error instanceof ResponseError2) {
      return NextResponse.json(await error.response.json(), {
        status: error.response.status
      });
    }
    throw error;
  }
}
async function GET8(request) {
  const params = new URL(request.url).searchParams;
  console.log(
    "params",
    `/calculations/history/${params.get("id")}/map-data/${params.get("planId")}`
  );
  try {
    const data2 = await fetchFromBackendApi(
      request,
      `/calculations/history/${params.get("id")}/map-data/${params.get("planId")}`,
      {
        revalidate: 0
      }
    );
    return NextResponse.json(data2);
  } catch (error) {
    if (error instanceof ResponseError2) {
      return NextResponse.json(await error.response.json(), {
        status: error.response.status
      });
    }
    throw error;
  }
}
async function GET9(request) {
  const params = new URL(request.url).searchParams;
  try {
    const data2 = await fetchFromBackendApi(
      request,
      `/calculations/batch/details/${params.get("id")}/${params.get("date")}?grouping=${params.get("grouping")}`,
      {
        revalidate: 0
      }
    );
    return NextResponse.json(data2);
  } catch (error) {
    if (error instanceof ResponseError2) {
      return NextResponse.json(await error.response.json(), {
        status: error.response.status
      });
    }
    throw error;
  }
}
async function GET10(request) {
  const params = new URL(request.url).searchParams;
  try {
    const data2 = await fetchFromBackendApi(
      request,
      `/precalculate-jobs/batch/${params.get("id")}/results/file`,
      {
        revalidate: 0,
        format: "raw"
      }
    );
    return data2;
  } catch (error) {
    if (error instanceof ResponseError2) {
      return NextResponse.json(await error.response.json(), {
        status: error.response.status
      });
    }
    throw error;
  }
}
async function POST4(request) {
  const data2 = await request.json();
  const requestId = data2.requestId;
  if (!requestId) {
    return NextResponse.json([], { status: 404 });
  }
  const ports = await fetchFromBackendApi(
    request,
    `/calculator/optimize/logs/${requestId}`,
    {
      revalidate: 0
    }
  );
  return NextResponse.json(ports);
}

// src/api/lib/routes/generic.ts
var getApiType = (request) => {
  const path = new URL(request.url).pathname;
  const pathComponent = path.substring(path.lastIndexOf("/"));
  return pathComponent;
};
async function GET11(request) {
  switch (getApiType(request)) {
    case "/terms":
      return GET(request);
    case "/commodities":
      return GET2(request);
    case "/ports":
      return GET3(request);
    case "/vessels":
      return GET4(request);
    case "/db-versions":
      return GET5(request);
    case "/calculations":
      return GET6(request);
    case "/calculation-details":
      return GET7(request);
    case "/batch-calculation-details":
      return GET7(request, "/calculations/batch");
    case "/batch-calculation-filter-options":
      return GET7(
        request,
        "/calculations/batch/filter-options"
      );
    case "/batch-calculation-graph-data":
      return GET7(request, "/calculations/batch/graph");
    case "/batch-calculation-result-plans":
      return GET9(request);
    case "/batch-calculation-csv-data":
      return GET10(request);
    case "/map-data":
      return GET8(request);
    default:
      return notFound();
  }
}
async function POST5(request) {
  switch (getApiType(request)) {
    case "/terms":
    case "/ports":
    case "/vessels":
    case "/db-versions":
    case "/commodities":
      return POST(request);
    case "/calculate":
      return POST2(request);
    case "/optimize":
      return POST2(request, "/calculator/optimize");
    case "/calc-historical":
      return POST2(request, "/calculator/historical");
    case "/copying-output":
      return POST3(request);
    case "/optimizer-logs":
      return POST4(request);
    default:
      return notFound();
  }
}
var dynamic = "force-dynamic";
/*! Bundled license information:

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

@mui/utils/index.js:
  (**
   * @mui/utils v5.15.20
   *
   * @license MIT
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

autonumeric/src/AutoNumeric.js:
  (**
   *               AutoNumeric.js
   *
   * @version      4.10.5
   * @date         2024-02-06 UTC 20:14
   *
   * @authors      2016-2024 Alexandre Bonneau <alexandre.bonneau@linuxfr.eu>
   *               2009-2016 Bob Knothe <bob.knothe@gmail.com>
   * @contributors Sokolov Yura and others, cf. AUTHORS
   * @copyright    Alexandre Bonneau & Robert J. Knothe
   * @since        2009-08-09
   *
   * @summary      AutoNumeric is a standalone Javascript library
   *               that provides live *as-you-type* formatting for
   *               international numbers and currencies.
   *
   * @link         http://autonumeric.org
   * @docs         https://docs.autonumeric.org
   *
   *               Note : Some functions are borrowed from big.js
   * @see          https://github.com/MikeMcl/big.js/
   *
   * Please report any bugs to https://github.com/autoNumeric/autoNumeric
   *
   * @license      Released under the MIT License
   * @link         http://www.opensource.org/licenses/mit-license.php
   *
   * Permission is hereby granted, free of charge, to any person
   * obtaining a copy of this software and associated documentation
   * files (the "Software"), to deal in the Software without
   * restriction, including without limitation the rights to use,
   * copy, modify, merge, publish, distribute, sub license, and/or sell
   * copies of the Software, and to permit persons to whom the
   * Software is furnished to do so, subject to the following
   * conditions:
   *
   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
   * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
   * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
   * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
   * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
   * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
   * OTHER DEALINGS IN THE SOFTWARE.
   *)
*/

export { AreaUsage, BatchJobType, CalcContext, CalcControls_default as CalcControls, CalcTableOutput_default as CalcTableOutput, calculate_api_exports as CalculateApi, CalculationContext, CalculationSchedulingType, Calculator_default as Calculator, CalculatorMode, CanalDirection, CanalFuelType, CanalLadenBallast, commodities_api_exports as CommoditiesApi, copying_output_api_exports as CopyingOutputApi, CronStatus, CurrencyOption, db_versions_api_exports as DBVersionsApi, DEFAULT_DB_VERSION, DRAWER_WIDTH, DebugPanel_default as DebugPanel, DebugTable_default as DebugTable, DepthUnit, DistancePassingDirection, EDITOR_DISABLED_TABLES, ExchangeEmission, ExternalAPIOperationType, FFAContractDirection, FFAProductCode, FalseValues, FuelGrade, FunctionLinkKey, generic_exports as GenericWebApi, HistoryTableHeaderCell_default as HistoryTableHeaderCell, IndeterminateProgress_default as IndeterminateProgress, JobType, LinearProgressWithLabel_default as LinearProgressWithLabel, LogLevelValuesEnum, MatrixPortCostFallbackFilter, MultiModeHooks, OperationType, Permission, PortOperationEnum, PortSizeRestrictionOperationType, PortSource, ports_api_exports as PortsApi, QueueType, REVERSE_VERSION_TABLE, RegionContext, ResponseError, ResultStructureVersionIdEnum, SeaMatrixSetting, SectionPassageType, SizeRestrictionResultStatus, StageType, SubActivityType, TOLERANCE_DEFAULT_VALUE, TableHeadCellInputType, TableHeaderCell_default as TableHeaderCell, terms_api_exports as TermsApi, TrueValues, VALID_TO_DEFAULT_VALUE, VERSION_COLUMNS, VersionedTable, VesselSizeInfo_default as VesselSizeInfo, VesselSpeedType, vessels_api_exports as VesselsApi, VoyageNoPlansReason, WaterTypeT, additionalRed, black, black1, black2, convertCbftToHectoliter, dark1, dark2, dark3, dark35, dark37, dark4, dark5, dark6, dark7, darkBorder, darkGrey, dragHandleLightTheme, errorRed, fetcher, formatMaturity, formatNumberWithCommas, formatNumbersWithCommas, generateDropdownOptions, getAPIRoutes, getApiPayload, getCalculatorMode, getLogLevelValue, getMonthsArray, getMonthsArrayWithLabels, getReverseVersionTable, getVersionColumn, getVersionTable, grey, isBallastStage, isPortStage, isSailingStage, isSubActivityDataType, isTableVersioned, lazyFetcher, light, lightBlue, lightBorder, lightGreen, numericFields, parseBool, parseErrorBody, secondaryBlue, secondaryBrightGreen, secondaryDarkBlue, secondaryDarkGreen, secondaryDarkPink, secondaryDarkPurple, secondaryLavender, secondaryLightGreen, secondaryOrange, secondaryPeachOrange, secondaryPink, secondaryPurple, secondarySand, secondaryWarmSand, secondaryYellow, setWidgetRequestMiddleware, text60, text87, useAPI, useAdminAPI, useAdminApiMutation, useApiMutation, useBatchCalculationDetails, useBatchCalculationFilterOptions, useBatchCalculationGraphData, useBatchCalculationResultPlans, useCalculationDetails, useCalculationMapData, useCalculator, useCalculatorInputOptions, useDebouncedValidation, useMultiModeSuggestions, white };
